/*! drapcode-builder - 0.1.18 */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports["drapcode-builder"] = e() : t["drapcode-builder"] = e();
}(window, function () {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) n.d(r, i, function (e) {
        return t[e];
      }.bind(null, i));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 102);
  }([function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return On;
    }), n.d(e, "VERSION", function () {
      return i.e;
    }), n.d(e, "restArguments", function () {
      return o;
    }), n.d(e, "isObject", function () {
      return a;
    }), n.d(e, "isNull", function () {
      return s;
    }), n.d(e, "isUndefined", function () {
      return l;
    }), n.d(e, "isBoolean", function () {
      return c;
    }), n.d(e, "isElement", function () {
      return u;
    }), n.d(e, "isString", function () {
      return h;
    }), n.d(e, "isNumber", function () {
      return f;
    }), n.d(e, "isDate", function () {
      return p;
    }), n.d(e, "isRegExp", function () {
      return g;
    }), n.d(e, "isError", function () {
      return v;
    }), n.d(e, "isSymbol", function () {
      return m;
    }), n.d(e, "isArrayBuffer", function () {
      return b;
    }), n.d(e, "isDataView", function () {
      return j;
    }), n.d(e, "isArray", function () {
      return T;
    }), n.d(e, "isFunction", function () {
      return x;
    }), n.d(e, "isArguments", function () {
      return D;
    }), n.d(e, "isFinite", function () {
      return M;
    }), n.d(e, "isNaN", function () {
      return A;
    }), n.d(e, "isTypedArray", function () {
      return R;
    }), n.d(e, "isEmpty", function () {
      return B;
    }), n.d(e, "isMatch", function () {
      return W;
    }), n.d(e, "isEqual", function () {
      return K;
    }), n.d(e, "isMap", function () {
      return rt;
    }), n.d(e, "isWeakMap", function () {
      return it;
    }), n.d(e, "isSet", function () {
      return ot;
    }), n.d(e, "isWeakSet", function () {
      return at;
    }), n.d(e, "keys", function () {
      return $;
    }), n.d(e, "allKeys", function () {
      return Y;
    }), n.d(e, "values", function () {
      return st;
    }), n.d(e, "pairs", function () {
      return lt;
    }), n.d(e, "invert", function () {
      return ct;
    }), n.d(e, "functions", function () {
      return ut;
    }), n.d(e, "methods", function () {
      return ut;
    }), n.d(e, "extend", function () {
      return ht;
    }), n.d(e, "extendOwn", function () {
      return ft;
    }), n.d(e, "assign", function () {
      return ft;
    }), n.d(e, "defaults", function () {
      return pt;
    }), n.d(e, "create", function () {
      return vt;
    }), n.d(e, "clone", function () {
      return mt;
    }), n.d(e, "tap", function () {
      return bt;
    }), n.d(e, "get", function () {
      return Ot;
    }), n.d(e, "has", function () {
      return Ct;
    }), n.d(e, "mapObject", function () {
      return Mt;
    }), n.d(e, "identity", function () {
      return St;
    }), n.d(e, "constant", function () {
      return L;
    }), n.d(e, "noop", function () {
      return At;
    }), n.d(e, "toPath", function () {
      return yt;
    }), n.d(e, "property", function () {
      return jt;
    }), n.d(e, "propertyOf", function () {
      return Lt;
    }), n.d(e, "matcher", function () {
      return kt;
    }), n.d(e, "matches", function () {
      return kt;
    }), n.d(e, "times", function () {
      return Nt;
    }), n.d(e, "random", function () {
      return _t;
    }), n.d(e, "now", function () {
      return It;
    }), n.d(e, "escape", function () {
      return Rt;
    }), n.d(e, "unescape", function () {
      return zt;
    }), n.d(e, "templateSettings", function () {
      return Ht;
    }), n.d(e, "template", function () {
      return Gt;
    }), n.d(e, "result", function () {
      return Kt;
    }), n.d(e, "uniqueId", function () {
      return Xt;
    }), n.d(e, "chain", function () {
      return Jt;
    }), n.d(e, "iteratee", function () {
      return Et;
    }), n.d(e, "partial", function () {
      return te;
    }), n.d(e, "bind", function () {
      return ee;
    }), n.d(e, "bindAll", function () {
      return ie;
    }), n.d(e, "memoize", function () {
      return oe;
    }), n.d(e, "delay", function () {
      return ae;
    }), n.d(e, "defer", function () {
      return se;
    }), n.d(e, "throttle", function () {
      return le;
    }), n.d(e, "debounce", function () {
      return ce;
    }), n.d(e, "wrap", function () {
      return ue;
    }), n.d(e, "negate", function () {
      return de;
    }), n.d(e, "compose", function () {
      return he;
    }), n.d(e, "after", function () {
      return fe;
    }), n.d(e, "before", function () {
      return pe;
    }), n.d(e, "once", function () {
      return ge;
    }), n.d(e, "findKey", function () {
      return ve;
    }), n.d(e, "findIndex", function () {
      return be;
    }), n.d(e, "findLastIndex", function () {
      return ye;
    }), n.d(e, "sortedIndex", function () {
      return we;
    }), n.d(e, "indexOf", function () {
      return Oe;
    }), n.d(e, "lastIndexOf", function () {
      return Ce;
    }), n.d(e, "find", function () {
      return Se;
    }), n.d(e, "detect", function () {
      return Se;
    }), n.d(e, "findWhere", function () {
      return ke;
    }), n.d(e, "each", function () {
      return je;
    }), n.d(e, "forEach", function () {
      return je;
    }), n.d(e, "map", function () {
      return Te;
    }), n.d(e, "collect", function () {
      return Te;
    }), n.d(e, "reduce", function () {
      return Ee;
    }), n.d(e, "foldl", function () {
      return Ee;
    }), n.d(e, "inject", function () {
      return Ee;
    }), n.d(e, "reduceRight", function () {
      return De;
    }), n.d(e, "foldr", function () {
      return De;
    }), n.d(e, "filter", function () {
      return Me;
    }), n.d(e, "select", function () {
      return Me;
    }), n.d(e, "reject", function () {
      return Ae;
    }), n.d(e, "every", function () {
      return Le;
    }), n.d(e, "all", function () {
      return Le;
    }), n.d(e, "some", function () {
      return Ne;
    }), n.d(e, "any", function () {
      return Ne;
    }), n.d(e, "contains", function () {
      return _e;
    }), n.d(e, "includes", function () {
      return _e;
    }), n.d(e, "include", function () {
      return _e;
    }), n.d(e, "invoke", function () {
      return Ie;
    }), n.d(e, "pluck", function () {
      return Fe;
    }), n.d(e, "where", function () {
      return Ve;
    }), n.d(e, "max", function () {
      return Re;
    }), n.d(e, "min", function () {
      return ze;
    }), n.d(e, "shuffle", function () {
      return We;
    }), n.d(e, "sample", function () {
      return Be;
    }), n.d(e, "sortBy", function () {
      return Ue;
    }), n.d(e, "groupBy", function () {
      return Ge;
    }), n.d(e, "indexBy", function () {
      return Ke;
    }), n.d(e, "countBy", function () {
      return Ye;
    }), n.d(e, "partition", function () {
      return Xe;
    }), n.d(e, "toArray", function () {
      return $e;
    }), n.d(e, "size", function () {
      return Je;
    }), n.d(e, "pick", function () {
      return Qe;
    }), n.d(e, "omit", function () {
      return tn;
    }), n.d(e, "first", function () {
      return nn;
    }), n.d(e, "head", function () {
      return nn;
    }), n.d(e, "take", function () {
      return nn;
    }), n.d(e, "initial", function () {
      return en;
    }), n.d(e, "last", function () {
      return on;
    }), n.d(e, "rest", function () {
      return rn;
    }), n.d(e, "tail", function () {
      return rn;
    }), n.d(e, "drop", function () {
      return rn;
    }), n.d(e, "compact", function () {
      return an;
    }), n.d(e, "flatten", function () {
      return sn;
    }), n.d(e, "without", function () {
      return cn;
    }), n.d(e, "uniq", function () {
      return un;
    }), n.d(e, "unique", function () {
      return un;
    }), n.d(e, "union", function () {
      return dn;
    }), n.d(e, "intersection", function () {
      return hn;
    }), n.d(e, "difference", function () {
      return ln;
    }), n.d(e, "unzip", function () {
      return fn;
    }), n.d(e, "transpose", function () {
      return fn;
    }), n.d(e, "zip", function () {
      return pn;
    }), n.d(e, "object", function () {
      return gn;
    }), n.d(e, "range", function () {
      return vn;
    }), n.d(e, "chunk", function () {
      return mn;
    }), n.d(e, "mixin", function () {
      return yn;
    });
    var r = {};
    n.r(r), n.d(r, "VERSION", function () {
      return i.e;
    }), n.d(r, "restArguments", function () {
      return o;
    }), n.d(r, "isObject", function () {
      return a;
    }), n.d(r, "isNull", function () {
      return s;
    }), n.d(r, "isUndefined", function () {
      return l;
    }), n.d(r, "isBoolean", function () {
      return c;
    }), n.d(r, "isElement", function () {
      return u;
    }), n.d(r, "isString", function () {
      return h;
    }), n.d(r, "isNumber", function () {
      return f;
    }), n.d(r, "isDate", function () {
      return p;
    }), n.d(r, "isRegExp", function () {
      return g;
    }), n.d(r, "isError", function () {
      return v;
    }), n.d(r, "isSymbol", function () {
      return m;
    }), n.d(r, "isArrayBuffer", function () {
      return b;
    }), n.d(r, "isDataView", function () {
      return j;
    }), n.d(r, "isArray", function () {
      return T;
    }), n.d(r, "isFunction", function () {
      return x;
    }), n.d(r, "isArguments", function () {
      return D;
    }), n.d(r, "isFinite", function () {
      return M;
    }), n.d(r, "isNaN", function () {
      return A;
    }), n.d(r, "isTypedArray", function () {
      return R;
    }), n.d(r, "isEmpty", function () {
      return B;
    }), n.d(r, "isMatch", function () {
      return W;
    }), n.d(r, "isEqual", function () {
      return K;
    }), n.d(r, "isMap", function () {
      return rt;
    }), n.d(r, "isWeakMap", function () {
      return it;
    }), n.d(r, "isSet", function () {
      return ot;
    }), n.d(r, "isWeakSet", function () {
      return at;
    }), n.d(r, "keys", function () {
      return $;
    }), n.d(r, "allKeys", function () {
      return Y;
    }), n.d(r, "values", function () {
      return st;
    }), n.d(r, "pairs", function () {
      return lt;
    }), n.d(r, "invert", function () {
      return ct;
    }), n.d(r, "functions", function () {
      return ut;
    }), n.d(r, "methods", function () {
      return ut;
    }), n.d(r, "extend", function () {
      return ht;
    }), n.d(r, "extendOwn", function () {
      return ft;
    }), n.d(r, "assign", function () {
      return ft;
    }), n.d(r, "defaults", function () {
      return pt;
    }), n.d(r, "create", function () {
      return vt;
    }), n.d(r, "clone", function () {
      return mt;
    }), n.d(r, "tap", function () {
      return bt;
    }), n.d(r, "get", function () {
      return Ot;
    }), n.d(r, "has", function () {
      return Ct;
    }), n.d(r, "mapObject", function () {
      return Mt;
    }), n.d(r, "identity", function () {
      return St;
    }), n.d(r, "constant", function () {
      return L;
    }), n.d(r, "noop", function () {
      return At;
    }), n.d(r, "toPath", function () {
      return yt;
    }), n.d(r, "property", function () {
      return jt;
    }), n.d(r, "propertyOf", function () {
      return Lt;
    }), n.d(r, "matcher", function () {
      return kt;
    }), n.d(r, "matches", function () {
      return kt;
    }), n.d(r, "times", function () {
      return Nt;
    }), n.d(r, "random", function () {
      return _t;
    }), n.d(r, "now", function () {
      return It;
    }), n.d(r, "escape", function () {
      return Rt;
    }), n.d(r, "unescape", function () {
      return zt;
    }), n.d(r, "templateSettings", function () {
      return Ht;
    }), n.d(r, "template", function () {
      return Gt;
    }), n.d(r, "result", function () {
      return Kt;
    }), n.d(r, "uniqueId", function () {
      return Xt;
    }), n.d(r, "chain", function () {
      return Jt;
    }), n.d(r, "iteratee", function () {
      return Et;
    }), n.d(r, "partial", function () {
      return te;
    }), n.d(r, "bind", function () {
      return ee;
    }), n.d(r, "bindAll", function () {
      return ie;
    }), n.d(r, "memoize", function () {
      return oe;
    }), n.d(r, "delay", function () {
      return ae;
    }), n.d(r, "defer", function () {
      return se;
    }), n.d(r, "throttle", function () {
      return le;
    }), n.d(r, "debounce", function () {
      return ce;
    }), n.d(r, "wrap", function () {
      return ue;
    }), n.d(r, "negate", function () {
      return de;
    }), n.d(r, "compose", function () {
      return he;
    }), n.d(r, "after", function () {
      return fe;
    }), n.d(r, "before", function () {
      return pe;
    }), n.d(r, "once", function () {
      return ge;
    }), n.d(r, "findKey", function () {
      return ve;
    }), n.d(r, "findIndex", function () {
      return be;
    }), n.d(r, "findLastIndex", function () {
      return ye;
    }), n.d(r, "sortedIndex", function () {
      return we;
    }), n.d(r, "indexOf", function () {
      return Oe;
    }), n.d(r, "lastIndexOf", function () {
      return Ce;
    }), n.d(r, "find", function () {
      return Se;
    }), n.d(r, "detect", function () {
      return Se;
    }), n.d(r, "findWhere", function () {
      return ke;
    }), n.d(r, "each", function () {
      return je;
    }), n.d(r, "forEach", function () {
      return je;
    }), n.d(r, "map", function () {
      return Te;
    }), n.d(r, "collect", function () {
      return Te;
    }), n.d(r, "reduce", function () {
      return Ee;
    }), n.d(r, "foldl", function () {
      return Ee;
    }), n.d(r, "inject", function () {
      return Ee;
    }), n.d(r, "reduceRight", function () {
      return De;
    }), n.d(r, "foldr", function () {
      return De;
    }), n.d(r, "filter", function () {
      return Me;
    }), n.d(r, "select", function () {
      return Me;
    }), n.d(r, "reject", function () {
      return Ae;
    }), n.d(r, "every", function () {
      return Le;
    }), n.d(r, "all", function () {
      return Le;
    }), n.d(r, "some", function () {
      return Ne;
    }), n.d(r, "any", function () {
      return Ne;
    }), n.d(r, "contains", function () {
      return _e;
    }), n.d(r, "includes", function () {
      return _e;
    }), n.d(r, "include", function () {
      return _e;
    }), n.d(r, "invoke", function () {
      return Ie;
    }), n.d(r, "pluck", function () {
      return Fe;
    }), n.d(r, "where", function () {
      return Ve;
    }), n.d(r, "max", function () {
      return Re;
    }), n.d(r, "min", function () {
      return ze;
    }), n.d(r, "shuffle", function () {
      return We;
    }), n.d(r, "sample", function () {
      return Be;
    }), n.d(r, "sortBy", function () {
      return Ue;
    }), n.d(r, "groupBy", function () {
      return Ge;
    }), n.d(r, "indexBy", function () {
      return Ke;
    }), n.d(r, "countBy", function () {
      return Ye;
    }), n.d(r, "partition", function () {
      return Xe;
    }), n.d(r, "toArray", function () {
      return $e;
    }), n.d(r, "size", function () {
      return Je;
    }), n.d(r, "pick", function () {
      return Qe;
    }), n.d(r, "omit", function () {
      return tn;
    }), n.d(r, "first", function () {
      return nn;
    }), n.d(r, "head", function () {
      return nn;
    }), n.d(r, "take", function () {
      return nn;
    }), n.d(r, "initial", function () {
      return en;
    }), n.d(r, "last", function () {
      return on;
    }), n.d(r, "rest", function () {
      return rn;
    }), n.d(r, "tail", function () {
      return rn;
    }), n.d(r, "drop", function () {
      return rn;
    }), n.d(r, "compact", function () {
      return an;
    }), n.d(r, "flatten", function () {
      return sn;
    }), n.d(r, "without", function () {
      return cn;
    }), n.d(r, "uniq", function () {
      return un;
    }), n.d(r, "unique", function () {
      return un;
    }), n.d(r, "union", function () {
      return dn;
    }), n.d(r, "intersection", function () {
      return hn;
    }), n.d(r, "difference", function () {
      return ln;
    }), n.d(r, "unzip", function () {
      return fn;
    }), n.d(r, "transpose", function () {
      return fn;
    }), n.d(r, "zip", function () {
      return pn;
    }), n.d(r, "object", function () {
      return gn;
    }), n.d(r, "range", function () {
      return vn;
    }), n.d(r, "chunk", function () {
      return mn;
    }), n.d(r, "mixin", function () {
      return yn;
    }), n.d(r, "default", function () {
      return wn;
    });
    var i = n(4);
    function o(t, e) {
      return e = null == e ? t.length - 1 : +e, function () {
        for (var n = Math.max(arguments.length - e, 0), r = Array(n), i = 0; i < n; i++) r[i] = arguments[i + e];
        switch (e) {
          case 0:
            return t.call(this, r);
          case 1:
            return t.call(this, arguments[0], r);
          case 2:
            return t.call(this, arguments[0], arguments[1], r);
        }
        var o = Array(e + 1);
        for (i = 0; i < e; i++) o[i] = arguments[i];
        return o[e] = r, t.apply(this, o);
      };
    }
    function a(t) {
      var e = typeof t;
      return "function" === e || "object" === e && !!t;
    }
    function s(t) {
      return null === t;
    }
    function l(t) {
      return void 0 === t;
    }
    function c(t) {
      return !0 === t || !1 === t || "[object Boolean]" === i.t.call(t);
    }
    function u(t) {
      return !(!t || 1 !== t.nodeType);
    }
    function d(t) {
      var e = "[object " + t + "]";
      return function (t) {
        return i.t.call(t) === e;
      };
    }
    var h = d("String"),
      f = d("Number"),
      p = d("Date"),
      g = d("RegExp"),
      v = d("Error"),
      m = d("Symbol"),
      b = d("ArrayBuffer"),
      y = d("Function"),
      w = i.p.document && i.p.document.childNodes;
    "object" != typeof Int8Array && "function" != typeof w && (y = function y(t) {
      return "function" == typeof t || !1;
    });
    var x = y,
      O = d("Object"),
      C = i.s && O(new DataView(new ArrayBuffer(8))),
      S = "undefined" != typeof Map && O(new Map()),
      k = d("DataView");
    var j = C ? function (t) {
        return null != t && x(t.getInt8) && b(t.buffer);
      } : k,
      T = i.k || d("Array");
    function P(t, e) {
      return null != t && i.i.call(t, e);
    }
    var E = d("Arguments");
    !function () {
      E(arguments) || (E = function E(t) {
        return P(t, "callee");
      });
    }();
    var D = E;
    function M(t) {
      return !m(t) && Object(i.f)(t) && !isNaN(parseFloat(t));
    }
    function A(t) {
      return f(t) && Object(i.g)(t);
    }
    function L(t) {
      return function () {
        return t;
      };
    }
    function N(t) {
      return function (e) {
        var n = t(e);
        return "number" == typeof n && n >= 0 && n <= i.b;
      };
    }
    function _(t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    }
    var I = _("byteLength"),
      F = N(I),
      V = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
    var R = i.r ? function (t) {
        return i.l ? Object(i.l)(t) && !j(t) : F(t) && V.test(i.t.call(t));
      } : L(!1),
      z = _("length");
    function H(t, e) {
      e = function (t) {
        for (var e = {}, n = t.length, r = 0; r < n; ++r) e[t[r]] = !0;
        return {
          contains: function contains(t) {
            return !0 === e[t];
          },
          push: function push(n) {
            return e[n] = !0, t.push(n);
          }
        };
      }(e);
      var n = i.n.length,
        r = t.constructor,
        o = x(r) && r.prototype || i.c,
        a = "constructor";
      for (P(t, a) && !e.contains(a) && e.push(a); n--;) (a = i.n[n]) in t && t[a] !== o[a] && !e.contains(a) && e.push(a);
    }
    function $(t) {
      if (!a(t)) return [];
      if (i.m) return Object(i.m)(t);
      var e = [];
      for (var n in t) P(t, n) && e.push(n);
      return i.h && H(t, e), e;
    }
    function B(t) {
      if (null == t) return !0;
      var e = z(t);
      return "number" == typeof e && (T(t) || h(t) || D(t)) ? 0 === e : 0 === z($(t));
    }
    function W(t, e) {
      var n = $(e),
        r = n.length;
      if (null == t) return !r;
      for (var i = Object(t), o = 0; o < r; o++) {
        var a = n[o];
        if (e[a] !== i[a] || !(a in i)) return !1;
      }
      return !0;
    }
    function U(t) {
      return t instanceof U ? t : this instanceof U ? void (this._wrapped = t) : new U(t);
    }
    function q(t) {
      return new Uint8Array(t.buffer || t, t.byteOffset || 0, I(t));
    }
    U.VERSION = i.e, U.prototype.value = function () {
      return this._wrapped;
    }, U.prototype.valueOf = U.prototype.toJSON = U.prototype.value, U.prototype.toString = function () {
      return String(this._wrapped);
    };
    function G(t, e, n, r) {
      if (t === e) return 0 !== t || 1 / t == 1 / e;
      if (null == t || null == e) return !1;
      if (t != t) return e != e;
      var o = typeof t;
      return ("function" === o || "object" === o || "object" == typeof e) && function t(e, n, r, o) {
        e instanceof U && (e = e._wrapped);
        n instanceof U && (n = n._wrapped);
        var a = i.t.call(e);
        if (a !== i.t.call(n)) return !1;
        if (C && "[object Object]" == a && j(e)) {
          if (!j(n)) return !1;
          a = "[object DataView]";
        }
        switch (a) {
          case "[object RegExp]":
          case "[object String]":
            return "" + e == "" + n;
          case "[object Number]":
            return +e != +e ? +n != +n : 0 == +e ? 1 / +e == 1 / n : +e == +n;
          case "[object Date]":
          case "[object Boolean]":
            return +e == +n;
          case "[object Symbol]":
            return i.d.valueOf.call(e) === i.d.valueOf.call(n);
          case "[object ArrayBuffer]":
          case "[object DataView]":
            return t(q(e), q(n), r, o);
        }
        var s = "[object Array]" === a;
        if (!s && R(e)) {
          if (I(e) !== I(n)) return !1;
          if (e.buffer === n.buffer && e.byteOffset === n.byteOffset) return !0;
          s = !0;
        }
        if (!s) {
          if ("object" != typeof e || "object" != typeof n) return !1;
          var l = e.constructor,
            c = n.constructor;
          if (l !== c && !(x(l) && l instanceof l && x(c) && c instanceof c) && "constructor" in e && "constructor" in n) return !1;
        }
        o = o || [];
        var u = (r = r || []).length;
        for (; u--;) if (r[u] === e) return o[u] === n;
        if (r.push(e), o.push(n), s) {
          if ((u = e.length) !== n.length) return !1;
          for (; u--;) if (!G(e[u], n[u], r, o)) return !1;
        } else {
          var d,
            h = $(e);
          if (u = h.length, $(n).length !== u) return !1;
          for (; u--;) if (d = h[u], !P(n, d) || !G(e[d], n[d], r, o)) return !1;
        }
        return r.pop(), o.pop(), !0;
      }(t, e, n, r);
    }
    function K(t, e) {
      return G(t, e);
    }
    function Y(t) {
      if (!a(t)) return [];
      var e = [];
      for (var n in t) e.push(n);
      return i.h && H(t, e), e;
    }
    function X(t) {
      var e = z(t);
      return function (n) {
        if (null == n) return !1;
        var r = Y(n);
        if (z(r)) return !1;
        for (var i = 0; i < e; i++) if (!x(n[t[i]])) return !1;
        return t !== et || !x(n[J]);
      };
    }
    var J = "forEach",
      Z = ["clear", "delete"],
      Q = ["get", "has", "set"],
      tt = Z.concat(J, Q),
      et = Z.concat(Q),
      nt = ["add"].concat(Z, J, "has"),
      rt = S ? X(tt) : d("Map"),
      it = S ? X(et) : d("WeakMap"),
      ot = S ? X(nt) : d("Set"),
      at = d("WeakSet");
    function st(t) {
      for (var e = $(t), n = e.length, r = Array(n), i = 0; i < n; i++) r[i] = t[e[i]];
      return r;
    }
    function lt(t) {
      for (var e = $(t), n = e.length, r = Array(n), i = 0; i < n; i++) r[i] = [e[i], t[e[i]]];
      return r;
    }
    function ct(t) {
      for (var e = {}, n = $(t), r = 0, i = n.length; r < i; r++) e[t[n[r]]] = n[r];
      return e;
    }
    function ut(t) {
      var e = [];
      for (var n in t) x(t[n]) && e.push(n);
      return e.sort();
    }
    function dt(t, e) {
      return function (n) {
        var r = arguments.length;
        if (e && (n = Object(n)), r < 2 || null == n) return n;
        for (var i = 1; i < r; i++) for (var o = arguments[i], a = t(o), s = a.length, l = 0; l < s; l++) {
          var c = a[l];
          e && void 0 !== n[c] || (n[c] = o[c]);
        }
        return n;
      };
    }
    var ht = dt(Y),
      ft = dt($),
      pt = dt(Y, !0);
    function gt(t) {
      if (!a(t)) return {};
      if (i.j) return Object(i.j)(t);
      var e = function e() {};
      e.prototype = t;
      var n = new e();
      return e.prototype = null, n;
    }
    function vt(t, e) {
      var n = gt(t);
      return e && ft(n, e), n;
    }
    function mt(t) {
      return a(t) ? T(t) ? t.slice() : ht({}, t) : t;
    }
    function bt(t, e) {
      return e(t), t;
    }
    function yt(t) {
      return T(t) ? t : [t];
    }
    function wt(t) {
      return U.toPath(t);
    }
    function xt(t, e) {
      for (var n = e.length, r = 0; r < n; r++) {
        if (null == t) return;
        t = t[e[r]];
      }
      return n ? t : void 0;
    }
    function Ot(t, e, n) {
      var r = xt(t, wt(e));
      return l(r) ? n : r;
    }
    function Ct(t, e) {
      for (var n = (e = wt(e)).length, r = 0; r < n; r++) {
        var i = e[r];
        if (!P(t, i)) return !1;
        t = t[i];
      }
      return !!n;
    }
    function St(t) {
      return t;
    }
    function kt(t) {
      return t = ft({}, t), function (e) {
        return W(e, t);
      };
    }
    function jt(t) {
      return t = wt(t), function (e) {
        return xt(e, t);
      };
    }
    function Tt(t, e, n) {
      if (void 0 === e) return t;
      switch (null == n ? 3 : n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };
        case 3:
          return function (n, r, i) {
            return t.call(e, n, r, i);
          };
        case 4:
          return function (n, r, i, o) {
            return t.call(e, n, r, i, o);
          };
      }
      return function () {
        return t.apply(e, arguments);
      };
    }
    function Pt(t, e, n) {
      return null == t ? St : x(t) ? Tt(t, e, n) : a(t) && !T(t) ? kt(t) : jt(t);
    }
    function Et(t, e) {
      return Pt(t, e, 1 / 0);
    }
    function Dt(t, e, n) {
      return U.iteratee !== Et ? U.iteratee(t, e) : Pt(t, e, n);
    }
    function Mt(t, e, n) {
      e = Dt(e, n);
      for (var r = $(t), i = r.length, o = {}, a = 0; a < i; a++) {
        var s = r[a];
        o[s] = e(t[s], s, t);
      }
      return o;
    }
    function At() {}
    function Lt(t) {
      return null == t ? At : function (e) {
        return Ot(t, e);
      };
    }
    function Nt(t, e, n) {
      var r = Array(Math.max(0, t));
      e = Tt(e, n, 1);
      for (var i = 0; i < t; i++) r[i] = e(i);
      return r;
    }
    function _t(t, e) {
      return null == e && (e = t, t = 0), t + Math.floor(Math.random() * (e - t + 1));
    }
    U.toPath = yt, U.iteratee = Et;
    var It = Date.now || function () {
      return new Date().getTime();
    };
    function Ft(t) {
      var e = function e(_e2) {
          return t[_e2];
        },
        n = "(?:" + $(t).join("|") + ")",
        r = RegExp(n),
        i = RegExp(n, "g");
      return function (t) {
        return t = null == t ? "" : "" + t, r.test(t) ? t.replace(i, e) : t;
      };
    }
    var Vt = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;"
      },
      Rt = Ft(Vt),
      zt = Ft(ct(Vt)),
      Ht = U.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      },
      $t = /(.)^/,
      Bt = {
        "'": "'",
        "\\": "\\",
        "\r": "r",
        "\n": "n",
        "\u2028": "u2028",
        "\u2029": "u2029"
      },
      Wt = /\\|'|\r|\n|\u2028|\u2029/g;
    function Ut(t) {
      return "\\" + Bt[t];
    }
    var qt = /^\s*(\w|\$)+\s*$/;
    function Gt(t, e, n) {
      !e && n && (e = n), e = pt({}, e, U.templateSettings);
      var r = RegExp([(e.escape || $t).source, (e.interpolate || $t).source, (e.evaluate || $t).source].join("|") + "|$", "g"),
        i = 0,
        o = "__p+='";
      t.replace(r, function (e, n, r, a, s) {
        return o += t.slice(i, s).replace(Wt, Ut), i = s + e.length, n ? o += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : r ? o += "'+\n((__t=(" + r + "))==null?'':__t)+\n'" : a && (o += "';\n" + a + "\n__p+='"), e;
      }), o += "';\n";
      var a,
        s = e.variable;
      if (s) {
        if (!qt.test(s)) throw new Error("variable is not a bare identifier: " + s);
      } else o = "with(obj||{}){\n" + o + "}\n", s = "obj";
      o = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
      try {
        a = new Function(s, "_", o);
      } catch (t) {
        throw t.source = o, t;
      }
      var l = function l(t) {
        return a.call(this, t, U);
      };
      return l.source = "function(" + s + "){\n" + o + "}", l;
    }
    function Kt(t, e, n) {
      var r = (e = wt(e)).length;
      if (!r) return x(n) ? n.call(t) : n;
      for (var i = 0; i < r; i++) {
        var o = null == t ? void 0 : t[e[i]];
        void 0 === o && (o = n, i = r), t = x(o) ? o.call(t) : o;
      }
      return t;
    }
    var Yt = 0;
    function Xt(t) {
      var e = ++Yt + "";
      return t ? t + e : e;
    }
    function Jt(t) {
      var e = U(t);
      return e._chain = !0, e;
    }
    function Zt(t, e, n, r, i) {
      if (!(r instanceof e)) return t.apply(n, i);
      var o = gt(t.prototype),
        s = t.apply(o, i);
      return a(s) ? s : o;
    }
    var Qt = o(function (t, e) {
      var n = Qt.placeholder,
        _r2 = function r() {
          for (var i = 0, o = e.length, a = Array(o), s = 0; s < o; s++) a[s] = e[s] === n ? arguments[i++] : e[s];
          for (; i < arguments.length;) a.push(arguments[i++]);
          return Zt(t, _r2, this, this, a);
        };
      return _r2;
    });
    Qt.placeholder = U;
    var te = Qt,
      ee = o(function (t, e, n) {
        if (!x(t)) throw new TypeError("Bind must be called on a function");
        var r = o(function (i) {
          return Zt(t, r, e, this, n.concat(i));
        });
        return r;
      }),
      ne = N(z);
    function re(t, e, n, r) {
      if (r = r || [], e || 0 === e) {
        if (e <= 0) return r.concat(t);
      } else e = 1 / 0;
      for (var i = r.length, o = 0, a = z(t); o < a; o++) {
        var s = t[o];
        if (ne(s) && (T(s) || D(s))) {
          if (e > 1) re(s, e - 1, n, r), i = r.length;else for (var l = 0, c = s.length; l < c;) r[i++] = s[l++];
        } else n || (r[i++] = s);
      }
      return r;
    }
    var ie = o(function (t, e) {
      var n = (e = re(e, !1, !1)).length;
      if (n < 1) throw new Error("bindAll must be passed function names");
      for (; n--;) {
        var r = e[n];
        t[r] = ee(t[r], t);
      }
      return t;
    });
    function oe(t, e) {
      var _n2 = function n(r) {
        var i = _n2.cache,
          o = "" + (e ? e.apply(this, arguments) : r);
        return P(i, o) || (i[o] = t.apply(this, arguments)), i[o];
      };
      return _n2.cache = {}, _n2;
    }
    var ae = o(function (t, e, n) {
        return setTimeout(function () {
          return t.apply(null, n);
        }, e);
      }),
      se = te(ae, U, 1);
    function le(t, e, n) {
      var r,
        i,
        o,
        a,
        s = 0;
      n || (n = {});
      var l = function l() {
          s = !1 === n.leading ? 0 : It(), r = null, a = t.apply(i, o), r || (i = o = null);
        },
        c = function c() {
          var c = It();
          s || !1 !== n.leading || (s = c);
          var u = e - (c - s);
          return i = this, o = arguments, u <= 0 || u > e ? (r && (clearTimeout(r), r = null), s = c, a = t.apply(i, o), r || (i = o = null)) : r || !1 === n.trailing || (r = setTimeout(l, u)), a;
        };
      return c.cancel = function () {
        clearTimeout(r), s = 0, r = i = o = null;
      }, c;
    }
    function ce(t, e, n) {
      var r,
        i,
        a,
        s,
        l,
        _c = function c() {
          var o = It() - i;
          e > o ? r = setTimeout(_c, e - o) : (r = null, n || (s = t.apply(l, a)), r || (a = l = null));
        },
        u = o(function (o) {
          return l = this, a = o, i = It(), r || (r = setTimeout(_c, e), n && (s = t.apply(l, a))), s;
        });
      return u.cancel = function () {
        clearTimeout(r), r = a = l = null;
      }, u;
    }
    function ue(t, e) {
      return te(e, t);
    }
    function de(t) {
      return function () {
        return !t.apply(this, arguments);
      };
    }
    function he() {
      var t = arguments,
        e = t.length - 1;
      return function () {
        for (var n = e, r = t[e].apply(this, arguments); n--;) r = t[n].call(this, r);
        return r;
      };
    }
    function fe(t, e) {
      return function () {
        if (--t < 1) return e.apply(this, arguments);
      };
    }
    function pe(t, e) {
      var n;
      return function () {
        return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = null), n;
      };
    }
    var ge = te(pe, 2);
    function ve(t, e, n) {
      e = Dt(e, n);
      for (var r, i = $(t), o = 0, a = i.length; o < a; o++) if (e(t[r = i[o]], r, t)) return r;
    }
    function me(t) {
      return function (e, n, r) {
        n = Dt(n, r);
        for (var i = z(e), o = t > 0 ? 0 : i - 1; o >= 0 && o < i; o += t) if (n(e[o], o, e)) return o;
        return -1;
      };
    }
    var be = me(1),
      ye = me(-1);
    function we(t, e, n, r) {
      for (var i = (n = Dt(n, r, 1))(e), o = 0, a = z(t); o < a;) {
        var s = Math.floor((o + a) / 2);
        n(t[s]) < i ? o = s + 1 : a = s;
      }
      return o;
    }
    function xe(t, e, n) {
      return function (r, o, a) {
        var s = 0,
          l = z(r);
        if ("number" == typeof a) t > 0 ? s = a >= 0 ? a : Math.max(a + l, s) : l = a >= 0 ? Math.min(a + 1, l) : a + l + 1;else if (n && a && l) return r[a = n(r, o)] === o ? a : -1;
        if (o != o) return (a = e(i.q.call(r, s, l), A)) >= 0 ? a + s : -1;
        for (a = t > 0 ? s : l - 1; a >= 0 && a < l; a += t) if (r[a] === o) return a;
        return -1;
      };
    }
    var Oe = xe(1, be, we),
      Ce = xe(-1, ye);
    function Se(t, e, n) {
      var r = (ne(t) ? be : ve)(t, e, n);
      if (void 0 !== r && -1 !== r) return t[r];
    }
    function ke(t, e) {
      return Se(t, kt(e));
    }
    function je(t, e, n) {
      var r, i;
      if (e = Tt(e, n), ne(t)) for (r = 0, i = t.length; r < i; r++) e(t[r], r, t);else {
        var o = $(t);
        for (r = 0, i = o.length; r < i; r++) e(t[o[r]], o[r], t);
      }
      return t;
    }
    function Te(t, e, n) {
      e = Dt(e, n);
      for (var r = !ne(t) && $(t), i = (r || t).length, o = Array(i), a = 0; a < i; a++) {
        var s = r ? r[a] : a;
        o[a] = e(t[s], s, t);
      }
      return o;
    }
    function Pe(t) {
      var e = function e(_e3, n, r, i) {
        var o = !ne(_e3) && $(_e3),
          a = (o || _e3).length,
          s = t > 0 ? 0 : a - 1;
        for (i || (r = _e3[o ? o[s] : s], s += t); s >= 0 && s < a; s += t) {
          var l = o ? o[s] : s;
          r = n(r, _e3[l], l, _e3);
        }
        return r;
      };
      return function (t, n, r, i) {
        var o = arguments.length >= 3;
        return e(t, Tt(n, i, 4), r, o);
      };
    }
    var Ee = Pe(1),
      De = Pe(-1);
    function Me(t, e, n) {
      var r = [];
      return e = Dt(e, n), je(t, function (t, n, i) {
        e(t, n, i) && r.push(t);
      }), r;
    }
    function Ae(t, e, n) {
      return Me(t, de(Dt(e)), n);
    }
    function Le(t, e, n) {
      e = Dt(e, n);
      for (var r = !ne(t) && $(t), i = (r || t).length, o = 0; o < i; o++) {
        var a = r ? r[o] : o;
        if (!e(t[a], a, t)) return !1;
      }
      return !0;
    }
    function Ne(t, e, n) {
      e = Dt(e, n);
      for (var r = !ne(t) && $(t), i = (r || t).length, o = 0; o < i; o++) {
        var a = r ? r[o] : o;
        if (e(t[a], a, t)) return !0;
      }
      return !1;
    }
    function _e(t, e, n, r) {
      return ne(t) || (t = st(t)), ("number" != typeof n || r) && (n = 0), Oe(t, e, n) >= 0;
    }
    var Ie = o(function (t, e, n) {
      var r, i;
      return x(e) ? i = e : (e = wt(e), r = e.slice(0, -1), e = e[e.length - 1]), Te(t, function (t) {
        var o = i;
        if (!o) {
          if (r && r.length && (t = xt(t, r)), null == t) return;
          o = t[e];
        }
        return null == o ? o : o.apply(t, n);
      });
    });
    function Fe(t, e) {
      return Te(t, jt(e));
    }
    function Ve(t, e) {
      return Me(t, kt(e));
    }
    function Re(t, e, n) {
      var r,
        i,
        o = -1 / 0,
        a = -1 / 0;
      if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) for (var s = 0, l = (t = ne(t) ? t : st(t)).length; s < l; s++) null != (r = t[s]) && r > o && (o = r);else e = Dt(e, n), je(t, function (t, n, r) {
        ((i = e(t, n, r)) > a || i === -1 / 0 && o === -1 / 0) && (o = t, a = i);
      });
      return o;
    }
    function ze(t, e, n) {
      var r,
        i,
        o = 1 / 0,
        a = 1 / 0;
      if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) for (var s = 0, l = (t = ne(t) ? t : st(t)).length; s < l; s++) null != (r = t[s]) && r < o && (o = r);else e = Dt(e, n), je(t, function (t, n, r) {
        ((i = e(t, n, r)) < a || i === 1 / 0 && o === 1 / 0) && (o = t, a = i);
      });
      return o;
    }
    var He = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
    function $e(t) {
      return t ? T(t) ? i.q.call(t) : h(t) ? t.match(He) : ne(t) ? Te(t, St) : st(t) : [];
    }
    function Be(t, e, n) {
      if (null == e || n) return ne(t) || (t = st(t)), t[_t(t.length - 1)];
      var r = $e(t),
        i = z(r);
      e = Math.max(Math.min(e, i), 0);
      for (var o = i - 1, a = 0; a < e; a++) {
        var s = _t(a, o),
          l = r[a];
        r[a] = r[s], r[s] = l;
      }
      return r.slice(0, e);
    }
    function We(t) {
      return Be(t, 1 / 0);
    }
    function Ue(t, e, n) {
      var r = 0;
      return e = Dt(e, n), Fe(Te(t, function (t, n, i) {
        return {
          value: t,
          index: r++,
          criteria: e(t, n, i)
        };
      }).sort(function (t, e) {
        var n = t.criteria,
          r = e.criteria;
        if (n !== r) {
          if (n > r || void 0 === n) return 1;
          if (n < r || void 0 === r) return -1;
        }
        return t.index - e.index;
      }), "value");
    }
    function qe(t, e) {
      return function (n, r, i) {
        var o = e ? [[], []] : {};
        return r = Dt(r, i), je(n, function (e, i) {
          var a = r(e, i, n);
          t(o, e, a);
        }), o;
      };
    }
    var Ge = qe(function (t, e, n) {
        P(t, n) ? t[n].push(e) : t[n] = [e];
      }),
      Ke = qe(function (t, e, n) {
        t[n] = e;
      }),
      Ye = qe(function (t, e, n) {
        P(t, n) ? t[n]++ : t[n] = 1;
      }),
      Xe = qe(function (t, e, n) {
        t[n ? 0 : 1].push(e);
      }, !0);
    function Je(t) {
      return null == t ? 0 : ne(t) ? t.length : $(t).length;
    }
    function Ze(t, e, n) {
      return e in n;
    }
    var Qe = o(function (t, e) {
        var n = {},
          r = e[0];
        if (null == t) return n;
        x(r) ? (e.length > 1 && (r = Tt(r, e[1])), e = Y(t)) : (r = Ze, e = re(e, !1, !1), t = Object(t));
        for (var i = 0, o = e.length; i < o; i++) {
          var a = e[i],
            s = t[a];
          r(s, a, t) && (n[a] = s);
        }
        return n;
      }),
      tn = o(function (t, e) {
        var n,
          r = e[0];
        return x(r) ? (r = de(r), e.length > 1 && (n = e[1])) : (e = Te(re(e, !1, !1), String), r = function r(t, n) {
          return !_e(e, n);
        }), Qe(t, r, n);
      });
    function en(t, e, n) {
      return i.q.call(t, 0, Math.max(0, t.length - (null == e || n ? 1 : e)));
    }
    function nn(t, e, n) {
      return null == t || t.length < 1 ? null == e || n ? void 0 : [] : null == e || n ? t[0] : en(t, t.length - e);
    }
    function rn(t, e, n) {
      return i.q.call(t, null == e || n ? 1 : e);
    }
    function on(t, e, n) {
      return null == t || t.length < 1 ? null == e || n ? void 0 : [] : null == e || n ? t[t.length - 1] : rn(t, Math.max(0, t.length - e));
    }
    function an(t) {
      return Me(t, Boolean);
    }
    function sn(t, e) {
      return re(t, e, !1);
    }
    var ln = o(function (t, e) {
        return e = re(e, !0, !0), Me(t, function (t) {
          return !_e(e, t);
        });
      }),
      cn = o(function (t, e) {
        return ln(t, e);
      });
    function un(t, e, n, r) {
      c(e) || (r = n, n = e, e = !1), null != n && (n = Dt(n, r));
      for (var i = [], o = [], a = 0, s = z(t); a < s; a++) {
        var l = t[a],
          u = n ? n(l, a, t) : l;
        e && !n ? (a && o === u || i.push(l), o = u) : n ? _e(o, u) || (o.push(u), i.push(l)) : _e(i, l) || i.push(l);
      }
      return i;
    }
    var dn = o(function (t) {
      return un(re(t, !0, !0));
    });
    function hn(t) {
      for (var e = [], n = arguments.length, r = 0, i = z(t); r < i; r++) {
        var o = t[r];
        if (!_e(e, o)) {
          var a;
          for (a = 1; a < n && _e(arguments[a], o); a++);
          a === n && e.push(o);
        }
      }
      return e;
    }
    function fn(t) {
      for (var e = t && Re(t, z).length || 0, n = Array(e), r = 0; r < e; r++) n[r] = Fe(t, r);
      return n;
    }
    var pn = o(fn);
    function gn(t, e) {
      for (var n = {}, r = 0, i = z(t); r < i; r++) e ? n[t[r]] = e[r] : n[t[r][0]] = t[r][1];
      return n;
    }
    function vn(t, e, n) {
      null == e && (e = t || 0, t = 0), n || (n = e < t ? -1 : 1);
      for (var r = Math.max(Math.ceil((e - t) / n), 0), i = Array(r), o = 0; o < r; o++, t += n) i[o] = t;
      return i;
    }
    function mn(t, e) {
      if (null == e || e < 1) return [];
      for (var n = [], r = 0, o = t.length; r < o;) n.push(i.q.call(t, r, r += e));
      return n;
    }
    function bn(t, e) {
      return t._chain ? U(e).chain() : e;
    }
    function yn(t) {
      return je(ut(t), function (e) {
        var n = U[e] = t[e];
        U.prototype[e] = function () {
          var t = [this._wrapped];
          return i.o.apply(t, arguments), bn(this, n.apply(U, t));
        };
      }), U;
    }
    je(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (t) {
      var e = i.a[t];
      U.prototype[t] = function () {
        var n = this._wrapped;
        return null != n && (e.apply(n, arguments), "shift" !== t && "splice" !== t || 0 !== n.length || delete n[0]), bn(this, n);
      };
    }), je(["concat", "join", "slice"], function (t) {
      var e = i.a[t];
      U.prototype[t] = function () {
        var t = this._wrapped;
        return null != t && (t = e.apply(t, arguments)), bn(this, t);
      };
    });
    var wn = U,
      xn = yn(r);
    xn._ = xn;
    var On = xn;
  }, function (t, e, n) {
    (function (r) {
      var i, o, a;
      a = "object" == typeof self && self.self === self && self || "object" == typeof r && r.global === r && r, i = [n(0), n(11), e], void 0 === (o = function (t, e, n) {
        a.Backbone = function (t, e, n, r) {
          var i = t.Backbone,
            o = Array.prototype.slice;
          e.VERSION = "1.3.3", e.$ = r, e.noConflict = function () {
            return t.Backbone = i, this;
          }, e.emulateHTTP = !1, e.emulateJSON = !1;
          var a = function a(t, e, r) {
              n.each(e, function (e, i) {
                n[i] && (t.prototype[i] = function (t, e, r) {
                  switch (t) {
                    case 1:
                      return function () {
                        return n[e](this[r]);
                      };
                    case 2:
                      return function (t) {
                        return n[e](this[r], t);
                      };
                    case 3:
                      return function (t, i) {
                        return n[e](this[r], s(t, this), i);
                      };
                    case 4:
                      return function (t, i, o) {
                        return n[e](this[r], s(t, this), i, o);
                      };
                    default:
                      return function () {
                        var t = o.call(arguments);
                        return t.unshift(this[r]), n[e].apply(n, t);
                      };
                  }
                }(e, i, r));
              });
            },
            s = function s(t, e) {
              return n.isFunction(t) ? t : n.isObject(t) && !e._isModel(t) ? l(t) : n.isString(t) ? function (e) {
                return e.get(t);
              } : t;
            },
            l = function l(t) {
              var e = n.matches(t);
              return function (t) {
                return e(t.attributes);
              };
            },
            c = e.Events = {},
            u = /\s+/,
            _d = function d(t, e, r, i, o) {
              var a,
                s = 0;
              if (r && "object" == typeof r) {
                void 0 !== i && "context" in o && void 0 === o.context && (o.context = i);
                for (a = n.keys(r); s < a.length; s++) e = _d(t, e, a[s], r[a[s]], o);
              } else if (r && u.test(r)) for (a = r.split(u); s < a.length; s++) e = t(e, a[s], i, o);else e = t(e, r, i, o);
              return e;
            };
          c.on = function (t, e, n) {
            return h(this, t, e, n);
          };
          var h = function h(t, e, n, r, i) {
            return t._events = _d(f, t._events || {}, e, n, {
              context: r,
              ctx: t,
              listening: i
            }), i && ((t._listeners || (t._listeners = {}))[i.id] = i), t;
          };
          c.listenTo = function (t, e, r) {
            if (!t) return this;
            var i = t._listenId || (t._listenId = n.uniqueId("l")),
              o = this._listeningTo || (this._listeningTo = {}),
              a = o[i];
            if (!a) {
              var s = this._listenId || (this._listenId = n.uniqueId("l"));
              a = o[i] = {
                obj: t,
                objId: i,
                id: s,
                listeningTo: o,
                count: 0
              };
            }
            return h(t, e, r, this, a), this;
          };
          var f = function f(t, e, n, r) {
            if (n) {
              var i = t[e] || (t[e] = []),
                o = r.context,
                a = r.ctx,
                s = r.listening;
              s && s.count++, i.push({
                callback: n,
                context: o,
                ctx: o || a,
                listening: s
              });
            }
            return t;
          };
          c.off = function (t, e, n) {
            return this._events ? (this._events = _d(p, this._events, t, e, {
              context: n,
              listeners: this._listeners
            }), this) : this;
          }, c.stopListening = function (t, e, r) {
            var i = this._listeningTo;
            if (!i) return this;
            for (var o = t ? [t._listenId] : n.keys(i), a = 0; a < o.length; a++) {
              var s = i[o[a]];
              if (!s) break;
              s.obj.off(e, r, this);
            }
            return this;
          };
          var p = function p(t, e, r, i) {
            if (t) {
              var o,
                a = 0,
                s = i.context,
                l = i.listeners;
              if (e || r || s) {
                for (var c = e ? [e] : n.keys(t); a < c.length; a++) {
                  var u = t[e = c[a]];
                  if (!u) break;
                  for (var d = [], h = 0; h < u.length; h++) {
                    var f = u[h];
                    r && r !== f.callback && r !== f.callback._callback || s && s !== f.context ? d.push(f) : (o = f.listening) && 0 == --o.count && (delete l[o.id], delete o.listeningTo[o.objId]);
                  }
                  d.length ? t[e] = d : delete t[e];
                }
                return t;
              }
              for (var p = n.keys(l); a < p.length; a++) delete l[(o = l[p[a]]).id], delete o.listeningTo[o.objId];
            }
          };
          c.once = function (t, e, r) {
            var i = _d(g, {}, t, e, n.bind(this.off, this));
            return "string" == typeof t && null == r && (e = void 0), this.on(i, e, r);
          }, c.listenToOnce = function (t, e, r) {
            var i = _d(g, {}, e, r, n.bind(this.stopListening, this, t));
            return this.listenTo(t, i);
          };
          var g = function g(t, e, r, i) {
            if (r) {
              var o = t[e] = n.once(function () {
                i(e, o), r.apply(this, arguments);
              });
              o._callback = r;
            }
            return t;
          };
          c.trigger = function (t) {
            if (!this._events) return this;
            for (var e = Math.max(0, arguments.length - 1), n = Array(e), r = 0; r < e; r++) n[r] = arguments[r + 1];
            return _d(v, this._events, t, void 0, n), this;
          };
          var v = function v(t, e, n, r) {
              if (t) {
                var i = t[e],
                  o = t.all;
                i && o && (o = o.slice()), i && m(i, r), o && m(o, [e].concat(r));
              }
              return t;
            },
            m = function m(t, e) {
              var n,
                r = -1,
                i = t.length,
                o = e[0],
                a = e[1],
                s = e[2];
              switch (e.length) {
                case 0:
                  for (; ++r < i;) (n = t[r]).callback.call(n.ctx);
                  return;
                case 1:
                  for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o);
                  return;
                case 2:
                  for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o, a);
                  return;
                case 3:
                  for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o, a, s);
                  return;
                default:
                  for (; ++r < i;) (n = t[r]).callback.apply(n.ctx, e);
                  return;
              }
            };
          c.bind = c.on, c.unbind = c.off, n.extend(e, c);
          var b = e.Model = function (t, e) {
            var r = t || {};
            e || (e = {}), this.cid = n.uniqueId(this.cidPrefix), this.attributes = {}, e.collection && (this.collection = e.collection), e.parse && (r = this.parse(r, e) || {});
            var i = n.result(this, "defaults");
            r = n.defaults(n.extend({}, i, r), i), this.set(r, e), this.changed = {}, this.initialize.apply(this, arguments);
          };
          n.extend(b.prototype, c, {
            changed: null,
            validationError: null,
            idAttribute: "id",
            cidPrefix: "c",
            initialize: function initialize() {},
            toJSON: function toJSON(t) {
              return n.clone(this.attributes);
            },
            sync: function sync() {
              return e.sync.apply(this, arguments);
            },
            get: function get(t) {
              return this.attributes[t];
            },
            escape: function escape(t) {
              return n.escape(this.get(t));
            },
            has: function has(t) {
              return null != this.get(t);
            },
            matches: function matches(t) {
              return !!n.iteratee(t, this)(this.attributes);
            },
            set: function set(t, e, r) {
              if (null == t) return this;
              var i;
              if ("object" == typeof t ? (i = t, r = e) : (i = {})[t] = e, r || (r = {}), !this._validate(i, r)) return !1;
              var o = r.unset,
                a = r.silent,
                s = [],
                l = this._changing;
              this._changing = !0, l || (this._previousAttributes = n.clone(this.attributes), this.changed = {});
              var c = this.attributes,
                u = this.changed,
                d = this._previousAttributes;
              for (var h in i) e = i[h], n.isEqual(c[h], e) || s.push(h), n.isEqual(d[h], e) ? delete u[h] : u[h] = e, o ? delete c[h] : c[h] = e;
              if (this.idAttribute in i && (this.id = this.get(this.idAttribute)), !a) {
                s.length && (this._pending = r);
                for (var f = 0; f < s.length; f++) this.trigger("change:" + s[f], this, c[s[f]], r);
              }
              if (l) return this;
              if (!a) for (; this._pending;) r = this._pending, this._pending = !1, this.trigger("change", this, r);
              return this._pending = !1, this._changing = !1, this;
            },
            unset: function unset(t, e) {
              return this.set(t, void 0, n.extend({}, e, {
                unset: !0
              }));
            },
            clear: function clear(t) {
              var e = {};
              for (var r in this.attributes) e[r] = void 0;
              return this.set(e, n.extend({}, t, {
                unset: !0
              }));
            },
            hasChanged: function hasChanged(t) {
              return null == t ? !n.isEmpty(this.changed) : n.has(this.changed, t);
            },
            changedAttributes: function changedAttributes(t) {
              if (!t) return !!this.hasChanged() && n.clone(this.changed);
              var e = this._changing ? this._previousAttributes : this.attributes,
                r = {};
              for (var i in t) {
                var o = t[i];
                n.isEqual(e[i], o) || (r[i] = o);
              }
              return !!n.size(r) && r;
            },
            previous: function previous(t) {
              return null != t && this._previousAttributes ? this._previousAttributes[t] : null;
            },
            previousAttributes: function previousAttributes() {
              return n.clone(this._previousAttributes);
            },
            fetch: function fetch(t) {
              t = n.extend({
                parse: !0
              }, t);
              var e = this,
                r = t.success;
              return t.success = function (n) {
                var i = t.parse ? e.parse(n, t) : n;
                if (!e.set(i, t)) return !1;
                r && r.call(t.context, e, n, t), e.trigger("sync", e, n, t);
              }, F(this, t), this.sync("read", this, t);
            },
            save: function save(t, e, r) {
              var i;
              null == t || "object" == typeof t ? (i = t, r = e) : (i = {})[t] = e;
              var o = (r = n.extend({
                validate: !0,
                parse: !0
              }, r)).wait;
              if (i && !o) {
                if (!this.set(i, r)) return !1;
              } else if (!this._validate(i, r)) return !1;
              var a = this,
                s = r.success,
                l = this.attributes;
              r.success = function (t) {
                a.attributes = l;
                var e = r.parse ? a.parse(t, r) : t;
                if (o && (e = n.extend({}, i, e)), e && !a.set(e, r)) return !1;
                s && s.call(r.context, a, t, r), a.trigger("sync", a, t, r);
              }, F(this, r), i && o && (this.attributes = n.extend({}, l, i));
              var c = this.isNew() ? "create" : r.patch ? "patch" : "update";
              "patch" !== c || r.attrs || (r.attrs = i);
              var u = this.sync(c, this, r);
              return this.attributes = l, u;
            },
            destroy: function destroy(t) {
              t = t ? n.clone(t) : {};
              var e = this,
                r = t.success,
                i = t.wait,
                o = function o() {
                  e.stopListening(), e.trigger("destroy", e, e.collection, t);
                };
              t.success = function (n) {
                i && o(), r && r.call(t.context, e, n, t), e.isNew() || e.trigger("sync", e, n, t);
              };
              var a = !1;
              return this.isNew() ? n.defer(t.success) : (F(this, t), a = this.sync("delete", this, t)), i || o(), a;
            },
            url: function url() {
              var t = n.result(this, "urlRoot") || n.result(this.collection, "url") || I();
              if (this.isNew()) return t;
              var e = this.get(this.idAttribute);
              return t.replace(/[^\/]$/, "$&/") + encodeURIComponent(e);
            },
            parse: function parse(t, e) {
              return t;
            },
            clone: function clone() {
              return new this.constructor(this.attributes);
            },
            isNew: function isNew() {
              return !this.has(this.idAttribute);
            },
            isValid: function isValid(t) {
              return this._validate({}, n.extend({}, t, {
                validate: !0
              }));
            },
            _validate: function _validate(t, e) {
              if (!e.validate || !this.validate) return !0;
              t = n.extend({}, this.attributes, t);
              var r = this.validationError = this.validate(t, e) || null;
              return !r || (this.trigger("invalid", this, r, n.extend(e, {
                validationError: r
              })), !1);
            }
          }), a(b, {
            keys: 1,
            values: 1,
            pairs: 1,
            invert: 1,
            pick: 0,
            omit: 0,
            chain: 1,
            isEmpty: 1
          }, "attributes");
          var y = e.Collection = function (t, e) {
              e || (e = {}), e.model && (this.model = e.model), void 0 !== e.comparator && (this.comparator = e.comparator), this._reset(), this.initialize.apply(this, arguments), t && this.reset(t, n.extend({
                silent: !0
              }, e));
            },
            w = {
              add: !0,
              remove: !0,
              merge: !0
            },
            x = {
              add: !0,
              remove: !1
            },
            O = function O(t, e, n) {
              n = Math.min(Math.max(n, 0), t.length);
              var r,
                i = Array(t.length - n),
                o = e.length;
              for (r = 0; r < i.length; r++) i[r] = t[r + n];
              for (r = 0; r < o; r++) t[r + n] = e[r];
              for (r = 0; r < i.length; r++) t[r + o + n] = i[r];
            };
          n.extend(y.prototype, c, {
            model: b,
            initialize: function initialize() {},
            toJSON: function toJSON(t) {
              return this.map(function (e) {
                return e.toJSON(t);
              });
            },
            sync: function sync() {
              return e.sync.apply(this, arguments);
            },
            add: function add(t, e) {
              return this.set(t, n.extend({
                merge: !1
              }, e, x));
            },
            remove: function remove(t, e) {
              e = n.extend({}, e);
              var r = !n.isArray(t);
              t = r ? [t] : t.slice();
              var i = this._removeModels(t, e);
              return !e.silent && i.length && (e.changes = {
                added: [],
                merged: [],
                removed: i
              }, this.trigger("update", this, e)), r ? i[0] : i;
            },
            set: function set(t, e) {
              if (null != t) {
                (e = n.extend({}, w, e)).parse && !this._isModel(t) && (t = this.parse(t, e) || []);
                var r = !n.isArray(t);
                t = r ? [t] : t.slice();
                var i = e.at;
                null != i && (i = +i), i > this.length && (i = this.length), i < 0 && (i += this.length + 1);
                var o,
                  a,
                  s = [],
                  l = [],
                  c = [],
                  u = [],
                  d = {},
                  h = e.add,
                  f = e.merge,
                  p = e.remove,
                  g = !1,
                  v = this.comparator && null == i && !1 !== e.sort,
                  m = n.isString(this.comparator) ? this.comparator : null;
                for (a = 0; a < t.length; a++) {
                  o = t[a];
                  var b = this.get(o);
                  if (b) {
                    if (f && o !== b) {
                      var y = this._isModel(o) ? o.attributes : o;
                      e.parse && (y = b.parse(y, e)), b.set(y, e), c.push(b), v && !g && (g = b.hasChanged(m));
                    }
                    d[b.cid] || (d[b.cid] = !0, s.push(b)), t[a] = b;
                  } else h && (o = t[a] = this._prepareModel(o, e)) && (l.push(o), this._addReference(o, e), d[o.cid] = !0, s.push(o));
                }
                if (p) {
                  for (a = 0; a < this.length; a++) d[(o = this.models[a]).cid] || u.push(o);
                  u.length && this._removeModels(u, e);
                }
                var x = !1,
                  C = !v && h && p;
                if (s.length && C ? (x = this.length !== s.length || n.some(this.models, function (t, e) {
                  return t !== s[e];
                }), this.models.length = 0, O(this.models, s, 0), this.length = this.models.length) : l.length && (v && (g = !0), O(this.models, l, null == i ? this.length : i), this.length = this.models.length), g && this.sort({
                  silent: !0
                }), !e.silent) {
                  for (a = 0; a < l.length; a++) null != i && (e.index = i + a), (o = l[a]).trigger("add", o, this, e);
                  (g || x) && this.trigger("sort", this, e), (l.length || u.length || c.length) && (e.changes = {
                    added: l,
                    removed: u,
                    merged: c
                  }, this.trigger("update", this, e));
                }
                return r ? t[0] : t;
              }
            },
            reset: function reset(t, e) {
              e = e ? n.clone(e) : {};
              for (var r = 0; r < this.models.length; r++) this._removeReference(this.models[r], e);
              return e.previousModels = this.models, this._reset(), t = this.add(t, n.extend({
                silent: !0
              }, e)), e.silent || this.trigger("reset", this, e), t;
            },
            push: function push(t, e) {
              return this.add(t, n.extend({
                at: this.length
              }, e));
            },
            pop: function pop(t) {
              var e = this.at(this.length - 1);
              return this.remove(e, t);
            },
            unshift: function unshift(t, e) {
              return this.add(t, n.extend({
                at: 0
              }, e));
            },
            shift: function shift(t) {
              var e = this.at(0);
              return this.remove(e, t);
            },
            slice: function slice() {
              return o.apply(this.models, arguments);
            },
            get: function get(t) {
              if (null != t) return this._byId[t] || this._byId[this.modelId(t.attributes || t)] || t.cid && this._byId[t.cid];
            },
            has: function has(t) {
              return null != this.get(t);
            },
            at: function at(t) {
              return t < 0 && (t += this.length), this.models[t];
            },
            where: function where(t, e) {
              return this[e ? "find" : "filter"](t);
            },
            findWhere: function findWhere(t) {
              return this.where(t, !0);
            },
            sort: function sort(t) {
              var e = this.comparator;
              if (!e) throw new Error("Cannot sort a set without a comparator");
              t || (t = {});
              var r = e.length;
              return n.isFunction(e) && (e = n.bind(e, this)), 1 === r || n.isString(e) ? this.models = this.sortBy(e) : this.models.sort(e), t.silent || this.trigger("sort", this, t), this;
            },
            pluck: function pluck(t) {
              return this.map(t + "");
            },
            fetch: function fetch(t) {
              var e = (t = n.extend({
                  parse: !0
                }, t)).success,
                r = this;
              return t.success = function (n) {
                var i = t.reset ? "reset" : "set";
                r[i](n, t), e && e.call(t.context, r, n, t), r.trigger("sync", r, n, t);
              }, F(this, t), this.sync("read", this, t);
            },
            create: function create(t, e) {
              var r = (e = e ? n.clone(e) : {}).wait;
              if (!(t = this._prepareModel(t, e))) return !1;
              r || this.add(t, e);
              var i = this,
                o = e.success;
              return e.success = function (t, e, n) {
                r && i.add(t, n), o && o.call(n.context, t, e, n);
              }, t.save(null, e), t;
            },
            parse: function parse(t, e) {
              return t;
            },
            clone: function clone() {
              return new this.constructor(this.models, {
                model: this.model,
                comparator: this.comparator
              });
            },
            modelId: function modelId(t) {
              return t[this.model.prototype.idAttribute || "id"];
            },
            _reset: function _reset() {
              this.length = 0, this.models = [], this._byId = {};
            },
            _prepareModel: function _prepareModel(t, e) {
              if (this._isModel(t)) return t.collection || (t.collection = this), t;
              (e = e ? n.clone(e) : {}).collection = this;
              var r = new this.model(t, e);
              return r.validationError ? (this.trigger("invalid", this, r.validationError, e), !1) : r;
            },
            _removeModels: function _removeModels(t, e) {
              for (var n = [], r = 0; r < t.length; r++) {
                var i = this.get(t[r]);
                if (i) {
                  var o = this.indexOf(i);
                  this.models.splice(o, 1), this.length--, delete this._byId[i.cid];
                  var a = this.modelId(i.attributes);
                  null != a && delete this._byId[a], e.silent || (e.index = o, i.trigger("remove", i, this, e)), n.push(i), this._removeReference(i, e);
                }
              }
              return n;
            },
            _isModel: function _isModel(t) {
              return t instanceof b;
            },
            _addReference: function _addReference(t, e) {
              this._byId[t.cid] = t;
              var n = this.modelId(t.attributes);
              null != n && (this._byId[n] = t), t.on("all", this._onModelEvent, this);
            },
            _removeReference: function _removeReference(t, e) {
              delete this._byId[t.cid];
              var n = this.modelId(t.attributes);
              null != n && delete this._byId[n], this === t.collection && delete t.collection, t.off("all", this._onModelEvent, this);
            },
            _onModelEvent: function _onModelEvent(t, e, n, r) {
              if (e) {
                if (("add" === t || "remove" === t) && n !== this) return;
                if ("destroy" === t && this.remove(e, r), "change" === t) {
                  var i = this.modelId(e.previousAttributes()),
                    o = this.modelId(e.attributes);
                  i !== o && (null != i && delete this._byId[i], null != o && (this._byId[o] = e));
                }
              }
              this.trigger.apply(this, arguments);
            }
          }), a(y, {
            forEach: 3,
            each: 3,
            map: 3,
            collect: 3,
            reduce: 0,
            foldl: 0,
            inject: 0,
            reduceRight: 0,
            foldr: 0,
            find: 3,
            detect: 3,
            filter: 3,
            select: 3,
            reject: 3,
            every: 3,
            all: 3,
            some: 3,
            any: 3,
            include: 3,
            includes: 3,
            contains: 3,
            invoke: 0,
            max: 3,
            min: 3,
            toArray: 1,
            size: 1,
            first: 3,
            head: 3,
            take: 3,
            initial: 3,
            rest: 3,
            tail: 3,
            drop: 3,
            last: 3,
            without: 0,
            difference: 0,
            indexOf: 3,
            shuffle: 1,
            lastIndexOf: 3,
            isEmpty: 1,
            chain: 1,
            sample: 3,
            partition: 3,
            groupBy: 3,
            countBy: 3,
            sortBy: 3,
            indexBy: 3,
            findIndex: 3,
            findLastIndex: 3
          }, "models");
          var C = e.View = function (t) {
              this.cid = n.uniqueId("view"), n.extend(this, n.pick(t, k)), this._ensureElement(), this.initialize.apply(this, arguments);
            },
            S = /^(\S+)\s*(.*)$/,
            k = ["model", "collection", "el", "id", "attributes", "className", "tagName", "events"];
          n.extend(C.prototype, c, {
            tagName: "div",
            $: function $(t) {
              return this.$el.find(t);
            },
            initialize: function initialize() {},
            render: function render() {
              return this;
            },
            remove: function remove() {
              return this._removeElement(), this.stopListening(), this;
            },
            _removeElement: function _removeElement() {
              this.$el.remove();
            },
            setElement: function setElement(t) {
              return this.undelegateEvents(), this._setElement(t), this.delegateEvents(), this;
            },
            _setElement: function _setElement(t) {
              this.$el = t instanceof e.$ ? t : e.$(t), this.el = this.$el[0];
            },
            delegateEvents: function delegateEvents(t) {
              if (t || (t = n.result(this, "events")), !t) return this;
              for (var e in this.undelegateEvents(), t) {
                var r = t[e];
                if (n.isFunction(r) || (r = this[r]), r) {
                  var i = e.match(S);
                  this.delegate(i[1], i[2], n.bind(r, this));
                }
              }
              return this;
            },
            delegate: function delegate(t, e, n) {
              return this.$el.on(t + ".delegateEvents" + this.cid, e, n), this;
            },
            undelegateEvents: function undelegateEvents() {
              return this.$el && this.$el.off(".delegateEvents" + this.cid), this;
            },
            undelegate: function undelegate(t, e, n) {
              return this.$el.off(t + ".delegateEvents" + this.cid, e, n), this;
            },
            _createElement: function _createElement(t) {
              return document.createElement(t);
            },
            _ensureElement: function _ensureElement() {
              if (this.el) this.setElement(n.result(this, "el"));else {
                var t = n.extend({}, n.result(this, "attributes"));
                this.id && (t.id = n.result(this, "id")), this.className && (t.class = n.result(this, "className")), this.setElement(this._createElement(n.result(this, "tagName"))), this._setAttributes(t);
              }
            },
            _setAttributes: function _setAttributes(t) {
              this.$el.attr(t);
            }
          }), e.sync = function (t, r, i) {
            var o = j[t];
            n.defaults(i || (i = {}), {
              emulateHTTP: e.emulateHTTP,
              emulateJSON: e.emulateJSON
            });
            var a = {
              type: o,
              dataType: "json"
            };
            if (i.url || (a.url = n.result(r, "url") || I()), null != i.data || !r || "create" !== t && "update" !== t && "patch" !== t || (a.contentType = "application/json", a.data = JSON.stringify(i.attrs || r.toJSON(i))), i.emulateJSON && (a.contentType = "application/x-www-form-urlencoded", a.data = a.data ? {
              model: a.data
            } : {}), i.emulateHTTP && ("PUT" === o || "DELETE" === o || "PATCH" === o)) {
              a.type = "POST", i.emulateJSON && (a.data._method = o);
              var s = i.beforeSend;
              i.beforeSend = function (t) {
                if (t.setRequestHeader("X-HTTP-Method-Override", o), s) return s.apply(this, arguments);
              };
            }
            "GET" === a.type || i.emulateJSON || (a.processData = !1);
            var l = i.error;
            i.error = function (t, e, n) {
              i.textStatus = e, i.errorThrown = n, l && l.call(i.context, t, e, n);
            };
            var c = i.xhr = e.ajax(n.extend(a, i));
            return r.trigger("request", r, c, i), c;
          };
          var j = {
            create: "POST",
            update: "PUT",
            patch: "PATCH",
            delete: "DELETE",
            read: "GET"
          };
          e.ajax = function () {
            return e.$.ajax.apply(e.$, arguments);
          };
          var T = e.Router = function (t) {
              t || (t = {}), t.routes && (this.routes = t.routes), this._bindRoutes(), this.initialize.apply(this, arguments);
            },
            P = /\((.*?)\)/g,
            E = /(\(\?)?:\w+/g,
            D = /\*\w+/g,
            M = /[\-{}\[\]+?.,\\\^$|#\s]/g;
          n.extend(T.prototype, c, {
            initialize: function initialize() {},
            route: function route(t, r, i) {
              n.isRegExp(t) || (t = this._routeToRegExp(t)), n.isFunction(r) && (i = r, r = ""), i || (i = this[r]);
              var o = this;
              return e.history.route(t, function (n) {
                var a = o._extractParameters(t, n);
                !1 !== o.execute(i, a, r) && (o.trigger.apply(o, ["route:" + r].concat(a)), o.trigger("route", r, a), e.history.trigger("route", o, r, a));
              }), this;
            },
            execute: function execute(t, e, n) {
              t && t.apply(this, e);
            },
            navigate: function navigate(t, n) {
              return e.history.navigate(t, n), this;
            },
            _bindRoutes: function _bindRoutes() {
              if (this.routes) {
                this.routes = n.result(this, "routes");
                for (var t, e = n.keys(this.routes); null != (t = e.pop());) this.route(t, this.routes[t]);
              }
            },
            _routeToRegExp: function _routeToRegExp(t) {
              return t = t.replace(M, "\\$&").replace(P, "(?:$1)?").replace(E, function (t, e) {
                return e ? t : "([^/?]+)";
              }).replace(D, "([^?]*?)"), new RegExp("^" + t + "(?:\\?([\\s\\S]*))?$");
            },
            _extractParameters: function _extractParameters(t, e) {
              var r = t.exec(e).slice(1);
              return n.map(r, function (t, e) {
                return e === r.length - 1 ? t || null : t ? decodeURIComponent(t) : null;
              });
            }
          });
          var A = e.History = function () {
              this.handlers = [], this.checkUrl = n.bind(this.checkUrl, this), "undefined" != typeof window && (this.location = window.location, this.history = window.history);
            },
            L = /^[#\/]|\s+$/g,
            N = /^\/+|\/+$/g,
            _ = /#.*$/;
          A.started = !1, n.extend(A.prototype, c, {
            interval: 50,
            atRoot: function atRoot() {
              return this.location.pathname.replace(/[^\/]$/, "$&/") === this.root && !this.getSearch();
            },
            matchRoot: function matchRoot() {
              return this.decodeFragment(this.location.pathname).slice(0, this.root.length - 1) + "/" === this.root;
            },
            decodeFragment: function decodeFragment(t) {
              return decodeURI(t.replace(/%25/g, "%2525"));
            },
            getSearch: function getSearch() {
              var t = this.location.href.replace(/#.*/, "").match(/\?.+/);
              return t ? t[0] : "";
            },
            getHash: function getHash(t) {
              var e = (t || this).location.href.match(/#(.*)$/);
              return e ? e[1] : "";
            },
            getPath: function getPath() {
              var t = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
              return "/" === t.charAt(0) ? t.slice(1) : t;
            },
            getFragment: function getFragment(t) {
              return null == t && (t = this._usePushState || !this._wantsHashChange ? this.getPath() : this.getHash()), t.replace(L, "");
            },
            start: function start(t) {
              if (A.started) throw new Error("Backbone.history has already been started");
              if (A.started = !0, this.options = n.extend({
                root: "/"
              }, this.options, t), this.root = this.options.root, this._wantsHashChange = !1 !== this.options.hashChange, this._hasHashChange = "onhashchange" in window && (void 0 === document.documentMode || document.documentMode > 7), this._useHashChange = this._wantsHashChange && this._hasHashChange, this._wantsPushState = !!this.options.pushState, this._hasPushState = !(!this.history || !this.history.pushState), this._usePushState = this._wantsPushState && this._hasPushState, this.fragment = this.getFragment(), this.root = ("/" + this.root + "/").replace(N, "/"), this._wantsHashChange && this._wantsPushState) {
                if (!this._hasPushState && !this.atRoot()) {
                  var e = this.root.slice(0, -1) || "/";
                  return this.location.replace(e + "#" + this.getPath()), !0;
                }
                this._hasPushState && this.atRoot() && this.navigate(this.getHash(), {
                  replace: !0
                });
              }
              if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
                this.iframe = document.createElement("iframe"), this.iframe.src = "javascript:0", this.iframe.style.display = "none", this.iframe.tabIndex = -1;
                var r = document.body,
                  i = r.insertBefore(this.iframe, r.firstChild).contentWindow;
                i.document.open(), i.document.close(), i.location.hash = "#" + this.fragment;
              }
              var o = window.addEventListener || function (t, e) {
                return attachEvent("on" + t, e);
              };
              if (this._usePushState ? o("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe ? o("hashchange", this.checkUrl, !1) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)), !this.options.silent) return this.loadUrl();
            },
            stop: function stop() {
              var t = window.removeEventListener || function (t, e) {
                return detachEvent("on" + t, e);
              };
              this._usePushState ? t("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe && t("hashchange", this.checkUrl, !1), this.iframe && (document.body.removeChild(this.iframe), this.iframe = null), this._checkUrlInterval && clearInterval(this._checkUrlInterval), A.started = !1;
            },
            route: function route(t, e) {
              this.handlers.unshift({
                route: t,
                callback: e
              });
            },
            checkUrl: function checkUrl(t) {
              var e = this.getFragment();
              if (e === this.fragment && this.iframe && (e = this.getHash(this.iframe.contentWindow)), e === this.fragment) return !1;
              this.iframe && this.navigate(e), this.loadUrl();
            },
            loadUrl: function loadUrl(t) {
              return !!this.matchRoot() && (t = this.fragment = this.getFragment(t), n.some(this.handlers, function (e) {
                if (e.route.test(t)) return e.callback(t), !0;
              }));
            },
            navigate: function navigate(t, e) {
              if (!A.started) return !1;
              e && !0 !== e || (e = {
                trigger: !!e
              }), t = this.getFragment(t || "");
              var n = this.root;
              "" !== t && "?" !== t.charAt(0) || (n = n.slice(0, -1) || "/");
              var r = n + t;
              if (t = this.decodeFragment(t.replace(_, "")), this.fragment !== t) {
                if (this.fragment = t, this._usePushState) this.history[e.replace ? "replaceState" : "pushState"]({}, document.title, r);else {
                  if (!this._wantsHashChange) return this.location.assign(r);
                  if (this._updateHash(this.location, t, e.replace), this.iframe && t !== this.getHash(this.iframe.contentWindow)) {
                    var i = this.iframe.contentWindow;
                    e.replace || (i.document.open(), i.document.close()), this._updateHash(i.location, t, e.replace);
                  }
                }
                return e.trigger ? this.loadUrl(t) : void 0;
              }
            },
            _updateHash: function _updateHash(t, e, n) {
              if (n) {
                var r = t.href.replace(/(javascript:|#).*$/, "");
                t.replace(r + "#" + e);
              } else t.hash = "#" + e;
            }
          }), e.history = new A(), b.extend = y.extend = T.extend = C.extend = A.extend = function (t, e) {
            var r,
              i = this;
            return r = t && n.has(t, "constructor") ? t.constructor : function () {
              return i.apply(this, arguments);
            }, n.extend(r, i, e), r.prototype = n.create(i.prototype, t), r.prototype.constructor = r, r.__super__ = i.prototype, r;
          };
          var I = function I() {
              throw new Error('A "url" property or function must be specified');
            },
            F = function F(t, e) {
              var n = e.error;
              e.error = function (r) {
                n && n.call(e.context, t, r, e), t.trigger("error", t, r, e);
              };
            };
          return e;
        }(a, n, t, e);
      }.apply(e, i)) || (t.exports = o);
    }).call(this, n(26));
  }, function (t, e, n) {
    var r = n(42);
    t.exports = function (t, e, n) {
      return (e = r(e)) in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "p", function () {
      return x;
    }), n.d(e, "u", function () {
      return h;
    }), n.d(e, "t", function () {
      return f;
    }), n.d(e, "k", function () {
      return b;
    }), n.d(e, "r", function () {
      return c;
    }), n.d(e, "g", function () {
      return O;
    }), n.d(e, "d", function () {
      return C;
    }), n.d(e, "b", function () {
      return v;
    }), n.d(e, "q", function () {
      return w;
    }), n.d(e, "f", function () {
      return j;
    }), n.d(e, "m", function () {
      return T;
    }), n.d(e, "e", function () {
      return y;
    }), n.d(e, "w", function () {
      return d;
    }), n.d(e, "s", function () {
      return m;
    }), n.d(e, "h", function () {
      return S;
    }), n.d(e, "i", function () {
      return p;
    }), n.d(e, "c", function () {
      return E;
    }), n.d(e, "j", function () {
      return A;
    }), n.d(e, "v", function () {
      return L;
    }), n.d(e, "a", function () {
      return u;
    }), n.d(e, "n", function () {
      return P;
    }), n.d(e, "l", function () {
      return D;
    }), n.d(e, "o", function () {
      return M;
    });
    var r = n(8),
      i = n.n(r),
      o = n(9),
      a = n.n(o),
      s = n(0),
      l = window.Element.prototype,
      c = l.matches || l.webkitMatchesSelector || l.mozMatchesSelector || l.msMatchesSelector,
      u = function t(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = Object(s.isArray)(e) ? a()(e) : [e];
        if (r.length) {
          var i = r.shift();
          if (i && (!n.unique || !document.querySelector('link[href="'.concat(i, '"]')))) {
            var o = document,
              l = o.head,
              c = document.createElement("link");
            c.href = i, c.rel = "stylesheet", n.prepand ? l.insertBefore(c, l.firstChild) : l.appendChild(c);
          }
          t(r);
        }
      },
      d = function d(t, e) {
        var n = {},
          r = Object(s.keys)(e);
        for (var i in t) if (t.hasOwnProperty(i)) {
          var o = t[i],
            a = e[i];
          r.indexOf(i) >= 0 ? o !== a && (n[i] = a) : n[i] = null;
        }
        for (var l in e) e.hasOwnProperty(l) && Object(s.isUndefined)(t[l]) && (n[l] = e[l]);
        return n;
      },
      h = function h(t, e, n) {
        e = e.split(/\s+/), t = t instanceof Array ? t : [t];
        for (var r = function r(_r3) {
            t.forEach(function (t) {
              return t.addEventListener(e[_r3], n);
            });
          }, i = 0; i < e.length; ++i) r(i);
      },
      f = function f(t, e, n) {
        e = e.split(/\s+/), t = t instanceof Array ? t : [t];
        for (var r = function r(_r4) {
            t.forEach(function (t) {
              return t.removeEventListener(e[_r4], n);
            });
          }, i = 0; i < e.length; ++i) r(i);
      },
      p = function p(t) {
        return t.replace(parseFloat(t), "");
      },
      g = function g(t) {
        return t[0].toUpperCase() + t.toLowerCase().slice(1);
      },
      v = function v(t) {
        var e = t.split("-").filter(String);
        return e[0].toLowerCase() + e.slice(1).map(g);
      },
      m = function m(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
          r = 0;
        if (isNaN(t)) return n;
        if (t = parseFloat(t), Math.floor(t) !== t) {
          var i = e.toString().split(".")[1];
          r = i ? i.length : 0;
        }
        return r ? parseFloat(t.toFixed(r)) : t;
      },
      b = function b(t) {
        return "draggable" in document.createElement("i") && (t ? t.get("Config").nativeDnD : 1);
      },
      y = function y(t) {
        return Object(s.isElement)(t) || w(t) ? t : t && t.getEl ? t.getEl() : void 0;
      },
      w = function w(t) {
        return t && 3 === t.nodeType;
      },
      x = function x(t) {
        return t && !w(t) && !function (t) {
          return t && 8 === t.nodeType;
        }(t);
      },
      O = function O(t, e) {
        var n = t;
        return Object(s.isElement)(t) && (n = e(t).data("model")), n;
      },
      C = function C(t) {
        var e,
          n = {
            top: 0,
            left: 0,
            width: 0,
            height: 0
          };
        if (!t) return n;
        if (w(t)) {
          var r = document.createRange();
          r.selectNode(t), e = r.getBoundingClientRect(), r.detach();
        }
        return e || (t.getBoundingClientRect ? t.getBoundingClientRect() : n);
      },
      S = function S(t) {
        return t.touches && t.touches[0] ? t.touches[0] : t;
      },
      k = function k(t) {
        return t.which || t.keyCode;
      },
      j = function j(t) {
        return String.fromCharCode(k(t));
      },
      T = function T(t) {
        return 27 === k(t);
      },
      P = function P(t) {
        return null !== t && !Array.isArray(t) && "object" === i()(t);
      },
      E = function E(t) {
        return t && t.charAt(0).toUpperCase() + t.substring(1);
      },
      D = function D(t) {
        return t && t.toHTML;
      },
      M = function M(t) {
        return t && t.toCSS;
      },
      A = function A(t) {
        return t.__gjsv;
      },
      L = function L(t, e) {
        t.__gjsv = e;
      };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      n.d(e, "e", function () {
        return r;
      }), n.d(e, "p", function () {
        return i;
      }), n.d(e, "a", function () {
        return o;
      }), n.d(e, "c", function () {
        return a;
      }), n.d(e, "d", function () {
        return s;
      }), n.d(e, "o", function () {
        return l;
      }), n.d(e, "q", function () {
        return c;
      }), n.d(e, "t", function () {
        return u;
      }), n.d(e, "i", function () {
        return d;
      }), n.d(e, "r", function () {
        return h;
      }), n.d(e, "s", function () {
        return f;
      }), n.d(e, "k", function () {
        return p;
      }), n.d(e, "m", function () {
        return g;
      }), n.d(e, "j", function () {
        return v;
      }), n.d(e, "l", function () {
        return m;
      }), n.d(e, "g", function () {
        return b;
      }), n.d(e, "f", function () {
        return y;
      }), n.d(e, "h", function () {
        return w;
      }), n.d(e, "n", function () {
        return x;
      }), n.d(e, "b", function () {
        return O;
      });
      var r = "1.13.6",
        i = "object" == typeof self && self.self === self && self || "object" == typeof t && t.global === t && t || Function("return this")() || {},
        o = Array.prototype,
        a = Object.prototype,
        s = "undefined" != typeof Symbol ? Symbol.prototype : null,
        l = o.push,
        c = o.slice,
        u = a.toString,
        d = a.hasOwnProperty,
        h = "undefined" != typeof ArrayBuffer,
        f = "undefined" != typeof DataView,
        p = Array.isArray,
        g = Object.keys,
        v = Object.create,
        m = h && ArrayBuffer.isView,
        b = isNaN,
        y = isFinite,
        w = !{
          toString: null
        }.propertyIsEnumerable("toString"),
        x = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
        O = Math.pow(2, 53) - 1;
    }).call(this, n(26));
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "eventDrag", function () {
      return O;
    });
    var r = n(8),
      i = n.n(r),
      o = n(2),
      a = n.n(o),
      s = n(0),
      l = n(3),
      c = n(23),
      u = n(1),
      d = n.n(u),
      h = n(21),
      f = n(10),
      p = n(12);
    function g(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function v(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? g(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : g(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var m = d.a.Model.extend({
        defaults: {
          type: "text",
          label: "",
          name: "",
          min: "",
          max: "",
          unit: "",
          step: 1,
          value: "",
          target: "",
          default: "",
          placeholder: "",
          changeProp: 0,
          options: [],
          title: "",
          info: "",
          infoStyle: ""
        },
        initialize: function initialize() {
          var t = this.get("target"),
            e = this.get("name"),
            n = this.get("changeProp");
          if (t) {
            this.target = t, this.unset("target");
            var r = n ? "change:".concat(e) : "change:attributes:".concat(e);
            this.listenTo(t, r, this.targetUpdated);
          }
        },
        props: function props() {
          return this.attributes;
        },
        targetUpdated: function targetUpdated() {
          var t = this.getTargetValue();
          this.set({
            value: t
          }, {
            fromTarget: 1
          });
        },
        getTargetValue: function getTargetValue() {
          var t,
            e = this.get("name"),
            n = this.target;
          return t = this.get("changeProp") ? n.get(e) : n.getAttributes()[e], Object(s.isUndefined)(t) ? "" : t;
        },
        setTargetValue: function setTargetValue(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.target,
            r = this.get("name");
          if (!Object(s.isUndefined)(t)) {
            var i = t;
            if ("false" === t ? i = !1 : "true" === t && (i = !0), this.get("changeProp")) n.set(r, i, e);else {
              var o = v({}, n.get("attributes"));
              o[r] = i, n.set("attributes", o, e);
            }
          }
        },
        setValueFromInput: function setValueFromInput(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = {
              value: t
            };
          this.set(r, v(v({}, n), {}, {
            avoidStore: 1
          })), e && (this.set("value", "", n), this.set(r, n));
        },
        getInitValue: function getInitValue() {
          var t,
            e = this.target,
            n = this.get("name");
          if (e) {
            var r = e.get("attributes");
            t = this.get("changeProp") ? e.get(n) : r[n];
          }
          return t || this.get("value") || this.get("default");
        }
      }),
      b = d.a.Collection.extend({
        model: m,
        initialize: function initialize(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.em = e.em || "", this.listenTo(this, "add", this.handleAdd), this.listenTo(this, "reset", this.handleReset);
        },
        handleReset: function handleReset(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = e.previousModels,
            r = void 0 === n ? [] : n;
          r.forEach(function (t) {
            return t.trigger("remove");
          });
        },
        handleAdd: function handleAdd(t) {
          var e = this.target;
          e && (t.target = e);
        },
        setTarget: function setTarget(t) {
          this.target = t;
        },
        add: function add(t, e) {
          var n = this.em;
          if (Object(s.isString)(t) || Object(s.isArray)(t)) {
            var r = n && n.get && n.get("TraitManager"),
              i = function () {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return {
                  build: function build(e) {
                    var n = [];
                    "string" == typeof e && (e = [e]);
                    for (var r = 0; r < e.length; r++) {
                      var i = {},
                        o = e[r];
                      switch (i.name = o, o) {
                        case "target":
                          i.type = "select", i.default = !1, i.options = t.optionsTarget;
                      }
                      n.push(i);
                    }
                    return n;
                  }
                };
              }(r && r.getConfig());
            Object(s.isString)(t) && (t = [t]);
            for (var o = 0, a = t.length; o < a; o++) {
              var l = t[o],
                c = Object(s.isString)(l) ? i.build(l)[0] : l;
              c.target = this.target, t[o] = c;
            }
          }
          return d.a.Collection.prototype.add.apply(this, [t, e]);
        }
      });
    function y(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function w(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? y(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var x = function x(t) {
        return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
      },
      O = "component:drag",
      C = d.a.Model.extend(c.a).extend({
        defaults: {
          tagName: "div",
          type: "",
          name: "",
          removable: !0,
          draggable: !0,
          droppable: !0,
          badgable: !0,
          stylable: !0,
          "stylable-require": "",
          "style-signature": "",
          unstylable: "",
          highlightable: !0,
          copyable: !0,
          resizable: !1,
          editable: !1,
          layerable: !0,
          selectable: !0,
          hoverable: !0,
          void: !1,
          state: "",
          status: "",
          content: "",
          icon: "",
          style: "",
          classes: "",
          script: "",
          "script-export": "",
          attributes: "",
          traits: ["id", "title"],
          propagate: "",
          dmode: "",
          toolbar: null
        },
        init: function init() {},
        updated: function updated(t, e, n) {},
        removed: function removed() {},
        initialize: function initialize() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = n.em,
            i = this.parent(),
            o = i && i.attributes;
          if (o && o.propagate) {
            var a = {},
              l = o.propagate;
            l.forEach(function (t) {
              return a[t] = i.get(t);
            }), a.propagate = l, a = w(w({}, a), e), this.set(a);
          }
          var c = this.get("propagate");
          c && this.set("propagate", Object(s.isArray)(c) ? c : [c]), n && n.config && n.config.voidElements.indexOf(this.get("tagName")) >= 0 && this.set("void", !0), n.em = r, this.opt = n, this.em = r, this.frame = n.frame, this.config = n.config || {}, this.set("attributes", w(w({}, this.defaults.attributes || {}), this.get("attributes") || {})), this.ccid = C.createId(this), this.initClasses(), this.initTraits(), this.initComponents(), this.initToolbar(), this.listenTo(this, "change:script", this.scriptUpdated), this.listenTo(this, "change:tagName", this.tagUpdated), this.listenTo(this, "change:attributes", this.attrUpdated), this.listenTo(this, "change:attributes:id", this._idUpdated), this.set("status", ""), this.views = [], ["classes", "traits", "components"].forEach(function (e) {
            var n = "add remove ".concat("components" !== e ? "change" : "");
            t.listenTo(t.get(e), n.trim(), function () {
              for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
              return t.emitUpdate.apply(t, [e].concat(r));
            });
          }), n.temporary || (this.init(), r && r.trigger("component:create", this));
        },
        is: function is(t) {
          return !(this.get("type") != t);
        },
        props: function props() {
          return this.attributes;
        },
        index: function index() {
          var t = this.collection;
          return t && t.indexOf(this);
        },
        setDragMode: function setDragMode(t) {
          return this.set("dmode", t);
        },
        find: function find(t) {
          var e = [],
            n = this.view.$el.find(t);
          return n.each(function (t) {
            var r = n.eq(t).data("model");
            r && e.push(r);
          }), e;
        },
        findType: function findType(t) {
          var e = [];
          return function n(r) {
            return r.forEach(function (r) {
              r.is(t) && e.push(r), n(r.components());
            });
          }(this.components()), e;
        },
        closest: function closest(t) {
          var e = this.view.$el.closest(t);
          return e.length && e.data("model");
        },
        closestType: function closestType(t) {
          for (var e = this.parent(); e && !e.is(t);) e = e.parent();
          return e;
        },
        tagUpdated: function tagUpdated() {
          var t = this.collection,
            e = t.indexOf(this);
          t.remove(this), t.add(this, {
            at: e
          });
        },
        replaceWith: function replaceWith(t) {
          var e = this.collection,
            n = e.indexOf(this);
          return e.remove(this), e.add(t, {
            at: n
          });
        },
        attrUpdated: function attrUpdated(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = this.get("attributes"),
            o = i.class;
          o && this.setClass(o), delete i.class;
          var a = i.style;
          a && this.setStyle(a), delete i.style;
          var c = w({}, this.previous("attributes")),
            u = Object(l.w)(c, this.get("attributes"));
          Object(s.keys)(u).forEach(function (t) {
            return n.trigger("change:attributes:".concat(t), n, u[t], r);
          });
        },
        setAttributes: function setAttributes(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return this.set("attributes", w({}, t), e), this;
        },
        addAttributes: function addAttributes(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = w(w({}, this.getAttributes()), t);
          return this.setAttributes(n, e), this;
        },
        getStyle: function getStyle() {
          var t = this.em;
          if (t && t.getConfig("avoidInlineStyle")) {
            var e = t.get("state"),
              n = t.get("CssComposer").getIdRule(this.getId(), {
                state: e
              });
            if (this.rule = n, n) return n.getStyle();
          }
          return c.a.getStyle.call(this);
        },
        setStyle: function setStyle() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = this.em,
            i = this.opt;
          if (r && r.getConfig("avoidInlineStyle") && !i.temporary) {
            var o = this.get("style") || {};
            e = w(w({}, e = Object(s.isString)(e) ? this.parseStyle(e) : e), o);
            var a = r.get("state"),
              u = r.get("CssComposer"),
              d = this.getStyle();
            this.rule = u.setIdRule(this.getId(), e, w(w({}, n), {}, {
              state: a
            }));
            var h = Object(l.w)(d, e);
            this.set("style", {}, {
              silent: 1
            }), Object(s.keys)(h).forEach(function (e) {
              return t.trigger("change:style:".concat(e));
            });
          } else e = c.a.setStyle.apply(this, arguments);
          return e;
        },
        getAttributes: function getAttributes() {
          var t,
            e = this.em,
            n = [],
            r = w({}, this.get("attributes")),
            i = e && e.get("SelectorManager"),
            o = this.getId();
          (this.get("classes").forEach(function (t) {
            return n.push(Object(s.isString)(t) ? t : t.get("name"));
          }), n.length && (r.class = n.join(" ")), Object(s.has)(r, "id")) || (!function (t) {
            return t && t.getConfig("avoidInlineStyle");
          }(e) ? Object(s.isEmpty)(this.getStyle()) || (t = 1) : t = i && i.get(o, i.Selector.TYPE_ID), t && (r.id = this.getId()));
          return r;
        },
        addClass: function addClass(t) {
          var e = this.em.get("SelectorManager").addClass(t);
          return this.get("classes").add(e);
        },
        setClass: function setClass(t) {
          return this.get("classes").reset(), this.addClass(t);
        },
        removeClass: function removeClass(t) {
          var e = [];
          t = Object(s.isArray)(t) ? t : [t];
          var n = this.get("classes"),
            r = f.a.TYPE_CLASS;
          return t.forEach(function (t) {
            t.split(" ").forEach(function (t) {
              var i = n.where({
                name: t,
                type: r
              })[0];
              i && e.push(n.remove(i));
            });
          }), e;
        },
        getClasses: function getClasses() {
          var t = this.getAttributes().class;
          return t ? t.split(" ") : [];
        },
        initClasses: function initClasses() {
          var t = this.get("attributes").class || [],
            e = [this, "change:classes", this.initClasses],
            n = this.get("classes") || t,
            r = Object(s.isString)(n) ? n.split(" ") : n;
          this.stopListening.apply(this, e);
          var i = this.normalizeClasses(r),
            o = new p.a([]);
          return this.set("classes", o), o.add(i), this.listenTo.apply(this, e), this;
        },
        initComponents: function initComponents() {
          var t = [this, "change:components", this.initComponents];
          this.stopListening.apply(this, t);
          var e = new h.a(null, this.opt);
          e.parent = this;
          var n = this.get("components"),
            r = !this.opt.avoidChildren;
          return this.set("components", e), r && e.add(Object(s.isFunction)(n) ? n(this) : n), this.listenTo.apply(this, t), this;
        },
        initTraits: function initTraits(t) {
          var e = this.em,
            n = [this, "change:traits", this.initTraits];
          this.stopListening.apply(this, n), this.loadTraits();
          var r = w({}, this.get("attributes")),
            i = this.get("traits");
          return i.each(function (t) {
            if (!t.get("changeProp")) {
              var e = t.get("name"),
                n = t.getInitValue();
              e && n && (r[e] = n);
            }
          }), i.length && this.set("attributes", r), this.listenTo.apply(this, n), t && e && e.trigger("component:toggled"), this;
        },
        append: function append(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.components().add(t, e);
          return Object(s.isArray)(n) ? n : [n];
        },
        components: function components(t) {
          var e = this.get("components");
          return Object(s.isUndefined)(t) ? e : (e.reset(), t && this.append(t));
        },
        empty: function empty() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.components().reset(null, t), this;
        },
        parent: function parent() {
          var t = this.collection;
          return t && t.parent;
        },
        scriptUpdated: function scriptUpdated() {
          this.set("scriptUpdated", 1);
        },
        initToolbar: function initToolbar() {
          var t = this.em,
            e = t && t.getConfig("stylePrefix") || "";
          if (!this.get("toolbar")) {
            var n = [];
            this.collection && n.push({
              attributes: {
                class: "fa fa-arrow-up"
              },
              command: function command(t) {
                return t.runCommand("core:component-exit", {
                  force: 1
                });
              }
            }), this.get("draggable") && n.push({
              attributes: {
                class: "fa fa-arrows ".concat(e, "no-touch-actions"),
                draggable: !0
              },
              command: "tlb-move"
            }), this.get("copyable") && n.push({
              attributes: {
                class: "fa fa-clone"
              },
              command: "tlb-clone"
            }), this.get("removable") && n.push({
              attributes: {
                class: "fa fa-trash-o"
              },
              command: "tlb-delete"
            }), this.get("traits").length > 0 && n.push({
              attributes: {
                class: "fa fa-cog"
              },
              command: "tlb-trait-setting"
            }), this.set("toolbar", n);
          }
        },
        loadTraits: function loadTraits(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (t = t || this.get("traits"), !((t = Object(s.isFunction)(t) ? t(this) : t) instanceof b)) {
            var n = new b([], this.opt);
            n.setTarget(this), t.length && (t.forEach(function (t) {
              return t.attributes && delete t.attributes.value;
            }), n.add(t)), this.set("traits", n, e);
          }
          return this;
        },
        getTrait: function getTrait(t) {
          return this.get("traits").filter(function (e) {
            return e.get("id") === t || e.get("name") === t;
          })[0];
        },
        updateTrait: function updateTrait(t, e) {
          var n = this.em,
            r = this.getTrait(t);
          return r && r.set(e), n && n.trigger("component:toggled"), this;
        },
        getTraitIndex: function getTraitIndex(t) {
          var e = this.getTrait(t);
          return e ? this.get("traits").indexOf(e) : e;
        },
        removeTrait: function removeTrait(t) {
          var e = this,
            n = this.em,
            r = (Object(s.isArray)(t) ? t : [t]).map(function (t) {
              return e.getTrait(t);
            }),
            i = this.get("traits").remove(r);
          return n && n.trigger("component:toggled"), i;
        },
        addTrait: function addTrait(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.em,
            r = this.get("traits").add(t, e);
          return n && n.trigger("component:toggled"), r;
        },
        normalizeClasses: function normalizeClasses(t) {
          var e = [],
            n = this.em;
          if (n) {
            var r = n.get("SelectorManager");
            if (r) return t.forEach(function (t) {
              var n = "";
              n = "string" == typeof t ? t : t.name;
              var i = r.add(n);
              e.push(i);
            }), e;
          }
        },
        clone: function clone() {
          var t = this.em,
            e = this.getStyle(),
            n = w({}, this.attributes),
            r = w({}, this.opt);
          n.attributes = w({}, n.attributes), delete n.attributes.id, n.components = [], n.classes = [], n.traits = [], this.get("components").each(function (t, e) {
            n.components[e] = t.clone();
          }), this.get("traits").each(function (t, e) {
            n.traits[e] = t.clone();
          }), this.get("classes").each(function (t, e) {
            n.classes[e] = t.get("name");
          }), n.status = "", n.view = "", r.collection = null, t && t.getConfig("avoidInlineStyle") && !Object(s.isEmpty)(e) && (n.style = e);
          var i = new this.constructor(n, r);
          return t && t.trigger("component:clone", i), this.trigger("component:clone", i), i;
        },
        getName: function getName() {
          var t = this.em,
            e = this.attributes,
            n = e.type,
            r = e.tagName,
            i = this.get("name"),
            o = "div" == r,
            a = n || (o ? "box" : r),
            s = !n && r && !o && r,
            c = "domComponents.names.",
            u = i && t && t.t("".concat(c).concat(i)),
            d = s && t && t.t("".concat(c).concat(s)),
            h = t && (t.t("".concat(c).concat(n)) || t.t("".concat(c).concat(r)));
          return this.get("custom-name") || u || i || d || Object(l.c)(s) || h || Object(l.c)(a);
        },
        getIcon: function getIcon() {
          var t = this.get("icon");
          return t ? t + " " : "";
        },
        toHTML: function toHTML() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this,
            n = [],
            r = t.tag,
            i = r || e.get("tagName"),
            o = e.get("void"),
            a = t.attributes,
            l = this.getAttrToHTML();
          for (var c in delete t.tag, a && (Object(s.isFunction)(a) ? l = a(e, l) || {} : Object(s.isObject)(a) && (l = a)), l) {
            var u = l[c],
              d = Object(s.isString)(u) ? u.replace(/"/g, "&quot;") : u;
            Object(s.isUndefined)(d) || (Object(s.isBoolean)(d) ? d && n.push(c) : n.push("".concat(c, '="').concat(d, '"')));
          }
          var h = n.length ? " ".concat(n.join(" ")) : "",
            f = "<".concat(i).concat(h).concat(o ? "/" : "", ">").concat(e.get("content"));
          return e.get("components").each(function (e) {
            return f += e.toHTML(t);
          }), !o && (f += "</".concat(i, ">")), f;
        },
        getAttrToHTML: function getAttrToHTML() {
          var t = this.getAttributes();
          return delete t.style, t;
        },
        toJSON: function toJSON() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          var r = d.a.Model.prototype.toJSON.apply(this, e);
          if (r.attributes = this.getAttributes(), delete r.attributes.class, delete r.toolbar, delete r.traits, this.em.getConfig("avoidDefaults")) {
            var i = Object(s.result)(this, "defaults");
            Object(s.forEach)(i, function (t, e) {
              -1 === ["type", "content"].indexOf(e) && r[e] === t && delete r[e];
            }), Object(s.isEmpty)(r.type) && delete r.type, Object(s.forEach)(["attributes", "style"], function (t) {
              Object(s.isEmpty)(i[t]) && Object(s.isEmpty)(r[t]) && delete r[t];
            }), Object(s.forEach)(["classes", "components"], function (t) {
              Object(s.isEmpty)(i[t]) && !r[t].length && delete r[t];
            });
          }
          return r;
        },
        getId: function getId() {
          return (this.get("attributes") || {}).id || this.ccid || this.cid;
        },
        setId: function setId(t, e) {
          var n = w({}, this.get("attributes"));
          return n.id = t, this.set("attributes", n, e), this;
        },
        getEl: function getEl(t) {
          var e = this.getView(t);
          return e && e.el;
        },
        getView: function getView(t) {
          var e = this.view,
            n = this.views;
          return t && (e = n.filter(function (e) {
            return e._getFrame() === t.view;
          })[0]), e;
        },
        getCurrentView: function getCurrentView() {
          var t = (this.em.get("currentFrame") || {}).model;
          return this.getView(t);
        },
        getScriptString: function getScriptString(t) {
          var e = this,
            n = t || this.get("script");
          if (!n) return n;
          if ("function" == typeof n) {
            var r = n.toString().trim();
            n = (r = r.replace(/^function[\s\w]*\(\)\s?\{/, "").replace(/\}$/, "")).trim();
          }
          var o = this.em.getConfig(),
            a = x(o.tagVarStart || "{[ "),
            l = x(o.tagVarEnd || " ]}"),
            c = new RegExp("".concat(a, "([\\w\\d-]*)").concat(l), "g");
          return n = n.replace(c, function (t, n) {
            e.scriptUpdated();
            var r = e.attributes[n] || "";
            return Object(s.isArray)(r) || "object" == i()(r) ? JSON.stringify(r) : r;
          });
        },
        emitUpdate: function emitUpdate(t) {
          for (var e = this.em, n = "component:update" + (t ? ":".concat(t) : ""), r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) i[o - 1] = arguments[o];
          t && this.updated.apply(this, [t, t && this.get(t), t && this.previous(t)].concat(i)), this.trigger.apply(this, [n].concat(i)), e && e.trigger.apply(e, [n, this].concat(i));
        },
        onAll: function onAll(t) {
          return Object(s.isFunction)(t) && (t(this), this.components().forEach(function (e) {
            return e.onAll(t);
          })), this;
        },
        remove: function remove() {
          var t = this.collection;
          return t && t.remove(this);
        },
        resetId: function resetId() {
          var t = this.em,
            e = this.getId();
          if (e) {
            var n = C.createId(this);
            this.setId(n);
            var r = t && t.get("CssComposer").getIdRule(e),
              i = r && r.get("selectors").at(0);
            return i && i.set("name", n), this;
          }
        },
        _getStyleRule: function _getStyleRule() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.id,
            n = this.em,
            r = e || this.getId();
          return n && n.get("CssComposer").getIdRule(r);
        },
        _getStyleSelector: function _getStyleSelector(t) {
          var e = this._getStyleRule(t);
          return e && e.get("selectors").at(0);
        },
        _idUpdated: function _idUpdated(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (!n.idUpdate) {
            var r = this.ccid,
              i = this.get("attributes") || {},
              o = i.id,
              a = (this.previous("attributes") || {}).id || r,
              s = C.getList(this);
            if (s[o]) return this.setId(a, {
              idUpdate: 1
            });
            delete s[a], s[o] = this, this.ccid = o;
            var l = this._getStyleSelector({
              id: a
            });
            l && l.set({
              name: o,
              label: o
            });
          }
        }
      }, {
        isComponent: function isComponent(t) {
          return {
            tagName: t.tagName ? t.tagName.toLowerCase() : ""
          };
        },
        ensureInList: function ensureInList(t) {
          var e = C.getList(t),
            n = t.getId(),
            r = e[n];
          if (r) {
            if (r !== t) {
              var i = C.getIncrementId(n, e);
              t.setId(i), e[i] = t;
            }
          } else e[n] = t;
          t.components().forEach(function (t) {
            return C.ensureInList(t);
          });
        },
        createId: function createId(t) {
          var e,
            n = C.getList(t),
            r = t.get("attributes").id;
          return r ? (e = C.getIncrementId(r, n), t.setId(e)) : e = C.getNewId(n), n[e] = t, e;
        },
        getNewId: function getNewId(t) {
          for (var e = Object.keys(t).length.toString().length + 2, n = (Math.random() + 1.1).toString(36).slice(-e), r = "i".concat(n); t[r];) r = C.getNewId(t);
          return r;
        },
        getIncrementId: function getIncrementId(t, e) {
          for (var n = 1, r = t; e[r];) n++, r = "".concat(t, "-").concat(n);
          return r;
        },
        getList: function getList(t) {
          var e = t.opt && t.opt.domc;
          return e ? e.componentsById : {};
        },
        checkId: function checkId(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = Object(s.isArray)(t) ? t : [t];
          r.forEach(function (t) {
            var r = t.attributes,
              i = void 0 === r ? {} : r,
              o = t.components,
              a = i.id;
            if (a && n[a]) {
              var l = C.getIncrementId(a, n);
              i.id = l, Object(s.isArray)(e) && e.forEach(function (t) {
                var e = t.selectors;
                e.forEach(function (t, n) {
                  t === "#".concat(a) && (e[n] = "#".concat(l));
                });
              });
            }
            o && C.checkId(o, e, n);
          });
        }
      });
    e.default = C;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(1),
      a = n.n(o),
      s = n(0),
      l = n(21),
      c = n(35),
      u = n(12),
      d = n(7),
      h = n(3);
    function f(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function p(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? f(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = a.a.View.extend({
      className: function className() {
        return this.getClasses();
      },
      tagName: function tagName() {
        return this.model.get("tagName");
      },
      initialize: function initialize() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = this.model,
          n = t.config || {},
          r = n.em,
          i = e.opt || {},
          o = this.$el,
          a = this.el,
          s = n.draggableComponents;
        this.opts = t, this.modelOpt = i, this.config = n, this.em = r || "", this.pfx = n.stylePrefix || "", this.ppfx = n.pStylePrefix || "", this.attr = e.get("attributes"), this.classe = this.attr.class || [], this.listenTo(e, "change:style", this.updateStyle), this.listenTo(e, "change:attributes change:_innertext", this.renderAttributes), this.listenTo(e, "change:highlightable", this.updateHighlight), this.listenTo(e, "change:status", this.updateStatus), this.listenTo(e, "change:script", this.reset), this.listenTo(e, "change:content", this.updateContent), this.listenTo(e, "change", this.handleChange), this.listenTo(e, "active", this.onActive), this.listenTo(e, "disable", this.onDisable), o.data("model", e), Object(h.v)(a, this), e.view = this, this._getFrame() && e.views.push(this), this.initClasses(), this.initComponents({
          avoidRender: 1
        }), this.events = p(p({}, this.events), s && {
          dragstart: "handleDragStart"
        }), this.delegateEvents(), !i.temporary && this.init(this._clbObj());
      },
      _clbObj: function _clbObj() {
        var t = this.em,
          e = this.model,
          n = this.el;
        return {
          editor: t && t.getEditor(),
          model: e,
          el: n
        };
      },
      init: function init() {},
      removed: function removed() {},
      onActive: function onActive() {},
      onDisable: function onDisable() {},
      remove: function remove() {
        var t = this;
        a.a.View.prototype.remove.apply(t, arguments);
        var e = t.model,
          n = t._getFrame() || {},
          r = n.model;
        e.components().forEach(function (t) {
          var e = t.getView(r);
          e && e.remove();
        });
        var i = e.views;
        return i.splice(i.indexOf(t), 1), t.removed(t._clbObj()), t.$el.data({
          model: "",
          collection: "",
          view: ""
        }), delete t.model, delete t.$el, delete t.el.__gjsv, delete t.childrenView, delete t.opts, t;
      },
      handleDragStart: function handleDragStart(t) {
        t.preventDefault(), t.stopPropagation(), this.em.get("Commands").run("tlb-move", {
          target: this.model,
          event: t
        });
      },
      initClasses: function initClasses() {
        var t = this.model,
          e = t.get("classes");
        e instanceof u.a && (this.stopListening(t, "change:classes", this.initClasses), this.listenTo(t, "change:classes", this.initClasses), this.listenTo(e, "add remove change", this.updateClasses), e.length && this.importClasses());
      },
      initComponents: function initComponents() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = this.model,
          n = this.$el,
          r = this.childrenView,
          i = "change:components",
          o = e.get("components"),
          a = [e, i, this.initComponents];
        o instanceof l.a && (n.data("collection", o), r && r.remove(), this.stopListening.apply(this, a), !t.avoidRender && this.renderChildren(), this.listenTo.apply(this, a));
      },
      handleChange: function handleChange() {
        var t = this.model,
          e = Object(s.keys)(t.changed);
        if (1 !== e.length || "status" !== e[0]) for (var n in t.emitUpdate(), t.changed) t.emitUpdate(n);
      },
      importClasses: function importClasses() {
        var t = this.config.em.get("SelectorManager");
        t && this.model.get("classes").each(function (e) {
          t.add(e.get("name"));
        });
      },
      updateStatus: function updateStatus() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = (this.em, this.el),
          n = this.model.get("status"),
          r = (this.pfx, this.ppfx),
          i = "".concat(r, "selected"),
          o = "".concat(i, "-parent"),
          a = "".concat(r, "freezed"),
          s = "".concat(r, "hovered"),
          l = [i, o, a, s];
        this.$el.removeClass(l.join(" "));
        var c = e.getAttribute("class") || "",
          u = "";
        switch (n) {
          case "selected":
            u = "".concat(c, " ").concat(i);
            break;
          case "selected-parent":
            u = "".concat(c, " ").concat(o);
            break;
          case "freezed":
            u = "".concat(c, " ").concat(a);
            break;
          case "freezed-selected":
            u = "".concat(c, " ").concat(a, " ").concat(i);
            break;
          case "hovered":
            u = t.avoidHover ? "" : "".concat(c, " ").concat(s);
        }
        (u = u.trim()) && e.setAttribute("class", u);
      },
      updateHighlight: function updateHighlight() {
        var t = this.model.get("highlightable");
        this.setAttribute("data-highlightable", t ? 1 : "");
      },
      updateStyle: function updateStyle() {
        var t = this.model,
          e = this.em,
          n = this.el;
        if (e && e.getConfig("avoidInlineStyle")) {
          t.get("_innertext") ? n.removeAttribute("id") : n.id = t.getId();
          var r = t.getStyle();
          !Object(s.isEmpty)(r) && t.setStyle(r);
        } else this.setAttribute("style", t.styleToString());
      },
      updateClasses: function updateClasses() {
        var t = this.model.get("classes").pluck("name").join(" ");
        this.setAttribute("class", t), this.updateStatus();
      },
      setAttribute: function setAttribute(t, e) {
        var n = this.$el;
        e ? n.attr(t, e) : n.removeAttr(t);
      },
      getClasses: function getClasses() {
        return this.model.getClasses().join(" ");
      },
      updateAttributes: function updateAttributes() {
        var t = [],
          e = this.model,
          n = this.$el,
          r = this.el,
          i = this.config,
          o = e.attributes,
          a = o.highlightable,
          l = o.textable,
          c = o.type,
          u = o._innertext,
          d = p(p(p({
            "data-gjs-type": c || "default"
          }, i.draggableComponents && !u ? {
            draggable: !0
          } : {}), a ? {
            "data-highlightable": 1
          } : {}), l ? {
            contenteditable: "false",
            "data-gjs-textable": "true"
          } : {});
        Object(s.each)(r.attributes, function (e) {
          return t.push(e.nodeName);
        }), t.forEach(function (t) {
          return n.removeAttr(t);
        });
        var h = p(p({}, d), e.getAttributes());
        Object(s.keys)(h).forEach(function (t) {
          return !1 === h[t] && delete h[t];
        }), n.attr(h), this.updateStyle();
      },
      updateContent: function updateContent() {
        this.getChildrenContainer().innerHTML = this.model.get("content");
      },
      prevDef: function prevDef(t) {
        t.preventDefault();
      },
      updateScript: function updateScript() {
        var t = this.model,
          e = this.em;
        t.get("script") && e && e.get("Canvas").getCanvasView().updateScript(this);
      },
      getChildrenContainer: function getChildrenContainer() {
        var t = this.el;
        return "function" == typeof this.getChildrenSelector ? t = this.el.querySelector(this.getChildrenSelector()) : this.getTemplate, t;
      },
      getOffsetRect: function getOffsetRect() {
        var t = {},
          e = this.el,
          n = 0,
          r = 0;
        return function i(o) {
          var a = o.offsetParent;
          a ? (n += a.offsetTop, r += a.offsetLeft, i(a)) : (t.top = e.offsetTop + n, t.left = e.offsetLeft + r, t.bottom = t.top + e.offsetHeight, t.right = t.left + e.offsetWidth);
        }(e), t;
      },
      isInViewport: function isInViewport() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.rect,
          n = this.el,
          r = n.ownerDocument,
          i = r.body,
          o = r.defaultView.frameElement,
          a = e || this.getOffsetRect(),
          s = a.top,
          l = a.left,
          c = this._getFrame().getOffsetRect();
        return s >= c.scrollTop && l >= c.scrollLeft && s <= c.scrollBottom && l <= o.offsetWidth + i.scrollLeft;
      },
      scrollIntoView: function scrollIntoView() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = this.getOffsetRect(),
          n = this.isInViewport({
            rect: e
          });
        if (!n || t.force) {
          var r = this.el;
          "smooth" !== t.behavior ? r.ownerDocument.defaultView.scrollTo(0, e.top) : r.scrollIntoView(p({
            behavior: "smooth",
            block: "nearest"
          }, t));
        }
      },
      reset: function reset() {
        var t = this.el;
        this.el = "", this._ensureElement(), this._setData(), Object(d.j)(t, this.el), this.render();
      },
      _setData: function _setData() {
        var t = this.model,
          e = t.components();
        this.$el.data({
          model: t,
          collection: e,
          view: this
        });
      },
      _getFrame: function _getFrame() {
        return this.config.frameView;
      },
      renderChildren: function renderChildren() {
        this.updateContent();
        var t = this.getChildrenContainer(),
          e = this.childrenView || new c.a({
            collection: this.model.get("components"),
            config: this.config,
            componentTypes: this.opts.componentTypes
          });
        e.render(t), this.childrenView = e;
        for (var n = Array.prototype.slice.call(e.el.childNodes), r = 0, i = n.length; r < i; r++) t.appendChild(n.shift());
      },
      renderAttributes: function renderAttributes() {
        this.updateAttributes(), this.updateClasses();
      },
      render: function render() {
        return this.renderAttributes(), this.modelOpt.temporary || (this.renderChildren(), this.updateScript(), Object(h.v)(this.el, this), this.postRender()), this;
      },
      postRender: function postRender() {
        var t = this.em,
          e = this.model;
        this.modelOpt.temporary || (this.onRender(this._clbObj()), t && t.trigger("component:mount", e));
      },
      onRender: function onRender() {}
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "i", function () {
      return i;
    }), n.d(e, "g", function () {
      return o;
    }), n.d(e, "h", function () {
      return a;
    }), n.d(e, "f", function () {
      return s;
    }), n.d(e, "j", function () {
      return l;
    }), n.d(e, "b", function () {
      return c;
    }), n.d(e, "a", function () {
      return u;
    }), n.d(e, "e", function () {
      return d;
    }), n.d(e, "d", function () {
      return h;
    }), n.d(e, "c", function () {
      return f;
    });
    var r = n(0),
      i = "transitionend oTransitionEnd transitionend webkitTransitionEnd",
      o = function o(t) {
        return t && 9 === t.nodeType;
      },
      a = function a(t) {
        return t && !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
      },
      s = function s(t) {
        for (; t.firstChild;) t.removeChild(t.firstChild);
      },
      l = function l(t, e) {
        t.parentNode.replaceChild(e, t);
      },
      c = function c(t, e, n) {
        var i = t.childNodes,
          o = i.length,
          a = Object(r.isUndefined)(n) ? o : n;
        Object(r.isString)(e) && (t.insertAdjacentHTML("beforeEnd", e), e = t.lastChild, t.removeChild(e)), a >= o ? t.appendChild(e) : t.insertBefore(e, i[a]);
      },
      u = function u(t, e) {
        return c(t, e);
      },
      d = function d(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 ? arguments[2] : void 0,
          i = document.createElement(t);
        return e && Object(r.each)(e, function (t, e) {
          return i.setAttribute(e, t);
        }), n && (Object(r.isString)(n) ? i.innerHTML = n : i.appendChild(n)), i;
      },
      h = function h(t, e) {
        var n;
        try {
          n = new window[e](t.type, t);
        } catch (t) {
          (n = document.createEvent(e)).initEvent(t.type, !0, !0);
        }
        return n.keyCodeVal = t.keyCode, n._parentEvent = t, ["keyCode", "which"].forEach(function (t) {
          Object.defineProperty(n, t, {
            get: function get() {
              return this.keyCodeVal;
            }
          });
        }), n;
      },
      f = function f(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
          n = Array.isArray(e) ? e : [e];
        n.forEach(function (e) {
          var n = e.tag || "div",
            i = e.attributes || {},
            o = document.createElement(n);
          Object(r.each)(i, function (t, e) {
            o.setAttribute(e, t);
          }), t.appendChild(o);
        });
      };
  }, function (t, e) {
    function n(e) {
      return t.exports = n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, n(e);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    var r = n(82),
      i = n(83),
      o = n(44),
      a = n(84);
    t.exports = function (t) {
      return r(t) || i(t) || o(t) || a();
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n.n(r).a.Model.extend({
        idAttribute: "name",
        defaults: {
          name: "",
          label: "",
          type: 1,
          active: !0,
          private: !1,
          protected: !1
        },
        initialize: function initialize(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = e.config,
            r = void 0 === n ? {} : n,
            o = this.get("name"),
            a = this.get("label");
          o ? a || this.set("label", o) : this.set("name", a);
          var s = this.get("name"),
            l = r.escapeName,
            c = l ? l(s) : i.escapeName(s);
          this.set("name", c);
        },
        getFullName: function getFullName() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.escape,
            n = this.get("name"),
            r = "";
          switch (this.get("type")) {
            case 1:
              r = ".";
              break;
            case 2:
              r = "#";
          }
          return r + (e ? e(n) : n);
        }
      }, {
        TYPE_CLASS: 1,
        TYPE_ID: 2,
        escapeName: function escapeName(t) {
          return "".concat(t).trim().replace(/([^a-z0-9\w-\:]+)/gi, "-");
        }
      });
    e.a = i;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = document,
      i = window,
      o = Array.prototype,
      a = o.filter,
      s = o.indexOf,
      l = o.map,
      c = o.push,
      u = o.reverse,
      d = o.slice,
      h = o.splice,
      f = /^#[\w-]*$/,
      p = /^\.[\w-]*$/,
      g = /<.+>/,
      v = /^\w+$/;
    function m(t, e) {
      return void 0 === e && (e = r), p.test(t) ? e.getElementsByClassName(t.slice(1)) : v.test(t) ? e.getElementsByTagName(t) : e.querySelectorAll(t);
    }
    function b(t, e) {
      if (void 0 === e && (e = r), t) {
        if (t.__cash) return t;
        var n = t;
        if (P(t)) {
          if (e.__cash && (e = e[0]), !(n = f.test(t) ? e.getElementById(t.slice(1)) : g.test(t) ? ct(t) : m(t, e))) return;
        } else if (T(t)) return this.ready(t);
        (n.nodeType || n === i) && (n = [n]), this.length = n.length;
        for (var o = 0, a = this.length; o < a; o++) this[o] = n[o];
      }
    }
    function y(t, e) {
      return new b(t, e);
    }
    var w = y.fn = y.prototype = b.prototype = {
      constructor: y,
      __cash: !0,
      length: 0,
      splice: h
    };
    w.get = function (t) {
      return void 0 === t ? d.call(this) : this[t < 0 ? t + this.length : t];
    }, w.eq = function (t) {
      return y(this.get(t));
    }, w.first = function () {
      return this.eq(0);
    }, w.last = function () {
      return this.eq(-1);
    }, w.map = function (t) {
      return y(l.call(this, function (e, n) {
        return t.call(e, n, e);
      }));
    }, w.slice = function () {
      return y(d.apply(this, arguments));
    };
    var x = /(?:^\w|[A-Z]|\b\w)/g,
      O = /[\s-_]+/g;
    function C(t) {
      return t.replace(x, function (t, e) {
        return t[e ? "toUpperCase" : "toLowerCase"]();
      }).replace(O, "");
    }
    function S(t, e) {
      for (var n = 0, r = t.length; n < r && !1 !== e.call(t[n], t[n], n, t); n++);
    }
    y.camelCase = C, y.each = S, w.each = function (t) {
      return S(this, function (e, n) {
        return t.call(e, n, e);
      }), this;
    }, w.removeProp = function (t) {
      return this.each(function (e, n) {
        delete n[t];
      });
    }, y.extend = w.extend = function (t) {
      void 0 === t && (t = this);
      for (var e = arguments, n = e.length, r = n < 2 ? 0 : 1; r < n; r++) for (var i in e[r]) t[i] = e[r][i];
      return t;
    };
    var k = 1;
    function j(t, e) {
      var n = t && (t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector);
      return !!n && n.call(t, e);
    }
    function T(t) {
      return "function" == typeof t;
    }
    function P(t) {
      return "string" == typeof t;
    }
    function E(t) {
      return !isNaN(parseFloat(t)) && isFinite(t);
    }
    y.guid = k, y.matches = j, y.isFunction = T, y.isString = P, y.isNumeric = E;
    var D = Array.isArray;
    function M(t) {
      return P(t) ? function (e, n) {
        return j(n, t);
      } : t.__cash ? function (e, n) {
        return t.is(n);
      } : function (t, e, n) {
        return e === n;
      };
    }
    y.isArray = D, w.prop = function (t, e) {
      if (t) {
        if (P(t)) return arguments.length < 2 ? this[0] && this[0][t] : this.each(function (n, r) {
          r[t] = e;
        });
        for (var n in t) this.prop(n, t[n]);
        return this;
      }
    }, w.filter = function (t) {
      if (!t) return y();
      var e = T(t) ? t : M(t);
      return y(a.call(this, function (n, r) {
        return e.call(n, r, n, t);
      }));
    };
    var A = /\S+/g;
    function L(t) {
      return P(t) && t.match(A) || [];
    }
    function N(t) {
      return t.filter(function (t, e, n) {
        return n.indexOf(t) === e;
      });
    }
    function _(t, e, n) {
      if (1 === t.nodeType) {
        var r = i.getComputedStyle(t, null);
        return e ? n ? r.getPropertyValue(e) : r[e] : r;
      }
    }
    function I(t, e) {
      return parseInt(_(t, e), 10) || 0;
    }
    w.hasClass = function (t) {
      var e = L(t),
        n = !1;
      return e.length && this.each(function (t, r) {
        return !(n = r.classList.contains(e[0]));
      }), n;
    }, w.removeAttr = function (t) {
      var e = L(t);
      return e.length ? this.each(function (t, n) {
        S(e, function (t) {
          n.removeAttribute(t);
        });
      }) : this;
    }, w.attr = function (t, e) {
      if (t) {
        if (P(t)) {
          if (arguments.length < 2) {
            if (!this[0]) return;
            var n = this[0].getAttribute(t);
            return null === n ? void 0 : n;
          }
          return null === e ? this.removeAttr(t) : this.each(function (n, r) {
            r.setAttribute(t, e);
          });
        }
        for (var r in t) this.attr(r, t[r]);
        return this;
      }
    }, w.toggleClass = function (t, e) {
      var n = L(t),
        r = void 0 !== e;
      return n.length ? this.each(function (t, i) {
        S(n, function (t) {
          r ? e ? i.classList.add(t) : i.classList.remove(t) : i.classList.toggle(t);
        });
      }) : this;
    }, w.addClass = function (t) {
      return this.toggleClass(t, !0);
    }, w.removeClass = function (t) {
      return arguments.length ? this.toggleClass(t, !1) : this.attr("class", "");
    }, y.unique = N, w.add = function (t, e) {
      return y(N(this.get().concat(y(t, e).get())));
    };
    var F = /^--/;
    function V(t) {
      return F.test(t);
    }
    var R = {},
      z = r.createElement("div").style,
      H = ["webkit", "moz", "ms", "o"];
    function $(t, e) {
      if (void 0 === e && (e = V(t)), e) return t;
      if (!R[t]) {
        var n = C(t),
          r = "" + n.charAt(0).toUpperCase() + n.slice(1);
        S((n + " " + H.join(r + " ") + r).split(" "), function (e) {
          if (e in z) return R[t] = e, !1;
        });
      }
      return R[t];
    }
    y.prefixedProp = $;
    var B = {
      animationIterationCount: !0,
      columnCount: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0
    };
    function W(t, e, n) {
      return void 0 === n && (n = V(t)), n || B[t] || !E(e) ? e : e + "px";
    }
    w.css = function (t, e) {
      if (P(t)) {
        var n = V(t);
        return t = $(t, n), arguments.length < 2 ? this[0] && _(this[0], t, n) : t ? (e = W(t, e, n), this.each(function (r, i) {
          1 === i.nodeType && (n ? i.style.setProperty(t, e) : i.style[t] = e);
        })) : this;
      }
      for (var r in t) this.css(r, t[r]);
      return this;
    };
    var U = /^data-(.*)/;
    function q(t) {
      return t.__cashData = t.__cashData || {};
    }
    function G(t, e) {
      var n = q(t);
      if (e) {
        if (!(e in n)) {
          var r = t.dataset ? t.dataset[e] || t.dataset[C(e)] : y(t).attr("data-" + e);
          if (void 0 !== r) {
            try {
              r = JSON.parse(r);
            } catch (t) {}
            n[e] = r;
          }
        }
        return n[e];
      }
      return n;
    }
    function K(t, e) {
      return I(t, "border" + (e ? "Left" : "Top") + "Width") + I(t, "padding" + (e ? "Left" : "Top")) + I(t, "padding" + (e ? "Right" : "Bottom")) + I(t, "border" + (e ? "Right" : "Bottom") + "Width");
    }
    function Y(t, e) {
      for (var n = 0, r = e.length; n < r; n++) if (t.indexOf(e[n]) < 0) return !1;
      return !0;
    }
    function X(t, e, n) {
      S(t[n], function (t) {
        t[0];
        var r = t[1];
        e.removeEventListener(n, r);
      }), delete t[n];
    }
    y.hasData = function (t) {
      return "__cashData" in t;
    }, w.data = function (t, e) {
      var n = this;
      if (!t) {
        if (!this[0]) return;
        return S(this[0].attributes, function (t) {
          var e = t.name.match(U);
          e && n.data(e[1]);
        }), G(this[0]);
      }
      if (P(t)) return void 0 === e ? this[0] && G(this[0], t) : this.each(function (n, r) {
        return function (t, e, n) {
          q(t)[e] = n;
        }(r, t, e);
      });
      for (var r in t) this.data(r, t[r]);
      return this;
    }, w.removeData = function (t) {
      return this.each(function (e, n) {
        return function (t, e) {
          void 0 === e ? delete t.__cashData : delete q(t)[e];
        }(n, t);
      });
    }, S(["Width", "Height"], function (t) {
      w["inner" + t] = function () {
        if (this[0]) return this[0] === i ? i["inner" + t] : this[0]["client" + t];
      };
    }), S(["width", "height"], function (t, e) {
      w[t] = function (n) {
        return this[0] ? arguments.length ? (n = parseInt(n, 10), this.each(function (r, i) {
          if (1 === i.nodeType) {
            var o = _(i, "boxSizing");
            i.style[t] = W(t, n + ("border-box" === o ? K(i, !e) : 0));
          }
        })) : this[0] === i ? this[0][C("outer-" + t)] : this[0].getBoundingClientRect()[t] - K(this[0], !e) : void 0 === n ? void 0 : this;
      };
    }), S(["Width", "Height"], function (t, e) {
      w["outer" + t] = function (n) {
        if (this[0]) return this[0] === i ? i["outer" + t] : this[0]["offset" + t] + (n ? I(this[0], "margin" + (e ? "Top" : "Left")) + I(this[0], "margin" + (e ? "Bottom" : "Right")) : 0);
      };
    });
    function J(t) {
      return t.__cashEvents = t.__cashEvents || {};
    }
    function Z(t) {
      var e = t.split(".");
      return [e[0], e.slice(1).sort()];
    }
    function Q(t, e, n, r) {
      var i = J(t);
      if (e) {
        var o = i[e];
        if (!o) return;
        r && (r.guid = r.guid || k++), i[e] = o.filter(function (i) {
          var o = i[0],
            a = i[1];
          if (r && a.guid !== r.guid || !Y(o, n)) return !0;
          t.removeEventListener(e, a);
        });
      } else if (n && n.length) for (e in i) Q(t, e, n, r);else for (e in i) X(i, t, e);
    }
    w.off = function (t, e) {
      var n = this;
      return void 0 === t ? this.each(function (t, e) {
        return Q(e);
      }) : S(L(t), function (t) {
        var r = Z(t),
          i = r[0],
          o = r[1];
        n.each(function (t, n) {
          return Q(n, i, o, e);
        });
      }), this;
    }, w.on = function (t, e, n, r) {
      var i = this;
      if (!P(t)) {
        for (var o in t) this.on(o, e, t[o]);
        return this;
      }
      return T(e) && (n = e, e = !1), S(L(t), function (t) {
        var o = Z(t),
          a = o[0],
          s = o[1];
        i.each(function (t, i) {
          var o = function t(o) {
            if (!o.namespace || Y(s, o.namespace.split("."))) {
              var l = i;
              if (e) {
                for (var c = o.target; !j(c, e);) {
                  if (c === i) return;
                  if (!(c = c.parentNode)) return;
                }
                l = c;
              }
              o.namespace = o.namespace || "";
              var u = n.call(l, o, o.data);
              r && Q(i, a, s, t), !1 === u && (o.preventDefault(), o.stopPropagation());
            }
          };
          o.guid = n.guid = n.guid || k++, function (t, e, n, r) {
            r.guid = r.guid || k++;
            var i = J(t);
            i[e] = i[e] || [], i[e].push([n, r]), t.addEventListener(e, r);
          }(i, a, s, o);
        });
      }), this;
    }, w.one = function (t, e, n) {
      return this.on(t, e, n, !0);
    }, w.ready = function (t) {
      var e = function e() {
        return t(y);
      };
      return "loading" !== r.readyState ? setTimeout(e) : r.addEventListener("DOMContentLoaded", e), this;
    }, w.trigger = function (t, e) {
      var n = t;
      if (P(t)) {
        var i = Z(t),
          o = i[0],
          a = i[1];
        (n = r.createEvent("HTMLEvents")).initEvent(o, !0, !0), n.namespace = a.join(".");
      }
      return n.data = e, this.each(function (t, e) {
        e.dispatchEvent(n);
      });
    };
    var tt = /select-one/i,
      et = /select-multiple/i;
    function nt(t) {
      var e = t.type;
      return tt.test(e) ? function (t) {
        return t.selectedIndex < 0 ? null : t.options[t.selectedIndex].value;
      }(t) : et.test(e) ? function (t) {
        var e = [];
        return S(t.options, function (t) {
          !t.selected || t.disabled || t.parentNode.disabled || e.push(t.value);
        }), e;
      }(t) : t.value;
    }
    var rt = /%20/g;
    var it = /file|reset|submit|button|image/i,
      ot = /radio|checkbox/i;
    w.serialize = function () {
      var t = "";
      return this.each(function (e, n) {
        S(n.elements || [n], function (e) {
          if (!e.disabled && e.name && "FIELDSET" !== e.tagName && !it.test(e.type) && (!ot.test(e.type) || e.checked)) {
            var n = nt(e);
            if (void 0 !== n) S(D(n) ? n : [n], function (n) {
              t += function (t, e) {
                return "&" + encodeURIComponent(t) + "=" + encodeURIComponent(e).replace(rt, "+");
              }(e.name, n);
            });
          }
        });
      }), t.substr(1);
    }, w.val = function (t) {
      return void 0 === t ? this[0] && nt(this[0]) : this.each(function (e, n) {
        var r = et.test(n.type),
          i = null === t ? r ? [] : "" : t;
        r && D(i) ? S(n.options, function (t) {
          t.selected = i.indexOf(t.value) >= 0;
        }) : n.value = i;
      });
    }, w.clone = function () {
      return this.map(function (t, e) {
        return e.cloneNode(!0);
      });
    }, w.detach = function () {
      return this.each(function (t, e) {
        e.parentNode && e.parentNode.removeChild(e);
      });
    };
    var at,
      st = /^\s*<(\w+)[^>]*>/,
      lt = /^\s*<(\w+)\s*\/?>(?:<\/\1>)?\s*$/;
    function ct(t) {
      if (function () {
        if (!at) {
          var t = r.createElement("table"),
            e = r.createElement("tr");
          at = {
            "*": r.createElement("div"),
            tr: r.createElement("tbody"),
            td: e,
            th: e,
            thead: t,
            tbody: t,
            tfoot: t
          };
        }
      }(), !P(t)) return [];
      if (lt.test(t)) return [r.createElement(RegExp.$1)];
      var e = st.test(t) && RegExp.$1,
        n = at[e] || at["*"];
      return n.innerHTML = t, y(n.childNodes).detach().get();
    }
    function ut(t, e, n) {
      if (void 0 !== e) {
        var r = P(e);
        !r && e.length ? S(e, function (e) {
          return ut(t, e, n);
        }) : S(t, r ? function (t) {
          t.insertAdjacentHTML(n ? "afterbegin" : "beforeend", e);
        } : function (t, r) {
          return function (t, e, n) {
            n ? t.insertBefore(e, t.childNodes[0]) : t.appendChild(e);
          }(t, r ? e.cloneNode(!0) : e, n);
        });
      }
    }
    y.parseHTML = ct, w.empty = function () {
      var t = this[0];
      if (t) for (; t.firstChild;) t.removeChild(t.firstChild);
      return this;
    }, w.append = function () {
      var t = this;
      return S(arguments, function (e) {
        ut(t, e);
      }), this;
    }, w.appendTo = function (t) {
      return ut(y(t), this), this;
    }, w.html = function (t) {
      if (void 0 === t) return this[0] && this[0].innerHTML;
      var e = t.nodeType ? t[0].outerHTML : t;
      return this.each(function (t, n) {
        n.innerHTML = e;
      });
    }, w.insertAfter = function (t) {
      var e = this;
      return y(t).each(function (t, n) {
        var r = n.parentNode;
        e.each(function (e, i) {
          r.insertBefore(t ? i.cloneNode(!0) : i, n.nextSibling);
        });
      }), this;
    }, w.after = function () {
      var t = this;
      return S(u.apply(arguments), function (e) {
        u.apply(y(e).slice()).insertAfter(t);
      }), this;
    }, w.insertBefore = function (t) {
      var e = this;
      return y(t).each(function (t, n) {
        var r = n.parentNode;
        e.each(function (e, i) {
          r.insertBefore(t ? i.cloneNode(!0) : i, n);
        });
      }), this;
    }, w.before = function () {
      var t = this;
      return S(arguments, function (e) {
        y(e).insertBefore(t);
      }), this;
    }, w.prepend = function () {
      var t = this;
      return S(arguments, function (e) {
        ut(t, e, !0);
      }), this;
    }, w.prependTo = function (t) {
      return ut(y(t), u.apply(this.slice()), !0), this;
    }, w.remove = function () {
      return this.detach().off();
    }, w.replaceWith = function (t) {
      var e = this;
      return this.each(function (n, r) {
        var i = r.parentNode;
        if (i) {
          var o = n ? y(t).clone() : y(t);
          if (!o[0]) return e.remove(), !1;
          i.replaceChild(o[0], r), y(o[0]).after(o.slice(1));
        }
      });
    }, w.replaceAll = function (t) {
      return y(t).replaceWith(this), this;
    }, w.text = function (t) {
      return void 0 === t ? this[0] ? this[0].textContent : "" : this.each(function (e, n) {
        n.textContent = t;
      });
    };
    var dt = r.documentElement;
    w.offset = function () {
      var t = this[0];
      if (t) {
        var e = t.getBoundingClientRect();
        return {
          top: e.top + i.pageYOffset - dt.clientTop,
          left: e.left + i.pageXOffset - dt.clientLeft
        };
      }
    }, w.offsetParent = function () {
      return y(this[0] && this[0].offsetParent);
    }, w.position = function () {
      var t = this[0];
      if (t) return {
        left: t.offsetLeft,
        top: t.offsetTop
      };
    }, w.children = function (t) {
      var e = [];
      return this.each(function (t, n) {
        c.apply(e, n.children);
      }), e = y(N(e)), t ? e.filter(function (e, n) {
        return j(n, t);
      }) : e;
    }, w.contents = function () {
      var t = [];
      return this.each(function (e, n) {
        c.apply(t, "IFRAME" === n.tagName ? [n.contentDocument] : n.childNodes);
      }), y(t.length && N(t));
    }, w.find = function (t) {
      for (var e = [], n = 0, r = this.length; n < r; n++) {
        var i = m(t, this[n]);
        i.length && c.apply(e, i);
      }
      return y(e.length && N(e));
    }, w.has = function (t) {
      var e = P(t) ? function (e, n) {
        return !!m(t, n).length;
      } : function (e, n) {
        return n.contains(t);
      };
      return this.filter(e);
    }, w.is = function (t) {
      if (!t || !this[0]) return !1;
      var e = M(t),
        n = !1;
      return this.each(function (r, i) {
        return !(n = e(r, i, t));
      }), n;
    }, w.next = function () {
      return y(this[0] && this[0].nextElementSibling);
    }, w.not = function (t) {
      if (!t || !this[0]) return this;
      var e = M(t);
      return this.filter(function (n, r) {
        return !e(n, r, t);
      });
    }, w.parent = function () {
      var t = [];
      return this.each(function (e, n) {
        n && n.parentNode && t.push(n.parentNode);
      }), y(N(t));
    }, w.index = function (t) {
      var e = t ? y(t)[0] : this[0],
        n = t ? this : y(e).parent().children();
      return s.call(n, e);
    }, w.closest = function (t) {
      return t && this[0] ? this.is(t) ? this.filter(t) : this.parent().closest(t) : y();
    }, w.parents = function (t) {
      var e,
        n = [];
      return this.each(function (i, o) {
        for (e = o; e && e.parentNode && e !== r.body.parentNode;) e = e.parentNode, (!t || t && j(e, t)) && n.push(e);
      }), y(N(n));
    }, w.prev = function () {
      return y(this[0] && this[0].previousElementSibling);
    }, w.siblings = function () {
      var t = this[0];
      return this.parent().children().filter(function (e, n) {
        return n !== t;
      });
    }, e.default = y;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
      i = n(1),
      o = n.n(i),
      a = n(10);
    e.a = o.a.Collection.extend({
      model: a.a,
      modelId: function modelId(t) {
        return "".concat(t.name, "_").concat(t.type || a.a.TYPE_CLASS);
      },
      getStyleable: function getStyleable() {
        return Object(r.filter)(this.models, function (t) {
          return t.get("active") && !t.get("private");
        });
      },
      getValid: function getValid() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.noDisabled;
        return Object(r.filter)(this.models, function (t) {
          return !t.get("private");
        }).filter(function (t) {
          return e ? t.get("active") : 1;
        });
      },
      getFullString: function getFullString(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = [],
          r = t || this;
        return r.forEach(function (t) {
          return n.push(t.getFullName(e));
        }), n.join("").trim();
      }
    });
  }, function (t, e, n) {
    t.exports = function () {
      "use strict";

      var t = navigator.userAgent,
        e = navigator.platform,
        n = /gecko\/\d/i.test(t),
        r = /MSIE \d/.test(t),
        i = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(t),
        o = /Edge\/(\d+)/.exec(t),
        a = r || i || o,
        s = a && (r ? document.documentMode || 6 : +(o || i)[1]),
        l = !o && /WebKit\//.test(t),
        c = l && /Qt\/\d+\.\d+/.test(t),
        u = !o && /Chrome\/(\d+)/.exec(t),
        d = u && +u[1],
        h = /Opera\//.test(t),
        f = /Apple Computer/.test(navigator.vendor),
        p = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(t),
        g = /PhantomJS/.test(t),
        v = f && (/Mobile\/\w+/.test(t) || navigator.maxTouchPoints > 2),
        m = /Android/.test(t),
        b = v || m || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(t),
        y = v || /Mac/.test(e),
        w = /\bCrOS\b/.test(t),
        x = /win/i.test(e),
        O = h && t.match(/Version\/(\d*\.\d*)/);
      O && (O = Number(O[1])), O && O >= 15 && (h = !1, l = !0);
      var C = y && (c || h && (null == O || O < 12.11)),
        S = n || a && s >= 9;
      function k(t) {
        return new RegExp("(^|\\s)" + t + "(?:$|\\s)\\s*");
      }
      var j,
        T = function T(t, e) {
          var n = t.className,
            r = k(e).exec(n);
          if (r) {
            var i = n.slice(r.index + r[0].length);
            t.className = n.slice(0, r.index) + (i ? r[1] + i : "");
          }
        };
      function P(t) {
        for (var e = t.childNodes.length; e > 0; --e) t.removeChild(t.firstChild);
        return t;
      }
      function E(t, e) {
        return P(t).appendChild(e);
      }
      function D(t, e, n, r) {
        var i = document.createElement(t);
        if (n && (i.className = n), r && (i.style.cssText = r), "string" == typeof e) i.appendChild(document.createTextNode(e));else if (e) for (var o = 0; o < e.length; ++o) i.appendChild(e[o]);
        return i;
      }
      function M(t, e, n, r) {
        var i = D(t, e, n, r);
        return i.setAttribute("role", "presentation"), i;
      }
      function A(t, e) {
        if (3 == e.nodeType && (e = e.parentNode), t.contains) return t.contains(e);
        do {
          if (11 == e.nodeType && (e = e.host), e == t) return !0;
        } while (e = e.parentNode);
      }
      function L(t) {
        var e,
          n = t.ownerDocument || t;
        try {
          e = t.activeElement;
        } catch (t) {
          e = n.body || null;
        }
        for (; e && e.shadowRoot && e.shadowRoot.activeElement;) e = e.shadowRoot.activeElement;
        return e;
      }
      function N(t, e) {
        var n = t.className;
        k(e).test(n) || (t.className += (n ? " " : "") + e);
      }
      function _(t, e) {
        for (var n = t.split(" "), r = 0; r < n.length; r++) n[r] && !k(n[r]).test(e) && (e += " " + n[r]);
        return e;
      }
      j = document.createRange ? function (t, e, n, r) {
        var i = document.createRange();
        return i.setEnd(r || t, n), i.setStart(t, e), i;
      } : function (t, e, n) {
        var r = document.body.createTextRange();
        try {
          r.moveToElementText(t.parentNode);
        } catch (t) {
          return r;
        }
        return r.collapse(!0), r.moveEnd("character", n), r.moveStart("character", e), r;
      };
      var I = function I(t) {
        t.select();
      };
      function F(t) {
        return t.display.wrapper.ownerDocument;
      }
      function V(t) {
        return R(t.display.wrapper);
      }
      function R(t) {
        return t.getRootNode ? t.getRootNode() : t.ownerDocument;
      }
      function z(t) {
        return F(t).defaultView;
      }
      function H(t) {
        var e = Array.prototype.slice.call(arguments, 1);
        return function () {
          return t.apply(null, e);
        };
      }
      function $(t, e, n) {
        for (var r in e || (e = {}), t) !t.hasOwnProperty(r) || !1 === n && e.hasOwnProperty(r) || (e[r] = t[r]);
        return e;
      }
      function B(t, e, n, r, i) {
        null == e && -1 == (e = t.search(/[^\s\u00a0]/)) && (e = t.length);
        for (var o = r || 0, a = i || 0;;) {
          var s = t.indexOf("\t", o);
          if (s < 0 || s >= e) return a + (e - o);
          a += s - o, a += n - a % n, o = s + 1;
        }
      }
      v ? I = function I(t) {
        t.selectionStart = 0, t.selectionEnd = t.value.length;
      } : a && (I = function I(t) {
        try {
          t.select();
        } catch (t) {}
      });
      var W = function W() {
        this.id = null, this.f = null, this.time = 0, this.handler = H(this.onTimeout, this);
      };
      function U(t, e) {
        for (var n = 0; n < t.length; ++n) if (t[n] == e) return n;
        return -1;
      }
      W.prototype.onTimeout = function (t) {
        t.id = 0, t.time <= +new Date() ? t.f() : setTimeout(t.handler, t.time - +new Date());
      }, W.prototype.set = function (t, e) {
        this.f = e;
        var n = +new Date() + t;
        (!this.id || n < this.time) && (clearTimeout(this.id), this.id = setTimeout(this.handler, t), this.time = n);
      };
      var q = {
          toString: function toString() {
            return "CodeMirror.Pass";
          }
        },
        G = {
          scroll: !1
        },
        K = {
          origin: "*mouse"
        },
        Y = {
          origin: "+move"
        };
      function X(t, e, n) {
        for (var r = 0, i = 0;;) {
          var o = t.indexOf("\t", r);
          -1 == o && (o = t.length);
          var a = o - r;
          if (o == t.length || i + a >= e) return r + Math.min(a, e - i);
          if (i += o - r, r = o + 1, (i += n - i % n) >= e) return r;
        }
      }
      var J = [""];
      function Z(t) {
        for (; J.length <= t;) J.push(Q(J) + " ");
        return J[t];
      }
      function Q(t) {
        return t[t.length - 1];
      }
      function tt(t, e) {
        for (var n = [], r = 0; r < t.length; r++) n[r] = e(t[r], r);
        return n;
      }
      function et() {}
      function nt(t, e) {
        var n;
        return Object.create ? n = Object.create(t) : (et.prototype = t, n = new et()), e && $(e, n), n;
      }
      var rt = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
      function it(t) {
        return /\w/.test(t) || t > "" && (t.toUpperCase() != t.toLowerCase() || rt.test(t));
      }
      function ot(t, e) {
        return e ? !!(e.source.indexOf("\\w") > -1 && it(t)) || e.test(t) : it(t);
      }
      function at(t) {
        for (var e in t) if (t.hasOwnProperty(e) && t[e]) return !1;
        return !0;
      }
      var st = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
      function lt(t) {
        return t.charCodeAt(0) >= 768 && st.test(t);
      }
      function ct(t, e, n) {
        for (; (n < 0 ? e > 0 : e < t.length) && lt(t.charAt(e));) e += n;
        return e;
      }
      function ut(t, e, n) {
        for (var r = e > n ? -1 : 1;;) {
          if (e == n) return e;
          var i = (e + n) / 2,
            o = r < 0 ? Math.ceil(i) : Math.floor(i);
          if (o == e) return t(o) ? e : n;
          t(o) ? n = o : e = o + r;
        }
      }
      var dt = null;
      function ht(t, e, n) {
        var r;
        dt = null;
        for (var i = 0; i < t.length; ++i) {
          var o = t[i];
          if (o.from < e && o.to > e) return i;
          o.to == e && (o.from != o.to && "before" == n ? r = i : dt = i), o.from == e && (o.from != o.to && "before" != n ? r = i : dt = i);
        }
        return null != r ? r : dt;
      }
      var ft = function () {
        var t = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/,
          e = /[stwN]/,
          n = /[LRr]/,
          r = /[Lb1n]/,
          i = /[1n]/;
        function o(t, e, n) {
          this.level = t, this.from = e, this.to = n;
        }
        return function (a, s) {
          var l = "ltr" == s ? "L" : "R";
          if (0 == a.length || "ltr" == s && !t.test(a)) return !1;
          for (var c, u = a.length, d = [], h = 0; h < u; ++h) d.push((c = a.charCodeAt(h)) <= 247 ? "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN".charAt(c) : 1424 <= c && c <= 1524 ? "R" : 1536 <= c && c <= 1785 ? "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111".charAt(c - 1536) : 1774 <= c && c <= 2220 ? "r" : 8192 <= c && c <= 8203 ? "w" : 8204 == c ? "b" : "L");
          for (var f = 0, p = l; f < u; ++f) {
            var g = d[f];
            "m" == g ? d[f] = p : p = g;
          }
          for (var v = 0, m = l; v < u; ++v) {
            var b = d[v];
            "1" == b && "r" == m ? d[v] = "n" : n.test(b) && (m = b, "r" == b && (d[v] = "R"));
          }
          for (var y = 1, w = d[0]; y < u - 1; ++y) {
            var x = d[y];
            "+" == x && "1" == w && "1" == d[y + 1] ? d[y] = "1" : "," != x || w != d[y + 1] || "1" != w && "n" != w || (d[y] = w), w = x;
          }
          for (var O = 0; O < u; ++O) {
            var C = d[O];
            if ("," == C) d[O] = "N";else if ("%" == C) {
              var S = void 0;
              for (S = O + 1; S < u && "%" == d[S]; ++S);
              for (var k = O && "!" == d[O - 1] || S < u && "1" == d[S] ? "1" : "N", j = O; j < S; ++j) d[j] = k;
              O = S - 1;
            }
          }
          for (var T = 0, P = l; T < u; ++T) {
            var E = d[T];
            "L" == P && "1" == E ? d[T] = "L" : n.test(E) && (P = E);
          }
          for (var D = 0; D < u; ++D) if (e.test(d[D])) {
            var M = void 0;
            for (M = D + 1; M < u && e.test(d[M]); ++M);
            for (var A = "L" == (D ? d[D - 1] : l), L = A == ("L" == (M < u ? d[M] : l)) ? A ? "L" : "R" : l, N = D; N < M; ++N) d[N] = L;
            D = M - 1;
          }
          for (var _, I = [], F = 0; F < u;) if (r.test(d[F])) {
            var V = F;
            for (++F; F < u && r.test(d[F]); ++F);
            I.push(new o(0, V, F));
          } else {
            var R = F,
              z = I.length,
              H = "rtl" == s ? 1 : 0;
            for (++F; F < u && "L" != d[F]; ++F);
            for (var $ = R; $ < F;) if (i.test(d[$])) {
              R < $ && (I.splice(z, 0, new o(1, R, $)), z += H);
              var B = $;
              for (++$; $ < F && i.test(d[$]); ++$);
              I.splice(z, 0, new o(2, B, $)), z += H, R = $;
            } else ++$;
            R < F && I.splice(z, 0, new o(1, R, F));
          }
          return "ltr" == s && (1 == I[0].level && (_ = a.match(/^\s+/)) && (I[0].from = _[0].length, I.unshift(new o(0, 0, _[0].length))), 1 == Q(I).level && (_ = a.match(/\s+$/)) && (Q(I).to -= _[0].length, I.push(new o(0, u - _[0].length, u)))), "rtl" == s ? I.reverse() : I;
        };
      }();
      function pt(t, e) {
        var n = t.order;
        return null == n && (n = t.order = ft(t.text, e)), n;
      }
      var gt = [],
        vt = function vt(t, e, n) {
          if (t.addEventListener) t.addEventListener(e, n, !1);else if (t.attachEvent) t.attachEvent("on" + e, n);else {
            var r = t._handlers || (t._handlers = {});
            r[e] = (r[e] || gt).concat(n);
          }
        };
      function mt(t, e) {
        return t._handlers && t._handlers[e] || gt;
      }
      function bt(t, e, n) {
        if (t.removeEventListener) t.removeEventListener(e, n, !1);else if (t.detachEvent) t.detachEvent("on" + e, n);else {
          var r = t._handlers,
            i = r && r[e];
          if (i) {
            var o = U(i, n);
            o > -1 && (r[e] = i.slice(0, o).concat(i.slice(o + 1)));
          }
        }
      }
      function yt(t, e) {
        var n = mt(t, e);
        if (n.length) for (var r = Array.prototype.slice.call(arguments, 2), i = 0; i < n.length; ++i) n[i].apply(null, r);
      }
      function wt(t, e, n) {
        return "string" == typeof e && (e = {
          type: e,
          preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
          }
        }), yt(t, n || e.type, t, e), jt(e) || e.codemirrorIgnore;
      }
      function xt(t) {
        var e = t._handlers && t._handlers.cursorActivity;
        if (e) for (var n = t.curOp.cursorActivityHandlers || (t.curOp.cursorActivityHandlers = []), r = 0; r < e.length; ++r) -1 == U(n, e[r]) && n.push(e[r]);
      }
      function Ot(t, e) {
        return mt(t, e).length > 0;
      }
      function Ct(t) {
        t.prototype.on = function (t, e) {
          vt(this, t, e);
        }, t.prototype.off = function (t, e) {
          bt(this, t, e);
        };
      }
      function St(t) {
        t.preventDefault ? t.preventDefault() : t.returnValue = !1;
      }
      function kt(t) {
        t.stopPropagation ? t.stopPropagation() : t.cancelBubble = !0;
      }
      function jt(t) {
        return null != t.defaultPrevented ? t.defaultPrevented : 0 == t.returnValue;
      }
      function Tt(t) {
        St(t), kt(t);
      }
      function Pt(t) {
        return t.target || t.srcElement;
      }
      function Et(t) {
        var e = t.which;
        return null == e && (1 & t.button ? e = 1 : 2 & t.button ? e = 3 : 4 & t.button && (e = 2)), y && t.ctrlKey && 1 == e && (e = 3), e;
      }
      var Dt,
        Mt,
        At = function () {
          if (a && s < 9) return !1;
          var t = D("div");
          return "draggable" in t || "dragDrop" in t;
        }();
      function Lt(t) {
        if (null == Dt) {
          var e = D("span", "​");
          E(t, D("span", [e, document.createTextNode("x")])), 0 != t.firstChild.offsetHeight && (Dt = e.offsetWidth <= 1 && e.offsetHeight > 2 && !(a && s < 8));
        }
        var n = Dt ? D("span", "​") : D("span", " ", null, "display: inline-block; width: 1px; margin-right: -1px");
        return n.setAttribute("cm-text", ""), n;
      }
      function Nt(t) {
        if (null != Mt) return Mt;
        var e = E(t, document.createTextNode("AخA")),
          n = j(e, 0, 1).getBoundingClientRect(),
          r = j(e, 1, 2).getBoundingClientRect();
        return P(t), !(!n || n.left == n.right) && (Mt = r.right - n.right < 3);
      }
      var _t,
        It = 3 != "\n\nb".split(/\n/).length ? function (t) {
          for (var e = 0, n = [], r = t.length; e <= r;) {
            var i = t.indexOf("\n", e);
            -1 == i && (i = t.length);
            var o = t.slice(e, "\r" == t.charAt(i - 1) ? i - 1 : i),
              a = o.indexOf("\r");
            -1 != a ? (n.push(o.slice(0, a)), e += a + 1) : (n.push(o), e = i + 1);
          }
          return n;
        } : function (t) {
          return t.split(/\r\n?|\n/);
        },
        Ft = window.getSelection ? function (t) {
          try {
            return t.selectionStart != t.selectionEnd;
          } catch (t) {
            return !1;
          }
        } : function (t) {
          var e;
          try {
            e = t.ownerDocument.selection.createRange();
          } catch (t) {}
          return !(!e || e.parentElement() != t) && 0 != e.compareEndPoints("StartToEnd", e);
        },
        Vt = "oncopy" in (_t = D("div")) || (_t.setAttribute("oncopy", "return;"), "function" == typeof _t.oncopy),
        Rt = null,
        zt = {},
        Ht = {};
      function $t(t, e) {
        arguments.length > 2 && (e.dependencies = Array.prototype.slice.call(arguments, 2)), zt[t] = e;
      }
      function Bt(t) {
        if ("string" == typeof t && Ht.hasOwnProperty(t)) t = Ht[t];else if (t && "string" == typeof t.name && Ht.hasOwnProperty(t.name)) {
          var e = Ht[t.name];
          "string" == typeof e && (e = {
            name: e
          }), (t = nt(e, t)).name = e.name;
        } else {
          if ("string" == typeof t && /^[\w\-]+\/[\w\-]+\+xml$/.test(t)) return Bt("application/xml");
          if ("string" == typeof t && /^[\w\-]+\/[\w\-]+\+json$/.test(t)) return Bt("application/json");
        }
        return "string" == typeof t ? {
          name: t
        } : t || {
          name: "null"
        };
      }
      function Wt(t, e) {
        e = Bt(e);
        var n = zt[e.name];
        if (!n) return Wt(t, "text/plain");
        var r = n(t, e);
        if (Ut.hasOwnProperty(e.name)) {
          var i = Ut[e.name];
          for (var o in i) i.hasOwnProperty(o) && (r.hasOwnProperty(o) && (r["_" + o] = r[o]), r[o] = i[o]);
        }
        if (r.name = e.name, e.helperType && (r.helperType = e.helperType), e.modeProps) for (var a in e.modeProps) r[a] = e.modeProps[a];
        return r;
      }
      var Ut = {};
      function qt(t, e) {
        $(e, Ut.hasOwnProperty(t) ? Ut[t] : Ut[t] = {});
      }
      function Gt(t, e) {
        if (!0 === e) return e;
        if (t.copyState) return t.copyState(e);
        var n = {};
        for (var r in e) {
          var i = e[r];
          i instanceof Array && (i = i.concat([])), n[r] = i;
        }
        return n;
      }
      function Kt(t, e) {
        for (var n; t.innerMode && (n = t.innerMode(e)) && n.mode != t;) e = n.state, t = n.mode;
        return n || {
          mode: t,
          state: e
        };
      }
      function Yt(t, e, n) {
        return !t.startState || t.startState(e, n);
      }
      var Xt = function Xt(t, e, n) {
        this.pos = this.start = 0, this.string = t, this.tabSize = e || 8, this.lastColumnPos = this.lastColumnValue = 0, this.lineStart = 0, this.lineOracle = n;
      };
      function Jt(t, e) {
        if ((e -= t.first) < 0 || e >= t.size) throw new Error("There is no line " + (e + t.first) + " in the document.");
        for (var n = t; !n.lines;) for (var r = 0;; ++r) {
          var i = n.children[r],
            o = i.chunkSize();
          if (e < o) {
            n = i;
            break;
          }
          e -= o;
        }
        return n.lines[e];
      }
      function Zt(t, e, n) {
        var r = [],
          i = e.line;
        return t.iter(e.line, n.line + 1, function (t) {
          var o = t.text;
          i == n.line && (o = o.slice(0, n.ch)), i == e.line && (o = o.slice(e.ch)), r.push(o), ++i;
        }), r;
      }
      function Qt(t, e, n) {
        var r = [];
        return t.iter(e, n, function (t) {
          r.push(t.text);
        }), r;
      }
      function te(t, e) {
        var n = e - t.height;
        if (n) for (var r = t; r; r = r.parent) r.height += n;
      }
      function ee(t) {
        if (null == t.parent) return null;
        for (var e = t.parent, n = U(e.lines, t), r = e.parent; r; e = r, r = r.parent) for (var i = 0; r.children[i] != e; ++i) n += r.children[i].chunkSize();
        return n + e.first;
      }
      function ne(t, e) {
        var n = t.first;
        t: do {
          for (var r = 0; r < t.children.length; ++r) {
            var i = t.children[r],
              o = i.height;
            if (e < o) {
              t = i;
              continue t;
            }
            e -= o, n += i.chunkSize();
          }
          return n;
        } while (!t.lines);
        for (var a = 0; a < t.lines.length; ++a) {
          var s = t.lines[a].height;
          if (e < s) break;
          e -= s;
        }
        return n + a;
      }
      function re(t, e) {
        return e >= t.first && e < t.first + t.size;
      }
      function ie(t, e) {
        return String(t.lineNumberFormatter(e + t.firstLineNumber));
      }
      function oe(t, e, n) {
        if (void 0 === n && (n = null), !(this instanceof oe)) return new oe(t, e, n);
        this.line = t, this.ch = e, this.sticky = n;
      }
      function ae(t, e) {
        return t.line - e.line || t.ch - e.ch;
      }
      function se(t, e) {
        return t.sticky == e.sticky && 0 == ae(t, e);
      }
      function le(t) {
        return oe(t.line, t.ch);
      }
      function ce(t, e) {
        return ae(t, e) < 0 ? e : t;
      }
      function ue(t, e) {
        return ae(t, e) < 0 ? t : e;
      }
      function de(t, e) {
        return Math.max(t.first, Math.min(e, t.first + t.size - 1));
      }
      function he(t, e) {
        if (e.line < t.first) return oe(t.first, 0);
        var n = t.first + t.size - 1;
        return e.line > n ? oe(n, Jt(t, n).text.length) : function (t, e) {
          var n = t.ch;
          return null == n || n > e ? oe(t.line, e) : n < 0 ? oe(t.line, 0) : t;
        }(e, Jt(t, e.line).text.length);
      }
      function fe(t, e) {
        for (var n = [], r = 0; r < e.length; r++) n[r] = he(t, e[r]);
        return n;
      }
      Xt.prototype.eol = function () {
        return this.pos >= this.string.length;
      }, Xt.prototype.sol = function () {
        return this.pos == this.lineStart;
      }, Xt.prototype.peek = function () {
        return this.string.charAt(this.pos) || void 0;
      }, Xt.prototype.next = function () {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
      }, Xt.prototype.eat = function (t) {
        var e = this.string.charAt(this.pos);
        if ("string" == typeof t ? e == t : e && (t.test ? t.test(e) : t(e))) return ++this.pos, e;
      }, Xt.prototype.eatWhile = function (t) {
        for (var e = this.pos; this.eat(t););
        return this.pos > e;
      }, Xt.prototype.eatSpace = function () {
        for (var t = this.pos; /[\s\u00a0]/.test(this.string.charAt(this.pos));) ++this.pos;
        return this.pos > t;
      }, Xt.prototype.skipToEnd = function () {
        this.pos = this.string.length;
      }, Xt.prototype.skipTo = function (t) {
        var e = this.string.indexOf(t, this.pos);
        if (e > -1) return this.pos = e, !0;
      }, Xt.prototype.backUp = function (t) {
        this.pos -= t;
      }, Xt.prototype.column = function () {
        return this.lastColumnPos < this.start && (this.lastColumnValue = B(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue - (this.lineStart ? B(this.string, this.lineStart, this.tabSize) : 0);
      }, Xt.prototype.indentation = function () {
        return B(this.string, null, this.tabSize) - (this.lineStart ? B(this.string, this.lineStart, this.tabSize) : 0);
      }, Xt.prototype.match = function (t, e, n) {
        if ("string" != typeof t) {
          var r = this.string.slice(this.pos).match(t);
          return r && r.index > 0 ? null : (r && !1 !== e && (this.pos += r[0].length), r);
        }
        var i = function i(t) {
          return n ? t.toLowerCase() : t;
        };
        if (i(this.string.substr(this.pos, t.length)) == i(t)) return !1 !== e && (this.pos += t.length), !0;
      }, Xt.prototype.current = function () {
        return this.string.slice(this.start, this.pos);
      }, Xt.prototype.hideFirstChars = function (t, e) {
        this.lineStart += t;
        try {
          return e();
        } finally {
          this.lineStart -= t;
        }
      }, Xt.prototype.lookAhead = function (t) {
        var e = this.lineOracle;
        return e && e.lookAhead(t);
      }, Xt.prototype.baseToken = function () {
        var t = this.lineOracle;
        return t && t.baseToken(this.pos);
      };
      var pe = function pe(t, e) {
          this.state = t, this.lookAhead = e;
        },
        ge = function ge(t, e, n, r) {
          this.state = e, this.doc = t, this.line = n, this.maxLookAhead = r || 0, this.baseTokens = null, this.baseTokenPos = 1;
        };
      function ve(t, e, n, r) {
        var i = [t.state.modeGen],
          o = {};
        ke(t, e.text, t.doc.mode, n, function (t, e) {
          return i.push(t, e);
        }, o, r);
        for (var a = n.state, s = function s(r) {
            n.baseTokens = i;
            var s = t.state.overlays[r],
              l = 1,
              c = 0;
            n.state = !0, ke(t, e.text, s.mode, n, function (t, e) {
              for (var n = l; c < t;) {
                var r = i[l];
                r > t && i.splice(l, 1, t, i[l + 1], r), l += 2, c = Math.min(t, r);
              }
              if (e) if (s.opaque) i.splice(n, l - n, t, "overlay " + e), l = n + 2;else for (; n < l; n += 2) {
                var o = i[n + 1];
                i[n + 1] = (o ? o + " " : "") + "overlay " + e;
              }
            }, o), n.state = a, n.baseTokens = null, n.baseTokenPos = 1;
          }, l = 0; l < t.state.overlays.length; ++l) s(l);
        return {
          styles: i,
          classes: o.bgClass || o.textClass ? o : null
        };
      }
      function me(t, e, n) {
        if (!e.styles || e.styles[0] != t.state.modeGen) {
          var r = be(t, ee(e)),
            i = e.text.length > t.options.maxHighlightLength && Gt(t.doc.mode, r.state),
            o = ve(t, e, r);
          i && (r.state = i), e.stateAfter = r.save(!i), e.styles = o.styles, o.classes ? e.styleClasses = o.classes : e.styleClasses && (e.styleClasses = null), n === t.doc.highlightFrontier && (t.doc.modeFrontier = Math.max(t.doc.modeFrontier, ++t.doc.highlightFrontier));
        }
        return e.styles;
      }
      function be(t, e, n) {
        var r = t.doc,
          i = t.display;
        if (!r.mode.startState) return new ge(r, !0, e);
        var o = function (t, e, n) {
            for (var r, i, o = t.doc, a = n ? -1 : e - (t.doc.mode.innerMode ? 1e3 : 100), s = e; s > a; --s) {
              if (s <= o.first) return o.first;
              var l = Jt(o, s - 1),
                c = l.stateAfter;
              if (c && (!n || s + (c instanceof pe ? c.lookAhead : 0) <= o.modeFrontier)) return s;
              var u = B(l.text, null, t.options.tabSize);
              (null == i || r > u) && (i = s - 1, r = u);
            }
            return i;
          }(t, e, n),
          a = o > r.first && Jt(r, o - 1).stateAfter,
          s = a ? ge.fromSaved(r, a, o) : new ge(r, Yt(r.mode), o);
        return r.iter(o, e, function (n) {
          ye(t, n.text, s);
          var r = s.line;
          n.stateAfter = r == e - 1 || r % 5 == 0 || r >= i.viewFrom && r < i.viewTo ? s.save() : null, s.nextLine();
        }), n && (r.modeFrontier = s.line), s;
      }
      function ye(t, e, n, r) {
        var i = t.doc.mode,
          o = new Xt(e, t.options.tabSize, n);
        for (o.start = o.pos = r || 0, "" == e && we(i, n.state); !o.eol();) xe(i, o, n.state), o.start = o.pos;
      }
      function we(t, e) {
        if (t.blankLine) return t.blankLine(e);
        if (t.innerMode) {
          var n = Kt(t, e);
          return n.mode.blankLine ? n.mode.blankLine(n.state) : void 0;
        }
      }
      function xe(t, e, n, r) {
        for (var i = 0; i < 10; i++) {
          r && (r[0] = Kt(t, n).mode);
          var o = t.token(e, n);
          if (e.pos > e.start) return o;
        }
        throw new Error("Mode " + t.name + " failed to advance stream.");
      }
      ge.prototype.lookAhead = function (t) {
        var e = this.doc.getLine(this.line + t);
        return null != e && t > this.maxLookAhead && (this.maxLookAhead = t), e;
      }, ge.prototype.baseToken = function (t) {
        if (!this.baseTokens) return null;
        for (; this.baseTokens[this.baseTokenPos] <= t;) this.baseTokenPos += 2;
        var e = this.baseTokens[this.baseTokenPos + 1];
        return {
          type: e && e.replace(/( |^)overlay .*/, ""),
          size: this.baseTokens[this.baseTokenPos] - t
        };
      }, ge.prototype.nextLine = function () {
        this.line++, this.maxLookAhead > 0 && this.maxLookAhead--;
      }, ge.fromSaved = function (t, e, n) {
        return e instanceof pe ? new ge(t, Gt(t.mode, e.state), n, e.lookAhead) : new ge(t, Gt(t.mode, e), n);
      }, ge.prototype.save = function (t) {
        var e = !1 !== t ? Gt(this.doc.mode, this.state) : this.state;
        return this.maxLookAhead > 0 ? new pe(e, this.maxLookAhead) : e;
      };
      var Oe = function Oe(t, e, n) {
        this.start = t.start, this.end = t.pos, this.string = t.current(), this.type = e || null, this.state = n;
      };
      function Ce(t, e, n, r) {
        var i,
          o,
          a = t.doc,
          s = a.mode,
          l = Jt(a, (e = he(a, e)).line),
          c = be(t, e.line, n),
          u = new Xt(l.text, t.options.tabSize, c);
        for (r && (o = []); (r || u.pos < e.ch) && !u.eol();) u.start = u.pos, i = xe(s, u, c.state), r && o.push(new Oe(u, i, Gt(a.mode, c.state)));
        return r ? o : new Oe(u, i, c.state);
      }
      function Se(t, e) {
        if (t) for (;;) {
          var n = t.match(/(?:^|\s+)line-(background-)?(\S+)/);
          if (!n) break;
          t = t.slice(0, n.index) + t.slice(n.index + n[0].length);
          var r = n[1] ? "bgClass" : "textClass";
          null == e[r] ? e[r] = n[2] : new RegExp("(?:^|\\s)" + n[2] + "(?:$|\\s)").test(e[r]) || (e[r] += " " + n[2]);
        }
        return t;
      }
      function ke(t, e, n, r, i, o, a) {
        var s = n.flattenSpans;
        null == s && (s = t.options.flattenSpans);
        var l,
          c = 0,
          u = null,
          d = new Xt(e, t.options.tabSize, r),
          h = t.options.addModeClass && [null];
        for ("" == e && Se(we(n, r.state), o); !d.eol();) {
          if (d.pos > t.options.maxHighlightLength ? (s = !1, a && ye(t, e, r, d.pos), d.pos = e.length, l = null) : l = Se(xe(n, d, r.state, h), o), h) {
            var f = h[0].name;
            f && (l = "m-" + (l ? f + " " + l : f));
          }
          if (!s || u != l) {
            for (; c < d.start;) i(c = Math.min(d.start, c + 5e3), u);
            u = l;
          }
          d.start = d.pos;
        }
        for (; c < d.pos;) {
          var p = Math.min(d.pos, c + 5e3);
          i(p, u), c = p;
        }
      }
      var je = !1,
        Te = !1;
      function Pe(t, e, n) {
        this.marker = t, this.from = e, this.to = n;
      }
      function Ee(t, e) {
        if (t) for (var n = 0; n < t.length; ++n) {
          var r = t[n];
          if (r.marker == e) return r;
        }
      }
      function De(t, e) {
        for (var n, r = 0; r < t.length; ++r) t[r] != e && (n || (n = [])).push(t[r]);
        return n;
      }
      function Me(t, e) {
        if (e.full) return null;
        var n = re(t, e.from.line) && Jt(t, e.from.line).markedSpans,
          r = re(t, e.to.line) && Jt(t, e.to.line).markedSpans;
        if (!n && !r) return null;
        var i = e.from.ch,
          o = e.to.ch,
          a = 0 == ae(e.from, e.to),
          s = function (t, e, n) {
            var r;
            if (t) for (var i = 0; i < t.length; ++i) {
              var o = t[i],
                a = o.marker;
              if (null == o.from || (a.inclusiveLeft ? o.from <= e : o.from < e) || o.from == e && "bookmark" == a.type && (!n || !o.marker.insertLeft)) {
                var s = null == o.to || (a.inclusiveRight ? o.to >= e : o.to > e);
                (r || (r = [])).push(new Pe(a, o.from, s ? null : o.to));
              }
            }
            return r;
          }(n, i, a),
          l = function (t, e, n) {
            var r;
            if (t) for (var i = 0; i < t.length; ++i) {
              var o = t[i],
                a = o.marker;
              if (null == o.to || (a.inclusiveRight ? o.to >= e : o.to > e) || o.from == e && "bookmark" == a.type && (!n || o.marker.insertLeft)) {
                var s = null == o.from || (a.inclusiveLeft ? o.from <= e : o.from < e);
                (r || (r = [])).push(new Pe(a, s ? null : o.from - e, null == o.to ? null : o.to - e));
              }
            }
            return r;
          }(r, o, a),
          c = 1 == e.text.length,
          u = Q(e.text).length + (c ? i : 0);
        if (s) for (var d = 0; d < s.length; ++d) {
          var h = s[d];
          if (null == h.to) {
            var f = Ee(l, h.marker);
            f ? c && (h.to = null == f.to ? null : f.to + u) : h.to = i;
          }
        }
        if (l) for (var p = 0; p < l.length; ++p) {
          var g = l[p];
          null != g.to && (g.to += u), null == g.from ? Ee(s, g.marker) || (g.from = u, c && (s || (s = [])).push(g)) : (g.from += u, c && (s || (s = [])).push(g));
        }
        s && (s = Ae(s)), l && l != s && (l = Ae(l));
        var v = [s];
        if (!c) {
          var m,
            b = e.text.length - 2;
          if (b > 0 && s) for (var y = 0; y < s.length; ++y) null == s[y].to && (m || (m = [])).push(new Pe(s[y].marker, null, null));
          for (var w = 0; w < b; ++w) v.push(m);
          v.push(l);
        }
        return v;
      }
      function Ae(t) {
        for (var e = 0; e < t.length; ++e) {
          var n = t[e];
          null != n.from && n.from == n.to && !1 !== n.marker.clearWhenEmpty && t.splice(e--, 1);
        }
        return t.length ? t : null;
      }
      function Le(t) {
        var e = t.markedSpans;
        if (e) {
          for (var n = 0; n < e.length; ++n) e[n].marker.detachLine(t);
          t.markedSpans = null;
        }
      }
      function Ne(t, e) {
        if (e) {
          for (var n = 0; n < e.length; ++n) e[n].marker.attachLine(t);
          t.markedSpans = e;
        }
      }
      function _e(t) {
        return t.inclusiveLeft ? -1 : 0;
      }
      function Ie(t) {
        return t.inclusiveRight ? 1 : 0;
      }
      function Fe(t, e) {
        var n = t.lines.length - e.lines.length;
        if (0 != n) return n;
        var r = t.find(),
          i = e.find(),
          o = ae(r.from, i.from) || _e(t) - _e(e);
        if (o) return -o;
        var a = ae(r.to, i.to) || Ie(t) - Ie(e);
        return a || e.id - t.id;
      }
      function Ve(t, e) {
        var n,
          r = Te && t.markedSpans;
        if (r) for (var i = void 0, o = 0; o < r.length; ++o) (i = r[o]).marker.collapsed && null == (e ? i.from : i.to) && (!n || Fe(n, i.marker) < 0) && (n = i.marker);
        return n;
      }
      function Re(t) {
        return Ve(t, !0);
      }
      function ze(t) {
        return Ve(t, !1);
      }
      function He(t, e) {
        var n,
          r = Te && t.markedSpans;
        if (r) for (var i = 0; i < r.length; ++i) {
          var o = r[i];
          o.marker.collapsed && (null == o.from || o.from < e) && (null == o.to || o.to > e) && (!n || Fe(n, o.marker) < 0) && (n = o.marker);
        }
        return n;
      }
      function $e(t, e, n, r, i) {
        var o = Jt(t, e),
          a = Te && o.markedSpans;
        if (a) for (var s = 0; s < a.length; ++s) {
          var l = a[s];
          if (l.marker.collapsed) {
            var c = l.marker.find(0),
              u = ae(c.from, n) || _e(l.marker) - _e(i),
              d = ae(c.to, r) || Ie(l.marker) - Ie(i);
            if (!(u >= 0 && d <= 0 || u <= 0 && d >= 0) && (u <= 0 && (l.marker.inclusiveRight && i.inclusiveLeft ? ae(c.to, n) >= 0 : ae(c.to, n) > 0) || u >= 0 && (l.marker.inclusiveRight && i.inclusiveLeft ? ae(c.from, r) <= 0 : ae(c.from, r) < 0))) return !0;
          }
        }
      }
      function Be(t) {
        for (var e; e = Re(t);) t = e.find(-1, !0).line;
        return t;
      }
      function We(t, e) {
        var n = Jt(t, e),
          r = Be(n);
        return n == r ? e : ee(r);
      }
      function Ue(t, e) {
        if (e > t.lastLine()) return e;
        var n,
          r = Jt(t, e);
        if (!qe(t, r)) return e;
        for (; n = ze(r);) r = n.find(1, !0).line;
        return ee(r) + 1;
      }
      function qe(t, e) {
        var n = Te && e.markedSpans;
        if (n) for (var r = void 0, i = 0; i < n.length; ++i) if ((r = n[i]).marker.collapsed) {
          if (null == r.from) return !0;
          if (!r.marker.widgetNode && 0 == r.from && r.marker.inclusiveLeft && Ge(t, e, r)) return !0;
        }
      }
      function Ge(t, e, n) {
        if (null == n.to) {
          var r = n.marker.find(1, !0);
          return Ge(t, r.line, Ee(r.line.markedSpans, n.marker));
        }
        if (n.marker.inclusiveRight && n.to == e.text.length) return !0;
        for (var i = void 0, o = 0; o < e.markedSpans.length; ++o) if ((i = e.markedSpans[o]).marker.collapsed && !i.marker.widgetNode && i.from == n.to && (null == i.to || i.to != n.from) && (i.marker.inclusiveLeft || n.marker.inclusiveRight) && Ge(t, e, i)) return !0;
      }
      function Ke(t) {
        for (var e = 0, n = (t = Be(t)).parent, r = 0; r < n.lines.length; ++r) {
          var i = n.lines[r];
          if (i == t) break;
          e += i.height;
        }
        for (var o = n.parent; o; o = (n = o).parent) for (var a = 0; a < o.children.length; ++a) {
          var s = o.children[a];
          if (s == n) break;
          e += s.height;
        }
        return e;
      }
      function Ye(t) {
        if (0 == t.height) return 0;
        for (var e, n = t.text.length, r = t; e = Re(r);) {
          var i = e.find(0, !0);
          r = i.from.line, n += i.from.ch - i.to.ch;
        }
        for (r = t; e = ze(r);) {
          var o = e.find(0, !0);
          n -= r.text.length - o.from.ch, n += (r = o.to.line).text.length - o.to.ch;
        }
        return n;
      }
      function Xe(t) {
        var e = t.display,
          n = t.doc;
        e.maxLine = Jt(n, n.first), e.maxLineLength = Ye(e.maxLine), e.maxLineChanged = !0, n.iter(function (t) {
          var n = Ye(t);
          n > e.maxLineLength && (e.maxLineLength = n, e.maxLine = t);
        });
      }
      var Je = function Je(t, e, n) {
        this.text = t, Ne(this, e), this.height = n ? n(this) : 1;
      };
      function Ze(t) {
        t.parent = null, Le(t);
      }
      Je.prototype.lineNo = function () {
        return ee(this);
      }, Ct(Je);
      var Qe = {},
        tn = {};
      function en(t, e) {
        if (!t || /^\s*$/.test(t)) return null;
        var n = e.addModeClass ? tn : Qe;
        return n[t] || (n[t] = t.replace(/\S+/g, "cm-$&"));
      }
      function nn(t, e) {
        var n = M("span", null, null, l ? "padding-right: .1px" : null),
          r = {
            pre: M("pre", [n], "CodeMirror-line"),
            content: n,
            col: 0,
            pos: 0,
            cm: t,
            trailingSpace: !1,
            splitSpaces: t.getOption("lineWrapping")
          };
        e.measure = {};
        for (var i = 0; i <= (e.rest ? e.rest.length : 0); i++) {
          var o = i ? e.rest[i - 1] : e.line,
            a = void 0;
          r.pos = 0, r.addToken = on, Nt(t.display.measure) && (a = pt(o, t.doc.direction)) && (r.addToken = an(r.addToken, a)), r.map = [], ln(o, r, me(t, o, e != t.display.externalMeasured && ee(o))), o.styleClasses && (o.styleClasses.bgClass && (r.bgClass = _(o.styleClasses.bgClass, r.bgClass || "")), o.styleClasses.textClass && (r.textClass = _(o.styleClasses.textClass, r.textClass || ""))), 0 == r.map.length && r.map.push(0, 0, r.content.appendChild(Lt(t.display.measure))), 0 == i ? (e.measure.map = r.map, e.measure.cache = {}) : ((e.measure.maps || (e.measure.maps = [])).push(r.map), (e.measure.caches || (e.measure.caches = [])).push({}));
        }
        if (l) {
          var s = r.content.lastChild;
          (/\bcm-tab\b/.test(s.className) || s.querySelector && s.querySelector(".cm-tab")) && (r.content.className = "cm-tab-wrap-hack");
        }
        return yt(t, "renderLine", t, e.line, r.pre), r.pre.className && (r.textClass = _(r.pre.className, r.textClass || "")), r;
      }
      function rn(t) {
        var e = D("span", "•", "cm-invalidchar");
        return e.title = "\\u" + t.charCodeAt(0).toString(16), e.setAttribute("aria-label", e.title), e;
      }
      function on(t, e, n, r, i, o, l) {
        if (e) {
          var c,
            u = t.splitSpaces ? function (t, e) {
              if (t.length > 1 && !/  /.test(t)) return t;
              for (var n = e, r = "", i = 0; i < t.length; i++) {
                var o = t.charAt(i);
                " " != o || !n || i != t.length - 1 && 32 != t.charCodeAt(i + 1) || (o = " "), r += o, n = " " == o;
              }
              return r;
            }(e, t.trailingSpace) : e,
            d = t.cm.state.specialChars,
            h = !1;
          if (d.test(e)) {
            c = document.createDocumentFragment();
            for (var f = 0;;) {
              d.lastIndex = f;
              var p = d.exec(e),
                g = p ? p.index - f : e.length - f;
              if (g) {
                var v = document.createTextNode(u.slice(f, f + g));
                a && s < 9 ? c.appendChild(D("span", [v])) : c.appendChild(v), t.map.push(t.pos, t.pos + g, v), t.col += g, t.pos += g;
              }
              if (!p) break;
              f += g + 1;
              var m = void 0;
              if ("\t" == p[0]) {
                var b = t.cm.options.tabSize,
                  y = b - t.col % b;
                (m = c.appendChild(D("span", Z(y), "cm-tab"))).setAttribute("role", "presentation"), m.setAttribute("cm-text", "\t"), t.col += y;
              } else "\r" == p[0] || "\n" == p[0] ? ((m = c.appendChild(D("span", "\r" == p[0] ? "␍" : "␤", "cm-invalidchar"))).setAttribute("cm-text", p[0]), t.col += 1) : ((m = t.cm.options.specialCharPlaceholder(p[0])).setAttribute("cm-text", p[0]), a && s < 9 ? c.appendChild(D("span", [m])) : c.appendChild(m), t.col += 1);
              t.map.push(t.pos, t.pos + 1, m), t.pos++;
            }
          } else t.col += e.length, c = document.createTextNode(u), t.map.push(t.pos, t.pos + e.length, c), a && s < 9 && (h = !0), t.pos += e.length;
          if (t.trailingSpace = 32 == u.charCodeAt(e.length - 1), n || r || i || h || o || l) {
            var w = n || "";
            r && (w += r), i && (w += i);
            var x = D("span", [c], w, o);
            if (l) for (var O in l) l.hasOwnProperty(O) && "style" != O && "class" != O && x.setAttribute(O, l[O]);
            return t.content.appendChild(x);
          }
          t.content.appendChild(c);
        }
      }
      function an(t, e) {
        return function (n, r, i, o, a, s, l) {
          i = i ? i + " cm-force-border" : "cm-force-border";
          for (var c = n.pos, u = c + r.length;;) {
            for (var d = void 0, h = 0; h < e.length && !((d = e[h]).to > c && d.from <= c); h++);
            if (d.to >= u) return t(n, r, i, o, a, s, l);
            t(n, r.slice(0, d.to - c), i, o, null, s, l), o = null, r = r.slice(d.to - c), c = d.to;
          }
        };
      }
      function sn(t, e, n, r) {
        var i = !r && n.widgetNode;
        i && t.map.push(t.pos, t.pos + e, i), !r && t.cm.display.input.needsContentAttribute && (i || (i = t.content.appendChild(document.createElement("span"))), i.setAttribute("cm-marker", n.id)), i && (t.cm.display.input.setUneditable(i), t.content.appendChild(i)), t.pos += e, t.trailingSpace = !1;
      }
      function ln(t, e, n) {
        var r = t.markedSpans,
          i = t.text,
          o = 0;
        if (r) for (var a, s, l, c, u, d, h, f = i.length, p = 0, g = 1, v = "", m = 0;;) {
          if (m == p) {
            l = c = u = s = "", h = null, d = null, m = 1 / 0;
            for (var b = [], y = void 0, w = 0; w < r.length; ++w) {
              var x = r[w],
                O = x.marker;
              if ("bookmark" == O.type && x.from == p && O.widgetNode) b.push(O);else if (x.from <= p && (null == x.to || x.to > p || O.collapsed && x.to == p && x.from == p)) {
                if (null != x.to && x.to != p && m > x.to && (m = x.to, c = ""), O.className && (l += " " + O.className), O.css && (s = (s ? s + ";" : "") + O.css), O.startStyle && x.from == p && (u += " " + O.startStyle), O.endStyle && x.to == m && (y || (y = [])).push(O.endStyle, x.to), O.title && ((h || (h = {})).title = O.title), O.attributes) for (var C in O.attributes) (h || (h = {}))[C] = O.attributes[C];
                O.collapsed && (!d || Fe(d.marker, O) < 0) && (d = x);
              } else x.from > p && m > x.from && (m = x.from);
            }
            if (y) for (var S = 0; S < y.length; S += 2) y[S + 1] == m && (c += " " + y[S]);
            if (!d || d.from == p) for (var k = 0; k < b.length; ++k) sn(e, 0, b[k]);
            if (d && (d.from || 0) == p) {
              if (sn(e, (null == d.to ? f + 1 : d.to) - p, d.marker, null == d.from), null == d.to) return;
              d.to == p && (d = !1);
            }
          }
          if (p >= f) break;
          for (var j = Math.min(f, m);;) {
            if (v) {
              var T = p + v.length;
              if (!d) {
                var P = T > j ? v.slice(0, j - p) : v;
                e.addToken(e, P, a ? a + l : l, u, p + P.length == m ? c : "", s, h);
              }
              if (T >= j) {
                v = v.slice(j - p), p = j;
                break;
              }
              p = T, u = "";
            }
            v = i.slice(o, o = n[g++]), a = en(n[g++], e.cm.options);
          }
        } else for (var E = 1; E < n.length; E += 2) e.addToken(e, i.slice(o, o = n[E]), en(n[E + 1], e.cm.options));
      }
      function cn(t, e, n) {
        this.line = e, this.rest = function (t) {
          for (var e, n; e = ze(t);) t = e.find(1, !0).line, (n || (n = [])).push(t);
          return n;
        }(e), this.size = this.rest ? ee(Q(this.rest)) - n + 1 : 1, this.node = this.text = null, this.hidden = qe(t, e);
      }
      function un(t, e, n) {
        for (var r, i = [], o = e; o < n; o = r) {
          var a = new cn(t.doc, Jt(t.doc, o), o);
          r = o + a.size, i.push(a);
        }
        return i;
      }
      var dn = null,
        hn = null;
      function fn(t, e) {
        var n = mt(t, e);
        if (n.length) {
          var r,
            i = Array.prototype.slice.call(arguments, 2);
          dn ? r = dn.delayedCallbacks : hn ? r = hn : (r = hn = [], setTimeout(pn, 0));
          for (var o = function o(t) {
              r.push(function () {
                return n[t].apply(null, i);
              });
            }, a = 0; a < n.length; ++a) o(a);
        }
      }
      function pn() {
        var t = hn;
        hn = null;
        for (var e = 0; e < t.length; ++e) t[e]();
      }
      function gn(t, e, n, r) {
        for (var i = 0; i < e.changes.length; i++) {
          var o = e.changes[i];
          "text" == o ? bn(t, e) : "gutter" == o ? wn(t, e, n, r) : "class" == o ? yn(t, e) : "widget" == o && xn(t, e, r);
        }
        e.changes = null;
      }
      function vn(t) {
        return t.node == t.text && (t.node = D("div", null, null, "position: relative"), t.text.parentNode && t.text.parentNode.replaceChild(t.node, t.text), t.node.appendChild(t.text), a && s < 8 && (t.node.style.zIndex = 2)), t.node;
      }
      function mn(t, e) {
        var n = t.display.externalMeasured;
        return n && n.line == e.line ? (t.display.externalMeasured = null, e.measure = n.measure, n.built) : nn(t, e);
      }
      function bn(t, e) {
        var n = e.text.className,
          r = mn(t, e);
        e.text == e.node && (e.node = r.pre), e.text.parentNode.replaceChild(r.pre, e.text), e.text = r.pre, r.bgClass != e.bgClass || r.textClass != e.textClass ? (e.bgClass = r.bgClass, e.textClass = r.textClass, yn(t, e)) : n && (e.text.className = n);
      }
      function yn(t, e) {
        !function (t, e) {
          var n = e.bgClass ? e.bgClass + " " + (e.line.bgClass || "") : e.line.bgClass;
          if (n && (n += " CodeMirror-linebackground"), e.background) n ? e.background.className = n : (e.background.parentNode.removeChild(e.background), e.background = null);else if (n) {
            var r = vn(e);
            e.background = r.insertBefore(D("div", null, n), r.firstChild), t.display.input.setUneditable(e.background);
          }
        }(t, e), e.line.wrapClass ? vn(e).className = e.line.wrapClass : e.node != e.text && (e.node.className = "");
        var n = e.textClass ? e.textClass + " " + (e.line.textClass || "") : e.line.textClass;
        e.text.className = n || "";
      }
      function wn(t, e, n, r) {
        if (e.gutter && (e.node.removeChild(e.gutter), e.gutter = null), e.gutterBackground && (e.node.removeChild(e.gutterBackground), e.gutterBackground = null), e.line.gutterClass) {
          var i = vn(e);
          e.gutterBackground = D("div", null, "CodeMirror-gutter-background " + e.line.gutterClass, "left: " + (t.options.fixedGutter ? r.fixedPos : -r.gutterTotalWidth) + "px; width: " + r.gutterTotalWidth + "px"), t.display.input.setUneditable(e.gutterBackground), i.insertBefore(e.gutterBackground, e.text);
        }
        var o = e.line.gutterMarkers;
        if (t.options.lineNumbers || o) {
          var a = vn(e),
            s = e.gutter = D("div", null, "CodeMirror-gutter-wrapper", "left: " + (t.options.fixedGutter ? r.fixedPos : -r.gutterTotalWidth) + "px");
          if (s.setAttribute("aria-hidden", "true"), t.display.input.setUneditable(s), a.insertBefore(s, e.text), e.line.gutterClass && (s.className += " " + e.line.gutterClass), !t.options.lineNumbers || o && o["CodeMirror-linenumbers"] || (e.lineNumber = s.appendChild(D("div", ie(t.options, n), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + r.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + t.display.lineNumInnerWidth + "px"))), o) for (var l = 0; l < t.display.gutterSpecs.length; ++l) {
            var c = t.display.gutterSpecs[l].className,
              u = o.hasOwnProperty(c) && o[c];
            u && s.appendChild(D("div", [u], "CodeMirror-gutter-elt", "left: " + r.gutterLeft[c] + "px; width: " + r.gutterWidth[c] + "px"));
          }
        }
      }
      function xn(t, e, n) {
        e.alignable && (e.alignable = null);
        for (var r = k("CodeMirror-linewidget"), i = e.node.firstChild, o = void 0; i; i = o) o = i.nextSibling, r.test(i.className) && e.node.removeChild(i);
        Cn(t, e, n);
      }
      function On(t, e, n, r) {
        var i = mn(t, e);
        return e.text = e.node = i.pre, i.bgClass && (e.bgClass = i.bgClass), i.textClass && (e.textClass = i.textClass), yn(t, e), wn(t, e, n, r), Cn(t, e, r), e.node;
      }
      function Cn(t, e, n) {
        if (Sn(t, e.line, e, n, !0), e.rest) for (var r = 0; r < e.rest.length; r++) Sn(t, e.rest[r], e, n, !1);
      }
      function Sn(t, e, n, r, i) {
        if (e.widgets) for (var o = vn(n), a = 0, s = e.widgets; a < s.length; ++a) {
          var l = s[a],
            c = D("div", [l.node], "CodeMirror-linewidget" + (l.className ? " " + l.className : ""));
          l.handleMouseEvents || c.setAttribute("cm-ignore-events", "true"), kn(l, c, n, r), t.display.input.setUneditable(c), i && l.above ? o.insertBefore(c, n.gutter || n.text) : o.appendChild(c), fn(l, "redraw");
        }
      }
      function kn(t, e, n, r) {
        if (t.noHScroll) {
          (n.alignable || (n.alignable = [])).push(e);
          var i = r.wrapperWidth;
          e.style.left = r.fixedPos + "px", t.coverGutter || (i -= r.gutterTotalWidth, e.style.paddingLeft = r.gutterTotalWidth + "px"), e.style.width = i + "px";
        }
        t.coverGutter && (e.style.zIndex = 5, e.style.position = "relative", t.noHScroll || (e.style.marginLeft = -r.gutterTotalWidth + "px"));
      }
      function jn(t) {
        if (null != t.height) return t.height;
        var e = t.doc.cm;
        if (!e) return 0;
        if (!A(document.body, t.node)) {
          var n = "position: relative;";
          t.coverGutter && (n += "margin-left: -" + e.display.gutters.offsetWidth + "px;"), t.noHScroll && (n += "width: " + e.display.wrapper.clientWidth + "px;"), E(e.display.measure, D("div", [t.node], null, n));
        }
        return t.height = t.node.parentNode.offsetHeight;
      }
      function Tn(t, e) {
        for (var n = Pt(e); n != t.wrapper; n = n.parentNode) if (!n || 1 == n.nodeType && "true" == n.getAttribute("cm-ignore-events") || n.parentNode == t.sizer && n != t.mover) return !0;
      }
      function Pn(t) {
        return t.lineSpace.offsetTop;
      }
      function En(t) {
        return t.mover.offsetHeight - t.lineSpace.offsetHeight;
      }
      function Dn(t) {
        if (t.cachedPaddingH) return t.cachedPaddingH;
        var e = E(t.measure, D("pre", "x", "CodeMirror-line-like")),
          n = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle,
          r = {
            left: parseInt(n.paddingLeft),
            right: parseInt(n.paddingRight)
          };
        return isNaN(r.left) || isNaN(r.right) || (t.cachedPaddingH = r), r;
      }
      function Mn(t) {
        return 50 - t.display.nativeBarWidth;
      }
      function An(t) {
        return t.display.scroller.clientWidth - Mn(t) - t.display.barWidth;
      }
      function Ln(t) {
        return t.display.scroller.clientHeight - Mn(t) - t.display.barHeight;
      }
      function Nn(t, e, n) {
        if (t.line == e) return {
          map: t.measure.map,
          cache: t.measure.cache
        };
        if (t.rest) {
          for (var r = 0; r < t.rest.length; r++) if (t.rest[r] == e) return {
            map: t.measure.maps[r],
            cache: t.measure.caches[r]
          };
          for (var i = 0; i < t.rest.length; i++) if (ee(t.rest[i]) > n) return {
            map: t.measure.maps[i],
            cache: t.measure.caches[i],
            before: !0
          };
        }
      }
      function _n(t, e, n, r) {
        return Vn(t, Fn(t, e), n, r);
      }
      function In(t, e) {
        if (e >= t.display.viewFrom && e < t.display.viewTo) return t.display.view[gr(t, e)];
        var n = t.display.externalMeasured;
        return n && e >= n.lineN && e < n.lineN + n.size ? n : void 0;
      }
      function Fn(t, e) {
        var n = ee(e),
          r = In(t, n);
        r && !r.text ? r = null : r && r.changes && (gn(t, r, n, ur(t)), t.curOp.forceUpdate = !0), r || (r = function (t, e) {
          var n = ee(e = Be(e)),
            r = t.display.externalMeasured = new cn(t.doc, e, n);
          r.lineN = n;
          var i = r.built = nn(t, r);
          return r.text = i.pre, E(t.display.lineMeasure, i.pre), r;
        }(t, e));
        var i = Nn(r, e, n);
        return {
          line: e,
          view: r,
          rect: null,
          map: i.map,
          cache: i.cache,
          before: i.before,
          hasHeights: !1
        };
      }
      function Vn(t, e, n, r, i) {
        e.before && (n = -1);
        var o,
          l = n + (r || "");
        return e.cache.hasOwnProperty(l) ? o = e.cache[l] : (e.rect || (e.rect = e.view.text.getBoundingClientRect()), e.hasHeights || (function (t, e, n) {
          var r = t.options.lineWrapping,
            i = r && An(t);
          if (!e.measure.heights || r && e.measure.width != i) {
            var o = e.measure.heights = [];
            if (r) {
              e.measure.width = i;
              for (var a = e.text.firstChild.getClientRects(), s = 0; s < a.length - 1; s++) {
                var l = a[s],
                  c = a[s + 1];
                Math.abs(l.bottom - c.bottom) > 2 && o.push((l.bottom + c.top) / 2 - n.top);
              }
            }
            o.push(n.bottom - n.top);
          }
        }(t, e.view, e.rect), e.hasHeights = !0), (o = function (t, e, n, r) {
          var i,
            o = Hn(e.map, n, r),
            l = o.node,
            c = o.start,
            u = o.end,
            d = o.collapse;
          if (3 == l.nodeType) {
            for (var h = 0; h < 4; h++) {
              for (; c && lt(e.line.text.charAt(o.coverStart + c));) --c;
              for (; o.coverStart + u < o.coverEnd && lt(e.line.text.charAt(o.coverStart + u));) ++u;
              if ((i = a && s < 9 && 0 == c && u == o.coverEnd - o.coverStart ? l.parentNode.getBoundingClientRect() : $n(j(l, c, u).getClientRects(), r)).left || i.right || 0 == c) break;
              u = c, c -= 1, d = "right";
            }
            a && s < 11 && (i = function (t, e) {
              if (!window.screen || null == screen.logicalXDPI || screen.logicalXDPI == screen.deviceXDPI || !function (t) {
                if (null != Rt) return Rt;
                var e = E(t, D("span", "x")),
                  n = e.getBoundingClientRect(),
                  r = j(e, 0, 1).getBoundingClientRect();
                return Rt = Math.abs(n.left - r.left) > 1;
              }(t)) return e;
              var n = screen.logicalXDPI / screen.deviceXDPI,
                r = screen.logicalYDPI / screen.deviceYDPI;
              return {
                left: e.left * n,
                right: e.right * n,
                top: e.top * r,
                bottom: e.bottom * r
              };
            }(t.display.measure, i));
          } else {
            var f;
            c > 0 && (d = r = "right"), i = t.options.lineWrapping && (f = l.getClientRects()).length > 1 ? f["right" == r ? f.length - 1 : 0] : l.getBoundingClientRect();
          }
          if (a && s < 9 && !c && (!i || !i.left && !i.right)) {
            var p = l.parentNode.getClientRects()[0];
            i = p ? {
              left: p.left,
              right: p.left + cr(t.display),
              top: p.top,
              bottom: p.bottom
            } : zn;
          }
          for (var g = i.top - e.rect.top, v = i.bottom - e.rect.top, m = (g + v) / 2, b = e.view.measure.heights, y = 0; y < b.length - 1 && !(m < b[y]); y++);
          var w = y ? b[y - 1] : 0,
            x = b[y],
            O = {
              left: ("right" == d ? i.right : i.left) - e.rect.left,
              right: ("left" == d ? i.left : i.right) - e.rect.left,
              top: w,
              bottom: x
            };
          return i.left || i.right || (O.bogus = !0), t.options.singleCursorHeightPerLine || (O.rtop = g, O.rbottom = v), O;
        }(t, e, n, r)).bogus || (e.cache[l] = o)), {
          left: o.left,
          right: o.right,
          top: i ? o.rtop : o.top,
          bottom: i ? o.rbottom : o.bottom
        };
      }
      var Rn,
        zn = {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        };
      function Hn(t, e, n) {
        for (var r, i, o, a, s, l, c = 0; c < t.length; c += 3) if (s = t[c], l = t[c + 1], e < s ? (i = 0, o = 1, a = "left") : e < l ? o = 1 + (i = e - s) : (c == t.length - 3 || e == l && t[c + 3] > e) && (i = (o = l - s) - 1, e >= l && (a = "right")), null != i) {
          if (r = t[c + 2], s == l && n == (r.insertLeft ? "left" : "right") && (a = n), "left" == n && 0 == i) for (; c && t[c - 2] == t[c - 3] && t[c - 1].insertLeft;) r = t[2 + (c -= 3)], a = "left";
          if ("right" == n && i == l - s) for (; c < t.length - 3 && t[c + 3] == t[c + 4] && !t[c + 5].insertLeft;) r = t[(c += 3) + 2], a = "right";
          break;
        }
        return {
          node: r,
          start: i,
          end: o,
          collapse: a,
          coverStart: s,
          coverEnd: l
        };
      }
      function $n(t, e) {
        var n = zn;
        if ("left" == e) for (var r = 0; r < t.length && (n = t[r]).left == n.right; r++);else for (var i = t.length - 1; i >= 0 && (n = t[i]).left == n.right; i--);
        return n;
      }
      function Bn(t) {
        if (t.measure && (t.measure.cache = {}, t.measure.heights = null, t.rest)) for (var e = 0; e < t.rest.length; e++) t.measure.caches[e] = {};
      }
      function Wn(t) {
        t.display.externalMeasure = null, P(t.display.lineMeasure);
        for (var e = 0; e < t.display.view.length; e++) Bn(t.display.view[e]);
      }
      function Un(t) {
        Wn(t), t.display.cachedCharWidth = t.display.cachedTextHeight = t.display.cachedPaddingH = null, t.options.lineWrapping || (t.display.maxLineChanged = !0), t.display.lineNumChars = null;
      }
      function qn(t) {
        return u && m ? -(t.body.getBoundingClientRect().left - parseInt(getComputedStyle(t.body).marginLeft)) : t.defaultView.pageXOffset || (t.documentElement || t.body).scrollLeft;
      }
      function Gn(t) {
        return u && m ? -(t.body.getBoundingClientRect().top - parseInt(getComputedStyle(t.body).marginTop)) : t.defaultView.pageYOffset || (t.documentElement || t.body).scrollTop;
      }
      function Kn(t) {
        var e = Be(t).widgets,
          n = 0;
        if (e) for (var r = 0; r < e.length; ++r) e[r].above && (n += jn(e[r]));
        return n;
      }
      function Yn(t, e, n, r, i) {
        if (!i) {
          var o = Kn(e);
          n.top += o, n.bottom += o;
        }
        if ("line" == r) return n;
        r || (r = "local");
        var a = Ke(e);
        if ("local" == r ? a += Pn(t.display) : a -= t.display.viewOffset, "page" == r || "window" == r) {
          var s = t.display.lineSpace.getBoundingClientRect();
          a += s.top + ("window" == r ? 0 : Gn(F(t)));
          var l = s.left + ("window" == r ? 0 : qn(F(t)));
          n.left += l, n.right += l;
        }
        return n.top += a, n.bottom += a, n;
      }
      function Xn(t, e, n) {
        if ("div" == n) return e;
        var r = e.left,
          i = e.top;
        if ("page" == n) r -= qn(F(t)), i -= Gn(F(t));else if ("local" == n || !n) {
          var o = t.display.sizer.getBoundingClientRect();
          r += o.left, i += o.top;
        }
        var a = t.display.lineSpace.getBoundingClientRect();
        return {
          left: r - a.left,
          top: i - a.top
        };
      }
      function Jn(t, e, n, r, i) {
        return r || (r = Jt(t.doc, e.line)), Yn(t, r, _n(t, r, e.ch, i), n);
      }
      function Zn(t, e, n, r, i, o) {
        function a(e, a) {
          var s = Vn(t, i, e, a ? "right" : "left", o);
          return a ? s.left = s.right : s.right = s.left, Yn(t, r, s, n);
        }
        r = r || Jt(t.doc, e.line), i || (i = Fn(t, r));
        var s = pt(r, t.doc.direction),
          l = e.ch,
          c = e.sticky;
        if (l >= r.text.length ? (l = r.text.length, c = "before") : l <= 0 && (l = 0, c = "after"), !s) return a("before" == c ? l - 1 : l, "before" == c);
        function u(t, e, n) {
          return a(n ? t - 1 : t, 1 == s[e].level != n);
        }
        var d = ht(s, l, c),
          h = dt,
          f = u(l, d, "before" == c);
        return null != h && (f.other = u(l, h, "before" != c)), f;
      }
      function Qn(t, e) {
        var n = 0;
        e = he(t.doc, e), t.options.lineWrapping || (n = cr(t.display) * e.ch);
        var r = Jt(t.doc, e.line),
          i = Ke(r) + Pn(t.display);
        return {
          left: n,
          right: n,
          top: i,
          bottom: i + r.height
        };
      }
      function tr(t, e, n, r, i) {
        var o = oe(t, e, n);
        return o.xRel = i, r && (o.outside = r), o;
      }
      function er(t, e, n) {
        var r = t.doc;
        if ((n += t.display.viewOffset) < 0) return tr(r.first, 0, null, -1, -1);
        var i = ne(r, n),
          o = r.first + r.size - 1;
        if (i > o) return tr(r.first + r.size - 1, Jt(r, o).text.length, null, 1, 1);
        e < 0 && (e = 0);
        for (var a = Jt(r, i);;) {
          var s = or(t, a, i, e, n),
            l = He(a, s.ch + (s.xRel > 0 || s.outside > 0 ? 1 : 0));
          if (!l) return s;
          var c = l.find(1);
          if (c.line == i) return c;
          a = Jt(r, i = c.line);
        }
      }
      function nr(t, e, n, r) {
        r -= Kn(e);
        var i = e.text.length,
          o = ut(function (e) {
            return Vn(t, n, e - 1).bottom <= r;
          }, i, 0);
        return {
          begin: o,
          end: i = ut(function (e) {
            return Vn(t, n, e).top > r;
          }, o, i)
        };
      }
      function rr(t, e, n, r) {
        return n || (n = Fn(t, e)), nr(t, e, n, Yn(t, e, Vn(t, n, r), "line").top);
      }
      function ir(t, e, n, r) {
        return !(t.bottom <= n) && (t.top > n || (r ? t.left : t.right) > e);
      }
      function or(t, e, n, r, i) {
        i -= Ke(e);
        var o = Fn(t, e),
          a = Kn(e),
          s = 0,
          l = e.text.length,
          c = !0,
          u = pt(e, t.doc.direction);
        if (u) {
          var d = (t.options.lineWrapping ? sr : ar)(t, e, n, o, u, r, i);
          s = (c = 1 != d.level) ? d.from : d.to - 1, l = c ? d.to : d.from - 1;
        }
        var h,
          f,
          p = null,
          g = null,
          v = ut(function (e) {
            var n = Vn(t, o, e);
            return n.top += a, n.bottom += a, !!ir(n, r, i, !1) && (n.top <= i && n.left <= r && (p = e, g = n), !0);
          }, s, l),
          m = !1;
        if (g) {
          var b = r - g.left < g.right - r,
            y = b == c;
          v = p + (y ? 0 : 1), f = y ? "after" : "before", h = b ? g.left : g.right;
        } else {
          c || v != l && v != s || v++, f = 0 == v ? "after" : v == e.text.length ? "before" : Vn(t, o, v - (c ? 1 : 0)).bottom + a <= i == c ? "after" : "before";
          var w = Zn(t, oe(n, v, f), "line", e, o);
          h = w.left, m = i < w.top ? -1 : i >= w.bottom ? 1 : 0;
        }
        return tr(n, v = ct(e.text, v, 1), f, m, r - h);
      }
      function ar(t, e, n, r, i, o, a) {
        var s = ut(function (s) {
            var l = i[s],
              c = 1 != l.level;
            return ir(Zn(t, oe(n, c ? l.to : l.from, c ? "before" : "after"), "line", e, r), o, a, !0);
          }, 0, i.length - 1),
          l = i[s];
        if (s > 0) {
          var c = 1 != l.level,
            u = Zn(t, oe(n, c ? l.from : l.to, c ? "after" : "before"), "line", e, r);
          ir(u, o, a, !0) && u.top > a && (l = i[s - 1]);
        }
        return l;
      }
      function sr(t, e, n, r, i, o, a) {
        var s = nr(t, e, r, a),
          l = s.begin,
          c = s.end;
        /\s/.test(e.text.charAt(c - 1)) && c--;
        for (var u = null, d = null, h = 0; h < i.length; h++) {
          var f = i[h];
          if (!(f.from >= c || f.to <= l)) {
            var p = Vn(t, r, 1 != f.level ? Math.min(c, f.to) - 1 : Math.max(l, f.from)).right,
              g = p < o ? o - p + 1e9 : p - o;
            (!u || d > g) && (u = f, d = g);
          }
        }
        return u || (u = i[i.length - 1]), u.from < l && (u = {
          from: l,
          to: u.to,
          level: u.level
        }), u.to > c && (u = {
          from: u.from,
          to: c,
          level: u.level
        }), u;
      }
      function lr(t) {
        if (null != t.cachedTextHeight) return t.cachedTextHeight;
        if (null == Rn) {
          Rn = D("pre", null, "CodeMirror-line-like");
          for (var e = 0; e < 49; ++e) Rn.appendChild(document.createTextNode("x")), Rn.appendChild(D("br"));
          Rn.appendChild(document.createTextNode("x"));
        }
        E(t.measure, Rn);
        var n = Rn.offsetHeight / 50;
        return n > 3 && (t.cachedTextHeight = n), P(t.measure), n || 1;
      }
      function cr(t) {
        if (null != t.cachedCharWidth) return t.cachedCharWidth;
        var e = D("span", "xxxxxxxxxx"),
          n = D("pre", [e], "CodeMirror-line-like");
        E(t.measure, n);
        var r = e.getBoundingClientRect(),
          i = (r.right - r.left) / 10;
        return i > 2 && (t.cachedCharWidth = i), i || 10;
      }
      function ur(t) {
        for (var e = t.display, n = {}, r = {}, i = e.gutters.clientLeft, o = e.gutters.firstChild, a = 0; o; o = o.nextSibling, ++a) {
          var s = t.display.gutterSpecs[a].className;
          n[s] = o.offsetLeft + o.clientLeft + i, r[s] = o.clientWidth;
        }
        return {
          fixedPos: dr(e),
          gutterTotalWidth: e.gutters.offsetWidth,
          gutterLeft: n,
          gutterWidth: r,
          wrapperWidth: e.wrapper.clientWidth
        };
      }
      function dr(t) {
        return t.scroller.getBoundingClientRect().left - t.sizer.getBoundingClientRect().left;
      }
      function hr(t) {
        var e = lr(t.display),
          n = t.options.lineWrapping,
          r = n && Math.max(5, t.display.scroller.clientWidth / cr(t.display) - 3);
        return function (i) {
          if (qe(t.doc, i)) return 0;
          var o = 0;
          if (i.widgets) for (var a = 0; a < i.widgets.length; a++) i.widgets[a].height && (o += i.widgets[a].height);
          return n ? o + (Math.ceil(i.text.length / r) || 1) * e : o + e;
        };
      }
      function fr(t) {
        var e = t.doc,
          n = hr(t);
        e.iter(function (t) {
          var e = n(t);
          e != t.height && te(t, e);
        });
      }
      function pr(t, e, n, r) {
        var i = t.display;
        if (!n && "true" == Pt(e).getAttribute("cm-not-content")) return null;
        var o,
          a,
          s = i.lineSpace.getBoundingClientRect();
        try {
          o = e.clientX - s.left, a = e.clientY - s.top;
        } catch (t) {
          return null;
        }
        var l,
          c = er(t, o, a);
        if (r && c.xRel > 0 && (l = Jt(t.doc, c.line).text).length == c.ch) {
          var u = B(l, l.length, t.options.tabSize) - l.length;
          c = oe(c.line, Math.max(0, Math.round((o - Dn(t.display).left) / cr(t.display)) - u));
        }
        return c;
      }
      function gr(t, e) {
        if (e >= t.display.viewTo) return null;
        if ((e -= t.display.viewFrom) < 0) return null;
        for (var n = t.display.view, r = 0; r < n.length; r++) if ((e -= n[r].size) < 0) return r;
      }
      function vr(t, e, n, r) {
        null == e && (e = t.doc.first), null == n && (n = t.doc.first + t.doc.size), r || (r = 0);
        var i = t.display;
        if (r && n < i.viewTo && (null == i.updateLineNumbers || i.updateLineNumbers > e) && (i.updateLineNumbers = e), t.curOp.viewChanged = !0, e >= i.viewTo) Te && We(t.doc, e) < i.viewTo && br(t);else if (n <= i.viewFrom) Te && Ue(t.doc, n + r) > i.viewFrom ? br(t) : (i.viewFrom += r, i.viewTo += r);else if (e <= i.viewFrom && n >= i.viewTo) br(t);else if (e <= i.viewFrom) {
          var o = yr(t, n, n + r, 1);
          o ? (i.view = i.view.slice(o.index), i.viewFrom = o.lineN, i.viewTo += r) : br(t);
        } else if (n >= i.viewTo) {
          var a = yr(t, e, e, -1);
          a ? (i.view = i.view.slice(0, a.index), i.viewTo = a.lineN) : br(t);
        } else {
          var s = yr(t, e, e, -1),
            l = yr(t, n, n + r, 1);
          s && l ? (i.view = i.view.slice(0, s.index).concat(un(t, s.lineN, l.lineN)).concat(i.view.slice(l.index)), i.viewTo += r) : br(t);
        }
        var c = i.externalMeasured;
        c && (n < c.lineN ? c.lineN += r : e < c.lineN + c.size && (i.externalMeasured = null));
      }
      function mr(t, e, n) {
        t.curOp.viewChanged = !0;
        var r = t.display,
          i = t.display.externalMeasured;
        if (i && e >= i.lineN && e < i.lineN + i.size && (r.externalMeasured = null), !(e < r.viewFrom || e >= r.viewTo)) {
          var o = r.view[gr(t, e)];
          if (null != o.node) {
            var a = o.changes || (o.changes = []);
            -1 == U(a, n) && a.push(n);
          }
        }
      }
      function br(t) {
        t.display.viewFrom = t.display.viewTo = t.doc.first, t.display.view = [], t.display.viewOffset = 0;
      }
      function yr(t, e, n, r) {
        var i,
          o = gr(t, e),
          a = t.display.view;
        if (!Te || n == t.doc.first + t.doc.size) return {
          index: o,
          lineN: n
        };
        for (var s = t.display.viewFrom, l = 0; l < o; l++) s += a[l].size;
        if (s != e) {
          if (r > 0) {
            if (o == a.length - 1) return null;
            i = s + a[o].size - e, o++;
          } else i = s - e;
          e += i, n += i;
        }
        for (; We(t.doc, n) != n;) {
          if (o == (r < 0 ? 0 : a.length - 1)) return null;
          n += r * a[o - (r < 0 ? 1 : 0)].size, o += r;
        }
        return {
          index: o,
          lineN: n
        };
      }
      function wr(t) {
        for (var e = t.display.view, n = 0, r = 0; r < e.length; r++) {
          var i = e[r];
          i.hidden || i.node && !i.changes || ++n;
        }
        return n;
      }
      function xr(t) {
        t.display.input.showSelection(t.display.input.prepareSelection());
      }
      function Or(t, e) {
        void 0 === e && (e = !0);
        var n = t.doc,
          r = {},
          i = r.cursors = document.createDocumentFragment(),
          o = r.selection = document.createDocumentFragment(),
          a = t.options.$customCursor;
        a && (e = !0);
        for (var s = 0; s < n.sel.ranges.length; s++) if (e || s != n.sel.primIndex) {
          var l = n.sel.ranges[s];
          if (!(l.from().line >= t.display.viewTo || l.to().line < t.display.viewFrom)) {
            var c = l.empty();
            if (a) {
              var u = a(t, l);
              u && Cr(t, u, i);
            } else (c || t.options.showCursorWhenSelecting) && Cr(t, l.head, i);
            c || kr(t, l, o);
          }
        }
        return r;
      }
      function Cr(t, e, n) {
        var r = Zn(t, e, "div", null, null, !t.options.singleCursorHeightPerLine),
          i = n.appendChild(D("div", " ", "CodeMirror-cursor"));
        if (i.style.left = r.left + "px", i.style.top = r.top + "px", i.style.height = Math.max(0, r.bottom - r.top) * t.options.cursorHeight + "px", /\bcm-fat-cursor\b/.test(t.getWrapperElement().className)) {
          var o = Jn(t, e, "div", null, null),
            a = o.right - o.left;
          i.style.width = (a > 0 ? a : t.defaultCharWidth()) + "px";
        }
        if (r.other) {
          var s = n.appendChild(D("div", " ", "CodeMirror-cursor CodeMirror-secondarycursor"));
          s.style.display = "", s.style.left = r.other.left + "px", s.style.top = r.other.top + "px", s.style.height = .85 * (r.other.bottom - r.other.top) + "px";
        }
      }
      function Sr(t, e) {
        return t.top - e.top || t.left - e.left;
      }
      function kr(t, e, n) {
        var r = t.display,
          i = t.doc,
          o = document.createDocumentFragment(),
          a = Dn(t.display),
          s = a.left,
          l = Math.max(r.sizerWidth, An(t) - r.sizer.offsetLeft) - a.right,
          c = "ltr" == i.direction;
        function u(t, e, n, r) {
          e < 0 && (e = 0), e = Math.round(e), r = Math.round(r), o.appendChild(D("div", null, "CodeMirror-selected", "position: absolute; left: " + t + "px;\n                             top: " + e + "px; width: " + (null == n ? l - t : n) + "px;\n                             height: " + (r - e) + "px"));
        }
        function d(e, n, r) {
          var o,
            a,
            d = Jt(i, e),
            h = d.text.length;
          function f(n, r) {
            return Jn(t, oe(e, n), "div", d, r);
          }
          function p(e, n, r) {
            var i = rr(t, d, null, e),
              o = "ltr" == n == ("after" == r) ? "left" : "right";
            return f("after" == r ? i.begin : i.end - (/\s/.test(d.text.charAt(i.end - 1)) ? 2 : 1), o)[o];
          }
          var g = pt(d, i.direction);
          return function (t, e, n, r) {
            if (!t) return r(e, n, "ltr", 0);
            for (var i = !1, o = 0; o < t.length; ++o) {
              var a = t[o];
              (a.from < n && a.to > e || e == n && a.to == e) && (r(Math.max(a.from, e), Math.min(a.to, n), 1 == a.level ? "rtl" : "ltr", o), i = !0);
            }
            i || r(e, n, "ltr");
          }(g, n || 0, null == r ? h : r, function (t, e, i, d) {
            var v = "ltr" == i,
              m = f(t, v ? "left" : "right"),
              b = f(e - 1, v ? "right" : "left"),
              y = null == n && 0 == t,
              w = null == r && e == h,
              x = 0 == d,
              O = !g || d == g.length - 1;
            if (b.top - m.top <= 3) {
              var C = (c ? w : y) && O,
                S = (c ? y : w) && x ? s : (v ? m : b).left,
                k = C ? l : (v ? b : m).right;
              u(S, m.top, k - S, m.bottom);
            } else {
              var j, T, P, E;
              v ? (j = c && y && x ? s : m.left, T = c ? l : p(t, i, "before"), P = c ? s : p(e, i, "after"), E = c && w && O ? l : b.right) : (j = c ? p(t, i, "before") : s, T = !c && y && x ? l : m.right, P = !c && w && O ? s : b.left, E = c ? p(e, i, "after") : l), u(j, m.top, T - j, m.bottom), m.bottom < b.top && u(s, m.bottom, null, b.top), u(P, b.top, E - P, b.bottom);
            }
            (!o || Sr(m, o) < 0) && (o = m), Sr(b, o) < 0 && (o = b), (!a || Sr(m, a) < 0) && (a = m), Sr(b, a) < 0 && (a = b);
          }), {
            start: o,
            end: a
          };
        }
        var h = e.from(),
          f = e.to();
        if (h.line == f.line) d(h.line, h.ch, f.ch);else {
          var p = Jt(i, h.line),
            g = Jt(i, f.line),
            v = Be(p) == Be(g),
            m = d(h.line, h.ch, v ? p.text.length + 1 : null).end,
            b = d(f.line, v ? 0 : null, f.ch).start;
          v && (m.top < b.top - 2 ? (u(m.right, m.top, null, m.bottom), u(s, b.top, b.left, b.bottom)) : u(m.right, m.top, b.left - m.right, m.bottom)), m.bottom < b.top && u(s, m.bottom, null, b.top);
        }
        n.appendChild(o);
      }
      function jr(t) {
        if (t.state.focused) {
          var e = t.display;
          clearInterval(e.blinker);
          var n = !0;
          e.cursorDiv.style.visibility = "", t.options.cursorBlinkRate > 0 ? e.blinker = setInterval(function () {
            t.hasFocus() || Dr(t), e.cursorDiv.style.visibility = (n = !n) ? "" : "hidden";
          }, t.options.cursorBlinkRate) : t.options.cursorBlinkRate < 0 && (e.cursorDiv.style.visibility = "hidden");
        }
      }
      function Tr(t) {
        t.hasFocus() || (t.display.input.focus(), t.state.focused || Er(t));
      }
      function Pr(t) {
        t.state.delayingBlurEvent = !0, setTimeout(function () {
          t.state.delayingBlurEvent && (t.state.delayingBlurEvent = !1, t.state.focused && Dr(t));
        }, 100);
      }
      function Er(t, e) {
        t.state.delayingBlurEvent && !t.state.draggingText && (t.state.delayingBlurEvent = !1), "nocursor" != t.options.readOnly && (t.state.focused || (yt(t, "focus", t, e), t.state.focused = !0, N(t.display.wrapper, "CodeMirror-focused"), t.curOp || t.display.selForContextMenu == t.doc.sel || (t.display.input.reset(), l && setTimeout(function () {
          return t.display.input.reset(!0);
        }, 20)), t.display.input.receivedFocus()), jr(t));
      }
      function Dr(t, e) {
        t.state.delayingBlurEvent || (t.state.focused && (yt(t, "blur", t, e), t.state.focused = !1, T(t.display.wrapper, "CodeMirror-focused")), clearInterval(t.display.blinker), setTimeout(function () {
          t.state.focused || (t.display.shift = !1);
        }, 150));
      }
      function Mr(t) {
        for (var e = t.display, n = e.lineDiv.offsetTop, r = Math.max(0, e.scroller.getBoundingClientRect().top), i = e.lineDiv.getBoundingClientRect().top, o = 0, l = 0; l < e.view.length; l++) {
          var c = e.view[l],
            u = t.options.lineWrapping,
            d = void 0,
            h = 0;
          if (!c.hidden) {
            if (i += c.line.height, a && s < 8) {
              var f = c.node.offsetTop + c.node.offsetHeight;
              d = f - n, n = f;
            } else {
              var p = c.node.getBoundingClientRect();
              d = p.bottom - p.top, !u && c.text.firstChild && (h = c.text.firstChild.getBoundingClientRect().right - p.left - 1);
            }
            var g = c.line.height - d;
            if ((g > .005 || g < -.005) && (i < r && (o -= g), te(c.line, d), Ar(c.line), c.rest)) for (var v = 0; v < c.rest.length; v++) Ar(c.rest[v]);
            if (h > t.display.sizerWidth) {
              var m = Math.ceil(h / cr(t.display));
              m > t.display.maxLineLength && (t.display.maxLineLength = m, t.display.maxLine = c.line, t.display.maxLineChanged = !0);
            }
          }
        }
        Math.abs(o) > 2 && (e.scroller.scrollTop += o);
      }
      function Ar(t) {
        if (t.widgets) for (var e = 0; e < t.widgets.length; ++e) {
          var n = t.widgets[e],
            r = n.node.parentNode;
          r && (n.height = r.offsetHeight);
        }
      }
      function Lr(t, e, n) {
        var r = n && null != n.top ? Math.max(0, n.top) : t.scroller.scrollTop;
        r = Math.floor(r - Pn(t));
        var i = n && null != n.bottom ? n.bottom : r + t.wrapper.clientHeight,
          o = ne(e, r),
          a = ne(e, i);
        if (n && n.ensure) {
          var s = n.ensure.from.line,
            l = n.ensure.to.line;
          s < o ? (o = s, a = ne(e, Ke(Jt(e, s)) + t.wrapper.clientHeight)) : Math.min(l, e.lastLine()) >= a && (o = ne(e, Ke(Jt(e, l)) - t.wrapper.clientHeight), a = l);
        }
        return {
          from: o,
          to: Math.max(a, o + 1)
        };
      }
      function Nr(t, e) {
        var n = t.display,
          r = lr(t.display);
        e.top < 0 && (e.top = 0);
        var i = t.curOp && null != t.curOp.scrollTop ? t.curOp.scrollTop : n.scroller.scrollTop,
          o = Ln(t),
          a = {};
        e.bottom - e.top > o && (e.bottom = e.top + o);
        var s = t.doc.height + En(n),
          l = e.top < r,
          c = e.bottom > s - r;
        if (e.top < i) a.scrollTop = l ? 0 : e.top;else if (e.bottom > i + o) {
          var u = Math.min(e.top, (c ? s : e.bottom) - o);
          u != i && (a.scrollTop = u);
        }
        var d = t.options.fixedGutter ? 0 : n.gutters.offsetWidth,
          h = t.curOp && null != t.curOp.scrollLeft ? t.curOp.scrollLeft : n.scroller.scrollLeft - d,
          f = An(t) - n.gutters.offsetWidth,
          p = e.right - e.left > f;
        return p && (e.right = e.left + f), e.left < 10 ? a.scrollLeft = 0 : e.left < h ? a.scrollLeft = Math.max(0, e.left + d - (p ? 0 : 10)) : e.right > f + h - 3 && (a.scrollLeft = e.right + (p ? 0 : 10) - f), a;
      }
      function _r(t, e) {
        null != e && (Vr(t), t.curOp.scrollTop = (null == t.curOp.scrollTop ? t.doc.scrollTop : t.curOp.scrollTop) + e);
      }
      function Ir(t) {
        Vr(t);
        var e = t.getCursor();
        t.curOp.scrollToPos = {
          from: e,
          to: e,
          margin: t.options.cursorScrollMargin
        };
      }
      function Fr(t, e, n) {
        null == e && null == n || Vr(t), null != e && (t.curOp.scrollLeft = e), null != n && (t.curOp.scrollTop = n);
      }
      function Vr(t) {
        var e = t.curOp.scrollToPos;
        e && (t.curOp.scrollToPos = null, Rr(t, Qn(t, e.from), Qn(t, e.to), e.margin));
      }
      function Rr(t, e, n, r) {
        var i = Nr(t, {
          left: Math.min(e.left, n.left),
          top: Math.min(e.top, n.top) - r,
          right: Math.max(e.right, n.right),
          bottom: Math.max(e.bottom, n.bottom) + r
        });
        Fr(t, i.scrollLeft, i.scrollTop);
      }
      function zr(t, e) {
        Math.abs(t.doc.scrollTop - e) < 2 || (n || fi(t, {
          top: e
        }), Hr(t, e, !0), n && fi(t), li(t, 100));
      }
      function Hr(t, e, n) {
        e = Math.max(0, Math.min(t.display.scroller.scrollHeight - t.display.scroller.clientHeight, e)), (t.display.scroller.scrollTop != e || n) && (t.doc.scrollTop = e, t.display.scrollbars.setScrollTop(e), t.display.scroller.scrollTop != e && (t.display.scroller.scrollTop = e));
      }
      function $r(t, e, n, r) {
        e = Math.max(0, Math.min(e, t.display.scroller.scrollWidth - t.display.scroller.clientWidth)), (n ? e == t.doc.scrollLeft : Math.abs(t.doc.scrollLeft - e) < 2) && !r || (t.doc.scrollLeft = e, vi(t), t.display.scroller.scrollLeft != e && (t.display.scroller.scrollLeft = e), t.display.scrollbars.setScrollLeft(e));
      }
      function Br(t) {
        var e = t.display,
          n = e.gutters.offsetWidth,
          r = Math.round(t.doc.height + En(t.display));
        return {
          clientHeight: e.scroller.clientHeight,
          viewHeight: e.wrapper.clientHeight,
          scrollWidth: e.scroller.scrollWidth,
          clientWidth: e.scroller.clientWidth,
          viewWidth: e.wrapper.clientWidth,
          barLeft: t.options.fixedGutter ? n : 0,
          docHeight: r,
          scrollHeight: r + Mn(t) + e.barHeight,
          nativeBarWidth: e.nativeBarWidth,
          gutterWidth: n
        };
      }
      var Wr = function Wr(t, e, n) {
        this.cm = n;
        var r = this.vert = D("div", [D("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar"),
          i = this.horiz = D("div", [D("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
        r.tabIndex = i.tabIndex = -1, t(r), t(i), vt(r, "scroll", function () {
          r.clientHeight && e(r.scrollTop, "vertical");
        }), vt(i, "scroll", function () {
          i.clientWidth && e(i.scrollLeft, "horizontal");
        }), this.checkedZeroWidth = !1, a && s < 8 && (this.horiz.style.minHeight = this.vert.style.minWidth = "18px");
      };
      Wr.prototype.update = function (t) {
        var e = t.scrollWidth > t.clientWidth + 1,
          n = t.scrollHeight > t.clientHeight + 1,
          r = t.nativeBarWidth;
        if (n) {
          this.vert.style.display = "block", this.vert.style.bottom = e ? r + "px" : "0";
          var i = t.viewHeight - (e ? r : 0);
          this.vert.firstChild.style.height = Math.max(0, t.scrollHeight - t.clientHeight + i) + "px";
        } else this.vert.scrollTop = 0, this.vert.style.display = "", this.vert.firstChild.style.height = "0";
        if (e) {
          this.horiz.style.display = "block", this.horiz.style.right = n ? r + "px" : "0", this.horiz.style.left = t.barLeft + "px";
          var o = t.viewWidth - t.barLeft - (n ? r : 0);
          this.horiz.firstChild.style.width = Math.max(0, t.scrollWidth - t.clientWidth + o) + "px";
        } else this.horiz.style.display = "", this.horiz.firstChild.style.width = "0";
        return !this.checkedZeroWidth && t.clientHeight > 0 && (0 == r && this.zeroWidthHack(), this.checkedZeroWidth = !0), {
          right: n ? r : 0,
          bottom: e ? r : 0
        };
      }, Wr.prototype.setScrollLeft = function (t) {
        this.horiz.scrollLeft != t && (this.horiz.scrollLeft = t), this.disableHoriz && this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
      }, Wr.prototype.setScrollTop = function (t) {
        this.vert.scrollTop != t && (this.vert.scrollTop = t), this.disableVert && this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
      }, Wr.prototype.zeroWidthHack = function () {
        var t = y && !p ? "12px" : "18px";
        this.horiz.style.height = this.vert.style.width = t, this.horiz.style.visibility = this.vert.style.visibility = "hidden", this.disableHoriz = new W(), this.disableVert = new W();
      }, Wr.prototype.enableZeroWidthBar = function (t, e, n) {
        t.style.visibility = "", e.set(1e3, function r() {
          var i = t.getBoundingClientRect();
          ("vert" == n ? document.elementFromPoint(i.right - 1, (i.top + i.bottom) / 2) : document.elementFromPoint((i.right + i.left) / 2, i.bottom - 1)) != t ? t.style.visibility = "hidden" : e.set(1e3, r);
        });
      }, Wr.prototype.clear = function () {
        var t = this.horiz.parentNode;
        t.removeChild(this.horiz), t.removeChild(this.vert);
      };
      var Ur = function Ur() {};
      function qr(t, e) {
        e || (e = Br(t));
        var n = t.display.barWidth,
          r = t.display.barHeight;
        Gr(t, e);
        for (var i = 0; i < 4 && n != t.display.barWidth || r != t.display.barHeight; i++) n != t.display.barWidth && t.options.lineWrapping && Mr(t), Gr(t, Br(t)), n = t.display.barWidth, r = t.display.barHeight;
      }
      function Gr(t, e) {
        var n = t.display,
          r = n.scrollbars.update(e);
        n.sizer.style.paddingRight = (n.barWidth = r.right) + "px", n.sizer.style.paddingBottom = (n.barHeight = r.bottom) + "px", n.heightForcer.style.borderBottom = r.bottom + "px solid transparent", r.right && r.bottom ? (n.scrollbarFiller.style.display = "block", n.scrollbarFiller.style.height = r.bottom + "px", n.scrollbarFiller.style.width = r.right + "px") : n.scrollbarFiller.style.display = "", r.bottom && t.options.coverGutterNextToScrollbar && t.options.fixedGutter ? (n.gutterFiller.style.display = "block", n.gutterFiller.style.height = r.bottom + "px", n.gutterFiller.style.width = e.gutterWidth + "px") : n.gutterFiller.style.display = "";
      }
      Ur.prototype.update = function () {
        return {
          bottom: 0,
          right: 0
        };
      }, Ur.prototype.setScrollLeft = function () {}, Ur.prototype.setScrollTop = function () {}, Ur.prototype.clear = function () {};
      var Kr = {
        native: Wr,
        null: Ur
      };
      function Yr(t) {
        t.display.scrollbars && (t.display.scrollbars.clear(), t.display.scrollbars.addClass && T(t.display.wrapper, t.display.scrollbars.addClass)), t.display.scrollbars = new Kr[t.options.scrollbarStyle](function (e) {
          t.display.wrapper.insertBefore(e, t.display.scrollbarFiller), vt(e, "mousedown", function () {
            t.state.focused && setTimeout(function () {
              return t.display.input.focus();
            }, 0);
          }), e.setAttribute("cm-not-content", "true");
        }, function (e, n) {
          "horizontal" == n ? $r(t, e) : zr(t, e);
        }, t), t.display.scrollbars.addClass && N(t.display.wrapper, t.display.scrollbars.addClass);
      }
      var Xr = 0;
      function Jr(t) {
        var e;
        t.curOp = {
          cm: t,
          viewChanged: !1,
          startHeight: t.doc.height,
          forceUpdate: !1,
          updateInput: 0,
          typing: !1,
          changeObjs: null,
          cursorActivityHandlers: null,
          cursorActivityCalled: 0,
          selectionChanged: !1,
          updateMaxLine: !1,
          scrollLeft: null,
          scrollTop: null,
          scrollToPos: null,
          focus: !1,
          id: ++Xr,
          markArrays: null
        }, e = t.curOp, dn ? dn.ops.push(e) : e.ownsGroup = dn = {
          ops: [e],
          delayedCallbacks: []
        };
      }
      function Zr(t) {
        var e = t.curOp;
        e && function (t, e) {
          var n = t.ownsGroup;
          if (n) try {
            !function (t) {
              var e = t.delayedCallbacks,
                n = 0;
              do {
                for (; n < e.length; n++) e[n].call(null);
                for (var r = 0; r < t.ops.length; r++) {
                  var i = t.ops[r];
                  if (i.cursorActivityHandlers) for (; i.cursorActivityCalled < i.cursorActivityHandlers.length;) i.cursorActivityHandlers[i.cursorActivityCalled++].call(null, i.cm);
                }
              } while (n < e.length);
            }(n);
          } finally {
            dn = null, e(n);
          }
        }(e, function (t) {
          for (var e = 0; e < t.ops.length; e++) t.ops[e].cm.curOp = null;
          !function (t) {
            for (var e = t.ops, n = 0; n < e.length; n++) Qr(e[n]);
            for (var r = 0; r < e.length; r++) ti(e[r]);
            for (var i = 0; i < e.length; i++) ei(e[i]);
            for (var o = 0; o < e.length; o++) ni(e[o]);
            for (var a = 0; a < e.length; a++) ri(e[a]);
          }(t);
        });
      }
      function Qr(t) {
        var e = t.cm,
          n = e.display;
        !function (t) {
          var e = t.display;
          !e.scrollbarsClipped && e.scroller.offsetWidth && (e.nativeBarWidth = e.scroller.offsetWidth - e.scroller.clientWidth, e.heightForcer.style.height = Mn(t) + "px", e.sizer.style.marginBottom = -e.nativeBarWidth + "px", e.sizer.style.borderRightWidth = Mn(t) + "px", e.scrollbarsClipped = !0);
        }(e), t.updateMaxLine && Xe(e), t.mustUpdate = t.viewChanged || t.forceUpdate || null != t.scrollTop || t.scrollToPos && (t.scrollToPos.from.line < n.viewFrom || t.scrollToPos.to.line >= n.viewTo) || n.maxLineChanged && e.options.lineWrapping, t.update = t.mustUpdate && new ui(e, t.mustUpdate && {
          top: t.scrollTop,
          ensure: t.scrollToPos
        }, t.forceUpdate);
      }
      function ti(t) {
        t.updatedDisplay = t.mustUpdate && di(t.cm, t.update);
      }
      function ei(t) {
        var e = t.cm,
          n = e.display;
        t.updatedDisplay && Mr(e), t.barMeasure = Br(e), n.maxLineChanged && !e.options.lineWrapping && (t.adjustWidthTo = _n(e, n.maxLine, n.maxLine.text.length).left + 3, e.display.sizerWidth = t.adjustWidthTo, t.barMeasure.scrollWidth = Math.max(n.scroller.clientWidth, n.sizer.offsetLeft + t.adjustWidthTo + Mn(e) + e.display.barWidth), t.maxScrollLeft = Math.max(0, n.sizer.offsetLeft + t.adjustWidthTo - An(e))), (t.updatedDisplay || t.selectionChanged) && (t.preparedSelection = n.input.prepareSelection());
      }
      function ni(t) {
        var e = t.cm;
        null != t.adjustWidthTo && (e.display.sizer.style.minWidth = t.adjustWidthTo + "px", t.maxScrollLeft < e.doc.scrollLeft && $r(e, Math.min(e.display.scroller.scrollLeft, t.maxScrollLeft), !0), e.display.maxLineChanged = !1);
        var n = t.focus && t.focus == L(V(e));
        t.preparedSelection && e.display.input.showSelection(t.preparedSelection, n), (t.updatedDisplay || t.startHeight != e.doc.height) && qr(e, t.barMeasure), t.updatedDisplay && gi(e, t.barMeasure), t.selectionChanged && jr(e), e.state.focused && t.updateInput && e.display.input.reset(t.typing), n && Tr(t.cm);
      }
      function ri(t) {
        var e = t.cm,
          n = e.display,
          r = e.doc;
        t.updatedDisplay && hi(e, t.update), null == n.wheelStartX || null == t.scrollTop && null == t.scrollLeft && !t.scrollToPos || (n.wheelStartX = n.wheelStartY = null), null != t.scrollTop && Hr(e, t.scrollTop, t.forceScroll), null != t.scrollLeft && $r(e, t.scrollLeft, !0, !0), t.scrollToPos && function (t, e) {
          if (!wt(t, "scrollCursorIntoView")) {
            var n = t.display,
              r = n.sizer.getBoundingClientRect(),
              i = null,
              o = n.wrapper.ownerDocument;
            if (e.top + r.top < 0 ? i = !0 : e.bottom + r.top > (o.defaultView.innerHeight || o.documentElement.clientHeight) && (i = !1), null != i && !g) {
              var a = D("div", "​", null, "position: absolute;\n                         top: " + (e.top - n.viewOffset - Pn(t.display)) + "px;\n                         height: " + (e.bottom - e.top + Mn(t) + n.barHeight) + "px;\n                         left: " + e.left + "px; width: " + Math.max(2, e.right - e.left) + "px;");
              t.display.lineSpace.appendChild(a), a.scrollIntoView(i), t.display.lineSpace.removeChild(a);
            }
          }
        }(e, function (t, e, n, r) {
          var i;
          null == r && (r = 0), t.options.lineWrapping || e != n || (n = "before" == e.sticky ? oe(e.line, e.ch + 1, "before") : e, e = e.ch ? oe(e.line, "before" == e.sticky ? e.ch - 1 : e.ch, "after") : e);
          for (var o = 0; o < 5; o++) {
            var a = !1,
              s = Zn(t, e),
              l = n && n != e ? Zn(t, n) : s,
              c = Nr(t, i = {
                left: Math.min(s.left, l.left),
                top: Math.min(s.top, l.top) - r,
                right: Math.max(s.left, l.left),
                bottom: Math.max(s.bottom, l.bottom) + r
              }),
              u = t.doc.scrollTop,
              d = t.doc.scrollLeft;
            if (null != c.scrollTop && (zr(t, c.scrollTop), Math.abs(t.doc.scrollTop - u) > 1 && (a = !0)), null != c.scrollLeft && ($r(t, c.scrollLeft), Math.abs(t.doc.scrollLeft - d) > 1 && (a = !0)), !a) break;
          }
          return i;
        }(e, he(r, t.scrollToPos.from), he(r, t.scrollToPos.to), t.scrollToPos.margin));
        var i = t.maybeHiddenMarkers,
          o = t.maybeUnhiddenMarkers;
        if (i) for (var a = 0; a < i.length; ++a) i[a].lines.length || yt(i[a], "hide");
        if (o) for (var s = 0; s < o.length; ++s) o[s].lines.length && yt(o[s], "unhide");
        n.wrapper.offsetHeight && (r.scrollTop = e.display.scroller.scrollTop), t.changeObjs && yt(e, "changes", e, t.changeObjs), t.update && t.update.finish();
      }
      function ii(t, e) {
        if (t.curOp) return e();
        Jr(t);
        try {
          return e();
        } finally {
          Zr(t);
        }
      }
      function oi(t, e) {
        return function () {
          if (t.curOp) return e.apply(t, arguments);
          Jr(t);
          try {
            return e.apply(t, arguments);
          } finally {
            Zr(t);
          }
        };
      }
      function ai(t) {
        return function () {
          if (this.curOp) return t.apply(this, arguments);
          Jr(this);
          try {
            return t.apply(this, arguments);
          } finally {
            Zr(this);
          }
        };
      }
      function si(t) {
        return function () {
          var e = this.cm;
          if (!e || e.curOp) return t.apply(this, arguments);
          Jr(e);
          try {
            return t.apply(this, arguments);
          } finally {
            Zr(e);
          }
        };
      }
      function li(t, e) {
        t.doc.highlightFrontier < t.display.viewTo && t.state.highlight.set(e, H(ci, t));
      }
      function ci(t) {
        var e = t.doc;
        if (!(e.highlightFrontier >= t.display.viewTo)) {
          var n = +new Date() + t.options.workTime,
            r = be(t, e.highlightFrontier),
            i = [];
          e.iter(r.line, Math.min(e.first + e.size, t.display.viewTo + 500), function (o) {
            if (r.line >= t.display.viewFrom) {
              var a = o.styles,
                s = o.text.length > t.options.maxHighlightLength ? Gt(e.mode, r.state) : null,
                l = ve(t, o, r, !0);
              s && (r.state = s), o.styles = l.styles;
              var c = o.styleClasses,
                u = l.classes;
              u ? o.styleClasses = u : c && (o.styleClasses = null);
              for (var d = !a || a.length != o.styles.length || c != u && (!c || !u || c.bgClass != u.bgClass || c.textClass != u.textClass), h = 0; !d && h < a.length; ++h) d = a[h] != o.styles[h];
              d && i.push(r.line), o.stateAfter = r.save(), r.nextLine();
            } else o.text.length <= t.options.maxHighlightLength && ye(t, o.text, r), o.stateAfter = r.line % 5 == 0 ? r.save() : null, r.nextLine();
            if (+new Date() > n) return li(t, t.options.workDelay), !0;
          }), e.highlightFrontier = r.line, e.modeFrontier = Math.max(e.modeFrontier, r.line), i.length && ii(t, function () {
            for (var e = 0; e < i.length; e++) mr(t, i[e], "text");
          });
        }
      }
      var ui = function ui(t, e, n) {
        var r = t.display;
        this.viewport = e, this.visible = Lr(r, t.doc, e), this.editorIsHidden = !r.wrapper.offsetWidth, this.wrapperHeight = r.wrapper.clientHeight, this.wrapperWidth = r.wrapper.clientWidth, this.oldDisplayWidth = An(t), this.force = n, this.dims = ur(t), this.events = [];
      };
      function di(t, e) {
        var n = t.display,
          r = t.doc;
        if (e.editorIsHidden) return br(t), !1;
        if (!e.force && e.visible.from >= n.viewFrom && e.visible.to <= n.viewTo && (null == n.updateLineNumbers || n.updateLineNumbers >= n.viewTo) && n.renderedView == n.view && 0 == wr(t)) return !1;
        mi(t) && (br(t), e.dims = ur(t));
        var i = r.first + r.size,
          o = Math.max(e.visible.from - t.options.viewportMargin, r.first),
          a = Math.min(i, e.visible.to + t.options.viewportMargin);
        n.viewFrom < o && o - n.viewFrom < 20 && (o = Math.max(r.first, n.viewFrom)), n.viewTo > a && n.viewTo - a < 20 && (a = Math.min(i, n.viewTo)), Te && (o = We(t.doc, o), a = Ue(t.doc, a));
        var s = o != n.viewFrom || a != n.viewTo || n.lastWrapHeight != e.wrapperHeight || n.lastWrapWidth != e.wrapperWidth;
        !function (t, e, n) {
          var r = t.display;
          0 == r.view.length || e >= r.viewTo || n <= r.viewFrom ? (r.view = un(t, e, n), r.viewFrom = e) : (r.viewFrom > e ? r.view = un(t, e, r.viewFrom).concat(r.view) : r.viewFrom < e && (r.view = r.view.slice(gr(t, e))), r.viewFrom = e, r.viewTo < n ? r.view = r.view.concat(un(t, r.viewTo, n)) : r.viewTo > n && (r.view = r.view.slice(0, gr(t, n)))), r.viewTo = n;
        }(t, o, a), n.viewOffset = Ke(Jt(t.doc, n.viewFrom)), t.display.mover.style.top = n.viewOffset + "px";
        var c = wr(t);
        if (!s && 0 == c && !e.force && n.renderedView == n.view && (null == n.updateLineNumbers || n.updateLineNumbers >= n.viewTo)) return !1;
        var u = function (t) {
          if (t.hasFocus()) return null;
          var e = L(V(t));
          if (!e || !A(t.display.lineDiv, e)) return null;
          var n = {
            activeElt: e
          };
          if (window.getSelection) {
            var r = z(t).getSelection();
            r.anchorNode && r.extend && A(t.display.lineDiv, r.anchorNode) && (n.anchorNode = r.anchorNode, n.anchorOffset = r.anchorOffset, n.focusNode = r.focusNode, n.focusOffset = r.focusOffset);
          }
          return n;
        }(t);
        return c > 4 && (n.lineDiv.style.display = "none"), function (t, e, n) {
          var r = t.display,
            i = t.options.lineNumbers,
            o = r.lineDiv,
            a = o.firstChild;
          function s(e) {
            var n = e.nextSibling;
            return l && y && t.display.currentWheelTarget == e ? e.style.display = "none" : e.parentNode.removeChild(e), n;
          }
          for (var c = r.view, u = r.viewFrom, d = 0; d < c.length; d++) {
            var h = c[d];
            if (h.hidden) ;else if (h.node && h.node.parentNode == o) {
              for (; a != h.node;) a = s(a);
              var f = i && null != e && e <= u && h.lineNumber;
              h.changes && (U(h.changes, "gutter") > -1 && (f = !1), gn(t, h, u, n)), f && (P(h.lineNumber), h.lineNumber.appendChild(document.createTextNode(ie(t.options, u)))), a = h.node.nextSibling;
            } else {
              var p = On(t, h, u, n);
              o.insertBefore(p, a);
            }
            u += h.size;
          }
          for (; a;) a = s(a);
        }(t, n.updateLineNumbers, e.dims), c > 4 && (n.lineDiv.style.display = ""), n.renderedView = n.view, function (t) {
          if (t && t.activeElt && t.activeElt != L(R(t.activeElt)) && (t.activeElt.focus(), !/^(INPUT|TEXTAREA)$/.test(t.activeElt.nodeName) && t.anchorNode && A(document.body, t.anchorNode) && A(document.body, t.focusNode))) {
            var e = t.activeElt.ownerDocument,
              n = e.defaultView.getSelection(),
              r = e.createRange();
            r.setEnd(t.anchorNode, t.anchorOffset), r.collapse(!1), n.removeAllRanges(), n.addRange(r), n.extend(t.focusNode, t.focusOffset);
          }
        }(u), P(n.cursorDiv), P(n.selectionDiv), n.gutters.style.height = n.sizer.style.minHeight = 0, s && (n.lastWrapHeight = e.wrapperHeight, n.lastWrapWidth = e.wrapperWidth, li(t, 400)), n.updateLineNumbers = null, !0;
      }
      function hi(t, e) {
        for (var n = e.viewport, r = !0;; r = !1) {
          if (r && t.options.lineWrapping && e.oldDisplayWidth != An(t)) r && (e.visible = Lr(t.display, t.doc, n));else if (n && null != n.top && (n = {
            top: Math.min(t.doc.height + En(t.display) - Ln(t), n.top)
          }), e.visible = Lr(t.display, t.doc, n), e.visible.from >= t.display.viewFrom && e.visible.to <= t.display.viewTo) break;
          if (!di(t, e)) break;
          Mr(t);
          var i = Br(t);
          xr(t), qr(t, i), gi(t, i), e.force = !1;
        }
        e.signal(t, "update", t), t.display.viewFrom == t.display.reportedViewFrom && t.display.viewTo == t.display.reportedViewTo || (e.signal(t, "viewportChange", t, t.display.viewFrom, t.display.viewTo), t.display.reportedViewFrom = t.display.viewFrom, t.display.reportedViewTo = t.display.viewTo);
      }
      function fi(t, e) {
        var n = new ui(t, e);
        if (di(t, n)) {
          Mr(t), hi(t, n);
          var r = Br(t);
          xr(t), qr(t, r), gi(t, r), n.finish();
        }
      }
      function pi(t) {
        var e = t.gutters.offsetWidth;
        t.sizer.style.marginLeft = e + "px", fn(t, "gutterChanged", t);
      }
      function gi(t, e) {
        t.display.sizer.style.minHeight = e.docHeight + "px", t.display.heightForcer.style.top = e.docHeight + "px", t.display.gutters.style.height = e.docHeight + t.display.barHeight + Mn(t) + "px";
      }
      function vi(t) {
        var e = t.display,
          n = e.view;
        if (e.alignWidgets || e.gutters.firstChild && t.options.fixedGutter) {
          for (var r = dr(e) - e.scroller.scrollLeft + t.doc.scrollLeft, i = e.gutters.offsetWidth, o = r + "px", a = 0; a < n.length; a++) if (!n[a].hidden) {
            t.options.fixedGutter && (n[a].gutter && (n[a].gutter.style.left = o), n[a].gutterBackground && (n[a].gutterBackground.style.left = o));
            var s = n[a].alignable;
            if (s) for (var l = 0; l < s.length; l++) s[l].style.left = o;
          }
          t.options.fixedGutter && (e.gutters.style.left = r + i + "px");
        }
      }
      function mi(t) {
        if (!t.options.lineNumbers) return !1;
        var e = t.doc,
          n = ie(t.options, e.first + e.size - 1),
          r = t.display;
        if (n.length != r.lineNumChars) {
          var i = r.measure.appendChild(D("div", [D("div", n)], "CodeMirror-linenumber CodeMirror-gutter-elt")),
            o = i.firstChild.offsetWidth,
            a = i.offsetWidth - o;
          return r.lineGutter.style.width = "", r.lineNumInnerWidth = Math.max(o, r.lineGutter.offsetWidth - a) + 1, r.lineNumWidth = r.lineNumInnerWidth + a, r.lineNumChars = r.lineNumInnerWidth ? n.length : -1, r.lineGutter.style.width = r.lineNumWidth + "px", pi(t.display), !0;
        }
        return !1;
      }
      function bi(t, e) {
        for (var n = [], r = !1, i = 0; i < t.length; i++) {
          var o = t[i],
            a = null;
          if ("string" != typeof o && (a = o.style, o = o.className), "CodeMirror-linenumbers" == o) {
            if (!e) continue;
            r = !0;
          }
          n.push({
            className: o,
            style: a
          });
        }
        return e && !r && n.push({
          className: "CodeMirror-linenumbers",
          style: null
        }), n;
      }
      function yi(t) {
        var e = t.gutters,
          n = t.gutterSpecs;
        P(e), t.lineGutter = null;
        for (var r = 0; r < n.length; ++r) {
          var i = n[r],
            o = i.className,
            a = i.style,
            s = e.appendChild(D("div", null, "CodeMirror-gutter " + o));
          a && (s.style.cssText = a), "CodeMirror-linenumbers" == o && (t.lineGutter = s, s.style.width = (t.lineNumWidth || 1) + "px");
        }
        e.style.display = n.length ? "" : "none", pi(t);
      }
      function wi(t) {
        yi(t.display), vr(t), vi(t);
      }
      function xi(t, e, r, i) {
        var o = this;
        this.input = r, o.scrollbarFiller = D("div", null, "CodeMirror-scrollbar-filler"), o.scrollbarFiller.setAttribute("cm-not-content", "true"), o.gutterFiller = D("div", null, "CodeMirror-gutter-filler"), o.gutterFiller.setAttribute("cm-not-content", "true"), o.lineDiv = M("div", null, "CodeMirror-code"), o.selectionDiv = D("div", null, null, "position: relative; z-index: 1"), o.cursorDiv = D("div", null, "CodeMirror-cursors"), o.measure = D("div", null, "CodeMirror-measure"), o.lineMeasure = D("div", null, "CodeMirror-measure"), o.lineSpace = M("div", [o.measure, o.lineMeasure, o.selectionDiv, o.cursorDiv, o.lineDiv], null, "position: relative; outline: none");
        var c = M("div", [o.lineSpace], "CodeMirror-lines");
        o.mover = D("div", [c], null, "position: relative"), o.sizer = D("div", [o.mover], "CodeMirror-sizer"), o.sizerWidth = null, o.heightForcer = D("div", null, null, "position: absolute; height: 50px; width: 1px;"), o.gutters = D("div", null, "CodeMirror-gutters"), o.lineGutter = null, o.scroller = D("div", [o.sizer, o.heightForcer, o.gutters], "CodeMirror-scroll"), o.scroller.setAttribute("tabIndex", "-1"), o.wrapper = D("div", [o.scrollbarFiller, o.gutterFiller, o.scroller], "CodeMirror"), u && d >= 105 && (o.wrapper.style.clipPath = "inset(0px)"), o.wrapper.setAttribute("translate", "no"), a && s < 8 && (o.gutters.style.zIndex = -1, o.scroller.style.paddingRight = 0), l || n && b || (o.scroller.draggable = !0), t && (t.appendChild ? t.appendChild(o.wrapper) : t(o.wrapper)), o.viewFrom = o.viewTo = e.first, o.reportedViewFrom = o.reportedViewTo = e.first, o.view = [], o.renderedView = null, o.externalMeasured = null, o.viewOffset = 0, o.lastWrapHeight = o.lastWrapWidth = 0, o.updateLineNumbers = null, o.nativeBarWidth = o.barHeight = o.barWidth = 0, o.scrollbarsClipped = !1, o.lineNumWidth = o.lineNumInnerWidth = o.lineNumChars = null, o.alignWidgets = !1, o.cachedCharWidth = o.cachedTextHeight = o.cachedPaddingH = null, o.maxLine = null, o.maxLineLength = 0, o.maxLineChanged = !1, o.wheelDX = o.wheelDY = o.wheelStartX = o.wheelStartY = null, o.shift = !1, o.selForContextMenu = null, o.activeTouch = null, o.gutterSpecs = bi(i.gutters, i.lineNumbers), yi(o), r.init(o);
      }
      ui.prototype.signal = function (t, e) {
        Ot(t, e) && this.events.push(arguments);
      }, ui.prototype.finish = function () {
        for (var t = 0; t < this.events.length; t++) yt.apply(null, this.events[t]);
      };
      var Oi = 0,
        Ci = null;
      function Si(t) {
        var e = t.wheelDeltaX,
          n = t.wheelDeltaY;
        return null == e && t.detail && t.axis == t.HORIZONTAL_AXIS && (e = t.detail), null == n && t.detail && t.axis == t.VERTICAL_AXIS ? n = t.detail : null == n && (n = t.wheelDelta), {
          x: e,
          y: n
        };
      }
      function ki(t) {
        var e = Si(t);
        return e.x *= Ci, e.y *= Ci, e;
      }
      function ji(t, e) {
        u && 102 == d && (null == t.display.chromeScrollHack ? t.display.sizer.style.pointerEvents = "none" : clearTimeout(t.display.chromeScrollHack), t.display.chromeScrollHack = setTimeout(function () {
          t.display.chromeScrollHack = null, t.display.sizer.style.pointerEvents = "";
        }, 100));
        var r = Si(e),
          i = r.x,
          o = r.y,
          a = Ci;
        0 === e.deltaMode && (i = e.deltaX, o = e.deltaY, a = 1);
        var s = t.display,
          c = s.scroller,
          f = c.scrollWidth > c.clientWidth,
          p = c.scrollHeight > c.clientHeight;
        if (i && f || o && p) {
          if (o && y && l) t: for (var g = e.target, v = s.view; g != c; g = g.parentNode) for (var m = 0; m < v.length; m++) if (v[m].node == g) {
            t.display.currentWheelTarget = g;
            break t;
          }
          if (i && !n && !h && null != a) return o && p && zr(t, Math.max(0, c.scrollTop + o * a)), $r(t, Math.max(0, c.scrollLeft + i * a)), (!o || o && p) && St(e), void (s.wheelStartX = null);
          if (o && null != a) {
            var b = o * a,
              w = t.doc.scrollTop,
              x = w + s.wrapper.clientHeight;
            b < 0 ? w = Math.max(0, w + b - 50) : x = Math.min(t.doc.height, x + b + 50), fi(t, {
              top: w,
              bottom: x
            });
          }
          Oi < 20 && 0 !== e.deltaMode && (null == s.wheelStartX ? (s.wheelStartX = c.scrollLeft, s.wheelStartY = c.scrollTop, s.wheelDX = i, s.wheelDY = o, setTimeout(function () {
            if (null != s.wheelStartX) {
              var t = c.scrollLeft - s.wheelStartX,
                e = c.scrollTop - s.wheelStartY,
                n = e && s.wheelDY && e / s.wheelDY || t && s.wheelDX && t / s.wheelDX;
              s.wheelStartX = s.wheelStartY = null, n && (Ci = (Ci * Oi + n) / (Oi + 1), ++Oi);
            }
          }, 200)) : (s.wheelDX += i, s.wheelDY += o));
        }
      }
      a ? Ci = -.53 : n ? Ci = 15 : u ? Ci = -.7 : f && (Ci = -1 / 3);
      var Ti = function Ti(t, e) {
        this.ranges = t, this.primIndex = e;
      };
      Ti.prototype.primary = function () {
        return this.ranges[this.primIndex];
      }, Ti.prototype.equals = function (t) {
        if (t == this) return !0;
        if (t.primIndex != this.primIndex || t.ranges.length != this.ranges.length) return !1;
        for (var e = 0; e < this.ranges.length; e++) {
          var n = this.ranges[e],
            r = t.ranges[e];
          if (!se(n.anchor, r.anchor) || !se(n.head, r.head)) return !1;
        }
        return !0;
      }, Ti.prototype.deepCopy = function () {
        for (var t = [], e = 0; e < this.ranges.length; e++) t[e] = new Pi(le(this.ranges[e].anchor), le(this.ranges[e].head));
        return new Ti(t, this.primIndex);
      }, Ti.prototype.somethingSelected = function () {
        for (var t = 0; t < this.ranges.length; t++) if (!this.ranges[t].empty()) return !0;
        return !1;
      }, Ti.prototype.contains = function (t, e) {
        e || (e = t);
        for (var n = 0; n < this.ranges.length; n++) {
          var r = this.ranges[n];
          if (ae(e, r.from()) >= 0 && ae(t, r.to()) <= 0) return n;
        }
        return -1;
      };
      var Pi = function Pi(t, e) {
        this.anchor = t, this.head = e;
      };
      function Ei(t, e, n) {
        var r = t && t.options.selectionsMayTouch,
          i = e[n];
        e.sort(function (t, e) {
          return ae(t.from(), e.from());
        }), n = U(e, i);
        for (var o = 1; o < e.length; o++) {
          var a = e[o],
            s = e[o - 1],
            l = ae(s.to(), a.from());
          if (r && !a.empty() ? l > 0 : l >= 0) {
            var c = ue(s.from(), a.from()),
              u = ce(s.to(), a.to()),
              d = s.empty() ? a.from() == a.head : s.from() == s.head;
            o <= n && --n, e.splice(--o, 2, new Pi(d ? u : c, d ? c : u));
          }
        }
        return new Ti(e, n);
      }
      function Di(t, e) {
        return new Ti([new Pi(t, e || t)], 0);
      }
      function Mi(t) {
        return t.text ? oe(t.from.line + t.text.length - 1, Q(t.text).length + (1 == t.text.length ? t.from.ch : 0)) : t.to;
      }
      function Ai(t, e) {
        if (ae(t, e.from) < 0) return t;
        if (ae(t, e.to) <= 0) return Mi(e);
        var n = t.line + e.text.length - (e.to.line - e.from.line) - 1,
          r = t.ch;
        return t.line == e.to.line && (r += Mi(e).ch - e.to.ch), oe(n, r);
      }
      function Li(t, e) {
        for (var n = [], r = 0; r < t.sel.ranges.length; r++) {
          var i = t.sel.ranges[r];
          n.push(new Pi(Ai(i.anchor, e), Ai(i.head, e)));
        }
        return Ei(t.cm, n, t.sel.primIndex);
      }
      function Ni(t, e, n) {
        return t.line == e.line ? oe(n.line, t.ch - e.ch + n.ch) : oe(n.line + (t.line - e.line), t.ch);
      }
      function _i(t) {
        t.doc.mode = Wt(t.options, t.doc.modeOption), Ii(t);
      }
      function Ii(t) {
        t.doc.iter(function (t) {
          t.stateAfter && (t.stateAfter = null), t.styles && (t.styles = null);
        }), t.doc.modeFrontier = t.doc.highlightFrontier = t.doc.first, li(t, 100), t.state.modeGen++, t.curOp && vr(t);
      }
      function Fi(t, e) {
        return 0 == e.from.ch && 0 == e.to.ch && "" == Q(e.text) && (!t.cm || t.cm.options.wholeLineUpdateBefore);
      }
      function Vi(t, e, n, r) {
        function i(t) {
          return n ? n[t] : null;
        }
        function o(t, n, i) {
          !function (t, e, n, r) {
            t.text = e, t.stateAfter && (t.stateAfter = null), t.styles && (t.styles = null), null != t.order && (t.order = null), Le(t), Ne(t, n);
            var i = r ? r(t) : 1;
            i != t.height && te(t, i);
          }(t, n, i, r), fn(t, "change", t, e);
        }
        function a(t, e) {
          for (var n = [], o = t; o < e; ++o) n.push(new Je(c[o], i(o), r));
          return n;
        }
        var s = e.from,
          l = e.to,
          c = e.text,
          u = Jt(t, s.line),
          d = Jt(t, l.line),
          h = Q(c),
          f = i(c.length - 1),
          p = l.line - s.line;
        if (e.full) t.insert(0, a(0, c.length)), t.remove(c.length, t.size - c.length);else if (Fi(t, e)) {
          var g = a(0, c.length - 1);
          o(d, d.text, f), p && t.remove(s.line, p), g.length && t.insert(s.line, g);
        } else if (u == d) {
          if (1 == c.length) o(u, u.text.slice(0, s.ch) + h + u.text.slice(l.ch), f);else {
            var v = a(1, c.length - 1);
            v.push(new Je(h + u.text.slice(l.ch), f, r)), o(u, u.text.slice(0, s.ch) + c[0], i(0)), t.insert(s.line + 1, v);
          }
        } else if (1 == c.length) o(u, u.text.slice(0, s.ch) + c[0] + d.text.slice(l.ch), i(0)), t.remove(s.line + 1, p);else {
          o(u, u.text.slice(0, s.ch) + c[0], i(0)), o(d, h + d.text.slice(l.ch), f);
          var m = a(1, c.length - 1);
          p > 1 && t.remove(s.line + 1, p - 1), t.insert(s.line + 1, m);
        }
        fn(t, "change", t, e);
      }
      function Ri(t, e, n) {
        !function t(r, i, o) {
          if (r.linked) for (var a = 0; a < r.linked.length; ++a) {
            var s = r.linked[a];
            if (s.doc != i) {
              var l = o && s.sharedHist;
              n && !l || (e(s.doc, l), t(s.doc, r, l));
            }
          }
        }(t, null, !0);
      }
      function zi(t, e) {
        if (e.cm) throw new Error("This document is already in use.");
        t.doc = e, e.cm = t, fr(t), _i(t), Hi(t), t.options.direction = e.direction, t.options.lineWrapping || Xe(t), t.options.mode = e.modeOption, vr(t);
      }
      function Hi(t) {
        ("rtl" == t.doc.direction ? N : T)(t.display.lineDiv, "CodeMirror-rtl");
      }
      function $i(t) {
        this.done = [], this.undone = [], this.undoDepth = t ? t.undoDepth : 1 / 0, this.lastModTime = this.lastSelTime = 0, this.lastOp = this.lastSelOp = null, this.lastOrigin = this.lastSelOrigin = null, this.generation = this.maxGeneration = t ? t.maxGeneration : 1;
      }
      function Bi(t, e) {
        var n = {
          from: le(e.from),
          to: Mi(e),
          text: Zt(t, e.from, e.to)
        };
        return Ki(t, n, e.from.line, e.to.line + 1), Ri(t, function (t) {
          return Ki(t, n, e.from.line, e.to.line + 1);
        }, !0), n;
      }
      function Wi(t) {
        for (; t.length && Q(t).ranges;) t.pop();
      }
      function Ui(t, e, n, r) {
        var i = t.history;
        i.undone.length = 0;
        var o,
          a,
          s = +new Date();
        if ((i.lastOp == r || i.lastOrigin == e.origin && e.origin && ("+" == e.origin.charAt(0) && i.lastModTime > s - (t.cm ? t.cm.options.historyEventDelay : 500) || "*" == e.origin.charAt(0))) && (o = function (t, e) {
          return e ? (Wi(t.done), Q(t.done)) : t.done.length && !Q(t.done).ranges ? Q(t.done) : t.done.length > 1 && !t.done[t.done.length - 2].ranges ? (t.done.pop(), Q(t.done)) : void 0;
        }(i, i.lastOp == r))) a = Q(o.changes), 0 == ae(e.from, e.to) && 0 == ae(e.from, a.to) ? a.to = Mi(e) : o.changes.push(Bi(t, e));else {
          var l = Q(i.done);
          for (l && l.ranges || Gi(t.sel, i.done), o = {
            changes: [Bi(t, e)],
            generation: i.generation
          }, i.done.push(o); i.done.length > i.undoDepth;) i.done.shift(), i.done[0].ranges || i.done.shift();
        }
        i.done.push(n), i.generation = ++i.maxGeneration, i.lastModTime = i.lastSelTime = s, i.lastOp = i.lastSelOp = r, i.lastOrigin = i.lastSelOrigin = e.origin, a || yt(t, "historyAdded");
      }
      function qi(t, e, n, r) {
        var i = t.history,
          o = r && r.origin;
        n == i.lastSelOp || o && i.lastSelOrigin == o && (i.lastModTime == i.lastSelTime && i.lastOrigin == o || function (t, e, n, r) {
          var i = e.charAt(0);
          return "*" == i || "+" == i && n.ranges.length == r.ranges.length && n.somethingSelected() == r.somethingSelected() && new Date() - t.history.lastSelTime <= (t.cm ? t.cm.options.historyEventDelay : 500);
        }(t, o, Q(i.done), e)) ? i.done[i.done.length - 1] = e : Gi(e, i.done), i.lastSelTime = +new Date(), i.lastSelOrigin = o, i.lastSelOp = n, r && !1 !== r.clearRedo && Wi(i.undone);
      }
      function Gi(t, e) {
        var n = Q(e);
        n && n.ranges && n.equals(t) || e.push(t);
      }
      function Ki(t, e, n, r) {
        var i = e["spans_" + t.id],
          o = 0;
        t.iter(Math.max(t.first, n), Math.min(t.first + t.size, r), function (n) {
          n.markedSpans && ((i || (i = e["spans_" + t.id] = {}))[o] = n.markedSpans), ++o;
        });
      }
      function Yi(t) {
        if (!t) return null;
        for (var e, n = 0; n < t.length; ++n) t[n].marker.explicitlyCleared ? e || (e = t.slice(0, n)) : e && e.push(t[n]);
        return e ? e.length ? e : null : t;
      }
      function Xi(t, e) {
        var n = function (t, e) {
            var n = e["spans_" + t.id];
            if (!n) return null;
            for (var r = [], i = 0; i < e.text.length; ++i) r.push(Yi(n[i]));
            return r;
          }(t, e),
          r = Me(t, e);
        if (!n) return r;
        if (!r) return n;
        for (var i = 0; i < n.length; ++i) {
          var o = n[i],
            a = r[i];
          if (o && a) t: for (var s = 0; s < a.length; ++s) {
            for (var l = a[s], c = 0; c < o.length; ++c) if (o[c].marker == l.marker) continue t;
            o.push(l);
          } else a && (n[i] = a);
        }
        return n;
      }
      function Ji(t, e, n) {
        for (var r = [], i = 0; i < t.length; ++i) {
          var o = t[i];
          if (o.ranges) r.push(n ? Ti.prototype.deepCopy.call(o) : o);else {
            var a = o.changes,
              s = [];
            r.push({
              changes: s
            });
            for (var l = 0; l < a.length; ++l) {
              var c = a[l],
                u = void 0;
              if (s.push({
                from: c.from,
                to: c.to,
                text: c.text
              }), e) for (var d in c) (u = d.match(/^spans_(\d+)$/)) && U(e, Number(u[1])) > -1 && (Q(s)[d] = c[d], delete c[d]);
            }
          }
        }
        return r;
      }
      function Zi(t, e, n, r) {
        if (r) {
          var i = t.anchor;
          if (n) {
            var o = ae(e, i) < 0;
            o != ae(n, i) < 0 ? (i = e, e = n) : o != ae(e, n) < 0 && (e = n);
          }
          return new Pi(i, e);
        }
        return new Pi(n || e, e);
      }
      function Qi(t, e, n, r, i) {
        null == i && (i = t.cm && (t.cm.display.shift || t.extend)), io(t, new Ti([Zi(t.sel.primary(), e, n, i)], 0), r);
      }
      function to(t, e, n) {
        for (var r = [], i = t.cm && (t.cm.display.shift || t.extend), o = 0; o < t.sel.ranges.length; o++) r[o] = Zi(t.sel.ranges[o], e[o], null, i);
        io(t, Ei(t.cm, r, t.sel.primIndex), n);
      }
      function eo(t, e, n, r) {
        var i = t.sel.ranges.slice(0);
        i[e] = n, io(t, Ei(t.cm, i, t.sel.primIndex), r);
      }
      function no(t, e, n, r) {
        io(t, Di(e, n), r);
      }
      function ro(t, e, n) {
        var r = t.history.done,
          i = Q(r);
        i && i.ranges ? (r[r.length - 1] = e, oo(t, e, n)) : io(t, e, n);
      }
      function io(t, e, n) {
        oo(t, e, n), qi(t, t.sel, t.cm ? t.cm.curOp.id : NaN, n);
      }
      function oo(t, e, n) {
        (Ot(t, "beforeSelectionChange") || t.cm && Ot(t.cm, "beforeSelectionChange")) && (e = function (t, e, n) {
          var r = {
            ranges: e.ranges,
            update: function update(e) {
              this.ranges = [];
              for (var n = 0; n < e.length; n++) this.ranges[n] = new Pi(he(t, e[n].anchor), he(t, e[n].head));
            },
            origin: n && n.origin
          };
          return yt(t, "beforeSelectionChange", t, r), t.cm && yt(t.cm, "beforeSelectionChange", t.cm, r), r.ranges != e.ranges ? Ei(t.cm, r.ranges, r.ranges.length - 1) : e;
        }(t, e, n));
        var r = n && n.bias || (ae(e.primary().head, t.sel.primary().head) < 0 ? -1 : 1);
        ao(t, lo(t, e, r, !0)), n && !1 === n.scroll || !t.cm || "nocursor" == t.cm.getOption("readOnly") || Ir(t.cm);
      }
      function ao(t, e) {
        e.equals(t.sel) || (t.sel = e, t.cm && (t.cm.curOp.updateInput = 1, t.cm.curOp.selectionChanged = !0, xt(t.cm)), fn(t, "cursorActivity", t));
      }
      function so(t) {
        ao(t, lo(t, t.sel, null, !1));
      }
      function lo(t, e, n, r) {
        for (var i, o = 0; o < e.ranges.length; o++) {
          var a = e.ranges[o],
            s = e.ranges.length == t.sel.ranges.length && t.sel.ranges[o],
            l = uo(t, a.anchor, s && s.anchor, n, r),
            c = a.head == a.anchor ? l : uo(t, a.head, s && s.head, n, r);
          (i || l != a.anchor || c != a.head) && (i || (i = e.ranges.slice(0, o)), i[o] = new Pi(l, c));
        }
        return i ? Ei(t.cm, i, e.primIndex) : e;
      }
      function co(t, e, n, r, i) {
        var o = Jt(t, e.line);
        if (o.markedSpans) for (var a = 0; a < o.markedSpans.length; ++a) {
          var s = o.markedSpans[a],
            l = s.marker,
            c = "selectLeft" in l ? !l.selectLeft : l.inclusiveLeft,
            u = "selectRight" in l ? !l.selectRight : l.inclusiveRight;
          if ((null == s.from || (c ? s.from <= e.ch : s.from < e.ch)) && (null == s.to || (u ? s.to >= e.ch : s.to > e.ch))) {
            if (i && (yt(l, "beforeCursorEnter"), l.explicitlyCleared)) {
              if (o.markedSpans) {
                --a;
                continue;
              }
              break;
            }
            if (!l.atomic) continue;
            if (n) {
              var d = l.find(r < 0 ? 1 : -1),
                h = void 0;
              if ((r < 0 ? u : c) && (d = ho(t, d, -r, d && d.line == e.line ? o : null)), d && d.line == e.line && (h = ae(d, n)) && (r < 0 ? h < 0 : h > 0)) return co(t, d, e, r, i);
            }
            var f = l.find(r < 0 ? -1 : 1);
            return (r < 0 ? c : u) && (f = ho(t, f, r, f.line == e.line ? o : null)), f ? co(t, f, e, r, i) : null;
          }
        }
        return e;
      }
      function uo(t, e, n, r, i) {
        var o = r || 1,
          a = co(t, e, n, o, i) || !i && co(t, e, n, o, !0) || co(t, e, n, -o, i) || !i && co(t, e, n, -o, !0);
        return a || (t.cantEdit = !0, oe(t.first, 0));
      }
      function ho(t, e, n, r) {
        return n < 0 && 0 == e.ch ? e.line > t.first ? he(t, oe(e.line - 1)) : null : n > 0 && e.ch == (r || Jt(t, e.line)).text.length ? e.line < t.first + t.size - 1 ? oe(e.line + 1, 0) : null : new oe(e.line, e.ch + n);
      }
      function fo(t) {
        t.setSelection(oe(t.firstLine(), 0), oe(t.lastLine()), G);
      }
      function po(t, e, n) {
        var r = {
          canceled: !1,
          from: e.from,
          to: e.to,
          text: e.text,
          origin: e.origin,
          cancel: function cancel() {
            return r.canceled = !0;
          }
        };
        return n && (r.update = function (e, n, i, o) {
          e && (r.from = he(t, e)), n && (r.to = he(t, n)), i && (r.text = i), void 0 !== o && (r.origin = o);
        }), yt(t, "beforeChange", t, r), t.cm && yt(t.cm, "beforeChange", t.cm, r), r.canceled ? (t.cm && (t.cm.curOp.updateInput = 2), null) : {
          from: r.from,
          to: r.to,
          text: r.text,
          origin: r.origin
        };
      }
      function go(t, e, n) {
        if (t.cm) {
          if (!t.cm.curOp) return oi(t.cm, go)(t, e, n);
          if (t.cm.state.suppressEdits) return;
        }
        if (!(Ot(t, "beforeChange") || t.cm && Ot(t.cm, "beforeChange")) || (e = po(t, e, !0))) {
          var r = je && !n && function (t, e, n) {
            var r = null;
            if (t.iter(e.line, n.line + 1, function (t) {
              if (t.markedSpans) for (var e = 0; e < t.markedSpans.length; ++e) {
                var n = t.markedSpans[e].marker;
                !n.readOnly || r && -1 != U(r, n) || (r || (r = [])).push(n);
              }
            }), !r) return null;
            for (var i = [{
                from: e,
                to: n
              }], o = 0; o < r.length; ++o) for (var a = r[o], s = a.find(0), l = 0; l < i.length; ++l) {
              var c = i[l];
              if (!(ae(c.to, s.from) < 0 || ae(c.from, s.to) > 0)) {
                var u = [l, 1],
                  d = ae(c.from, s.from),
                  h = ae(c.to, s.to);
                (d < 0 || !a.inclusiveLeft && !d) && u.push({
                  from: c.from,
                  to: s.from
                }), (h > 0 || !a.inclusiveRight && !h) && u.push({
                  from: s.to,
                  to: c.to
                }), i.splice.apply(i, u), l += u.length - 3;
              }
            }
            return i;
          }(t, e.from, e.to);
          if (r) for (var i = r.length - 1; i >= 0; --i) vo(t, {
            from: r[i].from,
            to: r[i].to,
            text: i ? [""] : e.text,
            origin: e.origin
          });else vo(t, e);
        }
      }
      function vo(t, e) {
        if (1 != e.text.length || "" != e.text[0] || 0 != ae(e.from, e.to)) {
          var n = Li(t, e);
          Ui(t, e, n, t.cm ? t.cm.curOp.id : NaN), yo(t, e, n, Me(t, e));
          var r = [];
          Ri(t, function (t, n) {
            n || -1 != U(r, t.history) || (Co(t.history, e), r.push(t.history)), yo(t, e, null, Me(t, e));
          });
        }
      }
      function mo(t, e, n) {
        var r = t.cm && t.cm.state.suppressEdits;
        if (!r || n) {
          for (var i, o = t.history, a = t.sel, s = "undo" == e ? o.done : o.undone, l = "undo" == e ? o.undone : o.done, c = 0; c < s.length && (i = s[c], n ? !i.ranges || i.equals(t.sel) : i.ranges); c++);
          if (c != s.length) {
            for (o.lastOrigin = o.lastSelOrigin = null;;) {
              if (!(i = s.pop()).ranges) {
                if (r) return void s.push(i);
                break;
              }
              if (Gi(i, l), n && !i.equals(t.sel)) return void io(t, i, {
                clearRedo: !1
              });
              a = i;
            }
            var u = [];
            Gi(a, l), l.push({
              changes: u,
              generation: o.generation
            }), o.generation = i.generation || ++o.maxGeneration;
            for (var d = Ot(t, "beforeChange") || t.cm && Ot(t.cm, "beforeChange"), h = function h(n) {
                var r = i.changes[n];
                if (r.origin = e, d && !po(t, r, !1)) return s.length = 0, {};
                u.push(Bi(t, r));
                var o = n ? Li(t, r) : Q(s);
                yo(t, r, o, Xi(t, r)), !n && t.cm && t.cm.scrollIntoView({
                  from: r.from,
                  to: Mi(r)
                });
                var a = [];
                Ri(t, function (t, e) {
                  e || -1 != U(a, t.history) || (Co(t.history, r), a.push(t.history)), yo(t, r, null, Xi(t, r));
                });
              }, f = i.changes.length - 1; f >= 0; --f) {
              var p = h(f);
              if (p) return p.v;
            }
          }
        }
      }
      function bo(t, e) {
        if (0 != e && (t.first += e, t.sel = new Ti(tt(t.sel.ranges, function (t) {
          return new Pi(oe(t.anchor.line + e, t.anchor.ch), oe(t.head.line + e, t.head.ch));
        }), t.sel.primIndex), t.cm)) {
          vr(t.cm, t.first, t.first - e, e);
          for (var n = t.cm.display, r = n.viewFrom; r < n.viewTo; r++) mr(t.cm, r, "gutter");
        }
      }
      function yo(t, e, n, r) {
        if (t.cm && !t.cm.curOp) return oi(t.cm, yo)(t, e, n, r);
        if (e.to.line < t.first) bo(t, e.text.length - 1 - (e.to.line - e.from.line));else if (!(e.from.line > t.lastLine())) {
          if (e.from.line < t.first) {
            var i = e.text.length - 1 - (t.first - e.from.line);
            bo(t, i), e = {
              from: oe(t.first, 0),
              to: oe(e.to.line + i, e.to.ch),
              text: [Q(e.text)],
              origin: e.origin
            };
          }
          var o = t.lastLine();
          e.to.line > o && (e = {
            from: e.from,
            to: oe(o, Jt(t, o).text.length),
            text: [e.text[0]],
            origin: e.origin
          }), e.removed = Zt(t, e.from, e.to), n || (n = Li(t, e)), t.cm ? function (t, e, n) {
            var r = t.doc,
              i = t.display,
              o = e.from,
              a = e.to,
              s = !1,
              l = o.line;
            t.options.lineWrapping || (l = ee(Be(Jt(r, o.line))), r.iter(l, a.line + 1, function (t) {
              if (t == i.maxLine) return s = !0, !0;
            })), r.sel.contains(e.from, e.to) > -1 && xt(t), Vi(r, e, n, hr(t)), t.options.lineWrapping || (r.iter(l, o.line + e.text.length, function (t) {
              var e = Ye(t);
              e > i.maxLineLength && (i.maxLine = t, i.maxLineLength = e, i.maxLineChanged = !0, s = !1);
            }), s && (t.curOp.updateMaxLine = !0)), function (t, e) {
              if (t.modeFrontier = Math.min(t.modeFrontier, e), !(t.highlightFrontier < e - 10)) {
                for (var n = t.first, r = e - 1; r > n; r--) {
                  var i = Jt(t, r).stateAfter;
                  if (i && (!(i instanceof pe) || r + i.lookAhead < e)) {
                    n = r + 1;
                    break;
                  }
                }
                t.highlightFrontier = Math.min(t.highlightFrontier, n);
              }
            }(r, o.line), li(t, 400);
            var c = e.text.length - (a.line - o.line) - 1;
            e.full ? vr(t) : o.line != a.line || 1 != e.text.length || Fi(t.doc, e) ? vr(t, o.line, a.line + 1, c) : mr(t, o.line, "text");
            var u = Ot(t, "changes"),
              d = Ot(t, "change");
            if (d || u) {
              var h = {
                from: o,
                to: a,
                text: e.text,
                removed: e.removed,
                origin: e.origin
              };
              d && fn(t, "change", t, h), u && (t.curOp.changeObjs || (t.curOp.changeObjs = [])).push(h);
            }
            t.display.selForContextMenu = null;
          }(t.cm, e, r) : Vi(t, e, r), oo(t, n, G), t.cantEdit && uo(t, oe(t.firstLine(), 0)) && (t.cantEdit = !1);
        }
      }
      function wo(t, e, n, r, i) {
        var o;
        r || (r = n), ae(r, n) < 0 && (n = (o = [r, n])[0], r = o[1]), "string" == typeof e && (e = t.splitLines(e)), go(t, {
          from: n,
          to: r,
          text: e,
          origin: i
        });
      }
      function xo(t, e, n, r) {
        n < t.line ? t.line += r : e < t.line && (t.line = e, t.ch = 0);
      }
      function Oo(t, e, n, r) {
        for (var i = 0; i < t.length; ++i) {
          var o = t[i],
            a = !0;
          if (o.ranges) {
            o.copied || ((o = t[i] = o.deepCopy()).copied = !0);
            for (var s = 0; s < o.ranges.length; s++) xo(o.ranges[s].anchor, e, n, r), xo(o.ranges[s].head, e, n, r);
          } else {
            for (var l = 0; l < o.changes.length; ++l) {
              var c = o.changes[l];
              if (n < c.from.line) c.from = oe(c.from.line + r, c.from.ch), c.to = oe(c.to.line + r, c.to.ch);else if (e <= c.to.line) {
                a = !1;
                break;
              }
            }
            a || (t.splice(0, i + 1), i = 0);
          }
        }
      }
      function Co(t, e) {
        var n = e.from.line,
          r = e.to.line,
          i = e.text.length - (r - n) - 1;
        Oo(t.done, n, r, i), Oo(t.undone, n, r, i);
      }
      function So(t, e, n, r) {
        var i = e,
          o = e;
        return "number" == typeof e ? o = Jt(t, de(t, e)) : i = ee(e), null == i ? null : (r(o, i) && t.cm && mr(t.cm, i, n), o);
      }
      function ko(t) {
        this.lines = t, this.parent = null;
        for (var e = 0, n = 0; n < t.length; ++n) t[n].parent = this, e += t[n].height;
        this.height = e;
      }
      function jo(t) {
        this.children = t;
        for (var e = 0, n = 0, r = 0; r < t.length; ++r) {
          var i = t[r];
          e += i.chunkSize(), n += i.height, i.parent = this;
        }
        this.size = e, this.height = n, this.parent = null;
      }
      Pi.prototype.from = function () {
        return ue(this.anchor, this.head);
      }, Pi.prototype.to = function () {
        return ce(this.anchor, this.head);
      }, Pi.prototype.empty = function () {
        return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
      }, ko.prototype = {
        chunkSize: function chunkSize() {
          return this.lines.length;
        },
        removeInner: function removeInner(t, e) {
          for (var n = t, r = t + e; n < r; ++n) {
            var i = this.lines[n];
            this.height -= i.height, Ze(i), fn(i, "delete");
          }
          this.lines.splice(t, e);
        },
        collapse: function collapse(t) {
          t.push.apply(t, this.lines);
        },
        insertInner: function insertInner(t, e, n) {
          this.height += n, this.lines = this.lines.slice(0, t).concat(e).concat(this.lines.slice(t));
          for (var r = 0; r < e.length; ++r) e[r].parent = this;
        },
        iterN: function iterN(t, e, n) {
          for (var r = t + e; t < r; ++t) if (n(this.lines[t])) return !0;
        }
      }, jo.prototype = {
        chunkSize: function chunkSize() {
          return this.size;
        },
        removeInner: function removeInner(t, e) {
          this.size -= e;
          for (var n = 0; n < this.children.length; ++n) {
            var r = this.children[n],
              i = r.chunkSize();
            if (t < i) {
              var o = Math.min(e, i - t),
                a = r.height;
              if (r.removeInner(t, o), this.height -= a - r.height, i == o && (this.children.splice(n--, 1), r.parent = null), 0 == (e -= o)) break;
              t = 0;
            } else t -= i;
          }
          if (this.size - e < 25 && (this.children.length > 1 || !(this.children[0] instanceof ko))) {
            var s = [];
            this.collapse(s), this.children = [new ko(s)], this.children[0].parent = this;
          }
        },
        collapse: function collapse(t) {
          for (var e = 0; e < this.children.length; ++e) this.children[e].collapse(t);
        },
        insertInner: function insertInner(t, e, n) {
          this.size += e.length, this.height += n;
          for (var r = 0; r < this.children.length; ++r) {
            var i = this.children[r],
              o = i.chunkSize();
            if (t <= o) {
              if (i.insertInner(t, e, n), i.lines && i.lines.length > 50) {
                for (var a = i.lines.length % 25 + 25, s = a; s < i.lines.length;) {
                  var l = new ko(i.lines.slice(s, s += 25));
                  i.height -= l.height, this.children.splice(++r, 0, l), l.parent = this;
                }
                i.lines = i.lines.slice(0, a), this.maybeSpill();
              }
              break;
            }
            t -= o;
          }
        },
        maybeSpill: function maybeSpill() {
          if (!(this.children.length <= 10)) {
            var t = this;
            do {
              var e = new jo(t.children.splice(t.children.length - 5, 5));
              if (t.parent) {
                t.size -= e.size, t.height -= e.height;
                var n = U(t.parent.children, t);
                t.parent.children.splice(n + 1, 0, e);
              } else {
                var r = new jo(t.children);
                r.parent = t, t.children = [r, e], t = r;
              }
              e.parent = t.parent;
            } while (t.children.length > 10);
            t.parent.maybeSpill();
          }
        },
        iterN: function iterN(t, e, n) {
          for (var r = 0; r < this.children.length; ++r) {
            var i = this.children[r],
              o = i.chunkSize();
            if (t < o) {
              var a = Math.min(e, o - t);
              if (i.iterN(t, a, n)) return !0;
              if (0 == (e -= a)) break;
              t = 0;
            } else t -= o;
          }
        }
      };
      var To = function To(t, e, n) {
        if (n) for (var r in n) n.hasOwnProperty(r) && (this[r] = n[r]);
        this.doc = t, this.node = e;
      };
      function Po(t, e, n) {
        Ke(e) < (t.curOp && t.curOp.scrollTop || t.doc.scrollTop) && _r(t, n);
      }
      To.prototype.clear = function () {
        var t = this.doc.cm,
          e = this.line.widgets,
          n = this.line,
          r = ee(n);
        if (null != r && e) {
          for (var i = 0; i < e.length; ++i) e[i] == this && e.splice(i--, 1);
          e.length || (n.widgets = null);
          var o = jn(this);
          te(n, Math.max(0, n.height - o)), t && (ii(t, function () {
            Po(t, n, -o), mr(t, r, "widget");
          }), fn(t, "lineWidgetCleared", t, this, r));
        }
      }, To.prototype.changed = function () {
        var t = this,
          e = this.height,
          n = this.doc.cm,
          r = this.line;
        this.height = null;
        var i = jn(this) - e;
        i && (qe(this.doc, r) || te(r, r.height + i), n && ii(n, function () {
          n.curOp.forceUpdate = !0, Po(n, r, i), fn(n, "lineWidgetChanged", n, t, ee(r));
        }));
      }, Ct(To);
      var Eo = 0,
        Do = function Do(t, e) {
          this.lines = [], this.type = e, this.doc = t, this.id = ++Eo;
        };
      function Mo(t, e, n, r, i) {
        if (r && r.shared) return function (t, e, n, r, i) {
          (r = $(r)).shared = !1;
          var o = [Mo(t, e, n, r, i)],
            a = o[0],
            s = r.widgetNode;
          return Ri(t, function (t) {
            s && (r.widgetNode = s.cloneNode(!0)), o.push(Mo(t, he(t, e), he(t, n), r, i));
            for (var l = 0; l < t.linked.length; ++l) if (t.linked[l].isParent) return;
            a = Q(o);
          }), new Ao(o, a);
        }(t, e, n, r, i);
        if (t.cm && !t.cm.curOp) return oi(t.cm, Mo)(t, e, n, r, i);
        var o = new Do(t, i),
          a = ae(e, n);
        if (r && $(r, o, !1), a > 0 || 0 == a && !1 !== o.clearWhenEmpty) return o;
        if (o.replacedWith && (o.collapsed = !0, o.widgetNode = M("span", [o.replacedWith], "CodeMirror-widget"), r.handleMouseEvents || o.widgetNode.setAttribute("cm-ignore-events", "true"), r.insertLeft && (o.widgetNode.insertLeft = !0)), o.collapsed) {
          if ($e(t, e.line, e, n, o) || e.line != n.line && $e(t, n.line, e, n, o)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
          Te = !0;
        }
        o.addToHistory && Ui(t, {
          from: e,
          to: n,
          origin: "markText"
        }, t.sel, NaN);
        var s,
          l = e.line,
          c = t.cm;
        if (t.iter(l, n.line + 1, function (r) {
          c && o.collapsed && !c.options.lineWrapping && Be(r) == c.display.maxLine && (s = !0), o.collapsed && l != e.line && te(r, 0), function (t, e, n) {
            var r = n && window.WeakSet && (n.markedSpans || (n.markedSpans = new WeakSet()));
            r && t.markedSpans && r.has(t.markedSpans) ? t.markedSpans.push(e) : (t.markedSpans = t.markedSpans ? t.markedSpans.concat([e]) : [e], r && r.add(t.markedSpans)), e.marker.attachLine(t);
          }(r, new Pe(o, l == e.line ? e.ch : null, l == n.line ? n.ch : null), t.cm && t.cm.curOp), ++l;
        }), o.collapsed && t.iter(e.line, n.line + 1, function (e) {
          qe(t, e) && te(e, 0);
        }), o.clearOnEnter && vt(o, "beforeCursorEnter", function () {
          return o.clear();
        }), o.readOnly && (je = !0, (t.history.done.length || t.history.undone.length) && t.clearHistory()), o.collapsed && (o.id = ++Eo, o.atomic = !0), c) {
          if (s && (c.curOp.updateMaxLine = !0), o.collapsed) vr(c, e.line, n.line + 1);else if (o.className || o.startStyle || o.endStyle || o.css || o.attributes || o.title) for (var u = e.line; u <= n.line; u++) mr(c, u, "text");
          o.atomic && so(c.doc), fn(c, "markerAdded", c, o);
        }
        return o;
      }
      Do.prototype.clear = function () {
        if (!this.explicitlyCleared) {
          var t = this.doc.cm,
            e = t && !t.curOp;
          if (e && Jr(t), Ot(this, "clear")) {
            var n = this.find();
            n && fn(this, "clear", n.from, n.to);
          }
          for (var r = null, i = null, o = 0; o < this.lines.length; ++o) {
            var a = this.lines[o],
              s = Ee(a.markedSpans, this);
            t && !this.collapsed ? mr(t, ee(a), "text") : t && (null != s.to && (i = ee(a)), null != s.from && (r = ee(a))), a.markedSpans = De(a.markedSpans, s), null == s.from && this.collapsed && !qe(this.doc, a) && t && te(a, lr(t.display));
          }
          if (t && this.collapsed && !t.options.lineWrapping) for (var l = 0; l < this.lines.length; ++l) {
            var c = Be(this.lines[l]),
              u = Ye(c);
            u > t.display.maxLineLength && (t.display.maxLine = c, t.display.maxLineLength = u, t.display.maxLineChanged = !0);
          }
          null != r && t && this.collapsed && vr(t, r, i + 1), this.lines.length = 0, this.explicitlyCleared = !0, this.atomic && this.doc.cantEdit && (this.doc.cantEdit = !1, t && so(t.doc)), t && fn(t, "markerCleared", t, this, r, i), e && Zr(t), this.parent && this.parent.clear();
        }
      }, Do.prototype.find = function (t, e) {
        var n, r;
        null == t && "bookmark" == this.type && (t = 1);
        for (var i = 0; i < this.lines.length; ++i) {
          var o = this.lines[i],
            a = Ee(o.markedSpans, this);
          if (null != a.from && (n = oe(e ? o : ee(o), a.from), -1 == t)) return n;
          if (null != a.to && (r = oe(e ? o : ee(o), a.to), 1 == t)) return r;
        }
        return n && {
          from: n,
          to: r
        };
      }, Do.prototype.changed = function () {
        var t = this,
          e = this.find(-1, !0),
          n = this,
          r = this.doc.cm;
        e && r && ii(r, function () {
          var i = e.line,
            o = ee(e.line),
            a = In(r, o);
          if (a && (Bn(a), r.curOp.selectionChanged = r.curOp.forceUpdate = !0), r.curOp.updateMaxLine = !0, !qe(n.doc, i) && null != n.height) {
            var s = n.height;
            n.height = null;
            var l = jn(n) - s;
            l && te(i, i.height + l);
          }
          fn(r, "markerChanged", r, t);
        });
      }, Do.prototype.attachLine = function (t) {
        if (!this.lines.length && this.doc.cm) {
          var e = this.doc.cm.curOp;
          e.maybeHiddenMarkers && -1 != U(e.maybeHiddenMarkers, this) || (e.maybeUnhiddenMarkers || (e.maybeUnhiddenMarkers = [])).push(this);
        }
        this.lines.push(t);
      }, Do.prototype.detachLine = function (t) {
        if (this.lines.splice(U(this.lines, t), 1), !this.lines.length && this.doc.cm) {
          var e = this.doc.cm.curOp;
          (e.maybeHiddenMarkers || (e.maybeHiddenMarkers = [])).push(this);
        }
      }, Ct(Do);
      var Ao = function Ao(t, e) {
        this.markers = t, this.primary = e;
        for (var n = 0; n < t.length; ++n) t[n].parent = this;
      };
      function Lo(t) {
        return t.findMarks(oe(t.first, 0), t.clipPos(oe(t.lastLine())), function (t) {
          return t.parent;
        });
      }
      function No(t) {
        for (var e = function e(_e4) {
            var n = t[_e4],
              r = [n.primary.doc];
            Ri(n.primary.doc, function (t) {
              return r.push(t);
            });
            for (var i = 0; i < n.markers.length; i++) {
              var o = n.markers[i];
              -1 == U(r, o.doc) && (o.parent = null, n.markers.splice(i--, 1));
            }
          }, n = 0; n < t.length; n++) e(n);
      }
      Ao.prototype.clear = function () {
        if (!this.explicitlyCleared) {
          this.explicitlyCleared = !0;
          for (var t = 0; t < this.markers.length; ++t) this.markers[t].clear();
          fn(this, "clear");
        }
      }, Ao.prototype.find = function (t, e) {
        return this.primary.find(t, e);
      }, Ct(Ao);
      var _o = 0,
        _Io = function Io(t, e, n, r, i) {
          if (!(this instanceof _Io)) return new _Io(t, e, n, r, i);
          null == n && (n = 0), jo.call(this, [new ko([new Je("", null)])]), this.first = n, this.scrollTop = this.scrollLeft = 0, this.cantEdit = !1, this.cleanGeneration = 1, this.modeFrontier = this.highlightFrontier = n;
          var o = oe(n, 0);
          this.sel = Di(o), this.history = new $i(null), this.id = ++_o, this.modeOption = e, this.lineSep = r, this.direction = "rtl" == i ? "rtl" : "ltr", this.extend = !1, "string" == typeof t && (t = this.splitLines(t)), Vi(this, {
            from: o,
            to: o,
            text: t
          }), io(this, Di(o), G);
        };
      _Io.prototype = nt(jo.prototype, {
        constructor: _Io,
        iter: function iter(t, e, n) {
          n ? this.iterN(t - this.first, e - t, n) : this.iterN(this.first, this.first + this.size, t);
        },
        insert: function insert(t, e) {
          for (var n = 0, r = 0; r < e.length; ++r) n += e[r].height;
          this.insertInner(t - this.first, e, n);
        },
        remove: function remove(t, e) {
          this.removeInner(t - this.first, e);
        },
        getValue: function getValue(t) {
          var e = Qt(this, this.first, this.first + this.size);
          return !1 === t ? e : e.join(t || this.lineSeparator());
        },
        setValue: si(function (t) {
          var e = oe(this.first, 0),
            n = this.first + this.size - 1;
          go(this, {
            from: e,
            to: oe(n, Jt(this, n).text.length),
            text: this.splitLines(t),
            origin: "setValue",
            full: !0
          }, !0), this.cm && Fr(this.cm, 0, 0), io(this, Di(e), G);
        }),
        replaceRange: function replaceRange(t, e, n, r) {
          wo(this, t, e = he(this, e), n = n ? he(this, n) : e, r);
        },
        getRange: function getRange(t, e, n) {
          var r = Zt(this, he(this, t), he(this, e));
          return !1 === n ? r : "" === n ? r.join("") : r.join(n || this.lineSeparator());
        },
        getLine: function getLine(t) {
          var e = this.getLineHandle(t);
          return e && e.text;
        },
        getLineHandle: function getLineHandle(t) {
          if (re(this, t)) return Jt(this, t);
        },
        getLineNumber: function getLineNumber(t) {
          return ee(t);
        },
        getLineHandleVisualStart: function getLineHandleVisualStart(t) {
          return "number" == typeof t && (t = Jt(this, t)), Be(t);
        },
        lineCount: function lineCount() {
          return this.size;
        },
        firstLine: function firstLine() {
          return this.first;
        },
        lastLine: function lastLine() {
          return this.first + this.size - 1;
        },
        clipPos: function clipPos(t) {
          return he(this, t);
        },
        getCursor: function getCursor(t) {
          var e = this.sel.primary();
          return null == t || "head" == t ? e.head : "anchor" == t ? e.anchor : "end" == t || "to" == t || !1 === t ? e.to() : e.from();
        },
        listSelections: function listSelections() {
          return this.sel.ranges;
        },
        somethingSelected: function somethingSelected() {
          return this.sel.somethingSelected();
        },
        setCursor: si(function (t, e, n) {
          no(this, he(this, "number" == typeof t ? oe(t, e || 0) : t), null, n);
        }),
        setSelection: si(function (t, e, n) {
          no(this, he(this, t), he(this, e || t), n);
        }),
        extendSelection: si(function (t, e, n) {
          Qi(this, he(this, t), e && he(this, e), n);
        }),
        extendSelections: si(function (t, e) {
          to(this, fe(this, t), e);
        }),
        extendSelectionsBy: si(function (t, e) {
          to(this, fe(this, tt(this.sel.ranges, t)), e);
        }),
        setSelections: si(function (t, e, n) {
          if (t.length) {
            for (var r = [], i = 0; i < t.length; i++) r[i] = new Pi(he(this, t[i].anchor), he(this, t[i].head || t[i].anchor));
            null == e && (e = Math.min(t.length - 1, this.sel.primIndex)), io(this, Ei(this.cm, r, e), n);
          }
        }),
        addSelection: si(function (t, e, n) {
          var r = this.sel.ranges.slice(0);
          r.push(new Pi(he(this, t), he(this, e || t))), io(this, Ei(this.cm, r, r.length - 1), n);
        }),
        getSelection: function getSelection(t) {
          for (var e, n = this.sel.ranges, r = 0; r < n.length; r++) {
            var i = Zt(this, n[r].from(), n[r].to());
            e = e ? e.concat(i) : i;
          }
          return !1 === t ? e : e.join(t || this.lineSeparator());
        },
        getSelections: function getSelections(t) {
          for (var e = [], n = this.sel.ranges, r = 0; r < n.length; r++) {
            var i = Zt(this, n[r].from(), n[r].to());
            !1 !== t && (i = i.join(t || this.lineSeparator())), e[r] = i;
          }
          return e;
        },
        replaceSelection: function replaceSelection(t, e, n) {
          for (var r = [], i = 0; i < this.sel.ranges.length; i++) r[i] = t;
          this.replaceSelections(r, e, n || "+input");
        },
        replaceSelections: si(function (t, e, n) {
          for (var r = [], i = this.sel, o = 0; o < i.ranges.length; o++) {
            var a = i.ranges[o];
            r[o] = {
              from: a.from(),
              to: a.to(),
              text: this.splitLines(t[o]),
              origin: n
            };
          }
          for (var s = e && "end" != e && function (t, e, n) {
              for (var r = [], i = oe(t.first, 0), o = i, a = 0; a < e.length; a++) {
                var s = e[a],
                  l = Ni(s.from, i, o),
                  c = Ni(Mi(s), i, o);
                if (i = s.to, o = c, "around" == n) {
                  var u = t.sel.ranges[a],
                    d = ae(u.head, u.anchor) < 0;
                  r[a] = new Pi(d ? c : l, d ? l : c);
                } else r[a] = new Pi(l, l);
              }
              return new Ti(r, t.sel.primIndex);
            }(this, r, e), l = r.length - 1; l >= 0; l--) go(this, r[l]);
          s ? ro(this, s) : this.cm && Ir(this.cm);
        }),
        undo: si(function () {
          mo(this, "undo");
        }),
        redo: si(function () {
          mo(this, "redo");
        }),
        undoSelection: si(function () {
          mo(this, "undo", !0);
        }),
        redoSelection: si(function () {
          mo(this, "redo", !0);
        }),
        setExtending: function setExtending(t) {
          this.extend = t;
        },
        getExtending: function getExtending() {
          return this.extend;
        },
        historySize: function historySize() {
          for (var t = this.history, e = 0, n = 0, r = 0; r < t.done.length; r++) t.done[r].ranges || ++e;
          for (var i = 0; i < t.undone.length; i++) t.undone[i].ranges || ++n;
          return {
            undo: e,
            redo: n
          };
        },
        clearHistory: function clearHistory() {
          var t = this;
          this.history = new $i(this.history), Ri(this, function (e) {
            return e.history = t.history;
          }, !0);
        },
        markClean: function markClean() {
          this.cleanGeneration = this.changeGeneration(!0);
        },
        changeGeneration: function changeGeneration(t) {
          return t && (this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null), this.history.generation;
        },
        isClean: function isClean(t) {
          return this.history.generation == (t || this.cleanGeneration);
        },
        getHistory: function getHistory() {
          return {
            done: Ji(this.history.done),
            undone: Ji(this.history.undone)
          };
        },
        setHistory: function setHistory(t) {
          var e = this.history = new $i(this.history);
          e.done = Ji(t.done.slice(0), null, !0), e.undone = Ji(t.undone.slice(0), null, !0);
        },
        setGutterMarker: si(function (t, e, n) {
          return So(this, t, "gutter", function (t) {
            var r = t.gutterMarkers || (t.gutterMarkers = {});
            return r[e] = n, !n && at(r) && (t.gutterMarkers = null), !0;
          });
        }),
        clearGutter: si(function (t) {
          var e = this;
          this.iter(function (n) {
            n.gutterMarkers && n.gutterMarkers[t] && So(e, n, "gutter", function () {
              return n.gutterMarkers[t] = null, at(n.gutterMarkers) && (n.gutterMarkers = null), !0;
            });
          });
        }),
        lineInfo: function lineInfo(t) {
          var e;
          if ("number" == typeof t) {
            if (!re(this, t)) return null;
            if (e = t, !(t = Jt(this, t))) return null;
          } else if (null == (e = ee(t))) return null;
          return {
            line: e,
            handle: t,
            text: t.text,
            gutterMarkers: t.gutterMarkers,
            textClass: t.textClass,
            bgClass: t.bgClass,
            wrapClass: t.wrapClass,
            widgets: t.widgets
          };
        },
        addLineClass: si(function (t, e, n) {
          return So(this, t, "gutter" == e ? "gutter" : "class", function (t) {
            var r = "text" == e ? "textClass" : "background" == e ? "bgClass" : "gutter" == e ? "gutterClass" : "wrapClass";
            if (t[r]) {
              if (k(n).test(t[r])) return !1;
              t[r] += " " + n;
            } else t[r] = n;
            return !0;
          });
        }),
        removeLineClass: si(function (t, e, n) {
          return So(this, t, "gutter" == e ? "gutter" : "class", function (t) {
            var r = "text" == e ? "textClass" : "background" == e ? "bgClass" : "gutter" == e ? "gutterClass" : "wrapClass",
              i = t[r];
            if (!i) return !1;
            if (null == n) t[r] = null;else {
              var o = i.match(k(n));
              if (!o) return !1;
              var a = o.index + o[0].length;
              t[r] = i.slice(0, o.index) + (o.index && a != i.length ? " " : "") + i.slice(a) || null;
            }
            return !0;
          });
        }),
        addLineWidget: si(function (t, e, n) {
          return function (t, e, n, r) {
            var i = new To(t, n, r),
              o = t.cm;
            return o && i.noHScroll && (o.display.alignWidgets = !0), So(t, e, "widget", function (e) {
              var n = e.widgets || (e.widgets = []);
              if (null == i.insertAt ? n.push(i) : n.splice(Math.min(n.length, Math.max(0, i.insertAt)), 0, i), i.line = e, o && !qe(t, e)) {
                var r = Ke(e) < t.scrollTop;
                te(e, e.height + jn(i)), r && _r(o, i.height), o.curOp.forceUpdate = !0;
              }
              return !0;
            }), o && fn(o, "lineWidgetAdded", o, i, "number" == typeof e ? e : ee(e)), i;
          }(this, t, e, n);
        }),
        removeLineWidget: function removeLineWidget(t) {
          t.clear();
        },
        markText: function markText(t, e, n) {
          return Mo(this, he(this, t), he(this, e), n, n && n.type || "range");
        },
        setBookmark: function setBookmark(t, e) {
          var n = {
            replacedWith: e && (null == e.nodeType ? e.widget : e),
            insertLeft: e && e.insertLeft,
            clearWhenEmpty: !1,
            shared: e && e.shared,
            handleMouseEvents: e && e.handleMouseEvents
          };
          return Mo(this, t = he(this, t), t, n, "bookmark");
        },
        findMarksAt: function findMarksAt(t) {
          var e = [],
            n = Jt(this, (t = he(this, t)).line).markedSpans;
          if (n) for (var r = 0; r < n.length; ++r) {
            var i = n[r];
            (null == i.from || i.from <= t.ch) && (null == i.to || i.to >= t.ch) && e.push(i.marker.parent || i.marker);
          }
          return e;
        },
        findMarks: function findMarks(t, e, n) {
          t = he(this, t), e = he(this, e);
          var r = [],
            i = t.line;
          return this.iter(t.line, e.line + 1, function (o) {
            var a = o.markedSpans;
            if (a) for (var s = 0; s < a.length; s++) {
              var l = a[s];
              null != l.to && i == t.line && t.ch >= l.to || null == l.from && i != t.line || null != l.from && i == e.line && l.from >= e.ch || n && !n(l.marker) || r.push(l.marker.parent || l.marker);
            }
            ++i;
          }), r;
        },
        getAllMarks: function getAllMarks() {
          var t = [];
          return this.iter(function (e) {
            var n = e.markedSpans;
            if (n) for (var r = 0; r < n.length; ++r) null != n[r].from && t.push(n[r].marker);
          }), t;
        },
        posFromIndex: function posFromIndex(t) {
          var e,
            n = this.first,
            r = this.lineSeparator().length;
          return this.iter(function (i) {
            var o = i.text.length + r;
            if (o > t) return e = t, !0;
            t -= o, ++n;
          }), he(this, oe(n, e));
        },
        indexFromPos: function indexFromPos(t) {
          var e = (t = he(this, t)).ch;
          if (t.line < this.first || t.ch < 0) return 0;
          var n = this.lineSeparator().length;
          return this.iter(this.first, t.line, function (t) {
            e += t.text.length + n;
          }), e;
        },
        copy: function copy(t) {
          var e = new _Io(Qt(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
          return e.scrollTop = this.scrollTop, e.scrollLeft = this.scrollLeft, e.sel = this.sel, e.extend = !1, t && (e.history.undoDepth = this.history.undoDepth, e.setHistory(this.getHistory())), e;
        },
        linkedDoc: function linkedDoc(t) {
          t || (t = {});
          var e = this.first,
            n = this.first + this.size;
          null != t.from && t.from > e && (e = t.from), null != t.to && t.to < n && (n = t.to);
          var r = new _Io(Qt(this, e, n), t.mode || this.modeOption, e, this.lineSep, this.direction);
          return t.sharedHist && (r.history = this.history), (this.linked || (this.linked = [])).push({
            doc: r,
            sharedHist: t.sharedHist
          }), r.linked = [{
            doc: this,
            isParent: !0,
            sharedHist: t.sharedHist
          }], function (t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n],
                i = r.find(),
                o = t.clipPos(i.from),
                a = t.clipPos(i.to);
              if (ae(o, a)) {
                var s = Mo(t, o, a, r.primary, r.primary.type);
                r.markers.push(s), s.parent = r;
              }
            }
          }(r, Lo(this)), r;
        },
        unlinkDoc: function unlinkDoc(t) {
          if (t instanceof Aa && (t = t.doc), this.linked) for (var e = 0; e < this.linked.length; ++e) if (this.linked[e].doc == t) {
            this.linked.splice(e, 1), t.unlinkDoc(this), No(Lo(this));
            break;
          }
          if (t.history == this.history) {
            var n = [t.id];
            Ri(t, function (t) {
              return n.push(t.id);
            }, !0), t.history = new $i(null), t.history.done = Ji(this.history.done, n), t.history.undone = Ji(this.history.undone, n);
          }
        },
        iterLinkedDocs: function iterLinkedDocs(t) {
          Ri(this, t);
        },
        getMode: function getMode() {
          return this.mode;
        },
        getEditor: function getEditor() {
          return this.cm;
        },
        splitLines: function splitLines(t) {
          return this.lineSep ? t.split(this.lineSep) : It(t);
        },
        lineSeparator: function lineSeparator() {
          return this.lineSep || "\n";
        },
        setDirection: si(function (t) {
          var e;
          "rtl" != t && (t = "ltr"), t != this.direction && (this.direction = t, this.iter(function (t) {
            return t.order = null;
          }), this.cm && ii(e = this.cm, function () {
            Hi(e), vr(e);
          }));
        })
      }), _Io.prototype.eachLine = _Io.prototype.iter;
      var Fo = 0;
      function Vo(t) {
        var e = this;
        if (Ro(e), !wt(e, t) && !Tn(e.display, t)) {
          St(t), a && (Fo = +new Date());
          var n = pr(e, t, !0),
            r = t.dataTransfer.files;
          if (n && !e.isReadOnly()) if (r && r.length && window.FileReader && window.File) for (var i = r.length, o = Array(i), s = 0, l = function l() {
              ++s == i && oi(e, function () {
                var t = {
                  from: n = he(e.doc, n),
                  to: n,
                  text: e.doc.splitLines(o.filter(function (t) {
                    return null != t;
                  }).join(e.doc.lineSeparator())),
                  origin: "paste"
                };
                go(e.doc, t), ro(e.doc, Di(he(e.doc, n), he(e.doc, Mi(t))));
              })();
            }, c = function c(t, n) {
              if (e.options.allowDropFileTypes && -1 == U(e.options.allowDropFileTypes, t.type)) l();else {
                var r = new FileReader();
                r.onerror = function () {
                  return l();
                }, r.onload = function () {
                  var t = r.result;
                  /[\x00-\x08\x0e-\x1f]{2}/.test(t) || (o[n] = t), l();
                }, r.readAsText(t);
              }
            }, u = 0; u < r.length; u++) c(r[u], u);else {
            if (e.state.draggingText && e.doc.sel.contains(n) > -1) return e.state.draggingText(t), void setTimeout(function () {
              return e.display.input.focus();
            }, 20);
            try {
              var d = t.dataTransfer.getData("Text");
              if (d) {
                var h;
                if (e.state.draggingText && !e.state.draggingText.copy && (h = e.listSelections()), oo(e.doc, Di(n, n)), h) for (var f = 0; f < h.length; ++f) wo(e.doc, "", h[f].anchor, h[f].head, "drag");
                e.replaceSelection(d, "around", "paste"), e.display.input.focus();
              }
            } catch (t) {}
          }
        }
      }
      function Ro(t) {
        t.display.dragCursor && (t.display.lineSpace.removeChild(t.display.dragCursor), t.display.dragCursor = null);
      }
      function zo(t) {
        if (document.getElementsByClassName) {
          for (var e = document.getElementsByClassName("CodeMirror"), n = [], r = 0; r < e.length; r++) {
            var i = e[r].CodeMirror;
            i && n.push(i);
          }
          n.length && n[0].operation(function () {
            for (var e = 0; e < n.length; e++) t(n[e]);
          });
        }
      }
      var Ho = !1;
      function $o() {
        var t;
        Ho || (vt(window, "resize", function () {
          null == t && (t = setTimeout(function () {
            t = null, zo(Bo);
          }, 100));
        }), vt(window, "blur", function () {
          return zo(Dr);
        }), Ho = !0);
      }
      function Bo(t) {
        var e = t.display;
        e.cachedCharWidth = e.cachedTextHeight = e.cachedPaddingH = null, e.scrollbarsClipped = !1, t.setSize();
      }
      for (var Wo = {
          3: "Pause",
          8: "Backspace",
          9: "Tab",
          13: "Enter",
          16: "Shift",
          17: "Ctrl",
          18: "Alt",
          19: "Pause",
          20: "CapsLock",
          27: "Esc",
          32: "Space",
          33: "PageUp",
          34: "PageDown",
          35: "End",
          36: "Home",
          37: "Left",
          38: "Up",
          39: "Right",
          40: "Down",
          44: "PrintScrn",
          45: "Insert",
          46: "Delete",
          59: ";",
          61: "=",
          91: "Mod",
          92: "Mod",
          93: "Mod",
          106: "*",
          107: "=",
          109: "-",
          110: ".",
          111: "/",
          145: "ScrollLock",
          173: "-",
          186: ";",
          187: "=",
          188: ",",
          189: "-",
          190: ".",
          191: "/",
          192: "`",
          219: "[",
          220: "\\",
          221: "]",
          222: "'",
          224: "Mod",
          63232: "Up",
          63233: "Down",
          63234: "Left",
          63235: "Right",
          63272: "Delete",
          63273: "Home",
          63275: "End",
          63276: "PageUp",
          63277: "PageDown",
          63302: "Insert"
        }, Uo = 0; Uo < 10; Uo++) Wo[Uo + 48] = Wo[Uo + 96] = String(Uo);
      for (var qo = 65; qo <= 90; qo++) Wo[qo] = String.fromCharCode(qo);
      for (var Go = 1; Go <= 12; Go++) Wo[Go + 111] = Wo[Go + 63235] = "F" + Go;
      var Ko = {};
      function Yo(t) {
        var e,
          n,
          r,
          i,
          o = t.split(/-(?!$)/);
        t = o[o.length - 1];
        for (var a = 0; a < o.length - 1; a++) {
          var s = o[a];
          if (/^(cmd|meta|m)$/i.test(s)) i = !0;else if (/^a(lt)?$/i.test(s)) e = !0;else if (/^(c|ctrl|control)$/i.test(s)) n = !0;else {
            if (!/^s(hift)?$/i.test(s)) throw new Error("Unrecognized modifier name: " + s);
            r = !0;
          }
        }
        return e && (t = "Alt-" + t), n && (t = "Ctrl-" + t), i && (t = "Cmd-" + t), r && (t = "Shift-" + t), t;
      }
      function Xo(t) {
        var e = {};
        for (var n in t) if (t.hasOwnProperty(n)) {
          var r = t[n];
          if (/^(name|fallthrough|(de|at)tach)$/.test(n)) continue;
          if ("..." == r) {
            delete t[n];
            continue;
          }
          for (var i = tt(n.split(" "), Yo), o = 0; o < i.length; o++) {
            var a = void 0,
              s = void 0;
            o == i.length - 1 ? (s = i.join(" "), a = r) : (s = i.slice(0, o + 1).join(" "), a = "...");
            var l = e[s];
            if (l) {
              if (l != a) throw new Error("Inconsistent bindings for " + s);
            } else e[s] = a;
          }
          delete t[n];
        }
        for (var c in e) t[c] = e[c];
        return t;
      }
      function Jo(t, e, n, r) {
        var i = (e = ea(e)).call ? e.call(t, r) : e[t];
        if (!1 === i) return "nothing";
        if ("..." === i) return "multi";
        if (null != i && n(i)) return "handled";
        if (e.fallthrough) {
          if ("[object Array]" != Object.prototype.toString.call(e.fallthrough)) return Jo(t, e.fallthrough, n, r);
          for (var o = 0; o < e.fallthrough.length; o++) {
            var a = Jo(t, e.fallthrough[o], n, r);
            if (a) return a;
          }
        }
      }
      function Zo(t) {
        var e = "string" == typeof t ? t : Wo[t.keyCode];
        return "Ctrl" == e || "Alt" == e || "Shift" == e || "Mod" == e;
      }
      function Qo(t, e, n) {
        var r = t;
        return e.altKey && "Alt" != r && (t = "Alt-" + t), (C ? e.metaKey : e.ctrlKey) && "Ctrl" != r && (t = "Ctrl-" + t), (C ? e.ctrlKey : e.metaKey) && "Mod" != r && (t = "Cmd-" + t), !n && e.shiftKey && "Shift" != r && (t = "Shift-" + t), t;
      }
      function ta(t, e) {
        if (h && 34 == t.keyCode && t.char) return !1;
        var n = Wo[t.keyCode];
        return null != n && !t.altGraphKey && (3 == t.keyCode && t.code && (n = t.code), Qo(n, t, e));
      }
      function ea(t) {
        return "string" == typeof t ? Ko[t] : t;
      }
      function na(t, e) {
        for (var n = t.doc.sel.ranges, r = [], i = 0; i < n.length; i++) {
          for (var o = e(n[i]); r.length && ae(o.from, Q(r).to) <= 0;) {
            var a = r.pop();
            if (ae(a.from, o.from) < 0) {
              o.from = a.from;
              break;
            }
          }
          r.push(o);
        }
        ii(t, function () {
          for (var e = r.length - 1; e >= 0; e--) wo(t.doc, "", r[e].from, r[e].to, "+delete");
          Ir(t);
        });
      }
      function ra(t, e, n) {
        var r = ct(t.text, e + n, n);
        return r < 0 || r > t.text.length ? null : r;
      }
      function ia(t, e, n) {
        var r = ra(t, e.ch, n);
        return null == r ? null : new oe(e.line, r, n < 0 ? "after" : "before");
      }
      function oa(t, e, n, r, i) {
        if (t) {
          "rtl" == e.doc.direction && (i = -i);
          var o = pt(n, e.doc.direction);
          if (o) {
            var a,
              s = i < 0 ? Q(o) : o[0],
              l = i < 0 == (1 == s.level) ? "after" : "before";
            if (s.level > 0 || "rtl" == e.doc.direction) {
              var c = Fn(e, n);
              a = i < 0 ? n.text.length - 1 : 0;
              var u = Vn(e, c, a).top;
              a = ut(function (t) {
                return Vn(e, c, t).top == u;
              }, i < 0 == (1 == s.level) ? s.from : s.to - 1, a), "before" == l && (a = ra(n, a, 1));
            } else a = i < 0 ? s.to : s.from;
            return new oe(r, a, l);
          }
        }
        return new oe(r, i < 0 ? n.text.length : 0, i < 0 ? "before" : "after");
      }
      Ko.basic = {
        Left: "goCharLeft",
        Right: "goCharRight",
        Up: "goLineUp",
        Down: "goLineDown",
        End: "goLineEnd",
        Home: "goLineStartSmart",
        PageUp: "goPageUp",
        PageDown: "goPageDown",
        Delete: "delCharAfter",
        Backspace: "delCharBefore",
        "Shift-Backspace": "delCharBefore",
        Tab: "defaultTab",
        "Shift-Tab": "indentAuto",
        Enter: "newlineAndIndent",
        Insert: "toggleOverwrite",
        Esc: "singleSelection"
      }, Ko.pcDefault = {
        "Ctrl-A": "selectAll",
        "Ctrl-D": "deleteLine",
        "Ctrl-Z": "undo",
        "Shift-Ctrl-Z": "redo",
        "Ctrl-Y": "redo",
        "Ctrl-Home": "goDocStart",
        "Ctrl-End": "goDocEnd",
        "Ctrl-Up": "goLineUp",
        "Ctrl-Down": "goLineDown",
        "Ctrl-Left": "goGroupLeft",
        "Ctrl-Right": "goGroupRight",
        "Alt-Left": "goLineStart",
        "Alt-Right": "goLineEnd",
        "Ctrl-Backspace": "delGroupBefore",
        "Ctrl-Delete": "delGroupAfter",
        "Ctrl-S": "save",
        "Ctrl-F": "find",
        "Ctrl-G": "findNext",
        "Shift-Ctrl-G": "findPrev",
        "Shift-Ctrl-F": "replace",
        "Shift-Ctrl-R": "replaceAll",
        "Ctrl-[": "indentLess",
        "Ctrl-]": "indentMore",
        "Ctrl-U": "undoSelection",
        "Shift-Ctrl-U": "redoSelection",
        "Alt-U": "redoSelection",
        fallthrough: "basic"
      }, Ko.emacsy = {
        "Ctrl-F": "goCharRight",
        "Ctrl-B": "goCharLeft",
        "Ctrl-P": "goLineUp",
        "Ctrl-N": "goLineDown",
        "Ctrl-A": "goLineStart",
        "Ctrl-E": "goLineEnd",
        "Ctrl-V": "goPageDown",
        "Shift-Ctrl-V": "goPageUp",
        "Ctrl-D": "delCharAfter",
        "Ctrl-H": "delCharBefore",
        "Alt-Backspace": "delWordBefore",
        "Ctrl-K": "killLine",
        "Ctrl-T": "transposeChars",
        "Ctrl-O": "openLine"
      }, Ko.macDefault = {
        "Cmd-A": "selectAll",
        "Cmd-D": "deleteLine",
        "Cmd-Z": "undo",
        "Shift-Cmd-Z": "redo",
        "Cmd-Y": "redo",
        "Cmd-Home": "goDocStart",
        "Cmd-Up": "goDocStart",
        "Cmd-End": "goDocEnd",
        "Cmd-Down": "goDocEnd",
        "Alt-Left": "goGroupLeft",
        "Alt-Right": "goGroupRight",
        "Cmd-Left": "goLineLeft",
        "Cmd-Right": "goLineRight",
        "Alt-Backspace": "delGroupBefore",
        "Ctrl-Alt-Backspace": "delGroupAfter",
        "Alt-Delete": "delGroupAfter",
        "Cmd-S": "save",
        "Cmd-F": "find",
        "Cmd-G": "findNext",
        "Shift-Cmd-G": "findPrev",
        "Cmd-Alt-F": "replace",
        "Shift-Cmd-Alt-F": "replaceAll",
        "Cmd-[": "indentLess",
        "Cmd-]": "indentMore",
        "Cmd-Backspace": "delWrappedLineLeft",
        "Cmd-Delete": "delWrappedLineRight",
        "Cmd-U": "undoSelection",
        "Shift-Cmd-U": "redoSelection",
        "Ctrl-Up": "goDocStart",
        "Ctrl-Down": "goDocEnd",
        fallthrough: ["basic", "emacsy"]
      }, Ko.default = y ? Ko.macDefault : Ko.pcDefault;
      var aa = {
        selectAll: fo,
        singleSelection: function singleSelection(t) {
          return t.setSelection(t.getCursor("anchor"), t.getCursor("head"), G);
        },
        killLine: function killLine(t) {
          return na(t, function (e) {
            if (e.empty()) {
              var n = Jt(t.doc, e.head.line).text.length;
              return e.head.ch == n && e.head.line < t.lastLine() ? {
                from: e.head,
                to: oe(e.head.line + 1, 0)
              } : {
                from: e.head,
                to: oe(e.head.line, n)
              };
            }
            return {
              from: e.from(),
              to: e.to()
            };
          });
        },
        deleteLine: function deleteLine(t) {
          return na(t, function (e) {
            return {
              from: oe(e.from().line, 0),
              to: he(t.doc, oe(e.to().line + 1, 0))
            };
          });
        },
        delLineLeft: function delLineLeft(t) {
          return na(t, function (t) {
            return {
              from: oe(t.from().line, 0),
              to: t.from()
            };
          });
        },
        delWrappedLineLeft: function delWrappedLineLeft(t) {
          return na(t, function (e) {
            var n = t.charCoords(e.head, "div").top + 5;
            return {
              from: t.coordsChar({
                left: 0,
                top: n
              }, "div"),
              to: e.from()
            };
          });
        },
        delWrappedLineRight: function delWrappedLineRight(t) {
          return na(t, function (e) {
            var n = t.charCoords(e.head, "div").top + 5,
              r = t.coordsChar({
                left: t.display.lineDiv.offsetWidth + 100,
                top: n
              }, "div");
            return {
              from: e.from(),
              to: r
            };
          });
        },
        undo: function undo(t) {
          return t.undo();
        },
        redo: function redo(t) {
          return t.redo();
        },
        undoSelection: function undoSelection(t) {
          return t.undoSelection();
        },
        redoSelection: function redoSelection(t) {
          return t.redoSelection();
        },
        goDocStart: function goDocStart(t) {
          return t.extendSelection(oe(t.firstLine(), 0));
        },
        goDocEnd: function goDocEnd(t) {
          return t.extendSelection(oe(t.lastLine()));
        },
        goLineStart: function goLineStart(t) {
          return t.extendSelectionsBy(function (e) {
            return sa(t, e.head.line);
          }, {
            origin: "+move",
            bias: 1
          });
        },
        goLineStartSmart: function goLineStartSmart(t) {
          return t.extendSelectionsBy(function (e) {
            return la(t, e.head);
          }, {
            origin: "+move",
            bias: 1
          });
        },
        goLineEnd: function goLineEnd(t) {
          return t.extendSelectionsBy(function (e) {
            return function (t, e) {
              var n = Jt(t.doc, e),
                r = function (t) {
                  for (var e; e = ze(t);) t = e.find(1, !0).line;
                  return t;
                }(n);
              return r != n && (e = ee(r)), oa(!0, t, n, e, -1);
            }(t, e.head.line);
          }, {
            origin: "+move",
            bias: -1
          });
        },
        goLineRight: function goLineRight(t) {
          return t.extendSelectionsBy(function (e) {
            var n = t.cursorCoords(e.head, "div").top + 5;
            return t.coordsChar({
              left: t.display.lineDiv.offsetWidth + 100,
              top: n
            }, "div");
          }, Y);
        },
        goLineLeft: function goLineLeft(t) {
          return t.extendSelectionsBy(function (e) {
            var n = t.cursorCoords(e.head, "div").top + 5;
            return t.coordsChar({
              left: 0,
              top: n
            }, "div");
          }, Y);
        },
        goLineLeftSmart: function goLineLeftSmart(t) {
          return t.extendSelectionsBy(function (e) {
            var n = t.cursorCoords(e.head, "div").top + 5,
              r = t.coordsChar({
                left: 0,
                top: n
              }, "div");
            return r.ch < t.getLine(r.line).search(/\S/) ? la(t, e.head) : r;
          }, Y);
        },
        goLineUp: function goLineUp(t) {
          return t.moveV(-1, "line");
        },
        goLineDown: function goLineDown(t) {
          return t.moveV(1, "line");
        },
        goPageUp: function goPageUp(t) {
          return t.moveV(-1, "page");
        },
        goPageDown: function goPageDown(t) {
          return t.moveV(1, "page");
        },
        goCharLeft: function goCharLeft(t) {
          return t.moveH(-1, "char");
        },
        goCharRight: function goCharRight(t) {
          return t.moveH(1, "char");
        },
        goColumnLeft: function goColumnLeft(t) {
          return t.moveH(-1, "column");
        },
        goColumnRight: function goColumnRight(t) {
          return t.moveH(1, "column");
        },
        goWordLeft: function goWordLeft(t) {
          return t.moveH(-1, "word");
        },
        goGroupRight: function goGroupRight(t) {
          return t.moveH(1, "group");
        },
        goGroupLeft: function goGroupLeft(t) {
          return t.moveH(-1, "group");
        },
        goWordRight: function goWordRight(t) {
          return t.moveH(1, "word");
        },
        delCharBefore: function delCharBefore(t) {
          return t.deleteH(-1, "codepoint");
        },
        delCharAfter: function delCharAfter(t) {
          return t.deleteH(1, "char");
        },
        delWordBefore: function delWordBefore(t) {
          return t.deleteH(-1, "word");
        },
        delWordAfter: function delWordAfter(t) {
          return t.deleteH(1, "word");
        },
        delGroupBefore: function delGroupBefore(t) {
          return t.deleteH(-1, "group");
        },
        delGroupAfter: function delGroupAfter(t) {
          return t.deleteH(1, "group");
        },
        indentAuto: function indentAuto(t) {
          return t.indentSelection("smart");
        },
        indentMore: function indentMore(t) {
          return t.indentSelection("add");
        },
        indentLess: function indentLess(t) {
          return t.indentSelection("subtract");
        },
        insertTab: function insertTab(t) {
          return t.replaceSelection("\t");
        },
        insertSoftTab: function insertSoftTab(t) {
          for (var e = [], n = t.listSelections(), r = t.options.tabSize, i = 0; i < n.length; i++) {
            var o = n[i].from(),
              a = B(t.getLine(o.line), o.ch, r);
            e.push(Z(r - a % r));
          }
          t.replaceSelections(e);
        },
        defaultTab: function defaultTab(t) {
          t.somethingSelected() ? t.indentSelection("add") : t.execCommand("insertTab");
        },
        transposeChars: function transposeChars(t) {
          return ii(t, function () {
            for (var e = t.listSelections(), n = [], r = 0; r < e.length; r++) if (e[r].empty()) {
              var i = e[r].head,
                o = Jt(t.doc, i.line).text;
              if (o) if (i.ch == o.length && (i = new oe(i.line, i.ch - 1)), i.ch > 0) i = new oe(i.line, i.ch + 1), t.replaceRange(o.charAt(i.ch - 1) + o.charAt(i.ch - 2), oe(i.line, i.ch - 2), i, "+transpose");else if (i.line > t.doc.first) {
                var a = Jt(t.doc, i.line - 1).text;
                a && (i = new oe(i.line, 1), t.replaceRange(o.charAt(0) + t.doc.lineSeparator() + a.charAt(a.length - 1), oe(i.line - 1, a.length - 1), i, "+transpose"));
              }
              n.push(new Pi(i, i));
            }
            t.setSelections(n);
          });
        },
        newlineAndIndent: function newlineAndIndent(t) {
          return ii(t, function () {
            for (var e = t.listSelections(), n = e.length - 1; n >= 0; n--) t.replaceRange(t.doc.lineSeparator(), e[n].anchor, e[n].head, "+input");
            e = t.listSelections();
            for (var r = 0; r < e.length; r++) t.indentLine(e[r].from().line, null, !0);
            Ir(t);
          });
        },
        openLine: function openLine(t) {
          return t.replaceSelection("\n", "start");
        },
        toggleOverwrite: function toggleOverwrite(t) {
          return t.toggleOverwrite();
        }
      };
      function sa(t, e) {
        var n = Jt(t.doc, e),
          r = Be(n);
        return r != n && (e = ee(r)), oa(!0, t, r, e, 1);
      }
      function la(t, e) {
        var n = sa(t, e.line),
          r = Jt(t.doc, n.line),
          i = pt(r, t.doc.direction);
        if (!i || 0 == i[0].level) {
          var o = Math.max(n.ch, r.text.search(/\S/)),
            a = e.line == n.line && e.ch <= o && e.ch;
          return oe(n.line, a ? 0 : o, n.sticky);
        }
        return n;
      }
      function ca(t, e, n) {
        if ("string" == typeof e && !(e = aa[e])) return !1;
        t.display.input.ensurePolled();
        var r = t.display.shift,
          i = !1;
        try {
          t.isReadOnly() && (t.state.suppressEdits = !0), n && (t.display.shift = !1), i = e(t) != q;
        } finally {
          t.display.shift = r, t.state.suppressEdits = !1;
        }
        return i;
      }
      var ua = new W();
      function da(t, e, n, r) {
        var i = t.state.keySeq;
        if (i) {
          if (Zo(e)) return "handled";
          if (/\'$/.test(e) ? t.state.keySeq = null : ua.set(50, function () {
            t.state.keySeq == i && (t.state.keySeq = null, t.display.input.reset());
          }), ha(t, i + " " + e, n, r)) return !0;
        }
        return ha(t, e, n, r);
      }
      function ha(t, e, n, r) {
        var i = function (t, e, n) {
          for (var r = 0; r < t.state.keyMaps.length; r++) {
            var i = Jo(e, t.state.keyMaps[r], n, t);
            if (i) return i;
          }
          return t.options.extraKeys && Jo(e, t.options.extraKeys, n, t) || Jo(e, t.options.keyMap, n, t);
        }(t, e, r);
        return "multi" == i && (t.state.keySeq = e), "handled" == i && fn(t, "keyHandled", t, e, n), "handled" != i && "multi" != i || (St(n), jr(t)), !!i;
      }
      function fa(t, e) {
        var n = ta(e, !0);
        return !!n && (e.shiftKey && !t.state.keySeq ? da(t, "Shift-" + n, e, function (e) {
          return ca(t, e, !0);
        }) || da(t, n, e, function (e) {
          if ("string" == typeof e ? /^go[A-Z]/.test(e) : e.motion) return ca(t, e);
        }) : da(t, n, e, function (e) {
          return ca(t, e);
        }));
      }
      var pa = null;
      function ga(t) {
        var e = this;
        if (!(t.target && t.target != e.display.input.getField() || (e.curOp.focus = L(V(e)), wt(e, t)))) {
          a && s < 11 && 27 == t.keyCode && (t.returnValue = !1);
          var r = t.keyCode;
          e.display.shift = 16 == r || t.shiftKey;
          var i = fa(e, t);
          h && (pa = i ? r : null, i || 88 != r || Vt || !(y ? t.metaKey : t.ctrlKey) || e.replaceSelection("", null, "cut")), n && !y && !i && 46 == r && t.shiftKey && !t.ctrlKey && document.execCommand && document.execCommand("cut"), 18 != r || /\bCodeMirror-crosshair\b/.test(e.display.lineDiv.className) || function (t) {
            var e = t.display.lineDiv;
            function n(t) {
              18 != t.keyCode && t.altKey || (T(e, "CodeMirror-crosshair"), bt(document, "keyup", n), bt(document, "mouseover", n));
            }
            N(e, "CodeMirror-crosshair"), vt(document, "keyup", n), vt(document, "mouseover", n);
          }(e);
        }
      }
      function va(t) {
        16 == t.keyCode && (this.doc.sel.shift = !1), wt(this, t);
      }
      function ma(t) {
        var e = this;
        if (!(t.target && t.target != e.display.input.getField() || Tn(e.display, t) || wt(e, t) || t.ctrlKey && !t.altKey || y && t.metaKey)) {
          var n = t.keyCode,
            r = t.charCode;
          if (h && n == pa) return pa = null, void St(t);
          if (!h || t.which && !(t.which < 10) || !fa(e, t)) {
            var i = String.fromCharCode(null == r ? n : r);
            "\b" != i && (function (t, e, n) {
              return da(t, "'" + n + "'", e, function (e) {
                return ca(t, e, !0);
              });
            }(e, t, i) || e.display.input.onKeyPress(t));
          }
        }
      }
      var ba,
        ya,
        wa = function wa(t, e, n) {
          this.time = t, this.pos = e, this.button = n;
        };
      function xa(t) {
        var e = this,
          n = e.display;
        if (!(wt(e, t) || n.activeTouch && n.input.supportsTouch())) if (n.input.ensurePolled(), n.shift = t.shiftKey, Tn(n, t)) l || (n.scroller.draggable = !1, setTimeout(function () {
          return n.scroller.draggable = !0;
        }, 100));else if (!Sa(e, t)) {
          var r = pr(e, t),
            i = Et(t),
            o = r ? function (t, e) {
              var n = +new Date();
              return ya && ya.compare(n, t, e) ? (ba = ya = null, "triple") : ba && ba.compare(n, t, e) ? (ya = new wa(n, t, e), ba = null, "double") : (ba = new wa(n, t, e), ya = null, "single");
            }(r, i) : "single";
          z(e).focus(), 1 == i && e.state.selectingText && e.state.selectingText(t), r && function (t, e, n, r, i) {
            var o = "Click";
            return "double" == r ? o = "Double" + o : "triple" == r && (o = "Triple" + o), da(t, Qo(o = (1 == e ? "Left" : 2 == e ? "Middle" : "Right") + o, i), i, function (e) {
              if ("string" == typeof e && (e = aa[e]), !e) return !1;
              var r = !1;
              try {
                t.isReadOnly() && (t.state.suppressEdits = !0), r = e(t, n) != q;
              } finally {
                t.state.suppressEdits = !1;
              }
              return r;
            });
          }(e, i, r, o, t) || (1 == i ? r ? function (t, e, n, r) {
            a ? setTimeout(H(Tr, t), 0) : t.curOp.focus = L(V(t));
            var i,
              o = function (t, e, n) {
                var r = t.getOption("configureMouse"),
                  i = r ? r(t, e, n) : {};
                if (null == i.unit) {
                  var o = w ? n.shiftKey && n.metaKey : n.altKey;
                  i.unit = o ? "rectangle" : "single" == e ? "char" : "double" == e ? "word" : "line";
                }
                return (null == i.extend || t.doc.extend) && (i.extend = t.doc.extend || n.shiftKey), null == i.addNew && (i.addNew = y ? n.metaKey : n.ctrlKey), null == i.moveOnDrag && (i.moveOnDrag = !(y ? n.altKey : n.ctrlKey)), i;
              }(t, n, r),
              c = t.doc.sel;
            t.options.dragDrop && At && !t.isReadOnly() && "single" == n && (i = c.contains(e)) > -1 && (ae((i = c.ranges[i]).from(), e) < 0 || e.xRel > 0) && (ae(i.to(), e) > 0 || e.xRel < 0) ? function (t, e, n, r) {
              var i = t.display,
                o = !1,
                c = oi(t, function (e) {
                  l && (i.scroller.draggable = !1), t.state.draggingText = !1, t.state.delayingBlurEvent && (t.hasFocus() ? t.state.delayingBlurEvent = !1 : Pr(t)), bt(i.wrapper.ownerDocument, "mouseup", c), bt(i.wrapper.ownerDocument, "mousemove", u), bt(i.scroller, "dragstart", d), bt(i.scroller, "drop", c), o || (St(e), r.addNew || Qi(t.doc, n, null, null, r.extend), l && !f || a && 9 == s ? setTimeout(function () {
                    i.wrapper.ownerDocument.body.focus({
                      preventScroll: !0
                    }), i.input.focus();
                  }, 20) : i.input.focus());
                }),
                u = function u(t) {
                  o = o || Math.abs(e.clientX - t.clientX) + Math.abs(e.clientY - t.clientY) >= 10;
                },
                d = function d() {
                  return o = !0;
                };
              l && (i.scroller.draggable = !0), t.state.draggingText = c, c.copy = !r.moveOnDrag, vt(i.wrapper.ownerDocument, "mouseup", c), vt(i.wrapper.ownerDocument, "mousemove", u), vt(i.scroller, "dragstart", d), vt(i.scroller, "drop", c), t.state.delayingBlurEvent = !0, setTimeout(function () {
                return i.input.focus();
              }, 20), i.scroller.dragDrop && i.scroller.dragDrop();
            }(t, r, e, o) : function (t, e, n, r) {
              a && Pr(t);
              var i = t.display,
                o = t.doc;
              St(e);
              var s,
                l,
                c = o.sel,
                u = c.ranges;
              if (r.addNew && !r.extend ? (l = o.sel.contains(n), s = l > -1 ? u[l] : new Pi(n, n)) : (s = o.sel.primary(), l = o.sel.primIndex), "rectangle" == r.unit) r.addNew || (s = new Pi(n, n)), n = pr(t, e, !0, !0), l = -1;else {
                var d = Oa(t, n, r.unit);
                s = r.extend ? Zi(s, d.anchor, d.head, r.extend) : d;
              }
              r.addNew ? -1 == l ? (l = u.length, io(o, Ei(t, u.concat([s]), l), {
                scroll: !1,
                origin: "*mouse"
              })) : u.length > 1 && u[l].empty() && "char" == r.unit && !r.extend ? (io(o, Ei(t, u.slice(0, l).concat(u.slice(l + 1)), 0), {
                scroll: !1,
                origin: "*mouse"
              }), c = o.sel) : eo(o, l, s, K) : (l = 0, io(o, new Ti([s], 0), K), c = o.sel);
              var h = n;
              function f(e) {
                if (0 != ae(h, e)) if (h = e, "rectangle" == r.unit) {
                  for (var i = [], a = t.options.tabSize, u = B(Jt(o, n.line).text, n.ch, a), d = B(Jt(o, e.line).text, e.ch, a), f = Math.min(u, d), p = Math.max(u, d), g = Math.min(n.line, e.line), v = Math.min(t.lastLine(), Math.max(n.line, e.line)); g <= v; g++) {
                    var m = Jt(o, g).text,
                      b = X(m, f, a);
                    f == p ? i.push(new Pi(oe(g, b), oe(g, b))) : m.length > b && i.push(new Pi(oe(g, b), oe(g, X(m, p, a))));
                  }
                  i.length || i.push(new Pi(n, n)), io(o, Ei(t, c.ranges.slice(0, l).concat(i), l), {
                    origin: "*mouse",
                    scroll: !1
                  }), t.scrollIntoView(e);
                } else {
                  var y,
                    w = s,
                    x = Oa(t, e, r.unit),
                    O = w.anchor;
                  ae(x.anchor, O) > 0 ? (y = x.head, O = ue(w.from(), x.anchor)) : (y = x.anchor, O = ce(w.to(), x.head));
                  var C = c.ranges.slice(0);
                  C[l] = function (t, e) {
                    var n = e.anchor,
                      r = e.head,
                      i = Jt(t.doc, n.line);
                    if (0 == ae(n, r) && n.sticky == r.sticky) return e;
                    var o = pt(i);
                    if (!o) return e;
                    var a = ht(o, n.ch, n.sticky),
                      s = o[a];
                    if (s.from != n.ch && s.to != n.ch) return e;
                    var l,
                      c = a + (s.from == n.ch == (1 != s.level) ? 0 : 1);
                    if (0 == c || c == o.length) return e;
                    if (r.line != n.line) l = (r.line - n.line) * ("ltr" == t.doc.direction ? 1 : -1) > 0;else {
                      var u = ht(o, r.ch, r.sticky),
                        d = u - a || (r.ch - n.ch) * (1 == s.level ? -1 : 1);
                      l = u == c - 1 || u == c ? d < 0 : d > 0;
                    }
                    var h = o[c + (l ? -1 : 0)],
                      f = l == (1 == h.level),
                      p = f ? h.from : h.to,
                      g = f ? "after" : "before";
                    return n.ch == p && n.sticky == g ? e : new Pi(new oe(n.line, p, g), r);
                  }(t, new Pi(he(o, O), y)), io(o, Ei(t, C, l), K);
                }
              }
              var p = i.wrapper.getBoundingClientRect(),
                g = 0;
              function v(e) {
                t.state.selectingText = !1, g = 1 / 0, e && (St(e), i.input.focus()), bt(i.wrapper.ownerDocument, "mousemove", m), bt(i.wrapper.ownerDocument, "mouseup", b), o.history.lastSelOrigin = null;
              }
              var m = oi(t, function (e) {
                  0 !== e.buttons && Et(e) ? function e(n) {
                    var a = ++g,
                      s = pr(t, n, !0, "rectangle" == r.unit);
                    if (s) if (0 != ae(s, h)) {
                      t.curOp.focus = L(V(t)), f(s);
                      var l = Lr(i, o);
                      (s.line >= l.to || s.line < l.from) && setTimeout(oi(t, function () {
                        g == a && e(n);
                      }), 150);
                    } else {
                      var c = n.clientY < p.top ? -20 : n.clientY > p.bottom ? 20 : 0;
                      c && setTimeout(oi(t, function () {
                        g == a && (i.scroller.scrollTop += c, e(n));
                      }), 50);
                    }
                  }(e) : v(e);
                }),
                b = oi(t, v);
              t.state.selectingText = b, vt(i.wrapper.ownerDocument, "mousemove", m), vt(i.wrapper.ownerDocument, "mouseup", b);
            }(t, r, e, o);
          }(e, r, o, t) : Pt(t) == n.scroller && St(t) : 2 == i ? (r && Qi(e.doc, r), setTimeout(function () {
            return n.input.focus();
          }, 20)) : 3 == i && (S ? e.display.input.onContextMenu(t) : Pr(e)));
        }
      }
      function Oa(t, e, n) {
        if ("char" == n) return new Pi(e, e);
        if ("word" == n) return t.findWordAt(e);
        if ("line" == n) return new Pi(oe(e.line, 0), he(t.doc, oe(e.line + 1, 0)));
        var r = n(t, e);
        return new Pi(r.from, r.to);
      }
      function Ca(t, e, n, r) {
        var i, o;
        if (e.touches) i = e.touches[0].clientX, o = e.touches[0].clientY;else try {
          i = e.clientX, o = e.clientY;
        } catch (t) {
          return !1;
        }
        if (i >= Math.floor(t.display.gutters.getBoundingClientRect().right)) return !1;
        r && St(e);
        var a = t.display,
          s = a.lineDiv.getBoundingClientRect();
        if (o > s.bottom || !Ot(t, n)) return jt(e);
        o -= s.top - a.viewOffset;
        for (var l = 0; l < t.display.gutterSpecs.length; ++l) {
          var c = a.gutters.childNodes[l];
          if (c && c.getBoundingClientRect().right >= i) return yt(t, n, t, ne(t.doc, o), t.display.gutterSpecs[l].className, e), jt(e);
        }
      }
      function Sa(t, e) {
        return Ca(t, e, "gutterClick", !0);
      }
      function ka(t, e) {
        Tn(t.display, e) || function (t, e) {
          return !!Ot(t, "gutterContextMenu") && Ca(t, e, "gutterContextMenu", !1);
        }(t, e) || wt(t, e, "contextmenu") || S || t.display.input.onContextMenu(e);
      }
      function ja(t) {
        t.display.wrapper.className = t.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + t.options.theme.replace(/(^|\s)\s*/g, " cm-s-"), Un(t);
      }
      wa.prototype.compare = function (t, e, n) {
        return this.time + 400 > t && 0 == ae(e, this.pos) && n == this.button;
      };
      var Ta = {
          toString: function toString() {
            return "CodeMirror.Init";
          }
        },
        Pa = {},
        Ea = {};
      function Da(t, e, n) {
        if (!e != !(n && n != Ta)) {
          var r = t.display.dragFunctions,
            i = e ? vt : bt;
          i(t.display.scroller, "dragstart", r.start), i(t.display.scroller, "dragenter", r.enter), i(t.display.scroller, "dragover", r.over), i(t.display.scroller, "dragleave", r.leave), i(t.display.scroller, "drop", r.drop);
        }
      }
      function Ma(t) {
        t.options.lineWrapping ? (N(t.display.wrapper, "CodeMirror-wrap"), t.display.sizer.style.minWidth = "", t.display.sizerWidth = null) : (T(t.display.wrapper, "CodeMirror-wrap"), Xe(t)), fr(t), vr(t), Un(t), setTimeout(function () {
          return qr(t);
        }, 100);
      }
      function Aa(t, e) {
        var n = this;
        if (!(this instanceof Aa)) return new Aa(t, e);
        this.options = e = e ? $(e) : {}, $(Pa, e, !1);
        var r = e.value;
        "string" == typeof r ? r = new _Io(r, e.mode, null, e.lineSeparator, e.direction) : e.mode && (r.modeOption = e.mode), this.doc = r;
        var i = new Aa.inputStyles[e.inputStyle](this),
          o = this.display = new xi(t, r, i, e);
        for (var c in o.wrapper.CodeMirror = this, ja(this), e.lineWrapping && (this.display.wrapper.className += " CodeMirror-wrap"), Yr(this), this.state = {
          keyMaps: [],
          overlays: [],
          modeGen: 0,
          overwrite: !1,
          delayingBlurEvent: !1,
          focused: !1,
          suppressEdits: !1,
          pasteIncoming: -1,
          cutIncoming: -1,
          selectingText: !1,
          draggingText: !1,
          highlight: new W(),
          keySeq: null,
          specialChars: null
        }, e.autofocus && !b && o.input.focus(), a && s < 11 && setTimeout(function () {
          return n.display.input.reset(!0);
        }, 20), function (t) {
          var e = t.display;
          vt(e.scroller, "mousedown", oi(t, xa)), vt(e.scroller, "dblclick", a && s < 11 ? oi(t, function (e) {
            if (!wt(t, e)) {
              var n = pr(t, e);
              if (n && !Sa(t, e) && !Tn(t.display, e)) {
                St(e);
                var r = t.findWordAt(n);
                Qi(t.doc, r.anchor, r.head);
              }
            }
          }) : function (e) {
            return wt(t, e) || St(e);
          }), vt(e.scroller, "contextmenu", function (e) {
            return ka(t, e);
          }), vt(e.input.getField(), "contextmenu", function (n) {
            e.scroller.contains(n.target) || ka(t, n);
          });
          var n,
            r = {
              end: 0
            };
          function i() {
            e.activeTouch && (n = setTimeout(function () {
              return e.activeTouch = null;
            }, 1e3), (r = e.activeTouch).end = +new Date());
          }
          function o(t, e) {
            if (null == e.left) return !0;
            var n = e.left - t.left,
              r = e.top - t.top;
            return n * n + r * r > 400;
          }
          vt(e.scroller, "touchstart", function (i) {
            if (!wt(t, i) && !function (t) {
              if (1 != t.touches.length) return !1;
              var e = t.touches[0];
              return e.radiusX <= 1 && e.radiusY <= 1;
            }(i) && !Sa(t, i)) {
              e.input.ensurePolled(), clearTimeout(n);
              var o = +new Date();
              e.activeTouch = {
                start: o,
                moved: !1,
                prev: o - r.end <= 300 ? r : null
              }, 1 == i.touches.length && (e.activeTouch.left = i.touches[0].pageX, e.activeTouch.top = i.touches[0].pageY);
            }
          }), vt(e.scroller, "touchmove", function () {
            e.activeTouch && (e.activeTouch.moved = !0);
          }), vt(e.scroller, "touchend", function (n) {
            var r = e.activeTouch;
            if (r && !Tn(e, n) && null != r.left && !r.moved && new Date() - r.start < 300) {
              var a,
                s = t.coordsChar(e.activeTouch, "page");
              a = !r.prev || o(r, r.prev) ? new Pi(s, s) : !r.prev.prev || o(r, r.prev.prev) ? t.findWordAt(s) : new Pi(oe(s.line, 0), he(t.doc, oe(s.line + 1, 0))), t.setSelection(a.anchor, a.head), t.focus(), St(n);
            }
            i();
          }), vt(e.scroller, "touchcancel", i), vt(e.scroller, "scroll", function () {
            e.scroller.clientHeight && (zr(t, e.scroller.scrollTop), $r(t, e.scroller.scrollLeft, !0), yt(t, "scroll", t));
          }), vt(e.scroller, "mousewheel", function (e) {
            return ji(t, e);
          }), vt(e.scroller, "DOMMouseScroll", function (e) {
            return ji(t, e);
          }), vt(e.wrapper, "scroll", function () {
            return e.wrapper.scrollTop = e.wrapper.scrollLeft = 0;
          }), e.dragFunctions = {
            enter: function enter(e) {
              wt(t, e) || Tt(e);
            },
            over: function over(e) {
              wt(t, e) || (function (t, e) {
                var n = pr(t, e);
                if (n) {
                  var r = document.createDocumentFragment();
                  Cr(t, n, r), t.display.dragCursor || (t.display.dragCursor = D("div", null, "CodeMirror-cursors CodeMirror-dragcursors"), t.display.lineSpace.insertBefore(t.display.dragCursor, t.display.cursorDiv)), E(t.display.dragCursor, r);
                }
              }(t, e), Tt(e));
            },
            start: function start(e) {
              return function (t, e) {
                if (a && (!t.state.draggingText || +new Date() - Fo < 100)) Tt(e);else if (!wt(t, e) && !Tn(t.display, e) && (e.dataTransfer.setData("Text", t.getSelection()), e.dataTransfer.effectAllowed = "copyMove", e.dataTransfer.setDragImage && !f)) {
                  var n = D("img", null, null, "position: fixed; left: 0; top: 0;");
                  n.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", h && (n.width = n.height = 1, t.display.wrapper.appendChild(n), n._top = n.offsetTop), e.dataTransfer.setDragImage(n, 0, 0), h && n.parentNode.removeChild(n);
                }
              }(t, e);
            },
            drop: oi(t, Vo),
            leave: function leave(e) {
              wt(t, e) || Ro(t);
            }
          };
          var l = e.input.getField();
          vt(l, "keyup", function (e) {
            return va.call(t, e);
          }), vt(l, "keydown", oi(t, ga)), vt(l, "keypress", oi(t, ma)), vt(l, "focus", function (e) {
            return Er(t, e);
          }), vt(l, "blur", function (e) {
            return Dr(t, e);
          });
        }(this), $o(), Jr(this), this.curOp.forceUpdate = !0, zi(this, r), e.autofocus && !b || this.hasFocus() ? setTimeout(function () {
          n.hasFocus() && !n.state.focused && Er(n);
        }, 20) : Dr(this), Ea) Ea.hasOwnProperty(c) && Ea[c](this, e[c], Ta);
        mi(this), e.finishInit && e.finishInit(this);
        for (var u = 0; u < La.length; ++u) La[u](this);
        Zr(this), l && e.lineWrapping && "optimizelegibility" == getComputedStyle(o.lineDiv).textRendering && (o.lineDiv.style.textRendering = "auto");
      }
      Aa.defaults = Pa, Aa.optionHandlers = Ea;
      var La = [];
      function Na(t, e, n, r) {
        var i,
          o = t.doc;
        null == n && (n = "add"), "smart" == n && (o.mode.indent ? i = be(t, e).state : n = "prev");
        var a = t.options.tabSize,
          s = Jt(o, e),
          l = B(s.text, null, a);
        s.stateAfter && (s.stateAfter = null);
        var c,
          u = s.text.match(/^\s*/)[0];
        if (r || /\S/.test(s.text)) {
          if ("smart" == n && ((c = o.mode.indent(i, s.text.slice(u.length), s.text)) == q || c > 150)) {
            if (!r) return;
            n = "prev";
          }
        } else c = 0, n = "not";
        "prev" == n ? c = e > o.first ? B(Jt(o, e - 1).text, null, a) : 0 : "add" == n ? c = l + t.options.indentUnit : "subtract" == n ? c = l - t.options.indentUnit : "number" == typeof n && (c = l + n), c = Math.max(0, c);
        var d = "",
          h = 0;
        if (t.options.indentWithTabs) for (var f = Math.floor(c / a); f; --f) h += a, d += "\t";
        if (h < c && (d += Z(c - h)), d != u) return wo(o, d, oe(e, 0), oe(e, u.length), "+input"), s.stateAfter = null, !0;
        for (var p = 0; p < o.sel.ranges.length; p++) {
          var g = o.sel.ranges[p];
          if (g.head.line == e && g.head.ch < u.length) {
            var v = oe(e, u.length);
            eo(o, p, new Pi(v, v));
            break;
          }
        }
      }
      Aa.defineInitHook = function (t) {
        return La.push(t);
      };
      var _a = null;
      function Ia(t) {
        _a = t;
      }
      function Fa(t, e, n, r, i) {
        var o = t.doc;
        t.display.shift = !1, r || (r = o.sel);
        var a = +new Date() - 200,
          s = "paste" == i || t.state.pasteIncoming > a,
          l = It(e),
          c = null;
        if (s && r.ranges.length > 1) if (_a && _a.text.join("\n") == e) {
          if (r.ranges.length % _a.text.length == 0) {
            c = [];
            for (var u = 0; u < _a.text.length; u++) c.push(o.splitLines(_a.text[u]));
          }
        } else l.length == r.ranges.length && t.options.pasteLinesPerSelection && (c = tt(l, function (t) {
          return [t];
        }));
        for (var d = t.curOp.updateInput, h = r.ranges.length - 1; h >= 0; h--) {
          var f = r.ranges[h],
            p = f.from(),
            g = f.to();
          f.empty() && (n && n > 0 ? p = oe(p.line, p.ch - n) : t.state.overwrite && !s ? g = oe(g.line, Math.min(Jt(o, g.line).text.length, g.ch + Q(l).length)) : s && _a && _a.lineWise && _a.text.join("\n") == l.join("\n") && (p = g = oe(p.line, 0)));
          var v = {
            from: p,
            to: g,
            text: c ? c[h % c.length] : l,
            origin: i || (s ? "paste" : t.state.cutIncoming > a ? "cut" : "+input")
          };
          go(t.doc, v), fn(t, "inputRead", t, v);
        }
        e && !s && Ra(t, e), Ir(t), t.curOp.updateInput < 2 && (t.curOp.updateInput = d), t.curOp.typing = !0, t.state.pasteIncoming = t.state.cutIncoming = -1;
      }
      function Va(t, e) {
        var n = t.clipboardData && t.clipboardData.getData("Text");
        if (n) return t.preventDefault(), e.isReadOnly() || e.options.disableInput || !e.hasFocus() || ii(e, function () {
          return Fa(e, n, 0, null, "paste");
        }), !0;
      }
      function Ra(t, e) {
        if (t.options.electricChars && t.options.smartIndent) for (var n = t.doc.sel, r = n.ranges.length - 1; r >= 0; r--) {
          var i = n.ranges[r];
          if (!(i.head.ch > 100 || r && n.ranges[r - 1].head.line == i.head.line)) {
            var o = t.getModeAt(i.head),
              a = !1;
            if (o.electricChars) {
              for (var s = 0; s < o.electricChars.length; s++) if (e.indexOf(o.electricChars.charAt(s)) > -1) {
                a = Na(t, i.head.line, "smart");
                break;
              }
            } else o.electricInput && o.electricInput.test(Jt(t.doc, i.head.line).text.slice(0, i.head.ch)) && (a = Na(t, i.head.line, "smart"));
            a && fn(t, "electricInput", t, i.head.line);
          }
        }
      }
      function za(t) {
        for (var e = [], n = [], r = 0; r < t.doc.sel.ranges.length; r++) {
          var i = t.doc.sel.ranges[r].head.line,
            o = {
              anchor: oe(i, 0),
              head: oe(i + 1, 0)
            };
          n.push(o), e.push(t.getRange(o.anchor, o.head));
        }
        return {
          text: e,
          ranges: n
        };
      }
      function Ha(t, e, n, r) {
        t.setAttribute("autocorrect", n ? "on" : "off"), t.setAttribute("autocapitalize", r ? "on" : "off"), t.setAttribute("spellcheck", !!e);
      }
      function $a() {
        var t = D("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none"),
          e = D("div", [t], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
        return l ? t.style.width = "1000px" : t.setAttribute("wrap", "off"), v && (t.style.border = "1px solid black"), e;
      }
      function Ba(t, e, n, r, i) {
        var o = e,
          a = n,
          s = Jt(t, e.line),
          l = i && "rtl" == t.direction ? -n : n;
        function c(o) {
          var a, c;
          if ("codepoint" == r) {
            var u = s.text.charCodeAt(e.ch + (n > 0 ? 0 : -1));
            if (isNaN(u)) a = null;else {
              var d = n > 0 ? u >= 55296 && u < 56320 : u >= 56320 && u < 57343;
              a = new oe(e.line, Math.max(0, Math.min(s.text.length, e.ch + n * (d ? 2 : 1))), -n);
            }
          } else a = i ? function (t, e, n, r) {
            var i = pt(e, t.doc.direction);
            if (!i) return ia(e, n, r);
            n.ch >= e.text.length ? (n.ch = e.text.length, n.sticky = "before") : n.ch <= 0 && (n.ch = 0, n.sticky = "after");
            var o = ht(i, n.ch, n.sticky),
              a = i[o];
            if ("ltr" == t.doc.direction && a.level % 2 == 0 && (r > 0 ? a.to > n.ch : a.from < n.ch)) return ia(e, n, r);
            var s,
              l = function l(t, n) {
                return ra(e, t instanceof oe ? t.ch : t, n);
              },
              c = function c(n) {
                return t.options.lineWrapping ? (s = s || Fn(t, e), rr(t, e, s, n)) : {
                  begin: 0,
                  end: e.text.length
                };
              },
              u = c("before" == n.sticky ? l(n, -1) : n.ch);
            if ("rtl" == t.doc.direction || 1 == a.level) {
              var d = 1 == a.level == r < 0,
                h = l(n, d ? 1 : -1);
              if (null != h && (d ? h <= a.to && h <= u.end : h >= a.from && h >= u.begin)) {
                var f = d ? "before" : "after";
                return new oe(n.line, h, f);
              }
            }
            var p = function p(t, e, r) {
                for (var o = function o(t, e) {
                  return e ? new oe(n.line, l(t, 1), "before") : new oe(n.line, t, "after");
                }; t >= 0 && t < i.length; t += e) {
                  var a = i[t],
                    s = e > 0 == (1 != a.level),
                    c = s ? r.begin : l(r.end, -1);
                  if (a.from <= c && c < a.to) return o(c, s);
                  if (c = s ? a.from : l(a.to, -1), r.begin <= c && c < r.end) return o(c, s);
                }
              },
              g = p(o + r, r, u);
            if (g) return g;
            var v = r > 0 ? u.end : l(u.begin, -1);
            return null == v || r > 0 && v == e.text.length || !(g = p(r > 0 ? 0 : i.length - 1, r, c(v))) ? null : g;
          }(t.cm, s, e, n) : ia(s, e, n);
          if (null == a) {
            if (o || (c = e.line + l) < t.first || c >= t.first + t.size || (e = new oe(c, e.ch, e.sticky), !(s = Jt(t, c)))) return !1;
            e = oa(i, t.cm, s, e.line, l);
          } else e = a;
          return !0;
        }
        if ("char" == r || "codepoint" == r) c();else if ("column" == r) c(!0);else if ("word" == r || "group" == r) for (var u = null, d = "group" == r, h = t.cm && t.cm.getHelper(e, "wordChars"), f = !0; !(n < 0) || c(!f); f = !1) {
          var p = s.text.charAt(e.ch) || "\n",
            g = ot(p, h) ? "w" : d && "\n" == p ? "n" : !d || /\s/.test(p) ? null : "p";
          if (!d || f || g || (g = "s"), u && u != g) {
            n < 0 && (n = 1, c(), e.sticky = "after");
            break;
          }
          if (g && (u = g), n > 0 && !c(!f)) break;
        }
        var v = uo(t, e, o, a, !0);
        return se(o, v) && (v.hitSide = !0), v;
      }
      function Wa(t, e, n, r) {
        var i,
          o,
          a = t.doc,
          s = e.left;
        if ("page" == r) {
          var l = Math.min(t.display.wrapper.clientHeight, z(t).innerHeight || a(t).documentElement.clientHeight),
            c = Math.max(l - .5 * lr(t.display), 3);
          i = (n > 0 ? e.bottom : e.top) + n * c;
        } else "line" == r && (i = n > 0 ? e.bottom + 3 : e.top - 3);
        for (; (o = er(t, s, i)).outside;) {
          if (n < 0 ? i <= 0 : i >= a.height) {
            o.hitSide = !0;
            break;
          }
          i += 5 * n;
        }
        return o;
      }
      var Ua = function Ua(t) {
        this.cm = t, this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null, this.polling = new W(), this.composing = null, this.gracePeriod = !1, this.readDOMTimeout = null;
      };
      function qa(t, e) {
        var n = In(t, e.line);
        if (!n || n.hidden) return null;
        var r = Jt(t.doc, e.line),
          i = Nn(n, r, e.line),
          o = pt(r, t.doc.direction),
          a = "left";
        o && (a = ht(o, e.ch) % 2 ? "right" : "left");
        var s = Hn(i.map, e.ch, a);
        return s.offset = "right" == s.collapse ? s.end : s.start, s;
      }
      function Ga(t, e) {
        return e && (t.bad = !0), t;
      }
      function Ka(t, e, n) {
        var r;
        if (e == t.display.lineDiv) {
          if (!(r = t.display.lineDiv.childNodes[n])) return Ga(t.clipPos(oe(t.display.viewTo - 1)), !0);
          e = null, n = 0;
        } else for (r = e;; r = r.parentNode) {
          if (!r || r == t.display.lineDiv) return null;
          if (r.parentNode && r.parentNode == t.display.lineDiv) break;
        }
        for (var i = 0; i < t.display.view.length; i++) {
          var o = t.display.view[i];
          if (o.node == r) return Ya(o, e, n);
        }
      }
      function Ya(t, e, n) {
        var r = t.text.firstChild,
          i = !1;
        if (!e || !A(r, e)) return Ga(oe(ee(t.line), 0), !0);
        if (e == r && (i = !0, e = r.childNodes[n], n = 0, !e)) {
          var o = t.rest ? Q(t.rest) : t.line;
          return Ga(oe(ee(o), o.text.length), i);
        }
        var a = 3 == e.nodeType ? e : null,
          s = e;
        for (a || 1 != e.childNodes.length || 3 != e.firstChild.nodeType || (a = e.firstChild, n && (n = a.nodeValue.length)); s.parentNode != r;) s = s.parentNode;
        var l = t.measure,
          c = l.maps;
        function u(e, n, r) {
          for (var i = -1; i < (c ? c.length : 0); i++) for (var o = i < 0 ? l.map : c[i], a = 0; a < o.length; a += 3) {
            var s = o[a + 2];
            if (s == e || s == n) {
              var u = ee(i < 0 ? t.line : t.rest[i]),
                d = o[a] + r;
              return (r < 0 || s != e) && (d = o[a + (r ? 1 : 0)]), oe(u, d);
            }
          }
        }
        var d = u(a, s, n);
        if (d) return Ga(d, i);
        for (var h = s.nextSibling, f = a ? a.nodeValue.length - n : 0; h; h = h.nextSibling) {
          if (d = u(h, h.firstChild, 0)) return Ga(oe(d.line, d.ch - f), i);
          f += h.textContent.length;
        }
        for (var p = s.previousSibling, g = n; p; p = p.previousSibling) {
          if (d = u(p, p.firstChild, -1)) return Ga(oe(d.line, d.ch + g), i);
          g += p.textContent.length;
        }
      }
      Ua.prototype.init = function (t) {
        var e = this,
          n = this,
          r = n.cm,
          i = n.div = t.lineDiv;
        function o(t) {
          for (var e = t.target; e; e = e.parentNode) {
            if (e == i) return !0;
            if (/\bCodeMirror-(?:line)?widget\b/.test(e.className)) break;
          }
          return !1;
        }
        function a(t) {
          if (o(t) && !wt(r, t)) {
            if (r.somethingSelected()) Ia({
              lineWise: !1,
              text: r.getSelections()
            }), "cut" == t.type && r.replaceSelection("", null, "cut");else {
              if (!r.options.lineWiseCopyCut) return;
              var e = za(r);
              Ia({
                lineWise: !0,
                text: e.text
              }), "cut" == t.type && r.operation(function () {
                r.setSelections(e.ranges, 0, G), r.replaceSelection("", null, "cut");
              });
            }
            if (t.clipboardData) {
              t.clipboardData.clearData();
              var a = _a.text.join("\n");
              if (t.clipboardData.setData("Text", a), t.clipboardData.getData("Text") == a) return void t.preventDefault();
            }
            var s = $a(),
              l = s.firstChild;
            Ha(l), r.display.lineSpace.insertBefore(s, r.display.lineSpace.firstChild), l.value = _a.text.join("\n");
            var c = L(R(i));
            I(l), setTimeout(function () {
              r.display.lineSpace.removeChild(s), c.focus(), c == i && n.showPrimarySelection();
            }, 50);
          }
        }
        i.contentEditable = !0, Ha(i, r.options.spellcheck, r.options.autocorrect, r.options.autocapitalize), vt(i, "paste", function (t) {
          !o(t) || wt(r, t) || Va(t, r) || s <= 11 && setTimeout(oi(r, function () {
            return e.updateFromDOM();
          }), 20);
        }), vt(i, "compositionstart", function (t) {
          e.composing = {
            data: t.data,
            done: !1
          };
        }), vt(i, "compositionupdate", function (t) {
          e.composing || (e.composing = {
            data: t.data,
            done: !1
          });
        }), vt(i, "compositionend", function (t) {
          e.composing && (t.data != e.composing.data && e.readFromDOMSoon(), e.composing.done = !0);
        }), vt(i, "touchstart", function () {
          return n.forceCompositionEnd();
        }), vt(i, "input", function () {
          e.composing || e.readFromDOMSoon();
        }), vt(i, "copy", a), vt(i, "cut", a);
      }, Ua.prototype.screenReaderLabelChanged = function (t) {
        t ? this.div.setAttribute("aria-label", t) : this.div.removeAttribute("aria-label");
      }, Ua.prototype.prepareSelection = function () {
        var t = Or(this.cm, !1);
        return t.focus = L(R(this.div)) == this.div, t;
      }, Ua.prototype.showSelection = function (t, e) {
        t && this.cm.display.view.length && ((t.focus || e) && this.showPrimarySelection(), this.showMultipleSelections(t));
      }, Ua.prototype.getSelection = function () {
        return this.cm.display.wrapper.ownerDocument.getSelection();
      }, Ua.prototype.showPrimarySelection = function () {
        var t = this.getSelection(),
          e = this.cm,
          r = e.doc.sel.primary(),
          i = r.from(),
          o = r.to();
        if (e.display.viewTo == e.display.viewFrom || i.line >= e.display.viewTo || o.line < e.display.viewFrom) t.removeAllRanges();else {
          var a = Ka(e, t.anchorNode, t.anchorOffset),
            s = Ka(e, t.focusNode, t.focusOffset);
          if (!a || a.bad || !s || s.bad || 0 != ae(ue(a, s), i) || 0 != ae(ce(a, s), o)) {
            var l = e.display.view,
              c = i.line >= e.display.viewFrom && qa(e, i) || {
                node: l[0].measure.map[2],
                offset: 0
              },
              u = o.line < e.display.viewTo && qa(e, o);
            if (!u) {
              var d = l[l.length - 1].measure,
                h = d.maps ? d.maps[d.maps.length - 1] : d.map;
              u = {
                node: h[h.length - 1],
                offset: h[h.length - 2] - h[h.length - 3]
              };
            }
            if (c && u) {
              var f,
                p = t.rangeCount && t.getRangeAt(0);
              try {
                f = j(c.node, c.offset, u.offset, u.node);
              } catch (t) {}
              f && (!n && e.state.focused ? (t.collapse(c.node, c.offset), f.collapsed || (t.removeAllRanges(), t.addRange(f))) : (t.removeAllRanges(), t.addRange(f)), p && null == t.anchorNode ? t.addRange(p) : n && this.startGracePeriod()), this.rememberSelection();
            } else t.removeAllRanges();
          }
        }
      }, Ua.prototype.startGracePeriod = function () {
        var t = this;
        clearTimeout(this.gracePeriod), this.gracePeriod = setTimeout(function () {
          t.gracePeriod = !1, t.selectionChanged() && t.cm.operation(function () {
            return t.cm.curOp.selectionChanged = !0;
          });
        }, 20);
      }, Ua.prototype.showMultipleSelections = function (t) {
        E(this.cm.display.cursorDiv, t.cursors), E(this.cm.display.selectionDiv, t.selection);
      }, Ua.prototype.rememberSelection = function () {
        var t = this.getSelection();
        this.lastAnchorNode = t.anchorNode, this.lastAnchorOffset = t.anchorOffset, this.lastFocusNode = t.focusNode, this.lastFocusOffset = t.focusOffset;
      }, Ua.prototype.selectionInEditor = function () {
        var t = this.getSelection();
        if (!t.rangeCount) return !1;
        var e = t.getRangeAt(0).commonAncestorContainer;
        return A(this.div, e);
      }, Ua.prototype.focus = function () {
        "nocursor" != this.cm.options.readOnly && (this.selectionInEditor() && L(R(this.div)) == this.div || this.showSelection(this.prepareSelection(), !0), this.div.focus());
      }, Ua.prototype.blur = function () {
        this.div.blur();
      }, Ua.prototype.getField = function () {
        return this.div;
      }, Ua.prototype.supportsTouch = function () {
        return !0;
      }, Ua.prototype.receivedFocus = function () {
        var t = this,
          e = this;
        this.selectionInEditor() ? setTimeout(function () {
          return t.pollSelection();
        }, 20) : ii(this.cm, function () {
          return e.cm.curOp.selectionChanged = !0;
        }), this.polling.set(this.cm.options.pollInterval, function t() {
          e.cm.state.focused && (e.pollSelection(), e.polling.set(e.cm.options.pollInterval, t));
        });
      }, Ua.prototype.selectionChanged = function () {
        var t = this.getSelection();
        return t.anchorNode != this.lastAnchorNode || t.anchorOffset != this.lastAnchorOffset || t.focusNode != this.lastFocusNode || t.focusOffset != this.lastFocusOffset;
      }, Ua.prototype.pollSelection = function () {
        if (null == this.readDOMTimeout && !this.gracePeriod && this.selectionChanged()) {
          var t = this.getSelection(),
            e = this.cm;
          if (m && u && this.cm.display.gutterSpecs.length && function (t) {
            for (var e = t; e; e = e.parentNode) if (/CodeMirror-gutter-wrapper/.test(e.className)) return !0;
            return !1;
          }(t.anchorNode)) return this.cm.triggerOnKeyDown({
            type: "keydown",
            keyCode: 8,
            preventDefault: Math.abs
          }), this.blur(), void this.focus();
          if (!this.composing) {
            this.rememberSelection();
            var n = Ka(e, t.anchorNode, t.anchorOffset),
              r = Ka(e, t.focusNode, t.focusOffset);
            n && r && ii(e, function () {
              io(e.doc, Di(n, r), G), (n.bad || r.bad) && (e.curOp.selectionChanged = !0);
            });
          }
        }
      }, Ua.prototype.pollContent = function () {
        null != this.readDOMTimeout && (clearTimeout(this.readDOMTimeout), this.readDOMTimeout = null);
        var t,
          e,
          n,
          r = this.cm,
          i = r.display,
          o = r.doc.sel.primary(),
          a = o.from(),
          s = o.to();
        if (0 == a.ch && a.line > r.firstLine() && (a = oe(a.line - 1, Jt(r.doc, a.line - 1).length)), s.ch == Jt(r.doc, s.line).text.length && s.line < r.lastLine() && (s = oe(s.line + 1, 0)), a.line < i.viewFrom || s.line > i.viewTo - 1) return !1;
        a.line == i.viewFrom || 0 == (t = gr(r, a.line)) ? (e = ee(i.view[0].line), n = i.view[0].node) : (e = ee(i.view[t].line), n = i.view[t - 1].node.nextSibling);
        var l,
          c,
          u = gr(r, s.line);
        if (u == i.view.length - 1 ? (l = i.viewTo - 1, c = i.lineDiv.lastChild) : (l = ee(i.view[u + 1].line) - 1, c = i.view[u + 1].node.previousSibling), !n) return !1;
        for (var d = r.doc.splitLines(function (t, e, n, r, i) {
            var o = "",
              a = !1,
              s = t.doc.lineSeparator(),
              l = !1;
            function c() {
              a && (o += s, l && (o += s), a = l = !1);
            }
            function u(t) {
              t && (c(), o += t);
            }
            function d(e) {
              if (1 == e.nodeType) {
                var n = e.getAttribute("cm-text");
                if (n) return void u(n);
                var o,
                  h = e.getAttribute("cm-marker");
                if (h) {
                  var f = t.findMarks(oe(r, 0), oe(i + 1, 0), (v = +h, function (t) {
                    return t.id == v;
                  }));
                  return void (f.length && (o = f[0].find(0)) && u(Zt(t.doc, o.from, o.to).join(s)));
                }
                if ("false" == e.getAttribute("contenteditable")) return;
                var p = /^(pre|div|p|li|table|br)$/i.test(e.nodeName);
                if (!/^br$/i.test(e.nodeName) && 0 == e.textContent.length) return;
                p && c();
                for (var g = 0; g < e.childNodes.length; g++) d(e.childNodes[g]);
                /^(pre|p)$/i.test(e.nodeName) && (l = !0), p && (a = !0);
              } else 3 == e.nodeType && u(e.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
              var v;
            }
            for (; d(e), e != n;) e = e.nextSibling, l = !1;
            return o;
          }(r, n, c, e, l)), h = Zt(r.doc, oe(e, 0), oe(l, Jt(r.doc, l).text.length)); d.length > 1 && h.length > 1;) if (Q(d) == Q(h)) d.pop(), h.pop(), l--;else {
          if (d[0] != h[0]) break;
          d.shift(), h.shift(), e++;
        }
        for (var f = 0, p = 0, g = d[0], v = h[0], m = Math.min(g.length, v.length); f < m && g.charCodeAt(f) == v.charCodeAt(f);) ++f;
        for (var b = Q(d), y = Q(h), w = Math.min(b.length - (1 == d.length ? f : 0), y.length - (1 == h.length ? f : 0)); p < w && b.charCodeAt(b.length - p - 1) == y.charCodeAt(y.length - p - 1);) ++p;
        if (1 == d.length && 1 == h.length && e == a.line) for (; f && f > a.ch && b.charCodeAt(b.length - p - 1) == y.charCodeAt(y.length - p - 1);) f--, p++;
        d[d.length - 1] = b.slice(0, b.length - p).replace(/^\u200b+/, ""), d[0] = d[0].slice(f).replace(/\u200b+$/, "");
        var x = oe(e, f),
          O = oe(l, h.length ? Q(h).length - p : 0);
        return d.length > 1 || d[0] || ae(x, O) ? (wo(r.doc, d, x, O, "+input"), !0) : void 0;
      }, Ua.prototype.ensurePolled = function () {
        this.forceCompositionEnd();
      }, Ua.prototype.reset = function () {
        this.forceCompositionEnd();
      }, Ua.prototype.forceCompositionEnd = function () {
        this.composing && (clearTimeout(this.readDOMTimeout), this.composing = null, this.updateFromDOM(), this.div.blur(), this.div.focus());
      }, Ua.prototype.readFromDOMSoon = function () {
        var t = this;
        null == this.readDOMTimeout && (this.readDOMTimeout = setTimeout(function () {
          if (t.readDOMTimeout = null, t.composing) {
            if (!t.composing.done) return;
            t.composing = null;
          }
          t.updateFromDOM();
        }, 80));
      }, Ua.prototype.updateFromDOM = function () {
        var t = this;
        !this.cm.isReadOnly() && this.pollContent() || ii(this.cm, function () {
          return vr(t.cm);
        });
      }, Ua.prototype.setUneditable = function (t) {
        t.contentEditable = "false";
      }, Ua.prototype.onKeyPress = function (t) {
        0 == t.charCode || this.composing || (t.preventDefault(), this.cm.isReadOnly() || oi(this.cm, Fa)(this.cm, String.fromCharCode(null == t.charCode ? t.keyCode : t.charCode), 0));
      }, Ua.prototype.readOnlyChanged = function (t) {
        this.div.contentEditable = String("nocursor" != t);
      }, Ua.prototype.onContextMenu = function () {}, Ua.prototype.resetPosition = function () {}, Ua.prototype.needsContentAttribute = !0;
      var Xa = function Xa(t) {
        this.cm = t, this.prevInput = "", this.pollingFast = !1, this.polling = new W(), this.hasSelection = !1, this.composing = null, this.resetting = !1;
      };
      Xa.prototype.init = function (t) {
        var e = this,
          n = this,
          r = this.cm;
        this.createField(t);
        var i = this.textarea;
        function o(t) {
          if (!wt(r, t)) {
            if (r.somethingSelected()) Ia({
              lineWise: !1,
              text: r.getSelections()
            });else {
              if (!r.options.lineWiseCopyCut) return;
              var e = za(r);
              Ia({
                lineWise: !0,
                text: e.text
              }), "cut" == t.type ? r.setSelections(e.ranges, null, G) : (n.prevInput = "", i.value = e.text.join("\n"), I(i));
            }
            "cut" == t.type && (r.state.cutIncoming = +new Date());
          }
        }
        t.wrapper.insertBefore(this.wrapper, t.wrapper.firstChild), v && (i.style.width = "0px"), vt(i, "input", function () {
          a && s >= 9 && e.hasSelection && (e.hasSelection = null), n.poll();
        }), vt(i, "paste", function (t) {
          wt(r, t) || Va(t, r) || (r.state.pasteIncoming = +new Date(), n.fastPoll());
        }), vt(i, "cut", o), vt(i, "copy", o), vt(t.scroller, "paste", function (e) {
          if (!Tn(t, e) && !wt(r, e)) {
            if (!i.dispatchEvent) return r.state.pasteIncoming = +new Date(), void n.focus();
            var o = new Event("paste");
            o.clipboardData = e.clipboardData, i.dispatchEvent(o);
          }
        }), vt(t.lineSpace, "selectstart", function (e) {
          Tn(t, e) || St(e);
        }), vt(i, "compositionstart", function () {
          var t = r.getCursor("from");
          n.composing && n.composing.range.clear(), n.composing = {
            start: t,
            range: r.markText(t, r.getCursor("to"), {
              className: "CodeMirror-composing"
            })
          };
        }), vt(i, "compositionend", function () {
          n.composing && (n.poll(), n.composing.range.clear(), n.composing = null);
        });
      }, Xa.prototype.createField = function (t) {
        this.wrapper = $a(), this.textarea = this.wrapper.firstChild;
        var e = this.cm.options;
        Ha(this.textarea, e.spellcheck, e.autocorrect, e.autocapitalize);
      }, Xa.prototype.screenReaderLabelChanged = function (t) {
        t ? this.textarea.setAttribute("aria-label", t) : this.textarea.removeAttribute("aria-label");
      }, Xa.prototype.prepareSelection = function () {
        var t = this.cm,
          e = t.display,
          n = t.doc,
          r = Or(t);
        if (t.options.moveInputWithCursor) {
          var i = Zn(t, n.sel.primary().head, "div"),
            o = e.wrapper.getBoundingClientRect(),
            a = e.lineDiv.getBoundingClientRect();
          r.teTop = Math.max(0, Math.min(e.wrapper.clientHeight - 10, i.top + a.top - o.top)), r.teLeft = Math.max(0, Math.min(e.wrapper.clientWidth - 10, i.left + a.left - o.left));
        }
        return r;
      }, Xa.prototype.showSelection = function (t) {
        var e = this.cm.display;
        E(e.cursorDiv, t.cursors), E(e.selectionDiv, t.selection), null != t.teTop && (this.wrapper.style.top = t.teTop + "px", this.wrapper.style.left = t.teLeft + "px");
      }, Xa.prototype.reset = function (t) {
        if (!(this.contextMenuPending || this.composing && t)) {
          var e = this.cm;
          if (this.resetting = !0, e.somethingSelected()) {
            this.prevInput = "";
            var n = e.getSelection();
            this.textarea.value = n, e.state.focused && I(this.textarea), a && s >= 9 && (this.hasSelection = n);
          } else t || (this.prevInput = this.textarea.value = "", a && s >= 9 && (this.hasSelection = null));
          this.resetting = !1;
        }
      }, Xa.prototype.getField = function () {
        return this.textarea;
      }, Xa.prototype.supportsTouch = function () {
        return !1;
      }, Xa.prototype.focus = function () {
        if ("nocursor" != this.cm.options.readOnly && (!b || L(R(this.textarea)) != this.textarea)) try {
          this.textarea.focus();
        } catch (t) {}
      }, Xa.prototype.blur = function () {
        this.textarea.blur();
      }, Xa.prototype.resetPosition = function () {
        this.wrapper.style.top = this.wrapper.style.left = 0;
      }, Xa.prototype.receivedFocus = function () {
        this.slowPoll();
      }, Xa.prototype.slowPoll = function () {
        var t = this;
        this.pollingFast || this.polling.set(this.cm.options.pollInterval, function () {
          t.poll(), t.cm.state.focused && t.slowPoll();
        });
      }, Xa.prototype.fastPoll = function () {
        var t = !1,
          e = this;
        e.pollingFast = !0, e.polling.set(20, function n() {
          e.poll() || t ? (e.pollingFast = !1, e.slowPoll()) : (t = !0, e.polling.set(60, n));
        });
      }, Xa.prototype.poll = function () {
        var t = this,
          e = this.cm,
          n = this.textarea,
          r = this.prevInput;
        if (this.contextMenuPending || this.resetting || !e.state.focused || Ft(n) && !r && !this.composing || e.isReadOnly() || e.options.disableInput || e.state.keySeq) return !1;
        var i = n.value;
        if (i == r && !e.somethingSelected()) return !1;
        if (a && s >= 9 && this.hasSelection === i || y && /[\uf700-\uf7ff]/.test(i)) return e.display.input.reset(), !1;
        if (e.doc.sel == e.display.selForContextMenu) {
          var o = i.charCodeAt(0);
          if (8203 != o || r || (r = "​"), 8666 == o) return this.reset(), this.cm.execCommand("undo");
        }
        for (var l = 0, c = Math.min(r.length, i.length); l < c && r.charCodeAt(l) == i.charCodeAt(l);) ++l;
        return ii(e, function () {
          Fa(e, i.slice(l), r.length - l, null, t.composing ? "*compose" : null), i.length > 1e3 || i.indexOf("\n") > -1 ? n.value = t.prevInput = "" : t.prevInput = i, t.composing && (t.composing.range.clear(), t.composing.range = e.markText(t.composing.start, e.getCursor("to"), {
            className: "CodeMirror-composing"
          }));
        }), !0;
      }, Xa.prototype.ensurePolled = function () {
        this.pollingFast && this.poll() && (this.pollingFast = !1);
      }, Xa.prototype.onKeyPress = function () {
        a && s >= 9 && (this.hasSelection = null), this.fastPoll();
      }, Xa.prototype.onContextMenu = function (t) {
        var e = this,
          n = e.cm,
          r = n.display,
          i = e.textarea;
        e.contextMenuPending && e.contextMenuPending();
        var o = pr(n, t),
          c = r.scroller.scrollTop;
        if (o && !h) {
          n.options.resetSelectionOnContextMenu && -1 == n.doc.sel.contains(o) && oi(n, io)(n.doc, Di(o), G);
          var u,
            d = i.style.cssText,
            f = e.wrapper.style.cssText,
            p = e.wrapper.offsetParent.getBoundingClientRect();
          if (e.wrapper.style.cssText = "position: static", i.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (t.clientY - p.top - 5) + "px; left: " + (t.clientX - p.left - 5) + "px;\n      z-index: 1000; background: " + (a ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);", l && (u = i.ownerDocument.defaultView.scrollY), r.input.focus(), l && i.ownerDocument.defaultView.scrollTo(null, u), r.input.reset(), n.somethingSelected() || (i.value = e.prevInput = " "), e.contextMenuPending = m, r.selForContextMenu = n.doc.sel, clearTimeout(r.detectingSelectAll), a && s >= 9 && v(), S) {
            Tt(t);
            var _g = function g() {
              bt(window, "mouseup", _g), setTimeout(m, 20);
            };
            vt(window, "mouseup", _g);
          } else setTimeout(m, 50);
        }
        function v() {
          if (null != i.selectionStart) {
            var t = n.somethingSelected(),
              o = "​" + (t ? i.value : "");
            i.value = "⇚", i.value = o, e.prevInput = t ? "" : "​", i.selectionStart = 1, i.selectionEnd = o.length, r.selForContextMenu = n.doc.sel;
          }
        }
        function m() {
          if (e.contextMenuPending == m && (e.contextMenuPending = !1, e.wrapper.style.cssText = f, i.style.cssText = d, a && s < 9 && r.scrollbars.setScrollTop(r.scroller.scrollTop = c), null != i.selectionStart)) {
            (!a || a && s < 9) && v();
            var t = 0,
              _o2 = function o() {
                r.selForContextMenu == n.doc.sel && 0 == i.selectionStart && i.selectionEnd > 0 && "​" == e.prevInput ? oi(n, fo)(n) : t++ < 10 ? r.detectingSelectAll = setTimeout(_o2, 500) : (r.selForContextMenu = null, r.input.reset());
              };
            r.detectingSelectAll = setTimeout(_o2, 200);
          }
        }
      }, Xa.prototype.readOnlyChanged = function (t) {
        t || this.reset(), this.textarea.disabled = "nocursor" == t, this.textarea.readOnly = !!t;
      }, Xa.prototype.setUneditable = function () {}, Xa.prototype.needsContentAttribute = !1, function (t) {
        var e = t.optionHandlers;
        function n(n, r, i, o) {
          t.defaults[n] = r, i && (e[n] = o ? function (t, e, n) {
            n != Ta && i(t, e, n);
          } : i);
        }
        t.defineOption = n, t.Init = Ta, n("value", "", function (t, e) {
          return t.setValue(e);
        }, !0), n("mode", null, function (t, e) {
          t.doc.modeOption = e, _i(t);
        }, !0), n("indentUnit", 2, _i, !0), n("indentWithTabs", !1), n("smartIndent", !0), n("tabSize", 4, function (t) {
          Ii(t), Un(t), vr(t);
        }, !0), n("lineSeparator", null, function (t, e) {
          if (t.doc.lineSep = e, e) {
            var n = [],
              r = t.doc.first;
            t.doc.iter(function (t) {
              for (var i = 0;;) {
                var o = t.text.indexOf(e, i);
                if (-1 == o) break;
                i = o + e.length, n.push(oe(r, o));
              }
              r++;
            });
            for (var i = n.length - 1; i >= 0; i--) wo(t.doc, e, n[i], oe(n[i].line, n[i].ch + e.length));
          }
        }), n("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function (t, e, n) {
          t.state.specialChars = new RegExp(e.source + (e.test("\t") ? "" : "|\t"), "g"), n != Ta && t.refresh();
        }), n("specialCharPlaceholder", rn, function (t) {
          return t.refresh();
        }, !0), n("electricChars", !0), n("inputStyle", b ? "contenteditable" : "textarea", function () {
          throw new Error("inputStyle can not (yet) be changed in a running editor");
        }, !0), n("spellcheck", !1, function (t, e) {
          return t.getInputField().spellcheck = e;
        }, !0), n("autocorrect", !1, function (t, e) {
          return t.getInputField().autocorrect = e;
        }, !0), n("autocapitalize", !1, function (t, e) {
          return t.getInputField().autocapitalize = e;
        }, !0), n("rtlMoveVisually", !x), n("wholeLineUpdateBefore", !0), n("theme", "default", function (t) {
          ja(t), wi(t);
        }, !0), n("keyMap", "default", function (t, e, n) {
          var r = ea(e),
            i = n != Ta && ea(n);
          i && i.detach && i.detach(t, r), r.attach && r.attach(t, i || null);
        }), n("extraKeys", null), n("configureMouse", null), n("lineWrapping", !1, Ma, !0), n("gutters", [], function (t, e) {
          t.display.gutterSpecs = bi(e, t.options.lineNumbers), wi(t);
        }, !0), n("fixedGutter", !0, function (t, e) {
          t.display.gutters.style.left = e ? dr(t.display) + "px" : "0", t.refresh();
        }, !0), n("coverGutterNextToScrollbar", !1, function (t) {
          return qr(t);
        }, !0), n("scrollbarStyle", "native", function (t) {
          Yr(t), qr(t), t.display.scrollbars.setScrollTop(t.doc.scrollTop), t.display.scrollbars.setScrollLeft(t.doc.scrollLeft);
        }, !0), n("lineNumbers", !1, function (t, e) {
          t.display.gutterSpecs = bi(t.options.gutters, e), wi(t);
        }, !0), n("firstLineNumber", 1, wi, !0), n("lineNumberFormatter", function (t) {
          return t;
        }, wi, !0), n("showCursorWhenSelecting", !1, xr, !0), n("resetSelectionOnContextMenu", !0), n("lineWiseCopyCut", !0), n("pasteLinesPerSelection", !0), n("selectionsMayTouch", !1), n("readOnly", !1, function (t, e) {
          "nocursor" == e && (Dr(t), t.display.input.blur()), t.display.input.readOnlyChanged(e);
        }), n("screenReaderLabel", null, function (t, e) {
          e = "" === e ? null : e, t.display.input.screenReaderLabelChanged(e);
        }), n("disableInput", !1, function (t, e) {
          e || t.display.input.reset();
        }, !0), n("dragDrop", !0, Da), n("allowDropFileTypes", null), n("cursorBlinkRate", 530), n("cursorScrollMargin", 0), n("cursorHeight", 1, xr, !0), n("singleCursorHeightPerLine", !0, xr, !0), n("workTime", 100), n("workDelay", 100), n("flattenSpans", !0, Ii, !0), n("addModeClass", !1, Ii, !0), n("pollInterval", 100), n("undoDepth", 200, function (t, e) {
          return t.doc.history.undoDepth = e;
        }), n("historyEventDelay", 1250), n("viewportMargin", 10, function (t) {
          return t.refresh();
        }, !0), n("maxHighlightLength", 1e4, Ii, !0), n("moveInputWithCursor", !0, function (t, e) {
          e || t.display.input.resetPosition();
        }), n("tabindex", null, function (t, e) {
          return t.display.input.getField().tabIndex = e || "";
        }), n("autofocus", null), n("direction", "ltr", function (t, e) {
          return t.doc.setDirection(e);
        }, !0), n("phrases", null);
      }(Aa), function (t) {
        var e = t.optionHandlers,
          n = t.helpers = {};
        t.prototype = {
          constructor: t,
          focus: function focus() {
            z(this).focus(), this.display.input.focus();
          },
          setOption: function setOption(t, n) {
            var r = this.options,
              i = r[t];
            r[t] == n && "mode" != t || (r[t] = n, e.hasOwnProperty(t) && oi(this, e[t])(this, n, i), yt(this, "optionChange", this, t));
          },
          getOption: function getOption(t) {
            return this.options[t];
          },
          getDoc: function getDoc() {
            return this.doc;
          },
          addKeyMap: function addKeyMap(t, e) {
            this.state.keyMaps[e ? "push" : "unshift"](ea(t));
          },
          removeKeyMap: function removeKeyMap(t) {
            for (var e = this.state.keyMaps, n = 0; n < e.length; ++n) if (e[n] == t || e[n].name == t) return e.splice(n, 1), !0;
          },
          addOverlay: ai(function (e, n) {
            var r = e.token ? e : t.getMode(this.options, e);
            if (r.startState) throw new Error("Overlays may not be stateful.");
            !function (t, e, n) {
              for (var r = 0, i = n(e); r < t.length && n(t[r]) <= i;) r++;
              t.splice(r, 0, e);
            }(this.state.overlays, {
              mode: r,
              modeSpec: e,
              opaque: n && n.opaque,
              priority: n && n.priority || 0
            }, function (t) {
              return t.priority;
            }), this.state.modeGen++, vr(this);
          }),
          removeOverlay: ai(function (t) {
            for (var e = this.state.overlays, n = 0; n < e.length; ++n) {
              var r = e[n].modeSpec;
              if (r == t || "string" == typeof t && r.name == t) return e.splice(n, 1), this.state.modeGen++, void vr(this);
            }
          }),
          indentLine: ai(function (t, e, n) {
            "string" != typeof e && "number" != typeof e && (e = null == e ? this.options.smartIndent ? "smart" : "prev" : e ? "add" : "subtract"), re(this.doc, t) && Na(this, t, e, n);
          }),
          indentSelection: ai(function (t) {
            for (var e = this.doc.sel.ranges, n = -1, r = 0; r < e.length; r++) {
              var i = e[r];
              if (i.empty()) i.head.line > n && (Na(this, i.head.line, t, !0), n = i.head.line, r == this.doc.sel.primIndex && Ir(this));else {
                var o = i.from(),
                  a = i.to(),
                  s = Math.max(n, o.line);
                n = Math.min(this.lastLine(), a.line - (a.ch ? 0 : 1)) + 1;
                for (var l = s; l < n; ++l) Na(this, l, t);
                var c = this.doc.sel.ranges;
                0 == o.ch && e.length == c.length && c[r].from().ch > 0 && eo(this.doc, r, new Pi(o, c[r].to()), G);
              }
            }
          }),
          getTokenAt: function getTokenAt(t, e) {
            return Ce(this, t, e);
          },
          getLineTokens: function getLineTokens(t, e) {
            return Ce(this, oe(t), e, !0);
          },
          getTokenTypeAt: function getTokenTypeAt(t) {
            t = he(this.doc, t);
            var e,
              n = me(this, Jt(this.doc, t.line)),
              r = 0,
              i = (n.length - 1) / 2,
              o = t.ch;
            if (0 == o) e = n[2];else for (;;) {
              var a = r + i >> 1;
              if ((a ? n[2 * a - 1] : 0) >= o) i = a;else {
                if (!(n[2 * a + 1] < o)) {
                  e = n[2 * a + 2];
                  break;
                }
                r = a + 1;
              }
            }
            var s = e ? e.indexOf("overlay ") : -1;
            return s < 0 ? e : 0 == s ? null : e.slice(0, s - 1);
          },
          getModeAt: function getModeAt(e) {
            var n = this.doc.mode;
            return n.innerMode ? t.innerMode(n, this.getTokenAt(e).state).mode : n;
          },
          getHelper: function getHelper(t, e) {
            return this.getHelpers(t, e)[0];
          },
          getHelpers: function getHelpers(t, e) {
            var r = [];
            if (!n.hasOwnProperty(e)) return r;
            var i = n[e],
              o = this.getModeAt(t);
            if ("string" == typeof o[e]) i[o[e]] && r.push(i[o[e]]);else if (o[e]) for (var a = 0; a < o[e].length; a++) {
              var s = i[o[e][a]];
              s && r.push(s);
            } else o.helperType && i[o.helperType] ? r.push(i[o.helperType]) : i[o.name] && r.push(i[o.name]);
            for (var l = 0; l < i._global.length; l++) {
              var c = i._global[l];
              c.pred(o, this) && -1 == U(r, c.val) && r.push(c.val);
            }
            return r;
          },
          getStateAfter: function getStateAfter(t, e) {
            var n = this.doc;
            return be(this, (t = de(n, null == t ? n.first + n.size - 1 : t)) + 1, e).state;
          },
          cursorCoords: function cursorCoords(t, e) {
            var n = this.doc.sel.primary();
            return Zn(this, null == t ? n.head : "object" == typeof t ? he(this.doc, t) : t ? n.from() : n.to(), e || "page");
          },
          charCoords: function charCoords(t, e) {
            return Jn(this, he(this.doc, t), e || "page");
          },
          coordsChar: function coordsChar(t, e) {
            return er(this, (t = Xn(this, t, e || "page")).left, t.top);
          },
          lineAtHeight: function lineAtHeight(t, e) {
            return t = Xn(this, {
              top: t,
              left: 0
            }, e || "page").top, ne(this.doc, t + this.display.viewOffset);
          },
          heightAtLine: function heightAtLine(t, e, n) {
            var r,
              i = !1;
            if ("number" == typeof t) {
              var o = this.doc.first + this.doc.size - 1;
              t < this.doc.first ? t = this.doc.first : t > o && (t = o, i = !0), r = Jt(this.doc, t);
            } else r = t;
            return Yn(this, r, {
              top: 0,
              left: 0
            }, e || "page", n || i).top + (i ? this.doc.height - Ke(r) : 0);
          },
          defaultTextHeight: function defaultTextHeight() {
            return lr(this.display);
          },
          defaultCharWidth: function defaultCharWidth() {
            return cr(this.display);
          },
          getViewport: function getViewport() {
            return {
              from: this.display.viewFrom,
              to: this.display.viewTo
            };
          },
          addWidget: function addWidget(t, e, n, r, i) {
            var o,
              a,
              s,
              l = this.display,
              c = (t = Zn(this, he(this.doc, t))).bottom,
              u = t.left;
            if (e.style.position = "absolute", e.setAttribute("cm-ignore-events", "true"), this.display.input.setUneditable(e), l.sizer.appendChild(e), "over" == r) c = t.top;else if ("above" == r || "near" == r) {
              var d = Math.max(l.wrapper.clientHeight, this.doc.height),
                h = Math.max(l.sizer.clientWidth, l.lineSpace.clientWidth);
              ("above" == r || t.bottom + e.offsetHeight > d) && t.top > e.offsetHeight ? c = t.top - e.offsetHeight : t.bottom + e.offsetHeight <= d && (c = t.bottom), u + e.offsetWidth > h && (u = h - e.offsetWidth);
            }
            e.style.top = c + "px", e.style.left = e.style.right = "", "right" == i ? (u = l.sizer.clientWidth - e.offsetWidth, e.style.right = "0px") : ("left" == i ? u = 0 : "middle" == i && (u = (l.sizer.clientWidth - e.offsetWidth) / 2), e.style.left = u + "px"), n && (o = this, a = {
              left: u,
              top: c,
              right: u + e.offsetWidth,
              bottom: c + e.offsetHeight
            }, null != (s = Nr(o, a)).scrollTop && zr(o, s.scrollTop), null != s.scrollLeft && $r(o, s.scrollLeft));
          },
          triggerOnKeyDown: ai(ga),
          triggerOnKeyPress: ai(ma),
          triggerOnKeyUp: va,
          triggerOnMouseDown: ai(xa),
          execCommand: function execCommand(t) {
            if (aa.hasOwnProperty(t)) return aa[t].call(null, this);
          },
          triggerElectric: ai(function (t) {
            Ra(this, t);
          }),
          findPosH: function findPosH(t, e, n, r) {
            var i = 1;
            e < 0 && (i = -1, e = -e);
            for (var o = he(this.doc, t), a = 0; a < e && !(o = Ba(this.doc, o, i, n, r)).hitSide; ++a);
            return o;
          },
          moveH: ai(function (t, e) {
            var n = this;
            this.extendSelectionsBy(function (r) {
              return n.display.shift || n.doc.extend || r.empty() ? Ba(n.doc, r.head, t, e, n.options.rtlMoveVisually) : t < 0 ? r.from() : r.to();
            }, Y);
          }),
          deleteH: ai(function (t, e) {
            var n = this.doc.sel,
              r = this.doc;
            n.somethingSelected() ? r.replaceSelection("", null, "+delete") : na(this, function (n) {
              var i = Ba(r, n.head, t, e, !1);
              return t < 0 ? {
                from: i,
                to: n.head
              } : {
                from: n.head,
                to: i
              };
            });
          }),
          findPosV: function findPosV(t, e, n, r) {
            var i = 1,
              o = r;
            e < 0 && (i = -1, e = -e);
            for (var a = he(this.doc, t), s = 0; s < e; ++s) {
              var l = Zn(this, a, "div");
              if (null == o ? o = l.left : l.left = o, (a = Wa(this, l, i, n)).hitSide) break;
            }
            return a;
          },
          moveV: ai(function (t, e) {
            var n = this,
              r = this.doc,
              i = [],
              o = !this.display.shift && !r.extend && r.sel.somethingSelected();
            if (r.extendSelectionsBy(function (a) {
              if (o) return t < 0 ? a.from() : a.to();
              var s = Zn(n, a.head, "div");
              null != a.goalColumn && (s.left = a.goalColumn), i.push(s.left);
              var l = Wa(n, s, t, e);
              return "page" == e && a == r.sel.primary() && _r(n, Jn(n, l, "div").top - s.top), l;
            }, Y), i.length) for (var a = 0; a < r.sel.ranges.length; a++) r.sel.ranges[a].goalColumn = i[a];
          }),
          findWordAt: function findWordAt(t) {
            var e = Jt(this.doc, t.line).text,
              n = t.ch,
              r = t.ch;
            if (e) {
              var i = this.getHelper(t, "wordChars");
              "before" != t.sticky && r != e.length || !n ? ++r : --n;
              for (var o = e.charAt(n), a = ot(o, i) ? function (t) {
                  return ot(t, i);
                } : /\s/.test(o) ? function (t) {
                  return /\s/.test(t);
                } : function (t) {
                  return !/\s/.test(t) && !ot(t);
                }; n > 0 && a(e.charAt(n - 1));) --n;
              for (; r < e.length && a(e.charAt(r));) ++r;
            }
            return new Pi(oe(t.line, n), oe(t.line, r));
          },
          toggleOverwrite: function toggleOverwrite(t) {
            null != t && t == this.state.overwrite || ((this.state.overwrite = !this.state.overwrite) ? N(this.display.cursorDiv, "CodeMirror-overwrite") : T(this.display.cursorDiv, "CodeMirror-overwrite"), yt(this, "overwriteToggle", this, this.state.overwrite));
          },
          hasFocus: function hasFocus() {
            return this.display.input.getField() == L(V(this));
          },
          isReadOnly: function isReadOnly() {
            return !(!this.options.readOnly && !this.doc.cantEdit);
          },
          scrollTo: ai(function (t, e) {
            Fr(this, t, e);
          }),
          getScrollInfo: function getScrollInfo() {
            var t = this.display.scroller;
            return {
              left: t.scrollLeft,
              top: t.scrollTop,
              height: t.scrollHeight - Mn(this) - this.display.barHeight,
              width: t.scrollWidth - Mn(this) - this.display.barWidth,
              clientHeight: Ln(this),
              clientWidth: An(this)
            };
          },
          scrollIntoView: ai(function (t, e) {
            null == t ? (t = {
              from: this.doc.sel.primary().head,
              to: null
            }, null == e && (e = this.options.cursorScrollMargin)) : "number" == typeof t ? t = {
              from: oe(t, 0),
              to: null
            } : null == t.from && (t = {
              from: t,
              to: null
            }), t.to || (t.to = t.from), t.margin = e || 0, null != t.from.line ? function (t, e) {
              Vr(t), t.curOp.scrollToPos = e;
            }(this, t) : Rr(this, t.from, t.to, t.margin);
          }),
          setSize: ai(function (t, e) {
            var n = this,
              r = function r(t) {
                return "number" == typeof t || /^\d+$/.test(String(t)) ? t + "px" : t;
              };
            null != t && (this.display.wrapper.style.width = r(t)), null != e && (this.display.wrapper.style.height = r(e)), this.options.lineWrapping && Wn(this);
            var i = this.display.viewFrom;
            this.doc.iter(i, this.display.viewTo, function (t) {
              if (t.widgets) for (var e = 0; e < t.widgets.length; e++) if (t.widgets[e].noHScroll) {
                mr(n, i, "widget");
                break;
              }
              ++i;
            }), this.curOp.forceUpdate = !0, yt(this, "refresh", this);
          }),
          operation: function operation(t) {
            return ii(this, t);
          },
          startOperation: function startOperation() {
            return Jr(this);
          },
          endOperation: function endOperation() {
            return Zr(this);
          },
          refresh: ai(function () {
            var t = this.display.cachedTextHeight;
            vr(this), this.curOp.forceUpdate = !0, Un(this), Fr(this, this.doc.scrollLeft, this.doc.scrollTop), pi(this.display), (null == t || Math.abs(t - lr(this.display)) > .5 || this.options.lineWrapping) && fr(this), yt(this, "refresh", this);
          }),
          swapDoc: ai(function (t) {
            var e = this.doc;
            return e.cm = null, this.state.selectingText && this.state.selectingText(), zi(this, t), Un(this), this.display.input.reset(), Fr(this, t.scrollLeft, t.scrollTop), this.curOp.forceScroll = !0, fn(this, "swapDoc", this, e), e;
          }),
          phrase: function phrase(t) {
            var e = this.options.phrases;
            return e && Object.prototype.hasOwnProperty.call(e, t) ? e[t] : t;
          },
          getInputField: function getInputField() {
            return this.display.input.getField();
          },
          getWrapperElement: function getWrapperElement() {
            return this.display.wrapper;
          },
          getScrollerElement: function getScrollerElement() {
            return this.display.scroller;
          },
          getGutterElement: function getGutterElement() {
            return this.display.gutters;
          }
        }, Ct(t), t.registerHelper = function (e, r, i) {
          n.hasOwnProperty(e) || (n[e] = t[e] = {
            _global: []
          }), n[e][r] = i;
        }, t.registerGlobalHelper = function (e, r, i, o) {
          t.registerHelper(e, r, o), n[e]._global.push({
            pred: i,
            val: o
          });
        };
      }(Aa);
      var Ja = "iter insert remove copy getEditor constructor".split(" ");
      for (var Za in _Io.prototype) _Io.prototype.hasOwnProperty(Za) && U(Ja, Za) < 0 && (Aa.prototype[Za] = function (t) {
        return function () {
          return t.apply(this.doc, arguments);
        };
      }(_Io.prototype[Za]));
      return Ct(_Io), Aa.inputStyles = {
        textarea: Xa,
        contenteditable: Ua
      }, Aa.defineMode = function (t) {
        Aa.defaults.mode || "null" == t || (Aa.defaults.mode = t), $t.apply(this, arguments);
      }, Aa.defineMIME = function (t, e) {
        Ht[t] = e;
      }, Aa.defineMode("null", function () {
        return {
          token: function token(t) {
            return t.skipToEnd();
          }
        };
      }), Aa.defineMIME("text/plain", "null"), Aa.defineExtension = function (t, e) {
        Aa.prototype[t] = e;
      }, Aa.defineDocExtension = function (t, e) {
        _Io.prototype[t] = e;
      }, Aa.fromTextArea = function (t, e) {
        if ((e = e ? $(e) : {}).value = t.value, !e.tabindex && t.tabIndex && (e.tabindex = t.tabIndex), !e.placeholder && t.placeholder && (e.placeholder = t.placeholder), null == e.autofocus) {
          var n = L(R(t));
          e.autofocus = n == t || null != t.getAttribute("autofocus") && n == document.body;
        }
        function r() {
          t.value = s.getValue();
        }
        var i;
        if (t.form && (vt(t.form, "submit", r), !e.leaveSubmitMethodAlone)) {
          var o = t.form;
          i = o.submit;
          try {
            var a = o.submit = function () {
              r(), o.submit = i, o.submit(), o.submit = a;
            };
          } catch (t) {}
        }
        e.finishInit = function (n) {
          n.save = r, n.getTextArea = function () {
            return t;
          }, n.toTextArea = function () {
            n.toTextArea = isNaN, r(), t.parentNode.removeChild(n.getWrapperElement()), t.style.display = "", t.form && (bt(t.form, "submit", r), e.leaveSubmitMethodAlone || "function" != typeof t.form.submit || (t.form.submit = i));
          };
        }, t.style.display = "none";
        var s = Aa(function (e) {
          return t.parentNode.insertBefore(e, t.nextSibling);
        }, e);
        return s;
      }, function (t) {
        t.off = bt, t.on = vt, t.wheelEventPixels = ki, t.Doc = _Io, t.splitLines = It, t.countColumn = B, t.findColumn = X, t.isWordChar = it, t.Pass = q, t.signal = yt, t.Line = Je, t.changeEnd = Mi, t.scrollbarModel = Kr, t.Pos = oe, t.cmpPos = ae, t.modes = zt, t.mimeModes = Ht, t.resolveMode = Bt, t.getMode = Wt, t.modeExtensions = Ut, t.extendMode = qt, t.copyState = Gt, t.startState = Yt, t.innerMode = Kt, t.commands = aa, t.keyMap = Ko, t.keyName = ta, t.isModifierKey = Zo, t.lookupKey = Jo, t.normalizeKeyMap = Xo, t.StringStream = Xt, t.SharedTextMarker = Ao, t.TextMarker = Do, t.LineWidget = To, t.e_preventDefault = St, t.e_stopPropagation = kt, t.e_stop = Tt, t.addClass = N, t.contains = A, t.rmClass = T, t.keyNames = Wo;
      }(Aa), Aa.version = "5.65.16", Aa;
    }();
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(8),
      i = n.n(r),
      o = n(2),
      a = n.n(o),
      s = n(1),
      l = n.n(s),
      c = n(0),
      u = n(3),
      d = n(7),
      h = n(20);
    function f(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function p(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? f(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var g = l.a.View.extend({
        events: function events() {
          return this.model.get("events") || {
            mousedown: "handleClick"
          };
        },
        attributes: function attributes() {
          return this.model.get("attributes");
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.config,
            n = void 0 === e ? {} : e;
          this.em = n.em, this.editor = n.editor;
        },
        handleClick: function handleClick(t) {
          t.preventDefault(), t.stopPropagation();
          var e = this.editor,
            n = this.em,
            r = e.Canvas.getFrameEl().getBoundingClientRect(),
            i = r.left,
            o = r.top,
            a = p(p({}, t), {}, {
              clientX: t.clientX - i,
              clientY: t.clientY - o
            });
          n.trigger("toolbar:run:before"), this.execCommand(a);
        },
        execCommand: function execCommand(t) {
          var e = {
              event: t
            },
            n = this.model.get("command"),
            r = this.editor;
          "function" == typeof n && n(r, null, e), "string" == typeof n && r.runCommand(n, e);
        },
        render: function render() {
          var t = this.editor,
            e = this.$el,
            n = this.model,
            r = n.get("id"),
            i = n.get("label"),
            o = t.getConfig("stylePrefix");
          return e.addClass("".concat(o, "toolbar-item")), r && e.addClass("".concat(o, "toolbar-item__").concat(r)), i && e.append(i), this;
        }
      }),
      v = h.a.extend({
        itemView: g,
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.config = {
            editor: t.editor || "",
            em: t.em
          }, this.listenTo(this.collection, "reset", this.render);
        }
      }),
      m = l.a.Model.extend({
        defaults: {
          command: "",
          attributes: {}
        }
      }),
      b = l.a.Collection.extend({
        model: m
      });
    function y(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function w(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? y(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var x,
      O = l.a.$;
    e.default = {
      init: function init(t) {
        Object(c.bindAll)(this, "onHover", "onOut", "onClick", "onFrameScroll", "onFrameUpdated", "onContainerChange");
      },
      enable: function enable() {
        this.frameOff = this.canvasOff = this.adjScroll = null, this.startSelectComponent(), x = 1;
      },
      startSelectComponent: function startSelectComponent() {
        this.toggleSelectComponent(1), this.em.getSelected() && this.onSelect();
      },
      stopSelectComponent: function stopSelectComponent() {
        this.toggleSelectComponent();
      },
      toggleSelectComponent: function toggleSelectComponent(t) {
        var e = this,
          n = this.em,
          r = n.getConfig("listenToEl"),
          i = n.getContainer().parentNode,
          o = t ? "on" : "off",
          a = {
            on: u.u,
            off: u.t
          };
        !r.length && i && r.push(i);
        a[o](window, "resize", this.onFrameUpdated), a[o](r, "scroll", this.onContainerChange), n[o]("component:toggled", this.onSelect, this), n[o]("change:componentHovered", this.onHovered, this), n[o]("component:resize component:styleUpdate component:input", this.updateGlobalPos, this), n[o]("change:canvasOffset", this.updateAttached, this), n[o]("frame:updated", this.onFrameUpdated, this), n.get("Canvas").getFrames().forEach(function (t) {
          var n,
            r,
            i = t.view;
          i && (n = i.getWindow(), r = i.getBody(), a[o](r, "mouseover", e.onHover), a[o](r, "mouseleave", e.onOut), a[o](r, "click touchend", e.onClick), a[o](n, "scroll", e.onFrameScroll));
        });
      },
      onHover: function onHover(t) {
        t.stopPropagation();
        var e = t.target,
          n = Object(u.j)(e),
          r = n && n._getFrame(),
          i = O(e),
          o = i.data("model");
        if (!o) for (var a = i.parent(); !o && a.length && !Object(d.g)(a[0]);) o = a.data("model"), a = a.parent();
        if (o && !o.get("hoverable")) {
          for (var s = o && o.parent(); s && !s.get("hoverable");) s = s.parent();
          o = s;
        }
        this.currentDoc = e.ownerDocument, this.em.setHovered(o), r && this.em.set("currentFrame", r);
      },
      onFrameUpdated: function onFrameUpdated() {
        this.updateLocalPos(), this.updateGlobalPos();
      },
      onHovered: function onHovered(t, e) {
        var n = this,
          r = {};
        e && e.views.forEach(function (t) {
          var i = t.el,
            o = n.getElementPos(i);
          r = {
            el: i,
            pos: o,
            component: e,
            view: Object(u.j)(i)
          }, n.updateToolsLocal(r), i.ownerDocument === n.currentDoc && (n.elHovered = r);
        });
      },
      onSelect: Object(c.debounce)(function () {
        var t = this.em,
          e = t.getSelected(),
          n = t.get("currentFrame") || {},
          r = e && e.getView(n.model),
          i = r && r.el,
          o = {};
        i && Object(d.h)(i) && (o = {
          el: i,
          pos: this.getElementPos(i),
          component: e,
          view: Object(u.j)(i)
        });
        this.elSelected = o, this.updateToolsGlobal(), this.updateToolsLocal(o), this.initResize(e);
      }),
      updateGlobalPos: function updateGlobalPos() {
        var t = this.getElSelected();
        t.el && (t.pos = this.getElementPos(t.el), this.updateToolsGlobal());
      },
      updateLocalPos: function updateLocalPos() {
        var t = this.getElHovered();
        t.el && (t.pos = this.getElementPos(t.el), this.updateToolsLocal());
      },
      getElHovered: function getElHovered() {
        return this.elHovered || {};
      },
      getElSelected: function getElSelected() {
        return this.elSelected || {};
      },
      onOut: function onOut() {
        var t = this;
        this.currentDoc = null, this.em.setHovered(0), this.elHovered = 0, this.updateToolsLocal(), this.canvas.getFrames().forEach(function (e) {
          var n = e.view,
            r = n && n.getToolsEl();
          r && t.toggleToolsEl(0, 0, {
            el: r
          });
        });
      },
      toggleToolsEl: function toggleToolsEl(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = n.el || this.canvas.getToolsEl(e);
        return r && (r.style.opacity = t ? 1 : 0), r || {};
      },
      showElementOffset: function showElementOffset(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        x && this.editor.runCommand("show-offset", {
          el: t,
          elPos: e,
          view: n.view,
          force: 1,
          top: 0,
          left: 0
        });
      },
      hideElementOffset: function hideElementOffset(t) {
        this.editor.stopCommand("show-offset", {
          view: t
        });
      },
      showFixedElementOffset: function showFixedElementOffset(t, e) {
        this.editor.runCommand("show-offset", {
          el: t,
          elPos: e,
          state: "Fixed"
        });
      },
      hideFixedElementOffset: function hideFixedElementOffset(t, e) {
        this.editor && this.editor.stopCommand("show-offset", {
          state: "Fixed"
        });
      },
      hideHighlighter: function hideHighlighter(t) {
        this.canvas.getHighlighter(t).style.opacity = 0;
      },
      onClick: function onClick(t) {
        t.stopPropagation(), t.preventDefault();
        var e = this.em;
        if (e.get("_cmpDrag")) return e.set("_cmpDrag");
        var n = O(t.target),
          r = n.data("model");
        if (!r) for (var i = n.parent(); !r && i.length && !Object(d.g)(i[0]);) r = i.data("model"), i = i.parent();
        if (r) if (r.get("selectable")) this.select(r, t);else {
          for (var o = r.parent(); o && !o.get("selectable");) o = o.parent();
          this.select(o, t);
        }
      },
      select: function select(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (t) {
          var n = e.ctrlKey || e.metaKey,
            r = e.shiftKey,
            i = this.editor,
            o = this.em,
            a = i.getConfig("multipleSelection");
          if (n && a) i.selectToggle(t);else if (r && a) {
            o.clearSelection(i.Canvas.getWindow());
            var s,
              l,
              u = t.collection,
              d = u.indexOf(t);
            i.getSelectedAll();
            if (i.getSelectedAll().forEach(function (t) {
              var e = t.collection,
                n = e.indexOf(t);
              e === u && (n < d ? s = Object(c.isUndefined)(s) ? n : Math.max(s, n) : n > d && (l = Object(c.isUndefined)(l) ? n : Math.min(l, n)));
            }), !Object(c.isUndefined)(s)) for (; s !== d;) i.selectAdd(u.at(s)), s++;
            if (!Object(c.isUndefined)(l)) for (; l !== d;) i.selectAdd(u.at(l)), l--;
            i.selectAdd(t);
          } else i.select(t, {
            scroll: {}
          });
          this.initResize(t);
        }
      },
      updateBadge: function updateBadge(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = O(t).data("model");
        if (r && r.get("badgable")) {
          var i = this.getBadge(n);
          if (!n.posOnly) {
            var o = this.canvas.getConfig(),
              a = r.getIcon(),
              s = o.pStylePrefix || "",
              l = "".concat(s, "badge"),
              c = o.customBadgeLabel,
              u = "".concat(a ? '<div class="'.concat(l, '__icon">').concat(a, "</div>") : "", '\n        <div class="').concat(l, '__name">').concat(r.getName(), "</div>");
            i.innerHTML = c ? c(r) : u;
          }
          var d = "px",
            h = i.style;
          h.display = "block";
          var f = i ? i.offsetHeight : 0,
            p = 0 - f,
            g = n.topOff - f < 0 ? -n.topOff : p,
            v = n.leftOff < 0 ? -n.leftOff : 0;
          h.top = g + d, h.left = v + d;
        }
      },
      showHighlighter: function showHighlighter(t) {
        this.canvas.getHighlighter(t).style.opacity = "";
      },
      initResize: function initResize(t) {
        var e,
          n = this.em,
          r = this.canvas,
          o = n ? n.get("Editor") : "",
          a = (n ? n.get("Config") : "").stylePrefix || "",
          s = "".concat(a, "resizing"),
          l = !Object(c.isElement)(t) && Object(u.p)(t) ? t : n.getSelected(),
          d = l && l.get("resizable"),
          h = {},
          f = function f(t, e, n) {
            var r = n.docs;
            r && r.forEach(function (e) {
              var n = e.body,
                r = n.className || "";
              n.className = ("add" == t ? "".concat(r, " ").concat(s) : r.replace(s, "")).trim();
            });
          };
        if (o && d) {
          var p = Object(c.isElement)(t) ? t : l.getEl();
          h = {
            onStart: function onStart(t) {
              var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                o = i.el,
                a = i.config,
                s = i.resizer,
                c = a.keyHeight,
                d = a.keyWidth,
                h = a.currentUnit,
                p = a.keepAutoHeight,
                g = a.keepAutoWidth;
              f("add", 0, i), e = n.get("StyleManager").getModelToStyle(l), r.toggleFramesEvents();
              var v = getComputedStyle(o),
                m = e.getStyle(),
                b = m[d];
              a.autoWidth = g && "auto" === b, isNaN(parseFloat(b)) && (b = v[d]);
              var y = m[c];
              a.autoHeight = p && "auto" === y, isNaN(parseFloat(y)) && (y = v[c]), s.startDim.w = parseFloat(b), s.startDim.h = parseFloat(y), x = 0, h && (a.unitHeight = Object(u.i)(y), a.unitWidth = Object(u.i)(b));
            },
            onMove: function onMove() {
              o.trigger("component:resize");
            },
            onEnd: function onEnd(t, e) {
              f("remove", 0, e), o.trigger("component:resize"), r.toggleFramesEvents(1), x = 1;
            },
            updateTarget: function updateTarget(t, i) {
              var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              if (e) {
                var a = o.store,
                  s = o.selectedHandler,
                  l = o.config,
                  c = l.keyHeight,
                  u = l.keyWidth,
                  d = l.autoHeight,
                  h = l.autoWidth,
                  f = l.unitWidth,
                  p = l.unitHeight,
                  g = ["tc", "bc"].indexOf(s) >= 0,
                  v = ["cl", "cr"].indexOf(s) >= 0,
                  m = {},
                  b = a ? "" : 1;
                if (!g) {
                  var y = r.getBody().offsetWidth,
                    x = i.w < y ? i.w : y;
                  m[u] = h ? "auto" : "".concat(x).concat(f);
                }
                v || (m[c] = d ? "auto" : "".concat(i.h).concat(p)), e.addStyle(w(w({}, m), {}, {
                  en: b
                }), {
                  avoidStore: !a
                });
                var O = "update:component:style",
                  C = "".concat(O, ":").concat(c, " ").concat(O, ":").concat(u);
                n && n.trigger(C, null, null, {
                  noEmit: 1
                });
              }
            }
          }, "object" == i()(d) && (h = w(w({}, h), d)), this.resizer = o.runCommand("resize", {
            el: p,
            options: h,
            force: 1
          });
        } else o.stopCommand("resize"), this.resizer = null;
      },
      updateToolbar: function updateToolbar(t) {
        var e = this.config.em,
          n = t == e ? e.getSelected() : t,
          r = this.canvas.getToolbarEl(),
          i = r.style;
        if (n) {
          var o = n.get("toolbar");
          if (e.get("Config").showToolbar && o && o.length) {
            if (i.opacity = "", i.display = "", !this.toolbar) {
              r.innerHTML = "", this.toolbar = new b(o);
              var a = new v({
                collection: this.toolbar,
                editor: this.editor,
                em: e
              });
              r.appendChild(a.render().el);
            }
            this.toolbar.reset(o), i.top = "-100px", i.left = 0;
          } else i.display = "none";
        } else i.opacity = 0;
      },
      updateToolbarPos: function updateToolbarPos(t) {
        var e = this.canvas.getToolbarEl().style;
        e.top = "".concat(t.top).concat("px"), e.left = "".concat(t.left).concat("px"), e.opacity = "";
      },
      getCanvasPosition: function getCanvasPosition() {
        return this.canvas.getCanvasView().getPosition();
      },
      getBadge: function getBadge() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return this.canvas.getBadgeEl(t.view);
      },
      onFrameScroll: function onFrameScroll() {
        this.updateTools();
      },
      updateTools: function updateTools() {
        this.updateToolsLocal(), this.updateGlobalPos();
      },
      isCompSelected: function isCompSelected(t) {
        return t && "selected" === t.get("status");
      },
      updateToolsLocal: function updateToolsLocal(t) {
        var e = t || this.getElHovered(),
          n = e.el,
          r = e.pos,
          i = e.view,
          o = e.component;
        if (n) {
          var a = o.get("hoverable"),
            s = this.lastHovered !== n,
            l = s ? {} : {
              posOnly: 1
            };
          s && a && (this.lastHovered = n, this.showHighlighter(i), this.showElementOffset(n, r, {
            view: i
          })), this.isCompSelected(o) && (this.hideHighlighter(i), this.hideElementOffset(i));
          var c = this.toggleToolsEl(1, i).style,
            u = this.canvas.canvasRectOffset(n, r),
            d = u.top,
            h = u.left;
          this.updateBadge(n, r, w(w({}, l), {}, {
            view: i,
            topOff: d,
            leftOff: h
          })), c.top = d + "px", c.left = h + "px", c.width = r.width + "px", c.height = r.height + "px";
        } else this.lastHovered = 0;
      },
      updateToolsGlobal: function updateToolsGlobal() {
        var t = this.getElSelected(),
          e = t.el,
          n = t.pos,
          r = t.component;
        if (!e) return this.toggleToolsEl(), void (this.lastSelected = 0);
        var i = this.canvas;
        this.lastSelected !== e && (this.lastSelected = e, this.updateToolbar(r));
        var o = this.toggleToolsEl(1).style,
          a = i.getTargetToElementFixed(e, i.getToolbarEl(), {
            pos: n
          }),
          s = a.canvasOffsetTop,
          l = a.canvasOffsetLeft;
        o.top = s + "px", o.left = l + "px", o.width = n.width + "px", o.height = n.height + "px", this.updateToolbarPos({
          top: a.top,
          left: a.left
        });
      },
      updateAttached: Object(c.debounce)(function () {
        this.updateGlobalPos();
      }),
      onContainerChange: Object(c.debounce)(function () {
        this.em.refreshCanvas();
      }, 150),
      getElementPos: function getElementPos(t) {
        return this.canvas.getCanvasView().getElementPos(t);
      },
      hideBadge: function hideBadge() {
        this.getBadge().style.display = "none";
      },
      cleanPrevious: function cleanPrevious(t) {
        t && t.set({
          status: "",
          state: ""
        });
      },
      getContentWindow: function getContentWindow() {
        return this.canvas.getWindow();
      },
      run: function run(t) {
        this.editor = t && t.get("Editor"), this.enable();
      },
      stop: function stop(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = this.em,
          i = this.editor;
        this.stopSelectComponent(), !n.preserveSelected && r.setSelected(null), this.onOut(), this.toggleToolsEl(), i && i.stopCommand("resize");
      }
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    var r = n(42);
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, r(i.key), i);
      }
    }
    t.exports = function (t, e, n) {
      return e && i(t.prototype, e), n && i(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return f;
    });
    var r = n(2),
      i = n.n(r),
      o = n(15),
      a = n.n(o),
      s = n(16),
      l = n.n(s),
      c = n(0),
      u = n(3);
    function d(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function h(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? d(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var f = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return a()(this, t), this.opts = {
          container: null,
          onStart: null,
          onDrag: null,
          onEnd: null,
          setPosition: null,
          getPosition: null,
          guidesStatic: null,
          guidesTarget: null,
          snapOffset: 5,
          doc: 0,
          scale: 1
        }, Object(c.bindAll)(this, "drag", "stop", "keyHandle", "handleScroll"), this.setOptions(e), this.delta = {
          x: 0,
          y: 0
        }, this;
      }
      return l()(t, [{
        key: "setOptions",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.opts = h(h({}, this.opts), t);
        }
      }, {
        key: "toggleDrag",
        value: function value(t) {
          var e = this.getDocumentEl(),
            n = this.getContainerEl(),
            r = this.getWindowEl(),
            i = t ? "on" : "off",
            o = {
              on: u.u,
              off: u.t
            };
          o[i](n, "mousemove dragover", this.drag), o[i](e, "mouseup dragend touchend", this.stop), o[i](e, "keydown", this.keyHandle), o[i](r, "scroll", this.handleScroll);
        }
      }, {
        key: "handleScroll",
        value: function value() {
          var t = this.lastScroll,
            e = this.delta,
            n = this.getScrollInfo(),
            r = {
              x: n.x - t.x,
              y: n.y - t.y
            };
          this.move(e.x + r.x, e.y + r.y), this.lastScrollDiff = r;
        }
      }, {
        key: "start",
        value: function value(t) {
          var e = this.opts,
            n = e.onStart;
          this.toggleDrag(1), this.startPointer = this.getPointerPos(t), this.guidesStatic = Object(c.result)(e, "guidesStatic") || [], this.guidesTarget = Object(c.result)(e, "guidesTarget") || [], Object(c.isFunction)(n) && n(t, this), this.startPosition = this.getStartPosition(), this.lastScrollDiff = {
            x: 0,
            y: 0
          }, this.globScrollDiff = {
            x: 0,
            y: 0
          }, this.drag(t);
        }
      }, {
        key: "drag",
        value: function value(t) {
          var e = this,
            n = this.opts,
            r = this.lastScrollDiff,
            i = this.globScrollDiff,
            o = n.onDrag,
            a = this.startPointer,
            s = this.getPointerPos(t),
            l = {
              x: i.x + r.x,
              y: i.y + r.y
            };
          this.globScrollDiff = l;
          var u = {
            x: s.x - a.x + l.x,
            y: s.y - a.y + l.y
          };
          this.lastScrollDiff = {
            x: 0,
            y: 0
          };
          var d = this.lockedAxis;
          "x" === (d = t.shiftKey ? !d && this.detectAxisLock(u.x, u.y) : null) ? u.x = a.x : "y" === d && (u.y = a.y);
          var f = function f(r) {
              ["x", "y"].forEach(function (t) {
                return r[t] = r[t] * Object(c.result)(n, "scale");
              }), e.delta = r, e.move(r.x, r.y), Object(c.isFunction)(o) && o(t, e);
            },
            p = h({}, u);
          if (this.currentPointer = s, this.lockedAxis = d, this.lastScroll = this.getScrollInfo(), f(u), this.guidesTarget.length) {
            var g = this.snapGuides(p),
              v = g.newDelta,
              m = g.trgX,
              b = g.trgY;
            (m || b) && f(v);
          }
          0 === t.which && this.stop(t);
        }
      }, {
        key: "snapGuides",
        value: function value(t) {
          var e = this,
            n = t,
            r = this.trgX,
            i = this.trgY;
          return this.guidesTarget.forEach(function (n) {
            n.x && e.trgX || n.y && e.trgY || (n.active = 0, e.guidesStatic.forEach(function (o) {
              if (!(n.y && o.x || n.x && o.y)) {
                var a = n.y && o.y,
                  s = a ? "y" : "x",
                  l = n[s],
                  u = o[s],
                  d = t[s],
                  h = a ? i : r;
                if (e.isPointIn(l, u) && Object(c.isUndefined)(h)) {
                  var f = d - (l - u);
                  e.setGuideLock(n, f);
                }
              }
            }));
          }), r = this.trgX, i = this.trgY, ["x", "y"].forEach(function (r) {
            var i = r.toUpperCase(),
              o = e["trg".concat(i)];
            o && !e.isPointIn(t[r], o.lock) && (e.setGuideLock(o, null), o = null), o && !Object(c.isUndefined)(o.lock) && (n[r] = o.lock);
          }), {
            newDelta: n,
            trgX: this.trgX,
            trgY: this.trgY
          };
        }
      }, {
        key: "isPointIn",
        value: function value(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = n.offset,
            i = r || this.opts.snapOffset;
          return t >= e && t <= e + i || t <= e && t >= e - i;
        }
      }, {
        key: "setGuideLock",
        value: function value(t, e) {
          var n = Object(c.isUndefined)(t.x) ? "Y" : "X",
            r = "trg".concat(n);
          return null !== e ? (t.active = 1, t.lock = e, this[r] = t) : (delete t.active, delete t.lock, delete this[r]), t;
        }
      }, {
        key: "stop",
        value: function value(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.delta,
            r = e.cancel,
            i = r ? 0 : n.x,
            o = r ? 0 : n.y;
          this.toggleDrag(), this.lockedAxis = null, this.move(i, o, 1);
          var a = this.opts.onEnd;
          Object(c.isFunction)(a) && a(t, this, {
            cancelled: r
          });
        }
      }, {
        key: "keyHandle",
        value: function value(t) {
          Object(u.m)(t) && this.stop(t, {
            cancel: 1
          });
        }
      }, {
        key: "move",
        value: function value(t, e, n) {
          var r = this.el,
            i = this.opts,
            o = this.startPosition;
          if (o) {
            var a = i.setPosition,
              s = o.x + t,
              l = o.y + e;
            this.position = {
              x: s,
              y: l,
              end: n
            }, Object(c.isFunction)(a) && a(this.position), r && (r.style.left = "".concat(s, "px"), r.style.top = "".concat(l, "px"));
          }
        }
      }, {
        key: "getContainerEl",
        value: function value() {
          var t = this.opts.container;
          return t ? [t] : this.getDocumentEl();
        }
      }, {
        key: "getWindowEl",
        value: function value() {
          return this.getContainerEl().map(function (t) {
            var e = t.ownerDocument || t;
            return e.defaultView || e.parentWindow;
          });
        }
      }, {
        key: "getDocumentEl",
        value: function value(t) {
          var e = this.opts.doc;
          if (t = t || this.el, !this.docs) {
            var n = [document];
            t && n.push(t.ownerDocument), e && n.push(e), this.docs = n;
          }
          return this.docs;
        }
      }, {
        key: "getPointerPos",
        value: function value(t) {
          var e = this.opts.getPointerPosition,
            n = Object(u.h)(t);
          return e ? e(t) : {
            x: n.clientX,
            y: n.clientY
          };
        }
      }, {
        key: "getStartPosition",
        value: function value() {
          var t = this.el,
            e = this.opts.getPosition,
            n = {
              x: 0,
              y: 0
            };
          return Object(c.isFunction)(e) ? n = e() : t && (n = {
            x: parseFloat(t.style.left),
            y: parseFloat(t.style.top)
          }), n;
        }
      }, {
        key: "getScrollInfo",
        value: function value() {
          var t = this.opts.doc,
            e = t && t.body;
          return {
            y: e ? e.scrollTop : 0,
            x: e ? e.scrollLeft : 0
          };
        }
      }, {
        key: "detectAxisLock",
        value: function value(t, e) {
          var n = t,
            r = e,
            i = Math.abs(n),
            o = Math.abs(r);
          return r >= i || r <= -i ? "x" : n > o || n < -o ? "y" : void 0;
        }
      }]), t;
    }();
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n.n(r),
      o = i.a.$;
    e.a = i.a.View.extend({
      events: {
        change: "handleChange"
      },
      template: function template() {
        return '<span class="'.concat(this.holderClass(), '"></span>');
      },
      inputClass: function inputClass() {
        return "".concat(this.ppfx, "field");
      },
      holderClass: function holderClass() {
        return "".concat(this.ppfx, "input-holder");
      },
      initialize: function initialize() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.ppfx || "";
        this.opts = t, this.ppfx = e, this.em = t.target || {}, this.listenTo(this.model, "change:value", this.handleModelChange);
      },
      elementUpdated: function elementUpdated() {
        this.model.trigger("el:change");
      },
      setValue: function setValue(t) {
        var e = this.model,
          n = t || e.get("defaults"),
          r = this.getInputEl();
        r && (r.value = n);
      },
      handleModelChange: function handleModelChange(t, e, n) {
        this.setValue(e, n);
      },
      handleChange: function handleChange(t) {
        t.stopPropagation();
        var e = this.getInputEl().value;
        this.model.set({
          value: e
        }, {
          fromInput: 1
        }), this.elementUpdated();
      },
      getInputEl: function getInputEl() {
        if (!this.inputEl) {
          var t = this.model,
            e = t.get("placeholder") || t.get("defaults") || "";
          this.inputEl = o('<input type="text" placeholder="'.concat(e, '">'));
        }
        return this.inputEl.get(0);
      },
      render: function render() {
        this.inputEl = null;
        var t = this.$el;
        return t.addClass(this.inputClass()), t.html(this.template()), t.find(".".concat(this.holderClass())).append(this.getInputEl()), this;
      }
    });
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
      i = n.n(r),
      o = n(7);
    e.default = i.a.View.extend({
      initialize: function initialize(t) {
        this.config = t.config || {}, this.pfx = this.config.stylePrefix || "", this.target = t.target || {}, this.propTarget = t.propTarget || {}, this.onChange = t.onChange, this.onInputRender = t.onInputRender || {}, this.customValue = t.customValue || {}, this.properties = [];
        var e = this.collection;
        this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.render);
      },
      addTo: function addTo(t, e, n) {
        this.add(t, null, n);
      },
      add: function add(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = e || this.el,
          i = new t.typeView({
            model: t,
            name: t.get("name"),
            id: this.pfx + t.get("property"),
            target: this.target,
            propTarget: this.propTarget,
            onChange: this.onChange,
            onInputRender: this.onInputRender,
            config: this.config
          });
        "composite" != t.get("type") && (i.customValue = this.customValue), i.render();
        var a = i.el;
        this.properties.push(i), i.updateVisibility(), Object(o.b)(r, a, n.at);
      },
      render: function render() {
        var t = this,
          e = this.$el;
        this.clearItems();
        var n = document.createDocumentFragment();
        return this.collection.each(function (e) {
          return t.add(e, n);
        }), e.empty(), e.append(n), e.attr("class", "".concat(this.pfx, "properties")), this;
      },
      remove: function remove() {
        i.a.View.prototype.remove.apply(this, arguments), this.clearItems();
      },
      clearItems: function clearItems() {
        this.properties.forEach(function (t) {
          return t.remove();
        }), this.properties = [];
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
      i = n(1),
      o = n.n(i);
    e.a = o.a.View.extend({
      itemView: "",
      itemsView: "",
      itemType: "type",
      autoAdd: 0,
      initialize: function initialize() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = arguments.length > 1 ? arguments[1] : void 0;
        this.config = e || t.config || {}, this.autoAdd && this.listenTo(this.collection, "add", this.addTo), this.items = [], this.init();
      },
      init: function init() {},
      addTo: function addTo(t) {
        this.add(t);
      },
      itemViewNotFound: function itemViewNotFound(t) {
        var e = this.config,
          n = this.ns,
          r = e.em,
          i = "".concat(n ? "[".concat(n, "]: ") : "", "'").concat(t, "' type not found");
        r && r.logWarning(i);
      },
      add: function add(t, e) {
        var n,
          i = this.config,
          o = this.reuseView,
          a = this.items,
          s = this.itemsView,
          l = void 0 === s ? {} : s,
          c = e || null,
          u = this.itemView,
          d = t.get(this.itemType);
        l[d] ? u = l[d] : !d || l[d] || Object(r.includes)(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time", "url", "week"], d) || this.itemViewNotFound(d), n = t.view && o ? t.view : new u({
          model: t,
          config: i
        }, i), a && a.push(n);
        var h = n.render().el;
        c ? c.appendChild(h) : this.$el.append(h);
      },
      render: function render() {
        var t = document.createDocumentFragment();
        return this.clearItems(), this.$el.empty(), this.collection.length && this.collection.each(function (e) {
          this.add(e, t);
        }, this), this.$el.append(t), this.onRender(), this;
      },
      onRender: function onRender() {},
      remove: function remove() {
        this.clearItems(), o.a.View.prototype.remove.apply(this, arguments);
      },
      clearItems: function clearItems() {
        this.items;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r,
      i = n(8),
      o = n.n(i),
      a = n(2),
      s = n.n(a),
      l = n(1),
      c = n.n(l),
      u = n(0);
    function d(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function h(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? d(Object(n), !0).forEach(function (e) {
          s()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.a = c.a.Collection.extend({
      initialize: function initialize(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        this.opt = e, this.listenTo(this, "add", this.onAdd), this.listenTo(this, "remove", this.removeChildren), this.listenTo(this, "reset", this.resetChildren), this.config = e.config, this.em = e.em, this.domc = e.domc;
      },
      resetChildren: function resetChildren(t) {
        var e = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = this,
          i = n.previousModels,
          o = void 0 === i ? [] : i;
        o.forEach(function (t) {
          return e.removeChildren(t, r, n);
        }), t.each(function (t) {
          return e.onAdd(t);
        });
      },
      removeChildren: function removeChildren(t, e) {
        var n = this,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = this.domc,
          o = this.em,
          a = i ? i.allById() : {};
        if (!r.temporary) {
          var s = t.getId(),
            l = o.get("SelectorManager").getAll(),
            c = o.get("CssComposer").getAll();
          delete a[s];
          var u = c.remove(c.filter(function (t) {
            return t.getSelectors().getFullString() === "#".concat(s);
          }));
          if (l.remove(u.map(function (t) {
            return t.getSelectors().at(0);
          })), !t.opt.temporary) {
            var d = o.get("Commands"),
              h = t.get("style-signature"),
              f = {
                target: t
              };
            h && d.run("core:component-style-clear", f), t.removed(), o.trigger("component:remove", t);
          }
          var p = t.components();
          p.forEach(function (t) {
            return n.removeChildren(t, e, r);
          });
        }
        var g = t.components(),
          v = o.get("UndoManager");
        o.stopListening(g), o.stopListening(t), o.stopListening(t.get("classes")), v.remove(t), v.remove(g);
      },
      model: function model(t, e) {
        var n,
          r = e.collection.opt,
          i = r.em,
          o = i.get("DomComponents").componentTypes;
        e.em = i, e.config = r.config, e.componentTypes = o, e.domc = r.domc;
        for (var a = 0; a < o.length; a++) {
          if (o[a].id == t.type) {
            n = o[a].model;
            break;
          }
        }
        return n || (n = o[o.length - 1].model, i && t.type && i.logWarning("Component type '".concat(t.type, "' not found"), {
          attrs: t,
          options: e
        })), new n(t, e);
      },
      parseString: function parseString(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = this.em,
          o = this.opt.domc,
          a = i.get("CssComposer"),
          s = i.get("Parser").parseHtml(t);
        return r || (r = n(5).default), r.checkId(s.html, s.css, o.componentsById), s.css && a && !e.temporary && a.addCollection(s.css, h(h({}, e), {}, {
          extend: 1
        })), s.html;
      },
      add: function add(t) {
        var e = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        Object(u.isString)(t) ? t = this.parseString(t, n) : Object(u.isArray)(t) && t.forEach(function (r, i) {
          if (Object(u.isString)(r)) {
            var o = e.parseString(r, n);
            t[i] = Object(u.isArray)(o) && !o.length ? null : o;
          }
        });
        var r = Object(u.isArray)(t);
        return t = (r ? t : [t]).filter(function (t) {
          return t;
        }).map(function (t) {
          return e.processDef(t);
        }), t = r ? t : t[0], c.a.Collection.prototype.add.apply(this, [t, n]);
      },
      processDef: function processDef(t) {
        if (t.cid && t.ccid) return t;
        var e = this.em,
          n = this.config,
          r = (void 0 === n ? {} : n).processor,
          i = t;
        if (r) {
          var a = r(i = h({}, i));
          a && (Object(u.each)(i, function (t, e) {
            return delete i[e];
          }), Object(u.extend)(i, a));
        }
        if (i.$$typeof && "object" == o()(i.props)) {
          (i = h({}, i)).props = h({}, i.props);
          var s = e.get("DomComponents"),
            l = e.get("Parser").parserHtml;
          Object(u.each)(i, function (t, e) {
            Object(u.includes)(["props", "type"], e) || delete i[e];
          });
          var c = i.props,
            d = c.children;
          delete c.children, delete i.props;
          var f = l.splitPropsFromAttr(c);
          i.attributes = f.attrs, d && (i.components = d), i.type ? s.getType(i.type) || (i.tagName = i.type, delete i.type) : i.type = "textnode", Object(u.extend)(i, f.props);
        }
        return i;
      },
      onAdd: function onAdd(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = this.domc,
          i = this.em,
          o = t.getStyle(),
          a = i && i.getConfig("avoidInlineStyle");
        if (r && r.Component.ensureInList(t), !Object(u.isEmpty)(o) && !a && i && i.get && i.getConfig("forceClass") && !n.temporary) {
          var s = t.cid;
          i.get("CssComposer").setClassRule(s, o);
          t.setStyle({}), t.addClass(s);
        }
      }
    });
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
      i = n.n(r);
    i.a.$;
    e.default = i.a.View.extend({
      initialize: function initialize(t) {
        this.config = t || {}, this.editorModel = this.em = this.config.em || {}, this.pfx = this.config.stylePrefix, this.ppfx = this.config.pStylePrefix, this.hoverClass = this.pfx + "hover", this.badgeClass = this.pfx + "badge", this.plhClass = this.pfx + "placeholder", this.freezClass = this.ppfx + "freezed", this.canvas = this.em.get && this.em.get("Canvas"), this.em.get && this.setElement(this.getCanvas()), this.canvas && (this.$canvas = this.$el, this.canvasTool = this.getCanvasTools()), this.init(this.config);
      },
      onFrameScroll: function onFrameScroll(t) {},
      getCanvas: function getCanvas() {
        return this.canvas ? this.canvas.getElement() : null;
      },
      getCanvasBody: function getCanvasBody() {
        return this.canvas.getBody();
      },
      getCanvasWrapper: function getCanvasWrapper() {
        return this.canvas.getWrapperEl();
      },
      getCanvasTools: function getCanvasTools() {
        return this.canvas.getToolsEl();
      },
      offset: function offset(t) {
        var e = t.getBoundingClientRect();
        return {
          top: e.top + t.ownerDocument.body.scrollTop,
          left: e.left + t.ownerDocument.body.scrollLeft
        };
      },
      init: function init(t) {},
      callRun: function callRun(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = this.id;
        if (t.trigger("run:".concat(n, ":before"), e), !e || !e.abort) {
          var r = e.sender || t,
            i = this.run(t, r, e);
          return t.trigger("run:".concat(n), i, e), t.trigger("run", n, i, e), i;
        }
        t.trigger("abort:".concat(n), e);
      },
      callStop: function callStop(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = this.id,
          r = e.sender || t;
        t.trigger("stop:".concat(n, ":before"), e);
        var i = this.stop(t, r, e);
        return t.trigger("stop:".concat(n), i, e), t.trigger("stop", n, i, e), i;
      },
      stopCommand: function stopCommand() {
        this.em.get("Commands").stop(this.id);
      },
      run: function run(t, e) {},
      stop: function stop(t, e) {}
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(2),
      i = n.n(r),
      o = n(0),
      a = n(3),
      s = n(29);
    function l(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function c(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? l(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var u = Object(s.a)().parseStyle;
    e.a = {
      parseStyle: u,
      extendStyle: function extendStyle(t) {
        return c(c({}, this.getStyle()), t);
      },
      getStyle: function getStyle() {
        return c({}, this.get("style") || {});
      },
      setStyle: function setStyle() {
        var t = this,
          e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        Object(o.isString)(e) && (e = u(e));
        var r = this.getStyle(),
          i = c({}, e);
        this.set("style", i, n);
        var s = Object(a.w)(r, i);
        return Object(o.keys)(s).forEach(function (e) {
          var n = t.em;
          t.trigger("change:style:".concat(e)), n && (n.trigger("styleable:change", t, e), n.trigger("styleable:change:".concat(e), t, e));
        }), i;
      },
      addStyle: function addStyle(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        "string" == typeof t ? t = {
          prop: e
        } : n = e || {}, t = this.extendStyle(t), this.setStyle(t, n);
      },
      removeStyle: function removeStyle(t) {
        var e = this.getStyle();
        delete e[t], this.setStyle(e);
      },
      styleToString: function styleToString() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = [],
          n = this.getStyle();
        for (var r in n) {
          var i = t.important,
            a = Object(o.isArray)(i) ? i.indexOf(r) >= 0 : i,
            s = "".concat(n[r]).concat(a ? " !important" : ""),
            l = "__" == r.substr(0, 2);
          s && !l && e.push("".concat(r, ":").concat(s, ";"));
        }
        return e.join("");
      },
      getSelectors: function getSelectors() {
        return this.get("selectors") || this.get("classes");
      },
      getSelectorsString: function getSelectorsString() {
        return this.selectorsToString ? this.selectorsToString() : this.getSelectors().getFullString();
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(1),
      a = n.n(o),
      s = n(30),
      l = n(0),
      c = n(3);
    function u(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function d(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? u(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var h = a.a.Model.extend({
        defaults: {
          name: "",
          property: "",
          type: "",
          defaults: "",
          info: "",
          value: "",
          icon: "",
          functionName: "",
          status: "",
          visible: !0,
          fixedValues: ["initial", "inherit"],
          full: 0,
          important: 0,
          toRequire: 0,
          requires: null,
          requiresParent: null
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.get("id") || "",
            r = this.get("name") || "";
          !this.get("property") && this.set("property", (r || n).replace(/ /g, "-"));
          var i = this.get("property");
          !this.get("id") && this.set("id", i), !r && this.set("name", Object(c.c)(i).replace(/-/g, " ")), h.callInit(this, t, e);
        },
        init: function init() {},
        clearValue: function clearValue() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.set({
            value: void 0,
            status: ""
          }, t), this;
        },
        setValue: function setValue(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.parseValue(t),
            i = !e;
          !i && this.set({
            value: void 0
          }, {
            avoidStore: i,
            silent: !0
          }), this.set(r, d({
            avoidStore: i
          }, n));
        },
        setValueFromInput: function setValueFromInput(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.setValue(t, e, d(d({}, n), {}, {
            fromInput: 1
          }));
        },
        parseValue: function parseValue(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = {
              value: t
            },
            r = "!important";
          if (Object(l.isString)(t) && -1 !== t.indexOf(r) && (n.value = t.replace(r, "").trim(), n.important = 1), !this.get("functionName") && !e.complete) return n;
          var i = [],
            o = "".concat(n.value),
            a = o.indexOf("(") + 1,
            s = o.lastIndexOf(")"),
            c = o.substring(0, a - 1);
          if (c && (n.functionName = c), i.push(a), s >= 0 && i.push(s), n.value = String.prototype.substring.apply(o, i), e.numeric) {
            var u = parseFloat(n.value);
            n.unit = n.value.replace(u, ""), n.value = u;
          }
          return n;
        },
        splitValues: function splitValues(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",",
            n = [],
            r = "(",
            i = ")",
            o = "",
            a = 0;
          return (t || "").split("").forEach(function (t) {
            t == r ? (a++, o += r) : t == i && a > 0 ? (a--, o += i) : t === e && 0 == a ? (n.push(o), o = "") : o += t;
          }), "" !== o && n.push(o), n.map(function (t) {
            return t.trim();
          });
        },
        getDefaultValue: function getDefaultValue() {
          return this.get("defaults");
        },
        getFullValue: function getFullValue(t) {
          var e = this.get("functionName"),
            n = this.getDefaultValue(),
            r = Object(l.isUndefined)(t) ? this.get("value") : t,
            i = !Object(l.isUndefined)(r) && "" !== r;
          if (r && n && r === n) return n;
          if (e && i) {
            var o = "url" === e ? "'".concat(r.replace(/'/g, ""), "'") : r;
            r = "".concat(e, "(").concat(o, ")");
          }
          return i && this.get("important") && (r = "".concat(r, " !important")), r || "";
        }
      }, {
        callParentInit: function callParentInit(t, e, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          t.prototype.initialize.apply(e, [n, d(d({}, r), {}, {
            skipInit: 1
          })]);
        },
        callInit: function callInit(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          !n.skipInit && t.init(e, n);
        }
      }),
      f = h;
    function p(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function g(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? p(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var v = f.extend({
        defaults: g(g({}, f.prototype.defaults), {}, {
          detached: 0,
          properties: [],
          separator: " "
        }),
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          f.callParentInit(f, this, t, e);
          var r = this.get("properties") || [],
            i = n(24).default;
          this.set("properties", new i(r)), this.listenTo(this, "change:value", this.updateValues), f.callInit(this, t, e);
        },
        clearValue: function clearValue() {
          return this.get("properties").each(function (t) {
            return t.clearValue();
          }), f.prototype.clearValue.apply(this, arguments);
        },
        updateValues: function updateValues() {
          var t = this.getFullValue().split(this.getSplitSeparator());
          this.get("properties").each(function (e, n) {
            var r = t.length;
            t[n] || t[n % r + (1 != r && r % 2 ? 1 : 0)];
          });
        },
        getSplitSeparator: function getSplitSeparator() {
          return new RegExp("".concat(this.get("separator"), "(?![^\\(]*\\))"));
        },
        getDefaultValue: function getDefaultValue(t) {
          var e = this.get("defaults");
          return e && !t ? e : (e = "", this.get("properties").each(function (t, n) {
            return e += "".concat(t.getDefaultValue(), " ");
          }), e.trim());
        },
        getFullValue: function getFullValue() {
          return this.get("detached") ? "" : this.get("properties").getFullValue();
        },
        getPropertyAt: function getPropertyAt(t) {
          return this.get("properties").at(t);
        }
      }),
      m = a.a.Model.extend({
        defaults: {
          index: "",
          value: "",
          values: {},
          active: !1,
          preview: !1,
          properties: []
        },
        initialize: function initialize() {
          var t = this.get("properties"),
            e = this.get("value");
          this.set("properties", t instanceof yt ? t : new yt(t));
          var n = this.get("properties");
          if (n.forEach(this.onPropAdd, this), this.listenTo(n, "add", this.onPropAdd), !e) {
            var r = "",
              i = this.get("values");
            for (var o in i) r += " " + i[o];
            this.set("value", r.trim());
          }
        },
        onPropAdd: function onPropAdd(t) {
          var e = this.collection;
          t.parent = e && e.property;
        },
        getPropertyAt: function getPropertyAt(t) {
          return this.get("properties").at(t);
        },
        getPropertyValue: function getPropertyValue(t) {
          var e = "";
          return this.get("properties").each(function (n) {
            n.get("property") == t && (e = n.getFullValue());
          }), e;
        },
        getFullValue: function getFullValue() {
          var t = [];
          return this.get("properties").each(function (e) {
            return t.push(e.getFullValue());
          }), t.join(" ").trim();
        }
      });
    function b(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function y(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? b(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var w = a.a.Collection.extend({
      model: m,
      initialize: function initialize() {
        this.idx = 1, this.on("add", this.onAdd), this.on("reset", this.onReset);
      },
      onAdd: function onAdd(t, e, n) {
        n.noIncrement || t.set("index", this.idx++), n.active && this.active(this.indexOf(t));
      },
      onReset: function onReset() {
        this.idx = 1;
      },
      getSeparator: function getSeparator() {
        var t = this.property;
        return t ? t.get("layerSeparator") : ", ";
      },
      getLayersFromValue: function getLayersFromValue(t) {
        var e = this,
          n = [];
        return t.replace(/\(([\w\s,.]*)\)/g, function (e) {
          var n = e.replace(/,\s*/g, ",");
          t = t.replace(e, n);
        }), (t ? t.split(this.getSeparator()) : []).forEach(function (t) {
          n.push({
            properties: e.properties.parseValue(t)
          });
        }), n;
      },
      getLayersFromStyle: function getLayersFromStyle(t) {
        var e = [],
          n = this.properties;
        return n.each(function (n) {
          var r = t[n.get("property")];
          (r ? r.split(", ") : []).forEach(function (t, r) {
            t = n.parseValue(t.trim()).value;
            var i = e[r],
              o = y(y({}, n.attributes), {
                value: t
              });
            i ? i.properties.push(o) : e[r] = {
              properties: [o]
            };
          });
        }), e.forEach(function (t) {
          var e = t.properties.map(function (t) {
            return t.property;
          });
          n.each(function (n) {
            var r = n.get("property");
            e.indexOf(r) < 0 && t.properties.push(y({}, n.attributes));
          });
        }), e;
      },
      active: function active(t) {
        this.each(function (t) {
          return t.set("active", 0);
        });
        var e = this.at(t);
        e && e.set("active", 1);
      },
      getFullValue: function getFullValue() {
        var t = [];
        return this.each(function (e) {
          return t.push(e.getFullValue());
        }), t.join(this.getSeparator());
      },
      getPropertyValues: function getPropertyValues(t, e) {
        var n = [];
        return this.each(function (r) {
          var i = r.getPropertyValue(t);
          i ? n.push(i) : !Object(l.isUndefined)(e) && n.push(e);
        }), n.join(", ");
      }
    });
    function x(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function O(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? x(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var C = v.extend({
        defaults: O(O({}, v.prototype.defaults), {}, {
          layers: [],
          layerSeparator: ", ",
          prepend: 0,
          preview: 0
        }),
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          v.callParentInit(v, this, t, e);
          var n = this.get("layers"),
            r = new w(n);
          r.property = this, r.properties = this.get("properties"), this.set("layers", r), v.callInit(this, t, e);
        },
        getLayers: function getLayers() {
          return this.get("layers");
        },
        getCurrentLayer: function getCurrentLayer() {
          return this.getLayers().filter(function (t) {
            return t.get("active");
          })[0];
        },
        getFullValue: function getFullValue() {
          return this.get("detached") ? "" : this.get("layers").getFullValue();
        },
        getValueFromStyle: function getValueFromStyle() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.getLayers().getLayersFromStyle(t);
          return new w(e).getFullValue();
        },
        clearValue: function clearValue() {
          return this.getLayers().reset(), v.prototype.clearValue.apply(this, arguments);
        },
        getValueFromTarget: function getValueFromTarget(t) {
          var e = this.attributes,
            n = e.detached,
            r = e.property,
            i = e.properties,
            o = t.getStyle(),
            a = {};
          return i.forEach(function (t) {
            var e = t.get("property"),
              n = o[e];
            n && (a[e] = n);
          }), n ? Object(l.keys)(a).length ? a : "" : o[r];
        },
        getLayersFromTarget: function getLayersFromTarget(t) {}
      }),
      S = n(25),
      k = n.n(S),
      j = ["status", "value"],
      T = ["complete"];
    function P(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function E(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? P(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : P(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var D = a.a.View.extend({
      template: function template() {
        var t = this.pfx,
          e = this.ppfx;
        return '\n      <div class="'.concat(t, 'label" data-sm-label></div>\n      <div class="').concat(e, 'fields" data-sm-fields></div>\n    ');
      },
      templateLabel: function templateLabel(t) {
        var e = this.pfx,
          n = this.em,
          r = t.parent,
          i = t.attributes,
          o = i.icon,
          a = void 0 === o ? "" : o,
          s = i.info,
          l = void 0 === s ? "" : s,
          c = i.id,
          u = i.name,
          d = n && n.t("styleManager.properties.".concat(c)) || u;
        return '\n      <span class="'.concat(e, "icon ").concat(a, '" title="').concat(l, '">\n        ').concat(d, "\n      </span>\n      ").concat(r ? "" : '<b class="'.concat(e, 'clear" ').concat("data-clear-style", ">&Cross;</b>"), "\n    ");
      },
      templateInput: function templateInput(t) {
        return '\n      <div class="'.concat(this.ppfx, 'field">\n        <input placeholder="').concat(t.getDefaultValue(), '"/>\n      </div>\n    ');
      },
      events: i()({
        change: "inputValueChanged"
      }, "click [".concat("data-clear-style", "]"), "clear"),
      initialize: function initialize() {
        var t = this,
          e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        Object(l.bindAll)(this, "targetUpdated", "__change", "__updateStyle"), this.config = e.config || {};
        var n = this.config.em;
        this.em = n, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.target = e.target || {}, this.propTarget = e.propTarget || {}, this.onChange = e.onChange, this.onInputRender = e.onInputRender || {}, this.customValue = e.customValue || {};
        var r = this.model;
        this.property = r.get("property"), this.input = null;
        var i = this.pfx;
        this.inputHolderId = "#" + i + "input-holder", this.sector = r.collection && r.collection.sector, this.__destroyFn = this.destroy ? this.destroy.bind(this) : function () {}, r.view = this, r.get("value") || r.set("value", r.getDefaultValue()), n && n.on("update:component:style:".concat(this.property), this.targetUpdated);
        var o = r.get("requires");
        o && Object.keys(o).forEach(function (e) {
          n && n.on("component:styleUpdate:".concat(e), t.targetUpdated);
        }), this.listenTo(this.propTarget, "update styleManager:update", this.targetUpdated), this.listenTo(r, "destroy remove", this.remove), this.listenTo(r, "change:value", this.modelValueChanged), this.listenTo(r, "targetUpdated", this.targetUpdated), this.listenTo(r, "change:visible", this.updateVisibility), this.listenTo(r, "change:status", this.updateStatus), this.listenTo(r, "change:name change:className change:full", this.render);
        var a = this.init && this.init.bind(this);
        a && a();
      },
      remove: function remove() {
        a.a.View.prototype.remove.apply(this, arguments), this.__destroyFn(this._getClbOpts());
      },
      updateStatus: function updateStatus() {
        var t = this.model,
          e = t.get("status"),
          n = t.parent,
          r = this.pfx,
          i = this.ppfx,
          o = this.config,
          a = "".concat(i, "four-color"),
          s = "".concat(i, "color-warn"),
          l = this.$el.children(".".concat(r, "label")),
          c = this.getClearEl(),
          u = c ? c.style : {};
        switch (l.removeClass("".concat(a, " ").concat(s)), u.display = "none", e) {
          case "updated":
            !n && l.addClass(a), o.clearProperties && (u.display = "inline");
            break;
          case "computed":
            l.addClass(s);
        }
      },
      clear: function clear(t) {
        var e = this;
        t && t.stopPropagation(), this.model.clearValue(), setTimeout(function () {
          return e.targetUpdated();
        });
      },
      getClearEl: function getClearEl() {
        return this.clearEl || (this.clearEl = this.el.querySelector("[".concat("data-clear-style", "]"))), this.clearEl;
      },
      getTarget: function getTarget() {
        return this.getTargetModel();
      },
      getTargets: function getTargets() {
        return this.propTarget.targets || [this.getTarget()];
      },
      getTargetModel: function getTargetModel() {
        return this.propTarget && this.propTarget.model;
      },
      getHelperModel: function getHelperModel() {
        return this.propTarget && this.propTarget.helper;
      },
      inputValueChanged: function inputValueChanged(t) {
        t && t.stopPropagation(), this.emit || (this.model.setValueFromInput(this.getInputValue()), this.elementUpdated());
      },
      elementUpdated: function elementUpdated() {
        this.setStatus("updated");
      },
      setStatus: function setStatus(t) {
        this.model.set("status", t);
        var e = this.model.parent;
        e && "updated" == t && e.set("status", t);
      },
      emitUpdateTarget: Object(l.debounce)(function () {
        var t = this.config.em;
        t && t.trigger("styleManager:update:target", this.getTarget());
      }),
      _getTargetData: function _getTargetData() {
        var t = this.model,
          e = this.config,
          n = this.getTargetValue({
            ignoreDefault: 1
          }),
          r = t.getDefaultValue(),
          i = this.getComputedValue(),
          o = "",
          a = "";
        return n ? (o = n, e.highlightChanged && (a = "updated")) : i && e.showComputed && i != r ? (o = i, e.highlightComputed && (a = "computed")) : (o = r, a = ""), {
          value: o,
          status: a,
          targetValue: n,
          defaultValue: r,
          computedValue: i
        };
      },
      targetUpdated: function targetUpdated(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (!this.config.fromLayer && (this.emitUpdateTarget(), this.checkVisibility())) {
          var r = this.config,
            i = r.em,
            o = this.model,
            a = o.get("property"),
            s = this._getTargetData(),
            l = s.status,
            c = s.value,
            u = k()(s, j),
            d = E({
              status: l,
              value: c
            }, u);
          return this.setStatus(l), o.setValue(c, 0, E({
            fromTarget: 1
          }, n)), i && (i.trigger("styleManager:change", this, a, c, d), i.trigger("styleManager:change:".concat(a), this, c, d), this._emitUpdate(d)), d;
        }
      },
      _emitUpdate: function _emitUpdate() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = this.em,
          n = this.model;
        if (e) {
          var r = n.get("property"),
            i = E(E({}, this._getEventData()), t),
            o = i.id;
          e.trigger("style:update", i), e.trigger("style:update:".concat(r), i), r !== o && e.trigger("style:update:".concat(o), i);
        }
      },
      _getEventData: function _getEventData() {
        var t = this.model;
        return {
          propertyView: this,
          targets: this.getTargets(),
          value: t.getFullValue(),
          property: t,
          id: t.get("id"),
          name: t.get("property")
        };
      },
      checkVisibility: function checkVisibility() {
        var t = 1;
        return this.config.hideNotStylable && (this.isTargetStylable() && this.isComponentStylable() ? this.show() : (this.hide(), t = 0), this.sector && this.sector.trigger("updateVisibility")), t;
      },
      getTargetValue: function getTargetValue() {
        var t,
          e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = this.model,
          r = this.getTargetModel(),
          i = this.customValue;
        if (!r) return t;
        if ((t = r.getStyle()[n.get("property")]) || e.ignoreDefault || (t = n.getDefaultValue()), "function" == typeof i && !e.ignoreCustomValue) {
          var o = n.collection.indexOf(n),
            a = i(this, o, t);
          a && (t = a);
        }
        return t;
      },
      getComputedValue: function getComputedValue() {
        var t = this.propTarget,
          e = t.computed || {},
          n = t.computedDefault || {},
          r = this.config.avoidComputed || [],
          i = this.model.get("property"),
          o = r.indexOf(i) < 0,
          a = e[i],
          s = n[Object(c.b)(i)];
        return e && o && s !== a && a || "";
      },
      getInputValue: function getInputValue() {
        var t = this.getInputEl();
        return t ? t.value : "";
      },
      modelValueChanged: function modelValueChanged(t, e) {
        var n = this,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = this.model,
          o = i.getFullValue();
        r.fromInput || this.setValue(o), r.fromTarget || this.getTargets().forEach(function (t) {
          return n.__updateTarget(t, r);
        });
      },
      __updateTarget: function __updateTarget(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = this.model,
          r = this.config.em,
          i = n.get("property"),
          o = n.getFullValue(),
          a = this.onChange;
        if (t && this.isTargetStylable(t) && this.isComponentStylable()) {
          e.fromTarget || (a && !e.fromParent ? a(t, this, e) : this.updateTargetStyle(o, null, E(E({}, e), {}, {
            target: t
          })));
          var s = r && r.getSelected();
          r && s && (!e.noEmit && r.trigger("component:update", s), r.trigger("component:styleUpdate", s, i), r.trigger("component:styleUpdate:".concat(i), s)), this._emitUpdate();
        }
      },
      updateTargetStyle: function updateTargetStyle(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = e || this.model.get("property"),
          i = n.target || this.getTarget(),
          o = i.getStyle();
        t ? o[r] = t : delete o[r], n.avoidStore ? o.__ = 1 : delete o.__, i.setStyle(o, n);
        var a = this.getHelperModel();
        a && a.setStyle(o, n);
      },
      isTargetStylable: function isTargetStylable(t) {
        var e = t || this.getTarget(),
          n = this.model,
          r = n.get("id"),
          i = n.get("property"),
          o = n.get("toRequire"),
          a = e.get("unstylable"),
          s = e.get("stylable-require"),
          c = n.get("requires"),
          u = n.get("requiresParent"),
          d = this.sector ? this.sector.collection : null,
          h = this.em ? this.em.getSelected() : null,
          f = e.get("stylable");
        if (Object(l.isArray)(f) && (f = f.indexOf(i) >= 0), Object(l.isArray)(a) && (f = a.indexOf(i) < 0), o && (f = !t || s && (s.indexOf(r) >= 0 || s.indexOf(i) >= 0)), d && c) {
          var p = Object.keys(c);
          d.each(function (t) {
            t.get("properties").each(function (t) {
              if (Object(l.includes)(p, t.id)) {
                var e = c[t.id];
                f = f && Object(l.includes)(e, t.get("value"));
              }
            });
          });
        }
        if (u) {
          var g = h && h.parent(),
            v = g && g.getEl();
          if (v) {
            var m = window.getComputedStyle(v);
            Object(l.each)(u, function (t, e) {
              f = f && m[e] && Object(l.includes)(t, m[e]);
            });
          } else f = !1;
        }
        return f;
      },
      isComponentStylable: function isComponentStylable() {
        var t = this.em,
          e = t && t.getSelected();
        return !e || this.isTargetStylable(e);
      },
      setRawValue: function setRawValue(t) {
        this.setValue(this.model.parseValue(t));
      },
      setValue: function setValue(t) {
        var e = this.model,
          n = Object(l.isUndefined)(t) ? e.getDefaultValue() : t;
        if (this.update) return this.__update(n);
        var r = this.getInputEl();
        r && (r.value = n);
      },
      getInputEl: function getInputEl() {
        return this.input || (this.input = this.el.querySelector("input")), this.input;
      },
      updateVisibility: function updateVisibility() {
        this.el.style.display = this.model.get("visible") ? "block" : "none";
      },
      show: function show() {
        this.model.set("visible", 1);
      },
      hide: function hide() {
        this.model.set("visible", 0);
      },
      cleanValue: function cleanValue() {
        this.setValue("");
      },
      clearCached: function clearCached() {
        this.clearEl = null, this.input = null, this.$input = null;
      },
      __update: function __update(t) {
        var e = this.update && this.update.bind(this);
        e && e(E(E({}, this._getClbOpts()), {}, {
          value: t
        }));
      },
      __change: function __change() {
        for (var t = this.emit && this.emit.bind(this), e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
        t && t.apply(void 0, [this._getClbOpts()].concat(n));
      },
      __updateStyle: function __updateStyle(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = e.complete,
          r = k()(e, T),
          i = !1 !== n;
        Object(c.n)(t) ? this.getTargets().forEach(function (e) {
          return e.addStyle(t, {
            avoidStore: !i
          });
        }) : this.model.setValueFromInput(t, n, r), i && this.elementUpdated();
      },
      _getClbOpts: function _getClbOpts() {
        var t = this.model;
        return {
          el: this.el,
          props: t.attributes,
          setProps: function setProps() {
            return t.set.apply(t, arguments);
          },
          change: this.__change,
          updateStyle: this.__updateStyle,
          targets: this.getTargets()
        };
      },
      render: function render() {
        this.clearCached();
        var t = this.pfx,
          e = this.model,
          n = this.el,
          r = this.$el,
          i = e.get("property"),
          o = e.get("full"),
          a = e.get("className") || "",
          s = "".concat(t, "property");
        this.createdEl && this.__destroyFn(this._getClbOpts()), r.empty().append(this.template(e)), r.find("[data-sm-label]").append(this.templateLabel(e));
        var l = this.create && this.create.bind(this);
        this.createdEl = l && l(this._getClbOpts()), r.find("[data-sm-fields]").append(this.createdEl || this.templateInput(e)), n.className = "".concat(s, " ").concat(t).concat(e.get("type"), " ").concat(s, "__").concat(i, " ").concat(a).trim(), n.className += o ? " ".concat(s, "--full") : "", this.updateStatus();
        var c = this.onRender && this.onRender.bind(this);
        c && c(), this.setValue(e.get("value"), {
          fromTarget: 1
        });
      }
    });
    function M(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function A(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? M(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : M(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var L = a.a.$,
      N = D.extend({
        templateInput: function templateInput() {
          var t = this.pfx;
          return '\n      <div class="'.concat(t, "field ").concat(t, 'composite">\n        <span id="').concat(t, 'input-holder"></span>\n      </div>\n    ');
        },
        inputValueChanged: function inputValueChanged() {
          if (!this.model.get("detached")) {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            D.prototype.inputValueChanged.apply(this, e);
          }
        },
        clear: function clear(t) {
          var e = this.properties;
          e && e.forEach(function (t) {
            return t.clear();
          }), D.prototype.clear.apply(this, arguments);
        },
        onRender: function onRender() {
          var t = this.model,
            e = t.get("properties") || [];
          if (this.properties = [], e.length && (this.$input || (this.$input = L('<input type="hidden" value="0">'), this.input = this.$input.get(0)), this.props || (this.props = t.get("properties")), !this.$props)) {
            this.props.each(function (e, n) {
              e && "composite" == e.get("type") && (this.props.remove(e), console.warn("Nested composite types not yet allowed.")), e.parent = t;
            }, this);
            var r = new (0, n(19).default)(this.getPropsConfig());
            this.$props = r.render().$el, this.properties = r.properties, this.$el.find("#".concat(this.pfx, "input-holder")).append(this.$props);
          }
        },
        getPropsConfig: function getPropsConfig(t) {
          var e = this,
            n = this.model,
            r = {
              config: A(A({}, this.config), {}, {
                highlightComputed: 0
              }),
              collection: this.props,
              target: this.target,
              propTarget: this.propTarget,
              onChange: function onChange(t, e, r) {
                n.set("value", n.getFullValue(), r);
              },
              customValue: function customValue(t, n) {
                return e.valueOnIndex(n, t);
              }
            };
          return n.get("detached") && delete r.onChange, r;
        },
        valueOnIndex: function valueOnIndex(t, e) {
          var n,
            r = this.getTargetValue({
              ignoreDefault: 1
            });
          r ? n = r.split(this.model.getSplitSeparator())[t] : n = e && e.getTargetValue({
            ignoreCustomValue: 1,
            ignoreDefault: 1
          });
          return n;
        },
        clearCached: function clearCached() {
          D.prototype.clearCached.apply(this, arguments), this.$input = null, this.props = null, this.$props = null;
        }
      }),
      _ = n(19);
    function I(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function F(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? I(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var V = a.a.View.extend({
        events: {
          click: "active",
          "click [data-close-layer]": "removeItem",
          "mousedown [data-move-layer]": "initSorter",
          "touchstart [data-move-layer]": "initSorter"
        },
        template: function template(t) {
          var e = this.pfx,
            n = this.ppfx,
            r = this.em,
            i = "".concat(r && r.t("styleManager.layer"), " ").concat(t.get("index"));
          return '\n      <div id="'.concat(e, 'move" class="').concat(n, 'no-touch-actions" data-move-layer>\n        <i class="fa fa-arrows"></i>\n      </div>\n      <div id="').concat(e, 'label">').concat(i, '</div>\n      <div id="').concat(e, 'preview-box">\n      \t<div id="').concat(e, 'preview" data-preview></div>\n      </div>\n      <div id="').concat(e, 'close-layer" class="').concat(e, 'btn-close" data-close-layer>\n        &Cross;\n      </div>\n      <div id="').concat(e, 'inputs" data-properties></div>\n      <div style="clear:both"></div>\n    ');
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model;
          this.stackModel = t.stackModel, this.config = t.config || {}, this.em = this.config.em, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.sorter = t.sorter || null, this.propsConfig = t.propsConfig || {}, this.customPreview = t.onPreview, this.listenTo(e, "destroy remove", this.remove), this.listenTo(e, "change:active", this.updateVisibility), this.listenTo(e.get("properties"), "change", this.updatePreview), e.view = this, e.set({
            droppable: 0,
            draggable: 1
          }), this.$el.data("model", e);
        },
        initSorter: function initSorter(t) {
          this.sorter && this.sorter.startSort(this.el);
        },
        removeItem: function removeItem(t) {
          t && t.stopPropagation(), this.remove();
        },
        remove: function remove() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model,
            n = this.props,
            r = e.collection,
            i = this.stackModel;
          a.a.View.prototype.remove.apply(this, arguments), r && r.contains(e) && r.remove(e), i && i.set && (i.set({
            stackIndex: null
          }, {
            silent: !0
          }), !t.fromTarget && i.trigger("updateValue")), n && n.remove();
        },
        onPreview: function onPreview(t) {
          var e = this.stackModel,
            n = e && e.get("detached"),
            r = t.split(" "),
            i = [],
            o = {};
          return this.model.get("properties").each(function (t, e) {
            var a = t.get("property"),
              s = n ? t.getFullValue() : r[e] || "";
            if (s && "integer" == t.get("type")) {
              var l = parseInt(s, 10),
                c = s.replace(l, "");
              s = (l = (l = (l = isNaN(l) ? 0 : l) > 3 ? 3 : l) < -3 ? -3 : l) + c;
            }
            i.push(s), o[a] = s;
          }), n ? o : i.join(" ");
        },
        updatePreview: function updatePreview() {
          var t = this.stackModel,
            e = this.customPreview,
            n = this.getPreviewEl(),
            r = this.model.getFullValue(),
            i = e ? e(r) : this.onPreview(r);
          if (i && t && n) {
            var o = n.style;
            if (Object(l.isString)(i)) o[t.get("property")] = i;else {
              var a = [];
              Object(l.each)(i, function (t, e) {
                return a.push("".concat(e, ":").concat(t));
              }), n.setAttribute("style", a.join(";"));
            }
          }
        },
        getPropertiesWrapper: function getPropertiesWrapper() {
          return this.propsWrapEl || (this.propsWrapEl = this.el.querySelector("[data-properties]")), this.propsWrapEl;
        },
        getPreviewEl: function getPreviewEl() {
          return this.previewEl || (this.previewEl = this.el.querySelector("[data-preview]")), this.previewEl;
        },
        active: function active() {
          var t = this.model,
            e = t.collection;
          e.active(e.indexOf(t));
        },
        updateVisibility: function updateVisibility() {
          var t = this.pfx,
            e = this.getPropertiesWrapper(),
            n = this.model.get("active");
          e.style.display = n ? "" : "none", this.$el[n ? "addClass" : "removeClass"]("".concat(t, "active"));
        },
        render: function render() {
          var t = this.propsConfig,
            e = this.model,
            n = this.el,
            r = this.pfx,
            i = e.get("preview"),
            o = new _.default({
              collection: e.get("properties"),
              config: F(F({}, this.config), {}, {
                fromLayer: 1
              }),
              target: t.target,
              customValue: t.customValue,
              propTarget: t.propTarget,
              onChange: t.onChange
            }),
            a = o.render().el;
          return n.innerHTML = this.template(e), n.className = "".concat(r, "layer").concat(i ? "" : " ".concat(r, "no-preview")), this.props = o, this.getPropertiesWrapper().appendChild(a), this.updateVisibility(), this.updatePreview(), this;
        }
      }),
      R = a.a.View.extend({
        initialize: function initialize(t) {
          this.config = t.config || {}, this.stackModel = t.stackModel, this.preview = t.preview, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.propsConfig = t.propsConfig;
          var e = this.pfx,
            n = this.ppfx,
            r = this.collection;
          this.className = "".concat(e, "layers ").concat(n, "field"), this.listenTo(r, "add", this.addTo), this.listenTo(r, "deselectAll", this.deselectAll), this.listenTo(r, "reset", this.reset), this.items = [];
          var i = this.config.em || "",
            o = i ? i.get("Utils") : "";
          this.sorter = o ? new o.Sorter({
            container: this.el,
            ignoreViewChildren: 1,
            containerSel: ".".concat(e, "layers"),
            itemSel: ".".concat(e, "layer"),
            pfx: this.config.pStylePrefix
          }) : "", r.view = this, this.$el.data("model", r), this.$el.data("collection", r);
        },
        addTo: function addTo(t) {
          var e = this.collection.indexOf(t);
          this.addToCollection(t, null, e);
        },
        addToCollection: function addToCollection(t, e, n) {
          var r = e || null,
            i = this.stackModel,
            o = this.config,
            a = this.sorter,
            s = this.propsConfig;
          void 0 !== this.preview && t.set("preview", this.preview);
          var l = new V({
              model: t,
              config: o,
              sorter: a,
              stackModel: i,
              propsConfig: s
            }),
            c = l.render().el;
          if (this.items.push(l), r) r.appendChild(c);else if (void 0 !== n) {
            var u = "before";
            this.$el.children().length == n && (n--, u = "after"), n < 0 ? this.$el.append(c) : this.$el.children().eq(n)[u](c);
          } else this.$el.append(c);
          return c;
        },
        deselectAll: function deselectAll() {
          this.$el.find("." + this.pfx + "layer").removeClass(this.pfx + "active");
        },
        reset: function reset(t, e) {
          this.clearItems(e), this.render();
        },
        render: function render() {
          var t = document.createDocumentFragment();
          return this.$el.empty(), this.collection.each(function (e) {
            this.addToCollection(e, t);
          }, this), this.$el.append(t), this.$el.attr("class", this.className), this.sorter && (this.sorter.plh = null), this;
        },
        remove: function remove() {
          this.clearItems(), a.a.View.prototype.remove.apply(this, arguments);
        },
        clearItems: function clearItems(t) {
          this.items.forEach(function (e) {
            return e.remove(t);
          }), this.items = [];
        }
      });
    function z(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    var H = new (n(31).a)(),
      $ = N.extend({
        templateInput: function templateInput() {
          var t = this.pfx;
          this.ppfx;
          return '\n      <div class="'.concat(t, "field ").concat(t, 'stack">\n        <button type="button" id="').concat(t, 'add" data-add-layer>+</button>\n        <div data-layers-wrapper></div>\n      </div>\n    ');
        },
        init: function init() {
          var t = this.model;
          this.pfx;
          t.set("stackIndex", null), this.events["click [data-add-layer]"] = "addLayer", this.listenTo(t, "change:stackIndex", this.indexChanged), this.listenTo(t, "updateValue", this.inputValueChanged), this.delegateEvents();
          var e = this.getPropsConfig();
          this.layers = new R({
            collection: this.getLayers(),
            stackModel: t,
            preview: t.get("preview"),
            config: this.config,
            propsConfig: e
          });
          var r = n(19).default;
          this.propsView = new r({
            target: this.target,
            collection: t.get("properties"),
            stackModel: t,
            config: this.config,
            onChange: e.onChange,
            propTarget: e.propTarget
          });
        },
        targetUpdated: function targetUpdated() {
          var t,
            e = this;
          if (this.model.get("detached")) t = this._getTargetData(), this.setStatus(t.status), this.checkVisibility();else {
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
            t = N.prototype.targetUpdated.apply(this, r);
          }
          setTimeout(function () {
            return e.refreshLayers(t);
          });
        },
        getLayers: function getLayers() {
          return this.model.get("layers");
        },
        indexChanged: function indexChanged(t) {
          var e = this.model;
          this.getLayers().active(e.get("stackIndex"));
        },
        addLayer: function addLayer() {
          var t = this.model,
            e = this.getLayers(),
            n = t.get("prepend"),
            r = t.get("properties").deepClone();
          r.each(function (t) {
            return t.set("value", "");
          });
          var o = e.add({
            properties: r
          }, function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? z(Object(n), !0).forEach(function (e) {
                i()(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : z(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }
            return t;
          }({
            active: 1
          }, n && {
            at: 0
          }));
          this.inputValueChanged({
            up: 1
          }), t.set("stackIndex", e.indexOf(o));
        },
        inputValueChanged: function inputValueChanged() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model;
          t.up && this.elementUpdated(), e.get("detached") ? e.get("properties").each(function (t) {
            return t.trigger("change:value");
          }) : e.set("value", this.getLayerValues());
        },
        setValue: function setValue() {},
        getLayerValues: function getLayerValues() {
          return this.getLayers().getFullValue();
        },
        _getClassRule: function _getClassRule() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.em,
            n = t.skipAdd,
            r = void 0 === n ? 1 : n,
            i = e.getSelected(),
            o = e.get("StyleManager").getModelToStyle(i, {
              skipAdd: r,
              useClasses: 1
            });
          return o !== i && o;
        },
        _getParentTarget: function _getParentTarget(t) {
          for (var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = this.em, i = this.model, o = i.get("property"), a = n.isValid || function (t) {
              return t.getStyle()[o];
            }, s = r.get("CssComposer").getAll().filter(function (e) {
              return e.selectorsToString() === t.getSelectorsString();
            }), l = s.reduce(function (t, e) {
              return t[e.getAtRule()] = e, t;
            }, {}), c = H.sortMediaObject(l), u = c.map(function (t) {
              return t.value;
            }), d = u.indexOf(t), h = u.splice(0, d), f = h.length - 1; f > -1; f--) {
            var p = h[f];
            if (a(p)) {
              e = p;
              break;
            }
          }
          return e;
        },
        refreshLayers: function refreshLayers() {
          var t,
            e,
            n,
            r,
            i,
            o,
            a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            s = [],
            c = this.model,
            u = this.em,
            d = this.getLayers(),
            h = c.get("detached"),
            f = c.get("property"),
            p = this.getTarget(),
            g = this.getComputedValue(),
            v = u.getSelected(),
            m = {
              fromTarget: 1
            };
          if (h) {
            e = a.targetValue || {};
            var b = function b(t) {
              var e = c.get("properties").at(0).get("property");
              return t && !Object(l.isUndefined)(t.getStyle()[e]);
            };
            if (!Object(l.keys)(e).length && g && v) {
              var y = {
                isValid: function isValid(t) {
                  return b(t);
                }
              };
              (r = this._getParentTarget(p, y)) ? e = r.getStyle() : (n = this._getClassRule(), r = !(i = b(n) && n.getStyle()) && this._getParentTarget(this._getClassRule({
                skipAdd: 0
              }), y), o = b(r) && r.getStyle(), e = i || o || {});
            }
            t = e, s = d.getLayersFromStyle(e);
          } else {
            var w = this.getTargetValue({
                ignoreDefault: 1
              }),
              x = w;
            !x && g && ((r = this._getParentTarget(p)) ? x = r.getStyle()[f] : (o = (r = !(i = (n = this._getClassRule()) && n.getStyle()[f]) && this._getParentTarget(this._getClassRule({
              skipAdd: 0
            }))) && r.getStyle()[f], x = i || o || g)), t = x = x == c.getDefaultValue() ? "" : x, s = d.getLayersFromValue(x);
          }
          var O = c.getLayersFromTarget(p, {
            resultValue: t,
            layersObj: s
          }) || s;
          d.reset(null, m), d.add(O, m), c.set({
            stackIndex: null
          }, {
            silent: !0
          });
        },
        getTargetValue: function getTargetValue() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model,
            n = e.attributes.detached,
            r = this.getTarget(),
            i = N.prototype.getTargetValue.call(this, t);
          return Object(l.isUndefined)(i) && !n ? i = e.getValueFromStyle(r.getStyle()) : n && (i = e.getValueFromTarget(r)), i;
        },
        getPropsConfig: function getPropsConfig() {
          var t = this,
            e = t.model;
          return {
            target: t.target,
            propTarget: t.propTarget,
            onChange: function onChange(n, r, o) {
              var a = r.model,
                s = e.get("status");
              if (e.get("detached")) {
                var l = a.get("property"),
                  c = a.getDefaultValue(),
                  u = t.getLayers(),
                  d = u.getPropertyValues(l, c);
                r.updateTargetStyle(d, null, o), "background-image" != l || o.avoidStore || "computed" != s || e.get("properties").filter(function (t) {
                  return "__" == t.get("property").substr(0, 2);
                }).forEach(function (e) {
                  var n = e.get("property"),
                    r = u.getPropertyValues(n, e.getDefaultValue());
                  t.getTargets().forEach(function (t) {
                    return t.addStyle(i()({}, n, r), o);
                  });
                });
              } else if ("updated" == s) {
                var h = e.getFullValue();
                e.set("value", h, o), !h && r.updateTargetStyle(h, null, o);
              }
            }
          };
        },
        onRender: function onRender() {
          var t = this.el,
            e = this.layers,
            n = this.propsView,
            r = t.querySelector("[data-layers-wrapper]");
          n.render(), r.appendChild(e.render().el);
        }
      }),
      B = a.a.$,
      W = D.extend({
        templateInput: function templateInput() {
          var t = this.pfx,
            e = this.em;
          return '\n    <div class="'.concat(t, "field ").concat(t, "file\">\n      <div id='").concat(t, "input-holder'>\n        <div class=\"").concat(t, 'btn-c">\n          <button class="').concat(t, 'btn" id="').concat(t, 'images" type="button">\n            ').concat(e.t("styleManager.fileButton"), '\n          </button>\n        </div>\n        <div style="clear:both;"></div>\n      </div>\n      <div id="').concat(t, 'preview-box">\n        <div id="').concat(t, 'preview-file"></div>\n        <div id="').concat(t, 'close">&Cross;</div>\n      </div>\n    </div>\n    ');
        },
        init: function init() {
          var t = this.em;
          this.modal = t.get("Modal"), this.am = t.get("AssetManager"), this.events["click #" + this.pfx + "close"] = "removeFile", this.events["click #" + this.pfx + "images"] = "openAssetManager", this.delegateEvents();
        },
        onRender: function onRender() {
          if (!this.$input) {
            var t = this.model.getDefaultValue();
            this.$input = B('<input placeholder="'.concat(t, '">'));
          }
          this.$preview || (this.$preview = this.$el.find("#" + this.pfx + "preview-file")), this.$previewBox || (this.$previewBox = this.$el.find("#" + this.pfx + "preview-box")), this.setValue(this.componentValue, 0);
        },
        clearCached: function clearCached() {
          D.prototype.clearCached.apply(this, arguments), this.$preview = null, this.$previewBox = null;
        },
        setValue: function setValue(t, e) {
          D.prototype.setValue.apply(this, arguments), this.setPreviewView(t && t != this.model.getDefaultValue()), this.setPreview(t);
        },
        setPreviewView: function setPreviewView(t) {
          var e = this.$previewBox;
          e && e[t ? "addClass" : "removeClass"]("".concat(this.pfx, "show")), e && e.css({
            display: t ? "block" : "none"
          });
        },
        spreadUrl: function spreadUrl(t) {
          this.model.set("value", t), this.setPreviewView(1);
        },
        setPreview: function setPreview(t) {
          var e = this.$preview;
          t = t && t.indexOf("url(") < 0 ? "url(".concat(t, ")") : t, e && e.css("background-image", t);
        },
        cleanValue: function cleanValue() {
          this.setPreviewView(0), this.model.set({
            value: ""
          }, {
            silent: !0
          });
        },
        removeFile: function removeFile() {
          this.model.set("value", this.model.getDefaultValue());
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          D.prototype.cleanValue.apply(this, e), this.setPreviewView(0);
        },
        openAssetManager: function openAssetManager(t) {
          var e = this,
            n = this.em,
            r = this.modal,
            i = n ? n.get("Editor") : "";
          i && i.runCommand("open-assets", {
            types: ["image"],
            accept: "image/*",
            target: this.getTargetModel(),
            onClick: function onClick() {},
            onDblClick: function onDblClick() {},
            onSelect: function onSelect(t) {
              r.close();
              var n = Object(l.isString)(t) ? t : t.get("src");
              e.spreadUrl(n);
            }
          });
        }
      }),
      U = a.a.$,
      q = D.extend({
        templateInput: function templateInput() {
          return "";
        },
        init: function init() {
          var t = this.model;
          this.listenTo(t, "change:unit", this.modelValueChanged), this.listenTo(t, "el:change", this.elementUpdated), this.listenTo(t, "change:units", this.render);
        },
        setValue: function setValue(t) {
          var e = this.model.parseValue(t);
          t = "".concat(e.value).concat(e.unit), this.inputInst.setValue(t, {
            silent: 1
          });
        },
        onRender: function onRender() {
          var t = this.ppfx;
          if (!this.input) {
            var e = this.model.input;
            e.ppfx = t, e.render(), this.el.querySelector(".".concat(t, "fields")).appendChild(e.el), this.$input = e.inputEl, this.unit = e.unitEl, this.$unit = U(this.unit), this.input = this.$input.get(0), this.inputInst = e;
          }
        },
        clearCached: function clearCached() {
          D.prototype.clearCached.apply(this, arguments), this.unit = null, this.$unit = null;
        }
      }),
      G = n(38);
    function K(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Y(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? K(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : K(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var X = q.extend({
        setValue: function setValue(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          e = Y(Y({}, e), {}, {
            silent: 1
          }), this.inputInst.setValue(t, e);
        },
        onRender: function onRender() {
          if (!this.input) {
            var t = this.ppfx,
              e = new G.a({
                target: this.target,
                model: this.model,
                ppfx: t
              }).render();
            this.el.querySelector(".".concat(t, "fields")).appendChild(e.el), this.$input = e.inputEl, this.$color = e.colorEl, this.input = this.$input.get(0), this.inputInst = e;
          }
        }
      }),
      J = n(9),
      Z = n.n(J);
    function Q(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function tt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Q(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Q(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var et = f.extend({
      defaults: function defaults() {
        return tt(tt({}, f.prototype.defaults), {}, {
          options: [],
          full: 1
        });
      },
      initialize: function initialize() {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        f.prototype.initialize.apply(this, e), this.listenTo(this, "change:options", this.onOptionChange);
      },
      onOptionChange: function onOptionChange() {
        this.set("list", this.get("options"));
      },
      getOptions: function getOptions() {
        var t = this.attributes,
          e = t.options,
          n = t.list;
        return e && e.length ? e : n;
      },
      setOptions: function setOptions() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return this.set("options", t), this;
      },
      addOption: function addOption(t) {
        if (t) {
          var e = this.getOptions();
          this.setOptions([].concat(Z()(e), [t]));
        }
        return this;
      }
    });
    function nt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function rt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? nt(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : nt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var it = et.extend({
        defaults: function defaults() {
          return rt(rt({}, et.prototype.defaults()), {}, {
            full: 0
          });
        }
      }),
      ot = (a.a.$, D.extend({
        templateInput: function templateInput() {
          var t = this.pfx,
            e = this.ppfx;
          return '\n      <div class="'.concat(e, "field ").concat(e, 'select">\n        <span id="').concat(t, 'input-holder"></span>\n        <div class="').concat(e, 'sel-arrow">\n          <div class="').concat(e, 'd-s-arrow"></div>\n        </div>\n      </div>\n    ');
        },
        initialize: function initialize() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          D.prototype.initialize.apply(this, e), this.listenTo(this.model, "change:options", this.updateOptions);
        },
        updateOptions: function updateOptions() {
          this.input = null, this.onRender();
        },
        onRender: function onRender() {
          var t = this.pfx,
            e = this.model.getOptions();
          if (!this.input) {
            var n = "";
            e.forEach(function (t) {
              var e = t.name || t.value,
                r = t.style ? t.style.replace(/"/g, "&quot;") : "",
                i = r ? 'style="'.concat(r, '"') : "",
                o = t.value.replace(/"/g, "&quot;");
              n += '<option value="'.concat(o, '" ').concat(i, ">").concat(e, "</option>");
            });
            var r = this.el.querySelector("#".concat(t, "input-holder"));
            r.innerHTML = "<select>".concat(n, "</select>"), this.input = r.firstChild;
          }
        }
      })),
      at = D.extend({
        templateInput: function templateInput() {
          this.pfx;
          var t = this.ppfx;
          return '\n      <div class="'.concat(t, "field ").concat(t, 'field-radio">\n      </div>\n    ');
        },
        onRender: function onRender() {
          var t = this.pfx,
            e = this.ppfx,
            n = "".concat(e, "radio-item-label"),
            r = this.model,
            i = r.get("property"),
            o = r.get("list") || r.get("options") || [],
            a = r.cid,
            s = "".concat(t, "radio ").concat(t, "radio-").concat(i);
          if (!this.input && o && o.length) {
            var l = "";
            o.forEach(function (r) {
              var o = r.className ? "".concat(r.className, " ").concat(t, "icon ").concat(n) : "",
                c = "".concat(i, "-").concat(r.value, "-").concat(a),
                u = r.name || r.value,
                d = r.title ? 'title="'.concat(r.title, '"') : "";
              l += '\n            <div class="'.concat(e, 'radio-item">\n              <input type="radio" class="').concat(s, '" id="').concat(c, '" name="').concat(i, "-").concat(a, '" value="').concat(r.value, '"/>\n              <label class="').concat(o || n, '" ').concat(d, ' for="').concat(c, '">').concat(o ? "" : u, "</label>\n            </div>\n          ");
            });
            var c = this.el.querySelector(".".concat(e, "field"));
            c.innerHTML = '<div class="'.concat(e, 'radio-items">').concat(l, "</div>"), this.input = c.firstChild;
          }
        },
        getInputValue: function getInputValue() {
          var t = this.getCheckedEl();
          return t ? t.value : "";
        },
        getCheckedEl: function getCheckedEl() {
          var t = this.getInputEl();
          return t ? t.querySelector("input:checked") : "";
        },
        setValue: function setValue(t) {
          var e = this.model,
            n = t || e.get("value") || e.getDefaultValue(),
            r = this.getInputEl(),
            i = r ? r.querySelector('[value="'.concat(n, '"]')) : "";
          if (i) i.checked = !0;else {
            var o = this.getCheckedEl();
            o && (o.checked = !1);
          }
        }
      }),
      st = n(32);
    function lt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function ct(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? lt(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : lt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var ut = f.extend({
      defaults: ct(ct({}, f.prototype.defaults), {}, {
        units: [],
        unit: "",
        step: 1,
        min: "",
        max: ""
      }),
      initialize: function initialize() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        f.callParentInit(f, this, t, e);
        var n = this.get("unit"),
          r = this.get("units");
        this.input = new st.a({
          model: this
        }), r.length && !n && this.set("unit", r[0]), f.callInit(this, t, e);
      },
      clearValue: function clearValue() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return this.set({
          value: void 0,
          unit: void 0
        }, t), this;
      },
      parseValue: function parseValue(t) {
        var e = f.prototype.parseValue.apply(this, arguments),
          n = this.input.validateInputValue(e.value, {
            deepCheck: 1
          }),
          r = n.value,
          i = n.unit;
        return e.value = r, e.unit = i, e;
      },
      getFullValue: function getFullValue() {
        var t = this.get("value"),
          e = this.get("unit");
        return t = Object(l.isUndefined)(t) ? "" : t, e = !Object(l.isUndefined)(e) && t ? e : "", t = "".concat(t).concat(e), f.prototype.getFullValue.apply(this, [t]);
      }
    });
    function dt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function ht(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? dt(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : dt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var ft = ut.extend({
      defaults: ht(ht({}, ut.prototype.defaults), {}, {
        showInput: 1
      })
    });
    function pt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function gt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? pt(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : pt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var vt = q.extend({
      events: function events() {
        return gt(gt({}, q.prototype.events), {}, {
          "change [type=range]": "inputValueChanged",
          "input [type=range]": "inputValueChangedSoft",
          change: ""
        });
      },
      templateInput: function templateInput(t) {
        var e = this.ppfx;
        return '\n      <div class="'.concat(e, "field ").concat(e, 'field-range">\n        <input type="range"\n          min="').concat(t.get("min"), '"\n          max="').concat(t.get("max"), '"\n          step="').concat(t.get("step"), '"/>\n      </div>\n    ');
      },
      getSliderEl: function getSliderEl() {
        return this.slider || (this.slider = this.el.querySelector("input[type=range]")), this.slider;
      },
      inputValueChanged: function inputValueChanged() {
        var t = this.model,
          e = t.get("step");
        this.getInputEl().value = this.getSliderEl().value;
        var n = this.getInputValue() - e;
        t.set("value", n, {
          avoidStore: 1
        }).set("value", n + e), this.elementUpdated();
      },
      inputValueChangedSoft: function inputValueChangedSoft() {
        this.getInputEl().value = this.getSliderEl().value, this.model.set("value", this.getInputValue(), {
          avoidStore: 1
        }), this.elementUpdated();
      },
      setValue: function setValue(t) {
        var e = this.model.parseValue(t);
        this.getSliderEl().value = parseFloat(e.value), q.prototype.setValue.apply(this, arguments);
      },
      onRender: function onRender() {
        q.prototype.onRender.apply(this, arguments), this.model.get("showInput") || (this.inputInst.el.style.display = "none");
      },
      clearCached: function clearCached() {
        q.prototype.clearCached.apply(this, arguments), this.slider = null;
      }
    });
    function mt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function bt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? mt(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : mt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var yt = e.default = a.a.Collection.extend(s.a).extend({
      extendViewApi: 1,
      types: [{
        id: "stack",
        model: C,
        view: $,
        isType: function isType(t) {
          if (t && "stack" == t.type) return t;
        }
      }, {
        id: "composite",
        model: v,
        view: N,
        isType: function isType(t) {
          if (t && "composite" == t.type) return t;
        }
      }, {
        id: "file",
        model: f,
        view: W,
        isType: function isType(t) {
          if (t && "file" == t.type) return t;
        }
      }, {
        id: "color",
        model: f,
        view: X,
        isType: function isType(t) {
          if (t && "color" == t.type) return t;
        }
      }, {
        id: "select",
        model: it,
        view: ot,
        isType: function isType(t) {
          if (t && "select" == t.type) return t;
        }
      }, {
        id: "radio",
        model: et,
        view: at,
        isType: function isType(t) {
          if (t && "radio" == t.type) return t;
        }
      }, {
        id: "slider",
        model: ft,
        view: vt,
        isType: function isType(t) {
          if (t && "slider" == t.type) return t;
        }
      }, {
        id: "integer",
        model: ut,
        view: q,
        isType: function isType(t) {
          if (t && "integer" == t.type) return t;
        }
      }, {
        id: "base",
        model: f,
        view: D,
        isType: function isType(t) {
          return t.type = "base", t;
        }
      }],
      deepClone: function deepClone() {
        var t = this.clone();
        return t.reset(t.map(function (t) {
          var e = t.clone();
          return e.typeView = t.typeView, e;
        })), t;
      },
      parseValue: function parseValue(t) {
        var e = this,
          n = [];
        return t.split(" ").forEach(function (t, r) {
          var i = e.at(r);
          i && n.push(bt(bt({}, i.attributes), {
            value: t
          }));
        }), n;
      },
      getFullValue: function getFullValue() {
        var t = "";
        return this.each(function (e) {
          return t += "".concat(e.getFullValue(), " ");
        }), t.trim();
      }
    });
  }, function (t, e, n) {
    var r = n(90);
    t.exports = function (t, e) {
      if (null == t) return {};
      var n,
        i,
        o = r(t, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        for (i = 0; i < a.length; i++) n = a[i], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
      }
      return o;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
      i = n.n(r).a.$;
    e.default = {
      startSelectPosition: function startSelectPosition(t, e) {
        var n = this,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        this.isPointed = !1;
        var i = this.editorModel.get("Utils"),
          o = t.ownerDocument.body;
        i && !this.sorter && (this.sorter = new i.Sorter({
          container: o,
          placer: this.canvas.getPlacerEl(),
          containerSel: "*",
          itemSel: "*",
          pfx: this.ppfx,
          direction: "a",
          document: e,
          wmargin: 1,
          nested: 1,
          em: this.editorModel,
          canvasRelative: 1,
          scale: function scale() {
            return n.em.getZoomDecimal();
          }
        })), r.onStart && (this.sorter.onStart = r.onStart), t && this.sorter.startSort(t, {
          container: o
        });
      },
      getOffsetDim: function getOffsetDim() {
        var t = this.offset(this.canvas.getFrameEl()),
          e = this.offset(this.canvas.getElement());
        return {
          top: t.top - e.top,
          left: t.left - e.left
        };
      },
      stopSelectPosition: function stopSelectPosition() {
        this.posTargetCollection = null, this.posIndex = "after" == this.posMethod && 0 !== this.cDim.length ? this.posIndex + 1 : this.posIndex, this.sorter && (this.sorter.moved = 0, this.sorter.endMove()), this.cDim && (this.posIsLastEl = 0 !== this.cDim.length && "after" == this.posMethod && this.posIndex == this.cDim.length, this.posTargetEl = 0 === this.cDim.length ? i(this.outsideElem) : !this.posIsLastEl && this.cDim[this.posIndex] ? i(this.cDim[this.posIndex][5]).parent() : i(this.outsideElem), this.posTargetModel = this.posTargetEl.data("model"), this.posTargetCollection = this.posTargetEl.data("model-comp"));
      },
      enable: function enable() {
        this.startSelectPosition();
      },
      nearFloat: function nearFloat(t, e, n) {
        var r = t || 0,
          i = e || "before",
          o = n.length,
          a = 0 !== o && "after" == i && r == o;
        return 0 !== o && (!a && !n[r][4] || n[r - 1] && !n[r - 1][4] || a && !n[r - 1][4]) ? 1 : 0;
      },
      run: function run() {
        this.enable();
      },
      stop: function stop() {
        this.stopSelectPosition(), this.$wrapper.css("cursor", ""), this.$wrapper.unbind();
      }
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(40);
    window.Promise = window.Promise || r.a, e.a = "function" == typeof fetch ? fetch.bind() : function (t, e) {
      return new r.a(function (n, i) {
        var o = new XMLHttpRequest();
        for (var a in o.open(e.method || "get", t), o.withCredentials = "include" == e.credentials, e.headers || {}) o.setRequestHeader(a, e.headers[a]);
        o.onload = function (t) {
          return n({
            status: o.status,
            statusText: o.statusText,
            text: function text() {
              return r.a.resolve(o.responseText);
            }
          });
        }, o.onerror = i, o.upload && e.onProgress && (o.upload.onprogress = e.onProgress), e.body ? o.send(e.body) : o.send();
      });
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(8),
      i = n.n(r),
      o = n(0);
    e.a = function (t) {
      var e = t;
      return {
        compTypes: "",
        modelAttrStart: "data-gjs-",
        splitPropsFromAttr: function splitPropsFromAttr() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = {},
            r = {};
          return Object(o.each)(e, function (e, i) {
            if (0 === i.indexOf(t.modelAttrStart)) {
              var a = i.replace("data-gjs-", ""),
                s = e.length,
                l = e && Object(o.isString)(e),
                c = l && e.substr(0, 1),
                u = l && e.substr(s - 1);
              e = "false" !== (e = "true" === e || e) && e;
              try {
                e = "{" == c && "}" == u || "[" == c && "]" == u ? JSON.parse(e) : e;
              } catch (t) {}
              n[a] = e;
            } else r[i] = e;
          }), {
            props: n,
            attrs: r
          };
        },
        parseStyle: function parseStyle(t) {
          for (var e = {}, n = t.split(";"), r = 0, i = n.length; r < i; r++) {
            var o = n[r].trim();
            if (o) {
              var a = o.split(":");
              e[a[0].trim()] = a.slice(1).join(":").trim();
            }
          }
          return e;
        },
        parseClass: function parseClass(t) {
          for (var e = [], n = t.split(" "), r = 0, i = n.length; r < i; r++) {
            var o = n[r].trim();
            o && e.push(o);
          }
          return e;
        },
        parseNode: function parseNode(n) {
          for (var r = [], o = n.childNodes, a = 0, s = o.length; a < s; a++) {
            var l = o[a],
              c = l.attributes || [],
              u = c.length,
              d = r[r.length - 1],
              h = l.childNodes.length,
              f = this.compTypes,
              p = {};
            if (f) {
              var g = "",
                v = l.getAttribute && l.getAttribute("".concat("data-gjs-", "type"));
              if (v) p = {
                type: v
              };else {
                for (var m = 0; m < f.length; m++) {
                  var b = f[m];
                  if (g = b.model.isComponent(l)) {
                    "object" !== i()(g) && (g = {
                      type: b.id
                    });
                    break;
                  }
                }
                p = g;
              }
            }
            p.tagName || (p.tagName = l.tagName ? l.tagName.toLowerCase() : ""), u && (p.attributes = {});
            for (var y = 0; y < u; y++) {
              var w = c[y].nodeName,
                x = c[y].nodeValue;
              if ("style" == w) p.style = this.parseStyle(x);else if ("class" == w) p.classes = this.parseClass(x);else {
                if ("contenteditable" == w) continue;
                if (0 === w.indexOf("data-gjs-")) {
                  var O = w.replace("data-gjs-", ""),
                    C = x.length,
                    S = x && x.substr(0, 1),
                    k = x && x.substr(C - 1);
                  x = "false" !== (x = "true" === x || x) && x;
                  try {
                    x = "{" == S && "}" == k || "[" == S && "]" == k ? JSON.parse(x) : x;
                  } catch (t) {}
                  p[O] = x;
                } else "" === x && !0 === l[w] && (x = !0), p.attributes[w] = x;
              }
            }
            if (h && !p.components) {
              var j = l.childNodes[0];
              1 === h && 3 === j.nodeType ? (!p.type && (p.type = "text"), p.content = j.nodeValue) : p.components = this.parseNode(l);
            }
            if ("textnode" == p.type) {
              if (d && "textnode" == d.type) {
                d.content += p.content;
                continue;
              }
              if (!t.keepEmptyTextNodes) {
                var T = l.nodeValue;
                if (" " != T && !T.trim()) continue;
              }
            }
            var P = p.components;
            if (!p.type && P) {
              for (var E = 1, D = 0, M = 0; M < P.length; M++) {
                var A = P[M],
                  L = A.type;
                if (["text", "textnode"].indexOf(L) < 0 && e.textTags.indexOf(A.tagName) < 0) {
                  E = 0;
                  break;
                }
                "textnode" == L && (D = 1);
              }
              E && D && (p.type = "text");
            }
            (p.tagName || "textnode" == p.type) && r.push(p);
          }
          return r;
        },
        parse: function parse(t, n) {
          var r = e.em && e.em.get("Config") || {},
            i = {
              html: "",
              css: ""
            },
            o = document.createElement("div");
          o.innerHTML = t;
          var a = o.querySelectorAll("script"),
            s = a.length;
          if (!r.allowScripts) for (; s--;) a[s].parentNode.removeChild(a[s]);
          if (n) {
            for (var l = "", c = o.querySelectorAll("style"), u = c.length; u--;) l = c[u].innerHTML + l, c[u].parentNode.removeChild(c[u]);
            l && (i.css = n.parse(l));
          }
          var d = this.parseNode(o);
          return 1 == d.length && (d = d[0]), i.html = d, i;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
      i = n(1),
      o = n.n(i),
      a = o.a.Model,
      s = o.a.View;
    e.a = {
      types: [],
      initialize: function initialize(t, e) {
        var n = this;
        this.model = function () {
          var t,
            e,
            r,
            i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (i && i.type) {
            var a = n.getBaseType();
            t = (r = n.getType(i.type)) ? r.model : a.model, e = r ? r.view : a.view;
          } else {
            var s = n.recognizeType(i);
            t = (r = s.type).model, e = r.view, i = s.attributes;
          }
          var l = new t(i, o);
          return l.typeView = e, l;
        };
        var r = this.init && this.init.bind(this);
        r && r();
      },
      recognizeType: function recognizeType(t) {
        for (var e = this.getTypes(), n = 0; n < e.length; n++) {
          var r = e[n],
            i = r.isType(t);
          if (i = "boolean" == typeof i && i ? {
            type: r.id
          } : i) return {
            type: r,
            attributes: i
          };
        }
        return {
          type: this.getBaseType(),
          attributes: t
        };
      },
      getBaseType: function getBaseType() {
        var t = this.getTypes();
        return t[t.length - 1];
      },
      getTypes: function getTypes() {
        return this.types;
      },
      getType: function getType(t) {
        for (var e = this.getTypes(), n = 0; n < e.length; n++) {
          var r = e[n];
          if (r.id === t) return r;
        }
      },
      addType: function addType(t, e) {
        var n = this.getType(t),
          i = this.getBaseType(),
          o = n ? n.model : i.model,
          l = n ? n.view : i.view,
          c = e.model,
          u = e.view,
          d = e.isType;
        c = c instanceof a || Object(r.isFunction)(c) ? c : o.extend(c || {}), u = u instanceof s || Object(r.isFunction)(u) ? u : l.extend(u || {}), !this.extendViewApi || e.model || e.view || (u = u.extend(e)), n ? (n.model = c, n.view = u, n.isType = d || n.isType) : (e.id = t, e.model = c, e.view = u, e.isType = d || function (e) {
          if (e && e.type == t) return !0;
        }, this.getTypes().unshift(e));
      }
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n.n(r),
      o = n(0),
      a = Number.MAX_VALUE;
    e.a = i.a.Model.extend({
      initialize: function initialize() {
        this.compCls = [], this.ids = [];
      },
      buildFromModel: function buildFromModel(t) {
        var e = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = "",
          i = this.em,
          o = i && i.getConfig("avoidInlineStyle"),
          a = t.styleToString(),
          s = t.get("classes"),
          l = n.wrapperIsBody,
          c = t.get("wrapper");
        if (this.ids.push("#".concat(t.getId())), s.each(function (t) {
          return e.compCls.push(t.getFullName());
        }), !o && a) {
          var u = "#".concat(t.getId());
          r = "".concat(u = l && c ? "body" : u, "{").concat(a, "}");
        }
        var d = t.components();
        return d.each(function (t) {
          return r += e.buildFromModel(t, n);
        }), r;
      },
      build: function build(t) {
        var e = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = n.cssc,
          i = n.em || "";
        this.em = i, this.compCls = [], this.ids = [];
        var a = this.buildFromModel(t, n),
          s = Object(o.isUndefined)(n.clearStyles) && i ? i.getConfig("clearStyles") : n.clearStyles;
        if (r) {
          var l = r.getAll(),
            c = {},
            u = [];
          l.each(function (t) {
            var r = t.getAtRule();
            if (r) {
              var i = c[r];
              i ? i.push(t) : c[r] = [t];
            } else a += e.buildFromRule(t, u, n);
          }), this.sortMediaObject(c).forEach(function (t) {
            var r = "",
              i = t.key;
            t.value.forEach(function (t) {
              var o = e.buildFromRule(t, u, n);
              t.get("singleAtRule") ? a += "".concat(i, "{").concat(o, "}") : r += o;
            }), r && (a += "".concat(i, "{").concat(r, "}"));
          }), i && s && l.remove(u);
        }
        return a;
      },
      buildFromRule: function buildFromRule(t, e) {
        var n,
          r = this,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = "",
          a = t.selectorsToString({
            skipAdd: 1
          }),
          s = t.get("selectorsAdd"),
          l = t.get("singleAtRule");
        if (t.get("selectors").each(function (t) {
          var e = t.getFullName();
          (r.compCls.indexOf(e) >= 0 || r.ids.indexOf(e) >= 0 || i.keepUnusedStyles) && (n = 1);
        }), a && n || s || l) {
          var c = t.getDeclaration();
          c && (o += c);
        } else e.push(t);
        return o;
      },
      getQueryLength: function getQueryLength(t) {
        var e = /(-?\d*\.?\d+)\w{0,}/.exec(t);
        return e ? parseFloat(e[1]) : a;
      },
      sortMediaObject: function sortMediaObject() {
        var t = this,
          e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = [];
        return Object(o.each)(e, function (t, e) {
          return n.push({
            key: e,
            value: t
          });
        }), n.sort(function (e, n) {
          var r = [e.key, n.key].every(function (t) {
              return -1 !== t.indexOf("min-width");
            }),
            i = r ? e.key : n.key,
            o = r ? n.key : e.key;
          return t.getQueryLength(i) - t.getQueryLength(o);
        });
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n.n(r),
      o = n(0),
      a = n(3),
      s = n(18);
    i.a.$;
    e.a = s.a.extend({
      events: {
        "change input": "handleChange",
        "change select": "handleUnitChange",
        "click [data-arrow-up]": "upArrowClick",
        "click [data-arrow-down]": "downArrowClick",
        "mousedown [data-arrows]": "downIncrement"
      },
      template: function template() {
        var t = this.ppfx;
        return '\n      <span class="'.concat(t, 'input-holder"></span>\n      <span class="').concat(t, 'field-units"></span>\n      <div class="').concat(t, 'field-arrows" data-arrows>\n        <div class="').concat(t, 'field-arrow-u" data-arrow-up></div>\n        <div class="').concat(t, 'field-arrow-d" data-arrow-down></div>\n      </div>\n    ');
      },
      inputClass: function inputClass() {
        var t = this.ppfx;
        return this.opts.contClass || "".concat(t, "field ").concat(t, "field-integer");
      },
      initialize: function initialize() {
        s.a.prototype.initialize.apply(this, arguments), Object(o.bindAll)(this, "moveIncrement", "upIncrement"), this.doc = document, this.listenTo(this.model, "change:unit", this.handleModelChange);
      },
      setValue: function setValue(t, e) {
        var n = e || {},
          r = this.validateInputValue(t, {
            deepCheck: 1
          }),
          i = {
            value: r.value
          };
        (r.unit || r.force) && (i.unit = r.unit), this.model.set(i, n), n.silent && this.handleModelChange();
      },
      handleChange: function handleChange(t) {
        t.stopPropagation(), this.setValue(this.getInputEl().value), this.elementUpdated();
      },
      handleUnitChange: function handleUnitChange(t) {
        t.stopPropagation();
        var e = this.getUnitEl().value;
        this.model.set("unit", e), this.elementUpdated();
      },
      elementUpdated: function elementUpdated() {
        this.model.trigger("el:change");
      },
      handleModelChange: function handleModelChange() {
        var t = this.model;
        this.getInputEl().value = t.get("value");
        var e = this.getUnitEl();
        e && (e.value = t.get("unit") || "");
      },
      getUnitEl: function getUnitEl() {
        if (!this.unitEl) {
          var t = this.model,
            e = t.get("units") || [];
          if (e.length) {
            var n = [];
            e.forEach(function (e) {
              var r = e == t.get("unit") ? "selected" : "";
              n.push("<option ".concat(r, ">").concat(e, "</option>"));
            });
            var r = document.createElement("div");
            r.innerHTML = '<select class="'.concat(this.ppfx, 'input-unit">').concat(n.join(""), "</select>"), this.unitEl = r.firstChild;
          }
        }
        return this.unitEl;
      },
      upArrowClick: function upArrowClick() {
        var t = this.model,
          e = t.get("step"),
          n = parseInt(t.get("value"), 10);
        n = this.normalizeValue(n + e);
        var r = this.validateInputValue(n);
        t.set("value", r.value), this.elementUpdated();
      },
      downArrowClick: function downArrowClick() {
        var t = this.model,
          e = t.get("step"),
          n = parseInt(t.get("value"), 10),
          r = this.normalizeValue(n - e),
          i = this.validateInputValue(r);
        t.set("value", i.value), this.elementUpdated();
      },
      downIncrement: function downIncrement(t) {
        t.preventDefault(), this.moved = 0;
        var e = this.model.get("value");
        e = this.normalizeValue(e), this.current = {
          y: t.pageY,
          val: e
        }, Object(a.u)(this.doc, "mousemove", this.moveIncrement), Object(a.u)(this.doc, "mouseup", this.upIncrement);
      },
      moveIncrement: function moveIncrement(t) {
        this.moved = 1;
        var e = this.model,
          n = e.get("step"),
          r = this.current,
          i = this.normalizeValue(r.val + (r.y - t.pageY) * n);
        return this.prValue = this.validateInputValue(i).value, e.set("value", this.prValue, {
          avoidStore: 1
        }), !1;
      },
      upIncrement: function upIncrement() {
        var t = this.model,
          e = t.get("step");
        if (Object(a.t)(this.doc, "mouseup", this.upIncrement), Object(a.t)(this.doc, "mousemove", this.moveIncrement), this.prValue && this.moved) {
          var n = this.prValue - e;
          t.set("value", n, {
            avoidStore: 1
          }).set("value", n + e), this.elementUpdated();
        }
      },
      normalizeValue: function normalizeValue(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = this.model,
          r = n.get("step"),
          i = 0;
        if (isNaN(t)) return e;
        if (t = parseFloat(t), Math.floor(t) !== t) {
          var o = r.toString().split(".")[1];
          i = o ? o.length : 0;
        }
        return i ? parseFloat(t.toFixed(i)) : t;
      },
      validateInputValue: function validateInputValue(t, e) {
        var n = 0,
          r = e || {},
          i = this.model,
          a = Object(o.isUndefined)(t) ? "" : t,
          s = i.get("units") || [],
          l = i.get("unit") || s.length && s[0] || "",
          c = i.get("max"),
          u = i.get("min");
        if (r.deepCheck) {
          var d = i.get("fixedValues") || [];
          if (a) {
            var h = new RegExp("^" + d.join("|"), "g");
            if (d.length && h.test(a)) a = a.match(h)[0], l = "", n = 1;else {
              var f = a + "";
              a += "", a = parseFloat(a.replace(",", ".")), a = isNaN(a) ? "" : a;
              var p = f.replace(a, "");
              Object(o.indexOf)(s, p) >= 0 && (l = p);
            }
          }
        }
        return Object(o.isUndefined)(c) || "" === c || (a = a > c ? c : a), Object(o.isUndefined)(u) || "" === u || (a = a < u ? u : a), {
          force: n,
          value: a,
          unit: l
        };
      },
      render: function render() {
        s.a.prototype.render.call(this), this.unitEl = null;
        var t = this.getUnitEl();
        return t && this.$el.find(".".concat(this.ppfx, "field-units")).get(0).appendChild(t), this;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n.n(r),
      o = n(34);
    e.a = i.a.Collection.extend({
      model: o.a,
      initialize: function initialize(t, e) {
        var n = this;
        e && e.em && (this.editor = e.em), setTimeout(function () {
          n.on("remove", n.onRemove), n.on("add", n.onAdd);
        });
      },
      onAdd: function onAdd(t) {
        t.ensureSelectors();
      },
      onRemove: function onRemove(t) {
        var e = this.editor;
        e.stopListening(t), e.get("UndoManager").remove(t);
      },
      add: function add(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return "string" == typeof t && (t = this.editor.get("Parser").parseCss(t)), e.em = this.editor, i.a.Collection.prototype.add.apply(this, [t, e]);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
      i = n(1),
      o = n.n(i),
      a = n(23),
      s = n(12),
      l = window.CSS;
    e.a = o.a.Model.extend(a.a).extend({
      defaults: {
        selectors: [],
        selectorsAdd: "",
        style: {},
        mediaText: "",
        state: "",
        stylable: !0,
        atRuleType: "",
        singleAtRule: 0,
        important: 0
      },
      initialize: function initialize(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        this.config = t || {}, this.em = e.em, this.ensureSelectors();
      },
      ensureSelectors: function ensureSelectors() {
        var t = this.em,
          e = [],
          n = t && t.get("SelectorManager"),
          r = this.getSelectors(),
          i = Array.isArray(r);
        r.forEach(function (t) {
          return e.push(n ? n.add(t) : t);
        }), i && this.set("selectors", new s.a(e));
      },
      getAtRule: function getAtRule() {
        var t = this.get("atRuleType"),
          e = this.get("mediaText"),
          n = t ? "@".concat(t) : e ? "@media" : "";
        return n + (e && n ? " ".concat(e) : "");
      },
      selectorsToString: function selectorsToString() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = [],
          n = this.em,
          r = this.get("state"),
          i = this.get("wrapper"),
          o = this.get("selectorsAdd"),
          a = i && n && n.getConfig("wrapperIsBody"),
          s = {
            escape: function escape(t) {
              return l && l.escape ? l.escape(t) : t;
            }
          },
          c = a ? "body" : this.get("selectors").getFullString(0, s),
          u = r && !t.skipState ? ":".concat(r) : "";
        return c && e.push("".concat(c).concat(u)), o && !t.skipAdd && e.push(o), e.join(", ");
      },
      getDeclaration: function getDeclaration() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = "",
          n = this.selectorsToString(),
          r = this.styleToString(t),
          i = this.get("singleAtRule");
        return (n || i) && r && (e = i ? r : "".concat(n, "{").concat(r, "}")), e;
      },
      toCSS: function toCSS() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = "",
          n = this.getAtRule(),
          r = this.getDeclaration(t);
        return r && (e = r), n && e && (e = "".concat(n, "{").concat(e, "}")), e;
      },
      toJSON: function toJSON() {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        var i = o.a.Model.prototype.toJSON.apply(this, e);
        if (this.em.getConfig("avoidDefaults")) {
          var a = this.defaults;
          Object(r.forEach)(a, function (t, e) {
            i[e] === t && delete i[e];
          }), Object(r.isEmpty)(i.selectors) && delete i.selectors, Object(r.isEmpty)(i.style) && delete i.style;
        }
        return i;
      },
      compare: function compare(t, e, n) {
        var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
          o = e || "",
          a = n || "",
          s = i.selectorsAdd || "",
          l = i.atRuleType || "";
        t instanceof Array || t.models || (t = [t]);
        var c = Object(r.map)(t.models || t, function (t) {
            return t.get("name");
          }),
          u = Object(r.map)(this.get("selectors").models, function (t) {
            return t.get("name");
          }),
          d = !1;
        if (c.length !== u.length) return d;
        for (var h = 0; h < c.length; h++) {
          for (var f = 0, p = 0; p < u.length; p++) c[h] === u[p] && (f = 1);
          if (0 === f) return d;
        }
        return this.get("state") === o && this.get("mediaText") === a && this.get("selectorsAdd") === s && this.get("atRuleType") === l || d;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n.n(r),
      o = n(0);
    e.a = i.a.View.extend({
      initialize: function initialize(t) {
        this.opts = t || {}, this.config = t.config || {}, this.em = this.config.em;
        var e = this.collection;
        this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.resetChildren), this.listenTo(e, "remove", this.removeChildren);
      },
      removeChildren: function removeChildren(t, e) {
        var n = this,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        t.views.forEach(function (t) {
          if (t) {
            var e = t.childrenView,
              n = t.scriptContainer;
            e && e.stopListening(), n && n.remove(), t.remove.apply(t);
          }
        });
        var i = t.components();
        i.forEach(function (t) {
          return n.removeChildren(t, e, r);
        });
      },
      addTo: function addTo(t) {
        var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          n = this.config.em,
          r = this.collection.indexOf(t);
        if (this.addToCollection(t, null, r), n && !e.temporary) {
          var i = function t(e) {
            n.trigger("component:add", e), e.components().forEach(function (e) {
              return t(e);
            });
          };
          i(t);
        }
      },
      addToCollection: function addToCollection(t, e, r) {
        this.compView || (this.compView = n(6).default);
        for (var i = this.config, a = this.opts, s = this.em, l = e || null, c = i.frameView, u = void 0 === c ? {} : c, d = u.model && t.getView(u.model), h = a.componentTypes || s && s.get("DomComponents").getTypes(), f = t.get("type"), p = this.compView, g = 0; g < h.length; g++) if (h[g].id == f) {
          p = h[g].view;
          break;
        }
        var v,
          m = d || new p({
            model: t,
            config: i,
            componentTypes: h
          });
        try {
          v = m.render().el;
        } catch (t) {
          v = document.createTextNode(""), s.logError(t);
        }
        if (l) l.appendChild(v);else {
          var b = this.parentEl,
            y = b.childNodes;
          if (Object(o.isUndefined)(r)) b.appendChild(v);else {
            var w = y.length == r;
            w && r--, w || !y.length ? b.appendChild(v) : b.insertBefore(v, y[r]);
          }
        }
        return v;
      },
      resetChildren: function resetChildren(t) {
        var e = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = n.previousModels,
          i = void 0 === r ? [] : r;
        this.parentEl.innerHTML = "", i.forEach(function (t) {
          return e.removeChildren(t, e.collection);
        }), t.each(function (t) {
          return e.addToCollection(t);
        });
      },
      render: function render(t) {
        var e = this,
          n = this.el,
          r = document.createDocumentFragment();
        return this.parentEl = t || this.el, this.collection.each(function (t) {
          return e.addToCollection(t, r);
        }), n.innerHTML = "", n.appendChild(r), this;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r,
      i = n(0),
      o = n(3),
      a = n(1),
      s = n.n(a),
      l = n(6),
      c = n(5),
      u = s.a.$;
    e.a = s.a.View.extend({
      events: {
        "mousedown [data-toggle-move]": "startSort",
        "touchstart [data-toggle-move]": "startSort",
        "click [data-toggle-visible]": "toggleVisibility",
        "click [data-toggle-select]": "handleSelect",
        "mouseover [data-toggle-select]": "handleHover",
        "click [data-toggle-open]": "toggleOpening",
        "dblclick [data-name]": "handleEdit",
        "focusout [data-name]": "handleEditEnd"
      },
      template: function template(t) {
        var e = this.pfx,
          n = this.ppfx,
          r = this.config,
          i = this.clsNoEdit,
          o = r.hidable,
          a = this.countChildren(t),
          s = a ? "" : this.clsNoChild,
          l = "".concat(this.clsTitle, " ").concat(s),
          c = "".concat(this.clsTitleC, " ").concat(n, "one-bg"),
          u = "".concat(this.clsCaret, " fa fa-chevron-right"),
          d = "".concat(this.inputNameCls, " ").concat(i, " ").concat(n, "no-app"),
          h = this.level + 1,
          f = "".concat(30 + 10 * h, "px"),
          p = t.getName(),
          g = t.getIcon();
        "".concat(e, "layer");
        return "\n      ".concat(o ? '<i class="'.concat(e, "layer-vis fa fa-eye ").concat(this.isVisible() ? "" : "fa-eye-slash", '" data-toggle-visible></i>') : "", '\n      <div class="').concat(c, '">\n        <div class="').concat(l, '" title="').concat(p, '" style="padding-left: ').concat(f, '" data-toggle-select>\n          <div class="').concat(e, 'layer-title-inn">\n            <i class="').concat(u, '" data-toggle-open></i>\n            <span class="').concat(d, '" data-name> \n             ').concat(g ? "".concat(g) : "", " &nbsp;").concat(p, '\n            </span>\n          </div>\n        </div>\n      </div>\n      <div class="').concat(this.clsCount, '" data-count>').concat(a || "", '</div>\n      <div class="').concat(this.clsMove, '" data-toggle-move>\n        <i class="fa fa-arrows"></i>\n      </div>\n      <div class="').concat(this.clsChildren, '"></div>');
      },
      initialize: function initialize() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        this.opt = t, this.level = t.level, this.config = t.config, this.em = t.config.em, this.ppfx = this.em.get("Config").stylePrefix, this.sorter = t.sorter || "", this.pfx = this.config.stylePrefix, this.parentView = t.parentView;
        var e = this.pfx,
          n = this.ppfx,
          r = this.model,
          i = r.get("components"),
          o = r.get("type") || "default";
        r.set("open", !1), this.listenTo(i, "remove add reset", this.checkChildren), this.listenTo(r, "change:status", this.updateStatus), this.listenTo(r, "change:open", this.updateOpening), this.listenTo(r, "change:layerable", this.updateLayerable), this.listenTo(r, "change:style:display", this.updateVisibility), this.className = "".concat(e, "layer ").concat(e, "layer__t-").concat(o, " no-select ").concat(n, "two-color"), this.inputNameCls = "".concat(n, "layer-name"), this.clsTitleC = "".concat(e, "layer-title-c"), this.clsTitle = "".concat(e, "layer-title"), this.clsCaret = "".concat(e, "layer-caret"), this.clsCount = "".concat(e, "layer-count"), this.clsMove = "".concat(e, "layer-move"), this.clsChildren = "".concat(e, "layer-children"), this.clsNoChild = "".concat(e, "layer-no-chld"), this.clsEdit = "".concat(this.inputNameCls, "--edit"), this.clsNoEdit = "".concat(this.inputNameCls, "--no-edit"), this.$el.data("model", r), this.$el.data("collection", i), r.viewLayer = this;
      },
      getVisibilityEl: function getVisibilityEl() {
        return this.eyeEl || (this.eyeEl = this.$el.children(".".concat(this.pfx, "layer-vis"))), this.eyeEl;
      },
      updateVisibility: function updateVisibility() {
        var t = this.pfx,
          e = this.model,
          n = "".concat(t, "layer-hidden"),
          r = "none" === e.getStyle().display ? "addClass" : "removeClass";
        this.$el[r](n), this.getVisibilityEl()[r]("fa-eye-slash");
      },
      toggleVisibility: function toggleVisibility(t) {
        t && t.stopPropagation();
        var e = this.model,
          n = this.em,
          r = e.get("__prev-display"),
          i = e.getStyle(),
          o = i.display;
        "none" == o ? (delete i.display, r && (i.display = r, e.unset("__prev-display"))) : (o && e.set("__prev-display", o), i.display = "none"), e.setStyle(i), n && n.trigger("component:toggled");
      },
      handleEdit: function handleEdit(t) {
        t && t.stopPropagation();
        var e = this.em,
          n = this.$el,
          r = this.clsNoEdit,
          i = this.clsEdit,
          o = this.getInputName();
        o.contentEditable = !0, o.focus(), e && e.setEditing(1), n.find(".".concat(this.inputNameCls)).removeClass(r).addClass(i);
      },
      handleEditEnd: function handleEditEnd(t) {
        t && t.stopPropagation();
        var e = this.em,
          n = this.$el,
          r = this.clsNoEdit,
          i = this.clsEdit,
          o = this.getInputName(),
          a = o.textContent;
        o.scrollLeft = 0, o.contentEditable = !1, this.model.set({
          "custom-name": a
        }), e && e.setEditing(0), n.find(".".concat(this.inputNameCls)).addClass(r).removeClass(i);
      },
      getInputName: function getInputName() {
        return this.inputName || (this.inputName = this.el.querySelector(".".concat(this.inputNameCls))), this.inputName;
      },
      updateOpening: function updateOpening() {
        var t = this.opt.opened || {},
          e = this.model;
        e.get("open") ? (this.$el.addClass("open"), this.getCaret().addClass("fa-chevron-down"), t[e.cid] = e) : (this.$el.removeClass("open"), this.getCaret().removeClass("fa-chevron-down"), delete t[e.cid]);
      },
      toggleOpening: function toggleOpening(t) {
        t.stopPropagation(), this.model.get("components").length && this.model.set("open", !this.model.get("open"));
      },
      handleSelect: function handleSelect(t) {
        t.stopPropagation();
        var e = this.em,
          n = this.config;
        if (e) {
          var r = this.model;
          e.setSelected(r, {
            fromLayers: 1
          });
          var i = n.scrollCanvas;
          i && r.views.forEach(function (t) {
            return t.scrollIntoView(i);
          });
        }
      },
      handleHover: function handleHover(t) {
        t.stopPropagation();
        var e = this.em,
          n = this.config,
          r = this.model;
        e && n.showHover && e.setHovered(r, {
          fromLayers: 1
        });
      },
      startSort: function startSort(t) {
        t.stopPropagation();
        var e = this.em,
          n = this.sorter;
        t.button && 0 !== t.button || n && (n.onStart = function (t) {
          return e.trigger("".concat(c.eventDrag, ":start"), t);
        }, n.onMoveClb = function (t) {
          return e.trigger(c.eventDrag, t);
        }, n.startSort(t.target));
      },
      freeze: function freeze() {
        this.$el.addClass(this.pfx + "opac50"), this.model.set("open", 0);
      },
      unfreeze: function unfreeze() {
        this.$el.removeClass(this.pfx + "opac50");
      },
      updateStatus: function updateStatus(t) {
        l.default.prototype.updateStatus.apply(this, [{
          avoidHover: !this.config.highlightHover
        }]);
      },
      isVisible: function isVisible() {
        var t = this.model.getStyle().display;
        return !(t && "none" === t);
      },
      checkChildren: function checkChildren() {
        var t = this.model,
          e = this.clsNoChild,
          n = this.countChildren(t),
          r = this.$el.children(".".concat(this.clsTitleC)).children(".".concat(this.clsTitle)),
          i = this.cnt;
        i || (i = this.$el.children("[data-count]").get(0), this.cnt = i), r[n ? "removeClass" : "addClass"](e), i && (i.innerHTML = n || ""), !n && t.set("open", 0);
      },
      countChildren: function countChildren(t) {
        var e = 0;
        return t.get("components").each(function (t) {
          var n = this.opt.isCountable,
            r = this.config.hideTextnode;
          n && !n(t, r) || e++;
        }, this), e;
      },
      getCaret: function getCaret() {
        if (!this.caret || !this.caret.length) {
          this.pfx;
          this.caret = this.$el.children(".".concat(this.clsTitleC)).find(".".concat(this.clsCaret));
        }
        return this.caret;
      },
      setRoot: function setRoot(t) {
        t = Object(i.isString)(t) ? this.em.getWrapper().find(t)[0] : t;
        var e = Object(o.g)(t, u);
        e && (this.stopListening(), this.model = e, this.initialize(this.opt), this.render());
      },
      updateLayerable: function updateLayerable() {
        (this.parentView || this).render();
      },
      render: function render() {
        var t = this.model,
          e = this.config,
          o = this.pfx,
          a = this.ppfx,
          s = this.opt.isCountable,
          l = s && !s(t, e.hideTextnode),
          c = this.isVisible(),
          u = this.$el.empty(),
          d = this.level + 1;
        Object(i.isUndefined)(r) && (r = n(98).default);
        var h = new r({
          collection: t.get("components"),
          config: this.config,
          sorter: this.sorter,
          opened: this.opt.opened,
          parentView: this,
          parent: t,
          level: d
        }).render().$el;
        return this.config.showWrapper || 1 !== d ? (u.html(this.template(t)), u.find(".".concat(this.clsChildren)).append(h)) : u.append(h), t.get("draggable") && this.config.sortable || u.children(".".concat(this.clsMove)).remove(), !c && (this.className += " ".concat(o, "hide")), l && (this.className += " ".concat(a, "hidden")), u.attr("class", this.className), this.updateOpening(), this.updateStatus(), this.updateVisibility(), this;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(1),
      i = n.n(r),
      o = i.a.View.extend({
        tagName: "style",
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.config = t.config || {};
          var e = this.model,
            n = "change:style change:state change:mediaText";
          this.listenTo(e, n, this.render), this.listenTo(e, "destroy remove", this.remove), this.listenTo(e.get("selectors"), "change", this.render);
        },
        render: function render() {
          var t = this.model.get("important");
          return this.el.innerHTML = this.model.toCSS({
            important: t
          }), this;
        }
      }),
      a = o.extend({
        _createElement: function _createElement(t) {
          return document.createTextNode("");
        },
        render: function render() {
          var t = this.model,
            e = t.get("important");
          return this.el.textContent = t.getDeclaration({
            important: e
          }), this;
        }
      }),
      s = i.a.$,
      l = function l(t, e) {
        return "".concat(t).concat(e ? "-".concat(parseFloat(e)) : "");
      };
    e.a = i.a.View.extend({
      initialize: function initialize(t) {
        var e = t.config || {};
        this.atRules = {}, this.config = e, this.em = e.em, this.pfx = e.stylePrefix || "", this.className = this.pfx + "rules";
        var n = this.collection;
        this.listenTo(n, "add", this.addTo), this.listenTo(n, "reset", this.render);
      },
      addTo: function addTo(t) {
        this.addToCollection(t);
      },
      addToCollection: function addToCollection(t, e) {
        if (this.renderStarted) {
          var n,
            r,
            i = e || null,
            s = {
              model: t,
              config: this.config
            };
          if ("keyframes" === t.get("atRuleType")) {
            var c = t.getAtRule(),
              u = this.atRules[c];
            if (!u) {
              var d = document.createElement("style");
              u = document.createTextNode(""), d.appendChild(document.createTextNode("".concat(c, "{"))), d.appendChild(u), d.appendChild(document.createTextNode("}")), this.atRules[c] = u, n = d;
            }
            r = new a(s), u.appendData(r.render().el.textContent);
          } else n = (r = new o(s)).render().el;
          var h = this.className,
            f = t.get("mediaText"),
            p = l(h),
            g = p;
          if (f && (g = l(h, this.getMediaWidth(f))), n) {
            var v,
              m = i || this.el;
            try {
              v = m.querySelector("#".concat(g));
            } catch (t) {}
            v || (v = m.querySelector("#".concat(p))), v.appendChild(n);
          }
          return n;
        }
      },
      getMediaWidth: function getMediaWidth(t) {
        return t && t.replace("(".concat(this.em.getConfig("mediaCondition"), ": "), "").replace(")", "");
      },
      render: function render() {
        var t = this;
        this.renderStarted = 1, this.atRules = {};
        var e = this.em,
          n = this.$el,
          r = this.className,
          i = this.collection,
          o = document.createDocumentFragment();
        n.empty();
        var a = e.get("DeviceManager").getAll().pluck("priority");
        return a.every(function (t) {
          return t;
        }) && a.unshift(0), a.forEach(function (t) {
          return s('<div id="'.concat(l(r, t), '"></div>')).appendTo(o);
        }), i.each(function (e) {
          return t.addToCollection(e, o);
        }), n.append(o), n.attr("class", r), this;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(2),
      i = n.n(r),
      o = n(1),
      a = n.n(o),
      s = n(0),
      l = n(8),
      c = n.n(l),
      u = n(18);
    function d(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function h(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? d(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var f = a.a.$;
    !function (t, e) {
      var n = {
          beforeShow: d,
          move: d,
          change: d,
          show: d,
          hide: d,
          color: !1,
          flat: !1,
          showInput: !1,
          allowEmpty: !1,
          showButtons: !0,
          clickoutFiresChange: !0,
          showInitial: !1,
          showPalette: !1,
          showPaletteOnly: !1,
          hideAfterPaletteSelect: !1,
          togglePaletteOnly: !1,
          showSelectionPalette: !0,
          localStorageKey: !1,
          appendTo: "body",
          maxSelectionSize: 7,
          cancelText: "cancel",
          chooseText: "choose",
          togglePaletteMoreText: "more",
          togglePaletteLessText: "less",
          clearText: "Clear Color Selection",
          noColorSelectedText: "No Color Selected",
          preferredFormat: !1,
          className: "",
          containerClassName: "",
          replacerClassName: "",
          showAlpha: !1,
          theme: "sp-light",
          palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
          selectionPalette: [],
          disabled: !1,
          offset: null
        },
        r = [],
        i = !!/msie/i.exec(window.navigator.userAgent),
        o = function () {
          function t(t, e) {
            return !!~("" + t).indexOf(e);
          }
          var e = document.createElement("div").style;
          return e.cssText = "background-color:rgba(0,0,0,.5)", t(e.backgroundColor, "rgba") || t(e.backgroundColor, "hsla");
        }(),
        a = ["<div class='sp-replacer'>", "<div class='sp-preview'><div class='sp-preview-inner'></div></div>", "<div class='sp-dd'>&#9660;</div>", "</div>"].join(""),
        s = function () {
          var t = "";
          if (i) for (var e = 1; e <= 6; e++) t += "<div class='sp-" + e + "'></div>";
          return ["<div class='sp-container sp-hidden'>", "<div class='sp-palette-container'>", "<div class='sp-palette sp-thumb sp-cf'></div>", "<div class='sp-palette-button-container sp-cf'>", "<button type='button' class='sp-palette-toggle'></button>", "</div>", "</div>", "<div class='sp-picker-container'>", "<div class='sp-top sp-cf'>", "<div class='sp-fill'></div>", "<div class='sp-top-inner'>", "<div class='sp-color'>", "<div class='sp-sat'>", "<div class='sp-val'>", "<div class='sp-dragger'></div>", "</div>", "</div>", "</div>", "<div class='sp-clear sp-clear-display'>", "</div>", "<div class='sp-hue'>", "<div class='sp-slider'></div>", t, "</div>", "</div>", "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>", "</div>", "<div class='sp-input-container sp-cf'>", "<input class='sp-input' type='text' spellcheck='false'  />", "</div>", "<div class='sp-initial sp-thumb sp-cf'></div>", "<div class='sp-button-container sp-cf'>", "<a class='sp-cancel' href='#'></a>", "<button type='button' class='sp-choose'></button>", "</div>", "</div>", "</div>"].join("");
        }();
      function l(e, n, r, i) {
        for (var a = [], s = 0; s < e.length; s++) {
          var l = e[s];
          if (l) {
            var c = k(l),
              u = c.toHsl().l < .5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
            u += k.equals(n, l) ? " sp-thumb-active" : "";
            var d = c.toString(i.preferredFormat || "rgb"),
              h = o ? "background-color:" + c.toRgbString() : "filter:" + c.toFilter();
            a.push('<span title="' + d + '" data-color="' + c.toRgbString() + '" class="' + u + '"><span class="sp-thumb-inner" style="' + h + ';"></span></span>');
          } else {
            a.push(t("<div />").append(t('<span data-color="" style="background-color:transparent;" class="sp-clear-display"></span>').attr("title", i.noColorSelectedText)).html());
          }
        }
        return "<div class='sp-cf " + r + "'>" + a.join("") + "</div>";
      }
      function u(c, u) {
        var d,
          v,
          m,
          b,
          y = function (e, r) {
            var i = t.extend({}, n, e);
            return i.callbacks = {
              move: f(i.move, r),
              change: f(i.change, r),
              show: f(i.show, r),
              hide: f(i.hide, r),
              beforeShow: f(i.beforeShow, r)
            }, i;
          }(u, c),
          w = y.flat,
          x = y.showSelectionPalette,
          O = y.localStorageKey,
          C = y.theme,
          S = y.callbacks,
          j = (d = Bt, v = 10, function () {
            var t = this,
              e = arguments,
              n = function n() {
                b = null, d.apply(t, e);
              };
            m && clearTimeout(b), !m && b || (b = setTimeout(n, v));
          }),
          T = !1,
          P = !1,
          E = 0,
          D = 0,
          M = 0,
          A = 0,
          L = 0,
          N = 0,
          _ = 0,
          I = 0,
          F = 0,
          V = 0,
          R = 1,
          z = [],
          H = [],
          $ = {},
          B = y.selectionPalette.slice(0),
          W = y.maxSelectionSize,
          U = null,
          q = c.ownerDocument,
          G = (q.body, t(c)),
          K = !1,
          Y = t(s, q).addClass(C),
          X = Y.find(".sp-picker-container"),
          J = Y.find(".sp-color"),
          Z = Y.find(".sp-dragger"),
          Q = Y.find(".sp-hue"),
          tt = Y.find(".sp-slider"),
          et = Y.find(".sp-alpha-inner"),
          nt = Y.find(".sp-alpha"),
          rt = Y.find(".sp-alpha-handle"),
          it = Y.find(".sp-input"),
          ot = Y.find(".sp-palette"),
          at = Y.find(".sp-initial"),
          st = Y.find(".sp-cancel"),
          lt = Y.find(".sp-clear"),
          ct = Y.find(".sp-choose"),
          ut = Y.find(".sp-palette-toggle"),
          dt = G.is("input"),
          ht = dt && "color" === G.attr("type") && g(),
          ft = dt && !w,
          pt = ft ? t(a).addClass(C).addClass(y.className).addClass(y.replacerClassName) : t([]),
          gt = ft ? pt : G,
          vt = pt.find(".sp-preview-inner"),
          mt = y.color || dt && G.val(),
          bt = !1,
          yt = y.preferredFormat,
          wt = !y.showButtons || y.clickoutFiresChange,
          xt = !mt,
          Ot = y.allowEmpty && !ht;
        function Ct() {
          if (y.showPaletteOnly && (y.showPalette = !0), ut.text(y.showPaletteOnly ? y.togglePaletteMoreText : y.togglePaletteLessText), y.palette) {
            z = y.palette.slice(0), H = t.isArray(z[0]) ? z : [z], $ = {};
            for (var e = 0; e < H.length; e++) for (var n = 0; n < H[e].length; n++) {
              var r = k(H[e][n]).toRgbString();
              $[r] = !0;
            }
          }
          Y.toggleClass("sp-flat", w), Y.toggleClass("sp-input-disabled", !y.showInput), Y.toggleClass("sp-alpha-enabled", y.showAlpha), Y.toggleClass("sp-clear-enabled", Ot), Y.toggleClass("sp-buttons-disabled", !y.showButtons), Y.toggleClass("sp-palette-buttons-disabled", !y.togglePaletteOnly), Y.toggleClass("sp-palette-disabled", !y.showPalette), Y.toggleClass("sp-palette-only", y.showPaletteOnly), Y.toggleClass("sp-initial-disabled", !y.showInitial), Y.addClass(y.className).addClass(y.containerClassName), Bt();
        }
        function St() {
          if (O && window.localStorage) {
            try {
              var e = window.localStorage[O].split(",#");
              e.length > 1 && (delete window.localStorage[O], t.each(e, function (t, e) {
                kt(e);
              }));
            } catch (t) {}
            try {
              B = window.localStorage[O].split(";");
            } catch (t) {}
          }
        }
        function kt(e) {
          if (x) {
            var n = k(e).toRgbString();
            if (!$[n] && -1 === t.inArray(n, B)) for (B.push(n); B.length > W;) B.shift();
            if (O && window.localStorage) try {
              window.localStorage[O] = B.join(";");
            } catch (t) {}
          }
        }
        function jt() {
          var e = Vt(),
            n = t.map(H, function (t, n) {
              return l(t, e, "sp-palette-row sp-palette-row-" + n, y);
            });
          St(), B && n.push(l(function () {
            var t = [];
            if (y.showPalette) for (var e = 0; e < B.length; e++) {
              var n = k(B[e]).toRgbString();
              $[n] || t.push(B[e]);
            }
            return t.reverse().slice(0, y.maxSelectionSize);
          }(), e, "sp-palette-row sp-palette-row-selection", y)), ot.html(n.join(""));
        }
        function Tt() {
          if (y.showInitial) {
            var t = bt,
              e = Vt();
            at.html(l([t, e], e, "sp-palette-row-initial", y));
          }
        }
        function Pt() {
          (D <= 0 || E <= 0 || A <= 0) && Bt(), P = !0, Y.addClass("sp-dragging"), U = null, G.trigger("dragstart.spectrum", [Vt()]);
        }
        function Et() {
          P = !1, Y.removeClass("sp-dragging"), G.trigger("dragstop.spectrum", [Vt()]);
        }
        function Dt() {
          var t = it.val();
          if (null !== t && "" !== t || !Ot) {
            var e = k(t);
            e.isValid() ? (Ft(e), $t(!0)) : it.addClass("sp-validation-error");
          } else Ft(null), $t(!0);
        }
        function Mt() {
          T ? _t() : At();
        }
        function At() {
          var e = t.Event("beforeShow.spectrum");
          if (T) Bt();else if (G.trigger("beforeShow.spectrum", [Vt()]), !1 !== S.beforeShow(Vt()) && !e.isDefaultPrevented()) {
            !function () {
              for (var t = 0; t < r.length; t++) r[t] && r[t].hide();
            }(), T = !0;
            var n = t(q);
            n.bind("keydown.spectrum", Lt), n.bind("click.spectrum", Nt), t(window).bind("resize.spectrum", j), pt.addClass("sp-active"), Y.removeClass("sp-hidden"), Bt(), zt(), bt = Vt(), Tt(), S.show(bt), G.trigger("show.spectrum", [bt]);
          }
        }
        function Lt(t) {
          27 === t.keyCode && _t();
        }
        function Nt(t) {
          2 != t.button && (P || (wt ? $t(!0) : It(), _t()));
        }
        function _t() {
          T && !w && (T = !1, t(q).unbind("keydown.spectrum", Lt), t(q).unbind("click.spectrum", Nt), t(window).unbind("resize.spectrum", j), pt.removeClass("sp-active"), Y.addClass("sp-hidden"), S.hide(Vt()), G.trigger("hide.spectrum", [Vt()]));
        }
        function It() {
          Ft(bt, !0);
        }
        function Ft(t, e) {
          var n, r;
          k.equals(t, Vt()) ? zt() : (!t && Ot ? xt = !0 : (xt = !1, r = (n = k(t)).toHsv(), I = r.h % 360 / 360, F = r.s, V = r.v, R = r.a), zt(), n && n.isValid() && !e && (yt = y.preferredFormat || n.getFormat()));
        }
        function Vt(t) {
          return t = t || {}, Ot && xt ? null : k.fromRatio({
            h: I,
            s: F,
            v: V,
            a: Math.round(100 * R) / 100
          }, {
            format: t.format || yt
          });
        }
        function Rt() {
          zt(), S.move(Vt()), G.trigger("move.spectrum", [Vt()]);
        }
        function zt() {
          it.removeClass("sp-validation-error"), Ht();
          var t = k.fromRatio({
            h: I,
            s: 1,
            v: 1
          });
          J.css("background-color", t.toHexString());
          var e = yt;
          R < 1 && (0 !== R || "name" !== e) && ("hex" !== e && "hex3" !== e && "hex6" !== e && "name" !== e || (e = "rgb"));
          var n = Vt({
              format: e
            }),
            r = "";
          if (vt.removeClass("sp-clear-display"), vt.css("background-color", "transparent"), !n && Ot) vt.addClass("sp-clear-display");else {
            var a = n.toHexString(),
              s = n.toRgbString();
            if (o || 1 === n.alpha ? vt.css("background-color", s) : (vt.css("background-color", "transparent"), vt.css("filter", n.toFilter())), y.showAlpha) {
              var l = n.toRgb();
              l.a = 0;
              var c = k(l).toRgbString(),
                u = "linear-gradient(left, " + c + ", " + a + ")";
              i ? et.css("filter", k(c).toFilter({
                gradientType: 1
              }, a)) : (et.css("background", "-webkit-" + u), et.css("background", "-moz-" + u), et.css("background", "-ms-" + u), et.css("background", "linear-gradient(to right, " + c + ", " + a + ")"));
            }
            r = n.toString(e);
          }
          y.showInput && it.val(r), y.showPalette && jt(), Tt();
        }
        function Ht() {
          var t = F,
            e = V;
          if (Ot && xt) rt.hide(), tt.hide(), Z.hide();else {
            rt.show(), tt.show(), Z.show();
            var n = t * E,
              r = D - e * D;
            n = Math.max(-M, Math.min(E - M, n - M)), r = Math.max(-M, Math.min(D - M, r - M)), Z.css({
              top: r + "px",
              left: n + "px"
            });
            var i = R * L;
            rt.css({
              left: i - N / 2 + "px"
            });
            var o = I * A;
            tt.css({
              top: o - _ + "px"
            });
          }
        }
        function $t(t) {
          var e = Vt(),
            n = "",
            r = !k.equals(e, bt);
          e && (n = e.toString(yt), kt(e)), dt && G.val(n), t && r && (S.change(e), G.trigger("change", [e]));
        }
        function Bt() {
          T && (E = J.width(), D = J.height(), M = Z.height(), Q.width(), A = Q.height(), _ = tt.height(), L = nt.width(), N = rt.width(), w || (Y.css("position", "absolute"), y.offset ? Y.offset(y.offset) : Y.offset(function (e, n) {
            var r = e.outerWidth(),
              i = e.outerHeight(),
              o = n.outerHeight(),
              a = e[0].ownerDocument,
              s = a.documentElement,
              l = s.clientWidth,
              c = s.clientHeight,
              u = t(a).scrollLeft(),
              d = t(a).scrollTop(),
              h = l + u,
              f = c + d,
              p = n.offset();
            return p.top += o, p.left -= Math.min(p.left, p.left + r > h && h > r ? Math.abs(p.left + r - h) : 0), p.top -= Math.min(p.top, p.top + i > f && f > i ? Math.abs(i + o - 0) : 0), p;
          }(Y, gt))), Ht(), y.showPalette && jt(), G.trigger("reflow.spectrum"));
        }
        function Wt() {
          _t(), K = !0, G.attr("disabled", !0), gt.addClass("sp-disabled");
        }
        !function () {
          if (i && Y.find("*:not(input)").attr("unselectable", "on"), Ct(), ft && G.after(pt).hide(), Ot || lt.hide(), w) G.after(Y).hide();else {
            var e = "parent" === y.appendTo ? G.parent() : t(y.appendTo);
            1 !== e.length && (e = t("body")), e.append(Y);
          }
          function n(e) {
            return e.data && e.data.ignore ? (Ft(t(e.target).closest(".sp-thumb-el").data("color")), Rt()) : (Ft(t(e.target).closest(".sp-thumb-el").data("color")), Rt(), $t(!0), y.hideAfterPaletteSelect && _t()), !1;
          }
          St(), gt.bind("click.spectrum touchstart.spectrum", function (e) {
            K || Mt(), e.stopPropagation(), t(e.target).is("input") || e.preventDefault();
          }), (G.is(":disabled") || !0 === y.disabled) && Wt(), Y.click(h), it.change(Dt), it.bind("paste", function () {
            setTimeout(Dt, 1);
          }), it.keydown(function (t) {
            13 == t.keyCode && Dt();
          }), st.text(y.cancelText), st.bind("click.spectrum", function (t) {
            t.stopPropagation(), t.preventDefault(), It(), _t();
          }), lt.attr("title", y.clearText), lt.bind("click.spectrum", function (t) {
            t.stopPropagation(), t.preventDefault(), xt = !0, Rt(), w && $t(!0);
          }), ct.text(y.chooseText), ct.bind("click.spectrum", function (t) {
            t.stopPropagation(), t.preventDefault(), i && it.is(":focus") && it.trigger("change"), it.hasClass("sp-validation-error") || ($t(!0), _t());
          }), ut.text(y.showPaletteOnly ? y.togglePaletteMoreText : y.togglePaletteLessText), ut.bind("click.spectrum", function (t) {
            t.stopPropagation(), t.preventDefault(), y.showPaletteOnly = !y.showPaletteOnly, y.showPaletteOnly || w || Y.css("left", "-=" + (X.outerWidth(!0) + 5)), Ct();
          }), p(nt, function (t, e, n) {
            R = t / L, xt = !1, n.shiftKey && (R = Math.round(10 * R) / 10), Rt();
          }, Pt, Et), p(Q, function (t, e) {
            I = parseFloat(e / A), xt = !1, y.showAlpha || (R = 1), Rt();
          }, Pt, Et), p(J, function (t, e, n) {
            if (n.shiftKey) {
              if (!U) {
                var r = F * E,
                  i = D - V * D,
                  o = Math.abs(t - r) > Math.abs(e - i);
                U = o ? "x" : "y";
              }
            } else U = null;
            var a = !U || "y" === U;
            (!U || "x" === U) && (F = parseFloat(t / E)), a && (V = parseFloat((D - e) / D)), xt = !1, y.showAlpha || (R = 1), Rt();
          }, Pt, Et), mt ? (Ft(mt), zt(), yt = y.preferredFormat || k(mt).format, kt(mt)) : zt(), w && At();
          var r = i ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
          ot.delegate(".sp-thumb-el", r, n), at.delegate(".sp-thumb-el:nth-child(1)", r, {
            ignore: !0
          }, n);
        }();
        var Ut = {
          show: At,
          hide: _t,
          toggle: Mt,
          reflow: Bt,
          option: function option(n, r) {
            return n === e ? t.extend({}, y) : r === e ? y[n] : (y[n] = r, "preferredFormat" === n && (yt = y.preferredFormat), void Ct());
          },
          enable: function enable() {
            K = !1, G.attr("disabled", !1), gt.removeClass("sp-disabled");
          },
          disable: Wt,
          offset: function offset(t) {
            y.offset = t, Bt();
          },
          set: function set(t) {
            Ft(t), $t();
          },
          get: Vt,
          destroy: function destroy() {
            G.show(), gt.unbind("click.spectrum touchstart.spectrum"), Y.remove(), pt.remove(), r[Ut.id] = null;
          },
          container: Y
        };
        return Ut.id = r.push(Ut) - 1, Ut;
      }
      function d() {}
      function h(t) {
        t.stopPropagation();
      }
      function f(t, e) {
        var n = Array.prototype.slice,
          r = n.call(arguments, 2);
        return function () {
          return t.apply(e, r.concat(n.call(arguments)));
        };
      }
      function p(e, n, r, o) {
        n = n || function () {}, r = r || function () {}, o = o || function () {};
        var a = document,
          s = !1,
          l = {},
          c = 0,
          u = 0,
          d = "ontouchstart" in window,
          h = {};
        function f(t) {
          t.stopPropagation && t.stopPropagation(), t.preventDefault && t.preventDefault(), t.returnValue = !1;
        }
        function p(t) {
          if (s) {
            if (i && a.documentMode < 9 && !t.button) return g();
            var r = t && t.touches && t.touches[0],
              o = r && r.pageX || t.pageX,
              h = r && r.pageY || t.pageY,
              p = Math.max(0, Math.min(o - l.left, u)),
              v = Math.max(0, Math.min(h - l.top, c));
            d && f(t), n.apply(e, [p, v, t]);
          }
        }
        function g() {
          s && (t(a).unbind(h), t(a.body).removeClass("sp-dragging"), setTimeout(function () {
            o.apply(e, arguments);
          }, 0)), s = !1;
        }
        h.selectstart = f, h.dragstart = f, h["touchmove mousemove"] = p, h["touchend mouseup"] = g, t(e).bind("touchstart mousedown", function (n) {
          var i = n.which ? 3 == n.which : 2 == n.button;
          i || s || !1 !== r.apply(e, arguments) && (s = !0, c = t(e).height(), u = t(e).width(), l = t(e).offset(), t(a).bind(h), t(a.body).addClass("sp-dragging"), p(n), f(n));
        });
      }
      function g() {
        return t.fn.spectrum.inputTypeColorSupport();
      }
      var v = "spectrum.id";
      t.fn.spectrum = function (e, n) {
        if ("string" == typeof e) {
          var i = this,
            o = Array.prototype.slice.call(arguments, 1);
          return this.each(function () {
            var n = r[t(this).data(v)];
            if (n) {
              var a = n[e];
              if (!a) throw new Error("Spectrum: no such method: '" + e + "'");
              "get" == e ? i = n.get() : "container" == e ? i = n.container : "option" == e ? i = n.option.apply(n, o) : "destroy" == e ? (n.destroy(), t(this).removeData(v)) : a.apply(n, o);
            }
          }), i;
        }
        return this.spectrum("destroy").each(function () {
          var n = u(this, t.extend({}, e, t(this).data()));
          t(this).data(v, n.id);
        });
      }, t.fn.spectrum.load = !0, t.fn.spectrum.loadOpts = {}, t.fn.spectrum.draggable = p, t.fn.spectrum.defaults = n, t.fn.spectrum.inputTypeColorSupport = function e() {
        if (void 0 === e._cachedResult) {
          var n = t("<input type='color'/>")[0];
          e._cachedResult = "color" === n.type && "" !== n.value;
        }
        return e._cachedResult;
      }, t.spectrum = {}, t.spectrum.localization = {}, t.spectrum.palettes = {}, t.fn.spectrum.processNativeColorInputs = function () {
        var e = t("input[type=color]");
        e.length && !g() && e.spectrum({
          preferredFormat: "hex6"
        });
      };
      var m = /^[\s,#]+/,
        b = /\s+$/,
        y = 0,
        w = Math,
        x = w.round,
        O = w.min,
        C = w.max,
        S = w.random,
        k = function t(e, n) {
          if (n = n || {}, (e = e || "") instanceof t) return e;
          if (!(this instanceof t)) return new t(e, n);
          var r = function (t) {
            var e = {
                r: 0,
                g: 0,
                b: 0
              },
              n = 1,
              r = !1,
              i = !1;
            "string" == typeof t && (t = function (t) {
              t = t.replace(m, "").replace(b, "").toLowerCase();
              var e,
                n = !1;
              if (B[t]) t = B[t], n = !0;else if ("transparent" == t) return {
                r: 0,
                g: 0,
                b: 0,
                a: 0,
                format: "name"
              };
              if (e = tt.rgb.exec(t)) return {
                r: e[1],
                g: e[2],
                b: e[3]
              };
              if (e = tt.rgba.exec(t)) return {
                r: e[1],
                g: e[2],
                b: e[3],
                a: e[4]
              };
              if (e = tt.hsl.exec(t)) return {
                h: e[1],
                s: e[2],
                l: e[3]
              };
              if (e = tt.hsla.exec(t)) return {
                h: e[1],
                s: e[2],
                l: e[3],
                a: e[4]
              };
              if (e = tt.hsv.exec(t)) return {
                h: e[1],
                s: e[2],
                v: e[3]
              };
              if (e = tt.hsva.exec(t)) return {
                h: e[1],
                s: e[2],
                v: e[3],
                a: e[4]
              };
              if (e = tt.hex8.exec(t)) return {
                a: (r = e[1], K(r) / 255),
                r: K(e[2]),
                g: K(e[3]),
                b: K(e[4]),
                format: n ? "name" : "hex8"
              };
              var r;
              if (e = tt.hex6.exec(t)) return {
                r: K(e[1]),
                g: K(e[2]),
                b: K(e[3]),
                format: n ? "name" : "hex"
              };
              if (e = tt.hex3.exec(t)) return {
                r: K(e[1] + "" + e[1]),
                g: K(e[2] + "" + e[2]),
                b: K(e[3] + "" + e[3]),
                format: n ? "name" : "hex"
              };
              return !1;
            }(t));
            "object" == c()(t) && (t.hasOwnProperty("r") && t.hasOwnProperty("g") && t.hasOwnProperty("b") ? (o = t.r, a = t.g, s = t.b, e = {
              r: 255 * q(o, 255),
              g: 255 * q(a, 255),
              b: 255 * q(s, 255)
            }, r = !0, i = "%" === String(t.r).substr(-1) ? "prgb" : "rgb") : t.hasOwnProperty("h") && t.hasOwnProperty("s") && t.hasOwnProperty("v") ? (t.s = X(t.s), t.v = X(t.v), e = function (t, e, n) {
              t = 6 * q(t, 360), e = q(e, 100), n = q(n, 100);
              var r = w.floor(t),
                i = t - r,
                o = n * (1 - e),
                a = n * (1 - i * e),
                s = n * (1 - (1 - i) * e),
                l = r % 6;
              return {
                r: 255 * [n, a, o, o, s, n][l],
                g: 255 * [s, n, n, a, o, o][l],
                b: 255 * [o, o, s, n, n, a][l]
              };
            }(t.h, t.s, t.v), r = !0, i = "hsv") : t.hasOwnProperty("h") && t.hasOwnProperty("s") && t.hasOwnProperty("l") && (t.s = X(t.s), t.l = X(t.l), e = function (t, e, n) {
              var r, i, o;
              function a(t, e, n) {
                return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
              }
              if (t = q(t, 360), e = q(e, 100), n = q(n, 100), 0 === e) r = i = o = n;else {
                var s = n < .5 ? n * (1 + e) : n + e - n * e,
                  l = 2 * n - s;
                r = a(l, s, t + 1 / 3), i = a(l, s, t), o = a(l, s, t - 1 / 3);
              }
              return {
                r: 255 * r,
                g: 255 * i,
                b: 255 * o
              };
            }(t.h, t.s, t.l), r = !0, i = "hsl"), t.hasOwnProperty("a") && (n = t.a));
            var o, a, s;
            return n = U(n), {
              ok: r,
              format: t.format || i,
              r: O(255, C(e.r, 0)),
              g: O(255, C(e.g, 0)),
              b: O(255, C(e.b, 0)),
              a: n
            };
          }(e);
          this._originalInput = e, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = x(100 * this._a) / 100, this._format = n.format || r.format, this._gradientType = n.gradientType, this._r < 1 && (this._r = x(this._r)), this._g < 1 && (this._g = x(this._g)), this._b < 1 && (this._b = x(this._b)), this._ok = r.ok, this._tc_id = y++;
        };
      function j(t, e, n) {
        t = q(t, 255), e = q(e, 255), n = q(n, 255);
        var r,
          i,
          o = C(t, e, n),
          a = O(t, e, n),
          s = (o + a) / 2;
        if (o == a) r = i = 0;else {
          var l = o - a;
          switch (i = s > .5 ? l / (2 - o - a) : l / (o + a), o) {
            case t:
              r = (e - n) / l + (e < n ? 6 : 0);
              break;
            case e:
              r = (n - t) / l + 2;
              break;
            case n:
              r = (t - e) / l + 4;
          }
          r /= 6;
        }
        return {
          h: r,
          s: i,
          l: s
        };
      }
      function T(t, e, n) {
        t = q(t, 255), e = q(e, 255), n = q(n, 255);
        var r,
          i,
          o = C(t, e, n),
          a = O(t, e, n),
          s = o,
          l = o - a;
        if (i = 0 === o ? 0 : l / o, o == a) r = 0;else {
          switch (o) {
            case t:
              r = (e - n) / l + (e < n ? 6 : 0);
              break;
            case e:
              r = (n - t) / l + 2;
              break;
            case n:
              r = (t - e) / l + 4;
          }
          r /= 6;
        }
        return {
          h: r,
          s: i,
          v: s
        };
      }
      function P(t, e, n, r) {
        var i = [Y(x(t).toString(16)), Y(x(e).toString(16)), Y(x(n).toString(16))];
        return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
      }
      function E(t, e, n, r) {
        var i;
        return [Y((i = r, Math.round(255 * parseFloat(i)).toString(16))), Y(x(t).toString(16)), Y(x(e).toString(16)), Y(x(n).toString(16))].join("");
      }
      function D(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = k(t).toHsl();
        return n.s -= e / 100, n.s = G(n.s), k(n);
      }
      function M(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = k(t).toHsl();
        return n.s += e / 100, n.s = G(n.s), k(n);
      }
      function A(t) {
        return k(t).desaturate(100);
      }
      function L(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = k(t).toHsl();
        return n.l += e / 100, n.l = G(n.l), k(n);
      }
      function N(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = k(t).toRgb();
        return n.r = C(0, O(255, n.r - x(-e / 100 * 255))), n.g = C(0, O(255, n.g - x(-e / 100 * 255))), n.b = C(0, O(255, n.b - x(-e / 100 * 255))), k(n);
      }
      function _(t, e) {
        e = 0 === e ? 0 : e || 10;
        var n = k(t).toHsl();
        return n.l -= e / 100, n.l = G(n.l), k(n);
      }
      function I(t, e) {
        var n = k(t).toHsl(),
          r = (x(n.h) + e) % 360;
        return n.h = r < 0 ? 360 + r : r, k(n);
      }
      function F(t) {
        var e = k(t).toHsl();
        return e.h = (e.h + 180) % 360, k(e);
      }
      function V(t) {
        var e = k(t).toHsl(),
          n = e.h;
        return [k(t), k({
          h: (n + 120) % 360,
          s: e.s,
          l: e.l
        }), k({
          h: (n + 240) % 360,
          s: e.s,
          l: e.l
        })];
      }
      function R(t) {
        var e = k(t).toHsl(),
          n = e.h;
        return [k(t), k({
          h: (n + 90) % 360,
          s: e.s,
          l: e.l
        }), k({
          h: (n + 180) % 360,
          s: e.s,
          l: e.l
        }), k({
          h: (n + 270) % 360,
          s: e.s,
          l: e.l
        })];
      }
      function z(t) {
        var e = k(t).toHsl(),
          n = e.h;
        return [k(t), k({
          h: (n + 72) % 360,
          s: e.s,
          l: e.l
        }), k({
          h: (n + 216) % 360,
          s: e.s,
          l: e.l
        })];
      }
      function H(t, e, n) {
        e = e || 6, n = n || 30;
        var r = k(t).toHsl(),
          i = 360 / n,
          o = [k(t)];
        for (r.h = (r.h - (i * e >> 1) + 720) % 360; --e;) r.h = (r.h + i) % 360, o.push(k(r));
        return o;
      }
      function $(t, e) {
        e = e || 6;
        for (var n = k(t).toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / e; e--;) a.push(k({
          h: r,
          s: i,
          v: o
        })), o = (o + s) % 1;
        return a;
      }
      k.prototype = {
        isDark: function isDark() {
          return this.getBrightness() < 128;
        },
        isLight: function isLight() {
          return !this.isDark();
        },
        isValid: function isValid() {
          return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
          return this._originalInput;
        },
        getFormat: function getFormat() {
          return this._format;
        },
        getAlpha: function getAlpha() {
          return this._a;
        },
        getBrightness: function getBrightness() {
          var t = this.toRgb();
          return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3;
        },
        setAlpha: function setAlpha(t) {
          return this._a = U(t), this._roundA = x(100 * this._a) / 100, this;
        },
        toHsv: function toHsv() {
          var t = T(this._r, this._g, this._b);
          return {
            h: 360 * t.h,
            s: t.s,
            v: t.v,
            a: this._a
          };
        },
        toHsvString: function toHsvString() {
          var t = T(this._r, this._g, this._b),
            e = x(360 * t.h),
            n = x(100 * t.s),
            r = x(100 * t.v);
          return 1 == this._a ? "hsv(" + e + ", " + n + "%, " + r + "%)" : "hsva(" + e + ", " + n + "%, " + r + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
          var t = j(this._r, this._g, this._b);
          return {
            h: 360 * t.h,
            s: t.s,
            l: t.l,
            a: this._a
          };
        },
        toHslString: function toHslString() {
          var t = j(this._r, this._g, this._b),
            e = x(360 * t.h),
            n = x(100 * t.s),
            r = x(100 * t.l);
          return 1 == this._a ? "hsl(" + e + ", " + n + "%, " + r + "%)" : "hsla(" + e + ", " + n + "%, " + r + "%, " + this._roundA + ")";
        },
        toHex: function toHex(t) {
          return P(this._r, this._g, this._b, t);
        },
        toHexString: function toHexString(t) {
          return "#" + this.toHex(t);
        },
        toHex8: function toHex8() {
          return E(this._r, this._g, this._b, this._a);
        },
        toHex8String: function toHex8String() {
          return "#" + this.toHex8();
        },
        toRgb: function toRgb() {
          return {
            r: x(this._r),
            g: x(this._g),
            b: x(this._b),
            a: this._a
          };
        },
        toRgbString: function toRgbString() {
          return 1 == this._a ? "rgb(" + x(this._r) + ", " + x(this._g) + ", " + x(this._b) + ")" : "rgba(" + x(this._r) + ", " + x(this._g) + ", " + x(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
          return {
            r: x(100 * q(this._r, 255)) + "%",
            g: x(100 * q(this._g, 255)) + "%",
            b: x(100 * q(this._b, 255)) + "%",
            a: this._a
          };
        },
        toPercentageRgbString: function toPercentageRgbString() {
          return 1 == this._a ? "rgb(" + x(100 * q(this._r, 255)) + "%, " + x(100 * q(this._g, 255)) + "%, " + x(100 * q(this._b, 255)) + "%)" : "rgba(" + x(100 * q(this._r, 255)) + "%, " + x(100 * q(this._g, 255)) + "%, " + x(100 * q(this._b, 255)) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
          return 0 === this._a ? "transparent" : !(this._a < 1) && (W[P(this._r, this._g, this._b, !0)] || !1);
        },
        toFilter: function toFilter(t) {
          var e = "#" + E(this._r, this._g, this._b, this._a),
            n = e,
            r = this._gradientType ? "GradientType = 1, " : "";
          t && (n = k(t).toHex8String());
          return "progid:DXImageTransform.Microsoft.gradient(" + r + "startColorstr=" + e + ",endColorstr=" + n + ")";
        },
        toString: function toString(t) {
          var e = !!t;
          t = t || this._format;
          var n = !1,
            r = this._a < 1 && this._a >= 0;
          return e || !r || "hex" !== t && "hex6" !== t && "hex3" !== t && "name" !== t ? ("rgb" === t && (n = this.toRgbString()), "prgb" === t && (n = this.toPercentageRgbString()), "hex" !== t && "hex6" !== t || (n = this.toHexString()), "hex3" === t && (n = this.toHexString(!0)), "hex8" === t && (n = this.toHex8String()), "name" === t && (n = this.toName()), "hsl" === t && (n = this.toHslString()), "hsv" === t && (n = this.toHsvString()), n || this.toHexString()) : "name" === t && 0 === this._a ? this.toName() : this.toRgbString();
        },
        _applyModification: function _applyModification(t, e) {
          var n = t.apply(null, [this].concat([].slice.call(e)));
          return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
        },
        lighten: function lighten() {
          return this._applyModification(L, arguments);
        },
        brighten: function brighten() {
          return this._applyModification(N, arguments);
        },
        darken: function darken() {
          return this._applyModification(_, arguments);
        },
        desaturate: function desaturate() {
          return this._applyModification(D, arguments);
        },
        saturate: function saturate() {
          return this._applyModification(M, arguments);
        },
        greyscale: function greyscale() {
          return this._applyModification(A, arguments);
        },
        spin: function spin() {
          return this._applyModification(I, arguments);
        },
        _applyCombination: function _applyCombination(t, e) {
          return t.apply(null, [this].concat([].slice.call(e)));
        },
        analogous: function analogous() {
          return this._applyCombination(H, arguments);
        },
        complement: function complement() {
          return this._applyCombination(F, arguments);
        },
        monochromatic: function monochromatic() {
          return this._applyCombination($, arguments);
        },
        splitcomplement: function splitcomplement() {
          return this._applyCombination(z, arguments);
        },
        triad: function triad() {
          return this._applyCombination(V, arguments);
        },
        tetrad: function tetrad() {
          return this._applyCombination(R, arguments);
        }
      }, k.fromRatio = function (t, e) {
        if ("object" == c()(t)) {
          var n = {};
          for (var r in t) t.hasOwnProperty(r) && (n[r] = "a" === r ? t[r] : X(t[r]));
          t = n;
        }
        return k(t, e);
      }, k.equals = function (t, e) {
        return !(!t || !e) && k(t).toRgbString() == k(e).toRgbString();
      }, k.random = function () {
        return k.fromRatio({
          r: S(),
          g: S(),
          b: S()
        });
      }, k.mix = function (t, e, n) {
        n = 0 === n ? 0 : n || 50;
        var r,
          i = k(t).toRgb(),
          o = k(e).toRgb(),
          a = n / 100,
          s = 2 * a - 1,
          l = o.a - i.a,
          c = 1 - (r = ((r = s * l == -1 ? s : (s + l) / (1 + s * l)) + 1) / 2),
          u = {
            r: o.r * r + i.r * c,
            g: o.g * r + i.g * c,
            b: o.b * r + i.b * c,
            a: o.a * a + i.a * (1 - a)
          };
        return k(u);
      }, k.readability = function (t, e) {
        var n = k(t),
          r = k(e),
          i = n.toRgb(),
          o = r.toRgb(),
          a = n.getBrightness(),
          s = r.getBrightness(),
          l = Math.max(i.r, o.r) - Math.min(i.r, o.r) + Math.max(i.g, o.g) - Math.min(i.g, o.g) + Math.max(i.b, o.b) - Math.min(i.b, o.b);
        return {
          brightness: Math.abs(a - s),
          color: l
        };
      }, k.isReadable = function (t, e) {
        var n = k.readability(t, e);
        return n.brightness > 125 && n.color > 500;
      }, k.mostReadable = function (t, e) {
        for (var n = null, r = 0, i = !1, o = 0; o < e.length; o++) {
          var a = k.readability(t, e[o]),
            s = a.brightness > 125 && a.color > 500,
            l = a.brightness / 125 * 3 + a.color / 500;
          (s && !i || s && i && l > r || !s && !i && l > r) && (i = s, r = l, n = k(e[o]));
        }
        return n;
      };
      var B = k.names = {
          aliceblue: "f0f8ff",
          antiquewhite: "faebd7",
          aqua: "0ff",
          aquamarine: "7fffd4",
          azure: "f0ffff",
          beige: "f5f5dc",
          bisque: "ffe4c4",
          black: "000",
          blanchedalmond: "ffebcd",
          blue: "00f",
          blueviolet: "8a2be2",
          brown: "a52a2a",
          burlywood: "deb887",
          burntsienna: "ea7e5d",
          cadetblue: "5f9ea0",
          chartreuse: "7fff00",
          chocolate: "d2691e",
          coral: "ff7f50",
          cornflowerblue: "6495ed",
          cornsilk: "fff8dc",
          crimson: "dc143c",
          cyan: "0ff",
          darkblue: "00008b",
          darkcyan: "008b8b",
          darkgoldenrod: "b8860b",
          darkgray: "a9a9a9",
          darkgreen: "006400",
          darkgrey: "a9a9a9",
          darkkhaki: "bdb76b",
          darkmagenta: "8b008b",
          darkolivegreen: "556b2f",
          darkorange: "ff8c00",
          darkorchid: "9932cc",
          darkred: "8b0000",
          darksalmon: "e9967a",
          darkseagreen: "8fbc8f",
          darkslateblue: "483d8b",
          darkslategray: "2f4f4f",
          darkslategrey: "2f4f4f",
          darkturquoise: "00ced1",
          darkviolet: "9400d3",
          deeppink: "ff1493",
          deepskyblue: "00bfff",
          dimgray: "696969",
          dimgrey: "696969",
          dodgerblue: "1e90ff",
          firebrick: "b22222",
          floralwhite: "fffaf0",
          forestgreen: "228b22",
          fuchsia: "f0f",
          gainsboro: "dcdcdc",
          ghostwhite: "f8f8ff",
          gold: "ffd700",
          goldenrod: "daa520",
          gray: "808080",
          green: "008000",
          greenyellow: "adff2f",
          grey: "808080",
          honeydew: "f0fff0",
          hotpink: "ff69b4",
          indianred: "cd5c5c",
          indigo: "4b0082",
          ivory: "fffff0",
          khaki: "f0e68c",
          lavender: "e6e6fa",
          lavenderblush: "fff0f5",
          lawngreen: "7cfc00",
          lemonchiffon: "fffacd",
          lightblue: "add8e6",
          lightcoral: "f08080",
          lightcyan: "e0ffff",
          lightgoldenrodyellow: "fafad2",
          lightgray: "d3d3d3",
          lightgreen: "90ee90",
          lightgrey: "d3d3d3",
          lightpink: "ffb6c1",
          lightsalmon: "ffa07a",
          lightseagreen: "20b2aa",
          lightskyblue: "87cefa",
          lightslategray: "789",
          lightslategrey: "789",
          lightsteelblue: "b0c4de",
          lightyellow: "ffffe0",
          lime: "0f0",
          limegreen: "32cd32",
          linen: "faf0e6",
          magenta: "f0f",
          maroon: "800000",
          mediumaquamarine: "66cdaa",
          mediumblue: "0000cd",
          mediumorchid: "ba55d3",
          mediumpurple: "9370db",
          mediumseagreen: "3cb371",
          mediumslateblue: "7b68ee",
          mediumspringgreen: "00fa9a",
          mediumturquoise: "48d1cc",
          mediumvioletred: "c71585",
          midnightblue: "191970",
          mintcream: "f5fffa",
          mistyrose: "ffe4e1",
          moccasin: "ffe4b5",
          navajowhite: "ffdead",
          navy: "000080",
          oldlace: "fdf5e6",
          olive: "808000",
          olivedrab: "6b8e23",
          orange: "ffa500",
          orangered: "ff4500",
          orchid: "da70d6",
          palegoldenrod: "eee8aa",
          palegreen: "98fb98",
          paleturquoise: "afeeee",
          palevioletred: "db7093",
          papayawhip: "ffefd5",
          peachpuff: "ffdab9",
          peru: "cd853f",
          pink: "ffc0cb",
          plum: "dda0dd",
          powderblue: "b0e0e6",
          purple: "800080",
          rebeccapurple: "663399",
          red: "f00",
          rosybrown: "bc8f8f",
          royalblue: "4169e1",
          saddlebrown: "8b4513",
          salmon: "fa8072",
          sandybrown: "f4a460",
          seagreen: "2e8b57",
          seashell: "fff5ee",
          sienna: "a0522d",
          silver: "c0c0c0",
          skyblue: "87ceeb",
          slateblue: "6a5acd",
          slategray: "708090",
          slategrey: "708090",
          snow: "fffafa",
          springgreen: "00ff7f",
          steelblue: "4682b4",
          tan: "d2b48c",
          teal: "008080",
          thistle: "d8bfd8",
          tomato: "ff6347",
          turquoise: "40e0d0",
          violet: "ee82ee",
          wheat: "f5deb3",
          white: "fff",
          whitesmoke: "f5f5f5",
          yellow: "ff0",
          yellowgreen: "9acd32"
        },
        W = k.hexNames = function (t) {
          var e = {};
          for (var n in t) t.hasOwnProperty(n) && (e[t[n]] = n);
          return e;
        }(B);
      function U(t) {
        return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
      }
      function q(t, e) {
        (function (t) {
          return "string" == typeof t && -1 != t.indexOf(".") && 1 === parseFloat(t);
        })(t) && (t = "100%");
        var n = function (t) {
          return "string" == typeof t && -1 != t.indexOf("%");
        }(t);
        return t = O(e, C(0, parseFloat(t))), n && (t = parseInt(t * e, 10) / 100), w.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e);
      }
      function G(t) {
        return O(1, C(0, t));
      }
      function K(t) {
        return parseInt(t, 16);
      }
      function Y(t) {
        return 1 == t.length ? "0" + t : "" + t;
      }
      function X(t) {
        return t <= 1 && (t = 100 * t + "%"), t;
      }
      var J,
        Z,
        Q,
        tt = (Z = "[\\s|\\(]+(" + (J = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")\\s*\\)?", Q = "[\\s|\\(]+(" + J + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")\\s*\\)?", {
          rgb: new RegExp("rgb" + Z),
          rgba: new RegExp("rgba" + Q),
          hsl: new RegExp("hsl" + Z),
          hsla: new RegExp("hsla" + Q),
          hsv: new RegExp("hsv" + Z),
          hsva: new RegExp("hsva" + Q),
          hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        });
      window.tinycolor = k, t(function () {
        t.fn.spectrum.load && t.fn.spectrum.processNativeColorInputs();
      });
    }(f);
    e.a = u.a.extend({
      template: function template() {
        var t = this.ppfx;
        return '\n      <div class="'.concat(this.holderClass(), '"></div>\n      <div class="').concat(t, 'field-colorp">\n        <div class="').concat(t, 'field-colorp-c" data-colorp-c>\n          <div class="').concat(t, 'checker-bg"></div>\n        </div>\n      </div>\n    ');
      },
      inputClass: function inputClass() {
        var t = this.ppfx;
        return "".concat(t, "field ").concat(t, "field-color");
      },
      holderClass: function holderClass() {
        return "".concat(this.ppfx, "input-holder");
      },
      setValue: function setValue(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = this.model,
          r = n.get("defaults"),
          i = Object(s.isUndefined)(t) ? Object(s.isUndefined)(r) ? "" : r : t,
          o = this.getInputEl(),
          a = this.getColorEl(),
          l = "none" != i ? i : "";
        o.value = i, a.get(0).style.backgroundColor = l, (e.fromTarget || e.fromInput && !e.avoidStore) && (a.spectrum("set", l), this.noneColor = "none" == i);
      },
      getColorEl: function getColorEl() {
        if (!this.colorEl) {
          var t,
            e = this.em,
            n = this,
            r = this.ppfx,
            i = this.model,
            o = f('<div class="'.concat(this.ppfx, 'field-color-picker"></div>')),
            a = o.get(0).style,
            s = e && e.config ? e.config.el : "",
            l = e && e.getConfig && e.getConfig("colorPicker") || {},
            c = function c(t) {
              return (1 == t.getAlpha() ? t.toHexString() : t.toRgbString()).replace(/ /g, "");
            },
            u = 0;
          this.$el.find("[data-colorp-c]").append(o), o.spectrum(h(h(h({
            containerClassName: "".concat(r, "one-bg ").concat(r, "two-color"),
            appendTo: s || "body",
            maxSelectionSize: 8,
            showPalette: !0,
            showAlpha: !0,
            chooseText: "Ok",
            cancelText: "⨯",
            palette: []
          }, l), i.get("colorPicker") || {}), {}, {
            move: function move(t) {
              var e = c(t);
              a.backgroundColor = e, i.setValueFromInput(e, 0);
            },
            change: function change(t) {
              u = 1;
              var e = c(t);
              a.backgroundColor = e, i.setValueFromInput(0, 0), i.setValueFromInput(e), n.noneColor = 0;
            },
            show: function show(e) {
              u = 0, t = c(e);
            },
            hide: function hide(e) {
              !u && t && (n.noneColor && (t = ""), a.backgroundColor = t, o.spectrum("set", t), i.setValueFromInput(t, 0));
            }
          })), e && e.on && e.on("component:selected", function () {
            u = 1, o.spectrum("hide");
          }), this.colorEl = o;
        }
        return this.colorEl;
      },
      render: function render() {
        return u.a.prototype.render.call(this), this.getColorEl(), this;
      }
    });
  }, function (t, e, n) {
    !function (e) {
      var n,
        r = {},
        i = {
          16: !1,
          18: !1,
          17: !1,
          91: !1
        },
        o = "all",
        a = {
          "⇧": 16,
          shift: 16,
          "⌥": 18,
          alt: 18,
          option: 18,
          "⌃": 17,
          ctrl: 17,
          control: 17,
          "⌘": 91,
          command: 91
        },
        s = {
          backspace: 8,
          tab: 9,
          clear: 12,
          enter: 13,
          return: 13,
          esc: 27,
          escape: 27,
          space: 32,
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          del: 46,
          delete: 46,
          home: 36,
          end: 35,
          pageup: 33,
          pagedown: 34,
          ",": 188,
          ".": 190,
          "/": 191,
          "`": 192,
          "-": 189,
          "=": 187,
          ";": 186,
          "'": 222,
          "[": 219,
          "]": 221,
          "\\": 220
        },
        l = function l(t) {
          return s[t] || t.toUpperCase().charCodeAt(0);
        },
        c = [];
      for (n = 1; n < 20; n++) s["f" + n] = 111 + n;
      function u(t, e) {
        for (var n = t.length; n--;) if (t[n] === e) return n;
        return -1;
      }
      function d(t, e) {
        if (t.length != e.length) return !1;
        for (var n = 0; n < t.length; n++) if (t[n] !== e[n]) return !1;
        return !0;
      }
      var h = {
        16: "shiftKey",
        18: "altKey",
        17: "ctrlKey",
        91: "metaKey"
      };
      function f(t) {
        for (n in i) i[n] = t[h[n]];
      }
      function p(t, e, n) {
        var i, o;
        i = v(t), void 0 === n && (n = e, e = "all");
        for (var a = 0; a < i.length; a++) o = [], (t = i[a].split("+")).length > 1 && (o = m(t), t = [t[t.length - 1]]), t = t[0], (t = l(t)) in r || (r[t] = []), r[t].push({
          shortcut: i[a],
          scope: e,
          method: n,
          key: i[a],
          mods: o
        });
      }
      for (n in a) p[n] = !1;
      function g() {
        return o || "all";
      }
      function v(t) {
        var e;
        return "" == (e = (t = t.replace(/\s/g, "")).split(","))[e.length - 1] && (e[e.length - 2] += ","), e;
      }
      function m(t) {
        for (var e = t.slice(0, t.length - 1), n = 0; n < e.length; n++) e[n] = a[e[n]];
        return e;
      }
      function b(t, e, n) {
        t.addEventListener ? t.addEventListener(e, n, !1) : t.attachEvent && t.attachEvent("on" + e, function () {
          n(window.event);
        });
      }
      b(document, "keydown", function (t) {
        !function (t) {
          var e, n, o, s, l, d;
          if (e = t.keyCode, -1 == u(c, e) && c.push(e), 93 != e && 224 != e || (e = 91), e in i) for (o in i[e] = !0, a) a[o] == e && (p[o] = !0);else if (f(t), p.filter.call(this, t) && e in r) for (d = g(), s = 0; s < r[e].length; s++) if ((n = r[e][s]).scope == d || "all" == n.scope) {
            for (o in l = n.mods.length > 0, i) (!i[o] && u(n.mods, +o) > -1 || i[o] && -1 == u(n.mods, +o)) && (l = !1);
            (0 != n.mods.length || i[16] || i[18] || i[17] || i[91]) && !l || !1 === n.method(t, n) && (t.preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation && t.stopPropagation(), t.cancelBubble && (t.cancelBubble = !0));
          }
        }(t);
      }), b(document, "keyup", function (t) {
        var e,
          n = t.keyCode,
          r = u(c, n);
        if (r >= 0 && c.splice(r, 1), 93 != n && 224 != n || (n = 91), n in i) for (e in i[n] = !1, a) a[e] == n && (p[e] = !1);
      }), b(window, "focus", function () {
        for (n in i) i[n] = !1;
        for (n in a) p[n] = !1;
      });
      var y = e.key;
      e.key = p, e.key.setScope = function (t) {
        o = t || "all";
      }, e.key.getScope = g, e.key.deleteScope = function (t) {
        var e, n, i;
        for (e in r) for (n = r[e], i = 0; i < n.length;) n[i].scope === t ? n.splice(i, 1) : i++;
      }, e.key.filter = function (t) {
        var e = (t.target || t.srcElement).tagName;
        return !("INPUT" == e || "SELECT" == e || "TEXTAREA" == e);
      }, e.key.isPressed = function (t) {
        return "string" == typeof t && (t = l(t)), -1 != u(c, t);
      }, e.key.getPressedKeyCodes = function () {
        return c.slice(0);
      }, e.key.noConflict = function () {
        var t = e.key;
        return e.key = y, t;
      }, e.key.unbind = function (t, e) {
        var n,
          i,
          o,
          a,
          s,
          c = [];
        for (n = v(t), a = 0; a < n.length; a++) {
          if ((i = n[a].split("+")).length > 1 && (c = m(i), t = i[i.length - 1]), t = l(t), void 0 === e && (e = g()), !r[t]) return;
          for (o = 0; o < r[t].length; o++) (s = r[t][o]).scope === e && d(s.mods, c) && (r[t][o] = {});
        }
      }, t.exports = p;
    }(this);
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var r = n(77),
        i = n(78),
        o = n(79),
        a = setTimeout;
      function s(t) {
        return Boolean(t && void 0 !== t.length);
      }
      function l() {}
      function c(t) {
        if (!(this instanceof c)) throw new TypeError("Promises must be constructed via new");
        if ("function" != typeof t) throw new TypeError("not a function");
        this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], g(t, this);
      }
      function u(t, e) {
        for (; 3 === t._state;) t = t._value;
        0 !== t._state ? (t._handled = !0, c._immediateFn(function () {
          var n = 1 === t._state ? e.onFulfilled : e.onRejected;
          if (null !== n) {
            var r;
            try {
              r = n(t._value);
            } catch (t) {
              return void h(e.promise, t);
            }
            d(e.promise, r);
          } else (1 === t._state ? d : h)(e.promise, t._value);
        })) : t._deferreds.push(e);
      }
      function d(t, e) {
        try {
          if (e === t) throw new TypeError("A promise cannot be resolved with itself.");
          if (e && ("object" == typeof e || "function" == typeof e)) {
            var n = e.then;
            if (e instanceof c) return t._state = 3, t._value = e, void f(t);
            if ("function" == typeof n) return void g((r = n, i = e, function () {
              r.apply(i, arguments);
            }), t);
          }
          t._state = 1, t._value = e, f(t);
        } catch (e) {
          h(t, e);
        }
        var r, i;
      }
      function h(t, e) {
        t._state = 2, t._value = e, f(t);
      }
      function f(t) {
        2 === t._state && 0 === t._deferreds.length && c._immediateFn(function () {
          t._handled || c._unhandledRejectionFn(t._value);
        });
        for (var e = 0, n = t._deferreds.length; e < n; e++) u(t, t._deferreds[e]);
        t._deferreds = null;
      }
      function p(t, e, n) {
        this.onFulfilled = "function" == typeof t ? t : null, this.onRejected = "function" == typeof e ? e : null, this.promise = n;
      }
      function g(t, e) {
        var n = !1;
        try {
          t(function (t) {
            n || (n = !0, d(e, t));
          }, function (t) {
            n || (n = !0, h(e, t));
          });
        } catch (t) {
          if (n) return;
          n = !0, h(e, t);
        }
      }
      c.prototype.catch = function (t) {
        return this.then(null, t);
      }, c.prototype.then = function (t, e) {
        var n = new this.constructor(l);
        return u(this, new p(t, e, n)), n;
      }, c.prototype.finally = r.a, c.all = function (t) {
        return new c(function (e, n) {
          if (!s(t)) return n(new TypeError("Promise.all accepts an array"));
          var r = Array.prototype.slice.call(t);
          if (0 === r.length) return e([]);
          var i = r.length;
          function o(t, a) {
            try {
              if (a && ("object" == typeof a || "function" == typeof a)) {
                var s = a.then;
                if ("function" == typeof s) return void s.call(a, function (e) {
                  o(t, e);
                }, n);
              }
              r[t] = a, 0 == --i && e(r);
            } catch (t) {
              n(t);
            }
          }
          for (var a = 0; a < r.length; a++) o(a, r[a]);
        });
      }, c.any = o.a, c.allSettled = i.a, c.resolve = function (t) {
        return t && "object" == typeof t && t.constructor === c ? t : new c(function (e) {
          e(t);
        });
      }, c.reject = function (t) {
        return new c(function (e, n) {
          n(t);
        });
      }, c.race = function (t) {
        return new c(function (e, n) {
          if (!s(t)) return n(new TypeError("Promise.race accepts an array"));
          for (var r = 0, i = t.length; r < i; r++) c.resolve(t[r]).then(e, n);
        });
      }, c._immediateFn = "function" == typeof t && function (e) {
        t(e);
      } || function (t) {
        a(t, 0);
      }, c._unhandledRejectionFn = function (t) {
        "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", t);
      }, e.a = c;
    }).call(this, n(87).setImmediate);
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
      i = n.n(r),
      o = i.a.Model.extend({
        defaults: {
          id: "",
          label: "",
          tagName: "span",
          className: "",
          command: "",
          context: "",
          buttons: [],
          attributes: {},
          options: {},
          active: !1,
          dragDrop: !1,
          togglable: !0,
          runDefaultCommand: !0,
          stopDefaultCommand: !1,
          disable: !1
        },
        initialize: function initialize(t) {
          if (this.get("buttons").length) {
            var e = n(41).default;
            this.set("buttons", new e(this.get("buttons")));
          }
        }
      });
    e.default = i.a.Collection.extend({
      model: o,
      deactivateAllExceptOne: function deactivateAllExceptOne(t, e) {
        this.forEach(function (n, r) {
          n !== t && (n.set("active", !1), e && n.get("buttons").length && n.get("buttons").deactivateAllExceptOne(t, e));
        });
      },
      deactivateAll: function deactivateAll(t, e) {
        var n = t || "";
        this.forEach(function (t) {
          t.get("context") == n && t !== e && (t.set("active", !1, {
            silent: 1
          }), t.trigger("updateActive", {
            fromCollection: 1
          }));
        });
      },
      disableAllButtons: function disableAllButtons(t) {
        var e = t || "";
        this.forEach(function (t, n) {
          t.get("context") == e && t.set("disable", !0);
        });
      },
      disableAllButtonsExceptOne: function disableAllButtonsExceptOne(t, e) {
        this.forEach(function (n, r) {
          n !== t && (n.set("disable", !0), e && n.get("buttons").length && n.get("buttons").disableAllButtonsExceptOne(t, e));
        });
      }
    });
  }, function (t, e, n) {
    var r = n(8).default,
      i = n(81);
    t.exports = function (t) {
      var e = i(t, "string");
      return "symbol" == r(e) ? e : String(e);
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e) {
    t.exports = function (t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
      return r;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    var r = n(43);
    t.exports = function (t, e) {
      if (t) {
        if ("string" == typeof t) return r(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0;
      }
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    !function (t) {
      "use strict";

      function e(t) {
        for (var e = {}, n = 0; n < t.length; ++n) e[t[n].toLowerCase()] = !0;
        return e;
      }
      t.defineMode("css", function (e, n) {
        var r = n.inline;
        n.propertyKeywords || (n = t.resolveMode("text/css"));
        var i,
          o,
          a = e.indentUnit,
          s = n.tokenHooks,
          l = n.documentTypes || {},
          c = n.mediaTypes || {},
          u = n.mediaFeatures || {},
          d = n.mediaValueKeywords || {},
          h = n.propertyKeywords || {},
          f = n.nonStandardPropertyKeywords || {},
          p = n.fontProperties || {},
          g = n.counterDescriptors || {},
          v = n.colorKeywords || {},
          m = n.valueKeywords || {},
          b = n.allowNested,
          y = n.lineComment,
          w = !0 === n.supportsAtComponent,
          x = !1 !== e.highlightNonStandardPropertyKeywords;
        function O(t, e) {
          return i = e, t;
        }
        function C(t, e) {
          var n = t.next();
          if (s[n]) {
            var r = s[n](t, e);
            if (!1 !== r) return r;
          }
          return "@" == n ? (t.eatWhile(/[\w\\\-]/), O("def", t.current())) : "=" == n || ("~" == n || "|" == n) && t.eat("=") ? O(null, "compare") : '"' == n || "'" == n ? (e.tokenize = S(n), e.tokenize(t, e)) : "#" == n ? (t.eatWhile(/[\w\\\-]/), O("atom", "hash")) : "!" == n ? (t.match(/^\s*\w*/), O("keyword", "important")) : /\d/.test(n) || "." == n && t.eat(/\d/) ? (t.eatWhile(/[\w.%]/), O("number", "unit")) : "-" !== n ? /[,+>*\/]/.test(n) ? O(null, "select-op") : "." == n && t.match(/^-?[_a-z][_a-z0-9-]*/i) ? O("qualifier", "qualifier") : /[:;{}\[\]\(\)]/.test(n) ? O(null, n) : t.match(/^[\w-.]+(?=\()/) ? (/^(url(-prefix)?|domain|regexp)$/i.test(t.current()) && (e.tokenize = k), O("variable callee", "variable")) : /[\w\\\-]/.test(n) ? (t.eatWhile(/[\w\\\-]/), O("property", "word")) : O(null, null) : /[\d.]/.test(t.peek()) ? (t.eatWhile(/[\w.%]/), O("number", "unit")) : t.match(/^-[\w\\\-]*/) ? (t.eatWhile(/[\w\\\-]/), t.match(/^\s*:/, !1) ? O("variable-2", "variable-definition") : O("variable-2", "variable")) : t.match(/^\w+-/) ? O("meta", "meta") : void 0;
        }
        function S(t) {
          return function (e, n) {
            for (var r, i = !1; null != (r = e.next());) {
              if (r == t && !i) {
                ")" == t && e.backUp(1);
                break;
              }
              i = !i && "\\" == r;
            }
            return (r == t || !i && ")" != t) && (n.tokenize = null), O("string", "string");
          };
        }
        function k(t, e) {
          return t.next(), t.match(/^\s*[\"\')]/, !1) ? e.tokenize = null : e.tokenize = S(")"), O(null, "(");
        }
        function j(t, e, n) {
          this.type = t, this.indent = e, this.prev = n;
        }
        function T(t, e, n, r) {
          return t.context = new j(n, e.indentation() + (!1 === r ? 0 : a), t.context), n;
        }
        function P(t) {
          return t.context.prev && (t.context = t.context.prev), t.context.type;
        }
        function E(t, e, n) {
          return A[n.context.type](t, e, n);
        }
        function D(t, e, n, r) {
          for (var i = r || 1; i > 0; i--) n.context = n.context.prev;
          return E(t, e, n);
        }
        function M(t) {
          var e = t.current().toLowerCase();
          o = m.hasOwnProperty(e) ? "atom" : v.hasOwnProperty(e) ? "keyword" : "variable";
        }
        var A = {
          top: function top(t, e, n) {
            if ("{" == t) return T(n, e, "block");
            if ("}" == t && n.context.prev) return P(n);
            if (w && /@component/i.test(t)) return T(n, e, "atComponentBlock");
            if (/^@(-moz-)?document$/i.test(t)) return T(n, e, "documentTypes");
            if (/^@(media|supports|(-moz-)?document|import)$/i.test(t)) return T(n, e, "atBlock");
            if (/^@(font-face|counter-style)/i.test(t)) return n.stateArg = t, "restricted_atBlock_before";
            if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(t)) return "keyframes";
            if (t && "@" == t.charAt(0)) return T(n, e, "at");
            if ("hash" == t) o = "builtin";else if ("word" == t) o = "tag";else {
              if ("variable-definition" == t) return "maybeprop";
              if ("interpolation" == t) return T(n, e, "interpolation");
              if (":" == t) return "pseudo";
              if (b && "(" == t) return T(n, e, "parens");
            }
            return n.context.type;
          },
          block: function block(t, e, n) {
            if ("word" == t) {
              var r = e.current().toLowerCase();
              return h.hasOwnProperty(r) ? (o = "property", "maybeprop") : f.hasOwnProperty(r) ? (o = x ? "string-2" : "property", "maybeprop") : b ? (o = e.match(/^\s*:(?:\s|$)/, !1) ? "property" : "tag", "block") : (o += " error", "maybeprop");
            }
            return "meta" == t ? "block" : b || "hash" != t && "qualifier" != t ? A.top(t, e, n) : (o = "error", "block");
          },
          maybeprop: function maybeprop(t, e, n) {
            return ":" == t ? T(n, e, "prop") : E(t, e, n);
          },
          prop: function prop(t, e, n) {
            if (";" == t) return P(n);
            if ("{" == t && b) return T(n, e, "propBlock");
            if ("}" == t || "{" == t) return D(t, e, n);
            if ("(" == t) return T(n, e, "parens");
            if ("hash" != t || /^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(e.current())) {
              if ("word" == t) M(e);else if ("interpolation" == t) return T(n, e, "interpolation");
            } else o += " error";
            return "prop";
          },
          propBlock: function propBlock(t, e, n) {
            return "}" == t ? P(n) : "word" == t ? (o = "property", "maybeprop") : n.context.type;
          },
          parens: function parens(t, e, n) {
            return "{" == t || "}" == t ? D(t, e, n) : ")" == t ? P(n) : "(" == t ? T(n, e, "parens") : "interpolation" == t ? T(n, e, "interpolation") : ("word" == t && M(e), "parens");
          },
          pseudo: function pseudo(t, e, n) {
            return "meta" == t ? "pseudo" : "word" == t ? (o = "variable-3", n.context.type) : E(t, e, n);
          },
          documentTypes: function documentTypes(t, e, n) {
            return "word" == t && l.hasOwnProperty(e.current()) ? (o = "tag", n.context.type) : A.atBlock(t, e, n);
          },
          atBlock: function atBlock(t, e, n) {
            if ("(" == t) return T(n, e, "atBlock_parens");
            if ("}" == t || ";" == t) return D(t, e, n);
            if ("{" == t) return P(n) && T(n, e, b ? "block" : "top");
            if ("interpolation" == t) return T(n, e, "interpolation");
            if ("word" == t) {
              var r = e.current().toLowerCase();
              o = "only" == r || "not" == r || "and" == r || "or" == r ? "keyword" : c.hasOwnProperty(r) ? "attribute" : u.hasOwnProperty(r) ? "property" : d.hasOwnProperty(r) ? "keyword" : h.hasOwnProperty(r) ? "property" : f.hasOwnProperty(r) ? x ? "string-2" : "property" : m.hasOwnProperty(r) ? "atom" : v.hasOwnProperty(r) ? "keyword" : "error";
            }
            return n.context.type;
          },
          atComponentBlock: function atComponentBlock(t, e, n) {
            return "}" == t ? D(t, e, n) : "{" == t ? P(n) && T(n, e, b ? "block" : "top", !1) : ("word" == t && (o = "error"), n.context.type);
          },
          atBlock_parens: function atBlock_parens(t, e, n) {
            return ")" == t ? P(n) : "{" == t || "}" == t ? D(t, e, n, 2) : A.atBlock(t, e, n);
          },
          restricted_atBlock_before: function restricted_atBlock_before(t, e, n) {
            return "{" == t ? T(n, e, "restricted_atBlock") : "word" == t && "@counter-style" == n.stateArg ? (o = "variable", "restricted_atBlock_before") : E(t, e, n);
          },
          restricted_atBlock: function restricted_atBlock(t, e, n) {
            return "}" == t ? (n.stateArg = null, P(n)) : "word" == t ? (o = "@font-face" == n.stateArg && !p.hasOwnProperty(e.current().toLowerCase()) || "@counter-style" == n.stateArg && !g.hasOwnProperty(e.current().toLowerCase()) ? "error" : "property", "maybeprop") : "restricted_atBlock";
          },
          keyframes: function keyframes(t, e, n) {
            return "word" == t ? (o = "variable", "keyframes") : "{" == t ? T(n, e, "top") : E(t, e, n);
          },
          at: function at(t, e, n) {
            return ";" == t ? P(n) : "{" == t || "}" == t ? D(t, e, n) : ("word" == t ? o = "tag" : "hash" == t && (o = "builtin"), "at");
          },
          interpolation: function interpolation(t, e, n) {
            return "}" == t ? P(n) : "{" == t || ";" == t ? D(t, e, n) : ("word" == t ? o = "variable" : "variable" != t && "(" != t && ")" != t && (o = "error"), "interpolation");
          }
        };
        return {
          startState: function startState(t) {
            return {
              tokenize: null,
              state: r ? "block" : "top",
              stateArg: null,
              context: new j(r ? "block" : "top", t || 0, null)
            };
          },
          token: function token(t, e) {
            if (!e.tokenize && t.eatSpace()) return null;
            var n = (e.tokenize || C)(t, e);
            return n && "object" == typeof n && (i = n[1], n = n[0]), o = n, "comment" != i && (e.state = A[e.state](i, t, e)), o;
          },
          indent: function indent(t, e) {
            var n = t.context,
              r = e && e.charAt(0),
              i = n.indent;
            return "prop" != n.type || "}" != r && ")" != r || (n = n.prev), n.prev && ("}" != r || "block" != n.type && "top" != n.type && "interpolation" != n.type && "restricted_atBlock" != n.type ? (")" != r || "parens" != n.type && "atBlock_parens" != n.type) && ("{" != r || "at" != n.type && "atBlock" != n.type) || (i = Math.max(0, n.indent - a)) : i = (n = n.prev).indent), i;
          },
          electricChars: "}",
          blockCommentStart: "/*",
          blockCommentEnd: "*/",
          blockCommentContinue: " * ",
          lineComment: y,
          fold: "brace"
        };
      });
      var n = ["domain", "regexp", "url", "url-prefix"],
        r = e(n),
        i = ["all", "aural", "braille", "handheld", "print", "projection", "screen", "tty", "tv", "embossed"],
        o = e(i),
        a = ["width", "min-width", "max-width", "height", "min-height", "max-height", "device-width", "min-device-width", "max-device-width", "device-height", "min-device-height", "max-device-height", "aspect-ratio", "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio", "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color", "max-color", "color-index", "min-color-index", "max-color-index", "monochrome", "min-monochrome", "max-monochrome", "resolution", "min-resolution", "max-resolution", "scan", "grid", "orientation", "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio", "pointer", "any-pointer", "hover", "any-hover", "prefers-color-scheme", "dynamic-range", "video-dynamic-range"],
        s = e(a),
        l = ["landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover", "interlace", "progressive", "dark", "light", "standard", "high"],
        c = e(l),
        u = ["align-content", "align-items", "align-self", "alignment-adjust", "alignment-baseline", "all", "anchor-point", "animation", "animation-delay", "animation-direction", "animation-duration", "animation-fill-mode", "animation-iteration-count", "animation-name", "animation-play-state", "animation-timing-function", "appearance", "azimuth", "backdrop-filter", "backface-visibility", "background", "background-attachment", "background-blend-mode", "background-clip", "background-color", "background-image", "background-origin", "background-position", "background-position-x", "background-position-y", "background-repeat", "background-size", "baseline-shift", "binding", "bleed", "block-size", "bookmark-label", "bookmark-level", "bookmark-state", "bookmark-target", "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius", "border-bottom-right-radius", "border-bottom-style", "border-bottom-width", "border-collapse", "border-color", "border-image", "border-image-outset", "border-image-repeat", "border-image-slice", "border-image-source", "border-image-width", "border-left", "border-left-color", "border-left-style", "border-left-width", "border-radius", "border-right", "border-right-color", "border-right-style", "border-right-width", "border-spacing", "border-style", "border-top", "border-top-color", "border-top-left-radius", "border-top-right-radius", "border-top-style", "border-top-width", "border-width", "bottom", "box-decoration-break", "box-shadow", "box-sizing", "break-after", "break-before", "break-inside", "caption-side", "caret-color", "clear", "clip", "color", "color-profile", "column-count", "column-fill", "column-gap", "column-rule", "column-rule-color", "column-rule-style", "column-rule-width", "column-span", "column-width", "columns", "contain", "content", "counter-increment", "counter-reset", "crop", "cue", "cue-after", "cue-before", "cursor", "direction", "display", "dominant-baseline", "drop-initial-after-adjust", "drop-initial-after-align", "drop-initial-before-adjust", "drop-initial-before-align", "drop-initial-size", "drop-initial-value", "elevation", "empty-cells", "fit", "fit-content", "fit-position", "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap", "float", "float-offset", "flow-from", "flow-into", "font", "font-family", "font-feature-settings", "font-kerning", "font-language-override", "font-optical-sizing", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-synthesis", "font-variant", "font-variant-alternates", "font-variant-caps", "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric", "font-variant-position", "font-variation-settings", "font-weight", "gap", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow", "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap", "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap", "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns", "grid-template-rows", "hanging-punctuation", "height", "hyphens", "icon", "image-orientation", "image-rendering", "image-resolution", "inline-box-align", "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline", "inset-inline-end", "inset-inline-start", "isolation", "justify-content", "justify-items", "justify-self", "left", "letter-spacing", "line-break", "line-height", "line-height-step", "line-stacking", "line-stacking-ruby", "line-stacking-shift", "line-stacking-strategy", "list-style", "list-style-image", "list-style-position", "list-style-type", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "marks", "marquee-direction", "marquee-loop", "marquee-play-count", "marquee-speed", "marquee-style", "mask-clip", "mask-composite", "mask-image", "mask-mode", "mask-origin", "mask-position", "mask-repeat", "mask-size", "mask-type", "max-block-size", "max-height", "max-inline-size", "max-width", "min-block-size", "min-height", "min-inline-size", "min-width", "mix-blend-mode", "move-to", "nav-down", "nav-index", "nav-left", "nav-right", "nav-up", "object-fit", "object-position", "offset", "offset-anchor", "offset-distance", "offset-path", "offset-position", "offset-rotate", "opacity", "order", "orphans", "outline", "outline-color", "outline-offset", "outline-style", "outline-width", "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y", "padding", "padding-bottom", "padding-left", "padding-right", "padding-top", "page", "page-break-after", "page-break-before", "page-break-inside", "page-policy", "pause", "pause-after", "pause-before", "perspective", "perspective-origin", "pitch", "pitch-range", "place-content", "place-items", "place-self", "play-during", "position", "presentation-level", "punctuation-trim", "quotes", "region-break-after", "region-break-before", "region-break-inside", "region-fragment", "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness", "right", "rotate", "rotation", "rotation-point", "row-gap", "ruby-align", "ruby-overhang", "ruby-position", "ruby-span", "scale", "scroll-behavior", "scroll-margin", "scroll-margin-block", "scroll-margin-block-end", "scroll-margin-block-start", "scroll-margin-bottom", "scroll-margin-inline", "scroll-margin-inline-end", "scroll-margin-inline-start", "scroll-margin-left", "scroll-margin-right", "scroll-margin-top", "scroll-padding", "scroll-padding-block", "scroll-padding-block-end", "scroll-padding-block-start", "scroll-padding-bottom", "scroll-padding-inline", "scroll-padding-inline-end", "scroll-padding-inline-start", "scroll-padding-left", "scroll-padding-right", "scroll-padding-top", "scroll-snap-align", "scroll-snap-type", "shape-image-threshold", "shape-inside", "shape-margin", "shape-outside", "size", "speak", "speak-as", "speak-header", "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set", "tab-size", "table-layout", "target", "target-name", "target-new", "target-position", "text-align", "text-align-last", "text-combine-upright", "text-decoration", "text-decoration-color", "text-decoration-line", "text-decoration-skip", "text-decoration-skip-ink", "text-decoration-style", "text-emphasis", "text-emphasis-color", "text-emphasis-position", "text-emphasis-style", "text-height", "text-indent", "text-justify", "text-orientation", "text-outline", "text-overflow", "text-rendering", "text-shadow", "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position", "text-wrap", "top", "touch-action", "transform", "transform-origin", "transform-style", "transition", "transition-delay", "transition-duration", "transition-property", "transition-timing-function", "translate", "unicode-bidi", "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration", "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress", "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break", "word-spacing", "word-wrap", "writing-mode", "z-index", "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color", "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events", "color-interpolation", "color-interpolation-filters", "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering", "marker", "marker-end", "marker-mid", "marker-start", "paint-order", "shape-rendering", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering", "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal", "glyph-orientation-vertical", "text-anchor", "writing-mode"],
        d = e(u),
        h = ["accent-color", "aspect-ratio", "border-block", "border-block-color", "border-block-end", "border-block-end-color", "border-block-end-style", "border-block-end-width", "border-block-start", "border-block-start-color", "border-block-start-style", "border-block-start-width", "border-block-style", "border-block-width", "border-inline", "border-inline-color", "border-inline-end", "border-inline-end-color", "border-inline-end-style", "border-inline-end-width", "border-inline-start", "border-inline-start-color", "border-inline-start-style", "border-inline-start-width", "border-inline-style", "border-inline-width", "content-visibility", "margin-block", "margin-block-end", "margin-block-start", "margin-inline", "margin-inline-end", "margin-inline-start", "overflow-anchor", "overscroll-behavior", "padding-block", "padding-block-end", "padding-block-start", "padding-inline", "padding-inline-end", "padding-inline-start", "scroll-snap-stop", "scrollbar-3d-light-color", "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color", "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color", "scrollbar-track-color", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "shape-inside", "zoom"],
        f = e(h),
        p = e(["font-display", "font-family", "src", "unicode-range", "font-variant", "font-feature-settings", "font-stretch", "font-weight", "font-style"]),
        g = e(["additive-symbols", "fallback", "negative", "pad", "prefix", "range", "speak-as", "suffix", "symbols", "system"]),
        v = ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
        m = e(v),
        b = ["above", "absolute", "activeborder", "additive", "activecaption", "afar", "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate", "always", "amharic", "amharic-abegede", "antialiased", "appworkspace", "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page", "avoid-region", "axis-pan", "background", "backwards", "baseline", "below", "bidi-override", "binary", "bengali", "blink", "block", "block-axis", "blur", "bold", "bolder", "border", "border-box", "both", "bottom", "break", "break-all", "break-word", "brightness", "bullets", "button", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian", "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret", "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch", "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote", "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse", "compact", "condensed", "conic-gradient", "contain", "content", "contents", "content-box", "context-menu", "continuous", "contrast", "copy", "counter", "counters", "cover", "crop", "cross", "crosshair", "cubic-bezier", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal", "decimal-leading-zero", "default", "default-button", "dense", "destination-atop", "destination-in", "destination-out", "destination-over", "devanagari", "difference", "disc", "discard", "disclosure-closed", "disclosure-open", "document", "dot-dash", "dot-dot-dash", "dotted", "double", "down", "drop-shadow", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out", "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede", "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er", "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er", "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et", "ethiopic-halehame-gez", "ethiopic-halehame-om-et", "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et", "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig", "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed", "extra-expanded", "fantasy", "fast", "fill", "fill-box", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes", "forwards", "from", "geometricPrecision", "georgian", "grayscale", "graytext", "grid", "groove", "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew", "help", "hidden", "hide", "higher", "highlight", "highlighttext", "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "hue-rotate", "icon", "ignore", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite", "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis", "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert", "italic", "japanese-formal", "japanese-informal", "justify", "kannada", "katakana", "katakana-iroha", "keep-all", "khmer", "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal", "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten", "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem", "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian", "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian", "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "manipulation", "match", "matrix", "matrix3d", "media-play-button", "media-slider", "media-sliderthumb", "media-volume-slider", "media-volume-sliderthumb", "medium", "menu", "menulist", "menulist-button", "menutext", "message-box", "middle", "min-intrinsic", "mix", "mongolian", "monospace", "move", "multiple", "multiple_mask_images", "multiply", "myanmar", "n-resize", "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop", "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap", "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote", "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset", "outside", "outside-shape", "overlay", "overline", "padding", "padding-box", "painted", "page", "paused", "persian", "perspective", "pinch-zoom", "plus-darker", "plus-lighter", "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d", "progress", "push-button", "radial-gradient", "radio", "read-only", "read-write", "read-write-plaintext-only", "rectangle", "region", "relative", "repeat", "repeating-linear-gradient", "repeating-radial-gradient", "repeating-conic-gradient", "repeat-x", "repeat-y", "reset", "reverse", "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY", "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running", "s-resize", "sans-serif", "saturate", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen", "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end", "semi-condensed", "semi-expanded", "separate", "sepia", "serif", "show", "sidama", "simp-chinese-formal", "simp-chinese-informal", "single", "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal", "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow", "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali", "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square", "square-button", "start", "static", "status-bar", "stretch", "stroke", "stroke-box", "sub", "subpixel-antialiased", "svg_masks", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row", "table-row-group", "tamil", "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai", "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er", "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top", "trad-chinese-formal", "trad-chinese-informal", "transform", "translate", "translate3d", "translateX", "translateY", "translateZ", "transparent", "ultra-condensed", "ultra-expanded", "underline", "unidirectional-pan", "unset", "up", "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal", "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url", "var", "vertical", "vertical-text", "view-box", "visible", "visibleFill", "visiblePainted", "visibleStroke", "visual", "w-resize", "wait", "wave", "wider", "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor", "xx-large", "xx-small"],
        y = e(b),
        w = n.concat(i).concat(a).concat(l).concat(u).concat(h).concat(v).concat(b);
      function x(t, e) {
        for (var n, r = !1; null != (n = t.next());) {
          if (r && "/" == n) {
            e.tokenize = null;
            break;
          }
          r = "*" == n;
        }
        return ["comment", "comment"];
      }
      t.registerHelper("hintWords", "css", w), t.defineMIME("text/css", {
        documentTypes: r,
        mediaTypes: o,
        mediaFeatures: s,
        mediaValueKeywords: c,
        propertyKeywords: d,
        nonStandardPropertyKeywords: f,
        fontProperties: p,
        counterDescriptors: g,
        colorKeywords: m,
        valueKeywords: y,
        tokenHooks: {
          "/": function _(t, e) {
            return !!t.eat("*") && (e.tokenize = x, x(t, e));
          }
        },
        name: "css"
      }), t.defineMIME("text/x-scss", {
        mediaTypes: o,
        mediaFeatures: s,
        mediaValueKeywords: c,
        propertyKeywords: d,
        nonStandardPropertyKeywords: f,
        colorKeywords: m,
        valueKeywords: y,
        fontProperties: p,
        allowNested: !0,
        lineComment: "//",
        tokenHooks: {
          "/": function _(t, e) {
            return t.eat("/") ? (t.skipToEnd(), ["comment", "comment"]) : t.eat("*") ? (e.tokenize = x, x(t, e)) : ["operator", "operator"];
          },
          ":": function _(t) {
            return !!t.match(/^\s*\{/, !1) && [null, null];
          },
          $: function $(t) {
            return t.match(/^[\w-]+/), t.match(/^\s*:/, !1) ? ["variable-2", "variable-definition"] : ["variable-2", "variable"];
          },
          "#": function _(t) {
            return !!t.eat("{") && [null, "interpolation"];
          }
        },
        name: "css",
        helperType: "scss"
      }), t.defineMIME("text/x-less", {
        mediaTypes: o,
        mediaFeatures: s,
        mediaValueKeywords: c,
        propertyKeywords: d,
        nonStandardPropertyKeywords: f,
        colorKeywords: m,
        valueKeywords: y,
        fontProperties: p,
        allowNested: !0,
        lineComment: "//",
        tokenHooks: {
          "/": function _(t, e) {
            return t.eat("/") ? (t.skipToEnd(), ["comment", "comment"]) : t.eat("*") ? (e.tokenize = x, x(t, e)) : ["operator", "operator"];
          },
          "@": function _(t) {
            return t.eat("{") ? [null, "interpolation"] : !t.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, !1) && (t.eatWhile(/[\w\\\-]/), t.match(/^\s*:/, !1) ? ["variable-2", "variable-definition"] : ["variable-2", "variable"]);
          },
          "&": function _() {
            return ["atom", "atom"];
          }
        },
        name: "css",
        helperType: "less"
      }), t.defineMIME("text/x-gss", {
        documentTypes: r,
        mediaTypes: o,
        mediaFeatures: s,
        propertyKeywords: d,
        nonStandardPropertyKeywords: f,
        fontProperties: p,
        counterDescriptors: g,
        colorKeywords: m,
        valueKeywords: y,
        supportsAtComponent: !0,
        tokenHooks: {
          "/": function _(t, e) {
            return !!t.eat("*") && (e.tokenize = x, x(t, e));
          }
        },
        name: "css",
        helperType: "gss"
      });
    }(n(13));
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        confirm("Are you sure to clean the canvas?") && (t.Storage.getCurrentStorage().attributes.isDeleteContent = !0, t.DomComponents.clear(), t.CssComposer.clear(), t.store());
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
      i = n(3),
      o = n(17);
    e.default = {
      run: function run(t) {
        Object(r.bindAll)(this, "onKeyUp", "enableDragger", "disableDragger"), this.editor = t, this.canvasModel = this.canvas.getCanvasView().model, this.toggleMove(1);
      },
      stop: function stop(t) {
        this.toggleMove(), this.disableDragger();
      },
      onKeyUp: function onKeyUp(t) {
        " " === Object(i.f)(t) && this.editor.stopCommand(this.id);
      },
      enableDragger: function enableDragger(t) {
        this.toggleDragger(1, t);
      },
      disableDragger: function disableDragger(t) {
        this.toggleDragger(0, t);
      },
      toggleDragger: function toggleDragger(t, e) {
        var n = this.canvasModel,
          r = this.em,
          i = this.dragger,
          a = t ? "add" : "remove";
        this.getCanvas().classList[a]("".concat(this.ppfx, "is__grabbing")), i || (i = new o.a({
          getPosition: function getPosition() {
            return {
              x: n.get("x"),
              y: n.get("y")
            };
          },
          setPosition: function setPosition(t) {
            var e = t.x,
              r = t.y;
            n.set({
              x: e,
              y: r
            });
          },
          onStart: function onStart(t, e) {
            r.trigger("canvas:move:start", e);
          },
          onDrag: function onDrag(t, e) {
            r.trigger("canvas:move", e);
          },
          onEnd: function onEnd(t, e) {
            r.trigger("canvas:move:end", e);
          }
        }), this.dragger = i), t ? i.start(e) : i.stop();
      },
      toggleMove: function toggleMove(t) {
        var e = this.ppfx,
          n = t ? "add" : "remove",
          r = t ? "on" : "off",
          o = {
            on: i.u,
            off: i.t
          },
          a = this.getCanvas(),
          s = ["".concat(e, "is__grab")];
        !t && s.push("".concat(e, "is__grabbing")), s.forEach(function (t) {
          return a.classList[n](t);
        }), o[r](document, "keyup", this.onKeyUp), o[r](a, "mousedown", this.enableDragger), o[r](document, "mouseup", this.disableDragger);
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(9),
      i = n.n(r),
      o = n(0);
    e.default = {
      run: function run(t, e) {
        var n = this,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          a = r.component || t.getSelectedAll();
        a = Object(o.isArray)(a) ? i()(a) : [a];
        var s = "",
          l = t.getComponents();
        if (l && 1 == l.length) {
          var c = t.getSelected();
          if ((s = c ? c.parent() : "") && !s.collection) return alert("Alert! The removal of the main component from a page is currently restricted.\n\nPlease click the Clear icon on the top bar if you like to Clear the page content."), this.em.logWarning("Alert! The removal of the main component from a page is currently restricted.\n\nPlease click the Clear icon on the top bar if you like to Clear the page content.", {
            component: c
          });
        }
        return t.select(null), a.forEach(function (t) {
          if (!t || !t.get("removable")) return n.em.logWarning("The element is not removable", {
            component: t
          });
          t.remove();
        }), a;
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(0),
      a = n(17);
    function s(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function l(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? s(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = {
      run: function run(t, e) {
        var n = this,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        Object(o.bindAll)(this, "setPosition", "onStart", "onDrag", "onEnd", "getPosition", "getGuidesStatic", "renderGuide", "getGuidesTarget");
        var i = r.target,
          s = r.event,
          c = r.mode,
          u = r.dragger,
          d = void 0 === u ? {} : u,
          h = i.getEl(),
          f = l({
            doc: h.ownerDocument,
            onStart: this.onStart,
            onEnd: this.onEnd,
            onDrag: this.onDrag,
            getPosition: this.getPosition,
            setPosition: this.setPosition,
            guidesStatic: function guidesStatic() {
              return n.guidesStatic;
            },
            guidesTarget: function guidesTarget() {
              return n.guidesTarget;
            }
          }, d);
        this.setupGuides(), this.opts = r, this.editor = t, this.em = t.getModel(), this.target = i, this.isTran = "translate" == c, this.guidesContainer = this.getGuidesContainer(), this.guidesTarget = this.getGuidesTarget(), this.guidesStatic = this.getGuidesStatic();
        var p = this.dragger;
        return p ? p.setOptions(f) : (p = new a.a(f), this.dragger = p), s && p.start(s), this.toggleDrag(1), this.em.trigger("".concat("dmode", ":start"), this.getEventOpts()), p;
      },
      getEventOpts: function getEventOpts() {
        return {
          mode: this.opts.mode,
          target: this.target,
          guidesTarget: this.guidesTarget,
          guidesStatic: this.guidesStatic
        };
      },
      stop: function stop() {
        this.toggleDrag();
      },
      setupGuides: function setupGuides() {
        (this.guides || []).forEach(function (t) {
          var e = t.guide;
          e && e.parentNode.removeChild(e);
        }), this.guides = [];
      },
      getGuidesContainer: function getGuidesContainer() {
        var t = this,
          e = this.guidesEl;
        if (!e) {
          var n = this.editor,
            r = this.em,
            i = this.opts,
            a = n.getConfig("stylePrefix"),
            s = document.createElement("div"),
            l = document.createElement("div"),
            c = '<div class="'.concat(a, "guide-info__line ").concat(a, 'danger-bg">\n        <div class="').concat(a, "guide-info__content ").concat(a, 'danger-color"></div>\n      </div>');
          (e = document.createElement("div")).className = "".concat(a, "guides"), s.className = "".concat(a, "guide-info ").concat(a, "guide-info__x"), l.className = "".concat(a, "guide-info ").concat(a, "guide-info__y"), s.innerHTML = c, l.innerHTML = c, e.appendChild(s), e.appendChild(l), n.Canvas.getGlobalToolsEl().appendChild(e), this.guidesEl = e, this.elGuideInfoX = s, this.elGuideInfoY = l, this.elGuideInfoContentX = s.querySelector(".".concat(a, "guide-info__content")), this.elGuideInfoContentY = l.querySelector(".".concat(a, "guide-info__content")), r.on("canvas:update frame:scroll", Object(o.debounce)(function () {
            t.updateGuides(), i.debug && t.guides.forEach(function (e) {
              return t.renderGuide(e);
            });
          }, 200));
        }
        return e;
      },
      getGuidesStatic: function getGuidesStatic() {
        var t = this,
          e = [],
          n = this.target.getEl(),
          r = n.parentNode,
          i = void 0 === r ? {} : r;
        return Object(o.each)(i.children, function (r) {
          return e = e.concat(n !== r ? t.getElementGuides(r) : []);
        }), e.concat(this.getElementGuides(i));
      },
      getGuidesTarget: function getGuidesTarget() {
        return this.getElementGuides(this.target.getEl());
      },
      updateGuides: function updateGuides(t) {
        var e,
          n,
          r = this;
        (t || this.guides).forEach(function (t) {
          var i = t.origin,
            a = e === i ? n : r.getElementPos(i);
          e = i, n = a, Object(o.each)(r.getGuidePosUpdate(t, a), function (e, n) {
            return t[n] = e;
          }), t.originRect = a;
        });
      },
      getGuidePosUpdate: function getGuidePosUpdate(t, e) {
        var n = {},
          r = e.top,
          i = e.height,
          o = e.left,
          a = e.width;
        switch (t.type) {
          case "t":
            n.y = r;
            break;
          case "b":
            n.y = r + i;
            break;
          case "l":
            n.x = o;
            break;
          case "r":
            n.x = o + a;
            break;
          case "x":
            n.x = o + a / 2;
            break;
          case "y":
            n.y = r + i / 2;
        }
        return n;
      },
      renderGuide: function renderGuide() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.guide || document.createElement("div"),
          n = "px",
          r = t.active ? 2 : 1,
          i = e.children[0];
        return e.style = "position: absolute; background-color: ".concat(t.active ? "green" : "red", ";"), e.children.length || ((i = document.createElement("div")).style = "position: absolute; color: red; padding: 5px; top: 0; left: 0;", e.appendChild(i)), t.y ? (e.style.width = "100%", e.style.height = "".concat(r).concat(n), e.style.top = "".concat(t.y).concat(n), e.style.left = 0) : (e.style.width = "".concat(r).concat(n), e.style.height = "100%", e.style.left = "".concat(t.x).concat(n), e.style.top = "0".concat(n)), !t.guide && this.guidesContainer.appendChild(e), e;
      },
      getElementPos: function getElementPos(t) {
        return this.editor.Canvas.getElementPos(t, {
          noScroll: 1
        });
      },
      getElementGuides: function getElementGuides(t) {
        var e = this,
          n = this.opts,
          r = this.getElementPos(t),
          i = r.top,
          o = r.height,
          a = r.left,
          s = r.width,
          c = [{
            type: "t",
            y: i
          }, {
            type: "b",
            y: i + o
          }, {
            type: "l",
            x: a
          }, {
            type: "r",
            x: a + s
          }, {
            type: "x",
            x: a + s / 2
          }, {
            type: "y",
            y: i + o / 2
          }].map(function (i) {
            return l(l({}, i), {}, {
              origin: t,
              originRect: r,
              guide: n.debug && e.renderGuide(i)
            });
          });
        return c.forEach(function (t) {
          return e.guides.push(t);
        }), c;
      },
      getTranslate: function getTranslate(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x",
          n = 0;
        return (t || "").split(" ").forEach(function (t) {
          var r = t.trim(),
            i = "translate".concat(e.toUpperCase(), "(");
          0 === r.indexOf(i) && (n = parseFloat(r.replace(i, "")));
        }), n;
      },
      setTranslate: function setTranslate(t, e, n) {
        var r = "translate".concat(e.toUpperCase(), "("),
          i = "".concat(r).concat(n, ")"),
          o = (t || "").split(" ").map(function (t) {
            return 0 === t.trim().indexOf(r) && (t = i), t;
          }).join(" ");
        return o.indexOf(r) < 0 && (o += " ".concat(i)), o;
      },
      getPosition: function getPosition() {
        var t = this.target,
          e = this.isTran,
          n = t.getStyle(),
          r = n.left,
          i = n.top,
          o = n.transform,
          a = 0,
          s = 0;
        return e ? (a = this.getTranslate(o), s = this.getTranslate(o, "y")) : (a = parseFloat(r), s = parseFloat(i)), {
          x: a,
          y: s
        };
      },
      setPosition: function setPosition(t) {
        var e = t.x,
          n = t.y,
          r = t.end,
          i = t.position,
          a = t.width,
          s = t.height,
          l = this.target,
          c = this.isTran,
          u = r ? "" : 1,
          d = "".concat(e).concat("px"),
          h = "".concat(n).concat("px");
        if (c) {
          var f = l.getStyle().transform || "";
          return f = this.setTranslate(f, "x", d), f = this.setTranslate(f, "y", h), l.addStyle({
            transform: f,
            en: u
          }, {
            avoidStore: !r
          });
        }
        var p = {
            position: i,
            width: a,
            height: s
          },
          g = {
            left: d,
            top: h,
            en: u
          };
        Object(o.keys)(p).forEach(function (t) {
          var e = p[t];
          e && (g[t] = e);
        }), l.addStyle(g, {
          avoidStore: !r
        });
      },
      _getDragData: function _getDragData() {
        var t = this.target;
        return {
          target: t,
          parent: t.parent(),
          index: t.index()
        };
      },
      onStart: function onStart() {
        var t = this.target,
          e = this.editor,
          n = this.isTran,
          r = this.opts,
          i = r.center,
          o = r.onStart,
          a = e.Canvas,
          s = t.getStyle();
        if (o && o(this._getDragData()), !n && "absolute" !== s.position) {
          var l = a.offset(t.getEl()),
            c = l.left,
            u = l.top,
            d = l.width,
            h = l.height;
          if (i) {
            var f = a.getMouseRelativeCanvas(event);
            c = f.x, u = f.y;
          }
          this.setPosition({
            x: c,
            y: u,
            width: "".concat(d, "px"),
            height: "".concat(h, "px"),
            position: "absolute"
          });
        }
      },
      onDrag: function onDrag() {
        var t = this,
          e = this.guidesTarget,
          n = this.opts,
          r = n.onDrag;
        this.updateGuides(e), n.debug && e.forEach(function (e) {
          return t.renderGuide(e);
        }), n.guidesInfo && this.renderGuideInfo(e.filter(function (t) {
          return t.active;
        })), r && r(this._getDragData());
      },
      onEnd: function onEnd(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = this.editor,
          i = this.opts,
          o = this.id,
          a = i.onEnd;
        a && a(t, n, l(l({
          event: t
        }, n), this._getDragData())), r.stopCommand(o), this.hideGuidesInfo(), this.em.trigger("".concat("dmode", ":end"), this.getEventOpts());
      },
      hideGuidesInfo: function hideGuidesInfo() {
        var t = this;
        ["X", "Y"].forEach(function (e) {
          var n = t["elGuideInfo".concat(e)];
          n && (n.style.display = "none");
        });
      },
      renderGuideInfo: function renderGuideInfo() {
        var t = this,
          e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          n = this.guidesStatic;
        this.hideGuidesInfo(), e.forEach(function (e) {
          var r = e.origin,
            i = e.x,
            a = t.getElementPos(r),
            s = Object(o.isUndefined)(i) ? "y" : "x",
            c = "y" === s,
            u = a[c ? "left" : "top"],
            d = a.rect[c ? "left" : "top"],
            h = c ? u + a.width : u + a.height,
            f = c ? d + a.rect.width : d + a.rect.height,
            p = t["elGuideInfo".concat(s.toUpperCase())],
            g = t["elGuideInfoContent".concat(s.toUpperCase())],
            v = p.style,
            m = n.filter(function (t) {
              return t.type === e.type;
            }).map(function (t) {
              var e = t.originRect,
                n = e.left,
                r = e.width,
                i = e.top,
                o = e.height,
                a = c ? n + r : i + o;
              return {
                gap: a < u ? u - a : (c ? n : i) - h,
                guide: t
              };
            }).filter(function (t) {
              return t.gap > 0;
            }).sort(function (t, e) {
              return t.gap - e.gap;
            }).map(function (t) {
              return t.guide;
            })[0];
          if (m) {
            var b = m.originRect,
              y = b.left,
              w = b.width,
              x = b.top,
              O = b.height,
              C = b.rect,
              S = c ? y < a.left : x < a.top,
              k = c ? y : x,
              j = c ? C.left : C.top,
              T = c ? y + w : x + O,
              P = c ? C.left + C.width : C.top + C.height,
              E = c ? e.y : e.x,
              D = S ? T : h,
              M = "".concat(E, "px"),
              A = S ? u - T : k - h,
              L = S ? d - P : j - f;
            v.display = "", v[c ? "top" : "left"] = M, v[c ? "left" : "top"] = "".concat(D, "px"), v[c ? "width" : "height"] = "".concat(A, "px"), g.innerHTML = "".concat(Math.round(L), "px"), t.em.trigger("".concat("dmode", ":active"), l(l({}, t.getEventOpts()), {}, {
              guide: e,
              guidesStatic: n,
              matched: m,
              posFirst: E,
              posSecond: D,
              size: A,
              sizeRaw: L,
              elGuideInfo: p,
              elGuideInfoCnt: g
            }));
          }
        });
      },
      toggleDrag: function toggleDrag(t) {
        var e = this.ppfx,
          n = this.editor,
          r = t ? "add" : "remove",
          i = ["".concat(e, "is__grabbing")],
          o = n.Canvas,
          a = o.getBody();
        i.forEach(function (t) {
          return a.classList[r](t);
        }), o[t ? "startAutoscroll" : "stopAutoscroll"]();
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        if (t.Canvas.hasFocus()) {
          var e = [];
          t.getSelectedAll().forEach(function (t) {
            var n = t.components(),
              r = n && n.at(0);
            r && e.push(r);
          }), e.length && t.select(e);
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if (t.Canvas.hasFocus() || n.force) {
          var r = [];
          t.getSelectedAll().forEach(function (t) {
            for (var e = t.parent(); e && !e.get("selectable");) e = e.parent();
            e && r.push(e);
          }), r.length && t.select(r);
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        if (t.Canvas.hasFocus()) {
          var e = [];
          t.getSelectedAll().forEach(function (t) {
            var n = t.collection,
              r = n.indexOf(t),
              i = n.at(r + 1);
            e.push(i || t);
          }), e.length && t.select(e);
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        if (t.Canvas.hasFocus()) {
          var e = [];
          t.getSelectedAll().forEach(function (t) {
            var n = t.collection,
              r = n.indexOf(t),
              i = n.at(r - 1);
            e.push(i && r - 1 >= 0 ? i : t);
          }), e.length && t.select(e);
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    e.default = {
      run: function run(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = n.target,
          o = t.DomComponents,
          a = i.get("type"),
          s = o.getWrapper().findType(a).length,
          l = [];
        if (!s) {
          var c = t.CssComposer.getAll(),
            u = i.get("style-signature");
          u = Object(r.isArray)(u) ? u : [u], c.forEach(function (t) {
            var e = t.selectorsToString();
            u.forEach(function (n) {
              n && e.indexOf(n) >= 0 && l.push(t);
            });
          }), c.remove(l);
        }
        return l;
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(9),
      i = n.n(r);
    e.default = {
      run: function run(t) {
        var e = t.getModel(),
          n = i()(t.getSelectedAll());
        n.length && e.set("clipboard", n);
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
      i = n(1),
      o = n.n(i),
      a = n(14),
      s = o.a.$;
    e.default = Object(r.extend)({}, a.default, {
      init: function init(t) {
        Object(r.bindAll)(this, "startDelete", "stopDelete", "onDelete"), this.hoverClass = this.pfx + "hover-delete", this.badgeClass = this.pfx + "badge-red";
      },
      enable: function enable() {
        this.$el.find("*").mouseover(this.startDelete).mouseout(this.stopDelete).click(this.onDelete);
      },
      startDelete: function startDelete(t) {
        t.stopPropagation();
        var e = s(t.target);
        e.data("model").get("removable") && (e.addClass(this.hoverClass), this.attachBadge(e.get(0)));
      },
      stopDelete: function stopDelete(t) {
        t.stopPropagation(), s(t.target).removeClass(this.hoverClass), this.badge && this.badge.css({
          left: -1e3,
          top: -1e3
        });
      },
      onDelete: function onDelete(t) {
        t.stopPropagation();
        var e = s(t.target);
        e.data("model").get("removable") && (e.data("model").destroy(), this.removeBadge(), this.clean());
      },
      updateBadgeLabel: function updateBadgeLabel(t) {
        this.badge.html("Remove " + t.getName());
      }
    });
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        t.setDevice("Desktop");
      },
      stop: function stop() {}
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        t.setDevice("Mobile landscape");
      },
      stop: function stop() {}
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        t.setDevice("Mobile portrait");
      },
      stop: function stop() {}
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        t.setDevice("Tablet");
      },
      stop: function stop() {}
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
      i = n.n(r).a.$;
    e.default = {
      run: function run(t, e) {
        var n = this;
        e && e.set && e.set("active", 0);
        var r = t.getConfig(),
          o = t.Modal,
          a = r.stylePrefix;
        if (this.cm = t.CodeManager || null, !this.$editors) {
          var s = this.buildEditor("htmlmixed", "hopscotch", "HTML"),
            l = this.buildEditor("css", "hopscotch", "CSS");
          this.htmlEditor = s.el, this.cssEditor = l.el;
          var c = i('<div class="'.concat(a, 'export-dl"></div>'));
          c.append(s.$el).append(l.$el), this.$editors = c;
        }
        o.open({
          title: r.textViewCode,
          content: this.$editors
        }).getModel().once("change:open", function () {
          return t.stopCommand(n.id);
        }), this.htmlEditor.setContent(t.getHtml()), this.cssEditor.setContent(t.getCss());
      },
      stop: function stop(t) {
        var e = t.Modal;
        e && e.close();
      },
      buildEditor: function buildEditor(t, e, n) {
        var r = document.createElement("textarea");
        !this.codeMirror && (this.codeMirror = this.cm.getViewer("CodeMirror"));
        var i = this.codeMirror.clone().set({
            label: n,
            codeName: t,
            theme: e,
            input: r
          }),
          o = new this.cm.EditorView({
            model: i,
            config: this.cm.getConfig()
          }).render().$el;
        return i.init(r), {
          el: i,
          $el: o
        };
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    e.default = {
      isEnabled: function isEnabled() {
        var t = document;
        return t.fullscreenElement || t.webkitFullscreenElement || t.mozFullScreenElement ? 1 : 0;
      },
      enable: function enable(t) {
        var e = "";
        return t.requestFullscreen ? t.requestFullscreen() : t.webkitRequestFullscreen ? (e = "webkit", t.webkitRequestFullscreen()) : t.mozRequestFullScreen ? (e = "moz", t.mozRequestFullScreen()) : t.msRequestFullscreen ? t.msRequestFullscreen() : console.warn("Fullscreen not supported"), e;
      },
      disable: function disable() {
        var t = document;
        this.isEnabled() && (t.exitFullscreen ? t.exitFullscreen() : t.webkitExitFullscreen ? t.webkitExitFullscreen() : t.mozCancelFullScreen ? t.mozCancelFullScreen() : t.msExitFullscreen && t.msExitFullscreen());
      },
      fsChanged: function fsChanged(t, e) {
        document;
        var n = (t || "") + "fullscreenchange";
        this.isEnabled() || (this.stop(null, this.sender), document.removeEventListener(n, this.fsChanged));
      },
      run: function run(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        this.sender = e;
        var i = n.target,
          o = Object(r.isElement)(i) ? i : document.querySelector(i),
          a = this.enable(o || t.getContainer());
        this.fsChanged = this.fsChanged.bind(this, a), document.addEventListener(a + "fullscreenchange", this.fsChanged), t.trigger("change:canvasOffset");
      },
      stop: function stop(t, e) {
        e && e.set && e.set("active", !1), this.disable(), t && t.trigger("change:canvasOffset");
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
      i = n(1),
      o = n.n(i),
      a = n(3),
      s = n(14),
      l = n(27),
      c = o.a.$;
    e.default = Object(r.extend)({}, l.default, s.default, {
      init: function init(t) {
        s.default.init.apply(this, arguments), Object(r.bindAll)(this, "initSorter", "rollback", "onEndMove"), this.opt = t, this.hoverClass = this.ppfx + "highlighter-warning", this.badgeClass = this.ppfx + "badge-warning", this.noSelClass = this.ppfx + "no-select";
      },
      enable: function enable() {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        s.default.enable.apply(this, e), this.getBadgeEl().addClass(this.badgeClass), this.getHighlighterEl().addClass(this.hoverClass);
        var r = this.$wrapper;
        r.css("cursor", "move"), r.on("mousedown", this.initSorter), r.addClass(this.noSelClass);
      },
      toggleClipboard: function toggleClipboard() {},
      initSorter: function initSorter(t) {
        var e = c(t.target).data("model").get("draggable");
        e && (this.cacheEl = null, this.startSelectPosition(t.target, this.frameEl.contentDocument), this.sorter.draggable = e, this.sorter.onEndMove = this.onEndMove.bind(this), this.stopSelectComponent(), this.$wrapper.off("mousedown", this.initSorter), Object(a.u)(this.getContentWindow(), "keydown", this.rollback));
      },
      initSorterFromModel: function initSorterFromModel(t) {
        var e = t.get("draggable");
        if (e) {
          this.cacheEl = null;
          var n = t.view.el;
          this.startSelectPosition(n, this.frameEl.contentDocument), this.sorter.draggable = e, this.sorter.onEndMove = this.onEndMoveFromModel.bind(this), this.stopSelectComponent(), Object(a.u)(this.getContentWindow(), "keydown", this.rollback);
        }
      },
      initSorterFromModels: function initSorterFromModels(t) {
        this.cacheEl = null;
        var e = t[t.length - 1],
          n = (this.em.get("currentFrame") || {}).model,
          r = e.getEl(n),
          i = r.ownerDocument;
        this.startSelectPosition(r, i, {
          onStart: this.onStart
        }), this.sorter.draggable = e.get("draggable"), this.sorter.toMove = t, this.sorter.onMoveClb = this.onDrag, this.sorter.onEndMove = this.onEndMoveFromModel.bind(this), this.stopSelectComponent(), Object(a.u)(this.getContentWindow(), "keydown", this.rollback);
      },
      onEndMoveFromModel: function onEndMoveFromModel() {
        Object(a.t)(this.getContentWindow(), "keydown", this.rollback);
      },
      onEndMove: function onEndMove() {
        this.enable(), Object(a.t)(this.getContentWindow(), "keydown", this.rollback);
      },
      onSelect: function onSelect(t, e) {},
      rollback: function rollback(t, e) {
        (27 == (t.which || t.keyCode) || e) && (this.sorter.moved = !1, this.sorter.endMove());
      },
      getBadgeEl: function getBadgeEl() {
        return this.$badge || (this.$badge = c(this.getBadge())), this.$badge;
      },
      getHighlighterEl: function getHighlighterEl() {
        return this.$hl || (this.$hl = c(this.canvas.getHighlighter())), this.$hl;
      },
      stop: function stop() {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
        s.default.stop.apply(this, e), this.getBadgeEl().removeClass(this.badgeClass), this.getHighlighterEl().removeClass(this.hoverClass);
        var r = this.$wrapper;
        r.css("cursor", "").unbind().removeClass(this.noSelClass);
      }
    });
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t, e) {
        var n = this,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          i = t.Modal,
          o = t.AssetManager,
          a = o.getConfig(),
          s = o.getContainer(),
          l = r.modalTitle || t.t("assetManager.modalTitle") || "",
          c = r.types,
          u = r.accept;
        if (o.setTarget(r.target), o.onClick(r.onClick), o.onDblClick(r.onDblClick), o.onSelect(r.onSelect), !this.rendered || c) {
          var d = o.getAll().filter(function (t) {
            return 1;
          });
          c && c.length && (d = d.filter(function (t) {
            return -1 !== c.indexOf(t.get("type"));
          })), o.render(d), this.rendered = 1;
        }
        if (u) {
          var h = s.querySelector("input#".concat(a.stylePrefix, "uploadFile"));
          h && h.setAttribute("accept", u);
        }
        return i.open({
          title: l,
          content: s
        }).getModel().once("change:open", function () {
          return t.stopCommand(n.id);
        }), this;
      },
      stop: function stop(t) {
        return t.Modal.close(), this;
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t, e) {
        var n = t.BlockManager,
          r = t.Panels;
        if (!this.blocks) {
          n.render();
          var i = "views-container",
            o = document.createElement("div"),
            a = r.getPanel(i) || r.addPanel({
              id: i
            });
          o.appendChild(n.getContainer()), a.set("appendContent", o).trigger("change:appendContent"), this.blocks = o;
        }
        this.blocks.style.display = "block";
      },
      stop: function stop() {
        var t = this.blocks;
        t && (t.style.display = "none");
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1);
    n.n(r).a.$;
    e.default = {
      run: function run(t) {
        var e = t.LayerManager,
          n = t.Panels;
        if (!this.layers) {
          var r = "views-container",
            i = document.createElement("div"),
            o = n.getPanel(r) || n.addPanel({
              id: r
            });
          i.appendChild(e.render()), o.set("appendContent", i).trigger("change:appendContent"), this.layers = i;
        }
        this.layers.style.display = "block";
      },
      stop: function stop() {
        var t = this.layers;
        t && (t.style.display = "none");
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
      i = n.n(r).a.$;
    e.default = {
      run: function run(t, e) {
        if (this.sender = e, !this.$cn) {
          var n = t.getConfig(),
            r = t.Panels;
          this.$cn = i("<div></div>"), this.$cn2 = i("<div></div>"), this.$cn.append(this.$cn2);
          var o = t.DeviceManager;
          if (o && n.showDevices) r.addPanel({
            id: "devices-c"
          }).set("appendContent", o.render()).trigger("change:appendContent");
          var a = t.SelectorManager;
          a && this.$cn2.append(a.render([])), this.$cn2.append(t.StyleManager.render());
          var s = t.StyleManager.getConfig().stylePrefix;
          this.$header = i('<div class="'.concat(s, 'header">').concat(t.t("styleManager.empty"), "</div>")), this.$cn.append(this.$header), r.getPanel("views-container") ? this.panel = r.getPanel("views-container") : this.panel = r.addPanel({
            id: "views-container"
          }), this.panel.set("appendContent", this.$cn).trigger("change:appendContent"), this.target = t.editor, this.listenTo(this.target, "component:toggled", this.toggleSm);
        }
        this.toggleSm();
      },
      toggleSm: function toggleSm() {
        var t = this.target,
          e = this.sender;
        if (!e || !e.get || e.get("active")) {
          var n = t.get("SelectorManager").getConfig().componentFirst,
            r = t.getSelectedAll().length;
          1 === r || r > 1 && n ? (this.$cn2.show(), this.$header.hide()) : (this.$cn2.hide(), this.$header.show());
        }
      },
      stop: function stop() {
        this.$cn2 && this.$cn2.hide(), this.$header && this.$header.hide();
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
      i = n.n(r).a.$;
    e.default = {
      run: function run(t, e) {
        this.sender = e;
        var n = t.getModel(),
          r = t.Config.stylePrefix,
          o = t.TraitManager;
        if (!this.$cn) {
          var a = o.getTraitsViewer(),
            s = o.getConfig();
          this.$cn = i("<div></div>"), this.$cn2 = i("<div></div>"), this.$cn.append(this.$cn2), this.$header = i("<div>").append('<div class="'.concat(s.stylePrefix, 'header">').concat(n.t("traitManager.empty"), "</div>")), this.$cn.append(this.$header), this.$cn2.append('<div class="'.concat(r, 'traits-label">').concat(n.t("traitManager.label"), "</div>")), this.$cn2.append(a.render().el);
          var l = t.Panels;
          (l.getPanel("views-container") ? l.getPanel("views-container") : l.addPanel({
            id: "views-container"
          })).set("appendContent", this.$cn.get(0)).trigger("change:appendContent"), this.target = t.getModel(), this.listenTo(this.target, "component:toggled", this.toggleTm);
        }
        this.toggleTm();
      },
      toggleTm: function toggleTm() {
        var t = this.sender;
        t && t.get && !t.get("active") || (1 === this.target.getSelectedAll().length ? (this.$cn2.show(), this.$header.hide()) : (this.$cn2.hide(), this.$header.show()));
      },
      stop: function stop() {
        this.$cn2 && this.$cn2.hide(), this.$header && this.$header.hide();
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    e.default = {
      run: function run(t) {
        var e = t.getModel().get("clipboard"),
          n = t.getSelected();
        e && n && (t.getSelectedAll().forEach(function (n) {
          if (n) {
            var i,
              o = n.collection,
              a = o.indexOf(n) + 1,
              s = e.filter(function (t) {
                return t.get("copyable");
              });
            i = Object(r.contains)(e, n) && n.get("copyable") ? o.add(n.clone(), {
              at: a
            }) : o.add(s.map(function (t) {
              return t.clone();
            }), {
              at: a
            }), (i = Object(r.isArray)(i) ? i : [i]).forEach(function (e) {
              return t.trigger("component:paste", e);
            });
          }
        }), n.emitUpdate());
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
      i = "sw-visibility";
    e.default = {
      getPanels: function getPanels(t) {
        return this.panels || (this.panels = t.Panels.getPanels()), this.panels;
      },
      preventDrag: function preventDrag(t) {
        t.abort = 1;
      },
      tglPointers: function tglPointers(t, e) {
        var n = t.Canvas.getBody().querySelectorAll(".".concat(this.ppfx, "no-pointer"));
        Object(r.each)(n, function (t) {
          return t.style.pointerEvents = e ? "" : "all";
        });
      },
      tglEffects: function tglEffects(t) {
        var e = this.em;
        e && e[t ? "on" : "off"]("run:tlb-move:before", this.preventDrag);
      },
      run: function run(t, e) {
        var n = this;
        this.sender = e, this.shouldRunSwVisibility || (this.shouldRunSwVisibility = t.Commands.isActive(i)), this.shouldRunSwVisibility && t.stopCommand(i), t.getModel().stopDefault();
        var r = this.getPanels(t),
          o = t.Canvas.getElement(),
          a = t.getEl(),
          s = t.Config.stylePrefix;
        if (!this.helper) {
          var l = document.createElement("span");
          l.className = "".concat(s, "off-prv fa fa-eye-slash"), a.appendChild(l), l.onclick = function () {
            return n.stopCommand();
          }, this.helper = l;
        }
        this.helper.style.display = "inline-block", this.tglPointers(t), r.forEach(function (t) {
          return t.set("visible", !1);
        });
        var c = o.style;
        c.width = "100%", c.height = "100%", c.top = "0", c.left = "0", c.padding = "0", c.margin = "0", t.refresh(), this.tglEffects(1);
      },
      stop: function stop(t) {
        var e = this.sender,
          n = void 0 === e ? {} : e;
        n.set && n.set("active", 0);
        var r = this.getPanels(t);
        this.shouldRunSwVisibility && (t.runCommand(i), this.shouldRunSwVisibility = !1), t.getModel().runDefault(), r.forEach(function (t) {
          return t.set("visible", !0);
        }), t.Canvas.getElement().setAttribute("style", ""), this.helper && (this.helper.style.display = "none"), t.refresh(), this.tglPointers(t, 1), this.tglEffects();
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t, e, n) {
        var r = n || {},
          i = r.el || "",
          o = t.Canvas,
          a = this.canvasResizer,
          s = r.options || {},
          l = o.getCanvasView();
        return s.appendTo = o.getResizerEl(), s.prefix = t.getConfig().stylePrefix, s.posFetcher = l.getElementPos.bind(l), s.mousePosFetcher = o.getMouseRelativePos, a && !r.forceNew || (this.canvasResizer = t.Utils.Resizer.init(s), a = this.canvasResizer), a.setOptions(s), a.blur(), a.focus(i), a;
      },
      stop: function stop() {
        var t = this.canvasResizer;
        t && t.blur();
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        var e = t.Storage.getCurrentStorage();
        e.attributes.isDeleteContent && (e.attributes.isDeleteContent = !1), t.store();
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(1),
      a = n.n(o),
      s = n(0),
      l = n(3);
    function c(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    var u = a.a.$;
    e.default = {
      getOffsetMethod: function getOffsetMethod(t) {
        return "get" + (t || "") + "OffsetViewerEl";
      },
      run: function run(t, e, n) {
        var r = n || {},
          o = r.state || "",
          a = t.getConfig(),
          d = this.em.getZoomDecimal(),
          h = r.el || "";
        if (!a.showOffsets || Object(l.q)(h) || !a.showOffsetsSelected && "Fixed" == o) t.stopCommand(this.id, n);else {
          var f = t.Canvas,
            p = function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {};
                e % 2 ? c(Object(n), !0).forEach(function (e) {
                  i()(t, e, n[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                });
              }
              return t;
            }({}, r.elPos || f.getElementPos(h));
          Object(s.isUndefined)(r.top) || (p.top = r.top), Object(s.isUndefined)(r.left) || (p.left = r.left);
          var g = window.getComputedStyle(h),
            v = this.ppfx,
            m = o + "State",
            b = f[this.getOffsetMethod(o)](n.view);
          b.style.opacity = "";
          var y = this["marginT" + o],
            w = this["marginB" + o],
            x = this["marginL" + o],
            O = this["marginR" + o],
            C = this["padT" + o],
            S = this["padB" + o],
            k = this["padL" + o],
            j = this["padR" + o];
          if (b.childNodes.length && (this[m] = "1", y = b.querySelector("[data-offset-m-t]"), w = b.querySelector("[data-offset-m-b]"), x = b.querySelector("[data-offset-m-l]"), O = b.querySelector("[data-offset-m-r]"), C = b.querySelector("[data-offset-p-t]"), S = b.querySelector("[data-offset-p-b]"), k = b.querySelector("[data-offset-p-l]"), j = b.querySelector("[data-offset-p-r]")), !this[m]) {
            var T = o.toLowerCase(),
              P = T + "margin-v",
              E = T + "padding-v",
              D = u('<div class="'.concat(v, 'marginName">')).get(0),
              M = u('<div class="'.concat(v, 'paddingName">')).get(0),
              A = v + E + "-el",
              L = "".concat(v + P + "-el", " ").concat(v + P),
              N = "".concat(A, " ").concat(v + E);
            y = u('<div class="'.concat(L, '-top"></div>')).get(0), w = u('<div class="'.concat(L, '-bottom"></div>')).get(0), x = u('<div class="'.concat(L, '-left"></div>')).get(0), O = u('<div class="'.concat(L, '-right"></div>')).get(0), C = u('<div class="'.concat(N, '-top"></div>')).get(0), S = u('<div class="'.concat(N, '-bottom"></div>')).get(0), k = u('<div class="'.concat(N, '-left"></div>')).get(0), j = u('<div class="'.concat(N, '-right"></div>')).get(0), this["marginT" + o] = y, this["marginB" + o] = w, this["marginL" + o] = x, this["marginR" + o] = O, this["padT" + o] = C, this["padB" + o] = S, this["padL" + o] = k, this["padR" + o] = j, D.appendChild(y), D.appendChild(w), D.appendChild(x), D.appendChild(O), M.appendChild(C), M.appendChild(S), M.appendChild(k), M.appendChild(j), b.appendChild(D), b.appendChild(M), this[m] = "1";
          }
          var _ = parseFloat(g.marginLeft.replace("px", "")) * d,
            I = parseFloat(g.marginRight.replace("px", "")) * d,
            F = parseFloat(g.marginTop.replace("px", "")) * d,
            V = parseFloat(g.marginBottom.replace("px", "")) * d,
            R = y.style,
            z = w.style,
            H = x.style,
            $ = O.style,
            B = C.style,
            W = S.style,
            U = k.style,
            q = j.style,
            G = parseFloat(p.left),
            K = parseFloat(g.width) * d + "px";
          R.height = F + "px", R.width = K, R.top = p.top - F + "px", R.left = G + "px", z.height = V + "px", z.width = K, z.top = p.top + p.height + "px", z.left = G + "px";
          var Y = p.height + F + V + "px",
            X = p.top - F + "px";
          H.height = Y, H.width = _ + "px", H.top = X, H.left = G - _ + "px", $.height = Y, $.width = I + "px", $.top = X, $.left = G + p.width + "px";
          var J = parseFloat(g.paddingTop) * d;
          B.height = J + "px";
          var Z = parseFloat(g.paddingBottom) * d;
          W.height = Z + "px";
          var Q = p.height - Z - J + "px",
            tt = p.top + J + "px";
          U.height = Q, U.width = parseFloat(g.paddingLeft) * d + "px", U.top = tt;
          var et = parseFloat(g.paddingRight) * d;
          q.height = Q, q.width = et + "px", q.top = tt;
        }
      },
      stop: function stop(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = n || {},
          i = r.state || "",
          o = this.getOffsetMethod(i),
          a = t.Canvas,
          s = a[o](n.view);
        s.style.opacity = 0;
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), e.default = {
      run: function run(t) {
        this.toggleVis(t);
      },
      stop: function stop(t) {
        this.toggleVis(t, 0);
      },
      toggleVis: function toggleVis(t) {
        var e = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
        if (!t.Commands.isActive("preview")) {
          var r = n ? "add" : "remove";
          t.Canvas.getFrames().forEach(function (t) {
            t.view.getBody().classList[r]("".concat(e.ppfx, "dashed"));
          });
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = {
        stylePrefix: "",
        appendTo: "",
        sortable: 1,
        hidable: 1,
        hideTextnode: 1,
        root: "",
        showWrapper: 1,
        showHover: 1,
        scrollCanvas: {
          behavior: "smooth",
          block: "nearest"
        },
        scrollLayers: {
          behavior: "auto",
          block: "nearest"
        },
        highlightHover: 1
      },
      a = n(36),
      s = n(0);
    function l(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function c(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? l(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n = {};
      return {
        name: "LayerManager",
        init: function init() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return (n = c(c({}, o), e)).stylePrefix = e.pStylePrefix, t = n.em, this;
        },
        getConfig: function getConfig() {
          return n;
        },
        onLoad: function onLoad() {
          e = new a.a({
            level: 0,
            config: n,
            opened: n.opened || {},
            model: t.get("DomComponents").getWrapper()
          }), t && t.on("component:selected", this.componentChanged), this.componentChanged();
        },
        postRender: function postRender() {
          var t = n.appendTo,
            e = n.root;
          (e && this.setRoot(e), t) && (Object(s.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
        },
        setRoot: function setRoot(t) {
          return e.setRoot(t), this;
        },
        getRoot: function getRoot() {
          return e.model;
        },
        getAll: function getAll() {
          return e;
        },
        componentChanged: function componentChanged(e) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!r.fromLayers) {
            var i = t.get("opened"),
              o = t.getSelected(),
              a = n.scrollLayers,
              s = o && o.collection ? o.collection.parent : null;
            for (var l in i) i[l].set("open", 0);
            for (; s;) s.set("open", 1), i[s.cid] = s, s = s.collection ? s.collection.parent : null;
            if (o && a) {
              var c = o.viewLayer && o.viewLayer.el;
              c && c.scrollIntoView(a);
            }
          }
        },
        render: function render() {
          return e.render().el;
        }
      };
    };
  }, function (t, e, n) {
    var r, i, o;
    /*!
     * Backbone.Undo.js v0.2
     * 
     * Copyright (c)2013 Oliver Sartun
     * Released under the MIT License
     *
     * Documentation and full license available at
     * https://github.com/osartun/Backbone.Undo.js
     */
    i = [n(0), n(1)], void 0 === (o = "function" == typeof (r = function r(t, e) {
      var n = Array.prototype.slice;
      function r(t, e, n) {
        return n.length <= 4 ? t.call(e, n[0], n[1], n[2], n[3]) : t.apply(e, n);
      }
      function i(t, e) {
        return n.call(t, e);
      }
      function o(e, n) {
        return null != e && (t.isArray(n) || (n = i(arguments, 1)), t.all(n, function (t) {
          return t in e;
        }));
      }
      var a,
        s,
        l = (a = !1, s = -1, function () {
          return a || (s++, a = !0, t.defer(function () {
            a = !1;
          })), s;
        });
      function c() {
        this.registeredObjects = [], this.cidIndexes = [];
      }
      function u(e, n, r, i) {
        for (var o, a = 0, s = n.length; a < s; a++) if (o = n[a]) {
          if ("on" === e) {
            if (!i.objectRegistry.register(o)) continue;
          } else if (!i.objectRegistry.unregister(o)) continue;
          t.isFunction(o[e]) && o[e]("all", r, i);
        }
      }
      function d(e, n) {
        var r = n.type,
          i = n.undoTypes,
          o = !i[r] || i[r][e];
        t.isFunction(o) && o(n.object, n.before, n.after, n.options);
      }
      function h(e, r, i, o, a) {
        if (!(i.isCurrentlyUndoRedoing || "undo" === e && -1 === i.pointer || "redo" === e && i.pointer === i.length - 1)) {
          i.isCurrentlyUndoRedoing = !0;
          var s,
            l,
            c = "undo" === e;
          for (a ? l = c && i.pointer === i.length - 1 || !c && -1 === i.pointer ? t.clone(i.models) : n.apply(i.models, c ? [0, i.pointer] : [i.pointer, i.length - 1]) : (s = i.at(c ? i.pointer : i.pointer + 1), l = o ? i.where({
            magicFusionIndex: s.get("magicFusionIndex")
          }) : [s]), i.pointer += (c ? -1 : 1) * l.length; s = c ? l.pop() : l.shift();) s[e]();
          i.isCurrentlyUndoRedoing = !1, r.trigger(e, r);
        }
      }
      function f(t, e, n, i) {
        if (t.track && !t.isCurrentlyUndoRedoing && e in i && function (t, e) {
          var n = t.condition,
            i = typeof n;
          return "function" === i ? !!r(n, t, e) : "boolean" !== i || n;
        }(i[e], n)) {
          var a = r(i[e].on, i[e], n);
          if (o(a, "object", "before", "after")) {
            if (a.type = e, a.magicFusionIndex = l(), a.undoTypes = i, t.pointer < t.length - 1) for (var s = t.length - t.pointer - 1; s--;) t.pop();
            t.pointer = t.length, t.add(a), t.length > t.maximumStackLength && (t.shift(), t.pointer--);
          }
        }
      }
      c.prototype = {
        isRegistered: function isRegistered(e) {
          return e && e.cid ? this.registeredObjects[e.cid] : t.contains(this.registeredObjects, e);
        },
        register: function register(t) {
          return !this.isRegistered(t) && (t && t.cid ? (this.registeredObjects[t.cid] = t, this.cidIndexes.push(t.cid)) : this.registeredObjects.push(t), !0);
        },
        unregister: function unregister(e) {
          if (this.isRegistered(e)) {
            if (e && e.cid) delete this.registeredObjects[e.cid], this.cidIndexes.splice(t.indexOf(this.cidIndexes, e.cid), 1);else {
              var n = t.indexOf(this.registeredObjects, e);
              this.registeredObjects.splice(n, 1);
            }
            return !0;
          }
          return !1;
        },
        get: function get() {
          return t.map(this.cidIndexes, function (t) {
            return this.registeredObjects[t];
          }, this).concat(this.registeredObjects);
        }
      };
      var p = {
        add: {
          undo: function undo(t, e, n, r) {
            t.remove(n, r);
          },
          redo: function redo(t, e, n, r) {
            r.index && (r.at = r.index), t.add(n, r);
          },
          on: function on(e, n, r) {
            return {
              object: n,
              before: void 0,
              after: e,
              options: t.clone(r)
            };
          }
        },
        remove: {
          undo: function undo(t, e, n, r) {
            "index" in r && (r.at = r.index), t.add(e, r);
          },
          redo: function redo(t, e, n, r) {
            t.remove(e, r);
          },
          on: function on(e, n, r) {
            return {
              object: n,
              before: e,
              after: void 0,
              options: t.clone(r)
            };
          }
        },
        change: {
          undo: function undo(e, n, r, i) {
            t.isEmpty(n) ? t.each(t.keys(r), e.unset, e) : (e.set(n), i && i.unsetData && i.unsetData.before && i.unsetData.before.length && t.each(i.unsetData.before, e.unset, e));
          },
          redo: function redo(e, n, r, i) {
            t.isEmpty(r) ? t.each(t.keys(n), e.unset, e) : (e.set(r), i && i.unsetData && i.unsetData.after && i.unsetData.after.length && t.each(i.unsetData.after, e.unset, e));
          },
          on: function on(e, n) {
            var r = e.changedAttributes(),
              i = t.keys(r),
              o = t.pick(e.previousAttributes(), i),
              a = t.keys(o),
              s = (n || (n = {})).unsetData = {
                after: [],
                before: []
              };
            return i.length != a.length && (i.length > a.length ? t.each(i, function (t) {
              t in o || s.before.push(t);
            }, this) : t.each(a, function (t) {
              t in r || s.after.push(t);
            })), {
              object: e,
              before: o,
              after: r,
              options: t.clone(n)
            };
          }
        },
        reset: {
          undo: function undo(t, e, n) {
            t.reset(e);
          },
          redo: function redo(t, e, n) {
            t.reset(n);
          },
          on: function on(e, n) {
            return {
              object: e,
              before: n.previousModels,
              after: t.clone(e.models)
            };
          }
        }
      };
      function g() {}
      function v(e, n, r, i) {
        if ("object" == typeof n) return t.each(n, function (t, n) {
          2 === e ? v(e, t, r, i) : v(e, n, t, r);
        });
        switch (e) {
          case 0:
            o(r, "undo", "redo", "on") && t.all(t.pick(r, "undo", "redo", "on"), t.isFunction) && (i[n] = r);
            break;
          case 1:
            i[n] && t.isObject(r) && (i[n] = t.extend({}, i[n], r));
            break;
          case 2:
            delete i[n];
        }
        return this;
      }
      g.prototype = p;
      var m = e.Model.extend({
          defaults: {
            type: null,
            object: null,
            before: null,
            after: null,
            magicFusionIndex: null
          },
          undo: function undo(t) {
            d("undo", this.attributes);
          },
          redo: function redo(t) {
            d("redo", this.attributes);
          }
        }),
        b = e.Collection.extend({
          model: m,
          pointer: -1,
          track: !1,
          isCurrentlyUndoRedoing: !1,
          maximumStackLength: 1 / 0,
          setMaxLength: function setMaxLength(t) {
            this.maximumStackLength = t;
          }
        }),
        y = e.Model.extend({
          defaults: {
            maximumStackLength: 1 / 0,
            track: !1
          },
          initialize: function initialize(e) {
            this.stack = new b(), this.objectRegistry = new c(), this.undoTypes = new g(), this.stack.setMaxLength(this.get("maximumStackLength")), this.on("change:maximumStackLength", function (t, e) {
              this.stack.setMaxLength(e);
            }, this), e && e.track && this.startTracking(), e && e.register && (t.isArray(e.register) || t.isArguments(e.register) ? r(this.register, this, e.register) : this.register(e.register));
          },
          startTracking: function startTracking() {
            this.set("track", !0), this.stack.track = !0;
          },
          stopTracking: function stopTracking() {
            this.set("track", !1), this.stack.track = !1;
          },
          isTracking: function isTracking() {
            return this.get("track");
          },
          _addToStack: function _addToStack(t) {
            f(this.stack, t, i(arguments, 1), this.undoTypes);
          },
          register: function register() {
            u("on", arguments, this._addToStack, this);
          },
          unregister: function unregister() {
            u("off", arguments, this._addToStack, this);
          },
          unregisterAll: function unregisterAll() {
            r(this.unregister, this, this.objectRegistry.get());
          },
          undo: function undo(t) {
            h("undo", this, this.stack, t);
          },
          undoAll: function undoAll() {
            h("undo", this, this.stack, !1, !0);
          },
          redo: function redo(t) {
            h("redo", this, this.stack, t);
          },
          redoAll: function redoAll() {
            h("redo", this, this.stack, !1, !0);
          },
          isAvailable: function isAvailable(t) {
            var e = this.stack,
              n = e.length;
            switch (t) {
              case "undo":
                return n > 0 && e.pointer > -1;
              case "redo":
                return n > 0 && e.pointer < n - 1;
              default:
                return !1;
            }
          },
          merge: function merge(e) {
            for (var n, r = t.isArray(e) ? e : i(arguments); n = r.pop();) n instanceof y && n.stack instanceof b && (n.stack = this.stack);
          },
          addUndoType: function addUndoType(t, e) {
            v(0, t, e, this.undoTypes);
          },
          changeUndoType: function changeUndoType(t, e) {
            v(1, t, e, this.undoTypes);
          },
          removeUndoType: function removeUndoType(t) {
            v(2, t, void 0, this.undoTypes);
          },
          clear: function clear() {
            this.stack.reset(), this.stack.pointer = -1;
          }
        });
      return t.extend(y, {
        defaults: function defaults(e) {
          t.extend(y.prototype.defaults, e);
        },
        addUndoType: function addUndoType(t, e) {
          v(0, t, e, p);
        },
        changeUndoType: function changeUndoType(t, e) {
          v(1, t, e, p);
        },
        removeUndoType: function removeUndoType(t) {
          v(2, t, void 0, p);
        }
      }), e.UndoManager = y;
    }) ? r.apply(e, i) : r) || (t.exports = o);
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      var e = this.constructor;
      return this.then(function (n) {
        return e.resolve(t()).then(function () {
          return n;
        });
      }, function (n) {
        return e.resolve(t()).then(function () {
          return e.reject(n);
        });
      });
    };
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      return new this(function (e, n) {
        if (!t || void 0 === t.length) return n(new TypeError(typeof t + " " + t + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var r = Array.prototype.slice.call(t);
        if (0 === r.length) return e([]);
        var i = r.length;
        function o(t, n) {
          if (n && ("object" == typeof n || "function" == typeof n)) {
            var a = n.then;
            if ("function" == typeof a) return void a.call(n, function (e) {
              o(t, e);
            }, function (n) {
              r[t] = {
                status: "rejected",
                reason: n
              }, 0 == --i && e(r);
            });
          }
          r[t] = {
            status: "fulfilled",
            value: n
          }, 0 == --i && e(r);
        }
        for (var a = 0; a < r.length; a++) o(a, r[a]);
      });
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      this.name = "AggregateError", this.errors = t, this.message = e || "";
    }
    r.prototype = Error.prototype, e.a = function (t) {
      var e = this;
      return new e(function (n, i) {
        if (!t || void 0 === t.length) return i(new TypeError("Promise.any accepts an array"));
        var o = Array.prototype.slice.call(t);
        if (0 === o.length) return i();
        for (var a = [], s = 0; s < o.length; s++) try {
          e.resolve(o[s]).then(n).catch(function (t) {
            a.push(t), a.length === o.length && i(new r(a, "All promises were rejected"));
          });
        } catch (t) {
          i(t);
        }
      });
    };
  }, function (t, e, n) {
    var r = n(95),
      i = n(96),
      o = n(44),
      a = n(97);
    t.exports = function (t, e) {
      return r(t) || i(t, e) || o(t, e) || a();
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    var r = n(8).default;
    t.exports = function (t, e) {
      if ("object" != r(t) || !t) return t;
      var n = t[Symbol.toPrimitive];
      if (void 0 !== n) {
        var i = n.call(t, e || "default");
        if ("object" != r(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === e ? String : Number)(t);
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    var r = n(43);
    t.exports = function (t) {
      if (Array.isArray(t)) return r(t);
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e) {
    t.exports = function (t) {
      if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(8),
      i = n.n(r),
      o = n(2),
      a = n.n(o),
      s = n(0),
      l = n(39),
      c = n.n(l);
    function u(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function d(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? u(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n = {},
        r = {
          defaults: {
            "core:undo": {
              keys: "⌘+z, ctrl+z",
              handler: "core:undo"
            },
            "core:redo": {
              keys: "⌘+shift+z, ctrl+shift+z",
              handler: "core:redo"
            },
            "core:copy": {
              keys: "⌘+c, ctrl+c",
              handler: "core:copy"
            },
            "core:paste": {
              keys: "⌘+v, ctrl+v",
              handler: "core:paste"
            },
            "core:component-next": {
              keys: "s",
              handler: "core:component-next"
            },
            "core:component-prev": {
              keys: "w",
              handler: "core:component-prev"
            },
            "core:component-enter": {
              keys: "d",
              handler: "core:component-enter"
            },
            "core:component-exit": {
              keys: "a",
              handler: "core:component-exit"
            },
            "core:component-delete": {
              keys: "backspace, delete",
              handler: "core:component-delete",
              opts: {
                prevent: 1
              }
            }
          }
        };
      return {
        keymaster: c.a,
        name: "Keymaps",
        getConfig: function getConfig() {
          return e;
        },
        init: function init() {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return e = d(d({}, r), n), t = e.em, this.em = t, this;
        },
        onLoad: function onLoad() {
          var t = e.defaults;
          for (var n in t) {
            var r = t[n];
            this.add(n, r.keys, r.handler, r.opts || {});
          }
        },
        add: function add(t, e, r) {
          var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            a = this.em,
            l = a.get("Commands"),
            u = a.getEditor(),
            d = a.get("Canvas"),
            h = {
              id: t,
              keys: e,
              handler: r
            },
            f = n[t];
          return f && this.remove(t), n[t] = h, c()(e, function (e, n) {
            var c = {
              event: e,
              h: n
            };
            if (r = Object(s.isString)(r) ? l.get(r) : r, !a.isEditing() && !u.Canvas.isInputFocused() || o.force) {
              o.prevent && d.getCanvasView().preventDefault(e), "object" == i()(r) ? l.runCommand(r, c) : r(u, 0, c);
              var h = [t, n.shortcut, e];
              a.trigger.apply(a, ["keymap:emit"].concat(h)), a.trigger.apply(a, ["keymap:emit:".concat(t)].concat(h));
            }
          }), a.trigger("keymap:add", h), h;
        },
        get: function get(t) {
          return n[t];
        },
        getAll: function getAll() {
          return n;
        },
        remove: function remove(t) {
          var e = this.em,
            r = this.get(t);
          if (r) return delete n[t], c.a.unbind(r.keys), e && e.trigger("keymap:remove", r), r;
        },
        removeAll: function removeAll() {
          var t = this;
          return Object.keys(n).forEach(function (e) {
            return t.remove(e);
          }), this;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(76),
      a = n.n(o);
    function s(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function l(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? s(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n,
        r,
        i = {
          maximumStackLength: 500
        };
      return {
        name: "UndoManager",
        init: function init() {
          var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          n = l(l({}, o), i), t = n.em, this.em = t, (e = new a.a(l({
            track: !0,
            register: []
          }, n))).changeUndoType("change", {
            condition: !1
          }), e.changeUndoType("add", {
            on: function on(t, e) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              if (!n.avoidStore) return {
                object: e,
                before: void 0,
                after: t,
                options: l({}, n)
              };
            }
          }), e.changeUndoType("remove", {
            on: function on(t, e) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              if (!n.avoidStore) return {
                object: e,
                before: t,
                after: void 0,
                options: l({}, n)
              };
            }
          });
          var s = {
              on: function on(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (!r && (r = t.previousAttributes()), !n.avoidStore) {
                  var i = {
                    object: t,
                    before: r,
                    after: t.toJSON()
                  };
                  return r = null, i;
                }
              },
              undo: function undo(t, e, n, r) {
                t.set(e);
              },
              redo: function redo(t, e, n, r) {
                t.set(n);
              }
            },
            c = ["style", "attributes", "content", "src"];
          return c.forEach(function (t) {
            return e.addUndoType("change:".concat(t), s);
          }), e.on("undo redo", function () {
            return t.trigger("component:toggled change:canvasOffset");
          }), ["undo", "redo"].forEach(function (n) {
            return e.on(n, function () {
              return t.trigger(n);
            });
          }), this;
        },
        getConfig: function getConfig() {
          return n;
        },
        add: function add(t) {
          return e.register(t), this;
        },
        remove: function remove(t) {
          return e.unregister(t), this;
        },
        removeAll: function removeAll() {
          return e.unregisterAll(), this;
        },
        start: function start() {
          return e.startTracking(), this;
        },
        stop: function stop() {
          return e.stopTracking(), this;
        },
        undo: function undo() {
          var n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          return !t.isEditing() && e.undo(n), this;
        },
        undoAll: function undoAll() {
          return e.undoAll(), this;
        },
        redo: function redo() {
          var n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          return !t.isEditing() && e.redo(n), this;
        },
        redoAll: function redoAll() {
          return e.redoAll(), this;
        },
        hasUndo: function hasUndo() {
          return e.isAvailable("undo");
        },
        hasRedo: function hasRedo() {
          return e.isAvailable("redo");
        },
        getStack: function getStack() {
          return e.stack;
        },
        getStackGroup: function getStackGroup() {
          var t = [],
            e = [];
          return this.getStack().forEach(function (n) {
            var r = n.get("magicFusionIndex");
            e.indexOf(r) < 0 && (e.push(r), t.push(n));
          }), t;
        },
        getPointer: function getPointer() {
          return this.getStack().pointer;
        },
        clear: function clear() {
          return e.clear(), this;
        },
        getInstance: function getInstance() {
          return e;
        }
      };
    };
  }, function (t, e, n) {
    (function (t) {
      var r = void 0 !== t && t || "undefined" != typeof self && self || window,
        i = Function.prototype.apply;
      function o(t, e) {
        this._id = t, this._clearFn = e;
      }
      e.setTimeout = function () {
        return new o(i.call(setTimeout, r, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new o(i.call(setInterval, r, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, n(88), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, n(26));
  }, function (t, e, n) {
    (function (t, e) {
      !function (t, n) {
        "use strict";

        if (!t.setImmediate) {
          var r,
            i,
            o,
            a,
            s,
            l = 1,
            c = {},
            u = !1,
            d = t.document,
            h = Object.getPrototypeOf && Object.getPrototypeOf(t);
          h = h && h.setTimeout ? h : t, "[object process]" === {}.toString.call(t.process) ? r = function r(t) {
            e.nextTick(function () {
              p(t);
            });
          } : !function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                n = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = n, e;
            }
          }() ? t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
            p(t.data);
          }, r = function r(t) {
            o.port2.postMessage(t);
          }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, r = function r(t) {
            var e = d.createElement("script");
            e.onreadystatechange = function () {
              p(t), e.onreadystatechange = null, i.removeChild(e), e = null;
            }, i.appendChild(e);
          }) : r = function r(t) {
            setTimeout(p, 0, t);
          } : (a = "setImmediate$" + Math.random() + "$", s = function s(e) {
            e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && p(+e.data.slice(a.length));
          }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), r = function r(e) {
            t.postMessage(a + e, "*");
          }), h.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));
            for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) e[n] = arguments[n + 1];
            var i = {
              callback: t,
              args: e
            };
            return c[l] = i, r(l), l++;
          }, h.clearImmediate = f;
        }
        function f(t) {
          delete c[t];
        }
        function p(t) {
          if (u) setTimeout(p, 0, t);else {
            var e = c[t];
            if (e) {
              u = !0;
              try {
                !function (t) {
                  var e = t.callback,
                    n = t.args;
                  switch (n.length) {
                    case 0:
                      e();
                      break;
                    case 1:
                      e(n[0]);
                      break;
                    case 2:
                      e(n[0], n[1]);
                      break;
                    case 3:
                      e(n[0], n[1], n[2]);
                      break;
                    default:
                      e.apply(void 0, n);
                  }
                }(e);
              } finally {
                f(t), u = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, n(26), n(89));
  }, function (t, e) {
    var n,
      r,
      i = t.exports = {};
    function o() {
      throw new Error("setTimeout has not been defined");
    }
    function a() {
      throw new Error("clearTimeout has not been defined");
    }
    function s(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);
      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }
    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        n = o;
      }
      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        r = a;
      }
    }();
    var l,
      c = [],
      u = !1,
      d = -1;
    function h() {
      u && l && (u = !1, l.length ? c = l.concat(c) : d = -1, c.length && f());
    }
    function f() {
      if (!u) {
        var t = s(h);
        u = !0;
        for (var e = c.length; e;) {
          for (l = c, c = []; ++d < e;) l && l[d].run();
          d = -1, e = c.length;
        }
        l = null, u = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);
          try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }
    function p(t, e) {
      this.fun = t, this.array = e;
    }
    function g() {}
    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
      c.push(new p(t, e)), 1 !== c.length || u || s(f);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (null == t) return {};
      var n,
        r,
        i = {},
        o = Object.keys(t);
      for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || (i[n] = t[n]);
      return i;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    !function (t) {
      "use strict";

      var e = {
          script: [["lang", /(javascript|babel)/i, "javascript"], ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i, "javascript"], ["type", /./, "text/plain"], [null, null, "javascript"]],
          style: [["lang", /^css$/i, "css"], ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"], ["type", /./, "text/plain"], [null, null, "css"]]
        },
        n = {};
      function r(t, e) {
        var r = t.match(function (t) {
          var e = n[t];
          return e || (n[t] = new RegExp("\\s+" + t + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*"));
        }(e));
        return r ? /^\s*(.*?)\s*$/.exec(r[2])[1] : "";
      }
      function i(t, e) {
        return new RegExp((e ? "^" : "") + "</\\s*" + t + "\\s*>", "i");
      }
      function o(t, e) {
        for (var n in t) for (var r = e[n] || (e[n] = []), i = t[n], o = i.length - 1; o >= 0; o--) r.unshift(i[o]);
      }
      t.defineMode("htmlmixed", function (n, a) {
        var s = t.getMode(n, {
            name: "xml",
            htmlMode: !0,
            multilineTagIndentFactor: a.multilineTagIndentFactor,
            multilineTagIndentPastTag: a.multilineTagIndentPastTag,
            allowMissingTagName: a.allowMissingTagName
          }),
          l = {},
          c = a && a.tags,
          u = a && a.scriptTypes;
        if (o(e, l), c && o(c, l), u) for (var d = u.length - 1; d >= 0; d--) l.script.unshift(["type", u[d].matches, u[d].mode]);
        function h(e, o) {
          var a,
            c = s.token(e, o.htmlState),
            u = /\btag\b/.test(c);
          if (u && !/[<>\s\/]/.test(e.current()) && (a = o.htmlState.tagName && o.htmlState.tagName.toLowerCase()) && l.hasOwnProperty(a)) o.inTag = a + " ";else if (o.inTag && u && />$/.test(e.current())) {
            var d = /^([\S]+) (.*)/.exec(o.inTag);
            o.inTag = null;
            var f = ">" == e.current() && function (t, e) {
                for (var n = 0; n < t.length; n++) {
                  var i = t[n];
                  if (!i[0] || i[1].test(r(e, i[0]))) return i[2];
                }
              }(l[d[1]], d[2]),
              p = t.getMode(n, f),
              g = i(d[1], !0),
              v = i(d[1], !1);
            o.token = function (t, e) {
              return t.match(g, !1) ? (e.token = h, e.localState = e.localMode = null, null) : function (t, e, n) {
                var r = t.current(),
                  i = r.search(e);
                return i > -1 ? t.backUp(r.length - i) : r.match(/<\/?$/) && (t.backUp(r.length), t.match(e, !1) || t.match(r)), n;
              }(t, v, e.localMode.token(t, e.localState));
            }, o.localMode = p, o.localState = t.startState(p, s.indent(o.htmlState, "", ""));
          } else o.inTag && (o.inTag += e.current(), e.eol() && (o.inTag += " "));
          return c;
        }
        return {
          startState: function startState() {
            return {
              token: h,
              inTag: null,
              localMode: null,
              localState: null,
              htmlState: t.startState(s)
            };
          },
          copyState: function copyState(e) {
            var n;
            return e.localState && (n = t.copyState(e.localMode, e.localState)), {
              token: e.token,
              inTag: e.inTag,
              localMode: e.localMode,
              localState: n,
              htmlState: t.copyState(s, e.htmlState)
            };
          },
          token: function token(t, e) {
            return e.token(t, e);
          },
          indent: function indent(e, n, r) {
            return !e.localMode || /^\s*<\//.test(n) ? s.indent(e.htmlState, n, r) : e.localMode.indent ? e.localMode.indent(e.localState, n, r) : t.Pass;
          },
          innerMode: function innerMode(t) {
            return {
              state: t.localState || t.htmlState,
              mode: t.localMode || s
            };
          }
        };
      }, "xml", "javascript", "css"), t.defineMIME("text/html", "htmlmixed");
    }(n(13), n(92), n(93), n(45));
  }, function (t, e, n) {
    !function (t) {
      "use strict";

      var e = {
          autoSelfClosers: {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            command: !0,
            embed: !0,
            frame: !0,
            hr: !0,
            img: !0,
            input: !0,
            keygen: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0,
            menuitem: !0
          },
          implicitlyClosed: {
            dd: !0,
            li: !0,
            optgroup: !0,
            option: !0,
            p: !0,
            rp: !0,
            rt: !0,
            tbody: !0,
            td: !0,
            tfoot: !0,
            th: !0,
            tr: !0
          },
          contextGrabbers: {
            dd: {
              dd: !0,
              dt: !0
            },
            dt: {
              dd: !0,
              dt: !0
            },
            li: {
              li: !0
            },
            option: {
              option: !0,
              optgroup: !0
            },
            optgroup: {
              optgroup: !0
            },
            p: {
              address: !0,
              article: !0,
              aside: !0,
              blockquote: !0,
              dir: !0,
              div: !0,
              dl: !0,
              fieldset: !0,
              footer: !0,
              form: !0,
              h1: !0,
              h2: !0,
              h3: !0,
              h4: !0,
              h5: !0,
              h6: !0,
              header: !0,
              hgroup: !0,
              hr: !0,
              menu: !0,
              nav: !0,
              ol: !0,
              p: !0,
              pre: !0,
              section: !0,
              table: !0,
              ul: !0
            },
            rp: {
              rp: !0,
              rt: !0
            },
            rt: {
              rp: !0,
              rt: !0
            },
            tbody: {
              tbody: !0,
              tfoot: !0
            },
            td: {
              td: !0,
              th: !0
            },
            tfoot: {
              tbody: !0
            },
            th: {
              td: !0,
              th: !0
            },
            thead: {
              tbody: !0,
              tfoot: !0
            },
            tr: {
              tr: !0
            }
          },
          doNotIndent: {
            pre: !0
          },
          allowUnquoted: !0,
          allowMissing: !0,
          caseFold: !0
        },
        n = {
          autoSelfClosers: {},
          implicitlyClosed: {},
          contextGrabbers: {},
          doNotIndent: {},
          allowUnquoted: !1,
          allowMissing: !1,
          allowMissingTagName: !1,
          caseFold: !1
        };
      t.defineMode("xml", function (r, i) {
        var o,
          a,
          s = r.indentUnit,
          l = {},
          c = i.htmlMode ? e : n;
        for (var u in c) l[u] = c[u];
        for (var u in i) l[u] = i[u];
        function d(t, e) {
          function n(n) {
            return e.tokenize = n, n(t, e);
          }
          var r = t.next();
          return "<" == r ? t.eat("!") ? t.eat("[") ? t.match("CDATA[") ? n(f("atom", "]]>")) : null : t.match("--") ? n(f("comment", "--\x3e")) : t.match("DOCTYPE", !0, !0) ? (t.eatWhile(/[\w\._\-]/), n(function t(e) {
            return function (n, r) {
              for (var i; null != (i = n.next());) {
                if ("<" == i) return r.tokenize = t(e + 1), r.tokenize(n, r);
                if (">" == i) {
                  if (1 == e) {
                    r.tokenize = d;
                    break;
                  }
                  return r.tokenize = t(e - 1), r.tokenize(n, r);
                }
              }
              return "meta";
            };
          }(1))) : null : t.eat("?") ? (t.eatWhile(/[\w\._\-]/), e.tokenize = f("meta", "?>"), "meta") : (o = t.eat("/") ? "closeTag" : "openTag", e.tokenize = h, "tag bracket") : "&" == r ? (t.eat("#") ? t.eat("x") ? t.eatWhile(/[a-fA-F\d]/) && t.eat(";") : t.eatWhile(/[\d]/) && t.eat(";") : t.eatWhile(/[\w\.\-:]/) && t.eat(";")) ? "atom" : "error" : (t.eatWhile(/[^&<]/), null);
        }
        function h(t, e) {
          var n,
            r,
            i = t.next();
          if (">" == i || "/" == i && t.eat(">")) return e.tokenize = d, o = ">" == i ? "endTag" : "selfcloseTag", "tag bracket";
          if ("=" == i) return o = "equals", null;
          if ("<" == i) {
            e.tokenize = d, e.state = b, e.tagName = e.tagStart = null;
            var a = e.tokenize(t, e);
            return a ? a + " tag error" : "tag error";
          }
          return /[\'\"]/.test(i) ? (e.tokenize = (n = i, (r = function r(t, e) {
            for (; !t.eol();) if (t.next() == n) {
              e.tokenize = h;
              break;
            }
            return "string";
          }).isInAttribute = !0, r), e.stringStartCol = t.column(), e.tokenize(t, e)) : (t.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/), "word");
        }
        function f(t, e) {
          return function (n, r) {
            for (; !n.eol();) {
              if (n.match(e)) {
                r.tokenize = d;
                break;
              }
              n.next();
            }
            return t;
          };
        }
        function p(t) {
          return t && t.toLowerCase();
        }
        function g(t, e, n) {
          this.prev = t.context, this.tagName = e || "", this.indent = t.indented, this.startOfLine = n, (l.doNotIndent.hasOwnProperty(e) || t.context && t.context.noIndent) && (this.noIndent = !0);
        }
        function v(t) {
          t.context && (t.context = t.context.prev);
        }
        function m(t, e) {
          for (var n;;) {
            if (!t.context) return;
            if (n = t.context.tagName, !l.contextGrabbers.hasOwnProperty(p(n)) || !l.contextGrabbers[p(n)].hasOwnProperty(p(e))) return;
            v(t);
          }
        }
        function b(t, e, n) {
          return "openTag" == t ? (n.tagStart = e.column(), y) : "closeTag" == t ? w : b;
        }
        function y(t, e, n) {
          return "word" == t ? (n.tagName = e.current(), a = "tag", C) : l.allowMissingTagName && "endTag" == t ? (a = "tag bracket", C(t, 0, n)) : (a = "error", y);
        }
        function w(t, e, n) {
          if ("word" == t) {
            var r = e.current();
            return n.context && n.context.tagName != r && l.implicitlyClosed.hasOwnProperty(p(n.context.tagName)) && v(n), n.context && n.context.tagName == r || !1 === l.matchClosing ? (a = "tag", x) : (a = "tag error", O);
          }
          return l.allowMissingTagName && "endTag" == t ? (a = "tag bracket", x(t, 0, n)) : (a = "error", O);
        }
        function x(t, e, n) {
          return "endTag" != t ? (a = "error", x) : (v(n), b);
        }
        function O(t, e, n) {
          return a = "error", x(t, 0, n);
        }
        function C(t, e, n) {
          if ("word" == t) return a = "attribute", S;
          if ("endTag" == t || "selfcloseTag" == t) {
            var r = n.tagName,
              i = n.tagStart;
            return n.tagName = n.tagStart = null, "selfcloseTag" == t || l.autoSelfClosers.hasOwnProperty(p(r)) ? m(n, r) : (m(n, r), n.context = new g(n, r, i == n.indented)), b;
          }
          return a = "error", C;
        }
        function S(t, e, n) {
          return "equals" == t ? k : (l.allowMissing || (a = "error"), C(t, 0, n));
        }
        function k(t, e, n) {
          return "string" == t ? j : "word" == t && l.allowUnquoted ? (a = "string", C) : (a = "error", C(t, 0, n));
        }
        function j(t, e, n) {
          return "string" == t ? j : C(t, 0, n);
        }
        return d.isInText = !0, {
          startState: function startState(t) {
            var e = {
              tokenize: d,
              state: b,
              indented: t || 0,
              tagName: null,
              tagStart: null,
              context: null
            };
            return null != t && (e.baseIndent = t), e;
          },
          token: function token(t, e) {
            if (!e.tagName && t.sol() && (e.indented = t.indentation()), t.eatSpace()) return null;
            o = null;
            var n = e.tokenize(t, e);
            return (n || o) && "comment" != n && (a = null, e.state = e.state(o || n, t, e), a && (n = "error" == a ? n + " error" : a)), n;
          },
          indent: function indent(e, n, r) {
            var i = e.context;
            if (e.tokenize.isInAttribute) return e.tagStart == e.indented ? e.stringStartCol + 1 : e.indented + s;
            if (i && i.noIndent) return t.Pass;
            if (e.tokenize != h && e.tokenize != d) return r ? r.match(/^(\s*)/)[0].length : 0;
            if (e.tagName) return !1 !== l.multilineTagIndentPastTag ? e.tagStart + e.tagName.length + 2 : e.tagStart + s * (l.multilineTagIndentFactor || 1);
            if (l.alignCDATA && /<!\[CDATA\[/.test(n)) return 0;
            var o = n && /^<(\/)?([\w_:\.-]*)/.exec(n);
            if (o && o[1]) for (; i;) {
              if (i.tagName == o[2]) {
                i = i.prev;
                break;
              }
              if (!l.implicitlyClosed.hasOwnProperty(p(i.tagName))) break;
              i = i.prev;
            } else if (o) for (; i;) {
              var a = l.contextGrabbers[p(i.tagName)];
              if (!a || !a.hasOwnProperty(p(o[2]))) break;
              i = i.prev;
            }
            for (; i && i.prev && !i.startOfLine;) i = i.prev;
            return i ? i.indent + s : e.baseIndent || 0;
          },
          electricInput: /<\/[\s\w:]+>$/,
          blockCommentStart: "\x3c!--",
          blockCommentEnd: "--\x3e",
          configuration: l.htmlMode ? "html" : "xml",
          helperType: l.htmlMode ? "html" : "xml",
          skipAttribute: function skipAttribute(t) {
            t.state == k && (t.state = C);
          },
          xmlCurrentTag: function xmlCurrentTag(t) {
            return t.tagName ? {
              name: t.tagName,
              close: "closeTag" == t.type
            } : null;
          },
          xmlCurrentContext: function xmlCurrentContext(t) {
            for (var e = [], n = t.context; n; n = n.prev) e.push(n.tagName);
            return e.reverse();
          }
        };
      }), t.defineMIME("text/xml", "xml"), t.defineMIME("application/xml", "xml"), t.mimeModes.hasOwnProperty("text/html") || t.defineMIME("text/html", {
        name: "xml",
        htmlMode: !0
      });
    }(n(13));
  }, function (t, e, n) {
    !function (t) {
      "use strict";

      t.defineMode("javascript", function (e, n) {
        var r,
          i,
          o = e.indentUnit,
          a = n.statementIndent,
          s = n.jsonld,
          l = n.json || s,
          c = !1 !== n.trackScope,
          u = n.typescript,
          d = n.wordCharacters || /[\w$\xa1-\uffff]/,
          h = function () {
            function t(t) {
              return {
                type: t,
                style: "keyword"
              };
            }
            var e = t("keyword a"),
              n = t("keyword b"),
              r = t("keyword c"),
              i = t("keyword d"),
              o = t("operator"),
              a = {
                type: "atom",
                style: "atom"
              };
            return {
              if: t("if"),
              while: e,
              with: e,
              else: n,
              do: n,
              try: n,
              finally: n,
              return: i,
              break: i,
              continue: i,
              new: t("new"),
              delete: r,
              void: r,
              throw: r,
              debugger: t("debugger"),
              var: t("var"),
              const: t("var"),
              let: t("var"),
              function: t("function"),
              catch: t("catch"),
              for: t("for"),
              switch: t("switch"),
              case: t("case"),
              default: t("default"),
              in: o,
              typeof: o,
              instanceof: o,
              true: a,
              false: a,
              null: a,
              undefined: a,
              NaN: a,
              Infinity: a,
              this: t("this"),
              class: t("class"),
              super: t("atom"),
              yield: r,
              export: t("export"),
              import: t("import"),
              extends: r,
              await: r
            };
          }(),
          f = /[+\-*&%=<>!?|~^@]/,
          p = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
        function g(t, e, n) {
          return r = t, i = n, e;
        }
        function v(t, e) {
          var n,
            r = t.next();
          if ('"' == r || "'" == r) return e.tokenize = (n = r, function (t, e) {
            var r,
              i = !1;
            if (s && "@" == t.peek() && t.match(p)) return e.tokenize = v, g("jsonld-keyword", "meta");
            for (; null != (r = t.next()) && (r != n || i);) i = !i && "\\" == r;
            return i || (e.tokenize = v), g("string", "string");
          }), e.tokenize(t, e);
          if ("." == r && t.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) return g("number", "number");
          if ("." == r && t.match("..")) return g("spread", "meta");
          if (/[\[\]{}\(\),;\:\.]/.test(r)) return g(r);
          if ("=" == r && t.eat(">")) return g("=>", "operator");
          if ("0" == r && t.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) return g("number", "number");
          if (/\d/.test(r)) return t.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/), g("number", "number");
          if ("/" == r) return t.eat("*") ? (e.tokenize = m, m(t, e)) : t.eat("/") ? (t.skipToEnd(), g("comment", "comment")) : Zt(t, e, 1) ? (function (t) {
            for (var e, n = !1, r = !1; null != (e = t.next());) {
              if (!n) {
                if ("/" == e && !r) return;
                "[" == e ? r = !0 : r && "]" == e && (r = !1);
              }
              n = !n && "\\" == e;
            }
          }(t), t.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/), g("regexp", "string-2")) : (t.eat("="), g("operator", "operator", t.current()));
          if ("`" == r) return e.tokenize = b, b(t, e);
          if ("#" == r && "!" == t.peek()) return t.skipToEnd(), g("meta", "meta");
          if ("#" == r && t.eatWhile(d)) return g("variable", "property");
          if ("<" == r && t.match("!--") || "-" == r && t.match("->") && !/\S/.test(t.string.slice(0, t.start))) return t.skipToEnd(), g("comment", "comment");
          if (f.test(r)) return ">" == r && e.lexical && ">" == e.lexical.type || (t.eat("=") ? "!" != r && "=" != r || t.eat("=") : /[<>*+\-|&?]/.test(r) && (t.eat(r), ">" == r && t.eat(r))), "?" == r && t.eat(".") ? g(".") : g("operator", "operator", t.current());
          if (d.test(r)) {
            t.eatWhile(d);
            var i = t.current();
            if ("." != e.lastType) {
              if (h.propertyIsEnumerable(i)) {
                var o = h[i];
                return g(o.type, o.style, i);
              }
              if ("async" == i && t.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, !1)) return g("async", "keyword", i);
            }
            return g("variable", "variable", i);
          }
        }
        function m(t, e) {
          for (var n, r = !1; n = t.next();) {
            if ("/" == n && r) {
              e.tokenize = v;
              break;
            }
            r = "*" == n;
          }
          return g("comment", "comment");
        }
        function b(t, e) {
          for (var n, r = !1; null != (n = t.next());) {
            if (!r && ("`" == n || "$" == n && t.eat("{"))) {
              e.tokenize = v;
              break;
            }
            r = !r && "\\" == n;
          }
          return g("quasi", "string-2", t.current());
        }
        function y(t, e) {
          e.fatArrowAt && (e.fatArrowAt = null);
          var n = t.string.indexOf("=>", t.start);
          if (!(n < 0)) {
            if (u) {
              var r = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(t.string.slice(t.start, n));
              r && (n = r.index);
            }
            for (var i = 0, o = !1, a = n - 1; a >= 0; --a) {
              var s = t.string.charAt(a),
                l = "([{}])".indexOf(s);
              if (l >= 0 && l < 3) {
                if (!i) {
                  ++a;
                  break;
                }
                if (0 == --i) {
                  "(" == s && (o = !0);
                  break;
                }
              } else if (l >= 3 && l < 6) ++i;else if (d.test(s)) o = !0;else if (/["'\/`]/.test(s)) for (;; --a) {
                if (0 == a) return;
                if (t.string.charAt(a - 1) == s && "\\" != t.string.charAt(a - 2)) {
                  a--;
                  break;
                }
              } else if (o && !i) {
                ++a;
                break;
              }
            }
            o && !i && (e.fatArrowAt = a);
          }
        }
        var w = {
          atom: !0,
          number: !0,
          variable: !0,
          string: !0,
          regexp: !0,
          this: !0,
          import: !0,
          "jsonld-keyword": !0
        };
        function x(t, e, n, r, i, o) {
          this.indented = t, this.column = e, this.type = n, this.prev = i, this.info = o, null != r && (this.align = r);
        }
        function O(t, e) {
          if (!c) return !1;
          for (var n = t.localVars; n; n = n.next) if (n.name == e) return !0;
          for (var r = t.context; r; r = r.prev) for (n = r.vars; n; n = n.next) if (n.name == e) return !0;
        }
        function C(t, e, n, r, i) {
          var o = t.cc;
          for (S.state = t, S.stream = i, S.marked = null, S.cc = o, S.style = e, t.lexical.hasOwnProperty("align") || (t.lexical.align = !0);;) if ((o.length ? o.pop() : l ? H : R)(n, r)) {
            for (; o.length && o[o.length - 1].lex;) o.pop()();
            return S.marked ? S.marked : "variable" == n && O(t, r) ? "variable-2" : e;
          }
        }
        var S = {
          state: null,
          column: null,
          marked: null,
          cc: null
        };
        function k() {
          for (var t = arguments.length - 1; t >= 0; t--) S.cc.push(arguments[t]);
        }
        function j() {
          return k.apply(null, arguments), !0;
        }
        function T(t, e) {
          for (var n = e; n; n = n.next) if (n.name == t) return !0;
          return !1;
        }
        function P(t) {
          var e = S.state;
          if (S.marked = "def", c) {
            if (e.context) if ("var" == e.lexical.info && e.context && e.context.block) {
              var r = function t(e, n) {
                if (n) {
                  if (n.block) {
                    var r = t(e, n.prev);
                    return r ? r == n.prev ? n : new D(r, n.vars, !0) : null;
                  }
                  return T(e, n.vars) ? n : new D(n.prev, new M(e, n.vars), !1);
                }
                return null;
              }(t, e.context);
              if (null != r) return void (e.context = r);
            } else if (!T(t, e.localVars)) return void (e.localVars = new M(t, e.localVars));
            n.globalVars && !T(t, e.globalVars) && (e.globalVars = new M(t, e.globalVars));
          }
        }
        function E(t) {
          return "public" == t || "private" == t || "protected" == t || "abstract" == t || "readonly" == t;
        }
        function D(t, e, n) {
          this.prev = t, this.vars = e, this.block = n;
        }
        function M(t, e) {
          this.name = t, this.next = e;
        }
        var A = new M("this", new M("arguments", null));
        function L() {
          S.state.context = new D(S.state.context, S.state.localVars, !1), S.state.localVars = A;
        }
        function N() {
          S.state.context = new D(S.state.context, S.state.localVars, !0), S.state.localVars = null;
        }
        function _() {
          S.state.localVars = S.state.context.vars, S.state.context = S.state.context.prev;
        }
        function I(t, e) {
          var n = function n() {
            var n = S.state,
              r = n.indented;
            if ("stat" == n.lexical.type) r = n.lexical.indented;else for (var i = n.lexical; i && ")" == i.type && i.align; i = i.prev) r = i.indented;
            n.lexical = new x(r, S.stream.column(), t, null, n.lexical, e);
          };
          return n.lex = !0, n;
        }
        function F() {
          var t = S.state;
          t.lexical.prev && (")" == t.lexical.type && (t.indented = t.lexical.indented), t.lexical = t.lexical.prev);
        }
        function V(t) {
          return function e(n) {
            return n == t ? j() : ";" == t || "}" == n || ")" == n || "]" == n ? k() : j(e);
          };
        }
        function R(t, e) {
          return "var" == t ? j(I("vardef", e), Ct, V(";"), F) : "keyword a" == t ? j(I("form"), B, R, F) : "keyword b" == t ? j(I("form"), R, F) : "keyword d" == t ? S.stream.match(/^\s*$/, !1) ? j() : j(I("stat"), U, V(";"), F) : "debugger" == t ? j(V(";")) : "{" == t ? j(I("}"), N, st, F, _) : ";" == t ? j() : "if" == t ? ("else" == S.state.lexical.info && S.state.cc[S.state.cc.length - 1] == F && S.state.cc.pop()(), j(I("form"), B, R, F, Et)) : "function" == t ? j(Lt) : "for" == t ? j(I("form"), N, Dt, R, _, F) : "class" == t || u && "interface" == e ? (S.marked = "keyword", j(I("form", "class" == t ? t : e), Vt, F)) : "variable" == t ? u && "declare" == e ? (S.marked = "keyword", j(R)) : u && ("module" == e || "enum" == e || "type" == e) && S.stream.match(/^\s*\w/, !1) ? (S.marked = "keyword", "enum" == e ? j(Xt) : "type" == e ? j(_t, V("operator"), ht, V(";")) : j(I("form"), St, V("{"), I("}"), st, F, F)) : u && "namespace" == e ? (S.marked = "keyword", j(I("form"), H, R, F)) : u && "abstract" == e ? (S.marked = "keyword", j(R)) : j(I("stat"), tt) : "switch" == t ? j(I("form"), B, V("{"), I("}", "switch"), N, st, F, F, _) : "case" == t ? j(H, V(":")) : "default" == t ? j(V(":")) : "catch" == t ? j(I("form"), L, z, R, F, _) : "export" == t ? j(I("stat"), $t, F) : "import" == t ? j(I("stat"), Wt, F) : "async" == t ? j(R) : "@" == e ? j(H, R) : k(I("stat"), H, V(";"), F);
        }
        function z(t) {
          if ("(" == t) return j(It, V(")"));
        }
        function H(t, e) {
          return W(t, e, !1);
        }
        function $(t, e) {
          return W(t, e, !0);
        }
        function B(t) {
          return "(" != t ? k() : j(I(")"), U, V(")"), F);
        }
        function W(t, e, n) {
          if (S.state.fatArrowAt == S.stream.start) {
            var r = n ? J : X;
            if ("(" == t) return j(L, I(")"), ot(It, ")"), F, V("=>"), r, _);
            if ("variable" == t) return k(L, St, V("=>"), r, _);
          }
          var i = n ? G : q;
          return w.hasOwnProperty(t) ? j(i) : "function" == t ? j(Lt, i) : "class" == t || u && "interface" == e ? (S.marked = "keyword", j(I("form"), Ft, F)) : "keyword c" == t || "async" == t ? j(n ? $ : H) : "(" == t ? j(I(")"), U, V(")"), F, i) : "operator" == t || "spread" == t ? j(n ? $ : H) : "[" == t ? j(I("]"), Yt, F, i) : "{" == t ? at(nt, "}", null, i) : "quasi" == t ? k(K, i) : "new" == t ? j(function (t) {
            return function (e) {
              return "." == e ? j(t ? Q : Z) : "variable" == e && u ? j(wt, t ? G : q) : k(t ? $ : H);
            };
          }(n)) : j();
        }
        function U(t) {
          return t.match(/[;\}\)\],]/) ? k() : k(H);
        }
        function q(t, e) {
          return "," == t ? j(U) : G(t, e, !1);
        }
        function G(t, e, n) {
          var r = 0 == n ? q : G,
            i = 0 == n ? H : $;
          return "=>" == t ? j(L, n ? J : X, _) : "operator" == t ? /\+\+|--/.test(e) || u && "!" == e ? j(r) : u && "<" == e && S.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, !1) ? j(I(">"), ot(ht, ">"), F, r) : "?" == e ? j(H, V(":"), i) : j(i) : "quasi" == t ? k(K, r) : ";" != t ? "(" == t ? at($, ")", "call", r) : "." == t ? j(et, r) : "[" == t ? j(I("]"), U, V("]"), F, r) : u && "as" == e ? (S.marked = "keyword", j(ht, r)) : "regexp" == t ? (S.state.lastType = S.marked = "operator", S.stream.backUp(S.stream.pos - S.stream.start - 1), j(i)) : void 0 : void 0;
        }
        function K(t, e) {
          return "quasi" != t ? k() : "${" != e.slice(e.length - 2) ? j(K) : j(U, Y);
        }
        function Y(t) {
          if ("}" == t) return S.marked = "string-2", S.state.tokenize = b, j(K);
        }
        function X(t) {
          return y(S.stream, S.state), k("{" == t ? R : H);
        }
        function J(t) {
          return y(S.stream, S.state), k("{" == t ? R : $);
        }
        function Z(t, e) {
          if ("target" == e) return S.marked = "keyword", j(q);
        }
        function Q(t, e) {
          if ("target" == e) return S.marked = "keyword", j(G);
        }
        function tt(t) {
          return ":" == t ? j(F, R) : k(q, V(";"), F);
        }
        function et(t) {
          if ("variable" == t) return S.marked = "property", j();
        }
        function nt(t, e) {
          return "async" == t ? (S.marked = "property", j(nt)) : "variable" == t || "keyword" == S.style ? (S.marked = "property", "get" == e || "set" == e ? j(rt) : (u && S.state.fatArrowAt == S.stream.start && (n = S.stream.match(/^\s*:\s*/, !1)) && (S.state.fatArrowAt = S.stream.pos + n[0].length), j(it))) : "number" == t || "string" == t ? (S.marked = s ? "property" : S.style + " property", j(it)) : "jsonld-keyword" == t ? j(it) : u && E(e) ? (S.marked = "keyword", j(nt)) : "[" == t ? j(H, lt, V("]"), it) : "spread" == t ? j($, it) : "*" == e ? (S.marked = "keyword", j(nt)) : ":" == t ? k(it) : void 0;
          var n;
        }
        function rt(t) {
          return "variable" != t ? k(it) : (S.marked = "property", j(Lt));
        }
        function it(t) {
          return ":" == t ? j($) : "(" == t ? k(Lt) : void 0;
        }
        function ot(t, e, n) {
          function r(i, o) {
            if (n ? n.indexOf(i) > -1 : "," == i) {
              var a = S.state.lexical;
              return "call" == a.info && (a.pos = (a.pos || 0) + 1), j(function (n, r) {
                return n == e || r == e ? k() : k(t);
              }, r);
            }
            return i == e || o == e ? j() : n && n.indexOf(";") > -1 ? k(t) : j(V(e));
          }
          return function (n, i) {
            return n == e || i == e ? j() : k(t, r);
          };
        }
        function at(t, e, n) {
          for (var r = 3; r < arguments.length; r++) S.cc.push(arguments[r]);
          return j(I(e, n), ot(t, e), F);
        }
        function st(t) {
          return "}" == t ? j() : k(R, st);
        }
        function lt(t, e) {
          if (u) {
            if (":" == t) return j(ht);
            if ("?" == e) return j(lt);
          }
        }
        function ct(t, e) {
          if (u && (":" == t || "in" == e)) return j(ht);
        }
        function ut(t) {
          if (u && ":" == t) return S.stream.match(/^\s*\w+\s+is\b/, !1) ? j(H, dt, ht) : j(ht);
        }
        function dt(t, e) {
          if ("is" == e) return S.marked = "keyword", j();
        }
        function ht(t, e) {
          return "keyof" == e || "typeof" == e || "infer" == e || "readonly" == e ? (S.marked = "keyword", j("typeof" == e ? $ : ht)) : "variable" == t || "void" == e ? (S.marked = "type", j(yt)) : "|" == e || "&" == e ? j(ht) : "string" == t || "number" == t || "atom" == t ? j(yt) : "[" == t ? j(I("]"), ot(ht, "]", ","), F, yt) : "{" == t ? j(I("}"), pt, F, yt) : "(" == t ? j(ot(bt, ")"), ft, yt) : "<" == t ? j(ot(ht, ">"), ht) : "quasi" == t ? k(vt, yt) : void 0;
        }
        function ft(t) {
          if ("=>" == t) return j(ht);
        }
        function pt(t) {
          return t.match(/[\}\)\]]/) ? j() : "," == t || ";" == t ? j(pt) : k(gt, pt);
        }
        function gt(t, e) {
          return "variable" == t || "keyword" == S.style ? (S.marked = "property", j(gt)) : "?" == e || "number" == t || "string" == t ? j(gt) : ":" == t ? j(ht) : "[" == t ? j(V("variable"), ct, V("]"), gt) : "(" == t ? k(Nt, gt) : t.match(/[;\}\)\],]/) ? void 0 : j();
        }
        function vt(t, e) {
          return "quasi" != t ? k() : "${" != e.slice(e.length - 2) ? j(vt) : j(ht, mt);
        }
        function mt(t) {
          if ("}" == t) return S.marked = "string-2", S.state.tokenize = b, j(vt);
        }
        function bt(t, e) {
          return "variable" == t && S.stream.match(/^\s*[?:]/, !1) || "?" == e ? j(bt) : ":" == t ? j(ht) : "spread" == t ? j(bt) : k(ht);
        }
        function yt(t, e) {
          return "<" == e ? j(I(">"), ot(ht, ">"), F, yt) : "|" == e || "." == t || "&" == e ? j(ht) : "[" == t ? j(ht, V("]"), yt) : "extends" == e || "implements" == e ? (S.marked = "keyword", j(ht)) : "?" == e ? j(ht, V(":"), ht) : void 0;
        }
        function wt(t, e) {
          if ("<" == e) return j(I(">"), ot(ht, ">"), F, yt);
        }
        function xt() {
          return k(ht, Ot);
        }
        function Ot(t, e) {
          if ("=" == e) return j(ht);
        }
        function Ct(t, e) {
          return "enum" == e ? (S.marked = "keyword", j(Xt)) : k(St, lt, Tt, Pt);
        }
        function St(t, e) {
          return u && E(e) ? (S.marked = "keyword", j(St)) : "variable" == t ? (P(e), j()) : "spread" == t ? j(St) : "[" == t ? at(jt, "]") : "{" == t ? at(kt, "}") : void 0;
        }
        function kt(t, e) {
          return "variable" != t || S.stream.match(/^\s*:/, !1) ? ("variable" == t && (S.marked = "property"), "spread" == t ? j(St) : "}" == t ? k() : "[" == t ? j(H, V("]"), V(":"), kt) : j(V(":"), St, Tt)) : (P(e), j(Tt));
        }
        function jt() {
          return k(St, Tt);
        }
        function Tt(t, e) {
          if ("=" == e) return j($);
        }
        function Pt(t) {
          if ("," == t) return j(Ct);
        }
        function Et(t, e) {
          if ("keyword b" == t && "else" == e) return j(I("form", "else"), R, F);
        }
        function Dt(t, e) {
          return "await" == e ? j(Dt) : "(" == t ? j(I(")"), Mt, F) : void 0;
        }
        function Mt(t) {
          return "var" == t ? j(Ct, At) : "variable" == t ? j(At) : k(At);
        }
        function At(t, e) {
          return ")" == t ? j() : ";" == t ? j(At) : "in" == e || "of" == e ? (S.marked = "keyword", j(H, At)) : k(H, At);
        }
        function Lt(t, e) {
          return "*" == e ? (S.marked = "keyword", j(Lt)) : "variable" == t ? (P(e), j(Lt)) : "(" == t ? j(L, I(")"), ot(It, ")"), F, ut, R, _) : u && "<" == e ? j(I(">"), ot(xt, ">"), F, Lt) : void 0;
        }
        function Nt(t, e) {
          return "*" == e ? (S.marked = "keyword", j(Nt)) : "variable" == t ? (P(e), j(Nt)) : "(" == t ? j(L, I(")"), ot(It, ")"), F, ut, _) : u && "<" == e ? j(I(">"), ot(xt, ">"), F, Nt) : void 0;
        }
        function _t(t, e) {
          return "keyword" == t || "variable" == t ? (S.marked = "type", j(_t)) : "<" == e ? j(I(">"), ot(xt, ">"), F) : void 0;
        }
        function It(t, e) {
          return "@" == e && j(H, It), "spread" == t ? j(It) : u && E(e) ? (S.marked = "keyword", j(It)) : u && "this" == t ? j(lt, Tt) : k(St, lt, Tt);
        }
        function Ft(t, e) {
          return "variable" == t ? Vt(t, e) : Rt(t, e);
        }
        function Vt(t, e) {
          if ("variable" == t) return P(e), j(Rt);
        }
        function Rt(t, e) {
          return "<" == e ? j(I(">"), ot(xt, ">"), F, Rt) : "extends" == e || "implements" == e || u && "," == t ? ("implements" == e && (S.marked = "keyword"), j(u ? ht : H, Rt)) : "{" == t ? j(I("}"), zt, F) : void 0;
        }
        function zt(t, e) {
          return "async" == t || "variable" == t && ("static" == e || "get" == e || "set" == e || u && E(e)) && S.stream.match(/^\s+#?[\w$\xa1-\uffff]/, !1) ? (S.marked = "keyword", j(zt)) : "variable" == t || "keyword" == S.style ? (S.marked = "property", j(Ht, zt)) : "number" == t || "string" == t ? j(Ht, zt) : "[" == t ? j(H, lt, V("]"), Ht, zt) : "*" == e ? (S.marked = "keyword", j(zt)) : u && "(" == t ? k(Nt, zt) : ";" == t || "," == t ? j(zt) : "}" == t ? j() : "@" == e ? j(H, zt) : void 0;
        }
        function Ht(t, e) {
          if ("!" == e) return j(Ht);
          if ("?" == e) return j(Ht);
          if (":" == t) return j(ht, Tt);
          if ("=" == e) return j($);
          var n = S.state.lexical.prev;
          return k(n && "interface" == n.info ? Nt : Lt);
        }
        function $t(t, e) {
          return "*" == e ? (S.marked = "keyword", j(Kt, V(";"))) : "default" == e ? (S.marked = "keyword", j(H, V(";"))) : "{" == t ? j(ot(Bt, "}"), Kt, V(";")) : k(R);
        }
        function Bt(t, e) {
          return "as" == e ? (S.marked = "keyword", j(V("variable"))) : "variable" == t ? k($, Bt) : void 0;
        }
        function Wt(t) {
          return "string" == t ? j() : "(" == t ? k(H) : "." == t ? k(q) : k(Ut, qt, Kt);
        }
        function Ut(t, e) {
          return "{" == t ? at(Ut, "}") : ("variable" == t && P(e), "*" == e && (S.marked = "keyword"), j(Gt));
        }
        function qt(t) {
          if ("," == t) return j(Ut, qt);
        }
        function Gt(t, e) {
          if ("as" == e) return S.marked = "keyword", j(Ut);
        }
        function Kt(t, e) {
          if ("from" == e) return S.marked = "keyword", j(H);
        }
        function Yt(t) {
          return "]" == t ? j() : k(ot($, "]"));
        }
        function Xt() {
          return k(I("form"), St, V("{"), I("}"), ot(Jt, "}"), F, F);
        }
        function Jt() {
          return k(St, Tt);
        }
        function Zt(t, e, n) {
          return e.tokenize == v && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(e.lastType) || "quasi" == e.lastType && /\{\s*$/.test(t.string.slice(0, t.pos - (n || 0)));
        }
        return L.lex = N.lex = !0, _.lex = !0, F.lex = !0, {
          startState: function startState(t) {
            var e = {
              tokenize: v,
              lastType: "sof",
              cc: [],
              lexical: new x((t || 0) - o, 0, "block", !1),
              localVars: n.localVars,
              context: n.localVars && new D(null, null, !1),
              indented: t || 0
            };
            return n.globalVars && "object" == typeof n.globalVars && (e.globalVars = n.globalVars), e;
          },
          token: function token(t, e) {
            if (t.sol() && (e.lexical.hasOwnProperty("align") || (e.lexical.align = !1), e.indented = t.indentation(), y(t, e)), e.tokenize != m && t.eatSpace()) return null;
            var n = e.tokenize(t, e);
            return "comment" == r ? n : (e.lastType = "operator" != r || "++" != i && "--" != i ? r : "incdec", C(e, n, r, i, t));
          },
          indent: function indent(e, r) {
            if (e.tokenize == m || e.tokenize == b) return t.Pass;
            if (e.tokenize != v) return 0;
            var i,
              s = r && r.charAt(0),
              l = e.lexical;
            if (!/^\s*else\b/.test(r)) for (var c = e.cc.length - 1; c >= 0; --c) {
              var u = e.cc[c];
              if (u == F) l = l.prev;else if (u != Et && u != _) break;
            }
            for (; ("stat" == l.type || "form" == l.type) && ("}" == s || (i = e.cc[e.cc.length - 1]) && (i == q || i == G) && !/^[,\.=+\-*:?[\(]/.test(r));) l = l.prev;
            a && ")" == l.type && "stat" == l.prev.type && (l = l.prev);
            var d = l.type,
              h = s == d;
            return "vardef" == d ? l.indented + ("operator" == e.lastType || "," == e.lastType ? l.info.length + 1 : 0) : "form" == d && "{" == s ? l.indented : "form" == d ? l.indented + o : "stat" == d ? l.indented + (function (t, e) {
              return "operator" == t.lastType || "," == t.lastType || f.test(e.charAt(0)) || /[,.]/.test(e.charAt(0));
            }(e, r) ? a || o : 0) : "switch" != l.info || h || 0 == n.doubleIndentSwitch ? l.align ? l.column + (h ? 0 : 1) : l.indented + (h ? 0 : o) : l.indented + (/^(?:case|default)\b/.test(r) ? o : 2 * o);
          },
          electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
          blockCommentStart: l ? null : "/*",
          blockCommentEnd: l ? null : "*/",
          blockCommentContinue: l ? null : " * ",
          lineComment: l ? null : "//",
          fold: "brace",
          closeBrackets: "()[]{}''\"\"``",
          helperType: l ? "json" : "javascript",
          jsonldMode: s,
          jsonMode: l,
          expressionAllowed: Zt,
          skipExpression: function skipExpression(e) {
            C(e, "atom", "atom", "true", new t.StringStream("", 2, null));
          }
        };
      }), t.registerHelper("wordChars", "javascript", /[\w$]/), t.defineMIME("text/javascript", "javascript"), t.defineMIME("text/ecmascript", "javascript"), t.defineMIME("application/javascript", "javascript"), t.defineMIME("application/x-javascript", "javascript"), t.defineMIME("application/ecmascript", "javascript"), t.defineMIME("application/json", {
        name: "javascript",
        json: !0
      }), t.defineMIME("application/x-json", {
        name: "javascript",
        json: !0
      }), t.defineMIME("application/manifest+json", {
        name: "javascript",
        json: !0
      }), t.defineMIME("application/ld+json", {
        name: "javascript",
        jsonld: !0
      }), t.defineMIME("text/typescript", {
        name: "javascript",
        typescript: !0
      }), t.defineMIME("application/typescript", {
        name: "javascript",
        typescript: !0
      });
    }(n(13));
  }, function (t, e, n) {
    !function (t) {
      t.extendMode("css", {
        commentStart: "/*",
        commentEnd: "*/",
        newlineAfterToken: function newlineAfterToken(t, e) {
          return /^[;{}]$/.test(e);
        }
      }), t.extendMode("javascript", {
        commentStart: "/*",
        commentEnd: "*/",
        newlineAfterToken: function newlineAfterToken(t, e, n, r) {
          return this.jsonMode ? /^[\[,{]$/.test(e) || /^}/.test(n) : (";" != e || !r.lexical || ")" != r.lexical.type) && /^[;{}]$/.test(e) && !/^;/.test(n);
        }
      });
      var e = /^(a|abbr|acronym|area|base|bdo|big|br|button|caption|cite|code|col|colgroup|dd|del|dfn|em|frame|hr|iframe|img|input|ins|kbd|label|legend|link|map|object|optgroup|option|param|q|samp|script|select|small|span|strong|sub|sup|textarea|tt|var)$/;
      t.extendMode("xml", {
        commentStart: "\x3c!--",
        commentEnd: "--\x3e",
        newlineAfterToken: function newlineAfterToken(t, n, r, i) {
          var o = !1;
          return "html" == this.configuration && (o = !!i.context && e.test(i.context.tagName)), !o && ("tag" == t && />$/.test(n) && i.context || /^</.test(r));
        }
      }), t.defineExtension("commentRange", function (e, n, r) {
        var i = this,
          o = t.innerMode(i.getMode(), i.getTokenAt(n).state).mode;
        i.operation(function () {
          if (e) i.replaceRange(o.commentEnd, r), i.replaceRange(o.commentStart, n), n.line == r.line && n.ch == r.ch && i.setCursor(n.line, n.ch + o.commentStart.length);else {
            var t = i.getRange(n, r),
              a = t.indexOf(o.commentStart),
              s = t.lastIndexOf(o.commentEnd);
            a > -1 && s > -1 && s > a && (t = t.substr(0, a) + t.substring(a + o.commentStart.length, s) + t.substr(s + o.commentEnd.length)), i.replaceRange(t, n, r);
          }
        });
      }), t.defineExtension("autoIndentRange", function (t, e) {
        var n = this;
        this.operation(function () {
          for (var r = t.line; r <= e.line; r++) n.indentLine(r, "smart");
        });
      }), t.defineExtension("autoFormatRange", function (e, n) {
        var r = this,
          i = r.getMode(),
          o = r.getRange(e, n).split("\n"),
          a = t.copyState(i, r.getTokenAt(e).state),
          s = r.getOption("tabSize"),
          l = "",
          c = 0,
          u = 0 === e.ch;
        function d() {
          l += "\n", u = !0, ++c;
        }
        for (var h = 0; h < o.length; ++h) {
          for (var f = new t.StringStream(o[h], s); !f.eol();) {
            var p = t.innerMode(i, a),
              g = i.token(f, a),
              v = f.current();
            f.start = f.pos, u && !/\S/.test(v) || (l += v, u = !1), !u && p.mode.newlineAfterToken && p.mode.newlineAfterToken(g, v, f.string.slice(f.pos) || o[h + 1] || "", p.state) && d();
          }
          !f.pos && i.blankLine && i.blankLine(a), !u && h < o.length - 1 && d();
        }
        r.operation(function () {
          r.replaceRange(l, e, n);
          for (var t = e.line + 1, i = e.line + c; t <= i; ++t) r.indentLine(t, "smart");
          r.setSelection(e, r.getCursor(!1));
        });
      });
    }(n(13));
  }, function (t, e) {
    t.exports = function (t) {
      if (Array.isArray(t)) return t;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e) {
    t.exports = function (t, e) {
      var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
      if (null != n) {
        var r,
          i,
          o,
          a,
          s = [],
          l = !0,
          c = !1;
        try {
          if (o = (n = n.call(t)).next, 0 === e) {
            if (Object(n) !== n) return;
            l = !1;
          } else for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== e); l = !0);
        } catch (t) {
          c = !0, i = t;
        } finally {
          try {
            if (!l && null != n.return && (a = n.return(), Object(a) !== a)) return;
          } finally {
            if (c) throw i;
          }
        }
        return s;
      }
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1),
      i = n.n(r),
      o = n(36),
      a = n(5);
    e.default = i.a.View.extend({
      initialize: function initialize() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        this.opt = t;
        var e = t.config || {};
        this.level = t.level, this.config = e, this.preview = t.preview, this.ppfx = e.pStylePrefix || "", this.pfx = e.stylePrefix || "", this.parent = t.parent, this.parentView = t.parentView;
        var n = this.pfx,
          r = this.ppfx,
          i = this.parent,
          o = this.collection;
        this.listenTo(o, "add", this.addTo), this.listenTo(o, "reset resetNavigator", this.render), this.listenTo(o, "remove", this.removeChildren), this.className = "".concat(n, "layers");
        var s = e.em;
        if (e.sortable && !this.opt.sorter) {
          var l = s.get("Utils");
          this.opt.sorter = new l.Sorter({
            container: e.sortContainer || this.el,
            containerSel: ".".concat(this.className),
            itemSel: ".".concat(n, "layer"),
            ignoreViewChildren: 1,
            onEndMove: function onEndMove(t, e, n) {
              var r = e.getSourceModel();
              s.setSelected(r, {
                forceChange: 1
              }), s.trigger("".concat(a.eventDrag, ":end"), n);
            },
            avoidSelectOnEnd: 1,
            nested: 1,
            ppfx: r,
            pfx: n
          });
        }
        this.sorter = this.opt.sorter || "", this.$el.data("collection", o), i && this.$el.data("model", i);
      },
      removeChildren: function removeChildren(t) {
        var e = t.viewLayer;
        e && (e.remove(), t.viewLayer = 0);
      },
      addTo: function addTo(t) {
        var e = this.collection.indexOf(t);
        this.addToCollection(t, null, e);
      },
      addToCollection: function addToCollection(t, e, n) {
        var r = this.level,
          i = this.parentView,
          a = e || null,
          s = new (0, o.a)({
            level: r,
            model: t,
            parentView: i,
            config: this.config,
            sorter: this.sorter,
            isCountable: this.isCountable,
            opened: this.opt.opened
          }).render().el;
        if (a) a.appendChild(s);else if (void 0 !== n) {
          var l = "before";
          this.$el.children().length == n && (n--, l = "after"), n < 0 ? this.$el.append(s) : this.$el.children().eq(n)[l](s);
        } else this.$el.append(s);
        return s;
      },
      isCountable: function isCountable(t, e) {
        var n = t.get("type"),
          r = t.get("tagName");
        return !(("textnode" == n || "br" == r) && e || !t.get("layerable"));
      },
      render: function render() {
        var t = this,
          e = document.createDocumentFragment(),
          n = this.el;
        return n.innerHTML = "", this.collection.each(function (n) {
          return t.addToCollection(n, e);
        }), n.appendChild(e), n.className = this.className, this;
      }
    });
  }, function (t, e, n) {
    var r = {
      "./CanvasClear": 46,
      "./CanvasClear.js": 46,
      "./CanvasMove": 47,
      "./CanvasMove.js": 47,
      "./CommandAbstract": 22,
      "./CommandAbstract.js": 22,
      "./ComponentDelete": 48,
      "./ComponentDelete.js": 48,
      "./ComponentDrag": 49,
      "./ComponentDrag.js": 49,
      "./ComponentEnter": 50,
      "./ComponentEnter.js": 50,
      "./ComponentExit": 51,
      "./ComponentExit.js": 51,
      "./ComponentNext": 52,
      "./ComponentNext.js": 52,
      "./ComponentPrev": 53,
      "./ComponentPrev.js": 53,
      "./ComponentStyleClear": 54,
      "./ComponentStyleClear.js": 54,
      "./CopyComponent": 55,
      "./CopyComponent.js": 55,
      "./DeleteComponent": 56,
      "./DeleteComponent.js": 56,
      "./DeviceDesktop": 57,
      "./DeviceDesktop.js": 57,
      "./DeviceMobile": 58,
      "./DeviceMobile.js": 58,
      "./DeviceMobilePtr": 59,
      "./DeviceMobilePtr.js": 59,
      "./DeviceTablet": 60,
      "./DeviceTablet.js": 60,
      "./ExportTemplate": 61,
      "./ExportTemplate.js": 61,
      "./Fullscreen": 62,
      "./Fullscreen.js": 62,
      "./MoveComponent": 63,
      "./MoveComponent.js": 63,
      "./OpenAssets": 64,
      "./OpenAssets.js": 64,
      "./OpenBlocks": 65,
      "./OpenBlocks.js": 65,
      "./OpenLayers": 66,
      "./OpenLayers.js": 66,
      "./OpenStyleManager": 67,
      "./OpenStyleManager.js": 67,
      "./OpenTraitManager": 68,
      "./OpenTraitManager.js": 68,
      "./PasteComponent": 69,
      "./PasteComponent.js": 69,
      "./Preview": 70,
      "./Preview.js": 70,
      "./Resize": 71,
      "./Resize.js": 71,
      "./SaveDb": 72,
      "./SaveDb.js": 72,
      "./SelectComponent": 14,
      "./SelectComponent.js": 14,
      "./SelectPosition": 27,
      "./SelectPosition.js": 27,
      "./ShowOffset": 73,
      "./ShowOffset.js": 73,
      "./SwitchVisibility": 74,
      "./SwitchVisibility.js": 74
    };
    function i(t) {
      var e = o(t);
      return n(e);
    }
    function o(t) {
      if (!n.o(r, t)) {
        var e = new Error("Cannot find module '" + t + "'");
        throw e.code = "MODULE_NOT_FOUND", e;
      }
      return r[t];
    }
    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = o, t.exports = i, i.id = 99;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(8),
      i = n.n(r),
      o = n(2),
      a = n.n(o),
      s = n(1),
      l = n.n(s),
      c = n(0),
      u = {
        stylePrefix: "comp-",
        wrapperId: "wrapper",
        wrapperName: "Body",
        wrapper: {
          removable: !1,
          copyable: !1,
          draggable: !1,
          components: [],
          traits: [],
          stylable: ["background", "background-color", "background-image", "background-repeat", "background-attachment", "background-position", "background-size"]
        },
        components: [],
        draggableComponents: 1,
        storeWrapper: 0,
        processor: 0,
        voidElements: ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"]
      },
      d = n(5),
      h = n(21),
      f = n(6),
      p = n(35);
    function g(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function v(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? g(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : g(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var m = d.default.extend({
        defaults: v(v({}, d.default.prototype.defaults), {}, {
          type: "cell",
          tagName: "td",
          draggable: ["tr"]
        })
      }, {
        isComponent: function isComponent(t) {
          var e = "",
            n = t.tagName;
          return "TD" != n && "TH" != n || (e = {
            type: "cell",
            tagName: n.toLowerCase()
          }), e;
        }
      }),
      b = f.default.extend({});
    function y(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function w(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? y(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var x = d.default.extend({
        defaults: w(w({}, d.default.prototype.defaults), {}, {
          tagName: "tr",
          draggable: ["thead", "tbody", "tfoot"],
          droppable: ["th", "td"]
        })
      }, {
        isComponent: function isComponent(t) {
          return "TR" == t.tagName && !0;
        }
      }),
      O = f.default.extend({});
    function C(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function S(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? C(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : C(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var k = d.default.extend({
        defaults: S(S({}, d.default.prototype.defaults), {}, {
          type: "table",
          tagName: "table",
          droppable: ["tbody", "thead", "tfoot"]
        }),
        initialize: function initialize(t, e) {
          d.default.prototype.initialize.apply(this, arguments);
          var n = this.get("components");
          !n.length && n.add({
            type: "tbody"
          });
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return "TABLE" == t.tagName && (e = {
            type: "table"
          }), e;
        }
      }),
      j = f.default.extend({
        events: {}
      });
    function T(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function P(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? T(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var E = d.default.extend({
      defaults: P(P({}, d.default.prototype.defaults), {}, {
        type: "tbody",
        tagName: "tbody",
        draggable: ["table"],
        droppable: ["tr"],
        columns: 1,
        rows: 1
      }),
      initialize: function initialize(t, e) {
        d.default.prototype.initialize.apply(this, arguments);
        var n = this.get("components"),
          r = this.get("columns"),
          i = this.get("rows");
        if (!n.length) {
          for (var o = []; i--;) {
            for (var a = [], s = r; s--;) a.push({
              type: "cell",
              classes: ["cell"]
            });
            o.push({
              type: "row",
              classes: ["row"],
              components: a
            });
          }
          n.add(o);
        }
      }
    }, {
      isComponent: function isComponent(t) {
        var e = "";
        return "TBODY" == t.tagName && (e = {
          type: "tbody"
        }), e;
      }
    });
    function D(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function M(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? D(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var A = E.extend({
        defaults: M(M({}, E.prototype.defaults), {}, {
          type: "thead",
          tagName: "thead"
        })
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return "THEAD" == t.tagName && (e = {
            type: "thead"
          }), e;
        }
      }),
      L = f.default.extend({}),
      N = f.default.extend({});
    function _(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function I(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? _(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : _(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var F = E.extend({
        defaults: I(I({}, E.prototype.defaults), {}, {
          type: "tfoot",
          tagName: "tfoot"
        })
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return "TFOOT" == t.tagName && (e = {
            type: "tfoot"
          }), e;
        }
      }),
      V = f.default.extend({});
    function R(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function z(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? R(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var H = 'xmlns="http://www.w3.org/2000/svg" width="100" viewBox="0 0 24 24" style="fill: rgba(0,0,0,0.15); transform: scale(0.75)"',
      $ = d.default.extend({
        defaults: z(z({}, d.default.prototype.defaults), {}, {
          type: "image",
          tagName: "img",
          void: 1,
          droppable: 0,
          editable: 1,
          highlightable: 0,
          resizable: {
            ratioDefault: 1
          },
          traits: ["alt"],
          src: "<svg ".concat(H, '>\n        <path d="M8.5 13.5l2.5 3 3.5-4.5 4.5 6H5m16 1V5a2 2 0 0 0-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2z"></path>\n      </svg>'),
          fallback: "<svg ".concat(H, '>\n        <path d="M2.28 3L1 4.27l2 2V19c0 1.1.9 2 2 2h12.73l2 2L21 21.72 2.28 3m2.55 0L21 19.17V5a2 2 0 0 0-2-2H4.83M8.5 13.5l2.5 3 1-1.25L14.73 18H5l3.5-4.5z"></path>\n      </svg>'),
          file: ""
        }),
        initialize: function initialize(t, e) {
          d.default.prototype.initialize.apply(this, arguments);
          var n = this.get("attributes");
          n.src && this.set("src", n.src);
        },
        initToolbar: function initToolbar() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          d.default.prototype.initToolbar.apply(this, e);
          var r = this.em;
          if (r) {
            var i = r.get("Commands"),
              o = "image-editor";
            if (i.has(o)) {
              for (var a = !1, s = this.get("toolbar"), l = 0; l < s.length; l++) if ("image-editor" === s[l].command) {
                a = !0;
                break;
              }
              a || (s.push({
                attributes: {
                  class: "fa fa-pencil"
                },
                command: o
              }), this.set("toolbar", s));
            }
          }
        },
        getAttrToHTML: function getAttrToHTML() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          var r = d.default.prototype.getAttrToHTML.apply(this, e),
            i = this.getSrcResult();
          return i && (r.src = i), r;
        },
        getSrcResult: function getSrcResult() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.get(t.fallback ? "fallback" : "src") || "",
            n = e;
          return e && "<svg" === e.substr(0, 4) && (n = "data:image/svg+xml;base64,".concat(window.btoa(e))), n;
        },
        isDefaultSrc: function isDefaultSrc() {
          return this.get("src") === Object(c.result)(this, "defaults").src;
        },
        parseUri: function parseUri(t) {
          var e = document.createElement("a");
          e.href = t;
          for (var n = {}, r = e.search.substring(1).split("&"), i = 0; i < r.length; i++) {
            var o = r[i].split("="),
              a = decodeURIComponent(o[0]);
            a && (n[a] = decodeURIComponent(o[1]));
          }
          return {
            hostname: e.hostname,
            pathname: e.pathname,
            protocol: e.protocol,
            search: e.search,
            hash: e.hash,
            port: e.port,
            query: n
          };
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return "IMG" == t.tagName && (e = {
            type: "image"
          }), e;
        }
      });
    function B(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function W(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? B(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : B(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var U = $.extend({
        defaults: W(W({}, $.prototype.defaults), {}, {
          type: "map",
          src: "",
          void: 0,
          mapUrl: "https://maps.google.com/maps",
          tagName: "iframe",
          mapType: "q",
          address: "",
          zoom: "1",
          attributes: {
            frameborder: 0
          },
          toolbar: d.default.prototype.defaults.toolbar,
          traits: [{
            label: "Address",
            name: "address",
            placeholder: "eg. London, UK",
            changeProp: 1
          }, {
            type: "select",
            label: "Map type",
            name: "mapType",
            changeProp: 1,
            options: [{
              value: "q",
              name: "Roadmap"
            }, {
              value: "w",
              name: "Satellite"
            }]
          }, {
            label: "Zoom",
            name: "zoom",
            type: "range",
            min: "1",
            max: "20",
            changeProp: 1
          }]
        }),
        initialize: function initialize(t, e) {
          this.get("src") ? this.parseFromSrc() : this.updateSrc(), $.prototype.initialize.apply(this, arguments), this.listenTo(this, "change:address change:zoom change:mapType", this.updateSrc);
        },
        updateSrc: function updateSrc() {
          this.set("src", this.getMapUrl());
        },
        getMapUrl: function getMapUrl() {
          var t = this.get("address"),
            e = this.get("zoom"),
            n = this.get("mapType");
          t = t ? "&q=" + t : "", e = e ? "&z=" + e : "", n = n ? "&t=" + n : "";
          var r = this.get("mapUrl") + "?" + t + e + n;
          return r += "&output=embed";
        },
        parseFromSrc: function parseFromSrc() {
          var t = this.parseUri(this.get("src")).query;
          t.q && this.set("address", t.q), t.z && this.set("zoom", t.z), t.t && this.set("mapType", t.t);
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return "IFRAME" == t.tagName && /maps\.google\.com/.test(t.src) && (e = {
            type: "map",
            src: t.src
          }), e;
        }
      }),
      q = f.default.extend({
        tagName: "img",
        events: {
          dblclick: "onActive",
          click: "initResize",
          error: "onError",
          load: "onLoad",
          dragstart: "noDrag"
        },
        initialize: function initialize(t) {
          var e = this.model;
          f.default.prototype.initialize.apply(this, arguments), this.listenTo(e, "change:src", this.updateSrc), this.classEmpty = "".concat(this.ppfx, "plh-image");
          var n = this.config;
          n.modal && (this.modal = n.modal), n.am && (this.am = n.am), this.fetchFile();
        },
        fetchFile: function fetchFile() {
          if (!this.modelOpt.temporary) {
            var t = this.model,
              e = t.get("file");
            if (e) this.em.get("AssetManager").FileUploader().uploadFile({
              dataTransfer: {
                files: [e]
              }
            }, function (e) {
              var n = e && e.data && e.data[0],
                r = n && (Object(c.isString)(n) ? n : n.src);
              r && t.set({
                src: r
              });
            }), t.set("file", "");
          }
        },
        updateSrc: function updateSrc() {
          var t = this.model,
            e = this.classEmpty,
            n = this.$el,
            r = t.getSrcResult(),
            i = r && !t.isDefaultSrc();
          t.addAttributes({
            src: r
          }), n[i ? "removeClass" : "addClass"](e);
        },
        onActive: function onActive(t) {
          t && t.stopPropagation();
          var e = this.opts.config.em,
            n = e ? e.get("Editor") : "";
          n && this.model.get("editable") && n.runCommand("open-assets", {
            target: this.model,
            types: ["image"],
            accept: "image/*",
            onSelect: function onSelect() {
              n.Modal.close(), n.AssetManager.setTarget(null);
            }
          });
        },
        onError: function onError() {
          var t = this.model.getSrcResult({
            fallback: 1
          });
          t && (this.el.src = t);
        },
        onLoad: function onLoad() {
          this.em.trigger("change:canvasOffset");
        },
        noDrag: function noDrag(t) {
          return t.preventDefault(), !1;
        },
        render: function render() {
          this.renderAttributes(), this.updateSrc();
          var t = this.$el,
            e = this.model,
            n = t.attr("class") || "";
          return !e.get("src") && t.attr("class", "".concat(n, " ").concat(this.classEmpty).trim()), this.postRender(), this;
        }
      }),
      G = q.extend({
        tagName: "div",
        events: {},
        initialize: function initialize(t) {
          q.prototype.initialize.apply(this, arguments), this.classEmpty = this.ppfx + "plh-map";
        },
        updateSrc: function updateSrc() {
          this.getIframe().src = this.model.get("src");
        },
        getIframe: function getIframe() {
          if (!this.iframe) {
            var t = document.createElement("iframe");
            t.src = this.model.get("src"), t.frameBorder = 0, t.style.height = "100%", t.style.width = "100%", t.className = this.ppfx + "no-pointer", this.iframe = t;
          }
          return this.iframe;
        },
        render: function render() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          return q.prototype.render.apply(this, e), this.updateClasses(), this.el.appendChild(this.getIframe()), this;
        }
      });
    function K(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Y(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? K(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : K(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var X = d.default.extend({
      defaults: Y(Y({}, d.default.prototype.defaults), {}, {
        type: "text",
        droppable: !1,
        editable: !0
      }),
      toHTML: function toHTML() {
        return this.trigger("sync:content", {
          silent: 1
        }), d.default.prototype.toHTML.apply(this, arguments);
      }
    });
    function J(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Z(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? J(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : J(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var Q = X.extend({
        defaults: Z(Z({}, X.prototype.defaults), {}, {
          type: "link",
          tagName: "a",
          traits: ["title", "href", "target"]
        }),
        getAttrToHTML: function getAttrToHTML() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          var r = X.prototype.getAttrToHTML.apply(this, e);
          return delete r.onmousedown, r;
        }
      }, {
        isComponent: function isComponent(t) {
          var e;
          if ("A" == t.tagName) {
            e = {
              type: "link",
              editable: 0
            };
            var n = t.childNodes,
              r = n.length;
            r || delete e.editable;
            for (var i = 0; i < r; i++) {
              var o = n[i];
              if (3 == o.nodeType && "" != o.textContent.trim()) {
                delete e.editable;
                break;
              }
            }
          }
          return e;
        }
      }),
      tt = n(3);
    function et(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function nt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? et(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : et(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var rt = f.default.prototype,
      it = f.default.extend({
        events: {
          dblclick: "onActive",
          input: "onInput"
        },
        initialize: function initialize(t) {
          rt.initialize.apply(this, arguments), this.disableEditing = this.disableEditing.bind(this);
          var e = this.model,
            n = this.em;
          this.listenTo(e, "focus", this.onActive), this.listenTo(e, "change:content", this.updateContentText), this.listenTo(e, "sync:content", this.syncContent), this.rte = n && n.get("RichTextEditor");
        },
        updateContentText: function updateContentText(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          !n.fromDisable && this.disableEditing();
        },
        onActive: function onActive(t) {
          if (!this.rteEnabled && this.model.get("editable")) {
            t && t.stopPropagation && t.stopPropagation();
            var e = this.rte,
              n = this.em;
            if (e) try {
              this.activeRte = e.enable(this, this.activeRte);
            } catch (t) {
              n.logError(t);
            }
            this.toggleEvents(1);
          }
        },
        onDisable: function onDisable() {
          this.disableEditing();
        },
        disableEditing: function disableEditing() {
          var t = this.model,
            e = this.rte,
            n = this.activeRte,
            r = this.em,
            i = t.get("editable");
          if (e && i) {
            try {
              e.disable(this, n);
            } catch (t) {
              r.logError(t);
            }
            this.syncContent();
          }
          this.toggleEvents();
        },
        getContent: function getContent() {
          var t = this.activeRte;
          return t && "function" == typeof t.getContent ? t.getContent() : this.getChildrenContainer().innerHTML;
        },
        syncContent: function syncContent() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model,
            n = this.rte,
            r = this.rteEnabled;
          if (r || t.force) {
            var i = this.getContent(),
              o = e.components(),
              a = nt({
                fromDisable: 1
              }, t);
            if (o.length && o.reset(null, t), e.set("content", "", a), n.customRte) e.set("content", i, a);else {
              var s = function e(n) {
                var r = !!n.get("textable"),
                  i = !["text", "default", ""].some(function (t) {
                    return n.is(t);
                  }) || r;
                n.set(nt({
                  _innertext: !i,
                  editable: i && n.get("editable"),
                  selectable: i,
                  hoverable: i,
                  removable: r,
                  draggable: r,
                  highlightable: 0,
                  copyable: r
                }, !r && {
                  toolbar: ""
                }), t), n.get("components").each(function (t) {
                  return e(t);
                });
              };
              !t.silent && e.trigger("change:content", e, "", a), o.add(i, t), o.each(function (t) {
                return s(t);
              }), o.trigger("resetNavigator");
            }
          }
        },
        getModelsFromEl: function getModelsFromEl(t) {
          for (var e = [], n = (t || this.el).childNodes, r = 0; r < n.length; r++) {
            var i = n[r],
              o = i.__cashData && i.__cashData.model;
            o && (o.components = this.getModelsFromEl(i), o.get("content") && (o.attributes.content = i.textContent), e.push(o));
          }
          return e;
        },
        onInput: function onInput() {
          var t = this.em,
            e = ["".concat("component", ":update"), "".concat("component", ":input")].join(" ");
          t && t.trigger(e, this.model);
        },
        disablePropagation: function disablePropagation(t) {
          t.stopPropagation();
        },
        toggleEvents: function toggleEvents(t) {
          var e = this.em,
            n = {
              on: tt.u,
              off: tt.t
            },
            r = t ? "on" : "off";
          e.setEditing(t), this.rteEnabled = !!t;
          var i = [this.el.ownerDocument, document];
          if (n.off(i, "mousedown", this.disableEditing), n[r](i, "mousedown", this.disableEditing), e[r]("toolbar:run:before", this.disableEditing), this.$el.off("mousedown", this.disablePropagation), this.$el[r]("mousedown", this.disablePropagation), this.config.draggableComponents) for (var o = this.el; o;) o.draggable = !t, (o = o.parentNode) && "BODY" == o.tagName && (o = 0);
        }
      }),
      ot = it.extend({
        render: function render() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          return it.prototype.render.apply(this, e), this.el.addEventListener("click", this.prevDef, !0), this;
        }
      });
    function at(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function st(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? at(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : at(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var lt = X.extend({
        defaults: st(st({}, X.prototype.defaults), {}, {
          tagName: "label",
          traits: ["id", "title", "for"]
        })
      }, {
        isComponent: function isComponent(t) {
          if ("LABEL" == t.tagName) return {
            type: "label"
          };
        }
      }),
      ct = ot.extend({
        tagName: "span"
      });
    function ut(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function dt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ut(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ut(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var ht = "yt",
      ft = "vi",
      pt = "ytnc",
      gt = $.extend({
        defaults: dt(dt({}, $.prototype.defaults), {}, {
          type: "video",
          tagName: "video",
          videoId: "",
          void: 0,
          provider: ht,
          ytUrl: "https://www.youtube.com/embed/",
          ytncUrl: "https://www.youtube-nocookie.com/embed/",
          viUrl: "https://player.vimeo.com/video/",
          loop: 0,
          poster: "",
          muted: 0,
          autoplay: 0,
          controls: 1,
          color: "",
          list: "",
          rel: 1,
          modestbranding: 0,
          sources: [],
          attributes: {
            allowfullscreen: "allowfullscreen"
          },
          src: "Bizu6v9k5Uc"
        }),
        initialize: function initialize(t, e) {
          this.em = e.em, this.get("src") && this.parseFromSrc(), this.updateTraits(), this.listenTo(this, "change:provider", this.updateTraits), this.listenTo(this, "change:videoId change:provider", this.updateSrc), $.prototype.initialize.apply(this, arguments);
        },
        updateTraits: function updateTraits() {
          var t,
            e = "iframe";
          switch (this.get("provider")) {
            case ht:
              this.setAttributes(a()({}, "data-video-type", "youtube")), t = this.getYoutubeTraits();
              break;
            case pt:
              this.setAttributes(a()({}, "data-video-type", "youtube-nocookie")), t = this.getYoutubeTraits();
              break;
            case ft:
              this.setAttributes(a()({}, "data-video-type", "vimeo")), t = this.getVimeoTraits();
              break;
            default:
              this.setAttributes(a()({}, "data-video-type", "video")), e = "video", t = this.getSourceTraits();
          }
          this.set({
            tagName: e
          }, {
            silent: 1
          }), this.set({
            traits: t
          }), this.em.trigger("component:toggled");
        },
        parseFromSrc: function parseFromSrc() {
          var t = this.get("provider"),
            e = this.parseUri(this.get("src")),
            n = e.query;
          switch (t) {
            case ht:
            case pt:
            case ft:
              var r = e.pathname.split("/").pop();
              this.set("videoId", r), n.list && this.set("list", n.list), n.autoplay && this.set("autoplay", 1), n.loop && this.set("loop", 1), 0 === parseInt(n.controls) && this.set("controls", 0), n.color && this.set("color", n.color), "0" === n.rel && this.set("rel", 0), "1" === n.modestbranding && this.set("modestbranding", 1);
          }
        },
        updateSrc: function updateSrc() {
          var t = "";
          switch (this.get("provider")) {
            case ht:
              t = this.getYoutubeSrc();
              break;
            case pt:
              t = this.getYoutubeNoCookieSrc();
              break;
            case ft:
              t = this.getVimeoSrc();
          }
          this.set({
            src: t
          });
        },
        getAttrToHTML: function getAttrToHTML() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          var r = $.prototype.getAttrToHTML.apply(this, e),
            i = this.get("provider");
          switch (i) {
            case ht:
            case pt:
            case ft:
              break;
            default:
              this.get("loop") && (r.loop = "loop"), this.get("autoplay") && (r.autoplay = "autoplay"), this.get("controls") && (r.controls = "controls");
          }
          return r;
        },
        getProviderTrait: function getProviderTrait() {
          return {
            type: "select",
            label: "Provider",
            name: "provider",
            changeProp: 1,
            options: [{
              value: "so",
              name: "HTML5 Source"
            }, {
              value: ht,
              name: "Youtube"
            }, {
              value: pt,
              name: "Youtube (no cookie)"
            }, {
              value: ft,
              name: "Vimeo"
            }]
          };
        },
        getSourceTraits: function getSourceTraits() {
          return [this.getProviderTrait(), {
            label: "Source",
            name: "src",
            placeholder: "eg. ./media/video.mp4",
            changeProp: 1
          }, {
            label: "Poster",
            name: "poster",
            placeholder: "eg. ./media/image.jpg"
          }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), this.getWebconnectVideoTrait()];
        },
        getYoutubeTraits: function getYoutubeTraits() {
          return [this.getProviderTrait(), {
            label: "Video ID",
            name: "videoId",
            placeholder: "eg. jNQXAC9IVRw",
            changeProp: 1
          }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), {
            type: "checkbox",
            label: "Related",
            name: "rel",
            changeProp: 1
          }, {
            type: "checkbox",
            label: "Modest",
            name: "modestbranding",
            changeProp: 1
          }, this.getWebconnectVideoTrait()];
        },
        getVimeoTraits: function getVimeoTraits() {
          return [this.getProviderTrait(), {
            label: "Video ID",
            name: "videoId",
            placeholder: "eg. 123456789",
            changeProp: 1
          }, {
            label: "Color",
            name: "color",
            placeholder: "eg. FF0000",
            changeProp: 1
          }, this.getAutoplayTrait(), this.getLoopTrait(), this.getWebconnectVideoTrait()];
        },
        getAutoplayTrait: function getAutoplayTrait() {
          return {
            type: "checkbox",
            label: "Autoplay",
            name: "autoplay",
            changeProp: 1
          };
        },
        getLoopTrait: function getLoopTrait() {
          return {
            type: "checkbox",
            label: "Loop",
            name: "loop",
            changeProp: 1
          };
        },
        getControlsTrait: function getControlsTrait() {
          return {
            type: "checkbox",
            label: "Controls",
            name: "controls",
            changeProp: 1
          };
        },
        getYoutubeSrc: function getYoutubeSrc() {
          var t = this.get("videoId"),
            e = this.get("ytUrl"),
            n = this.get("list");
          return e += t + (t.indexOf("?") < 0 ? "?" : ""), e += n ? "&list=".concat(n) : "", e += this.get("autoplay") ? "&autoplay=1" : "", e += this.get("controls") ? "" : "&controls=0&showinfo=0", e += this.get("loop") ? "&loop=1&playlist=".concat(t) : "", e += this.get("rel") ? "" : "&rel=0", e += this.get("modestbranding") ? "&modestbranding=1" : "";
        },
        getYoutubeNoCookieSrc: function getYoutubeNoCookieSrc() {
          var t = this.getYoutubeSrc();
          return t = t.replace(this.get("ytUrl"), this.get("ytncUrl"));
        },
        getVimeoSrc: function getVimeoSrc() {
          var t = this.get("viUrl");
          return t += this.get("videoId") + "?", t += this.get("autoplay") ? "&autoplay=1" : "", t += this.get("loop") ? "&loop=1" : "", t += this.get("controls") ? "" : "&title=0&portrait=0&badge=0", t += this.get("color") ? "&color=" + this.get("color") : "";
        },
        getWebconnectVideoTrait: function getWebconnectVideoTrait() {
          return {
            type: "webconnect-video",
            label: !1,
            content: "Insert your text here"
          };
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "",
            n = /youtube\.com\/embed/.test(t.src),
            r = /youtube-nocookie\.com\/embed/.test(t.src),
            i = /player\.vimeo\.com\/video/.test(t.src),
            o = n || r || i;
          return ("VIDEO" == t.tagName || "IFRAME" == t.tagName && o) && (e = {
            type: "video"
          }, t.src && (e.src = t.src), o && (n ? e.provider = ht : r ? e.provider = pt : i && (e.provider = ft))), e;
        }
      }),
      vt = q.extend({
        tagName: "div",
        events: {},
        initialize: function initialize(t) {
          f.default.prototype.initialize.apply(this, arguments);
          var e = this.model,
            n = ["loop", "autoplay", "controls", "color", "rel", "modestbranding", "poster"],
            r = n.map(function (t) {
              return "change:".concat(t);
            }).join(" ");
          this.listenTo(e, "change:provider", this.updateProvider), this.listenTo(e, "change:src", this.updateSrc), this.listenTo(e, r, this.updateVideo);
        },
        updateProvider: function updateProvider() {
          var t = this.model.get("provider");
          this.el.innerHTML = "", this.el.appendChild(this.renderByProvider(t));
        },
        updateSrc: function updateSrc() {
          var t = this.model,
            e = this.videoEl;
          if (e) {
            var n = t.get("provider"),
              r = t.get("src");
            switch (n) {
              case "yt":
                r = t.getYoutubeSrc();
                break;
              case "ytnc":
                r = t.getYoutubeNoCookieSrc();
                break;
              case "vi":
                r = t.getVimeoSrc();
            }
            e.src = r;
          }
        },
        updateVideo: function updateVideo() {
          var t = this.model.get("provider"),
            e = this.videoEl,
            n = this.model;
          switch (t) {
            case "yt":
            case "ytnc":
            case "vi":
              this.model.trigger("change:videoId");
              break;
            default:
              e.loop = n.get("loop"), e.autoplay = n.get("autoplay"), e.controls = n.get("controls"), e.poster = n.get("poster");
          }
        },
        renderByProvider: function renderByProvider(t) {
          var e;
          switch (t) {
            case "yt":
              e = this.renderYoutube();
              break;
            case "ytnc":
              e = this.renderYoutubeNoCookie();
              break;
            case "vi":
              e = this.renderVimeo();
              break;
            default:
              e = this.renderSource();
          }
          return this.videoEl = e, e;
        },
        renderSource: function renderSource() {
          var t = document.createElement("video");
          return t.src = this.model.get("src"), this.initVideoEl(t), t;
        },
        renderYoutube: function renderYoutube() {
          var t = document.createElement("iframe");
          return t.src = this.model.getYoutubeSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
        },
        renderYoutubeNoCookie: function renderYoutubeNoCookie() {
          var t = document.createElement("iframe");
          return t.src = this.model.getYoutubeNoCookieSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
        },
        renderVimeo: function renderVimeo() {
          var t = document.createElement("iframe");
          return t.src = this.model.getVimeoSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
        },
        initVideoEl: function initVideoEl(t) {
          t.className = this.ppfx + "no-pointer", t.style.height = "100%", t.style.width = "100%";
        },
        render: function render() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          q.prototype.render.apply(this, e), this.updateClasses();
          var r = this.model.get("provider");
          return this.el.appendChild(this.renderByProvider(r)), this.updateVideo(), this;
        }
      });
    function mt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function bt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? mt(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : mt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var yt = $.extend({
        defaults: bt(bt({}, $.prototype.defaults), {}, {
          type: "audio",
          tagName: "audio",
          void: 0,
          provider: "hso",
          loop: 0,
          muted: 0,
          autoplay: 0,
          controls: 1,
          list: "",
          sources: [],
          attributes: {},
          src: "https://cdn.pixabay.com/download/audio/2022/01/12/audio_45cacdef8f.mp3"
        }),
        initialize: function initialize(t, e) {
          this.em = e.em, this.updateTraits(), $.prototype.initialize.apply(this, arguments);
        },
        updateTraits: function updateTraits() {
          var t = this.getSourceTraits();
          this.setAttributes(a()({}, "data-audio-type", "url")), this.set({
            tagName: "audio"
          }, {
            silent: 1
          }), this.set({
            traits: t
          }), this.em.trigger("component:toggled");
        },
        updateSrc: function updateSrc() {
          this.set({
            src: ""
          });
        },
        getAttrToHTML: function getAttrToHTML() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          var r = $.prototype.getAttrToHTML.apply(this, e);
          return this.get("loop") && (r.loop = "loop"), this.get("autoplay") && (r.autoplay = "autoplay"), this.get("controls") && (r.controls = "controls"), r;
        },
        getSourceTraits: function getSourceTraits() {
          return [{
            label: "Source",
            name: "src",
            placeholder: "eg. ./media/audio.mp3",
            changeProp: 1
          }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), this.getWebconnectAudioTrait()];
        },
        getAutoplayTrait: function getAutoplayTrait() {
          return {
            type: "checkbox",
            label: "Autoplay",
            name: "autoplay",
            changeProp: 1
          };
        },
        getLoopTrait: function getLoopTrait() {
          return {
            type: "checkbox",
            label: "Loop",
            name: "loop",
            changeProp: 1
          };
        },
        getControlsTrait: function getControlsTrait() {
          return {
            type: "checkbox",
            label: "Controls",
            name: "controls",
            changeProp: 1
          };
        },
        getWebconnectAudioTrait: function getWebconnectAudioTrait() {
          return {
            type: "drapcode-audio",
            label: !1,
            content: "Insert audio URL here"
          };
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return "AUDIO" == t.tagName && (e = {
            type: "audio"
          }, t.src && (e.src = t.src)), e;
        }
      }),
      wt = q.extend({
        tagName: "div",
        events: {},
        initialize: function initialize(t) {
          f.default.prototype.initialize.apply(this, arguments);
          var e = this.model,
            n = ["loop", "autoplay", "controls"],
            r = n.map(function (t) {
              return "change:".concat(t);
            }).join(" ");
          this.listenTo(e, "change:src", this.updateSrc), this.listenTo(e, r, this.updateAudio);
        },
        updateProvider: function updateProvider() {
          var t = this.model.get("provider");
          this.el.innerHTML = "", this.el.appendChild(this.renderByProvider(t));
        },
        updateSrc: function updateSrc() {
          var t = this.model,
            e = this.audioEl;
          if (e) {
            var n = t.get("src");
            e.src = n;
          }
        },
        updateAudio: function updateAudio() {
          var t = this.audioEl,
            e = this.model;
          t.loop = e.get("loop"), t.autoplay = e.get("autoplay"), t.controls = e.get("controls");
        },
        renderByProvider: function renderByProvider(t) {
          var e;
          return e = this.renderSource(), this.audioEl = e, e;
        },
        renderSource: function renderSource() {
          var t = document.createElement("audio");
          return t.src = this.model.get("src"), this.initAudioEl(t), t;
        },
        initAudioEl: function initAudioEl(t) {
          t.className = this.ppfx + "no-pointer", t.style.height = "100%", t.style.width = "100%";
        },
        render: function render() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          q.prototype.render.apply(this, e), this.updateClasses();
          var r = this.model.get("provider");
          return this.el.appendChild(this.renderByProvider(r)), this.updateAudio(), this;
        }
      });
    function xt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Ot(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? xt(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var Ct = d.default.extend({
        defaults: Ot(Ot({}, d.default.prototype.defaults), {}, {
          type: "script",
          droppable: !1,
          draggable: !1,
          layerable: !1
        })
      }, {
        isComponent: function isComponent(t) {
          if ("SCRIPT" == t.tagName) {
            var e = {
              type: "script"
            };
            return t.src && (e.src = t.src, e.onload = t.onload), e;
          }
        }
      }),
      St = q.extend({
        tagName: "script",
        events: {},
        render: function render() {
          var t = this.model,
            e = t.get("src"),
            n = this.em,
            r = n && n.get("scriptCount") ? n.get("scriptCount") : 0,
            i = "";
          if (e) {
            var o = t.get("onload"),
              a = "script" + r,
              s = "script" + (r + 1);
            i = "var " + a + " = document.createElement('script');\n" + a + ".onload = function(){\n" + (o ? o + "();\n" : "") + "typeof " + s + "Start == 'function' && " + s + "Start();\n};\n" + a + ".src = '" + e + "';\nfunction " + a + "Start() { document.body.appendChild(" + a + "); };\n" + (r ? "" : a + "Start();"), n && n.set("scriptCount", r + 1);
          } else i = t.get("content");
          return this.el.innerHTML = i, this.postRender(), this;
        }
      });
    function kt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function jt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? kt(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : kt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var Tt = d.default.extend({
      defaults: jt(jt({}, d.default.prototype.defaults), {}, {
        resizable: {
          ratioDefault: 1
        },
        highlightable: 0
      }),
      getName: function getName() {
        var t = this.get("tagName"),
          e = this.get("custom-name");
        return t = t.charAt(0).toUpperCase() + t.slice(1), e || t;
      }
    }, {
      isComponent: function isComponent(t) {
        if (SVGElement && t instanceof SVGElement) return {
          tagName: t.tagName,
          type: "svg"
        };
      }
    });
    function Pt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Et(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? Pt(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Pt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var Dt = Tt.extend({
        defaults: Et(Et({}, Tt.prototype.defaults), {}, {
          selectable: !1,
          hoverable: !1,
          layerable: !1
        })
      }, {
        isComponent: function isComponent(t) {
          if (Tt.isComponent(t) && "svg" !== t.tagName.toLowerCase()) return {
            tagName: t.tagName,
            type: "svg-in"
          };
        }
      }),
      Mt = f.default.extend({
        _createElement: function _createElement(t) {
          return document.createElementNS("http://www.w3.org/2000/svg", t);
        }
      });
    function At(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Lt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? At(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : At(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var Nt = d.default.extend({
      defaults: Lt(Lt({}, d.default.prototype.defaults), {}, {
        droppable: !1,
        layerable: !1,
        editable: !0
      }),
      toHTML: function toHTML() {
        return this.get("content").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
      }
    }, {
      isComponent: function isComponent(t) {
        var e = "";
        return 3 === t.nodeType && (e = {
          type: "textnode",
          content: t.textContent
        }), e;
      }
    });
    function _t(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    var It = Nt.extend({
        defaults: function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = null != arguments[e] ? arguments[e] : {};
            e % 2 ? _t(Object(n), !0).forEach(function (e) {
              a()(t, e, n[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : _t(Object(n)).forEach(function (e) {
              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
            });
          }
          return t;
        }({}, Nt.prototype.defaults),
        toHTML: function toHTML() {
          return "\x3c!--".concat(this.get("content"), "--\x3e");
        }
      }, {
        isComponent: function isComponent(t) {
          if (8 == t.nodeType) return {
            tagName: "NULL",
            type: "comment",
            content: t.textContent
          };
        }
      }),
      Ft = f.default.extend({
        initialize: function initialize() {
          f.default.prototype.initialize.apply(this, arguments);
        },
        _setAttributes: function _setAttributes() {},
        renderAttributes: function renderAttributes() {},
        setAttribute: function setAttribute() {},
        updateAttributes: function updateAttributes() {},
        initClasses: function initClasses() {},
        initComponents: function initComponents() {},
        delegateEvents: function delegateEvents() {},
        _createElement: function _createElement() {
          return document.createTextNode("");
        },
        render: function render() {
          var t = this.model,
            e = this.el;
          return t.opt.temporary || (e.textContent = t.get("content")), this;
        }
      }),
      Vt = Ft.extend({
        _createElement: function _createElement() {
          return document.createComment(this.model.get("content"));
        }
      }),
      Rt = d.default.extend({}, {
        isComponent: function isComponent() {
          return !1;
        }
      });
    function zt(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function Ht(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? zt(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : zt(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n,
        r = {},
        o = {},
        a = [{
          id: "cell",
          model: m,
          view: b
        }, {
          id: "row",
          model: x,
          view: O
        }, {
          id: "table",
          model: k,
          view: j
        }, {
          id: "thead",
          model: A,
          view: L
        }, {
          id: "tbody",
          model: E,
          view: N
        }, {
          id: "tfoot",
          model: F,
          view: V
        }, {
          id: "map",
          model: U,
          view: G
        }, {
          id: "link",
          model: Q,
          view: ot
        }, {
          id: "label",
          model: lt,
          view: ct
        }, {
          id: "video",
          model: gt,
          view: vt
        }, {
          id: "audio",
          model: yt,
          view: wt
        }, {
          id: "image",
          model: $,
          view: q
        }, {
          id: "script",
          model: Ct,
          view: St
        }, {
          id: "svg-in",
          model: Dt,
          view: Mt
        }, {
          id: "svg",
          model: Tt,
          view: Mt
        }, {
          id: "comment",
          model: It,
          view: Vt
        }, {
          id: "textnode",
          model: Nt,
          view: Ft
        }, {
          id: "text",
          model: X,
          view: it
        }, {
          id: "wrapper",
          model: Rt,
          view: f.default
        }, {
          id: "default",
          model: d.default,
          view: f.default
        }];
      return {
        Component: d.default,
        Components: h.a,
        ComponentsView: p.a,
        componentTypes: a,
        componentsById: o,
        name: "DomComponents",
        getConfig: function getConfig() {
          return r;
        },
        storageKey: function storageKey() {
          var t = [],
            e = r.stm && r.stm.getConfig() || {};
          return e.storeHtml && t.push("html"), e.storeComponents && t.push("components"), t;
        },
        init: function init(i) {
          var o = this;
          for (var s in t = (r = i || {}).em, this.em = t, t && (r.components = t.config.components || r.components), u) s in r || (r[s] = u[s]);
          var l = r.pStylePrefix;
          if (l && (r.stylePrefix = l + r.stylePrefix), t) {
            r.modal = t.get("Modal") || "", r.popover = t.get("Popover") || "", r.am = t.get("AssetManager") || "", t.get("Parser").compTypes = a, t.on("change:componentHovered", this.componentHovered, this);
            var c = t.get("selected");
            t.listenTo(c, "add", function (t, e, n) {
              return o.selectAdd(t, n);
            }), t.listenTo(c, "remove", function (t, e, n) {
              return o.selectRemove(t, n);
            });
          }
          var h = r.components,
            p = Ht({}, r.wrapper);
          return p["custom-name"] = r.wrapperName, p.wrapper = 1, p.type = "wrapper", h && h.constructor === Object && h.wrapper && (p = Ht({}, h), h = h.components || [], p.components = [], t && (t.config.components = h, r.components = h)), (e = new d.default(p, {
            em: t,
            config: r,
            componentTypes: a,
            domc: this
          })).set({
            attributes: {
              id: "wrapper"
            }
          }), n = new f.default({
            model: e,
            config: r,
            componentTypes: a
          }), this;
        },
        onLoad: function onLoad() {
          this.setComponents(r.components);
        },
        postLoad: function postLoad(t) {
          this.handleChanges(this.getWrapper(), null, {
            avoidStore: 1
          });
        },
        handleChanges: function handleChanges(e, n) {
          var r = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = e.components(),
            a = t.get("UndoManager"),
            s = t.handleUpdates.bind(t),
            l = this.handleChanges.bind(this),
            c = this.handleChangesColl.bind(this),
            u = this.handleRemoves.bind(this);
          a && a.add(e), a && o && a.add(o);
          var d = "change:style change:content change:attributes change:src";
          [[e, d, s], [e, "change:components", c], [o, "add", l], [o, "remove", u], [e.get("classes"), "add remove", s]].forEach(function (e) {
            t.stopListening(e[0], e[1], e[2]), t.listenTo(e[0], e[1], e[2]);
          }), !i.avoidStore && s("", "", i), o.each(function (t) {
            return r.handleChanges(t, n, i);
          });
        },
        handleChangesColl: function handleChangesColl(e, n) {
          var r = t.get("UndoManager");
          if (r && n instanceof l.a.Collection) {
            var i = this.handleChanges.bind(this),
              o = this.handleRemoves.bind(this);
            r.add(n), [[n, "add", i], [n, "remove", o]].forEach(function (e) {
              t.stopListening(e[0], e[1], e[2]), t.listenTo(e[0], e[1], e[2]);
            });
          }
        },
        handleRemoves: function handleRemoves(e, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          !r.avoidStore && t.handleUpdates(e, n, r);
        },
        load: function load() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            e = this.em,
            n = "";
          !t && r.stm && (t = r.em.getCacheLoad());
          var i = t,
            o = i.components,
            a = i.html;
          if (o) {
            if (Object(c.isObject)(o) || Object(c.isArray)(o)) n = o;else try {
              n = JSON.parse(o);
            } catch (t) {
              e && e.logError(t);
            }
          } else a && (n = a);
          var s = n && n.constructor === Object;
          return (n && n.length || s) && (this.clear(), s ? this.getWrapper().set(n) : this.getComponents().add(n)), n;
        },
        store: function store(t) {
          if (r.stm) {
            var e = {},
              n = this.storageKey();
            if (n.indexOf("html") >= 0 && (e.html = r.em.getHtml()), n.indexOf("components") >= 0) {
              this.em;
              var i = r.storeWrapper ? this.getWrapper() : this.getComponents();
              e.components = JSON.stringify(i);
            }
            return t || r.stm.store(e), e;
          }
        },
        getComponent: function getComponent() {
          return e;
        },
        getWrapper: function getWrapper() {
          return this.getComponent();
        },
        getComponents: function getComponents() {
          return this.getWrapper().get("components");
        },
        addComponent: function addComponent(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return this.getComponents().add(t, e);
        },
        render: function render() {
          return n.render().el;
        },
        clear: function clear() {
          return this.getComponents().map(function (t) {
            return t;
          }).forEach(function (t) {
            return t.remove();
          }), this;
        },
        setComponents: function setComponents(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.clear().addComponent(t, e);
        },
        addType: function addType(t, e) {
          var n = this.em,
            r = e.model,
            o = void 0 === r ? {} : r,
            s = e.view,
            l = void 0 === s ? {} : s,
            u = e.isComponent,
            d = e.extend,
            h = e.extendView,
            f = e.extendFn,
            p = void 0 === f ? [] : f,
            g = e.extendFnView,
            v = void 0 === g ? [] : g,
            m = this.getType(t),
            b = this.getType(d),
            y = this.getType(h),
            w = b || m || this.getType("default"),
            x = w.model,
            O = y ? y.view : w.view,
            C = function C(t, e, n) {
              return t.reduce(function (t, r) {
                var i = e[r],
                  o = n.prototype[r];
                return i && o && (t[r] = function () {
                  o.bind(this).apply(void 0, arguments), i.bind(this).apply(void 0, arguments);
                }), t;
              }, {});
            };
          "object" === i()(o) && (e.model = x.extend(Ht(Ht(Ht({}, o), C(p, o, x)), {}, {
            defaults: Ht(Ht({}, x.prototype.defaults), Object(c.result)(o, "defaults") || {})
          }), {
            isComponent: !m || b || u ? u || function () {
              return 0;
            } : x.isComponent
          })), "object" === i()(l) && (e.view = O.extend(Ht(Ht({}, l), C(v, l, O)))), m ? (m.model = e.model, m.view = e.view) : (e.id = t, a.unshift(e));
          var S = "component:type:".concat(m ? "update" : "add");
          return n && n.trigger(S, m || e), this;
        },
        getType: function getType(t) {
          for (var e = a, n = 0; n < e.length; n++) {
            if (e[n].id == t) return e[n];
          }
        },
        removeType: function removeType(t) {
          var e = a,
            n = this.getType(t);
          if (n) {
            var r = e.indexOf(n);
            return e.splice(r, 1), n;
          }
        },
        getTypes: function getTypes() {
          return a;
        },
        selectAdd: function selectAdd(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          t && (t.set({
            status: "selected"
          }), ["component:selected", "component:toggled"].forEach(function (r) {
            return e.em.trigger(r, t, n);
          }));
        },
        selectRemove: function selectRemove(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (t) {
            this.em;
            t.set({
              status: "",
              state: ""
            }), ["component:deselected", "component:toggled"].forEach(function (r) {
              return e.em.trigger(r, t, n);
            });
          }
        },
        componentHovered: function componentHovered() {
          var t = r.em,
            e = t.get("componentHovered"),
            n = t.previous("componentHovered");
          n && "hovered" == n.get("status") && n.set({
            status: "",
            state: ""
          }), e && Object(c.isEmpty)(e.get("status")) && e.set("status", "hovered");
        },
        allById: function allById() {
          return o;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(9),
      i = n.n(r),
      o = n(2),
      a = n.n(o),
      s = n(3),
      l = n(0),
      c = n(15),
      u = n.n(c),
      d = n(16),
      h = n.n(d),
      f = function () {
        function t(e, n) {
          var r = this;
          u()(this, t), this.em = e;
          var i = n || e.get("Canvas").getFrames().map(function (t) {
              return t.get("root").getEl();
            }),
            o = Array.isArray(i) ? i : [i];
          return this.el = i, this.counter = 0, Object(l.bindAll)(this, "handleDragEnter", "handleDragOver", "handleDrop", "handleDragLeave"), o.forEach(function (t) {
            return r.toggleEffects(t, 1);
          }), this;
        }
        return h()(t, [{
          key: "toggleEffects",
          value: function value(t, e) {
            var n = {
                on: s.u,
                off: s.t
              },
              r = e ? "on" : "off";
            n[r](t, "dragenter", this.handleDragEnter), n[r](t, "dragover", this.handleDragOver), n[r](t, "drop", this.handleDrop), n[r](t, "dragleave", this.handleDragLeave);
          }
        }, {
          key: "endDrop",
          value: function value(t, e) {
            var n = this.em,
              r = this.dragStop;
            this.counter = 0, this.over = 0, r && r(t), n.runDefault({
              preserveSelected: 1
            }), n.trigger("canvas:dragend", e);
          }
        }, {
          key: "handleDragLeave",
          value: function value(t) {
            this.updateCounter(-1, t);
          }
        }, {
          key: "updateCounter",
          value: function value(t, e) {
            this.counter += t, 0 === this.counter && this.endDrop(1, e);
          }
        }, {
          key: "handleDragEnter",
          value: function value(t) {
            var e = this,
              n = this.em,
              r = t.dataTransfer;
            if (this.updateCounter(1, t), !this.over) {
              this.over = 1;
              var i,
                o,
                a = n.get("Utils"),
                s = n.get("Canvas"),
                l = s.getBody(),
                c = n.get("dragContent") || "<br>";
              if (n.stopDefault(), n.inAbsoluteMode()) {
                var u = n.get("DomComponents").getWrapper(),
                  d = u.append({})[0],
                  h = n.get("Commands").run("core:component-drag", {
                    event: t,
                    guidesInfo: 1,
                    center: 1,
                    target: d,
                    onEnd: function onEnd(t, n, i) {
                      if (!i.cancelled) {
                        var o = u.append(c)[0],
                          a = d.getStyle(),
                          s = a.left,
                          l = a.top,
                          h = a.position;
                        o.addStyle({
                          left: s,
                          top: l,
                          position: h
                        }), e.handleDragEnd(o, r);
                      }
                      d.remove();
                    }
                  });
                i = function i(e) {
                  return h.stop(t, {
                    cancel: e
                  });
                }, o = function o(t) {
                  return c = t;
                };
              } else {
                var f = new a.Sorter({
                  em: n,
                  wmargin: 1,
                  nested: 1,
                  canvasRelative: 1,
                  direction: "a",
                  container: l,
                  placer: s.getPlacerEl(),
                  containerSel: "*",
                  itemSel: "*",
                  pfx: "gjs-",
                  onEndMove: function onEndMove(t) {
                    return e.handleDragEnd(t, r);
                  },
                  document: s.getFrameEl().contentDocument
                });
                f.setDropContent(c), f.startSort(), this.sorter = f, i = function i(t) {
                  t && (f.moved = 0), f.endMove();
                }, o = function o(t) {
                  return f.setDropContent(t);
                };
              }
              this.dragStop = i, this.dragContent = o, n.trigger("canvas:dragenter", r, c);
            }
          }
        }, {
          key: "handleDragEnd",
          value: function value(t, e) {
            if (t) {
              var n = this.em;
              n.set("dragResult", t), n.trigger("canvas:drop", e, t);
            }
          }
        }, {
          key: "handleDragOver",
          value: function value(t) {
            t.preventDefault(), this.em.trigger("canvas:dragover", t);
          }
        }, {
          key: "handleDrop",
          value: function value(t) {
            t.preventDefault();
            var e = this.dragContent,
              n = t.dataTransfer,
              r = this.getContentByData(n).content;
            t.target.style.border = "", r && e && e(r), this.endDrop(!r, t);
          }
        }, {
          key: "getContentByData",
          value: function value(t) {
            var e = this.em,
              n = t.types,
              r = t.files || [],
              i = e.get("dragContent"),
              o = t.getData("text");
            if (r.length) {
              o = [];
              for (var a = 0; a < r.length; a++) {
                var s = r[a],
                  c = s.type.split("/")[0];
                "image" == c && o.push({
                  type: c,
                  file: s,
                  attributes: {
                    alt: s.name
                  }
                });
              }
            } else if (i) o = i;else if (Object(l.indexOf)(n, "text/html") >= 0) o = t.getData("text/html").replace(/<\/?meta[^>]*>/g, "");else if (Object(l.indexOf)(n, "text/uri-list") >= 0) o = {
              type: "link",
              attributes: {
                href: o
              },
              content: o
            };else if (Object(l.indexOf)(n, "text/json") >= 0) {
              var u = t.getData("text/json");
              u && (o = JSON.parse(u));
            }
            var d = {
              content: o
            };
            return e.trigger("canvas:dragdata", t, d), d;
          }
        }]), t;
      }(),
      p = {
        stylePrefix: "cv-",
        scripts: [],
        styles: [],
        customBadgeLabel: "",
        autoscrollLimit: 50,
        notTextable: ["button", "a", "input[type=checkbox]", "input[type=radio]"]
      },
      g = n(1),
      v = n.n(g),
      m = n(5),
      b = n(33);
    function y(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function w(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? y(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var x = v.a.Model.extend({
        defaults: {
          wrapper: "",
          width: null,
          height: null,
          head: "",
          x: 0,
          y: 0,
          root: 0,
          components: 0,
          styles: 0,
          attributes: {}
        },
        initialize: function initialize(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.attributes,
            r = n.root,
            i = n.styles,
            o = n.components;
          this.set("head", []), this.em = e.em;
          var a = {
            em: e.em,
            config: e.em.get("DomComponents").getConfig(),
            frame: this
          };
          !r && this.set("root", new m.default({
            type: "wrapper",
            components: o || []
          }, a)), (!i || Object(l.isString)(i)) && this.set("styles", new b.a(i, a));
        },
        remove: function remove() {
          this.view = 0;
          var t = this.collection;
          return t && t.remove(this);
        },
        getHead: function getHead() {
          return i()(this.get("head"));
        },
        setHead: function setHead(t) {
          return this.set("head", i()(t));
        },
        addHeadItem: function addHeadItem(t) {
          var e = this.getHead();
          e.push(t), this.setHead(e);
        },
        getHeadByAttr: function getHeadByAttr(t, e, n) {
          return this.getHead().filter(function (r) {
            return r.attributes && r.attributes[t] == e && (!n || n === r.tag);
          })[0];
        },
        removeHeadByAttr: function removeHeadByAttr(t, e, n) {
          var r = this.getHead(),
            i = this.getHeadByAttr(t, e, n),
            o = r.indexOf(i);
          o >= 0 && (r.splice(o, 1), this.setHead(r));
        },
        addLink: function addLink(t) {
          !this.getHeadByAttr("href", t, "link") && this.addHeadItem({
            tag: "link",
            attributes: {
              href: t,
              rel: "stylesheet"
            }
          });
        },
        removeLink: function removeLink(t) {
          this.removeHeadByAttr("href", t, "link");
        },
        addScript: function addScript(t) {
          !this.getHeadByAttr("src", t, "script") && this.addHeadItem({
            tag: "script",
            attributes: {
              src: t
            }
          });
        },
        removeScript: function removeScript(t) {
          this.removeHeadByAttr("src", t, "script");
        },
        _emitUpdated: function _emitUpdated() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.em.trigger("frame:updated", w({
            frame: this
          }, t));
        }
      }),
      O = v.a.Collection.extend({
        model: x,
        initialize: function initialize() {
          Object(l.bindAll)(this, "itemLoaded");
        },
        itemLoaded: function itemLoaded() {
          this.loadedItems++, this.loadedItems >= this.itemsToLoad && (this.trigger("loaded:all"), this.listenToLoadItems(0));
        },
        listenToLoad: function listenToLoad() {
          this.loadedItems = 0, this.itemsToLoad = this.length, this.listenToLoadItems(1);
        },
        listenToLoadItems: function listenToLoadItems(t) {
          var e = this;
          this.forEach(function (n) {
            return n[t ? "on" : "off"]("loaded", e.itemLoaded);
          });
        }
      }),
      C = v.a.Model.extend({
        defaults: {
          frame: "",
          frames: "",
          wrapper: "",
          rulers: !1,
          zoom: 100,
          x: 0,
          y: 0
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.em,
            n = t.styles,
            r = void 0 === n ? [] : n,
            i = t.scripts,
            o = void 0 === i ? [] : i,
            a = e && e.getWrapper(),
            s = e && e.getStyle(),
            l = new x({
              root: a,
              styles: s
            }, t);
          r.forEach(function (t) {
            return l.addLink(t);
          }), o.forEach(function (t) {
            return l.addScript(t);
          }), this.em = e, this.set("frame", l), this.set("frames", new O([l], t)), this.listenTo(this, "change:zoom", this.onZoomChange), this.listenTo(e, "change:device", this.updateDevice);
        },
        updateDevice: function updateDevice() {
          var t = this.em,
            e = t.getDeviceModel(),
            n = t.getCurrentFrameModel();
          if (n && e) {
            var r = e.attributes,
              i = r.width,
              o = r.height;
            n.set({
              width: i,
              height: o
            });
          }
        },
        onZoomChange: function onZoomChange() {
          this.get("zoom") < 1 && this.set("zoom", 1);
        }
      }),
      S = n(20),
      k = n(37),
      j = n(6),
      T = n(7);
    function P(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function E(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? P(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : P(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var D = v.a.View.extend({
        tagName: "iframe",
        attributes: {
          allowfullscreen: "allowfullscreen",
          "data-frame-el": !0,
          "data-hj-allow-iframe": !0
        },
        initialize: function initialize(t) {
          Object(l.bindAll)(this, "updateClientY", "stopAutoscroll", "autoscroll", "_emitUpdate");
          var e = this.model,
            n = this.el;
          this.config = E(E({}, t.config || {}), {}, {
            frameView: this
          }), this.ppfx = this.config.pStylePrefix || "", this.em = this.config.em, this.listenTo(e, "change:head", this.updateHead), e.view = this, Object(s.v)(n, this);
        },
        updateHead: function updateHead() {
          var t = this.getHead();
          Object(T.f)(t), Object(T.c)(t, this.model.getHead());
        },
        getEl: function getEl() {
          return this.el;
        },
        getWindow: function getWindow() {
          return this.getEl().contentWindow;
        },
        getDoc: function getDoc() {
          return this.getEl().contentDocument;
        },
        getHead: function getHead() {
          return this.getDoc() ? this.getDoc().querySelector("head") : null;
        },
        getBody: function getBody() {
          return this.getDoc() ? this.getDoc().querySelector("body") : null;
        },
        getWrapper: function getWrapper() {
          return this.getBody() ? this.getBody().querySelector("[data-gjs-type=wrapper]") : null;
        },
        getJsContainer: function getJsContainer() {
          return this.jsContainer || (console.log("Creating div element"), this.jsContainer = Object(T.e)("div", {
            class: "".concat(this.ppfx, "js-cont")
          })), this.jsContainer;
        },
        getToolsEl: function getToolsEl() {
          var t = this.config.frameWrapView;
          return t && t.elTools;
        },
        getGlobalToolsEl: function getGlobalToolsEl() {
          return this.em.get("Canvas").getGlobalToolsEl();
        },
        getHighlighter: function getHighlighter() {
          return this._getTool("[data-hl]");
        },
        getBadgeEl: function getBadgeEl() {
          return this._getTool("[data-badge]");
        },
        getOffsetViewerEl: function getOffsetViewerEl() {
          return this._getTool("[data-offset]");
        },
        getRect: function getRect() {
          return this.rect || (this.rect = this.el.getBoundingClientRect()), this.rect;
        },
        getOffsetRect: function getOffsetRect() {
          var t = this.el,
            e = this.getBody(),
            n = e.scrollTop,
            r = e.scrollLeft,
            i = t.offsetHeight,
            o = t.offsetWidth;
          return {
            top: t.offsetTop,
            left: t.offsetLeft,
            height: i,
            width: o,
            scrollTop: n,
            scrollLeft: r,
            scrollBottom: n + i,
            scrollRight: r + o
          };
        },
        _getTool: function _getTool(t) {
          var e = this.getToolsEl();
          return this[t] || (this[t] = e.querySelector(t)), this[t];
        },
        remove: function remove() {
          var t = this.root,
            e = this.model;
          this._toggleEffects(), v.a.View.prototype.remove.apply(this, arguments), t.remove(), e.remove();
        },
        startAutoscroll: function startAutoscroll() {
          var t = this;
          this.lastMaxHeight = this.getWrapper().offsetHeight - this.el.offsetHeight, setTimeout(function () {
            t._toggleAutoscrollFx(1), requestAnimationFrame(t.autoscroll);
          }, 0);
        },
        autoscroll: function autoscroll() {
          if (this.dragging) {
            var t = this.em.get("Canvas"),
              e = this.getWindow(),
              n = this.getBody().scrollTop,
              r = this.lastClientY || 0,
              i = t.getConfig().autoscrollLimit,
              o = this.getRect().height - i,
              a = n;
            if (r < i && (a -= i - r), r > o && (a += r - o), a !== n && a > 0 && a < this.lastMaxHeight) this.getGlobalToolsEl().style.opacity = 0, this.showGlobalTools(), e.scrollTo(0, a);
            requestAnimationFrame(this.autoscroll);
          }
        },
        updateClientY: function updateClientY(t) {
          t.preventDefault(), this.lastClientY = Object(s.h)(t).clientY * this.em.getZoomDecimal();
        },
        showGlobalTools: Object(l.debounce)(function () {
          this.getGlobalToolsEl().style.opacity = "";
        }, 50),
        stopAutoscroll: function stopAutoscroll() {
          this.dragging && this._toggleAutoscrollFx();
        },
        _toggleAutoscrollFx: function _toggleAutoscrollFx(t) {
          this.dragging = t;
          var e = this.getWindow(),
            n = t ? "on" : "off",
            r = {
              on: s.u,
              off: s.t
            };
          r[n](e, "mousemove dragover", this.updateClientY), r[n](e, "mouseup", this.stopAutoscroll);
        },
        render: function render() {
          var t = this.el,
            e = this.$el,
            n = this.ppfx,
            r = this.config;
          return e.attr({
            class: n + "frame"
          }), r.scripts.length ? this.renderScripts() : r.renderContent && (t.onload = this.renderBody.bind(this)), this;
        },
        renderScripts: function renderScripts() {
          var t = this,
            e = this.el,
            n = this.config;
          e.onload = function () {
            return function n(r) {
              if (r.length > 0) {
                var i = r.shift(),
                  o = Object(T.e)("script", E({
                    type: "text/javascript"
                  }, Object(l.isString)(i) ? {
                    src: i
                  } : i));
                o.onerror = o.onload = n.bind(null, r), e.contentDocument.head.appendChild(o);
              } else t.renderBody();
            }(i()(n.scripts));
          };
        },
        renderBody: function renderBody() {
          var t = this,
            e = this.config,
            n = this.model,
            r = this.ppfx,
            i = n.get("root"),
            o = n.get("styles"),
            a = e.em,
            c = this.getDoc(),
            u = this.getHead(),
            d = this.getBody(),
            h = this.getWindow(),
            f = a.get("Config"),
            p = [];
          h._isEditor = !0, e.styles.forEach(function (t) {
            return p.push(Object(l.isString)(t) ? {
              tag: "link",
              attributes: {
                href: t,
                rel: "stylesheet"
              }
            } : {
              tag: "link",
              attributes: E({
                rel: "stylesheet"
              }, t)
            });
          }), p.length && Object(T.c)(u, p);
          Object(T.a)(d, "<style>\n      ".concat(f.baseCss || "", "\n\n      .").concat(r, "dashed *[data-highlightable] {\n        outline: 1px dashed rgba(170,170,170,0.7);\n        outline-offset: -2px;\n      }\n\n      .").concat(r, "selected {\n        outline: 3px solid #3b97e3 !important;\n        outline-offset: -3px;\n      }\n\n      .").concat(r, "selected-parent {\n        outline: 2px solid ").concat("#ffca6f", " !important\n      }\n\n      .").concat(r, "no-select {\n        user-select: none;\n        -webkit-user-select:none;\n        -moz-user-select: none;\n      }\n\n      .").concat(r, "freezed {\n        opacity: 0.5;\n        pointer-events: none;\n      }\n\n      .").concat(r, "no-pointer {\n        pointer-events: none;\n      }\n\n      .").concat(r, "plh-image {\n        background: #f5f5f5;\n        border: none;\n        height: 100px;\n        width: 100px;\n        display: block;\n        outline: 3px solid #ffca6f;\n        cursor: pointer;\n        outline-offset: -2px\n      }\n\n      .").concat(r, "grabbing {\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n      }\n\n      .").concat(r, "is__grabbing {\n        overflow-x: hidden;\n      }\n\n      .").concat(r, "is__grabbing,\n      .").concat(r, "is__grabbing * {\n        cursor: grabbing !important;\n      }\n\n      ").concat(f.canvasCss || "", "\n      ").concat(f.protectedCss || "", "\n    </style>")), this.root = new j.default({
            model: i,
            config: E(E({}, i.config), {}, {
              frameView: this
            })
          }).render(), Object(T.a)(d, this.root.el), Object(T.a)(d, new k.a({
            collection: o,
            config: E(E({}, a.get("CssComposer").getConfig()), {}, {
              frameView: this
            })
          }).render().el), Object(T.a)(d, this.getJsContainer()), Object(s.u)(d, "click", function (t) {
            return t && "A" == t.target.tagName && t.preventDefault();
          }), Object(s.u)(d, "submit", function (t) {
            return t && t.preventDefault();
          }), [{
            event: "keydown keyup keypress",
            class: "KeyboardEvent"
          }, {
            event: "mousemove",
            class: "MouseEvent"
          }, {
            event: "wheel",
            class: "WheelEvent"
          }].forEach(function (e) {
            return e.event.split(" ").forEach(function (n) {
              c.addEventListener(n, function (n) {
                return t.el.dispatchEvent(Object(T.d)(n, e.class));
              });
            });
          }), this._toggleEffects(1), n.trigger("loaded");
        },
        _toggleEffects: function _toggleEffects(t) {
          (t ? s.u : s.t)(this.getWindow(), "".concat(T.i, " resize"), this._emitUpdate);
        },
        _emitUpdate: function _emitUpdate() {
          this.model._emitUpdated();
        }
      }),
      M = n(17);
    function A(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function L(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? A(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : A(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var N = v.a.View.extend({
        events: {
          "click [data-action-remove]": "remove",
          "mousedown [data-action-move]": "startDrag"
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          Object(l.bindAll)(this, "onScroll", "frameLoaded", "updateOffset", "remove", "startDrag");
          var n = this.model,
            r = L(L({}, t.config || e), {}, {
              frameWrapView: this
            }),
            i = r.canvasView,
            o = r.em;
          this.cv = i, this.config = r, this.em = o, this.canvas = o && o.get("Canvas"), this.ppfx = r.pStylePrefix || "", this.frame = new D({
            model: n,
            config: r
          }), this.classAnim = "".concat(this.ppfx, "frame-wrapper--anim"), this.listenTo(n, "loaded", this.frameLoaded), this.listenTo(n, "change:x change:y", this.updatePos), this.listenTo(n, "change:width change:height", this.updateSize), this.updatePos(), this.setupDragger();
        },
        setupDragger: function setupDragger() {
          var t,
            e,
            n,
            r = this,
            i = this.canvas,
            o = this.model,
            a = function a(t) {
              i.toggleFramesEvents(t);
            };
          this.dragger = new M.a({
            onStart: function onStart() {
              var i = o.attributes,
                s = i.x,
                l = i.y;
              n = r.em.getZoomMultiplier(), t = s, e = l, a();
            },
            onEnd: function onEnd() {
              return a(1);
            },
            setPosition: function setPosition(r) {
              o.set({
                x: t + r.x * n,
                y: e + r.y * n
              });
            }
          });
        },
        startDrag: function startDrag(t) {
          t && this.dragger.start(t);
        },
        remove: function remove() {
          return v.a.View.prototype.remove.apply(this, arguments), this.frame.remove(), this;
        },
        updateOffset: Object(l.debounce)(function () {
          var t = this.em,
            e = this.$el,
            n = this.frame;
          t.runDefault({
            preserveSelected: 1
          }), e.removeClass(this.classAnim), n.model._emitUpdated();
        }),
        updatePos: function updatePos(t) {
          var e = this.model,
            n = this.el,
            r = e.attributes,
            i = r.x,
            o = r.y,
            a = n.style;
          this.frame.rect = 0, a.left = isNaN(i) ? i : "".concat(i, "px"), a.top = isNaN(o) ? o : "".concat(o, "px"), t && this.updateOffset();
        },
        updateSize: Object(l.debounce)(function () {
          this.updateDim();
        }),
        updateDim: function updateDim() {
          var t = this.em,
            e = this.el,
            n = this.$el,
            r = this.model,
            i = this.classAnim,
            o = r.attributes,
            a = o.width,
            s = o.height,
            c = e.style,
            u = c.width || "",
            d = c.height || "",
            h = a || "",
            f = s || "",
            p = u == h && d == f;
          if (this.frame.rect = 0, n.addClass(i), c.width = Object(l.isNumber)(h) ? "".concat(h).concat("px") : h, c.height = Object(l.isNumber)(f) ? "".concat(f).concat("px") : f, Object(l.isNull)(a) || Object(l.isNull)(s)) {
            var g = L(L({}, a ? {} : {
              width: e.offsetWidth
            }), s ? {} : {
              height: e.offsetHeight
            });
            r.set(g, {
              silent: 1
            });
          }
          t.stopDefault({
            preserveSelected: 1
          }), p ? this.updateOffset() : n.one(T.i, this.updateOffset);
        },
        onScroll: function onScroll() {
          var t = this.frame;
          this.em.trigger("frame:scroll", {
            frame: t,
            body: t.getBody(),
            target: t.getWindow()
          });
        },
        frameLoaded: function frameLoaded() {
          this.frame.getWindow().onscroll = this.onScroll, this.updateDim();
        },
        render: function render() {
          var t = this.frame,
            e = this.$el,
            n = this.ppfx,
            r = this.cv,
            i = this.model,
            o = this.el,
            a = i.attributes.onRender;
          t.render(), e.empty().attr({
            class: "".concat(n, "frame-wrapper")
          }).append('\n      <div class="'.concat(n, 'frame-wrapper__top gjs-two-color" data-frame-top>\n        <div class="').concat(n, 'frame-wrapper__name" data-action-move>\n          ').concat(i.get("name") || "", '\n        </div>\n        <div class="').concat(n, 'frame-wrapper__top-r">\n          <div class="').concat(n, 'frame-wrapper__icon" data-action-remove style="display: none">\n            <svg viewBox="0 0 24 24"><path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z"></path></svg>\n          </div>\n        </div>\n      </div>\n      <div class="').concat(n, 'frame-wrapper__right" data-frame-right></div>\n      <div class="').concat(n, 'frame-wrapper__left" data-frame-left></div>\n      <div class="').concat(n, 'frame-wrapper__bottom" data-frame-bottom></div>\n      ')).append(t.el), console.log("Create div element frame");
          var s = Object(T.e)("div", {
            class: "".concat(n, "tools"),
            style: "pointer-events:none; opacity: 0"
          }, '\n      <div class="'.concat(n, 'highlighter" data-hl></div>\n      <div class="').concat(n, 'badge" data-badge></div>\n      <div class="').concat(n, 'placeholder">\n        <div class="').concat(n, 'placeholder-int"></div>\n      </div>\n      <div class="').concat(n, 'ghost"></div>\n      <div class="').concat(n, 'toolbar" style="pointer-events:all"></div>\n      <div class="').concat(n, 'resizer"></div>\n      <div class="').concat(n, 'offset-v" data-offset>\n        <div class="gjs-marginName" data-offset-m>\n          <div class="gjs-margin-v-el gjs-margin-v-top" data-offset-m-t></div>\n          <div class="gjs-margin-v-el gjs-margin-v-bottom" data-offset-m-b></div>\n          <div class="gjs-margin-v-el gjs-margin-v-left" data-offset-m-l></div>\n          <div class="gjs-margin-v-el gjs-margin-v-right" data-offset-m-r></div>\n        </div>\n        <div class="gjs-paddingName" data-offset-m>\n          <div class="gjs-padding-v-el gjs-padding-v-top" data-offset-p-t></div>\n          <div class="gjs-padding-v-el gjs-padding-v-bottom" data-offset-p-b></div>\n          <div class="gjs-padding-v-el gjs-padding-v-left" data-offset-p-l></div>\n          <div class="gjs-padding-v-el gjs-padding-v-right" data-offset-p-r></div>\n        </div>\n      </div>\n      <div class="').concat(n, 'offset-fixed-v"></div>\n    '));
          return this.elTools = s, r.toolsWrapper.appendChild(s), a && a({
            el: o,
            elTop: o.querySelector("[data-frame-top]"),
            elRight: o.querySelector("[data-frame-right]"),
            elBottom: o.querySelector("[data-frame-bottom]"),
            elLeft: o.querySelector("[data-frame-left]"),
            frame: i,
            frameWrapperView: this,
            remove: this.remove,
            startDrag: this.startDrag
          }), this;
        }
      }),
      _ = S.a.extend({
        itemView: N,
        autoAdd: 1,
        init: function init() {
          this.listenTo(this.collection, "reset", this.render);
        },
        onRender: function onRender() {
          var t = this.config,
            e = this.$el,
            n = t.em;
          n && e.attr({
            class: "".concat(n.getConfig("stylePrefix"), "frames")
          });
        }
      });
    function I(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function F(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? I(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var V,
      R = v.a.$,
      z = v.a.View.extend({
        events: {
          wheel: "onWheel"
        },
        template: function template() {
          var t = this.pfx;
          return '\n      <div class="'.concat(t, 'canvas__frames" data-frames></div>\n      <div id="').concat(t, 'tools" class="').concat(t, 'canvas__tools" data-tools></div>\n    ');
        },
        initialize: function initialize(t) {
          Object(l.bindAll)(this, "clearOff", "onKeyPress", "onCanvasMove"), Object(s.u)(window, "scroll resize", this.clearOff);
          var e = this.model,
            n = e.get("frames");
          this.config = t.config || {}, this.em = this.config.em || {}, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.className = this.config.stylePrefix + "canvas";
          var r = this.em,
            i = this.config;
          this.frames = new _({
            collection: n,
            config: F(F({}, i), {}, {
              canvasView: this,
              renderContent: 1
            })
          }), this.listenTo(r, "change:canvasOffset", this.clearOff), this.listenTo(r, "component:selected", this.checkSelected), this.listenTo(e, "change:zoom change:x change:y", this.updateFrames), this.listenTo(n, "loaded:all", function () {
            return r.trigger("loaded");
          }), this.toggleListeners(1);
        },
        checkSelected: function checkSelected(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = e.scroll,
            r = this.em.get("currentFrame");
          n && t.views.forEach(function (t) {
            t._getFrame() !== r && t.scrollIntoView(n);
          });
        },
        remove: function remove() {
          v.a.View.prototype.remove.apply(this, arguments), this.toggleListeners();
        },
        preventDefault: function preventDefault(t) {
          t && (t.preventDefault(), t._parentEvent && t._parentEvent.preventDefault());
        },
        onCanvasMove: function onCanvasMove(t) {},
        toggleListeners: function toggleListeners(t) {
          this.el;
          (t ? s.u : s.t)(document, "keypress", this.onKeyPress);
        },
        onKeyPress: function onKeyPress(t) {
          var e = this.em;
          " " !== Object(s.f)(t) || 1 === e.getZoomDecimal() || e.get("Canvas").isInputFocused() || (this.preventDefault(t), e.get("Editor").runCommand("core:canvas-move"));
        },
        onWheel: function onWheel(t) {
          if ((t.ctrlKey || t.metaKey) && this.em.getConfig("multiFrames")) {
            this.preventDefault(t);
            var e = this.model,
              n = Math.max(-1, Math.min(1, t.wheelDelta || -t.detail)),
              r = e.get("zoom");
            e.set("zoom", r + 2 * n);
          }
        },
        updateFrames: function updateFrames(t) {
          var e = this.em,
            n = this.model.attributes,
            r = n.x,
            i = n.y,
            o = this.getZoom(),
            a = {
              preserveSelected: 1
            },
            s = o ? 1 / o : 1;
          this.framesArea.style.transform = "scale(".concat(o, ") translate(").concat(r * s, "px, ").concat(i * s, "px)"), this.clearOff(), e.stopDefault(a), e.trigger("canvas:update", t), V && clearTimeout(V), V = setTimeout(function () {
            return e.runDefault(a);
          }, 300);
        },
        getZoom: function getZoom() {
          return this.em.getZoomDecimal();
        },
        isElInViewport: function isElInViewport(t) {
          var e = Object(s.e)(t),
            n = Object(s.d)(e),
            r = this.getFrameOffset(e),
            i = n.top,
            o = n.left;
          return i >= 0 && o >= 0 && i <= r.height && o <= r.width;
        },
        offset: function offset(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = Object(s.d)(t),
            r = t.ownerDocument.body,
            i = e.noScroll;
          return {
            top: n.top + (i ? 0 : r.scrollTop),
            left: n.left + (i ? 0 : r.scrollLeft),
            width: n.width,
            height: n.height
          };
        },
        clearOff: function clearOff() {
          this.frmOff = null, this.cvsOff = null;
        },
        getFrameOffset: function getFrameOffset(t) {
          if (!this.frmOff || t) {
            var e = this.frame.el,
              n = t ? t.ownerDocument.defaultView.frameElement : e;
            this.frmOff = this.offset(n || e);
          }
          return this.frmOff;
        },
        getCanvasOffset: function getCanvasOffset() {
          return this.cvsOff || (this.cvsOff = this.offset(this.el)), this.cvsOff;
        },
        getElementPos: function getElementPos(t, e) {
          var n = this.getZoom(),
            r = e || {},
            i = this.getFrameOffset(t),
            o = this.getCanvasOffset(),
            a = this.offset(t, e),
            s = r.avoidFrameOffset ? 0 : i.top,
            l = r.avoidFrameOffset ? 0 : i.left;
          return {
            top: a.top * n + s - o.top,
            left: a.left * n + l - o.left,
            height: a.height * n,
            width: a.width * n,
            zoom: n,
            rect: a
          };
        },
        getElementOffsets: function getElementOffsets(t) {
          var e = this;
          if (!t || Object(s.q)(t)) return {};
          var n = {},
            r = window.getComputedStyle(t);
          return ["marginTop", "marginRight", "marginBottom", "marginLeft", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"].forEach(function (t) {
            n[t] = parseFloat(r[t]) * e.getZoom();
          }), n;
        },
        getPosition: function getPosition() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.frame.el.contentDocument;
          if (e) {
            var n = e.body,
              r = this.getZoom(),
              i = this.getFrameOffset(),
              o = this.getCanvasOffset(),
              a = t.noScroll;
            return {
              top: i.top + (a ? 0 : n.scrollTop) * r - o.top,
              left: i.left + (a ? 0 : n.scrollLeft) * r - o.left,
              width: o.width,
              height: o.height
            };
          }
        },
        updateScript: function updateScript(t) {
          var e = t.model,
            n = e.getId();
          t.scriptContainer || (t.scriptContainer = R('<div data-id="'.concat(n, '">')), this.getJsContainer().appendChild(t.scriptContainer.get(0))), t.el.id = n, t.scriptContainer.html("");
          var r = document.createElement("script");
          r.innerHTML = "\n        setTimeout(function() {\n          var item = document.getElementById('".concat(n, "');\n          if (!item) return;\n          (function(){\n            ").concat(e.getScriptString(), ";\n          }.bind(item))()\n        }, 1);"), setTimeout(function () {
            return t.scriptContainer.get(0).appendChild(r);
          }, 0);
        },
        getJsContainer: function getJsContainer(t) {
          var e = this.getFrameView(t);
          return e && e.getJsContainer();
        },
        getFrameView: function getFrameView(t) {
          return t && t._getFrame() || this.em.get("currentFrame");
        },
        render: function render() {
          var t = this.el,
            e = this.$el,
            n = this.ppfx,
            r = this.model,
            i = this.em,
            o = this.frames,
            a = i.get("CssComposer"),
            s = r.get("wrapper");
          e.html(this.template());
          var l = e.find("[data-frames]");
          this.framesArea = l.get(0), this.wrapper = s, s && "function" == typeof s.render && r.get("frame").set({
            wrapper: s,
            root: s.getWrapper(),
            styles: a.getAll()
          });
          var c = e.find("[data-tools]");
          this.toolsWrapper = c.get(0), c.append('\n      <div class="'.concat(n, "tools ").concat(n, 'tools-gl" style="pointer-events:none">\n        <div class="').concat(n, 'placeholder">\n          <div class="').concat(n, 'placeholder-int"></div>\n        </div>\n      </div>\n      <div id="').concat(n, 'tools" style="pointer-events:none">\n        <div class="').concat(n, 'badge"></div>\n        <div class="').concat(n, 'ghost"></div>\n        <div class="').concat(n, 'toolbar" style="pointer-events:all"></div>\n        <div class="').concat(n, 'resizer"></div>\n        <div class="').concat(n, 'offset-v"></div>\n        <div class="').concat(n, 'offset-fixed-v"></div>\n      </div>\n    '));
          var u = t.querySelector("#".concat(n, "tools"));
          this.hlEl = t.querySelector(".".concat(n, "highlighter")), this.badgeEl = t.querySelector(".".concat(n, "badge")), this.placerEl = t.querySelector(".".concat(n, "placeholder")), this.ghostEl = t.querySelector(".".concat(n, "ghost")), this.toolbarEl = t.querySelector(".".concat(n, "toolbar")), this.resizerEl = t.querySelector(".".concat(n, "resizer")), this.offsetEl = t.querySelector(".".concat(n, "offset-v")), this.fixedOffsetEl = t.querySelector(".".concat(n, "offset-fixed-v")), this.toolsGlobEl = t.querySelector(".".concat(n, "tools-gl")), this.toolsEl = u, this.el.className = this.className;
          var d = r.get("frames");
          return d.listenToLoad(), o.render(), i.setCurrentFrame(d.at(0).view), l.append(o.el), this.frame = d.at(0).view, this;
        }
      });
    function H(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function $(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? H(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : H(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    window.requestAnimationFrame, e.default = function () {
      var t,
        e,
        n = {};
      return {
        getCanvasView: function getCanvasView() {
          return e;
        },
        name: "Canvas",
        init: function init() {
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          n = $($($({}, p), r), {}, {
            module: this
          }), this.em = n.em;
          var i = n.pStylePrefix;
          i && (n.stylePrefix = i + n.stylePrefix), t = new C(r), e = new z({
            model: t,
            config: n
          });
          var o = n.em.get("DomComponents");
          return o && this.setWrapper(o), this.model = t, this.startAutoscroll = this.startAutoscroll.bind(this), this.stopAutoscroll = this.stopAutoscroll.bind(this), this;
        },
        getConfig: function getConfig() {
          return n;
        },
        setWrapper: function setWrapper(e) {
          t.set("wrapper", e);
        },
        getElement: function getElement() {
          return e.el;
        },
        getFrame: function getFrame(e) {
          return e ? this.getFrames()[e] : t.get("frame");
        },
        getFrameEl: function getFrameEl() {
          var t = e.frame;
          return t && t.el;
        },
        getFramesEl: function getFramesEl() {
          return e.framesArea;
        },
        getWindow: function getWindow() {
          return this.getFrameEl().contentWindow;
        },
        getDocument: function getDocument() {
          var t = this.getFrameEl();
          return t && t.contentDocument;
        },
        getBody: function getBody() {
          var t = this.getDocument();
          return t && t.body;
        },
        getWrapperEl: function getWrapperEl() {
          var t = this.getBody();
          return t && t.querySelector("#wrapper");
        },
        _getCompFrame: function _getCompFrame(t) {
          return t && t._getFrame();
        },
        _getLocalEl: function _getLocalEl(t, e, n) {
          var r = t,
            i = this._getCompFrame(e);
          return r = i ? i[n]() : r;
        },
        getGlobalToolsEl: function getGlobalToolsEl() {
          return e.toolsGlobEl;
        },
        getToolsEl: function getToolsEl(t) {
          return this._getLocalEl(e.toolsEl, t, "getToolsEl");
        },
        getHighlighter: function getHighlighter(t) {
          return this._getLocalEl(e.hlEl, t, "getHighlighter");
        },
        getBadgeEl: function getBadgeEl(t) {
          return this._getLocalEl(e.badgeEl, t, "getBadgeEl");
        },
        getPlacerEl: function getPlacerEl() {
          return e.placerEl;
        },
        getGhostEl: function getGhostEl() {
          return e.ghostEl;
        },
        getToolbarEl: function getToolbarEl() {
          return e.toolbarEl;
        },
        getResizerEl: function getResizerEl() {
          return e.resizerEl;
        },
        getOffsetViewerEl: function getOffsetViewerEl(t) {
          return this._getLocalEl(e.offsetEl, t, "getOffsetViewerEl");
        },
        getFixedOffsetViewerEl: function getFixedOffsetViewerEl() {
          return e.fixedOffsetEl;
        },
        render: function render() {
          return e.render().el;
        },
        getOffset: function getOffset() {
          var t = this.offset(this.getFrameEl()),
            e = this.offset(this.getElement());
          return {
            top: t.top - e.top,
            left: t.left - e.left
          };
        },
        offset: function offset(t) {
          return e.offset(t);
        },
        setCustomBadgeLabel: function setCustomBadgeLabel(t) {
          n.customBadgeLabel = t;
        },
        getElementPos: function getElementPos(t, n) {
          return e.getElementPos(t, n);
        },
        getElementOffsets: function getElementOffsets(t) {
          return e.getElementOffsets(t);
        },
        getRect: function getRect() {
          var t = e.getPosition(),
            n = t.top,
            r = t.left;
          return $($({}, e.getCanvasOffset()), {}, {
            topScroll: n,
            leftScroll: r
          });
        },
        getTargetToElementDim: function getTargetToElementDim(t, r) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = i || {},
            a = e.getPosition();
          if (a) {
            var s = o.elPos || e.getElementPos(r),
              l = i.toRight || 0,
              c = o.targetHeight || t.offsetHeight,
              u = o.targetWidth || t.offsetWidth,
              d = o.event || null,
              h = s.top - c,
              f = s.left;
            f += l ? s.width : 0;
            var p = (f = l ? f - u : f) < a.left ? a.left : f,
              g = h < a.top ? a.top : h,
              v = {
                top: g = g > s.top + s.height ? s.top + s.height : g,
                left: p,
                elementTop: s.top,
                elementLeft: s.left,
                elementWidth: s.width,
                elementHeight: s.height,
                targetWidth: t.offsetWidth,
                targetHeight: t.offsetHeight,
                canvasTop: a.top,
                canvasLeft: a.left,
                canvasWidth: a.width,
                canvasHeight: a.height
              };
            return d && n.em && n.em.trigger(d, v), v;
          }
        },
        canvasRectOffset: function canvasRectOffset(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = function i(t) {
              var e = t.defaultView;
              return e && e.frameElement;
            },
            o = function o(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                o = arguments.length > 2 ? arguments[2] : void 0,
                a = n.em.getZoomDecimal(),
                s = e ? "top" : "left",
                l = t.ownerDocument,
                c = r.offset ? i(l) : {},
                u = c.offsetTop,
                d = void 0 === u ? 0 : u,
                h = c.offsetLeft,
                f = void 0 === h ? 0 : h,
                p = l.body || {},
                g = p.scrollTop,
                v = void 0 === g ? 0 : g,
                m = p.scrollLeft,
                b = void 0 === m ? 0 : m,
                y = e ? v : b,
                w = e ? d : f;
              return o[s] - (y - w) * a;
            };
          return {
            top: o(t, 1, e),
            left: o(t, 0, e)
          };
        },
        getTargetToElementFixed: function getTargetToElementFixed(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = n.pos || this.getElementPos(t),
            i = n.canvasOff || this.canvasRectOffset(t, r),
            o = e.offsetHeight || 0,
            a = e.offsetWidth || 0,
            s = r.left + r.width,
            l = this.getCanvasView(),
            c = l.getPosition(),
            u = l.getFrameOffset(t),
            d = n.event,
            h = -o,
            f = r.width - a;
          f = r.left < -f ? -r.left : f, f = s > c.width ? f - (s - c.width) : f;
          var p = r.height + o,
            g = p < u.height;
          i.top < o && (g ? h += p : h = -i.top < r.height ? -i.top : r.height);
          var v = {
            top: h,
            left: f,
            canvasOffsetTop: i.top,
            canvasOffsetLeft: i.left
          };
          return d && this.em.trigger(d, v), v;
        },
        getMouseRelativePos: function getMouseRelativePos(t, e) {
          var n = 0,
            r = 0,
            i = (e || {}).subWinOffset,
            o = t.target.ownerDocument,
            a = o.defaultView || o.parentWindow,
            s = a.frameElement,
            l = i ? a.pageYOffset : 0,
            c = i ? a.pageXOffset : 0;
          if (s) {
            var u = s.getBoundingClientRect();
            n = u.top || 0, r = u.left || 0;
          }
          return {
            y: t.clientY + n - l,
            x: t.clientX + r - c
          };
        },
        getMouseRelativeCanvas: function getMouseRelativeCanvas(t, n) {
          var r = this.getZoomDecimal(),
            i = e.getPosition(n),
            o = i.top,
            a = i.left;
          return {
            y: t.clientY * r + o,
            x: t.clientX * r + a
          };
        },
        hasFocus: function hasFocus() {
          return this.getDocument().hasFocus();
        },
        isInputFocused: function isInputFocused() {
          var t = this.getDocument(),
            e = this.getFrameEl(),
            n = ["body"].concat(i()(this.getConfig().notTextable)),
            r = e && document.activeElement === e ? t && t.activeElement : document.activeElement;
          return r && !n.some(function (t) {
            return r.matches(t);
          });
        },
        scrollTo: function scrollTo(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = Object(s.e)(t),
            r = n && Object(s.j)(n);
          r && r.scrollIntoView(e);
        },
        startAutoscroll: function startAutoscroll(t) {
          var e = t && t.view || this.em.getCurrentFrame();
          e && e.startAutoscroll();
        },
        stopAutoscroll: function stopAutoscroll(t) {
          var e = t && t.view || this.em.getCurrentFrame();
          e && e.stopAutoscroll();
        },
        postRender: function postRender() {
          Object(s.k)(n.em) && (this.droppable = new f(n.em));
        },
        setZoom: function setZoom(e) {
          return t.set("zoom", parseFloat(e)), this;
        },
        getZoom: function getZoom() {
          return parseFloat(t.get("zoom"));
        },
        getZoomDecimal: function getZoomDecimal() {
          return this.getZoom() / 100;
        },
        getZoomMultiplier: function getZoomMultiplier() {
          var t = this.getZoomDecimal();
          return t ? 1 / t : 1;
        },
        toggleFramesEvents: function toggleFramesEvents(t) {
          this.getFramesEl().style.pointerEvents = t ? "" : "none";
        },
        getFrameWrapperEl: function getFrameWrapperEl() {
          return e.frame.getWrapper();
        },
        getFrames: function getFrames() {
          return t.get("frames").map(function (t) {
            return t;
          });
        },
        addFrame: function addFrame() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return t.get("frames").add($({}, e), $($({}, n), {}, {
            em: this.em
          }));
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(11),
      a = {
        stylePrefix: "gjs-",
        components: "",
        style: "",
        fromElement: 0,
        noticeOnUnload: !0,
        showOffsets: !1,
        showOffsetsSelected: !1,
        forceClass: !0,
        height: "900px",
        width: "100%",
        log: ["warning", "error"],
        baseCss: "\n    * {\n      box-sizing: border-box;\n    }\n    html, body, [data-gjs-type=wrapper] {\n      min-height: 100%;\n    }\n    body {\n      margin: 0;\n      height: 100%;\n      background-color: #fff\n    }\n    [data-gjs-type=wrapper] {\n      overflow: auto;\n      overflow-x: hidden;\n    }\n\n    * ::-webkit-scrollbar-track {\n      background: rgba(0, 0, 0, 0.1)\n    }\n\n    * ::-webkit-scrollbar-thumb {\n      background: rgba(255, 255, 255, 0.2)\n    }\n\n    * ::-webkit-scrollbar {\n      width: 10px\n    }\n  ",
        protectedCss: "* { box-sizing: border-box; } body {margin: 0;}",
        canvasCss: "",
        defaultCommand: "select-comp",
        showToolbar: 1,
        allowScripts: 0,
        showDevices: 1,
        devicePreviewMode: 0,
        mediaCondition: "max-width",
        tagVarStart: "{[ ",
        tagVarEnd: " ]}",
        keepEmptyTextNodes: 0,
        jsInHtml: !0,
        nativeDnD: 1,
        multipleSelection: 1,
        exportWrapper: 0,
        wrapperIsBody: 1,
        avoidInlineStyle: 1,
        avoidDefaults: 1,
        clearStyles: 0,
        dragMode: 0,
        listenToEl: [],
        cssIcons: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css",
        el: "",
        i18n: {},
        undoManager: {},
        assetManager: {},
        canvas: {},
        layers: {},
        storageManager: {},
        richTextEditor: {},
        domComponents: {},
        modal: {},
        popover: {},
        codeManager: {},
        panels: {},
        commands: {},
        cssComposer: {},
        selectorManager: {},
        deviceManager: {
          devices: [{
            id: "desktop",
            name: "Desktop",
            width: ""
          }, {
            id: "tablet",
            name: "Tablet",
            width: "768px",
            widthMedia: "992px"
          }, {
            id: "mobileLandscape",
            name: "Mobile landscape",
            width: "568px",
            widthMedia: "768px"
          }, {
            id: "mobilePortrait",
            name: "Mobile portrait",
            width: "320px",
            widthMedia: "480px"
          }]
        },
        styleManager: {
          sectors: [{
            name: "General",
            open: !1,
            buildProps: ["float", "display", "position", "top", "right", "left", "bottom"]
          }, {
            name: "Flex",
            open: !1,
            buildProps: ["flex-direction", "flex-wrap", "justify-content", "align-items", "align-content", "order", "flex-basis", "flex-grow", "flex-shrink", "align-self"]
          }, {
            name: "Dimension",
            open: !1,
            buildProps: ["width", "height", "max-width", "min-height", "margin", "padding"]
          }, {
            name: "Typography",
            open: !1,
            buildProps: ["font-family", "font-size", "font-weight", "letter-spacing", "color", "line-height", "text-align", "text-shadow"],
            properties: [{
              property: "text-align",
              list: [{
                value: "left",
                className: "fa fa-align-left"
              }, {
                value: "center",
                className: "fa fa-align-center"
              }, {
                value: "right",
                className: "fa fa-align-right"
              }, {
                value: "justify",
                className: "fa fa-align-justify"
              }]
            }]
          }, {
            name: "Decorations",
            open: !1,
            buildProps: ["border-radius-c", "background-color", "border-radius", "border", "box-shadow", "background"]
          }, {
            name: "Extra",
            open: !1,
            buildProps: ["transition", "perspective", "transform"]
          }]
        },
        blockManager: {},
        traitManager: {},
        textViewCode: "Code",
        keepUnusedStyles: 0,
        multiFrames: 0
      },
      s = n(0),
      l = n(1),
      c = n.n(l),
      u = n(3);
    function d(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function h(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? d(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    c.a.$ = o.default;
    var f,
      p,
      g = [n(115), n(116), n(85), n(86), n(110), n(109), n(111), n(112), n(107), n(113), n(114), n(108), n(106), n(117), n(103), n(118), n(104), n(100), n(75), n(101), n(119), n(105)],
      v = c.a.Collection;
    !function (t) {
      var e = t.$;
      if (e && "jQuery" !== e.prototype.constructor.name) {
        var n = e.fn;
        n.hide = function () {
          return this.css("display", "none");
        }, n.show = function () {
          return this.css("display", "block");
        }, n.focus = function () {
          var t = this.get(0);
          return t && t.focus(), this;
        }, n.bind = function (t, e) {
          return this.on(t, e);
        }, n.unbind = function (t, e) {
          if (Object(s.isObject)(t)) {
            for (var n in t) t.hasOwnProperty(n) && this.off(n, t[n]);
            return this;
          }
          return this.off(t, e);
        }, n.click = function (t) {
          return t ? this.on("click", t) : this.trigger("click");
        }, n.change = function (t) {
          return t ? this.on("change", t) : this.trigger("change");
        }, n.keydown = function (t) {
          return t ? this.on("keydown", t) : this.trigger("keydown");
        }, n.delegate = function (t, e, n, r) {
          return r || (r = n), this.on(e, t, function (t) {
            t.data = n, r(t);
          });
        }, n.scrollLeft = function () {
          var t = this.get(0),
            e = (t = 9 == t.nodeType ? t.defaultView : t) instanceof Window ? t : null;
          return e ? e.pageXOffset : t.scrollLeft || 0;
        }, n.scrollTop = function () {
          var t = this.get(0),
            e = (t = 9 == t.nodeType ? t.defaultView : t) instanceof Window ? t : null;
          return e ? e.pageYOffset : t.scrollTop || 0;
        };
        var r = e.prototype.offset;
        n.offset = function (t) {
          var e, n;
          return t && (e = t.top, n = t.left), void 0 !== e && this.css("top", "".concat(e, "px")), void 0 !== n && this.css("left", "".concat(n, "px")), r.call(this);
        }, e.map = function (t, e) {
          for (var n = [], r = 0; r < t.length; r++) n.push(e(t[r], r));
          return n;
        };
        var i = Array.prototype.indexOf;
        e.inArray = function (t, e, n) {
          return null == e ? -1 : i.call(e, t, n);
        }, e.Event = function (t, n) {
          if (!(this instanceof e.Event)) return new e.Event(t, n);
          this.type = t, this.isDefaultPrevented = function () {
            return !1;
          };
        };
      }
    }({
      Backbone: c.a,
      $: c.a.$
    });
    var m = {
        debug: console.log,
        info: console.info,
        warning: console.warn,
        error: console.error
      },
      b = c.a.Model.extend({
        defaults: function defaults() {
          return {
            editing: 0,
            selected: new v(),
            clipboard: null,
            dmode: 0,
            componentHovered: null,
            previousModel: null,
            changesCount: 0,
            storables: [],
            modules: [],
            toLoad: [],
            opened: {},
            device: ""
          };
        },
        initialize: function initialize() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.config = e, this.set("Config", e), this.set("modules", []), this.set("toLoad", []), this.set("storables", []), this.set("selected", new v()), this.set("dmode", e.dragMode);
          var n = e.el,
            r = e.log,
            i = !0 === r ? Object(s.keys)(m) : Object(s.isArray)(r) ? r : [];
          Object(s.bindAll)(this, "initBaseColorPicker"), n && e.fromElement && (this.config.components = n.innerHTML), this.attrsOrig = n ? Object(s.toArray)(n.attributes).reduce(function (t, e) {
            return t[e.nodeName] = e.nodeValue, t;
          }, {}) : "", g.forEach(function (e) {
            return t.loadModule(e);
          }), this.on("change:componentHovered", this.componentHovered, this), this.on("change:changesCount", this.updateChanges, this), i.forEach(function (e) {
            return t.listenLog(e);
          }), [{
            from: "change:selectedComponent",
            to: "component:toggled"
          }].forEach(function (e) {
            var n = e.from,
              r = e.to;
            t.listenTo(t, n, function () {
              for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
              t.trigger.apply(t, [r].concat(i)), t.logWarning("The event '".concat(n, "' is deprecated, replace it with '").concat(r, "'"));
            });
          });
        },
        getContainer: function getContainer() {
          return this.config.el;
        },
        listenLog: function listenLog(t) {
          this.listenTo(this, "log:".concat(t), m[t]);
        },
        getConfig: function getConfig(t) {
          var e = this.config;
          return Object(s.isUndefined)(t) ? e : e[t];
        },
        loadOnStart: function loadOnStart() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
            n = this.get("StorageManager");
          this.get("toLoad").forEach(function (t) {
            t.onLoad();
          });
          var r = function r() {
            var n = t.get("modules");
            n && n.forEach(function (e) {
              return e.postLoad && e.postLoad(t);
            }), e && e();
          };
          n && n.canAutoload() ? this.load(r) : r();
        },
        updateChanges: function updateChanges() {
          var t = this,
            e = this.get("StorageManager"),
            n = this.get("changesCount");
          p && clearTimeout(p), p = setTimeout(function () {
            return t.trigger("update");
          });
          var r = document.querySelector(".btn-save");
          n ? r.classList.add("text-warning") : r.classList.remove("text-warning"), this.config.noticeOnUnload && (window.onbeforeunload = n ? function (t) {
            return 1;
          } : null), e.isAutosave() && n >= e.getStepsBeforeSave() && this.store();
        },
        loadModule: function loadModule(t) {
          var e = this.config,
            n = new (t.default || t)(),
            r = n.name.charAt(0).toLowerCase() + n.name.slice(1),
            i = Object(s.isUndefined)(e[r]) ? e[n.name] : e[r],
            o = i || {},
            a = this.get("StorageManager");
          if (o.pStylePrefix = e.pStylePrefix || "", Object(s.isUndefined)(i) || i || (o._disable = 1), n.storageKey && n.store && n.load && a) {
            o.stm = a;
            var l = "domComponents" == r ? "unshift" : "push";
            this.get("storables")[l](n);
          }
          return o.em = this, n.init(h({}, o)), !n.private && this.set(n.name, n), n.onLoad && this.get("toLoad").push(n), this.get("modules").push(n), this;
        },
        init: function init(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.destroyed && (this.initialize(e), this.destroyed = 0), this.set("Editor", t);
        },
        getEditor: function getEditor() {
          return this.get("Editor");
        },
        handleUpdates: function handleUpdates(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          r.temporary || (f && clearInterval(f), f = setTimeout(function () {
            r.avoidStore || n.set("changesCount", n.get("changesCount") + 1, r);
          }, 0));
        },
        componentHovered: function componentHovered(t, e, n) {
          var r = this.previous("componentHovered");
          r && this.trigger("component:unhovered", r, n), e && this.trigger("component:hovered", e, n);
        },
        getSelected: function getSelected() {
          return this.get("selected").last();
        },
        getSelectedAll: function getSelectedAll() {
          var t = this.get("selected");
          return t && t.models || [];
        },
        setSelected: function setSelected(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = Object(s.isArray)(t),
            i = r ? t : [t],
            a = this.get("selected");
          r && this.removeSelected(a.filter(function (t) {
            return !Object(s.contains)(i, t);
          })), i.forEach(function (t) {
            var i = Object(u.g)(t, o.default);
            i && !i.get("selectable") || (!r && e.removeSelected(a.filter(function (t) {
              return t !== i;
            })), e.addSelected(i, n), i);
          });
        },
        addSelected: function addSelected(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = Object(u.g)(t, o.default),
            i = Object(s.isArray)(r) ? r : [r];
          i.forEach(function (t) {
            if (!t || t.get("selectable")) {
              var r = e.get("selected");
              n.forceChange && r.remove(t, n), r.push(t, n);
            }
          });
        },
        removeSelected: function removeSelected(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.get("selected").remove(Object(u.g)(t, o.default), e);
        },
        toggleSelected: function toggleSelected(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = Object(u.g)(t, o.default),
            i = Object(s.isArray)(r) ? r : [r];
          i.forEach(function (t) {
            e.get("selected").contains(t) ? e.removeSelected(t, n) : e.addSelected(t, n);
          });
        },
        setHovered: function setHovered(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = Object(u.g)(t, o.default);
          n && !n.get("hoverable") || (e.forceChange && this.set("componentHovered", ""), this.set("componentHovered", n, e));
        },
        getHovered: function getHovered() {
          return this.get("componentHovered");
        },
        setComponents: function setComponents(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return this.get("DomComponents").setComponents(t, e);
        },
        getComponents: function getComponents() {
          var t = this.get("DomComponents"),
            e = this.get("CodeManager");
          if (t && e) {
            var n = t.getComponents();
            return e.getCode(n, "json");
          }
        },
        setStyle: function setStyle(t) {
          for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.get("CssComposer").getAll(), r = 0, i = n.length; r < i; r++) n.pop();
          return n.add(t, e), this;
        },
        getStyle: function getStyle() {
          return this.get("CssComposer").getAll();
        },
        setState: function setState(t) {
          return this.set("state", t), this;
        },
        getState: function getState() {
          return this.get("state");
        },
        getHtml: function getHtml() {
          var t = this.config,
            e = t.exportWrapper,
            n = t.wrapperIsBody,
            r = t.jsInHtml ? this.getJs() : "",
            i = this.get("DomComponents").getComponent(),
            o = this.get("CodeManager").getCode(i, "html", {
              exportWrapper: e,
              wrapperIsBody: n
            });
          return o += r ? "<script>".concat(r, "<\/script>") : "";
        },
        getCss: function getCss() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.config,
            n = e.wrapperIsBody,
            r = t.avoidProtected,
            i = Object(s.isUndefined)(t.keepUnusedStyles) ? e.keepUnusedStyles : t.keepUnusedStyles,
            o = this.get("CssComposer"),
            a = this.get("DomComponents").getComponent(),
            l = r ? "" : e.protectedCss;
          return l + this.get("CodeManager").getCode(a, "css", {
            cssc: o,
            wrapperIsBody: n,
            keepUnusedStyles: i
          });
        },
        getJs: function getJs() {
          var t = this.get("DomComponents").getWrapper();
          return this.get("CodeManager").getCode(t, "js").trim();
        },
        store: function store(t) {
          var e = this,
            n = this.get("StorageManager"),
            r = {};
          if (n) return this.get("storables").forEach(function (t) {
            var e = t.store(1);
            for (var n in e) r[n] = e[n];
          }), n.store(r, function (n) {
            t && t(n), e.set("changesCount", 0), e.trigger("storage:store", r);
          }), r;
        },
        load: function load() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
          this.getCacheLoad(1, function (n) {
            t.get("storables") && t.get("storables").forEach(function (e) {
              e.load(n), e.postLoad && e.postLoad(t);
            }), e && e(n);
          });
        },
        getCacheLoad: function getCacheLoad(t, e) {
          var n = this;
          if (this.cacheLoad && !t) return this.cacheLoad;
          var r = this.get("StorageManager"),
            i = [];
          if (!r) return {};
          this.get("storables").forEach(function (t) {
            var e = t.storageKey;
            e = Object(s.isFunction)(e) ? e() : e, (Object(s.isArray)(e) ? e : [e]).forEach(function (t) {
              return i.push(t);
            });
          }), r.load(i, function (t) {
            n.cacheLoad = t, e && e(t), setTimeout(function () {
              return n.trigger("storage:load", t);
            });
          });
        },
        getDeviceModel: function getDeviceModel() {
          var t = this.get("device");
          return this.get("DeviceManager").get(t);
        },
        runDefault: function runDefault() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.get("Commands").get(this.config.defaultCommand);
          e && !this.defaultRunning && (e.stop(this, this, t), e.run(this, this, t), this.defaultRunning = 1);
        },
        stopDefault: function stopDefault() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.get("Commands"),
            n = e.get(this.config.defaultCommand);
          n && (n.stop(this, this, t), this.defaultRunning = 0);
        },
        refreshCanvas: function refreshCanvas() {
          this.set("canvasOffset", null), this.set("canvasOffset", this.get("Canvas").getOffset());
        },
        clearSelection: function clearSelection(t) {
          (t || window).getSelection().removeAllRanges();
        },
        getCurrentMedia: function getCurrentMedia() {
          var t = this.config,
            e = this.getDeviceModel(),
            n = t.mediaCondition,
            r = t.devicePreviewMode,
            i = e && e.get("widthMedia");
          return e && i && !r ? "(".concat(n, ": ").concat(i, ")") : "";
        },
        getWrapper: function getWrapper() {
          return this.get("DomComponents").getWrapper();
        },
        setCurrentFrame: function setCurrentFrame(t) {
          return this.set("currentFrame", t);
        },
        getCurrentFrame: function getCurrentFrame() {
          return this.get("currentFrame");
        },
        getCurrentFrameModel: function getCurrentFrameModel() {
          return (this.getCurrentFrame() || {}).model;
        },
        getDirtyCount: function getDirtyCount() {
          return this.get("changesCount");
        },
        getZoomDecimal: function getZoomDecimal() {
          return this.get("Canvas").getZoomDecimal();
        },
        getZoomMultiplier: function getZoomMultiplier() {
          return this.get("Canvas").getZoomMultiplier();
        },
        setDragMode: function setDragMode(t) {
          return this.set("dmode", t);
        },
        t: function t() {
          var t;
          return (t = this.get("I18n")).t.apply(t, arguments);
        },
        inAbsoluteMode: function inAbsoluteMode() {
          return "absolute" === this.get("dmode");
        },
        destroyAll: function destroyAll() {
          var t = this.config,
            e = this.getEditor(),
            n = (t.grapesjs || {}).editors,
            r = void 0 === n ? [] : n,
            i = this.attributes,
            a = i.DomComponents,
            s = i.CssComposer,
            l = i.UndoManager,
            c = i.Panels,
            u = i.Canvas,
            d = i.Keymaps,
            h = i.RichTextEditor;
          this.stopDefault(), a.clear(), s.clear(), l.clear().removeAll(), c.getPanels().reset(), u.getCanvasView().remove(), d.removeAll(), h.destroy(), this.view.remove(), this.stopListening(), this.clear({
            silent: !0
          }), this.destroyed = 1, r.splice(r.indexOf(e), 1), Object(o.default)(t.el).empty().attr(this.attrsOrig);
        },
        setEditing: function setEditing(t) {
          return this.set("editing", t), this;
        },
        isEditing: function isEditing() {
          return !!this.get("editing");
        },
        log: function log(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = e.ns,
            r = e.level,
            i = void 0 === r ? "debug" : r;
          if (this.trigger("log", t, e), i && this.trigger("log:".concat(i), t, e), n) {
            var o = "log-".concat(n);
            this.trigger(o, t, e), i && this.trigger("".concat(o, ":").concat(i), t, e);
          }
        },
        logInfo: function logInfo(t, e) {
          this.log(t, h(h({}, e), {}, {
            level: "info"
          }));
        },
        logWarning: function logWarning(t, e) {
          this.log(t, h(h({}, e), {}, {
            level: "warning"
          }));
        },
        logError: function logError(t, e) {
          this.log(t, h(h({}, e), {}, {
            level: "error"
          }));
        },
        initBaseColorPicker: function initBaseColorPicker(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.getConfig(),
            r = n.colorPicker,
            i = void 0 === r ? {} : r,
            a = n.el,
            s = n.stylePrefix;
          return Object(o.default)(t).spectrum(h(h({
            containerClassName: "".concat(s, "one-bg ").concat(s, "two-color"),
            appendTo: a || "body",
            maxSelectionSize: 8,
            showPalette: !0,
            palette: [],
            showAlpha: !0,
            chooseText: "Ok",
            cancelText: "⨯"
          }, e), i));
        },
        data: function data(t, e, n) {
          if (t["_gjs-data"] || (t["_gjs-data"] = {}), Object(s.isUndefined)(n)) return t["_gjs-data"][e];
          t["_gjs-data"][e] = n;
        }
      }),
      y = c.a.$,
      w = c.a.View.extend({
        initialize: function initialize() {
          var t = this,
            e = this.model;
          e.view = this, this.conf = e.config, this.pn = e.get("Panels"), this.cv = e.get("Canvas"), e.on("loaded", function () {
            t.pn.active(), t.pn.disableButtons(), setTimeout(function () {
              e.runDefault(), e.trigger("load", e.get("Editor"));
            });
          });
        },
        render: function render() {
          this.model;
          var t = this.$el,
            e = this.conf,
            n = e.stylePrefix,
            r = y(e.el || "body ".concat(e.container));
          return Object(u.a)(e.cssIcons, {
            unique: 1,
            prepand: 1
          }), t.empty(), e.width && r.css("width", e.width), e.height && r.css("height", e.height), t.append(this.cv.render()), t.append(this.pn.render()), t.attr("class", "".concat(n, "editor ").concat(n, "one-bg ").concat(n, "two-color")), r.addClass("".concat(n, "editor-cont")).empty().append(t), this;
        }
      });
    function x(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function O(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? x(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var C = function C() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = O(O({}, a), t);
        e.pStylePrefix = e.stylePrefix;
        var n = new b(e),
          r = new w({
            model: n,
            config: e
          });
        return {
          $: o.default,
          editor: n,
          init: function init() {
            var t = this,
              i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return n.init(this, O(O({}, e), i)), ["I18n", "Utils", "Config", "Commands", "Keymaps", "Modal", "Popover", "Panels", "Canvas", "Parser", "CodeManager", "UndoManager", "RichTextEditor", "DomComponents", ["Components", "DomComponents"], "LayerManager", ["Layers", "LayerManager"], "CssComposer", ["Css", "CssComposer"], "StorageManager", ["Storage", "StorageManager"], "AssetManager", ["Assets", "AssetManager"], "BlockManager", ["Blocks", "BlockManager"], "TraitManager", ["Traits", "TraitManager"], "SelectorManager", ["Selectors", "SelectorManager"], "StyleManager", ["Styles", "StyleManager"], "DeviceManager", ["Devices", "DeviceManager"]].forEach(function (e) {
              Array.isArray(e) ? t[e[0]] = n.get(e[1]) : t[e] = n.get(e);
            }), n.on("loaded", function () {
              t.UndoManager.clear(), n.get("modules").forEach(function (t) {
                t.postRender && t.postRender(r);
              });
            }), this;
          },
          getConfig: function getConfig(t) {
            return n.getConfig(t);
          },
          getHtml: function getHtml(t) {
            return n.getHtml(t);
          },
          getCss: function getCss(t) {
            return n.getCss(t);
          },
          getJs: function getJs() {
            return n.getJs();
          },
          getComponents: function getComponents() {
            return n.get("DomComponents").getComponents();
          },
          getWrapper: function getWrapper() {
            return n.get("DomComponents").getWrapper();
          },
          setComponents: function setComponents(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return n.setComponents(t, e), this;
          },
          addComponents: function addComponents(t, e) {
            return this.getWrapper().append(t, e);
          },
          getStyle: function getStyle() {
            return n.get("CssComposer").getAll();
          },
          setStyle: function setStyle(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return n.setStyle(t, e), this;
          },
          getSelected: function getSelected() {
            return n.getSelected();
          },
          getSelectedAll: function getSelectedAll() {
            return n.getSelectedAll();
          },
          getSelectedToStyle: function getSelectedToStyle() {
            var t = n.getSelected();
            if (t) return this.StyleManager.getModelToStyle(t);
          },
          select: function select(t, e) {
            return n.setSelected(t, e), this;
          },
          selectAdd: function selectAdd(t) {
            return n.addSelected(t), this;
          },
          selectRemove: function selectRemove(t) {
            return n.removeSelected(t), this;
          },
          selectToggle: function selectToggle(t) {
            return n.toggleSelected(t), this;
          },
          setDevice: function setDevice(t) {
            return n.set("device", t), this;
          },
          getDevice: function getDevice() {
            return n.get("device");
          },
          runCommand: function runCommand(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return n.get("Commands").run(t, e);
          },
          stopCommand: function stopCommand(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return n.get("Commands").stop(t, e);
          },
          store: function store(t) {
            return n.store(t);
          },
          load: function load(t) {
            return n.load(t);
          },
          getContainer: function getContainer() {
            return e.el;
          },
          getDirtyCount: function getDirtyCount() {
            return n.getDirtyCount();
          },
          refresh: function refresh() {
            n.refreshCanvas();
          },
          setCustomRte: function setCustomRte(t) {
            this.RichTextEditor.customRte = t;
          },
          setCustomParserCss: function setCustomParserCss(t) {
            return this.Parser.getConfig().parserCss = t, this;
          },
          setDragMode: function setDragMode(t) {
            return n.setDragMode(t), this;
          },
          log: function log(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return n.log(t, e), this;
          },
          t: function t() {
            return n.t.apply(n, arguments);
          },
          on: function on(t, e) {
            return n.on(t, e), this;
          },
          once: function once(t, e) {
            return n.once(t, e), this;
          },
          off: function off(t, e) {
            return n.off(t, e), this;
          },
          trigger: function trigger(t) {
            return n.trigger.apply(n, arguments), this;
          },
          destroy: function destroy() {
            return n.destroyAll();
          },
          getEl: function getEl() {
            return r.el;
          },
          getModel: function getModel() {
            return n;
          },
          render: function render() {
            return r.render(), r.el;
          }
        };
      },
      S = {
        plugins: []
      };
    function k(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function j(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? k(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : k(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    !function () {
      if (function () {
        for (var t, e = window.navigator.userAgent, n = [["edge", /Edge\/([0-9\._]+)/], ["ie", /MSIE\s(7\.0)/], ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/]], r = 0; r < n.length; r++) {
          if (t = n[r][1].exec(e)) break;
        }
        return !!t;
      }()) {
        var t = DOMImplementation.prototype.createHTMLDocument;
        DOMImplementation.prototype.createHTMLDocument = function (e) {
          return e || (e = ""), t.apply(document.implementation, [e]);
        };
      }
    }();
    var T = new function (t) {
        var e = t || {};
        for (var n in S) n in e || (e[n] = S[n]);
        var r = {};
        return {
          add: function add(t, e) {
            return r[t] ? r[t] : (r[t] = e, e);
          },
          get: function get(t) {
            return r[t];
          },
          getAll: function getAll() {
            return r;
          }
        };
      }(),
      P = [],
      E = {
        autorender: 1,
        plugins: [],
        pluginsOpts: {}
      };
    e.default = {
      $: o.default,
      editors: P,
      plugins: T,
      version: "0.1.18",
      init: function init() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.container;
        if (!e) throw new Error("'container' is required");
        (t = j(j(j({}, E), t), {}, {
          grapesjs: this
        })).el = Object(s.isElement)(e) ? e : document.querySelector(e);
        var n = new C(t).init();
        return t.plugins.forEach(function (e) {
          var r = T.get(e),
            i = t.pluginsOpts[e] || {};
          if (!r) {
            var o = window[e];
            r = o && o.default ? o.default : o;
          }
          r ? r(n, i) : Object(s.isFunction)(e) && e(n, i);
        }), n.getModel().loadOnStart(), t.autorender && n.render(), P.push(n), n;
      }
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = {
        assets: [],
        noAssets: "",
        stylePrefix: "am-",
        upload: 0,
        uploadName: "files",
        headers: {},
        params: {},
        credentials: "include",
        multiUpload: !0,
        autoAdd: 1,
        customFetch: "",
        uploadFile: "",
        embedAsBase64: 1,
        handleAdd: "",
        dropzone: 0,
        openAssetsOnDrop: 1,
        dropzoneContent: "",
        beforeUpload: null,
        showUrlInput: !0
      },
      i = n(1),
      o = n.n(i),
      a = n(2),
      s = n.n(a),
      l = o.a.Model.extend({
        idAttribute: "src",
        defaults: {
          type: "",
          src: ""
        },
        getFilename: function getFilename() {
          return this.get("src").split("/").pop();
        },
        getExtension: function getExtension() {
          return this.getFilename().split(".").pop();
        }
      });
    function c(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function u(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? c(Object(n), !0).forEach(function (e) {
          s()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var d = l.extend({
        defaults: u(u({}, l.prototype.defaults), {}, {
          type: "image",
          unitDim: "px",
          height: 0,
          width: 0
        })
      }),
      h = n(0),
      f = o.a.View.extend({
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.options = t, this.collection = t.collection;
          var e = t.config || {};
          this.config = e, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.em = e.em, this.className = this.pfx + "asset", this.listenTo(this.model, "destroy remove", this.remove), this.model.view = this;
          var n = this.init && this.init.bind(this);
          n && n(t);
        },
        template: function template() {
          var t = this.pfx;
          return '\n      <div class="'.concat(t, 'preview-cont">\n        ').concat(this.getPreview(), '\n      </div>\n      <div class="').concat(t, 'meta">\n        ').concat(this.getInfo(), '\n      </div>\n      <div class="').concat(t, 'close" data-toggle="asset-remove">\n        &Cross;\n      </div>\n    ');
        },
        updateTarget: function updateTarget(t) {
          t && t.set && (t.set("attributes", Object(h.clone)(t.get("attributes"))), t.set("src", this.model.get("src")));
        },
        getPreview: function getPreview() {
          return "";
        },
        getInfo: function getInfo() {
          return "";
        },
        render: function render() {
          var t = this.el;
          return t.innerHTML = this.template(this, this.model), t.className = this.className, this;
        }
      }).extend({
        events: {
          "click [data-toggle=asset-remove]": "onRemove",
          click: "onClick",
          dblclick: "onDblClick"
        },
        getPreview: function getPreview() {
          var t = this.pfx,
            e = this.model.get("src");
          return '\n      <div class="'.concat(t, 'preview" style="background-image: url(\'').concat(e, '\');"></div>\n      <div class="').concat(t, "preview-bg ").concat(this.ppfx, 'checker-bg"></div>\n    ');
        },
        getInfo: function getInfo() {
          var t = this.pfx,
            e = this.model,
            n = e.get("name"),
            r = e.get("width"),
            i = e.get("height"),
            o = e.get("unitDim"),
            a = r && i ? "".concat(r, "x").concat(i).concat(o) : "";
          return n = n || e.getFilename(), '\n      <div class="'.concat(t, 'name">').concat(n, '</div>\n      <div class="').concat(t, 'dimensions">').concat(a, "</div>\n    ");
        },
        init: function init(t) {
          var e = this.pfx;
          this.className += " ".concat(e, "asset-image");
        },
        onClick: function onClick() {
          var t = this.config.onClick,
            e = this.model;
          this.collection.trigger("deselectAll"), this.$el.addClass(this.pfx + "highlight"), Object(h.isFunction)(t) ? t(e) : this.updateTarget(this.collection.target);
        },
        onDblClick: function onDblClick() {
          var t = this.em,
            e = this.model,
            n = this.config.onDblClick;
          Object(h.isFunction)(n) ? n(e) : (this.updateTarget(this.collection.target), t && t.get("Modal").close());
          var r = this.collection.onSelect;
          Object(h.isFunction)(r) && r(e);
        },
        onRemove: function onRemove(t) {
          t.stopImmediatePropagation(), this.model.collection.remove(this.model);
        }
      }),
      p = n(30),
      g = o.a.Collection.extend(p.a).extend({
        types: [{
          id: "image",
          model: d,
          view: f,
          isType: function isType(t) {
            return "string" == typeof t ? {
              type: "image",
              src: t
            } : t;
          }
        }]
      }),
      v = n(25),
      m = n.n(v),
      b = ["pfx", "ppfx", "em"],
      y = o.a.View.extend({
        events: {
          submit: "handleSubmit"
        },
        template: function template(t) {
          var e = t.pfx,
            n = t.ppfx,
            r = t.em,
            i = (m()(t, b), "");
          return this.config.showUrlInput && (i = '\n          <form class="'.concat(e, 'add-asset">\n            <div class="').concat(n, "field ").concat(e, 'add-field">\n              <input placeholder="').concat(r && r.t("assetManager.inputPlh"), '"/>\n            </div>\n            <button class="').concat(n, 'btn-prim">').concat(r && r.t("assetManager.addButton"), '</button>\n            <div style="clear:both"></div>\n          </form>\n      ')), '\n    <div class="'.concat(e, 'assets-cont">\n      <div class="').concat(e, 'assets-header">\n        ').concat(i, '\n      </div>\n      <div class="').concat(e, 'assets" data-el="assets"></div>\n      <div style="clear:both"></div>\n    </div>\n    ');
        },
        initialize: function initialize(t) {
          this.options = t, this.config = t.config, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.em = this.config.em;
          var e = this.collection;
          this.listenTo(e, "reset", this.renderAssets), this.listenTo(e, "add", this.addToAsset), this.listenTo(e, "remove", this.removedAsset), this.listenTo(e, "deselectAll", this.deselectAll);
        },
        handleSubmit: function handleSubmit(t) {
          t.preventDefault();
          var e = this.getAddInput(),
            n = e && e.value.trim(),
            r = this.config.handleAdd;
          n && (e.value = "", this.getAssetsEl().scrollTop = 0, r ? r.bind(this)(n) : this.options.globalCollection.add(n, {
            at: 0
          }));
        },
        getAssetsEl: function getAssetsEl() {
          return this.el.querySelector(".".concat(this.pfx, "assets"));
        },
        getAddInput: function getAddInput() {
          return this.inputUrl && this.inputUrl.value || (this.inputUrl = this.el.querySelector(".".concat(this.pfx, "add-asset input"))), this.inputUrl;
        },
        removedAsset: function removedAsset(t) {
          this.collection.length || this.toggleNoAssets();
        },
        addToAsset: function addToAsset(t) {
          1 == this.collection.length && this.toggleNoAssets(1), this.addAsset(t);
        },
        addAsset: function addAsset(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            n = e,
            r = this.collection,
            i = this.config,
            o = new t.typeView({
              model: t,
              collection: r,
              config: i
            }).render().el;
          if (n) n.appendChild(o);else {
            var a = this.getAssetsEl();
            a && a.insertBefore(o, a.firstChild);
          }
          return o;
        },
        toggleNoAssets: function toggleNoAssets(t) {
          var e = this.$el.find(".".concat(this.pfx, "assets"));
          if (t) e.empty();else {
            var n = this.config.noAssets;
            n && e.append(n);
          }
        },
        deselectAll: function deselectAll() {
          var t = this.pfx;
          this.$el.find(".".concat(t, "highlight")).removeClass("".concat(t, "highlight"));
        },
        renderAssets: function renderAssets() {
          var t = this,
            e = document.createDocumentFragment(),
            n = this.$el.find(".".concat(this.pfx, "assets"));
          n.empty(), this.toggleNoAssets(this.collection.length), this.collection.each(function (n) {
            return t.addAsset(n, e);
          }), n.append(e);
        },
        render: function render() {
          var t = this.options.fu.render().el;
          return this.$el.empty(), this.$el.append(t).append(this.template(this)), this.el.className = "".concat(this.ppfx, "asset-manager"), this.renderAssets(), this.rendered = 1, this;
        }
      }),
      w = n(28);
    function x(t, e) {
      var _n3 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
      if (!_n3) {
        if (Array.isArray(t) || (_n3 = function (t, e) {
          if (!t) return;
          if ("string" == typeof t) return O(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          "Object" === n && t.constructor && (n = t.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(t);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return O(t, e);
        }(t)) || e && t && "number" == typeof t.length) {
          _n3 && (t = _n3);
          var r = 0,
            i = function i() {};
          return {
            s: i,
            n: function n() {
              return r >= t.length ? {
                done: !0
              } : {
                done: !1,
                value: t[r++]
              };
            },
            e: function e(t) {
              throw t;
            },
            f: i
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o,
        a = !0,
        s = !1;
      return {
        s: function s() {
          _n3 = _n3.call(t);
        },
        n: function n() {
          var t = _n3.next();
          return a = t.done, t;
        },
        e: function e(t) {
          s = !0, o = t;
        },
        f: function f() {
          try {
            a || null == _n3.return || _n3.return();
          } finally {
            if (s) throw o;
          }
        }
      };
    }
    function O(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
      return r;
    }
    var C = o.a.View.extend({
      template: Object(h.template)('\n  <form>\n    <div id="<%= pfx %>title"><%= title %></div>\n    <input type="file" id="<%= uploadId %>" name="file" accept="*/*" <%= disabled ? \'disabled\' : \'\' %> <%= multiUpload ? \'multiple\' : \'\' %>/>\n    <div style="clear:both;"></div>\n  </form>\n  '),
      events: {},
      initialize: function initialize() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        this.options = t;
        var e = t.config || {};
        this.config = e, this.em = this.config.em, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.target = this.options.globalCollection || {}, this.uploadId = this.pfx + "uploadFile", this.disabled = void 0 !== e.disableUpload ? e.disableUpload : !e.upload && !e.embedAsBase64, this.multiUpload = void 0 === e.multiUpload || e.multiUpload, this.events["change #" + this.uploadId] = "uploadFile";
        var n = e.uploadFile;
        n ? this.uploadFile = n.bind(this) : !e.upload && e.embedAsBase64 && (this.uploadFile = this.constructor.embedAsBase64), this.delegateEvents();
      },
      onUploadStart: function onUploadStart() {
        var t = this.config.em;
        t && t.trigger("asset:upload:start");
      },
      onUploadEnd: function onUploadEnd(t) {
        var e = this.$el,
          n = this.config.em;
        n && n.trigger("asset:upload:end", t);
        var r = e.find("input");
        r && r.val("");
      },
      onUploadError: function onUploadError(t) {
        var e = this.config.em;
        this.onUploadEnd(t), e && e.trigger("asset:upload:error", t);
      },
      onUploadResponse: function onUploadResponse(t, e) {
        var n,
          r = this.config.em,
          i = this.config,
          o = this.target;
        try {
          n = "string" == typeof t ? JSON.parse(t) : t;
        } catch (e) {
          n = t;
        }
        r && r.trigger("asset:upload:response", n), i.autoAdd && o && o.add(n.data, {
          at: 0
        }), this.onUploadEnd(t), e && e(n);
      },
      uploadFile: function uploadFile(t, e) {
        var n = this,
          r = t.dataTransfer ? t.dataTransfer.files : t.target.files,
          i = this.config,
          o = i.beforeUpload;
        if (!1 !== (o && o(r))) {
          var a = new FormData(),
            s = i.params,
            l = i.customFetch;
          for (var c in s) a.append(c, s[c]);
          if (this.multiUpload) for (var u = 0; u < r.length; u++) a.append("".concat(i.uploadName, "[]"), r[u]);else r.length && a.append(i.uploadName, r[0]);
          this.target;
          var d = i.upload,
            h = i.headers;
          if (void 0 === h["X-Requested-With"] && (h["X-Requested-With"] = "XMLHttpRequest"), d) {
            this.onUploadStart();
            var f = {
              method: "post",
              credentials: i.credentials || "include",
              headers: h,
              body: a
            };
            return (l ? l(d, f) : Object(w.a)(d, f).then(function (t) {
              return 1 == (t.status / 200 | 0) ? t.text() : t.text().then(function (t) {
                return Promise.reject(t);
              });
            })).then(function (t) {
              return n.onUploadResponse(t, e);
            }).catch(function (t) {
              return n.onUploadError(t);
            });
          }
        }
      },
      initDrop: function initDrop() {
        var t = this;
        if (!this.uploadForm && (this.uploadForm = this.$el.find("form").get(0), "draggable" in this.uploadForm)) {
          this.uploadFile;
          this.uploadForm.ondragover = function () {
            return this.className = t.pfx + "hover", !1;
          }, this.uploadForm.ondragleave = function () {
            return this.className = "", !1;
          }, this.uploadForm.ondrop = function (e) {
            this.className = "", e.preventDefault(), t.uploadFile(e);
          };
        }
      },
      initDropzone: function initDropzone(t) {
        var e = this,
          n = 0,
          r = this.config,
          i = t.model,
          o = t.el,
          a = i.get("Editor"),
          s = (i.get("Config").el, i.get("Canvas").getBody()),
          l = this.ppfx,
          c = "".concat(l, "dropzone-active"),
          u = "".concat(l, "dropzone"),
          d = function d() {
            o.className = o.className.replace(c, "").trim(), n = 0;
          },
          h = function h() {
            return n || (o.className += " ".concat(c), n = 1), !1;
          },
          f = function f() {
            return d(), !1;
          },
          p = function p(t) {
            if (d(), t.preventDefault(), t.stopPropagation(), e.uploadFile(t), r.openAssetsOnDrop && a) {
              var n = a.getSelected();
              a.runCommand("open-assets", {
                target: n,
                onSelect: function onSelect() {
                  a.Modal.close(), a.AssetManager.setTarget(null);
                }
              });
            }
            return !1;
          };
        t.$el.append('<div class="'.concat(u, '">').concat(r.dropzoneContent, "</div>")), d(), "draggable" in o && [o, s].forEach(function (t) {
          t.ondragover = h, t.ondragleave = f, t.ondrop = p;
        });
      },
      render: function render() {
        var t = this.$el,
          e = this.pfx,
          n = this.em;
        return t.html(this.template({
          title: n && n.t("assetManager.uploadTitle"),
          uploadId: this.uploadId,
          disabled: this.disabled,
          multiUpload: this.multiUpload,
          pfx: e
        })), this.initDrop(), t.attr("class", e + "file-uploader"), this;
      }
    }, {
      embedAsBase64: function embedAsBase64(t, e) {
        var n = this,
          r = t.dataTransfer ? t.dataTransfer.files : t.target.files,
          i = {
            data: []
          };
        if (FileReader) {
          var o,
            a = [],
            s = /^(.+)\/(.+)$/,
            l = x(r);
          try {
            var c = function c() {
              var t = o.value,
                e = new Promise(function (e, n) {
                  var r = new FileReader();
                  r.addEventListener("load", function (i) {
                    var o,
                      a = t.name,
                      l = s.exec(t.type);
                    if ("image" === (o = l ? l[1] : t.type)) {
                      var c = {
                          src: r.result,
                          name: a,
                          type: o,
                          height: 0,
                          width: 0
                        },
                        u = new Image();
                      u.addEventListener("error", function (t) {
                        n(t);
                      }), u.addEventListener("load", function () {
                        c.height = u.height, c.width = u.width, e(c);
                      }), u.src = c.src;
                    } else e(o ? {
                      src: r.result,
                      name: a,
                      type: o
                    } : r.result);
                  }), r.addEventListener("error", function (t) {
                    n(t);
                  }), r.addEventListener("abort", function (t) {
                    n("Aborted");
                  }), r.readAsDataURL(t);
                });
              a.push(e);
            };
            for (l.s(); !(o = l.n()).done;) c();
          } catch (t) {
            l.e(t);
          } finally {
            l.f();
          }
          Promise.all(a).then(function (t) {
            i.data = t, n.onUploadResponse(i, e);
          }, function (t) {
            n.onUploadError(t);
          });
        } else this.onUploadError(new Error("Unsupported platform, FileReader is not defined"));
      }
    });
    e.default = function () {
      var t,
        e,
        n,
        i = {};
      return {
        name: "AssetManager",
        storageKey: "assets",
        getConfig: function getConfig() {
          return i;
        },
        init: function init(o) {
          var a = this;
          for (var s in i = o || {}, r) s in i || (i[s] = r[s]);
          var l = i.pStylePrefix,
            c = i.em;
          l && (i.stylePrefix = l + i.stylePrefix), t = new g([]);
          var u = {
            collection: new g([]),
            globalCollection: t,
            config: i
          };
          return n = new C(u), u.fu = n, e = new y(u), t.listenTo(t, "add", function (t) {
            a.getAllVisible().add(t), c && c.trigger("asset:add", t);
          }), t.listenTo(t, "remove", function (t) {
            a.getAllVisible().remove(t), c && c.trigger("asset:remove", t);
          }), this;
        },
        add: function add(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return void 0 === n.at && (n.at = 0), t.add(e, n);
        },
        get: function get(e) {
          return t.where({
            src: e
          })[0];
        },
        getAll: function getAll() {
          return t;
        },
        getAllVisible: function getAllVisible() {
          return e.collection;
        },
        remove: function remove(t) {
          var e = this.get(t);
          return this.getAll().remove(e), this;
        },
        store: function store(t) {
          var e = {},
            n = JSON.stringify(this.getAll().toJSON());
          return e[this.storageKey] = n, !t && i.stm && i.stm.store(e), e;
        },
        load: function load() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.storageKey,
            n = t[e] || [];
          if ("string" == typeof n) try {
            n = JSON.parse(t[e]);
          } catch (t) {}
          return n && n.length && this.getAll().reset(n), n;
        },
        getContainer: function getContainer() {
          return e.el;
        },
        getAssetsEl: function getAssetsEl() {
          return e.el.querySelector("[data-el=assets]");
        },
        render: function render(t) {
          var n = t || this.getAll().models;
          return e.rendered || e.render(), e.collection.reset(n), this.getContainer();
        },
        addType: function addType(t, e) {
          this.getAll().addType(t, e);
        },
        getType: function getType(t) {
          return this.getAll().getType(t);
        },
        getTypes: function getTypes() {
          return this.getAll().getTypes();
        },
        AssetsView: function AssetsView() {
          return e;
        },
        FileUploader: function FileUploader() {
          return n;
        },
        onLoad: function onLoad() {
          this.getAll().reset(i.assets);
        },
        postRender: function postRender(t) {
          i.dropzone && n.initDropzone(t);
        },
        setTarget: function setTarget(t) {
          e.collection.target = t;
        },
        onSelect: function onSelect(t) {
          e.collection.onSelect = t;
        },
        onClick: function onClick(t) {
          i.onClick = t;
        },
        onDblClick: function onDblClick(t) {
          i.onDblClick = t;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
      i = {
        stylePrefix: "trt-",
        appendTo: "",
        optionsTarget: [{
          value: !1
        }, {
          value: "_blank"
        }]
      },
      o = n(20),
      a = n(2),
      s = n.n(a),
      l = n(80),
      c = n.n(l),
      u = n(1),
      d = n.n(u),
      h = n(3);
    function f(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function p(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? f(Object(n), !0).forEach(function (e) {
          s()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var g = d.a.$,
      v = d.a.View.extend({
        events: {},
        eventCapture: ["change"],
        appendInput: 1,
        attributes: function attributes() {
          return this.model.get("attributes");
        },
        templateLabel: function templateLabel() {
          var t = this.ppfx,
            e = this.getLabel(),
            n = this.getLabelTitle(),
            r = this.getLabelTitleInfo();
          return '<div class="'.concat(t, 'label" title="').concat(n, '">').concat(e).concat(r, "</div>");
        },
        templateInput: function templateInput() {
          var t = this.clsField;
          return '<div class="'.concat(t, '" data-input></div>');
        },
        initialize: function initialize() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = e.config,
            r = void 0 === n ? {} : n,
            i = this.model,
            o = this.eventCapture,
            a = i.target,
            s = i.attributes.type;
          this.config = r, this.em = r.em, this.pfx = r.stylePrefix || "", this.ppfx = r.pStylePrefix || "", this.target = a;
          var l = this.ppfx;
          this.clsField = "".concat(l, "field ").concat(l, "field-").concat(s), [["change:value", this.onValueChange], ["remove", this.removeView]].forEach(function (e) {
            var n = c()(e, 2),
              r = n[0],
              o = n[1];
            i.off(r, o), t.listenTo(i, r, o);
          }), i.view = this, this.listenTo(i, "change:label", this.render), this.listenTo(i, "change:placeholder", this.rerender), o.forEach(function (e) {
            return t.events[e] = "onChange";
          }), this.delegateEvents(), this.init();
        },
        getClbOpts: function getClbOpts() {
          return {
            component: this.target,
            trait: this.model,
            elInput: this.getInputElem()
          };
        },
        removeView: function removeView() {
          this.remove(), this.removed();
        },
        init: function init() {},
        removed: function removed() {},
        onRender: function onRender() {},
        onUpdate: function onUpdate() {},
        onEvent: function onEvent() {},
        onChange: function onChange(t) {
          var e = this.getInputElem();
          e && !Object(r.isUndefined)(e.value) && this.model.set("value", e.value), this.onEvent(p(p({}, this.getClbOpts()), {}, {
            event: t
          }));
        },
        getValueForTarget: function getValueForTarget() {
          return this.model.get("value");
        },
        setInputValue: function setInputValue(t) {
          var e = this.getInputElem();
          e && (e.value = t);
        },
        onValueChange: function onValueChange(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (n.fromTarget) this.setInputValue(t.get("value")), this.postUpdate();else {
            var r = this.getValueForTarget();
            t.setTargetValue(r, n);
          }
        },
        renderLabel: function renderLabel() {
          var t = this.$el,
            e = this.target,
            n = this.getLabel(),
            r = this.templateLabel(e);
          this.createLabel && (r = this.createLabel({
            label: n,
            component: e,
            trait: this
          }) || ""), t.find("[data-label]").append(r);
        },
        getLabel: function getLabel() {
          var t = this.em,
            e = this.model.attributes,
            n = e.label,
            r = e.name;
          return t.t("traitManager.traits.labels.".concat(r)) || Object(h.c)(n || r).replace(/-/g, " ");
        },
        getLabelTitle: function getLabelTitle() {
          var t = this.em,
            e = this.model.attributes,
            n = e.label,
            r = e.name,
            i = e.title;
          return i ? Object(h.c)(i).replace(/-/g, " ") : t.t("traitManager.traits.labels.".concat(r)) || Object(h.c)(n || r).replace(/-/g, " ");
        },
        getLabelTitleInfo: function getLabelTitleInfo() {
          var t = this.model.attributes,
            e = t.info,
            n = t.infoStyle;
          return e ? '<i class="gjs-block__info-fa fa fa-info-circle" style="'.concat(n || "margin-left: 5px", '" title="').concat(e, '"></i>') : "";
        },
        getComponent: function getComponent() {
          return this.target;
        },
        getInputEl: function getInputEl() {
          if (!this.$input) {
            var t = this.em,
              e = this.model,
              n = e,
              i = e.attributes.name,
              o = n.get("placeholder") || n.get("default") || "",
              a = n.get("type") || "text",
              s = n.get("min"),
              l = n.get("max"),
              c = this.getModelValue(),
              u = g('<input type="'.concat(a, '" placeholder="').concat(o, '">')),
              d = t.t("traitManager.traits.attributes.".concat(i)) || {};
            u.attr(d), Object(r.isUndefined)(c) || (n.set({
              value: c
            }, {
              silent: !0
            }), u.prop("value", c)), s && u.prop("min", s), l && u.prop("max", l), this.$input = u;
          }
          return this.$input.get(0);
        },
        getInputElem: function getInputElem() {
          var t = this.input,
            e = this.$input;
          return t || e && e.get && e.get(0) || this.getElInput();
        },
        getModelValue: function getModelValue() {
          var t,
            e = this.model,
            n = this.target,
            i = e.get("name");
          if (e.get("changeProp")) t = n.get(i);else {
            var o = n.get("attributes");
            t = e.get("value") || o[i];
          }
          return Object(r.isUndefined)(t) ? "" : t;
        },
        getElInput: function getElInput() {
          return this.elInput;
        },
        renderField: function renderField() {
          var t = this.$el,
            e = this.appendInput,
            n = this.model,
            i = t.find("[data-input]"),
            o = i[i.length - 1],
            a = n.el;
          a || (a = this.createInput ? this.createInput(this.getClbOpts()) : this.getInputEl()), Object(r.isString)(a) ? (o.innerHTML = a, this.elInput = o.firstChild) : (e ? o.appendChild(a) : o.insertBefore(a, o.firstChild), this.elInput = a), n.el = this.elInput;
        },
        hasLabel: function hasLabel() {
          var t = this.model.attributes.label;
          return !this.noLabel && !1 !== t;
        },
        rerender: function rerender() {
          this.model.el = null, this.render();
        },
        postUpdate: function postUpdate() {
          this.onUpdate(this.getClbOpts());
        },
        render: function render() {
          var t = this.$el,
            e = this.pfx,
            n = this.ppfx,
            i = this.model.attributes.type,
            o = this.hasLabel && this.hasLabel(),
            a = "".concat(e, "trait");
          this.$input = null;
          var s = '<div class="'.concat(a, " ").concat(a, "--").concat(i, '">\n      ').concat(o ? '<div class="'.concat(n, 'label-wrp" data-label></div>') : "", '\n      <div class="').concat(n, "field-wrp ").concat(n, "field-wrp--").concat(i, '" data-input>\n        ').concat(this.templateInput ? Object(r.isFunction)(this.templateInput) ? this.templateInput(this.getClbOpts()) : this.templateInput : "", "\n      </div>\n    </div>");
          return t.empty().append(s), o && this.renderLabel(), this.renderField(), this.el.className = "".concat(a, "__wrp"), this.postUpdate(), this.onRender(this.getClbOpts()), this;
        }
      }),
      m = d.a.$,
      b = v.extend({
        init: function init() {
          this.listenTo(this.model, "change:options", this.rerender);
        },
        templateInput: function templateInput() {
          var t = this.ppfx,
            e = this.clsField;
          return '<div class="'.concat(e, '">\n      <div data-input></div>\n      <div class="').concat(t, 'sel-arrow">\n        <div class="').concat(t, 'd-s-arrow"></div>\n      </div>\n    </div>');
        },
        getInputEl: function getInputEl() {
          if (!this.$input) {
            var t = this.model,
              e = this.em,
              n = t.get("name"),
              i = t.get("options") || [],
              o = [],
              a = "<select>";
            i.forEach(function (t) {
              var i,
                s,
                l,
                c = "";
              Object(r.isString)(t) ? (i = t, s = t) : (i = t.name || t.label || t.value, s = "".concat(Object(r.isUndefined)(t.value) ? t.id : t.value).replace(/"/g, "&quot;"), c += (l = t.style ? t.style.replace(/"/g, "&quot;") : "") ? ' style="'.concat(l, '"') : "");
              var u = e.t("traitManager.traits.options.".concat(n, ".").concat(s)) || i;
              a += '<option value="'.concat(s, '"').concat(c, ">").concat(u, "</option>"), o.push(s);
            }), a += "</select>", this.$input = m(a);
            var s = t.getTargetValue(),
              l = o.indexOf(s) >= 0 ? s : t.get("default");
            !Object(r.isUndefined)(l) && this.$input.val(l);
          }
          return this.$input.get(0);
        }
      }),
      y = v.extend({
        appendInput: 0,
        templateInput: function templateInput() {
          var t = this.ppfx,
            e = this.clsField;
          return '<label class="'.concat(e, '" data-input>\n    <i class="').concat(t, 'chk-icon"></i>\n  </label>');
        },
        onChange: function onChange() {
          var t = this.getInputElem().checked;
          this.model.set("value", this.getCheckedValue(t));
        },
        getCheckedValue: function getCheckedValue(t) {
          var e = t,
            n = this.model.attributes,
            i = n.valueTrue,
            o = n.valueFalse;
          return e && !Object(r.isUndefined)(i) && (e = i), e || Object(r.isUndefined)(o) || (e = o), e;
        },
        getInputEl: function getInputEl() {
          for (var t = !this.$input, e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
          var o = v.prototype.getInputEl.apply(this, n);
          if (t) {
            var a,
              s,
              l = this.model,
              c = this.target,
              u = l.attributes,
              d = (u.valueTrue, u.valueFalse),
              h = l.get("name");
            l.get("changeProp") ? s = a = c.get(h) : a = !(!(s = c.get("attributes")[h]) && "" !== s), Object(r.isUndefined)(d) || s !== d || (a = !1), o.checked = a;
          }
          return o;
        }
      }),
      w = n(32),
      x = v.extend({
        getValueForTarget: function getValueForTarget() {
          var t = this.model.attributes,
            e = t.value,
            n = t.unit;
          return e ? e + n : "";
        },
        getInputEl: function getInputEl() {
          if (!this.input) {
            var t = this.getModelValue(),
              e = new w.a({
                contClass: this.ppfx + "field-int",
                model: this.model,
                ppfx: this.ppfx
              });
            this.input = e.render(), this.$input = this.input.inputEl, this.$unit = this.input.unitEl, this.model.set("value", t), this.$input.val(t), this.input = e.el;
          }
          return this.input;
        }
      }),
      O = n(38),
      C = v.extend({
        templateInput: "",
        getInputEl: function getInputEl() {
          if (!this.input) {
            var t = this.model,
              e = this.getModelValue(),
              n = new O.a({
                model: t,
                target: this.config.em,
                contClass: this.ppfx + "field-color",
                ppfx: this.ppfx
              }).render();
            n.setValue(e, {
              fromTarget: 1
            }), this.input = n.el;
          }
          return this.input;
        }
      }),
      S = v.extend({
        events: {
          "click button": "handleClick"
        },
        templateInput: "",
        handleClick: function handleClick() {
          var t = this.model,
            e = this.em,
            n = t.get("command");
          n && (Object(r.isString)(n) ? e.get("Commands").run(n) : n(e.get("Editor"), t));
        },
        renderLabel: function renderLabel() {
          this.model.get("label") && v.prototype.renderLabel.apply(this, arguments);
        },
        getInputEl: function getInputEl() {
          var t = this.model,
            e = this.ppfx,
            n = t.props(),
            r = n.labelButton,
            i = n.text,
            o = n.full,
            a = r || i,
            s = "".concat(e, "btn");
          return '<button type="button" class="'.concat(s, "-prim").concat(o ? " ".concat(s, "--full") : "", '">').concat(a, "</button>");
        }
      }),
      k = o.a.extend({
        ns: "Traits",
        itemView: v,
        reuseView: 1,
        itemsView: {
          text: v,
          number: x,
          select: b,
          checkbox: y,
          color: C,
          button: S
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.config || {};
          this.config = e, this.em = t.editor, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.className = this.pfx + "traits";
          var n = "component:toggled";
          this.listenTo(this.em, n, this.updatedCollection), this.updatedCollection();
        },
        updatedCollection: function updatedCollection() {
          var t = this.ppfx,
            e = this.em.getSelected();
          this.el.className = "".concat(this.className, " ").concat(t, "one-bg ").concat(t, "two-color"), this.collection = e ? e.get("traits") : [], this.render();
        }
      });
    e.default = function () {
      var t,
        e = {};
      return {
        TraitsView: k,
        name: "TraitManager",
        getConfig: function getConfig() {
          return e;
        },
        init: function init() {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e = n, Object(r.defaults)(e, i);
          var o = e.pStylePrefix;
          return o && (e.stylePrefix = "".concat(o).concat(e.stylePrefix)), t = new k({
            collection: [],
            editor: e.em,
            config: e
          }), this;
        },
        postRender: function postRender() {
          var t = this.getConfig().appendTo;
          t && (Object(r.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
        },
        getTraitsViewer: function getTraitsViewer() {
          return t;
        },
        addType: function addType(e, n) {
          var r = t.itemView;
          t.itemsView[e] = r.extend(n);
        },
        getType: function getType(e) {
          return t.itemsView[e];
        },
        render: function render() {
          return t.render().el;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(0),
      a = {
        appendTo: "",
        appendOnClick: 0,
        appendOnDblClick: 0,
        blocks: []
      },
      s = n(1),
      l = n.n(s),
      c = l.a.Model.extend({
        defaults: {
          id: "",
          label: "",
          open: !0,
          attributes: {}
        }
      }),
      u = l.a.Model.extend({
        defaults: {
          activate: 0,
          select: 0,
          resetId: 0,
          label: "",
          disable: 0,
          media: "",
          content: "",
          category: "",
          attributes: {}
        },
        initialize: function initialize() {
          var t = this.get("category");
          if (t && "string" == typeof t) new c({
            id: t,
            label: t
          });
        }
      }),
      d = l.a.Collection.extend({
        model: u
      }),
      h = l.a.Collection.extend({
        model: c
      }),
      f = n(3),
      p = l.a.View.extend({
        events: {
          click: "handleClick",
          dblclick: "handleDblClick",
          mousedown: "startDrag",
          dragstart: "handleDragStart",
          drag: "handleDrag",
          dragend: "handleDragEnd"
        },
        initialize: function initialize(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.model;
          this.em = e.em, this.config = e, this.endDrag = this.endDrag.bind(this), this.ppfx = e.pStylePrefix || "", this.listenTo(n, "destroy remove", this.remove), this.listenTo(n, "change", this.render);
        },
        handleClick: function handleClick() {
          var t = this.config,
            e = this.model,
            n = this.em;
          if (t.appendOnClick) {
            var r,
              i = t.getSorter(),
              o = e.get("content"),
              a = n.getSelected();
            if (i.setDropContent(o), a) if (i.validTarget(a.getEl(), o).valid) r = a;else {
              var s = a.parent();
              i.validTarget(s.getEl(), o).valid && (r = s);
            }
            if (!r) {
              var l = n.getWrapper();
              i.validTarget(l.getEl(), o).valid && (r = l);
            }
            var c = r && r.append(o)[0];
            c && n.setSelected(c, {
              scroll: 1
            });
          }
        },
        handleDblClick: function handleDblClick() {
          var t = this.config,
            e = this.model,
            n = this.em;
          if (t.appendOnDblClick) {
            var r,
              i = t.getSorter(),
              o = e.get("content"),
              a = n.getSelected();
            if (i.setDropContent(o), a) {
              var s = a.parent();
              void 0 === s ? i.validTarget(a.getEl(), o).valid && (r = a) : i.validTarget(s.getEl(), o).valid && (r = s);
            }
            if (!r) {
              var l = n.getWrapper();
              i.validTarget(l.getEl(), o).valid && (r = l);
            }
            var c = r && r.append(o)[0];
            c && n.setSelected(c, {
              scroll: 1
            });
          }
        },
        startDrag: function startDrag(t) {
          var e = this.config,
            n = this.em,
            r = this.model.get("disable");
          if (0 === t.button && e.getSorter && !this.el.draggable && !r) {
            n.refreshCanvas();
            var i = e.getSorter();
            i.setDragHelper(this.el, t), i.setDropContent(this.model.get("content")), i.startSort(this.el), Object(f.u)(document, "mouseup", this.endDrag);
          }
        },
        handleDragStart: function handleDragStart(t) {
          var e = this.em,
            n = this.model,
            r = n.get("content"),
            i = Object(o.isObject)(r) ? JSON.stringify(r) : r;
          e.set("dragResult"), t.dataTransfer.setData("text", i), e.set("dragContent", r), e.trigger("block:drag:start", n, t);
        },
        handleDrag: function handleDrag(t) {
          this.em.trigger("block:drag", this.model, t);
        },
        handleDragEnd: function handleDragEnd() {
          var t = this.em,
            e = this.model,
            n = t.get("dragResult");
          if (n) {
            var r = n.get && n.get("activeOnRender");
            (e.get("activate") || r) && (n.trigger("active"), n.set("activeOnRender", 0)), e.get("select") && t.setSelected(n), e.get("resetId") && n.onAll(function (t) {
              return t.resetId();
            });
          }
          t.set({
            dragResult: null,
            dragContent: null
          }), t.trigger("block:drag:stop", n, e);
        },
        endDrag: function endDrag(t) {
          Object(f.t)(document, "mouseup", this.endDrag);
          var e = this.config.getSorter();
          e.moved = 0, e.endMove();
        },
        render: function render() {
          var t = this.em,
            e = this.el,
            n = this.$el,
            r = this.ppfx,
            i = this.model,
            o = i.get("disable"),
            a = i.get("attributes") || {},
            s = a.class || "",
            l = a.title || "",
            c = "".concat(r, "block"),
            u = t && t.t("blockManager.labels.".concat(i.id)) || i.get("label"),
            d = i.get("render"),
            h = i.get("media"),
            p = o ? "".concat(c, "--disable") : "".concat(r, "four-color-h");
          n.attr(a), e.className = "".concat(s, " ").concat(c, " ").concat(r, "one-bg ").concat(p).trim(), e.innerHTML = "\n      ".concat(h ? '<div class="'.concat(c, '__media">').concat(h, "</div>") : "", '\n      <div class="').concat(c, '-label">').concat(u, "</div>\n    "), e.title = e.textContent.trim().startsWith(".") ? l : e.textContent.trim(), e.setAttribute("draggable", !(!Object(f.k)(t) || o));
          var g = d && d({
            el: e,
            model: i,
            className: c,
            prefix: r
          });
          return g && (e.innerHTML = g), this;
        }
      }),
      g = l.a.View.extend({
        template: Object(o.template)('\n  <div class="<%= pfx %>title">\n    <i class="<%= pfx %>caret-icon"></i>\n    <%= label %>\n  </div>\n  <div class="<%= pfx %>blocks-c"></div>\n  '),
        events: {},
        initialize: function initialize() {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.config = t;
          var e = t.pStylePrefix || "";
          this.em = t.em, this.pfx = e, this.caretR = "fa fa-caret-right", this.caretD = "fa fa-caret-down", this.iconClass = "".concat(e, "caret-icon"), this.activeClass = "".concat(e, "open"), this.className = "".concat(e, "block-category"), this.events["click .".concat(e, "title")] = "toggle", this.listenTo(this.model, "change:open", this.updateVisibility), this.delegateEvents();
        },
        updateVisibility: function updateVisibility() {
          this.model.get("open") ? this.open() : this.close();
        },
        open: function open() {
          this.el.className = "".concat(this.className, " ").concat(this.activeClass), this.getIconEl().className = "".concat(this.iconClass, " ").concat(this.caretD), this.getBlocksEl().style.display = "";
        },
        close: function close() {
          this.el.className = this.className, this.getIconEl().className = "".concat(this.iconClass, " ").concat(this.caretR), this.getBlocksEl().style.display = "none";
        },
        toggle: function toggle() {
          var t = this.model;
          t.set("open", !t.get("open"));
        },
        getIconEl: function getIconEl() {
          return this.iconEl || (this.iconEl = this.el.querySelector("." + this.iconClass)), this.iconEl;
        },
        getBlocksEl: function getBlocksEl() {
          return this.blocksEl || (this.blocksEl = this.el.querySelector("." + this.pfx + "blocks-c")), this.blocksEl;
        },
        append: function append(t) {
          this.getBlocksEl().appendChild(t);
        },
        render: function render() {
          var t = this.em,
            e = this.el,
            n = this.$el,
            r = this.model,
            i = t.t("blockManager.categories.".concat(r.id)) || r.get("label");
          return e.innerHTML = this.template({
            pfx: this.pfx,
            label: i
          }), e.className = this.className, n.css({
            order: r.get("order")
          }), this.updateVisibility(), this;
        }
      });
    function v(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function m(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? v(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var b = l.a.View.extend({
      initialize: function initialize(t, e) {
        Object(o.bindAll)(this, "getSorter", "onDrag", "onDrop"), this.config = e || {}, this.categories = t.categories || "", this.renderedCategories = [];
        var n = this.config.pStylePrefix || "";
        this.ppfx = n, this.noCatClass = "".concat(n, "blocks-no-cat"), this.blockContClass = "".concat(n, "blocks-c"), this.catsClass = "".concat(n, "block-categories");
        var r = this.collection;
        this.listenTo(r, "add", this.addTo), this.listenTo(r, "reset", this.render), this.em = this.config.em, this.tac = "test-tac", this.grabbingCls = this.ppfx + "grabbing", this.em && (this.config.getSorter = this.getSorter, this.canvas = this.em.get("Canvas"));
      },
      updateConfig: function updateConfig() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        this.config = m(m({}, this.config), t);
      },
      getSorter: function getSorter() {
        if (this.em) {
          if (!this.sorter) {
            var t = this.em.get("Utils"),
              e = this.canvas;
            this.sorter = new t.Sorter({
              container: e.getBody(),
              placer: e.getPlacerEl(),
              containerSel: "*",
              itemSel: "*",
              pfx: this.ppfx,
              onStart: this.onDrag,
              onEndMove: this.onDrop,
              onMove: this.onMove,
              document: e.getFrameEl().contentDocument,
              direction: "a",
              wmargin: 1,
              nested: 1,
              em: this.em,
              canvasRelative: 1
            });
          }
          return this.sorter;
        }
      },
      onDrag: function onDrag(t) {
        this.em.stopDefault(), this.em.trigger("block:drag:start", t);
      },
      onMove: function onMove(t) {
        this.em.trigger("block:drag:move", t);
      },
      onDrop: function onDrop(t) {
        var e = this.em;
        e.runDefault(), t && t.get && (t.get("activeOnRender") && (t.trigger("active"), t.set("activeOnRender", 0)), e.trigger("block:drag:stop", t));
      },
      addTo: function addTo(t) {
        this.add(t);
      },
      add: function add(t, e) {
        var n = this.config,
          r = e || null,
          i = new p({
            model: t,
            attributes: t.get("attributes")
          }, n).render().el,
          a = t.get("category");
        if (a && this.categories && !n.ignoreCategories) {
          Object(o.isString)(a) ? a = {
            id: a,
            label: a
          } : Object(o.isObject)(a) && !a.id && (a.id = a.label);
          var s = this.categories.add(a),
            l = s.get("id"),
            c = this.renderedCategories[l],
            u = this.getCategoriesEl();
          return t.set("category", s), !c && u && (c = new g({
            model: s
          }, this.config).render(), this.renderedCategories[l] = c, u.appendChild(c.el)), void (c && c.append(i));
        }
        r ? r.appendChild(i) : this.append(i);
      },
      getCategoriesEl: function getCategoriesEl() {
        return this.catsEl || (this.catsEl = this.el.querySelector(".".concat(this.catsClass))), this.catsEl;
      },
      getBlocksEl: function getBlocksEl() {
        return this.blocksEl || (this.blocksEl = this.el.querySelector(".".concat(this.noCatClass, " .").concat(this.blockContClass))), this.blocksEl;
      },
      append: function append(t) {
        var e = this.getBlocksEl();
        e && e.appendChild(t);
      },
      render: function render() {
        var t = this,
          e = this.ppfx,
          n = document.createDocumentFragment();
        this.catsEl = null, this.blocksEl = null, this.renderedCategories = [], this.el.innerHTML = '\n      <div class="'.concat(this.catsClass, '"></div>\n      <div class="').concat(this.noCatClass, '">\n        <div class="').concat(this.blockContClass, '"></div>\n      </div>\n    '), this.collection.each(function (e) {
          return t.add(e, n);
        }), this.append(n);
        var r = "".concat(this.blockContClass, "s ").concat(e, "one-bg ").concat(e, "two-color");
        return this.$el.addClass(r), this;
      }
    });
    function y(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function w(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? y(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n,
        r = {},
        i = [];
      return {
        name: "BlockManager",
        init: function init(n) {
          var o = (r = n || {}).em;
          for (var s in a) s in r || (r[s] = a[s]);
          return t = new d([]), e = new d([]), i = new h(), t.listenTo(t, "add", function (t) {
            e.add(t), o && o.trigger("block:add", t);
          }), t.listenTo(t, "remove", function (t) {
            e.remove(t), o && o.trigger("block:remove", t);
          }), t.listenTo(t, "reset", function (t) {
            e.reset(t.models);
          }), this;
        },
        getConfig: function getConfig() {
          return r;
        },
        onLoad: function onLoad() {
          var t = this.getAll();
          !t.length && t.reset(r.blocks);
        },
        postRender: function postRender() {
          n = new b({
            collection: e,
            categories: i
          }, r);
          var t = this.getConfig().appendTo;
          t && (Object(o.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render(e.models));
        },
        add: function add(e, n) {
          var r = n || {};
          return r.id = e, t.add(r);
        },
        get: function get(e) {
          return t.get(e);
        },
        getAll: function getAll() {
          return t;
        },
        getAllVisible: function getAllVisible() {
          return e;
        },
        remove: function remove(e) {
          return t.remove(e);
        },
        getCategories: function getCategories() {
          return i;
        },
        getContainer: function getContainer() {
          return n.el;
        },
        render: function render(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            o = t || this.getAll().models;
          if (e.external) {
            var a = new d(o);
            return new b({
              collection: a,
              categories: i
            }, w(w({}, r), e)).render().el;
          }
          return n && (n.updateConfig(e), n.collection.reset(o), n.rendered || (n.render(), n.rendered = 1)), this.getContainer();
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = "sw-visibility",
      i = "open-layers",
      o = {
        stylePrefix: "pn-",
        defaults: [{
          id: "commands",
          buttons: [{}]
        }, {
          id: "devices-c",
          buttons: [{
            active: !0,
            id: "set-device-desktop",
            className: "fa fa-desktop",
            command: "set-device-desktop",
            attributes: {
              title: "Desktop"
            }
          }, {
            id: "set-device-tablet",
            className: "fa fa-tablet",
            command: "set-device-tablet",
            attributes: {
              title: "Tablet"
            }
          }, {
            id: "set-device-mobile-ptr",
            className: "fa fa-mobile",
            command: "set-device-mobile-ptr",
            attributes: {
              title: "Mobile"
            }
          }, {
            id: "set-device-mobile",
            className: "fa fa-mobile",
            command: "set-device-mobile",
            attributes: {
              title: "Mobile Landscape"
            }
          }, {
            id: "versions",
            className: "fa fa-code-fork",
            command: "switch-version",
            attributes: {
              title: "Switch Version"
            }
          }, {
            id: "shortcut",
            className: "fa fa-search",
            command: "shortcut",
            attributes: {
              title: "Shortcut"
            }
          }, {
            id: "custom-open-blocks",
            className: "fa fa-plus-circle btn btn-theme-primary--light btn-xs",
            command: "custom-open-blocks",
            togglable: 1,
            attributes: {
              title: "Add Components",
              id: "add-components"
            }
          }]
        }, {
          id: "options",
          buttons: [{
            active: !0,
            id: r,
            className: "fa fa-square-o",
            command: r,
            context: r,
            attributes: {
              title: "View components"
            }
          }, {
            id: "preview",
            className: "fa fa-eye",
            command: "custom-preview",
            context: "preview",
            attributes: {
              title: "Preview"
            }
          }, {
            id: "build",
            className: "fa fa-paper-plane-o",
            command: "custom-build",
            context: "build",
            attributes: {
              title: "Production"
            }
          }, {
            id: "code-editor",
            className: "wb webconnect-layout-text-sidebar-reverse",
            command: "code-editor-open",
            attributes: {
              title: "View Code"
            }
          }, {
            id: "undo",
            className: "fa fa-undo",
            command: function command(t) {
              return t.runCommand("core:undo");
            }
          }, {
            id: "redo",
            className: "fa fa-repeat",
            command: function command(t) {
              return t.runCommand("core:redo");
            }
          }, {
            id: "save-db",
            className: "fa fa-save btn-save",
            command: "save-db",
            context: "save-db",
            attributes: {
              title: "Save"
            }
          }, {
            id: "cmd-clear",
            className: "fa fa-trash",
            command: "cmd-clear",
            context: "cmd-clear",
            attributes: {
              title: "Clear"
            }
          }]
        }, {
          id: "views",
          buttons: [{
            id: "open-sm",
            className: "fa fa-paint-brush",
            command: "open-sm",
            active: !0,
            togglable: 0,
            attributes: {
              title: "Open Style Manager"
            }
          }, {
            id: "open-tm",
            className: "fa fa-cog",
            command: "open-tm",
            togglable: 0,
            attributes: {
              title: "Settings"
            }
          }, {
            id: i,
            className: "fa fa-bars",
            command: i,
            togglable: 0,
            attributes: {
              title: "Open Layer Manager"
            }
          }]
        }],
        em: null,
        delayBtnsShow: 300
      },
      a = n(1),
      s = n.n(a),
      l = n(41),
      c = s.a.Model.extend({
        defaults: {
          id: "",
          content: "",
          visible: !0,
          buttons: [],
          attributes: {}
        },
        initialize: function initialize(t) {
          this.btn = this.get("buttons") || [], this.buttons = new l.default(this.btn), this.set("buttons", this.buttons);
        }
      }),
      u = s.a.Collection.extend({
        model: c
      }),
      d = n(2),
      h = n.n(d),
      f = n(0);
    function p(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function g(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? p(Object(n), !0).forEach(function (e) {
          h()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    s.a.$;
    var v = s.a.View.extend({
        tagName: function tagName() {
          return this.model.get("tagName");
        },
        events: {
          click: "clicked"
        },
        initialize: function initialize(t) {
          var e = this.model.get("className");
          this.config = t.config || {}, this.em = this.config.em || {};
          var n = this.config.stylePrefix || "",
            r = this.config.pStylePrefix || "";
          this.pfx = n, this.ppfx = this.config.pStylePrefix || "", this.id = n + this.model.get("id"), this.activeCls = "".concat(n, "active ").concat(r, "four-color"), this.disableCls = "".concat(r, "disabled"), this.btnsVisCls = "".concat(n, "visible"), this.className = n + "btn" + (e ? " " + e : ""), this.listenTo(this.model, "change", this.render), this.listenTo(this.model, "change:active updateActive", this.updateActive), this.listenTo(this.model, "checkActive", this.checkActive), this.listenTo(this.model, "change:bntsVis", this.updateBtnsVis), this.listenTo(this.model, "change:attributes", this.updateAttributes), this.listenTo(this.model, "change:className", this.updateClassName), this.listenTo(this.model, "change:disable", this.updateDisable), this.em && this.em.get && (this.commands = this.em.get("Commands"));
        },
        updateClassName: function updateClassName() {
          var t = this.model,
            e = this.pfx,
            n = t.get("className"),
            r = t.get("attributes").class,
            i = "".concat(r || "", " ").concat(e, "btn ").concat(n || "");
          this.$el.attr("class", i.trim());
        },
        updateAttributes: function updateAttributes() {
          var t = this.em,
            e = this.model,
            n = this.$el,
            r = e.get("attributes") || {},
            i = t && t.t && t.t("panels.buttons.titles.".concat(e.id));
          n.attr(r), i && n.attr({
            title: i
          }), this.updateClassName();
        },
        updateBtnsVis: function updateBtnsVis() {
          this.$buttons && (this.model.get("bntsVis") ? this.$buttons.addClass(this.btnsVisCls) : this.$buttons.removeClass(this.btnsVisCls));
        },
        updateActive: function updateActive() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model,
            n = this.commands,
            r = this.$el,
            i = this.activeCls,
            o = t.fromCollection,
            a = e.get("context"),
            s = e.get("options"),
            l = e.get("command"),
            c = {};
          n && Object(f.isString)(l) ? c = n.get(l) || {} : Object(f.isFunction)(l) ? c = n.create({
            run: l
          }) : null !== l && Object(f.isObject)(l) && (c = n.create(l)), e.get("active") ? (!o && e.collection.deactivateAll(a, e), e.set("active", !0, {
            silent: !0
          }).trigger("checkActive"), n.runCommand(c, g(g({}, s), {}, {
            sender: e
          })), c.noStop && e.set("active", !1)) : (r.removeClass(i), n.stopCommand(c, g(g({}, s), {}, {
            sender: e,
            force: 1
          })));
        },
        updateDisable: function updateDisable() {
          var t = this.disableCls,
            e = this.model.get("disable");
          this.$el[e ? "addClass" : "removeClass"](t);
        },
        checkActive: function checkActive() {
          var t = this.model,
            e = this.$el,
            n = this.activeCls;
          t.get("active") ? e.addClass(n) : e.removeClass(n);
        },
        clicked: function clicked(t) {
          this.model.get("bntsVis") || this.model.get("disable") || this.toggleActive();
        },
        toggleActive: function toggleActive() {
          var t = this.model,
            e = t.attributes,
            n = e.active,
            r = e.togglable;
          if (!n || r) {
            t.set("active", !n);
            this.em.get("Commands").get("select-comp");
            n ? t.get("runDefaultCommand") && this.em.runDefault() : t.get("stopDefaultCommand") && this.em.stopDefault();
          }
        },
        render: function render() {
          var t = this.model.get("label"),
            e = this.$el;
          return e.empty(), this.updateAttributes(), t && e.append(t), this.checkActive(), this.updateDisable(), this;
        }
      }),
      m = s.a.View.extend({
        initialize: function initialize(t) {
          this.opt = t || {}, this.config = this.opt.config || {}, this.pfx = this.config.stylePrefix || "", this.parentM = this.opt.parentM || null, this.listenTo(this.collection, "add", this.addTo), this.listenTo(this.collection, "reset remove", this.render), this.className = this.pfx + "buttons";
        },
        addTo: function addTo(t) {
          this.addToCollection(t);
        },
        addToCollection: function addToCollection(t, e) {
          var n = e || null,
            r = new v({
              model: t,
              config: this.config,
              parentM: this.parentM
            }).render().el;
          return n ? n.appendChild(r) : this.$el.append(r), r;
        },
        render: function render() {
          var t = document.createDocumentFragment();
          return this.$el.empty(), this.collection.each(function (e) {
            this.addToCollection(e, t);
          }, this), this.$el.append(t), this.$el.attr("class", Object(f.result)(this, "className")), this;
        }
      });
    function b(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    var y = s.a.View.extend({
        initialize: function initialize(t) {
          var e = t.config || {},
            n = this.model;
          this.config = e, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.buttons = n.get("buttons"), this.className = this.pfx + "panel", this.id = this.pfx + n.get("id"), this.listenTo(n, "change:appendContent", this.appendContent), this.listenTo(n, "change:content", this.updateContent), this.listenTo(n, "change:visible", this.toggleVisible), n.view = this;
        },
        appendContent: function appendContent() {
          this.$el.append(this.model.get("appendContent"));
        },
        updateContent: function updateContent() {
          this.$el.html(this.model.get("content"));
        },
        toggleVisible: function toggleVisible() {
          this.model.get("visible") ? this.$el.removeClass("".concat(this.ppfx, "hidden")) : this.$el.addClass("".concat(this.ppfx, "hidden"));
        },
        attributes: function attributes() {
          return this.model.get("attributes");
        },
        initResize: function initResize() {
          var t = this.config.em,
            e = t ? t.get("Editor") : "",
            n = this.model.get("resizable");
          if (e && n) {
            var r,
              i,
              o,
              a = !0 === n ? [1, 1, 1, 1] : n,
              s = a.length,
              l = 0;
            2 == s ? (r = a[0], o = a[0], i = a[1], l = a[1]) : 4 == s && (r = a[0], i = a[1], o = a[2], l = a[3]);
            var c = e.Utils.Resizer.init(function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {};
                e % 2 ? b(Object(n), !0).forEach(function (e) {
                  h()(t, e, n[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                });
              }
              return t;
            }({
              tc: r,
              cr: i,
              bc: o,
              cl: l,
              tl: 0,
              tr: 0,
              bl: 0,
              br: 0,
              appendTo: this.el,
              silentFrames: 1,
              avoidContainerUpdate: 1,
              prefix: e.getConfig().stylePrefix,
              onEnd: function onEnd() {
                t && t.trigger("change:canvasOffset");
              },
              posFetcher: function posFetcher(t, e) {
                var n = e.target,
                  r = t.style,
                  i = c.getConfig(),
                  o = i.keyWidth,
                  a = i.keyHeight,
                  s = t.getBoundingClientRect(),
                  l = "container" == n,
                  u = r[o],
                  d = r[a];
                return {
                  left: 0,
                  top: 0,
                  width: u && !l ? parseFloat(u) : s.width,
                  height: d && !l ? parseFloat(d) : s.height
                };
              }
            }, n));
            c.blur = function () {}, c.focus(this.el);
          }
        },
        render: function render() {
          var t = this.$el,
            e = this.ppfx,
            n = "".concat(this.className, " ").concat(this.id, " ").concat(e, "one-bg ").concat(e, "two-color");
          if (t.addClass(n), this.buttons.length) {
            var r = new m({
              collection: this.buttons,
              config: this.config
            });
            t.append(r.render().el);
          }
          return t.append(this.model.get("content")), this;
        }
      }),
      w = s.a.View.extend({
        initialize: function initialize(t) {
          this.opt = t || {}, this.config = this.opt.config || {}, this.pfx = this.config.stylePrefix || "";
          var e = this.collection;
          this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.render), this.listenTo(e, "remove", this.onRemove), this.className = this.pfx + "panels";
        },
        onRemove: function onRemove(t) {
          var e = t.view;
          e && e.remove();
        },
        addTo: function addTo(t) {
          this.addToCollection(t);
        },
        addToCollection: function addToCollection(t, e) {
          var n = e || null,
            r = this.config,
            i = t.get("el"),
            o = new y({
              el: i,
              model: t,
              config: r
            }),
            a = o.render().el,
            s = t.get("appendTo");
          if (i) ;else if (s) {
            document.querySelector(s).appendChild(a);
          } else n ? n.appendChild(a) : this.$el.append(a);
          return o.initResize(), a;
        },
        render: function render() {
          var t = this,
            e = this.$el,
            n = document.createDocumentFragment();
          return e.empty(), this.collection.each(function (e) {
            return t.addToCollection(e, n);
          }), e.append(n), e.attr("class", this.className), this;
        }
      });
    e.default = function () {
      var t,
        e,
        n = {};
      return {
        name: "Panels",
        init: function init(r) {
          for (var i in n = r || {}, o) i in n || (n[i] = o[i]);
          var a = n.pStylePrefix;
          return a && (n.stylePrefix = a + n.stylePrefix), t = new u(n.defaults), e = new w({
            collection: t,
            config: n
          }), this;
        },
        getPanels: function getPanels() {
          return t;
        },
        getPanelsEl: function getPanelsEl() {
          return e.el;
        },
        addPanel: function addPanel(e) {
          return t.add(e);
        },
        removePanel: function removePanel(e) {
          return t.remove(e);
        },
        getPanel: function getPanel(e) {
          var n = t.where({
            id: e
          });
          return n.length ? n[0] : null;
        },
        addButton: function addButton(t, e) {
          var n = this.getPanel(t);
          return n ? n.get("buttons").add(e) : null;
        },
        removeButton: function removeButton(t, e) {
          var n = this.getPanel(t);
          return n && n.get("buttons").remove(e);
        },
        getButton: function getButton(t, e) {
          var n = this.getPanel(t);
          if (n) {
            var r = n.get("buttons").where({
              id: e
            });
            return r.length ? r[0] : null;
          }
          return null;
        },
        render: function render() {
          return e.render().el;
        },
        active: function active() {
          this.getPanels().each(function (t) {
            t.get("buttons").each(function (t) {
              t.get("active") && t.trigger("updateActive");
            });
          });
        },
        disableButtons: function disableButtons() {
          this.getPanels().each(function (t) {
            t.get("buttons").each(function (t) {
              t.get("disable") && t.trigger("change:disable");
            });
          });
        },
        Panel: c
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(0),
      a = {
        stylePrefix: "sm-",
        sectors: [],
        appendTo: "",
        hideNotStylable: !0,
        highlightChanged: !0,
        highlightComputed: !0,
        showComputed: !0,
        clearProperties: 0,
        avoidComputed: ["width", "height"]
      },
      s = n(1),
      l = n.n(s),
      c = n(24),
      u = function u() {
        return {
          build: function build(t) {
            var e = [];
            "string" == typeof t && (t = [t]);
            for (var n = 0, r = t.length; n < r; n++) {
              var i = {},
                o = t[n];
              switch (i.property = o, o) {
                case "border-radius-c":
                  i.property = "border-radius";
              }
              switch (o) {
                case "top":
                case "right":
                case "bottom":
                case "left":
                case "margin-top":
                case "margin-right":
                case "margin-bottom":
                case "margin-left":
                case "padding-top":
                case "padding-right":
                case "padding-bottom":
                case "padding-left":
                case "width":
                case "max-width":
                case "min-width":
                case "height":
                case "max-height":
                case "min-height":
                case "flex-basis":
                  i.fixedValues = ["initial", "inherit", "auto", "min-content", "max-content"];
                  break;
                case "font-size":
                  i.fixedValues = ["medium", "xx-small", "x-small", "small", "large", "x-large", "xx-large", "smaller", "larger", "length", "initial", "inherit"];
                  break;
                case "letter-spacing":
                case "line-height":
                  i.fixedValues = ["normal", "initial", "inherit"];
              }
              switch (o) {
                case "float":
                case "position":
                case "text-align":
                  i.type = "radio";
                  break;
                case "display":
                case "flex-direction":
                case "flex-wrap":
                case "justify-content":
                case "align-items":
                case "align-content":
                case "align-self":
                case "font-family":
                case "font-weight":
                case "border-style":
                case "box-shadow-type":
                case "background-repeat":
                case "background-position":
                case "background-attachment":
                case "background-size":
                case "transition-property":
                case "transition-timing-function":
                case "cursor":
                case "overflow":
                case "overflow-x":
                case "overflow-y":
                  i.type = "select";
                  break;
                case "top":
                case "right":
                case "bottom":
                case "left":
                case "margin-top":
                case "margin-right":
                case "margin-bottom":
                case "margin-left":
                case "padding-top":
                case "padding-right":
                case "padding-bottom":
                case "padding-left":
                case "min-height":
                case "min-width":
                case "max-height":
                case "max-width":
                case "width":
                case "height":
                case "font-size":
                case "letter-spacing":
                case "line-height":
                case "text-shadow-h":
                case "text-shadow-v":
                case "text-shadow-blur":
                case "border-radius-c":
                case "border-top-left-radius":
                case "border-top-right-radius":
                case "border-bottom-left-radius":
                case "border-bottom-right-radius":
                case "border-width":
                case "box-shadow-h":
                case "box-shadow-v":
                case "box-shadow-blur":
                case "box-shadow-spread":
                case "transition-duration":
                case "perspective":
                case "transform-rotate-x":
                case "transform-rotate-y":
                case "transform-rotate-z":
                case "transform-scale-x":
                case "transform-scale-y":
                case "transform-scale-z":
                case "order":
                case "flex-grow":
                case "flex-shrink":
                case "flex-basis":
                  i.type = "integer";
                  break;
                case "margin":
                case "padding":
                case "border-radius":
                case "border":
                case "transform":
                  i.type = "composite";
                  break;
                case "color":
                case "text-shadow-color":
                case "background-color":
                case "border-color":
                case "box-shadow-color":
                  i.type = "color";
                  break;
                case "text-shadow":
                case "box-shadow":
                case "background":
                case "transition":
                  i.type = "stack";
                  break;
                case "background-image":
                  i.type = "file";
              }
              switch (o) {
                case "float":
                case "background-color":
                case "text-shadow":
                  i.defaults = "none";
                  break;
                case "display":
                  i.defaults = "block";
                  break;
                case "flex-direction":
                  i.defaults = "row";
                  break;
                case "flex-wrap":
                  i.defaults = "nowrap";
                  break;
                case "justify-content":
                  i.defaults = "flex-start";
                  break;
                case "align-items":
                case "align-content":
                  i.defaults = "stretch";
                  break;
                case "align-self":
                  i.defaults = "auto";
                  break;
                case "position":
                  i.defaults = "static";
                  break;
                case "margin-top":
                case "margin-right":
                case "margin-bottom":
                case "margin-left":
                case "padding-top":
                case "padding-right":
                case "padding-bottom":
                case "padding-left":
                case "text-shadow-h":
                case "text-shadow-v":
                case "text-shadow-blur":
                case "border-radius-c":
                case "box-shadow-h":
                case "box-shadow-v":
                case "box-shadow-spread":
                case "perspective":
                case "transform-rotate-x":
                case "transform-rotate-y":
                case "transform-rotate-z":
                case "order":
                case "flex-grow":
                  i.defaults = 0;
                  break;
                case "border-top-left-radius":
                case "border-top-right-radius":
                case "border-bottom-left-radius":
                case "border-bottom-right-radius":
                  i.defaults = "0px";
                  break;
                case "transform-scale-x":
                case "transform-scale-y":
                case "transform-scale-z":
                case "flex-shrink":
                  i.defaults = 1;
                  break;
                case "box-shadow-blur":
                  i.defaults = "5px";
                  break;
                case "top":
                case "right":
                case "bottom":
                case "left":
                case "min-height":
                case "min-width":
                case "max-height":
                case "max-width":
                case "width":
                case "height":
                case "background-size":
                case "cursor":
                case "flex-basis":
                  i.defaults = "auto";
                  break;
                case "font-family":
                  i.defaults = "Arial, Helvetica, sans-serif";
                  break;
                case "font-size":
                case "border-width":
                  i.defaults = "medium";
                  break;
                case "font-weight":
                  i.defaults = "400";
                  break;
                case "letter-spacing":
                case "line-height":
                  i.defaults = "normal";
                  break;
                case "color":
                case "text-shadow-color":
                case "border-color":
                case "box-shadow-color":
                  i.defaults = "black";
                  break;
                case "text-align":
                  i.defaults = "left";
                  break;
                case "border-style":
                  i.defaults = "solid";
                  break;
                case "box-shadow-type":
                  i.defaults = "";
                  break;
                case "background-repeat":
                  i.defaults = "repeat";
                  break;
                case "background-position":
                  i.defaults = "left top";
                  break;
                case "background-attachment":
                  i.defaults = "scroll";
                  break;
                case "transition-property":
                  i.defaults = "width";
                  break;
                case "transition-duration":
                  i.defaults = "2";
                  break;
                case "transition-timing-function":
                  i.defaults = "ease";
                  break;
                case "overflow":
                case "overflow-x":
                case "overflow-y":
                  i.defaults = "visible";
              }
              switch (o) {
                case "flex-direction":
                case "flex-wrap":
                case "justify-content":
                case "align-items":
                case "align-content":
                  i.requires = {
                    display: ["flex"]
                  };
                  break;
                case "order":
                case "flex-basis":
                case "flex-grow":
                case "flex-shrink":
                case "align-self":
                  i.requiresParent = {
                    display: ["flex"]
                  };
              }
              switch (o) {
                case "top":
                case "bottom":
                case "margin-top":
                case "margin-bottom":
                case "padding-top":
                case "padding-bottom":
                case "min-height":
                case "max-height":
                case "height":
                  i.units = ["px", "%", "vh", "em", "rem"];
                  break;
                case "right":
                case "left":
                case "margin-right":
                case "margin-left":
                case "padding-right":
                case "padding-left":
                case "min-width":
                case "max-width":
                case "width":
                  i.units = ["px", "%", "vw", "em", "rem"];
                  break;
                case "flex-basis":
                  i.units = ["px", "%", "vw", "vh"];
                  break;
                case "text-shadow-v":
                case "text-shadow-h":
                case "text-shadow-blur":
                case "border-radius-c":
                case "border-top-left-radius":
                case "border-top-right-radius":
                case "border-bottom-left-radius":
                case "border-bottom-right-radius":
                case "box-shadow-h":
                case "box-shadow-v":
                  i.units = ["px", "%"];
                  break;
                case "font-size":
                case "letter-spacing":
                case "line-height":
                  i.units = ["px", "em", "rem", "%", "vw", "vh"];
                  break;
                case "border-width":
                  i.units = ["px", "em"];
                  break;
                case "box-shadow-blur":
                case "box-shadow-spread":
                case "perspective":
                  i.units = ["px"];
                  break;
                case "transition-duration":
                  i.units = ["s"];
                  break;
                case "transform-rotate-x":
                case "transform-rotate-y":
                case "transform-rotate-z":
                  i.units = ["deg"];
              }
              switch (o) {
                case "padding-top":
                case "padding-right":
                case "padding-bottom":
                case "padding-left":
                case "min-height":
                case "min-width":
                case "max-height":
                case "max-width":
                case "width":
                case "height":
                case "font-size":
                case "text-shadow-blur":
                case "border-radius-c":
                case "border-top-left-radius":
                case "border-top-right-radius":
                case "border-bottom-left-radius":
                case "border-bottom-right-radius":
                case "border-width":
                case "box-shadow-blur":
                case "transition-duration":
                case "perspective":
                case "flex-basis":
                  i.min = 0;
              }
              switch (o) {
                case "text-shadow":
                case "box-shadow":
                case "background":
                  i.preview = !0;
              }
              switch (o) {
                case "background":
                  i.detached = !0;
              }
              switch (o) {
                case "transform-rotate-x":
                  i.functionName = "rotateX";
                  break;
                case "transform-rotate-y":
                  i.functionName = "rotateY";
                  break;
                case "transform-rotate-z":
                  i.functionName = "rotateZ";
                  break;
                case "transform-scale-x":
                  i.functionName = "scaleX";
                  break;
                case "transform-scale-y":
                  i.functionName = "scaleY";
                  break;
                case "transform-scale-z":
                  i.functionName = "scaleZ";
                  break;
                case "background-image":
                  i.functionName = "url";
              }
              switch (o) {
                case "float":
                  i.list = [{
                    value: "none"
                  }, {
                    value: "left"
                  }, {
                    value: "right"
                  }];
                  break;
                case "display":
                  i.list = [{
                    value: "block"
                  }, {
                    value: "inline"
                  }, {
                    value: "inline-block"
                  }, {
                    value: "flex"
                  }, {
                    value: "none"
                  }];
                  break;
                case "flex-direction":
                  i.list = [{
                    value: "row"
                  }, {
                    value: "row-reverse"
                  }, {
                    value: "column"
                  }, {
                    value: "column-reverse"
                  }];
                  break;
                case "flex-wrap":
                  i.list = [{
                    value: "nowrap"
                  }, {
                    value: "wrap"
                  }, {
                    value: "wrap-reverse"
                  }];
                  break;
                case "justify-content":
                  i.list = [{
                    value: "flex-start"
                  }, {
                    value: "flex-end"
                  }, {
                    value: "center"
                  }, {
                    value: "space-between"
                  }, {
                    value: "space-around"
                  }, {
                    value: "space-evenly"
                  }];
                  break;
                case "align-items":
                  i.list = [{
                    value: "flex-start"
                  }, {
                    value: "flex-end"
                  }, {
                    value: "center"
                  }, {
                    value: "baseline"
                  }, {
                    value: "stretch"
                  }];
                  break;
                case "align-content":
                  i.list = [{
                    value: "flex-start"
                  }, {
                    value: "flex-end"
                  }, {
                    value: "center"
                  }, {
                    value: "space-between"
                  }, {
                    value: "space-around"
                  }, {
                    value: "stretch"
                  }];
                  break;
                case "align-self":
                  i.list = [{
                    value: "auto"
                  }, {
                    value: "flex-start"
                  }, {
                    value: "flex-end"
                  }, {
                    value: "center"
                  }, {
                    value: "baseline"
                  }, {
                    value: "stretch"
                  }];
                  break;
                case "position":
                  i.list = [{
                    value: "static"
                  }, {
                    value: "relative"
                  }, {
                    value: "absolute"
                  }, {
                    value: "fixed"
                  }, {
                    value: "sticky"
                  }];
                  break;
                case "font-family":
                  var a = ", sans-serif",
                    s = ["Arial, Helvetica" + a, "Arial Black, Gadget" + a, "Brush Script MT" + a, "Comic Sans MS, cursive" + a, "Courier New, Courier, monospace", "Georgia, serif", "Helvetica" + a, "Impact, Charcoal" + a, "Lucida Sans Unicode, Lucida Grande" + a, "Tahoma, Geneva" + a, "Times New Roman, Times, serif", "Trebuchet MS, Helvetica" + a, "Verdana, Geneva" + a];
                  i.list = [];
                  for (var l = 0, c = s.length; l < c; l++) {
                    var u = {};
                    u.value = s[l], u.name = s[l].split(",")[0], i.list.push(u);
                  }
                  break;
                case "font-weight":
                  i.list = [{
                    value: "100",
                    name: "Thin"
                  }, {
                    value: "200",
                    name: "Extra-Light"
                  }, {
                    value: "300",
                    name: "Light"
                  }, {
                    value: "400",
                    name: "Normal"
                  }, {
                    value: "500",
                    name: "Medium"
                  }, {
                    value: "600",
                    name: "Semi-Bold"
                  }, {
                    value: "700",
                    name: "Bold"
                  }, {
                    value: "800",
                    name: "Extra-Bold"
                  }, {
                    value: "900",
                    name: "Ultra-Bold"
                  }];
                  break;
                case "text-align":
                  i.list = [{
                    value: "left"
                  }, {
                    value: "center"
                  }, {
                    value: "right"
                  }, {
                    value: "justify"
                  }];
                  break;
                case "border-style":
                  i.list = [{
                    value: "none"
                  }, {
                    value: "solid"
                  }, {
                    value: "dotted"
                  }, {
                    value: "dashed"
                  }, {
                    value: "double"
                  }, {
                    value: "groove"
                  }, {
                    value: "ridge"
                  }, {
                    value: "inset"
                  }, {
                    value: "outset"
                  }];
                  break;
                case "box-shadow-type":
                  i.list = [{
                    value: "",
                    name: "Outside"
                  }, {
                    value: "inset",
                    name: "Inside"
                  }];
                  break;
                case "background-repeat":
                  i.list = [{
                    value: "repeat"
                  }, {
                    value: "repeat-x"
                  }, {
                    value: "repeat-y"
                  }, {
                    value: "no-repeat"
                  }];
                  break;
                case "background-position":
                  i.list = [{
                    value: "left top"
                  }, {
                    value: "left center"
                  }, {
                    value: "left bottom"
                  }, {
                    value: "right top"
                  }, {
                    value: "right center"
                  }, {
                    value: "right bottom"
                  }, {
                    value: "center top"
                  }, {
                    value: "center center"
                  }, {
                    value: "center bottom"
                  }];
                  break;
                case "background-attachment":
                  i.list = [{
                    value: "scroll"
                  }, {
                    value: "fixed"
                  }, {
                    value: "local"
                  }];
                  break;
                case "background-size":
                  i.list = [{
                    value: "auto"
                  }, {
                    value: "cover"
                  }, {
                    value: "contain"
                  }];
                  break;
                case "transition-property":
                  i.list = [{
                    value: "all"
                  }, {
                    value: "width"
                  }, {
                    value: "height"
                  }, {
                    value: "background-color"
                  }, {
                    value: "transform"
                  }, {
                    value: "box-shadow"
                  }, {
                    value: "opacity"
                  }];
                  break;
                case "transition-timing-function":
                  i.list = [{
                    value: "linear"
                  }, {
                    value: "ease"
                  }, {
                    value: "ease-in"
                  }, {
                    value: "ease-out"
                  }, {
                    value: "ease-in-out"
                  }];
                  break;
                case "cursor":
                  i.list = [{
                    value: "auto"
                  }, {
                    value: "default"
                  }, {
                    value: "none"
                  }, {
                    value: "initial"
                  }, {
                    value: "inherit"
                  }, {
                    value: "pointer"
                  }, {
                    value: "copy"
                  }, {
                    value: "crosshair"
                  }, {
                    value: "grab"
                  }, {
                    value: "grabbing"
                  }, {
                    value: "help"
                  }, {
                    value: "move"
                  }, {
                    value: "text"
                  }, {
                    value: "context-menu"
                  }, {
                    value: "progress"
                  }, {
                    value: "wait"
                  }, {
                    value: "vertical-text"
                  }, {
                    value: "alias"
                  }, {
                    value: "no-drop"
                  }, {
                    value: "not-allowed"
                  }];
                  break;
                case "overflow":
                case "overflow-x":
                case "overflow-y":
                  i.list = [{
                    value: "visible"
                  }, {
                    value: "hidden"
                  }, {
                    value: "scroll"
                  }, {
                    value: "auto"
                  }];
              }
              switch (o) {
                case "margin":
                  i.properties = this.build(["margin-top", "margin-right", "margin-bottom", "margin-left"]);
                  break;
                case "padding":
                  i.properties = this.build(["padding-top", "padding-right", "padding-bottom", "padding-left"]);
                  break;
                case "text-shadow":
                  i.properties = this.build(["text-shadow-h", "text-shadow-v", "text-shadow-blur", "text-shadow-color"]);
                  break;
                case "border":
                  i.properties = this.build(["border-width", "border-style", "border-color"]);
                  break;
                case "border-radius":
                  i.properties = this.build(["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"]);
                  break;
                case "box-shadow":
                  i.properties = this.build(["box-shadow-h", "box-shadow-v", "box-shadow-blur", "box-shadow-spread", "box-shadow-color", "box-shadow-type"]);
                  break;
                case "background":
                  i.properties = this.build(["background-image", "background-repeat", "background-position", "background-attachment", "background-size"]);
                  break;
                case "transition":
                  i.properties = this.build(["transition-property", "transition-duration", "transition-timing-function"]);
                  break;
                case "transform":
                  i.properties = this.build(["transform-rotate-x", "transform-rotate-y", "transform-rotate-z", "transform-scale-x", "transform-scale-y", "transform-scale-z"]);
              }
              e.push(i);
            }
            return e;
          }
        };
      },
      d = l.a.Model.extend({
        defaults: {
          id: "",
          name: "",
          open: !0,
          buildProps: "",
          extendBuilded: 1,
          properties: []
        },
        initialize: function initialize(t) {
          var e = t || {},
            n = this.buildProperties(e.buildProps),
            r = this.get("name") || "",
            i = [];
          !this.get("id") && this.set("id", r.replace(/ /g, "_").toLowerCase()), i = n ? this.extendProperties(n) : this.get("properties");
          var o = new c.default(i);
          o.sector = this, this.set("properties", o);
        },
        extendProperties: function extendProperties(t, e, n) {
          for (var r = t.length, i = e || this.get("properties"), a = this.get("extendBuilded"), s = [], l = 0, c = i.length; l < c; l++) {
            for (var u = i[l], d = 0, h = 0; h < r; h++) {
              var f = t[h];
              if (u.property != f.property && u.id != f.property) ;else {
                var p = u.properties;
                p && p.length && (u.properties = this.extendProperties(f.properties || [], p, 1)), t[h] = a ? Object(o.extend)(f, u) : u, s[h] = t[h], d = 1;
              }
            }
            d || (t.push(u), s.push(u));
          }
          return n ? s.filter(function (t) {
            return t;
          }) : t;
        },
        buildProperties: function buildProperties(t) {
          var e = t || [];
          if (e.length) return this.propFactory || (this.propFactory = new u()), this.propFactory.build(e);
        }
      }),
      h = l.a.Collection.extend({
        model: d
      }),
      f = n(3),
      p = n(7),
      g = n(19),
      v = l.a.View.extend({
        template: Object(o.template)('\n  <div class="<%= pfx %>title" data-sector-title>\n    <i id="<%= pfx %>caret" class="fa"></i>\n    <%= label %>\n  </div>'),
        events: {
          "click [data-sector-title]": "toggle"
        },
        initialize: function initialize(t) {
          this.config = t.config || {}, this.em = this.config.em, this.pfx = this.config.stylePrefix || "", this.target = t.target || {}, this.propTarget = t.propTarget || {}, this.caretR = "fa-caret-right", this.caretD = "fa-caret-down";
          var e = this.model;
          this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "updateVisibility", this.updateVisibility), this.listenTo(e, "destroy remove", this.remove);
        },
        updateVisibility: function updateVisibility() {
          var t;
          this.model.get("properties").each(function (e) {
            e.get("visible") && (t = 1);
          }), this.el.style.display = t ? "block" : "none";
        },
        updateOpen: function updateOpen() {
          this.model.get("open") ? this.show() : this.hide();
        },
        show: function show() {
          this.$el.addClass(this.pfx + "open"), this.getPropertiesEl().style.display = "", this.$caret.removeClass(this.caretR).addClass(this.caretD);
        },
        hide: function hide() {
          this.$el.removeClass(this.pfx + "open"), this.getPropertiesEl().style.display = "none", this.$caret.removeClass(this.caretD).addClass(this.caretR);
        },
        getPropertiesEl: function getPropertiesEl() {
          return this.$el.find(".".concat(this.pfx, "properties")).get(0);
        },
        toggle: function toggle(t) {
          var e = this.model.get("open") ? 0 : 1;
          this.model.set("open", e);
        },
        render: function render() {
          var t = this.pfx,
            e = this.model,
            n = this.em,
            r = this.$el,
            i = e.attributes,
            o = i.id,
            a = i.name,
            s = n && n.t("styleManager.sectors.".concat(o)) || a;
          return r.html(this.template({
            pfx: t,
            label: s
          })), this.$caret = r.find("#".concat(t, "caret")), this.renderProperties(), r.attr("class", "".concat(t, "sector ").concat(t, "sector__").concat(o, " no-select")), this.updateOpen(), this;
        },
        renderProperties: function renderProperties() {
          var t = this.model.get("properties");
          if (t) {
            var e = new g.default({
              collection: t,
              target: this.target,
              propTarget: this.propTarget,
              config: this.config
            });
            this.$el.append(e.render().el);
          }
        }
      });
    function m(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function b(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? m(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var y = l.a.View.extend({
      initialize: function initialize() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          e = t.config || {};
        this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.target = t.target || {}, this.config = e;
        var n = {};
        Object(o.extend)(n, l.a.Events);
        var r = document.body,
          i = document.createElement("el-".concat(new Date().getTime()));
        r.appendChild(i), n.computedDefault = b({}, window.getComputedStyle(i)), r.removeChild(i), this.propTarget = n;
        var a = this.collection,
          s = "component:toggled component:update:classes change:state change:device frame:resized";
        this.listenTo(a, "add", this.addTo), this.listenTo(a, "reset", this.render), this.listenTo(this.target, s, this.targetUpdated);
      },
      addTo: function addTo(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        this.addToCollection(t, null, n);
      },
      toggleStateCls: function toggleStateCls() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          e = arguments.length > 1 ? arguments[1] : void 0;
        t.forEach(function (t) {
          var n = t.getEl();
          n && n.classList && n.classList[e ? "add" : "remove"]("hc-state");
        });
      },
      targetUpdated: function targetUpdated(t) {
        var e = this.target,
          n = this.propTarget,
          r = e.getSelectedAll(),
          i = e.getSelected(),
          o = t && t.toHTML ? t : i;
        if (o && this.toggleStateCls([o]), i) {
          var a = e.get("Config").devicePreviewMode ? "" : e.get("state"),
            s = e.get("SelectorManager").getConfig().componentFirst,
            l = i.getEl();
          if (n.helper = null, n.targets = null, l && Object(f.p)(l)) {
            var c = a ? ":".concat(a) : null;
            n.computed = window.getComputedStyle(l, c);
          }
          i = e.get("StyleManager").getModelToStyle(i), a && (!function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = e.get("CssComposer"),
              i = r.getAll(),
              o = r.getClassRule("hc-state");
            o ? (i.remove(o), i.add(o)) : o = r.setClassRule("hc-state"), o.set("important", 1), o.setStyle(t), n.helper = o;
          }(i.getStyle()), this.toggleStateCls(r, 1)), n.model = i, s && (n.targets = r), n.trigger("update");
        }
      },
      setTarget: function setTarget(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = this.target,
          r = Object(o.isArray)(t) ? t : [t],
          i = e.targetIsClass,
          a = e.stylable,
          s = [];
        r.forEach(function (t) {
          var e = t;
          if (Object(o.isString)(t)) {
            var r,
              l = n.get("CssComposer").getAll();
            i && (r = l.filter(function (e) {
              return e.get("selectors").getFullString() === t;
            })[0]), r || (r = l.filter(function (e) {
              return e.get("selectorsAdd") === t;
            })[0]), r || (r = l.add({
              selectors: [],
              selectorsAdd: t
            })), a && r.set({
              stylable: a
            }), e = r;
          }
          s.push(e);
        });
        var l = this.propTarget;
        return l.targets = s, l.trigger("update"), s;
      },
      addToCollection: function addToCollection(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = this.pfx,
          i = this.target,
          o = this.propTarget,
          a = this.config,
          s = this.el,
          l = e || s,
          c = new v({
            model: t,
            id: "".concat(r).concat(t.get("id")),
            name: t.get("name"),
            properties: t.get("properties"),
            target: i,
            propTarget: o,
            config: a
          }).render().el;
        return Object(p.b)(l, c, n.at), c;
      },
      render: function render() {
        var t = this,
          e = document.createDocumentFragment(),
          n = this.$el,
          r = this.pfx,
          i = this.ppfx;
        return n.empty(), this.collection.each(function (n) {
          return t.addToCollection(n, e);
        }), n.append(e), n.addClass("".concat(r, "sectors ").concat(i, "one-bg ").concat(i, "two-color")), this;
      }
    });
    function w(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function x(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? w(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : w(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n,
        r = {};
      return {
        name: "StyleManager",
        getConfig: function getConfig() {
          return r;
        },
        init: function init(i) {
          var o = (r = x(x({}, a), i)).pStylePrefix;
          return this.em = r.em, o && (r.stylePrefix = o + r.stylePrefix), t = new c.default(), e = new h([], r), n = new y({
            collection: e,
            target: r.em,
            config: r
          }), this;
        },
        onLoad: function onLoad() {
          e.add(r.sectors, {
            silent: !0
          });
        },
        postRender: function postRender() {
          var t = this.getConfig().appendTo;
          t && (Object(o.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
        },
        addSector: function addSector(t, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = this.getSector(t);
          return i || (n.id = t, i = e.add(n, r)), i;
        },
        getSector: function getSector(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = e.where({
              id: t
            })[0];
          return !r && n.warn && this._logNoSector(t), r;
        },
        removeSector: function removeSector(t) {
          return this.getSectors().remove(this.getSector(t, {
            warn: 1
          }));
        },
        getSectors: function getSectors() {
          return e;
        },
        addProperty: function addProperty(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.getSector(t, {
              warn: 1
            }),
            i = null;
          return r && (i = r.get("properties").add(e, n)), i;
        },
        getProperty: function getProperty(t, e) {
          var n,
            r = this.getSector(t, {
              warn: 1
            });
          return r && (n = r.get("properties").filter(function (t) {
            return t.get("property") === e || t.get("id") === e;
          })[0]), n || null;
        },
        removeProperty: function removeProperty(t, e) {
          var n = this.getProperties(t);
          return n && n.remove(this.getProperty(t, e));
        },
        getProperties: function getProperties(t) {
          var e = null,
            n = this.getSector(t, {
              warn: 1
            });
          return n && (e = n.get("properties")), e;
        },
        getModelToStyle: function getModelToStyle(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = r.em,
            i = e.skipAdd,
            o = t.get("classes"),
            a = t.getId();
          if (n) {
            var s,
              l = n.getConfig(),
              c = n.get("UndoManager"),
              u = n.get("CssComposer"),
              d = n.get("SelectorManager"),
              h = d ? d.getConfig() : {},
              f = l.devicePreviewMode ? "" : n.get("state"),
              p = o.getStyleable(),
              g = p.length,
              v = !h.componentFirst || e.useClasses,
              m = {
                state: f
              };
            if (c.stop(), g && v) {
              var b = n.getCurrentMedia();
              (s = u.get(p, f, b)) || i || (s = u.add(p, f, b));
            } else l.avoidInlineStyle && (!(s = u.getIdRule(a, m)) && !i && (s = u.setIdRule(a, {}, m)), t.is("wrapper") && s.set("wrapper", 1));
            s && (t = s), c.start();
          }
          return t;
        },
        addType: function addType(e, n) {
          t.addType(e, n);
        },
        getType: function getType(e) {
          return t.getType(e);
        },
        getTypes: function getTypes() {
          return t.getTypes();
        },
        createType: function createType(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = e.model,
            i = void 0 === n ? {} : n,
            o = e.view,
            a = void 0 === o ? {} : o,
            s = this.getType(t);
          if (s) return new s.view(x({
            model: new s.model(i),
            config: r
          }, a));
        },
        setTarget: function setTarget(t, e) {
          return n.setTarget(t, e);
        },
        getEmitter: function getEmitter() {
          return n.propTarget;
        },
        render: function render() {
          return n.render().el;
        },
        _logNoSector: function _logNoSector(t) {
          var e = this.em;
          e && e.logWarning("'".concat(t, "' sector not found"));
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
      i = {
        stylePrefix: "cm-",
        inlineCss: !1
      },
      o = n(2),
      a = n.n(o),
      s = n(1),
      l = n.n(s);
    function c(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function u(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? c(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var d = l.a.Model.extend({
        build: function build(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.get("components");
          return e.exportWrapper ? t.toHTML(u({}, e.wrapperIsBody && {
            tag: "body"
          })) : this.buildModels(n);
        },
        buildModels: function buildModels(t) {
          var e = "";
          return t.each(function (t) {
            e += t.toHTML();
          }), e;
        }
      }),
      h = n(31),
      f = l.a.Model.extend({
        build: function build(t) {
          var e = t.toJSON();
          return this.beforeEach(e), Object(r.each)(e, function (t, n) {
            var r = e[n];
            if (r instanceof l.a.Model) e[n] = this.build(r);else if (r instanceof l.a.Collection) {
              var i = r;
              e[n] = [], i.length && i.each(function (t, r) {
                e[n][r] = this.build(t);
              }, this);
            }
          }, this), e;
        },
        beforeEach: function beforeEach(t) {
          delete t.status;
        }
      }),
      p = l.a.Model.extend({
        mapModel: function mapModel(t) {
          var e = "",
            n = t.get("script-export") || t.get("script"),
            i = t.get("type"),
            o = t.get("components"),
            a = t.getId();
          if (n) {
            var s = t.get("attributes");
            s = Object(r.extend)({}, s, {
              id: a
            }), t.set("attributes", s, {
              silent: 1
            });
            var l = t.getScriptString(n);
            if (t.get("scriptUpdated")) this.mapJs[i + "-" + a] = {
              ids: [a],
              code: l
            };else {
              var c = this.mapJs[i];
              c ? c.ids.push(a) : this.mapJs[i] = {
                ids: [a],
                code: l
              };
            }
          }
          return o.each(function (t) {
            e += this.mapModel(t);
          }, this), e;
        },
        build: function build(t) {
          this.mapJs = {}, this.mapModel(t);
          var e = "";
          for (var n in this.mapJs) {
            var r = this.mapJs[n],
              i = "#" + r.ids.join(", #");
            e += "\n        var items = document.querySelectorAll('".concat(i, "');\n        for (var i = 0, len = items.length; i < len; i++) {\n          (function(){").concat(r.code, "}.bind(items[i]))();\n        }");
          }
          return e;
        }
      }),
      g = n(13),
      v = n.n(g);
    n(91), n(45), n(94);
    function m(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    var b = l.a.Model.extend({
        defaults: {
          input: "",
          label: "",
          codeName: "",
          theme: "hopscotch",
          readOnly: !0,
          lineNumbers: !0
        },
        init: function init(t) {
          return Object(r.bindAll)(this, "onChange"), this.editor = v.a.fromTextArea(t, function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? m(Object(n), !0).forEach(function (e) {
                a()(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }
            return t;
          }({
            dragDrop: !1,
            lineWrapping: !0,
            mode: this.get("codeName")
          }, this.attributes)), this.element = t, this.editor.on("change", this.onChange), this;
        },
        onChange: function onChange() {
          this.trigger("update", this);
        },
        getEditor: function getEditor() {
          return this.editor;
        },
        getElement: function getElement() {
          return this.element;
        },
        setElement: function setElement(t) {
          return this.element = t, this;
        },
        refresh: function refresh() {
          return this.getEditor().refresh(), this;
        },
        focus: function focus() {
          return this.getEditor().focus(), this;
        },
        getContent: function getContent() {
          var t = this.getEditor();
          return t && t.getValue();
        },
        setContent: function setContent(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = this.editor;
          r && (r.setValue(t), r.autoFormatRange && (v.a.commands.selectAll(r), r.autoFormatRange(r.getCursor(!0), r.getCursor(!1)), v.a.commands.goDocStart(r)), !n.noRefresh && setTimeout(function () {
            return e.refresh();
          }));
        }
      }),
      y = l.a.View.extend({
        template: Object(r.template)('\n  <div class="<%= pfx %>editor" id="<%= pfx %><%= codeName %>">\n  \t<div id="<%= pfx %>title"><%= label %></div>\n  \t<div id="<%= pfx %>code"></div>\n  </div>'),
        initialize: function initialize(t) {
          this.config = t.config || {}, this.pfx = this.config.stylePrefix;
        },
        render: function render() {
          var t = this.model.toJSON();
          return t.pfx = this.pfx, this.$el.html(this.template(t)), this.$el.attr("class", this.pfx + "editor-c"), this.$el.find("#" + this.pfx + "code").append(this.model.get("input")), this;
        }
      });
    e.default = function () {
      var t = {},
        e = {},
        n = {},
        o = {},
        a = {};
      return {
        getConfig: function getConfig() {
          return t;
        },
        config: t,
        EditorView: y,
        name: "CodeManager",
        init: function init(e) {
          for (var r in t = e || {}, i) r in t || (t[r] = i[r]);
          var o = t.pStylePrefix;
          return o && (t.stylePrefix = o + t.stylePrefix), n.html = new d(), n.css = new h.a(), n.json = new f(), n.js = new p(), a.CodeMirror = new b(), this.loadDefaultGenerators().loadDefaultViewers(), this;
        },
        addGenerator: function addGenerator(t, n) {
          return e[t] = n, this;
        },
        getGenerator: function getGenerator(t) {
          return e[t] || null;
        },
        getGenerators: function getGenerators() {
          return e;
        },
        addViewer: function addViewer(t, e) {
          return o[t] = e, this;
        },
        getViewer: function getViewer(t) {
          return o[t] || null;
        },
        getViewers: function getViewers() {
          return o;
        },
        createViewer: function createViewer() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = Object(r.isUndefined)(t.type) ? "CodeMirror" : t.type,
            n = this.getViewer(e) && this.getViewer(e).clone();
          console.log("Creating div element codemanager:index");
          var i = document.createElement("div"),
            o = document.createElement("textarea");
          return i.appendChild(o), n.set(t), n.init(o), n.setElement(i), n;
        },
        updateViewer: function updateViewer(t, e) {
          t.setContent(e);
        },
        getCode: function getCode(e, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          r.em = t.em;
          var i = this.getGenerator(n);
          return i ? i.build(e, r) : "";
        },
        loadDefaultGenerators: function loadDefaultGenerators() {
          for (var t in n) this.addGenerator(t, n[t]);
          return this;
        },
        loadDefaultViewers: function loadDefaultViewers() {
          for (var t in a) this.addViewer(t, a[t]);
          return this;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = {
        devices: []
      },
      a = n(1),
      s = n.n(a),
      l = s.a.Model.extend({
        idAttribute: "name",
        defaults: {
          name: "",
          width: null,
          height: "",
          widthMedia: null,
          priority: null
        },
        initialize: function initialize() {
          var t = this;
          null === this.get("widthMedia") && this.set("widthMedia", this.get("width")), null === this.get("width") && this.set("width", this.get("widthMedia")), !this.get("priority") && this.set("priority", parseFloat(this.get("widthMedia")) || 0);
          ["width", "height", "widthMedia"].forEach(function (e) {
            return t.checkUnit(e);
          });
        },
        checkUnit: function checkUnit(t) {
          var e = this.get(t) || "";
          (parseFloat(e) || 0).toString() === e.toString() && this.set(t, "".concat(e, "px"));
        }
      }),
      c = s.a.Collection.extend({
        model: l,
        comparator: function comparator(t, e) {
          var n = Number.MAX_VALUE;
          return (e.get("priority") || n) - (t.get("priority") || n);
        },
        getSorted: function getSorted() {
          return this.sort();
        }
      }),
      u = n(0),
      d = s.a.View.extend({
        template: Object(u.template)('\n    <div class="<%= ppfx %>device-label"><%= deviceLabel %></div>\n    <div class="<%= ppfx %>field <%= ppfx %>select">\n      <span id="<%= ppfx %>input-holder">\n        <select class="<%= ppfx %>devices"></select>\n      </span>\n      <div class="<%= ppfx %>sel-arrow">\n        <div class="<%= ppfx %>d-s-arrow"></div>\n      </div>\n    </div>\n    <button style="display:none" class="<%= ppfx %>add-trasp">+</button>'),
        events: {
          change: "updateDevice"
        },
        initialize: function initialize(t) {
          this.config = t.config || {}, this.em = this.config.em, this.ppfx = this.config.pStylePrefix || "", this.events["click ." + this.ppfx + "add-trasp"] = this.startAdd, this.listenTo(this.em, "change:device", this.updateSelect), this.delegateEvents();
        },
        startAdd: function startAdd() {},
        updateDevice: function updateDevice() {
          var t = this.em;
          if (t) {
            var e = this.devicesEl,
              n = e ? e.val() : "";
            t.set("device", n);
          }
        },
        updateSelect: function updateSelect() {
          var t = this.em,
            e = this.devicesEl;
          if (t && t.getDeviceModel && e) {
            var n = t.getDeviceModel(),
              r = n ? n.get("name") : "";
            e.val(r);
          }
        },
        getOptions: function getOptions() {
          var t = this.collection,
            e = this.em,
            n = "";
          return t.each(function (t) {
            var r = t.attributes,
              i = r.name,
              o = r.id,
              a = e && e.t && e.t("deviceManager.devices.".concat(o)) || i;
            n += '<option value="'.concat(i, '">').concat(a, "</option>");
          }), n;
        },
        render: function render() {
          var t = this.em,
            e = this.ppfx,
            n = this.$el,
            r = this.el;
          return n.html(this.template({
            ppfx: e,
            deviceLabel: t && t.t && t.t("deviceManager.device")
          })), this.devicesEl = n.find(".".concat(e, "devices")), this.devicesEl.append(this.getOptions()), r.className = "".concat(e, "devices-c"), this;
        }
      });
    function h(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function f(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? h(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n = {};
      return {
        name: "DeviceManager",
        init: function init(r) {
          var i = this;
          for (var a in n = r || {}, o) a in n || (n[a] = o[a]);
          return t = new c(), (n.devices || []).forEach(function (t) {
            return i.add(t.id || t.name, t.width, t);
          }), e = new d({
            collection: t,
            config: n
          }), this;
        },
        add: function add(e, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = f(f({}, r), {}, {
              id: e,
              name: r.name || e,
              width: n
            });
          return t.add(i);
        },
        get: function get(e) {
          return t.get(e);
        },
        getAll: function getAll() {
          return t;
        },
        render: function render() {
          return e.render().el;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = {
        id: "gjs-",
        autosave: 1,
        autoload: 1,
        type: "local",
        stepsBeforeSave: 1,
        storeComponents: 1,
        storeStyles: 1,
        storeHtml: 1,
        storeCss: 1,
        checkLocal: 1,
        params: {},
        headers: {},
        urlStore: "",
        urlLoad: "",
        beforeSend: function beforeSend(t, e) {},
        onComplete: function onComplete(t, e) {},
        contentTypeJson: !0,
        credentials: "include",
        fetchOptions: ""
      },
      a = n(1),
      s = n.n(a),
      l = s.a.Model.extend({
        defaults: {
          checkLocal: !0
        },
        store: function store(t, e) {
          for (var n in this.checkStorageEnvironment(), t) localStorage.setItem(n, t[n]);
          "function" == typeof e && e();
        },
        load: function load(t, e) {
          this.checkStorageEnvironment();
          for (var n = {}, r = 0, i = t.length; r < i; r++) {
            var o = localStorage.getItem(t[r]);
            o && (n[t[r]] = o);
          }
          return "function" == typeof e && e(n), n;
        },
        remove: function remove(t) {
          this.checkStorageEnvironment();
          for (var e = 0, n = t.length; e < n; e++) localStorage.removeItem(t[e]);
        },
        checkStorageEnvironment: function checkStorageEnvironment() {
          this.get("checkLocal") && !localStorage && console.warn("Your browser doesn't support localStorage");
        }
      }),
      c = n(28),
      u = n(0);
    function d(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function h(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? d(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var f = s.a.Model.extend({
      fetch: c.a,
      defaults: {
        urlStore: "",
        urlLoad: "",
        params: {},
        beforeSend: function beforeSend() {},
        onComplete: function onComplete() {},
        contentTypeJson: !1,
        credentials: "include",
        fetchOptions: ""
      },
      onStart: function onStart() {
        this.get("em");
        var t = this.get("beforeSend");
        t && t();
      },
      onError: function onError(t, e) {
        var n = document.querySelector(".btn-save");
        if (t ? n.classList.add("text-warning") : n.classList.remove("text-warning"), e) {
          var r = this.get("em");
          r && r.logError(t), e(t);
        } else {
          var i = this.get("em");
          console.error(t), i && i.logError(t), i && i.trigger("storage:error", t);
        }
      },
      onResponse: function onResponse(t, e) {
        var n = this.get("em"),
          r = this.get("onComplete"),
          i = this.get("contentTypeJson") && t && "string" == typeof t ? JSON.parse(t) : t;
        r && r(i), e && e(i), n && n.trigger("storage:response", i);
      },
      store: function store(t, e, n) {
        var r = {};
        for (var i in t) r[i] = t[i];
        var o = this.get("urlStore");
        this.get("isDeleteContent") && (o += "/delete"), this.request(o, {
          body: r
        }, e, n), this.resetAttributes();
      },
      resetAttributes: function resetAttributes() {
        this.set("isDeleteContent", !1);
      },
      load: function load(t, e, n) {
        this.request(this.get("urlLoad"), {
          method: "get"
        }, e, n);
      },
      request: function request(t) {
        var e,
          n,
          r = this,
          i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
          s = this.get("contentTypeJson"),
          l = this.get("headers") || {},
          c = this.get("params"),
          d = "X-Requested-With",
          f = "Content-Type",
          p = i.body || {};
        for (var g in c) p[g] = c[g];
        if (Object(u.isUndefined)(l[d]) && (l[d] = "XMLHttpRequest"), Object(u.isUndefined)(l[f]) && s && (l[f] = "application/json; charset=utf-8"), s) n = JSON.stringify(p);else for (var v in n = new FormData(), p) n.append(v, p[v]);
        "post" === (e = {
          method: i.method || "post",
          credentials: this.get("credentials"),
          headers: l
        }).method && (e.body = n);
        var m = this.get("fetchOptions") || {},
          b = Object(u.isFunction)(m) ? m(e) : e;
        this.onStart(), this.fetch(t, h(h({}, e), b || {})).then(function (t) {
          return 1 == (t.status / 200 | 0) ? t.text() : t.text().then(function (t) {
            return Promise.reject(t);
          });
        }).then(function (t) {
          return r.onResponse(t, o);
        }).catch(function (t) {
          return r.onError(t, a);
        });
      }
    });
    function p(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function g(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? p(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e = {},
        n = {},
        r = {};
      return {
        name: "StorageManager",
        init: function init() {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return e = g(g({}, o), n), t = e.em, e._disable && (e.type = 0), r.remote = new f(e), r.local = new l(e), e.currentStorage = e.type, this.loadDefaultProviders().setCurrent(e.type), this;
        },
        getConfig: function getConfig() {
          return e;
        },
        isAutosave: function isAutosave() {
          return !!e.autosave;
        },
        setAutosave: function setAutosave(t) {
          return e.autosave = !!t, this;
        },
        getStepsBeforeSave: function getStepsBeforeSave() {
          return e.stepsBeforeSave;
        },
        setStepsBeforeSave: function setStepsBeforeSave(t) {
          return e.stepsBeforeSave = t, this;
        },
        add: function add(t, e) {
          return n[t] = e, this;
        },
        get: function get(t) {
          return n[t] || null;
        },
        getStorages: function getStorages() {
          return n;
        },
        getCurrent: function getCurrent() {
          return e.currentStorage;
        },
        setCurrent: function setCurrent(t) {
          return e.currentStorage = t, this;
        },
        store: function store(t, n) {
          var r = this,
            i = this.get(this.getCurrent()),
            o = {};
          for (var a in this.onStart("store", t), t) o[e.id + a] = t[a];
          return i ? i.store(o, function (t) {
            n && n(t), r.onEnd("store", t);
          }, function (t) {
            r.onError("store", t);
          }) : null;
        },
        load: function load(t, n) {
          var r = this,
            i = this.get(this.getCurrent()),
            o = [],
            a = {};
          "string" == typeof t && (t = [t]), this.onStart("load", t);
          for (var s = 0, l = t.length; s < l; s++) o.push(e.id + t[s]);
          i ? i.load(o, function (t) {
            var i = new RegExp("^" + e.id);
            for (var o in t) {
              var s = o.replace(i, "");
              a[s] = t[o];
            }
            n && n(a), r.onEnd("load", a);
          }, function (t) {
            n && n(a), r.onError("load", t);
          }) : n && n(a);
        },
        loadDefaultProviders: function loadDefaultProviders() {
          for (var t in r) this.add(t, r[t]);
          return this;
        },
        getCurrentStorage: function getCurrentStorage() {
          return this.get(this.getCurrent());
        },
        onStart: function onStart(e, n) {
          t && (t.trigger("storage:start"), e && t.trigger("".concat("storage:start", ":").concat(e), n));
        },
        onEnd: function onEnd(e, n) {
          t && (t.trigger("storage:end"), e && t.trigger("".concat("storage:end", ":").concat(e), n));
        },
        onError: function onError(e, n) {
          t && (t.trigger("storage:error", n), e && t.trigger("".concat("storage:error", ":").concat(e), n), this.onEnd(e, n));
        },
        canAutoload: function canAutoload() {
          return this.getCurrentStorage() && this.getConfig().autoload;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = {
        textTags: ["br", "b", "i", "u", "a", "ul", "ol"],
        parserCss: null,
        parserHtml: null
      },
      a = n(0),
      s = {
        4: "media",
        5: "font-face",
        6: "page",
        7: "keyframes",
        11: "counter-style",
        12: "supports",
        13: "document",
        14: "font-feature-values",
        15: "viewport"
      },
      l = Object(a.keys)(s),
      c = ["5", "6", "11", "15"],
      u = ["font-face", "page", "counter-style", "viewport"],
      d = function d() {
        for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", e = [], n = [], r = t.split(","), i = 0, o = r.length; i < o; i++) {
          var a = r[i].trim();
          if (/^(\.{1}[\w\-]+)+(:{1,2}[\w\-()]+)?$/gi.test(a) || /^(#{1}[\w\-]+){1}(:{1,2}[\w\-()]+)?$/gi.test(a)) {
            var s = a.split(".").filter(Boolean);
            n.push(s);
          } else e.push(a);
        }
        return {
          result: n,
          add: e
        };
      },
      h = function h(t) {
        for (var e = t.style, n = {}, r = 0, i = e.length; r < i; r++) {
          var o = e[r],
            a = e.getPropertyValue(o),
            s = e.getPropertyPriority(o);
          n[o] = "".concat(a).concat(s ? " !".concat(s) : "");
        }
        return n;
      },
      f = function f(t) {
        return (t.conditionText || t.media && t.media.mediaText || t.name || t.selectorText || "").trim();
      },
      p = function p(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = {},
          i = t.length,
          o = t[i - 1],
          a = o ? o.split(/:(.+)/) : [],
          s = a[1],
          l = n.atRule,
          c = n.selectorsAdd,
          d = n.mediaText,
          h = u.indexOf(l) >= 0;
        return h && (r.singleAtRule = 1), l && (r.atRuleType = l), c && (r.selectorsAdd = c), d && (r.mediaText = d), s && (t[i - 1] = a[0], r.state = s, a.splice(a.length - 1, 1)), r.selectors = t, r.style = e, r;
      },
      g = function g(t) {
        var e = document.createElement("style");
        e.innerHTML = t, document.head.appendChild(e);
        var n = e.sheet;
        return document.head.removeChild(e), function t(e) {
          for (var n = [], r = e.cssRules || [], i = 0, o = r.length; i < o; i++) {
            var a = r[i],
              u = a.type.toString(),
              g = 0,
              v = "",
              m = "",
              b = a.selectorText || a.keyText,
              y = c.indexOf(u) >= 0;
            if (y) g = 1, v = s[u], m = f(a);else if (l.indexOf(u) >= 0) {
              var w = t(a);
              m = f(a);
              for (var x = 0, O = w.length; x < O; x++) {
                var C = w[x];
                m && (C.mediaText = m), C.atRuleType = s[u];
              }
              n = n.concat(w);
            }
            if (b || y) {
              for (var S = h(a), k = d(b), j = k.add, T = void 0, P = 0, E = (b = k.result).length; P < E; P++) {
                var D = p(b[P], S, {
                  atRule: s[u]
                });
                n.push(D), T = D;
              }
              if (j.length) {
                var M = j.join(", ");
                if (T) T.selectorsAdd = M;else {
                  var A = {
                    selectors: [],
                    selectorsAdd: M,
                    style: S
                  };
                  g && (A.singleAtRule = g), v && (A.atRuleType = v), m && (A.mediaText = m), n.push(A);
                }
              }
            }
          }
          return n;
        }(n);
      },
      v = function v() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return {
          parse: function parse(e) {
            var n = this,
              r = [],
              i = t.parserCss,
              o = t.em,
              a = void 0 === o ? {} : o,
              s = a && a.get && a.get("Editor");
            return (i ? i(e, s) : g(e)).forEach(function (t) {
              return r = r.concat(n.checkNode(t));
            }), r;
          },
          checkNode: function checkNode(t) {
            var e = t,
              n = e.selectors,
              r = e.style;
            if (Object(a.isString)(n)) {
              var i = [],
                o = d(n),
                s = o.result,
                l = o.add.join(", "),
                c = {
                  atRule: t.atRule,
                  mediaText: t.params
                };
              if (s.length ? s.forEach(function (t) {
                i.push(p(t, r, c));
              }) : i.push(p([], r, c)), l) i[i.length - 1].selectorsAdd = l;
              t = i;
            }
            return t;
          }
        };
      },
      m = n(29);
    function b(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function y(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? b(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n = {};
      return {
        compTypes: "",
        parserCss: null,
        parserHtml: null,
        name: "Parser",
        getConfig: function getConfig() {
          return n;
        },
        init: function init() {
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return (n = y(y({}, o), r)).Parser = this, t = new m.a(n), e = new v(n), this.em = n.em, this.parserCss = e, this.parserHtml = t, this;
        },
        parseHtml: function parseHtml(n) {
          var r = this.em,
            i = this.compTypes;
          return t.compTypes = r ? r.get("DomComponents").getTypes() : i, t.parse(n, e);
        },
        parseCss: function parseCss(t) {
          return e.parse(t);
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(0),
      a = n(3),
      s = {
        stylePrefix: "clm-",
        appendTo: "",
        selectors: [],
        states: [{
          name: "hover"
        }, {
          name: "active"
        }, {
          name: "nth-of-type(2n)"
        }],
        escapeName: 0,
        selectedName: 0,
        iconAdd: '<svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg>',
        iconSync: '<svg viewBox="0 0 24 24"><path d="M12 18c-3.31 0-6-2.69-6-6 0-1 .25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4m0-11V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8z"></path></svg>',
        iconTagOn: '<svg viewBox="0 0 24 24"><path d="M19 19H5V5h10V3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8h-2m-11.09-.92L6.5 11.5 11 16 21 6l-1.41-1.42L11 13.17l-3.09-3.09z"></path></svg>',
        iconTagOff: '<svg viewBox="0 0 24 24"><path d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14z"></path></svg>',
        iconTagRemove: '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg>',
        render: 0,
        componentFirst: 0
      },
      l = n(10),
      c = n(12),
      u = n(9),
      d = n.n(u),
      h = n(1),
      f = n.n(h),
      p = f.a.View.extend({
        template: function template() {
          var t = this.pfx,
            e = this.model,
            n = this.config,
            r = e.get("label") || "";
          return '\n      <span id="'.concat(t, 'checkbox" class="').concat(t, 'tag-status" data-tag-status></span>\n      <span id="').concat(t, 'tag-label" data-tag-name>').concat(r, '</span>\n      <span id="').concat(t, 'close" class="').concat(t, 'tag-close" data-tag-remove>\n        ').concat(n.iconTagRemove, "\n      </span>\n    ");
        },
        events: {
          "click [data-tag-remove]": "removeTag",
          "click [data-tag-status]": "changeStatus",
          "dblclick [data-tag-name]": "startEditTag",
          "focusout [data-tag-name]": "endEditTag"
        },
        initialize: function initialize(t) {
          var e = t.config || {};
          this.config = e, this.coll = t.coll || null, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.em = e.em, this.listenTo(this.model, "change:active", this.updateStatus);
        },
        getInputEl: function getInputEl() {
          return this.inputEl || (this.inputEl = this.el.querySelector("[data-tag-name]")), this.inputEl;
        },
        startEditTag: function startEditTag() {
          var t = this.em,
            e = this.getInputEl();
          e.contentEditable = !0, e.focus(), t && t.setEditing(1);
        },
        endEditTag: function endEditTag() {
          var t = this.model,
            e = this.getInputEl(),
            n = e.textContent,
            r = this.em,
            i = r && r.get("SelectorManager");
          if (e.contentEditable = !1, r && r.setEditing(0), i) {
            var o = i.escapeName(n);
            i.get(o) ? e.innerText = t.get("label") : t.set({
              name: o,
              label: n
            });
          }
        },
        changeStatus: function changeStatus() {
          var t = this.model;
          t.set("active", !t.get("active"));
        },
        removeTag: function removeTag() {
          var t = this.em,
            e = this.model;
          (t && t.getSelectedAll()).forEach(function (t) {
            !e.get("protected") && t && t.getSelectors().remove(e);
          });
        },
        updateStatus: function updateStatus() {
          var t = this.model,
            e = this.$el,
            n = this.config,
            r = n.iconTagOn,
            i = n.iconTagOff,
            o = e.find("[data-tag-status]");
          t.get("active") ? (o.html(r), e.removeClass("opac50")) : (o.html(i), e.addClass("opac50"));
        },
        render: function render() {
          var t = this.pfx,
            e = this.ppfx;
          return this.$el.html(this.template()), this.$el.attr("class", "".concat(t, "tag ").concat(e, "three-bg")), this.updateStatus(), this;
        }
      }),
      g = f.a.View.extend({
        template: function template(t) {
          var e = t.labelInfo,
            n = t.labelStates,
            r = t.labelHead,
            i = t.iconSync,
            o = t.iconAdd,
            a = t.pfx,
            s = t.ppfx;
          return '\n    <div id="'.concat(a, 'up" class="').concat(a, 'header">\n      <div id="').concat(a, 'label" class="').concat(a, 'header-label">').concat(r, '</div>\n      <div id="').concat(a, 'status-c" class="').concat(a, 'header-status">\n        <span id="').concat(a, 'input-c" data-states-c>\n          <div class="').concat(s, "field ").concat(s, 'select">\n            <span id="').concat(s, 'input-holder">\n              <select id="').concat(a, 'states" data-states>\n                <option value="">').concat(n, '</option>\n              </select>\n            </span>\n            <div class="').concat(s, 'sel-arrow">\n              <div class="').concat(s, 'd-s-arrow"></div>\n            </div>\n          </div>\n        </span>\n      </div>\n    </div>\n    <div id="').concat(a, 'tags-field" class="').concat(s, 'field">\n      <div id="').concat(a, 'tags-c" data-selectors></div>\n      <input id="').concat(a, 'new" data-input/>\n      <span id="').concat(a, 'add-tag" class="').concat(a, "tags-btn ").concat(a, 'tags-btn__add" data-add>\n        ').concat(o, '\n      </span>\n      <span class="').concat(a, "tags-btn ").concat(a, 'tags-btn__sync" style="display: none" data-sync-style>\n        ').concat(i, '\n      </span>\n    </div>\n    <div class="').concat(a, 'sels-info">\n      <div class="').concat(a, 'label-sel">').concat(e, ':</div>\n      <div class="').concat(a, 'sels" data-selected></div>\n      <div style="clear:both"></div>\n    </div>');
        },
        events: {
          "change [data-states]": "stateChanged",
          "click [data-add]": "startNewTag",
          "focusout [data-input]": "endNewTag",
          "keyup [data-input]": "onInputKeyUp",
          "click [data-sync-style]": "syncStyle"
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.config = t.config || {}, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.className = this.pfx + "tags", this.stateInputId = this.pfx + "states", this.stateInputC = this.pfx + "input-c", this.states = this.config.states || [];
          var e = this.config.em,
            n = this.getStyleEmitter(),
            r = this.collection;
          this.target = this.config.em, this.em = e;
          var i = "component:toggled component:update:classes",
            o = "component:update:classes change:state";
          this.listenTo(e, i, this.componentChanged), this.listenTo(n, "styleManager:update", this.componentChanged), this.listenTo(e, o, this.__handleStateChange), this.listenTo(e, "styleable:change change:device", this.checkSync), this.listenTo(r, "add", this.addNew), this.listenTo(r, "reset", this.renderClasses), this.listenTo(r, "remove", this.tagRemoved), this.delegateEvents();
        },
        syncStyle: function syncStyle() {
          var t,
            e = this.em,
            n = this.getTarget(),
            r = e.get("CssComposer"),
            i = this.getCommonSelectors({
              opts: {
                noDisabled: 1
              }
            }),
            o = e.get("state"),
            a = e.getCurrentMedia(),
            s = [],
            l = r.get(i, o, a) || r.add(i, o, a);
          this.getTargets().forEach(function (e) {
            var n = r.getIdRule(e.getId(), {
              state: o,
              mediaText: a
            });
            t = n.getStyle(), n.setStyle({}), s.push(n);
          }), t && l.addStyle(t), e.trigger("component:toggled"), e.trigger("component:sync-style", {
            component: n,
            selectors: i,
            mediaText: a,
            rule: l,
            ruleComponents: s,
            state: o
          });
        },
        getStyleEmitter: function getStyleEmitter() {
          var t = this.em,
            e = t && t.get("StyleManager");
          return e && e.getEmitter() || {};
        },
        tagRemoved: function tagRemoved(t) {
          this.updateStateVis();
        },
        getStateOptions: function getStateOptions() {
          var t = this.states,
            e = this.em,
            n = [];
          return t.forEach(function (t) {
            return n.push('<option value="'.concat(t.name, '">').concat(e.t("selectorManager.states.".concat(t.name)) || t.label || t.name, "</option>"));
          }), n.join("");
        },
        addNew: function addNew(t) {
          this.addToClasses(t);
        },
        startNewTag: function startNewTag() {
          this.$addBtn.css({
            display: "none"
          }), this.$input.show().focus();
        },
        endNewTag: function endNewTag() {
          this.$addBtn.css({
            display: ""
          }), this.$input.hide().val("");
        },
        onInputKeyUp: function onInputKeyUp(t) {
          13 === t.keyCode ? this.addNewTag(this.$input.val()) : 27 === t.keyCode && this.endNewTag();
        },
        checkStates: function checkStates() {
          var t = this.em.getState(),
            e = this.getStates();
          e && e.val(t);
        },
        componentChanged: Object(o.debounce)(function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.targets;
          this.updateSelection(e);
        }),
        updateSelection: function updateSelection(t) {
          var e = t || this.getTargets(),
            n = [];
          return (e = Object(o.isArray)(e) ? e : [e]) && e.length && (n = this.getCommonSelectors({
            targets: e
          }), this.checkSync({
            validSelectors: n
          })), this.collection.reset(n), this.updateStateVis(e), n;
        },
        getCommonSelectors: function getCommonSelectors() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.targets,
            n = t.opts,
            r = void 0 === n ? {} : n,
            i = e || this.getTargets(),
            o = i.map(function (t) {
              return t.getSelectors && t.getSelectors().getValid(r);
            }).filter(function (t) {
              return t;
            });
          return this._commonSelectors.apply(this, d()(o));
        },
        _commonSelectors: function _commonSelectors() {
          for (var t = this, e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
          return n.length ? 1 === n.length ? n[0] : 2 === n.length ? n[0].filter(function (t) {
            return n[1].indexOf(t) >= 0;
          }) : n.slice(1).reduce(function (e, n) {
            return t._commonSelectors(e, n);
          }, n[0]) : [];
        },
        checkSync: Object(o.debounce)(function () {
          var t,
            e = this.$btnSyncEl,
            n = this.config,
            r = this.collection,
            i = this.getTarget();
          if (i && n.componentFirst && r.length) {
            var a = i.getStyle();
            t = !Object(o.isEmpty)(a);
          }
          e && e[t ? "show" : "hide"]();
        }),
        getTarget: function getTarget() {
          return this.target.getSelected();
        },
        getTargets: function getTargets() {
          return this.target.getSelectedAll();
        },
        updateStateVis: function updateStateVis(t) {
          var e = this.em,
            n = e && e.getConfig("avoidInlineStyle"),
            r = this.collection.length || n ? "" : "none";
          this.getStatesC().css("display", r), this.updateSelector(t);
        },
        __handleStateChange: function __handleStateChange() {
          this.updateSelector(this.getTargets());
        },
        updateSelector: function updateSelector(t) {
          var e = this,
            n = this.el.querySelector("[data-selected]"),
            r = [],
            i = t || this.getTargets();
          (i = Object(o.isArray)(i) ? i : [i]).forEach(function (t) {
            return r.push(e.__getName(t));
          }), n && (n.innerHTML = r.join(", ")), this.checkStates();
        },
        __getName: function __getName(t) {
          var e,
            n = this.pfx,
            r = this.config,
            i = this.em,
            a = r.selectedName,
            s = r.componentFirst;
          if (Object(o.isString)(t)) e = '<span class="'.concat(n, 'sel-gen">').concat(t, "</span>");else {
            if (!t || !t.get) return;
            var l = t.getSelectors().getStyleable(),
              c = i.get("state"),
              u = t.getId ? '<span class="'.concat(n, 'sel-cmp">').concat(t.getName(), '</span><span class="').concat(n, 'sel-id">#').concat(t.getId(), "</span>") : "";
            e = (e = this.collection.getFullString(l)) ? '<span class="'.concat(n, 'sel-rule">').concat(e, "</span>") : t.get("selectorsAdd") || u, e = s && u ? u : e, e += c ? '<span class="'.concat(n, 'sel-state">:').concat(c, "</span>") : "", e = a ? a({
              result: e,
              state: c,
              target: t
            }) : e;
          }
          return e && '<span class="'.concat(n, 'sel">').concat(e, "</span>");
        },
        stateChanged: function stateChanged(t) {
          var e = this.em,
            n = t.target.value;
          e.set("state", n);
        },
        addNewTag: function addNewTag(t) {
          var e = this,
            n = this.em;
          if (t.trim()) {
            if (n) {
              var r = n.get("SelectorManager").add({
                label: t
              });
              this.getTargets().forEach(function (t) {
                t.getSelectors().add(r), e.collection.add(r), e.updateStateVis();
              });
            }
            this.endNewTag();
          }
        },
        addToClasses: function addToClasses(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
            n = e,
            r = this.getClasses(),
            i = new p({
              model: t,
              config: this.config,
              coll: this.collection
            }).render().el;
          return n ? n.appendChild(i) : r.append(i), i;
        },
        renderClasses: function renderClasses() {
          var t = this,
            e = document.createDocumentFragment(),
            n = this.getClasses();
          n.empty(), this.collection.each(function (n) {
            return t.addToClasses(n, e);
          }), n.append(e);
        },
        getClasses: function getClasses() {
          return this.$el.find("[data-selectors]");
        },
        getStates: function getStates() {
          if (!this.$states) {
            var t = this.$el.find("[data-states]");
            this.$states = t[0] && t;
          }
          return this.$states;
        },
        getStatesC: function getStatesC() {
          return this.$statesC || (this.$statesC = this.$el.find("#" + this.stateInputC)), this.$statesC;
        },
        render: function render() {
          var t = this.em,
            e = this.pfx,
            n = this.ppfx,
            r = this.config,
            i = this.$el,
            o = this.el,
            a = r.render,
            s = {
              iconSync: r.iconSync,
              iconAdd: r.iconAdd,
              labelHead: t.t("selectorManager.label"),
              labelStates: t.t("selectorManager.emptyState"),
              labelInfo: t.t("selectorManager.selected"),
              ppfx: n,
              pfx: e,
              el: o
            };
          i.html(this.template(s));
          var l = a && a(s);
          l && l !== o && i.empty().append(l), this.$input = i.find("[data-input]"), this.$addBtn = i.find("[data-add]"), this.$classes = i.find("#" + e + "tags-c"), this.$btnSyncEl = i.find("[data-sync-style]"), this.$input.hide();
          var c = this.getStates();
          return c && c.append(this.getStateOptions()), this.renderClasses(), i.attr("class", "".concat(this.className, " ").concat(n, "one-bg ").concat(n, "two-color")), this;
        }
      });
    function v(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function m(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? v(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var b = function b(t) {
        return Object(o.isString)(t) && "#" == t[0];
      },
      y = function y(t) {
        return Object(o.isString)(t) && "." == t[0];
      };
    e.default = function (t) {
      var e,
        n = t || {};
      return {
        Selector: l.a,
        Selectors: c.a,
        name: "SelectorManager",
        getConfig: function getConfig() {
          return n;
        },
        init: function init() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = (n = m(m({}, s), t)).em,
            i = n.pStylePrefix;
          return this.em = r, i && (n.stylePrefix = i + n.stylePrefix), this.selectorTags = new g({
            collection: new c.a([], {
              em: r,
              config: n
            }),
            config: n
          }), (e = new c.a(n.selectors)).on("add", function (t) {
            return r.trigger("selector:add", t);
          }), e.on("remove", function (t) {
            return r.trigger("selector:remove", t);
          }), e.on("change", function (t) {
            return r.trigger("selector:update", t, t.previousAttributes(), t.changedAttributes());
          }), r.on("change:state", function (t, e) {
            return r.trigger("selector:state", e);
          }), this;
        },
        postRender: function postRender() {
          var t = this.getConfig().appendTo;
          t && (Object(o.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render([]));
        },
        select: function select(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = Array.isArray(t) ? t : [t],
            r = this.em.get("StyleManager").setTarget(n, e),
            i = r.filter(function (t) {
              return t;
            }).map(function (t) {
              return Object(a.l)(t) || Object(a.o)(t) && !t.get("selectorsAdd") ? t : t.getSelectorsString();
            });
          return this.selectorTags.componentChanged({
            targets: i
          }), this;
        },
        setState: function setState(t) {
          return this.em.setState(t), this;
        },
        getState: function getState() {
          return this.em.setState();
        },
        addSelector: function addSelector(t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = m({}, r);
          Object(o.isObject)(t) ? i = t : i.name = t, b(i.name) ? (i.name = i.name.substr(1), i.type = l.a.TYPE_ID) : y(i.name) && (i.name = i.name.substr(1)), i.label && !i.name && (i.name = this.escapeName(i.label));
          var a = i.name,
            s = a ? this.get(a, i.type) : e.where(i)[0];
          return s || e.add(i, {
            config: n
          });
        },
        getSelector: function getSelector(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.a.TYPE_CLASS;
          return b(t) ? (t = t.substr(1), n = l.a.TYPE_ID) : y(t) && (t = t.substr(1)), e.where({
            name: t,
            type: n
          })[0];
        },
        add: function add(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return Object(o.isArray)(t) ? t.map(function (t) {
            return e.addSelector(t, n);
          }) : this.addSelector(t, n);
        },
        addClass: function addClass(t) {
          var e = this,
            n = [];
          return Object(o.isString)(t) && (t = t.trim().split(" ")), t.forEach(function (t) {
            return n.push(e.addSelector(t));
          }), n;
        },
        get: function get(t, e) {
          var n = this;
          if (Object(o.isArray)(t)) {
            var r = [];
            return t.map(function (t) {
              return n.getSelector(t);
            }).filter(function (t) {
              return t;
            }).forEach(function (t) {
              return r.indexOf(t) < 0 && r.push(t);
            }), r;
          }
          return this.getSelector(t, e);
        },
        getAll: function getAll() {
          return e;
        },
        escapeName: function escapeName(t) {
          var e = n.escapeName;
          return e ? e(t) : l.a.escapeName(t);
        },
        render: function render(t) {
          return t ? (this.selectorTags = new g({
            collection: new c.a(t),
            config: n
          }), this.selectorTags.render().el) : this.selectorTags.render().el;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = {
        stylePrefix: "mdl-",
        title: "",
        content: "",
        backdrop: !0
      },
      a = n(1),
      s = n.n(a),
      l = s.a.Model.extend({
        defaults: {
          title: "",
          content: "",
          open: !1
        }
      }),
      c = s.a.View.extend({
        template: function template(t) {
          var e = t.pfx,
            n = t.ppfx,
            r = t.content,
            i = t.title;
          return '<div class="'.concat(e, "dialog ").concat(n, "one-bg ").concat(n, 'two-color">\n      <div class="').concat(e, 'header">\n        <div class="').concat(e, 'title">').concat(i, '</div>\n        <div class="').concat(e, 'btn-close" data-close-modal>&Cross;</div>\n      </div>\n      <div class="').concat(e, 'content">\n        <div id="').concat(e, 'c">').concat(r, '</div>\n        <div style="clear:both"></div>\n      </div>\n    </div>\n    <div class="').concat(e, 'collector" style="display: none"></div>');
        },
        events: {
          click: "onClick",
          "click [data-close-modal]": "hide"
        },
        initialize: function initialize(t) {
          var e = this.model,
            n = t.config || {},
            r = n.stylePrefix || "";
          this.config = n, this.pfx = r, this.ppfx = n.pStylePrefix || "", this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "change:title", this.updateTitle), this.listenTo(e, "change:content", this.updateContent);
        },
        onClick: function onClick(t) {
          this.config.backdrop && t.target === this.el && this.hide();
        },
        getCollector: function getCollector() {
          return this.$collector || (this.$collector = this.$el.find("." + this.pfx + "collector")), this.$collector;
        },
        getContent: function getContent() {
          var t = this.pfx;
          return this.$content || (this.$content = this.$el.find(".".concat(t, "content #").concat(t, "c"))), this.$content;
        },
        getTitle: function getTitle() {
          return this.$title || (this.$title = this.$el.find("." + this.pfx + "title")), this.$title.get(0);
        },
        updateContent: function updateContent() {
          var t = this.getContent(),
            e = t.children(),
            n = this.getCollector(),
            r = this.model.get("content");
          e.length && n.append(e), t.empty().append(r);
        },
        updateTitle: function updateTitle() {
          var t = this.getTitle();
          t && (t.innerHTML = this.model.get("title"));
        },
        updateOpen: function updateOpen() {
          this.el.style.display = this.model.get("open") ? "" : "none";
        },
        hide: function hide() {
          this.model.set("open", 0);
        },
        show: function show() {
          this.model.set("open", 1);
        },
        render: function render() {
          var t = this.$el,
            e = this.pfx,
            n = (this.ppfx, this.model.toJSON());
          return n.pfx = this.pfx, n.ppfx = this.ppfx, t.html(this.template(n)), t.attr("class", "".concat(e, "container")), this.updateOpen(), this;
        }
      });
    function u(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function d(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? u(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n = {},
        r = function r(t, e) {
          e && e.trigger("modal:".concat(t ? "open" : "close"));
        };
      return {
        name: "Modal",
        getConfig: function getConfig() {
          return n;
        },
        init: function init() {
          var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            a = (n = d(d({}, o), i)).em;
          this.em = a;
          var s = n.pStylePrefix;
          return s && (n.stylePrefix = s + n.stylePrefix), (t = new l(n)).on("change:open", function (t, e) {
            return r(e, a);
          }), e = new c({
            model: t,
            config: n
          }), this;
        },
        postRender: function postRender(t) {
          var e = t.model.getConfig().el || t.el;
          this.render().appendTo(e);
        },
        open: function open() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return t.title && this.setTitle(t.title), t.content && this.setContent(t.content), e.show(), this;
        },
        close: function close() {
          return e.hide(), this;
        },
        onceClose: function onceClose(t) {
          return this.em.once("modal:close", t), this;
        },
        onceOpen: function onceOpen(t) {
          return this.em.once("modal:open", t), this;
        },
        isOpen: function isOpen() {
          return !!t.get("open");
        },
        setTitle: function setTitle(e) {
          return t.set("title", e), this;
        },
        getTitle: function getTitle() {
          return t.get("title");
        },
        setContent: function setContent(e) {
          return t.set("content", " "), t.set("content", e), this;
        },
        getContent: function getContent() {
          return t.get("content");
        },
        getContentEl: function getContentEl() {
          return e.getContent().get(0);
        },
        getModel: function getModel() {
          return t;
        },
        render: function render() {
          return e.render().$el;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = {
        stylePrefix: "pop-",
        title: "",
        content: "",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backdrop: !0
      },
      a = n(1),
      s = n.n(a),
      l = s.a.Model.extend({
        defaults: {
          title: "",
          content: "",
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          open: !1
        }
      }),
      c = s.a.View.extend({
        template: function template(t) {
          var e = t.pfx,
            n = t.ppfx,
            r = t.content,
            i = t.title;
          t.top, t.bottom, t.left, t.right;
          return '<div class="'.concat(e, "dialog ").concat(n, "one-bg ").concat(n, 'two-color">\n      <div class="').concat(e, 'header">\n        <div class="').concat(e, 'title">').concat(i, '</div>\n        <div class="').concat(e, 'btn-close" data-close-popover>&Cross;</div>\n      </div>\n      <div class="').concat(e, 'content">\n        <div id="').concat(e, 'c">').concat(r, '</div>\n        <div style="clear:both"></div>\n      </div>\n    </div>\n    <div class="').concat(e, 'collector" style="display: none"></div>');
        },
        events: {
          click: "onClick",
          "click [data-close-popover]": "hide"
        },
        initialize: function initialize(t) {
          var e = this.model,
            n = t.config || {},
            r = n.stylePrefix || "";
          this.config = n, this.pfx = r, this.ppfx = n.pStylePrefix || "", this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "change:title", this.updateTitle), this.listenTo(e, "change:content", this.updateContent);
        },
        onClick: function onClick(t) {
          this.config.backdrop && t.target === this.el && this.hide();
        },
        getCollector: function getCollector() {
          return this.$collector || (this.$collector = this.$el.find("." + this.pfx + "collector")), this.$collector;
        },
        getContent: function getContent() {
          var t = this.pfx;
          return this.$content || (this.$content = this.$el.find(".".concat(t, "content #").concat(t, "c"))), this.$content;
        },
        getTitle: function getTitle() {
          return this.$title || (this.$title = this.$el.find("." + this.pfx + "title")), this.$title.get(0);
        },
        updateContent: function updateContent() {
          var t = this.getContent(),
            e = t.children(),
            n = this.getCollector(),
            r = this.model.get("content");
          e.length && n.append(e), t.empty().append(r);
        },
        updateTitle: function updateTitle() {
          var t = this.getTitle();
          t && (t.innerHTML = this.model.get("title"));
        },
        updateOpen: function updateOpen() {
          this.el.style.display = this.model.get("open") ? "" : "none", this.el.style.top = this.model.get("top") + "px", this.el.style.bottom = this.model.get("bottom") + "px", this.el.style.right = this.model.get("right") + "px", this.el.style.left = this.model.get("left") + "px";
        },
        hide: function hide() {
          this.model.set("open", 0);
        },
        show: function show() {
          this.model.set("open", 1);
        },
        render: function render() {
          var t = this.$el,
            e = this.pfx,
            n = (this.ppfx, this.model.toJSON());
          return n.pfx = this.pfx, n.ppfx = this.ppfx, t.html(this.template(n)), t.attr("class", "".concat(e, "container")), this.updateOpen(), this;
        }
      });
    function u(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function d(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? u(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n = {},
        r = function r(t, e) {
          e && e.trigger("popover:".concat(t ? "open" : "close"));
        };
      return {
        name: "Popover",
        getConfig: function getConfig() {
          return n;
        },
        init: function init() {
          var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            a = (n = d(d({}, o), i)).em;
          this.em = a;
          var s = n.pStylePrefix;
          return s && (n.stylePrefix = s + n.stylePrefix), (t = new l(n)).on("change:open", function (t, e) {
            return r(e, a);
          }), e = new c({
            model: t,
            config: n
          }), this;
        },
        postRender: function postRender(t) {
          var e = t.model.getConfig().el || t.el;
          this.render().appendTo(e);
        },
        open: function open() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return t.title && this.setTitle(t.title), t.content && this.setContent(t.content), t.top && this.setTop(t.top), t.bottom && this.setBottom(t.bottom), t.left && this.setLeft(t.left), t.right && this.setRight(t.right), e.show(), this;
        },
        close: function close() {
          return e.hide(), this;
        },
        onceClose: function onceClose(t) {
          return this.em.once("popover:close", t), this;
        },
        onceOpen: function onceOpen(t) {
          return this.em.once("popover:open", t), this;
        },
        isOpen: function isOpen() {
          return !!t.get("open");
        },
        setTitle: function setTitle(e) {
          return t.set("title", e), this;
        },
        getTitle: function getTitle() {
          return t.get("title");
        },
        setContent: function setContent(e) {
          return t.set("content", " "), t.set("content", e), this;
        },
        getContent: function getContent() {
          return t.get("content");
        },
        getContentEl: function getContentEl() {
          return e.getContent().get(0);
        },
        setTop: function setTop(e) {
          return t.set("top", e), this;
        },
        getTop: function getTop() {
          return t.get("top");
        },
        setBottom: function setBottom(e) {
          return t.set("bottom", e), this;
        },
        getBottom: function getBottom() {
          return t.get("bottom");
        },
        setLeft: function setLeft(e) {
          return t.set("left", e), this;
        },
        getLeft: function getLeft() {
          return t.get("left");
        },
        setRight: function setRight(e) {
          return t.set("right", e), this;
        },
        getRight: function getRight() {
          return t.get("right");
        },
        getModel: function getModel() {
          return t;
        },
        render: function render() {
          return e.render().$el;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(17),
      i = n(2),
      o = n.n(i),
      a = n(1),
      s = n.n(a),
      l = n(0),
      c = n(3);
    function u(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function d(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? u(Object(n), !0).forEach(function (e) {
          o()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var h = s.a.$,
      f = s.a.View.extend({
        initialize: function initialize(t) {
          this.opt = t || {}, Object(l.bindAll)(this, "startSort", "onMove", "endMove", "rollback", "updateOffset", "moveDragHelper");
          var e = t || {};
          this.elT = 0, this.elL = 0, this.borderOffset = e.borderOffset || 10;
          var n = e.container;
          this.el = "string" == typeof n ? document.querySelector(n) : n, this.$el = h(this.el), this.containerSel = e.containerSel || "div", this.itemSel = e.itemSel || "div", this.draggable = e.draggable || !0, this.nested = e.nested || 0, this.pfx = e.pfx || "", this.ppfx = e.ppfx || "", this.freezeClass = e.freezeClass || this.pfx + "freezed", this.onStart = e.onStart || "", this.onEndMove = e.onEndMove || "", this.direction = e.direction || "v", this.onMoveClb = e.onMove || "", this.relative = e.relative || 0, this.ignoreViewChildren = e.ignoreViewChildren || 0, this.ignoreModels = e.ignoreModels || 0, this.plh = e.placer || "", this.wmargin = e.wmargin || 0, this.offTop = e.offsetTop || 0, this.offLeft = e.offsetLeft || 0, this.document = e.document || document, this.$document = h(this.document), this.dropContent = null, this.em = e.em || "", this.dragHelper = null, this.canvasRelative = e.canvasRelative || 0, this.selectOnEnd = !e.avoidSelectOnEnd, this.scale = e.scale, this.activeTextModel = null, this.em && this.em.on && (this.em.on("change:canvasOffset", this.updateOffset), this.updateOffset());
        },
        getScale: function getScale() {
          return Object(l.result)(this, scale) || 1;
        },
        getContainerEl: function getContainerEl(t) {
          if (t && (this.el = t), !this.el) {
            var e = this.opt.container;
            this.el = "string" == typeof e ? document.querySelector(e) : e, this.$el = h(this.el);
          }
          return this.el;
        },
        getDocuments: function getDocuments(t) {
          var e = this.em,
            n = t ? t.ownerDocument : e && e.get("Canvas").getBody().ownerDocument,
            r = [document];
          return n && r.push(n), r;
        },
        updateOffset: function updateOffset() {
          var t = this.em.get("canvasOffset") || {};
          this.offTop = t.top, this.offLeft = t.left;
        },
        setDropContent: function setDropContent(t) {
          this.dropModel = null, this.dropContent = t;
        },
        updateTextViewCursorPosition: function updateTextViewCursorPosition(t) {
          var e = this.em.get("Canvas"),
            n = e.getDocument(),
            r = null;
          if (n.caretRangeFromPoint) {
            var i = Object(c.h)(t);
            r = n.caretRangeFromPoint(i.clientX, i.clientY);
          } else t.rangeParent && (r = n.createRange()).setStart(t.rangeParent, t.rangeOffset);
          var o = e.getWindow().getSelection();
          e.getFrameEl().focus(), o.removeAllRanges(), r && o.addRange(r);
        },
        setContentEditable: function setContentEditable(t, e) {
          if (t) {
            var n = t.getEl();
            n.contentEditable != e && (n.contentEditable = e);
          }
        },
        toggleSortCursor: function toggleSortCursor(t) {
          var e = this.em,
            n = e && e.get("Canvas");
          n && (t ? n.startAutoscroll() : n.stopAutoscroll());
        },
        setDragHelper: function setDragHelper(t, e) {
          for (var n = e || "", r = t.cloneNode(1), i = t.getBoundingClientRect(), o = getComputedStyle(t), a = "", s = 0; s < o.length; s++) {
            var l = o[s];
            a += "".concat(l, ":").concat(o.getPropertyValue(l), ";");
          }
          document.body.appendChild(r), r.className += " ".concat(this.pfx, "bdrag"), r.setAttribute("style", a), this.dragHelper = r, r.style.width = "".concat(i.width, "px"), r.style.height = "".concat(i.height, "px"), n && this.moveDragHelper(n), this.em && h(this.em.get("Canvas").getBody().ownerDocument).off("mousemove", this.moveDragHelper).on("mousemove", this.moveDragHelper), h(document).off("mousemove", this.moveDragHelper).on("mousemove", this.moveDragHelper);
        },
        moveDragHelper: function moveDragHelper(t) {
          var e = t.target.ownerDocument;
          if (this.dragHelper && e) {
            var n = t.pageY,
              r = t.pageX,
              i = 0,
              o = 0,
              a = (e.defaultView || e.parentWindow).frameElement,
              s = this.dragHelper.style;
            if (a) {
              var l = a.getBoundingClientRect();
              i = l.top + document.documentElement.scrollTop, o = l.left + document.documentElement.scrollLeft, n = t.clientY, r = t.clientX;
            }
            s.top = n + i + "px", s.left = r + o + "px";
          }
        },
        matches: function matches(t, e, n) {
          return c.r.call(t, e);
        },
        closest: function closest(t, e) {
          if (t) {
            for (var n = t.parentNode; n && 1 === n.nodeType;) {
              if (this.matches(n, e)) return n;
              n = n.parentNode;
            }
            return null;
          }
        },
        offset: function offset(t) {
          var e = t.getBoundingClientRect();
          return {
            top: e.top + document.body.scrollTop,
            left: e.left + document.body.scrollLeft
          };
        },
        createPlaceholder: function createPlaceholder() {
          var t = this.pfx,
            e = document.createElement("div"),
            n = document.createElement("div");
          return e.className = t + "placeholder", e.style.display = "none", e.style["pointer-events"] = "none", n.className = t + "placeholder-int", e.appendChild(n), e;
        },
        startSort: function startSort(t) {
          var e,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = this.em,
            i = this.itemSel,
            o = this.containerSel,
            a = this.getContainerEl(n.container),
            s = this.getDocuments(t),
            l = this.onStart,
            u = this.plh;
          this.dropModel = null, this.target = null, this.prevTarget = null, this.moved = 0, t && !this.matches(t, "".concat(i, ", ").concat(o)) && (t = this.closest(t, i)), this.eV = t, u || (u = this.createPlaceholder(), a.appendChild(u), this.plh = u), t && ((e = this.getSourceModel(t)) && e.set && e.set("status", "freezed"), this.srcModel = e), Object(c.u)(a, "mousemove dragover", this.onMove), Object(c.u)(s, "mouseup dragend touchend", this.endMove), Object(c.u)(s, "keydown", this.rollback), l && l({
            target: e,
            parent: e && e.parent(),
            index: e && e.index()
          }), r && r.clearSelection(), this.toggleSortCursor(1), r && r.trigger("sorter:drag:start", t, e);
        },
        getTargetModel: function getTargetModel(t) {
          var e = t || this.target;
          return h(e).data("model");
        },
        getSourceModel: function getSourceModel(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = n.target,
            i = n.avoidChildren,
            o = void 0 === i ? 1 : i,
            a = this.em,
            s = this.eV,
            l = t || s,
            c = this.dropModel,
            u = this.dropContent,
            f = function f(t) {
              return t && r && t.opt && t.opt.avoidChildren && e.isTextableActive(t, r);
            };
          if (u && a) {
            if (f(c) && (c = null), !c) {
              var p = a.get("DomComponents").getComponents(),
                g = {
                  avoidChildren: o,
                  avoidStore: 1,
                  avoidUpdateStyle: 1
                },
                v = p.add(u, d(d({}, g), {}, {
                  temporary: 1
                }));
              if (c = (c = p.remove(v, g)) instanceof Array ? c[0] : c, this.dropModel = c, f(c)) return this.getSourceModel(l, {
                target: r,
                avoidChildren: 0
              });
            }
            return c;
          }
          return l && h(l).data("model");
        },
        selectTargetModel: function selectTargetModel(t, e) {
          if (!(t instanceof s.a.Collection || e && e === t)) {
            var n = this.targetModel;
            n && n !== this.srcModel && n.set("status", ""), t && t.set && (t.set("status", "selected-parent"), this.targetModel = t);
          }
        },
        onMove: function onMove(t) {
          var e = t,
            n = this.em,
            r = this.onMoveClb,
            i = this.plh;
          this.moved = 1;
          var o = i.style.display;
          o && "none" !== o || (i.style.display = "block");
          var a = this.offset(this.el);
          this.elT = this.wmargin ? Math.abs(a.top) : a.top, this.elL = this.wmargin ? Math.abs(a.left) : a.left;
          var s = t.pageY - this.elT + this.el.scrollTop,
            c = t.pageX - this.elL + this.el.scrollLeft;
          if (this.canvasRelative && n) {
            var u = n.get("Canvas").getMouseRelativeCanvas(t, {
              noScroll: 1
            });
            c = u.x, s = u.y;
          }
          this.rX = c, this.rY = s, this.eventMove = t;
          var d = this.getSourceModel(),
            f = this.dimsFromTarget(t.target, c, s),
            p = this.target,
            g = p && this.getTargetModel(p);
          if (this.selectTargetModel(g, d), g || (i.style.display = "none"), p) {
            this.lastDims = f;
            var v = this.findPosition(f, c, s);
            this.isTextableActive(d, g) ? (this.activeTextModel = g, this.setContentEditable(g, !0), i.style.display = "none", this.lastPos = v, this.updateTextViewCursorPosition(e)) : (this.disableTextable(), this.activeTextModel = null, this.lastPos && this.lastPos.index == v.index && this.lastPos.method == v.method || (this.movePlaceholder(this.plh, f, v, this.prevTargetDim), this.$plh || (this.$plh = h(this.plh)), this.canvasRelative || (this.offTop && this.$plh.css("top", "+=" + this.offTop + "px"), this.offLeft && this.$plh.css("left", "+=" + this.offLeft + "px")), this.lastPos = v)), Object(l.isFunction)(r) && r({
              event: t,
              target: d,
              parent: g,
              index: v.index + ("after" == v.method ? 1 : 0)
            }), n && n.trigger("sorter:drag", {
              target: p,
              targetModel: g,
              sourceModel: d,
              dims: f,
              pos: v,
              x: c,
              y: s
            });
          }
        },
        isTextableActive: function isTextableActive(t, e) {
          return t && t.get && t.get("textable") && e && e.is("text");
        },
        disableTextable: function disableTextable() {
          var t = this.activeTextModel;
          t && t.getView().disableEditing();
        },
        isInFlow: function isInFlow(t, e) {
          if (!t) return !1;
          e = e || document.body;
          var n = t;
          return n.offsetHeight, !!this.styleInFlow(n, e);
        },
        styleInFlow: function styleInFlow(t, e) {
          if (!Object(c.q)(t)) {
            var n = t.style || {},
              r = h(t),
              i = e && h(e);
            if (!(n.overflow && "visible" !== n.overflow || "none" !== r.css("float") || i && "flex" == i.css("display") && "column" !== i.css("flex-direction"))) {
              switch (n.position) {
                case "static":
                case "relative":
                case "":
                  break;
                default:
                  return;
              }
              switch (t.tagName) {
                case "TR":
                case "TBODY":
                case "THEAD":
                case "TFOOT":
                  return !0;
              }
              switch (r.css("display")) {
                case "block":
                case "list-item":
                case "table":
                case "flex":
                  return !0;
              }
            }
          }
        },
        validTarget: function validTarget(t, e) {
          var n = this.getTargetModel(t),
            r = this.getSourceModel(e, {
              target: n
            }),
            i = {
              valid: !0,
              src: e = r && r.view && r.view.el,
              srcModel: r,
              trg: t = n && n.view && n.view.el,
              trgModel: n
            };
          if (!e || !t) return i.valid = !1, i;
          var o = r.get("draggable");
          o = o instanceof Array ? o.join(", ") : o, i.dragInfo = o, o = Object(l.isString)(o) ? this.matches(t, o) : o, i.draggable = o;
          var a = n.get("droppable");
          return a = (a = a instanceof s.a.Collection ? 1 : a) instanceof Array ? a.join(", ") : a, i.dropInfo = a, a = Object(l.isString)(a) ? this.matches(e, a) : a, a = o && this.isTextableActive(r, n) ? 1 : a, i.droppable = a, a && o || (i.valid = !1), i;
        },
        dimsFromTarget: function dimsFromTarget(t, e, n) {
          var r = this.em,
            i = [];
          if (!t) return i;
          if (this.matches(t, "".concat(this.itemSel, ", ").concat(this.containerSel)) || (t = this.closest(t, this.itemSel)), this.draggable instanceof Array && (t = this.closest(t, this.draggable.join(","))), !t) return i;
          if (this.prevTarget && this.prevTarget != t && (this.prevTarget = null), !this.prevTarget) {
            this.targetP = this.closest(t, this.containerSel);
            var o = this.validTarget(t);
            if (r && r.trigger("sorter:drag:validation", o), !o.valid && this.targetP) return this.dimsFromTarget(this.targetP, e, n);
            this.prevTarget = t, this.prevTargetDim = this.getDim(t), this.cacheDimsP = this.getChildrenDim(this.targetP), this.cacheDims = this.getChildrenDim(t);
          }
          if (this.prevTarget == t && (i = this.cacheDims), this.target = this.prevTarget, this.nearBorders(this.prevTargetDim, e, n) || !this.nested && !this.cacheDims.length) {
            var a = this.targetP;
            a && this.validTarget(a).valid && (i = this.cacheDimsP, this.target = a);
          }
          return this.lastPos = null, i;
        },
        getTargetFromEl: function getTargetFromEl(t) {
          var e,
            n = t,
            r = this.targetPrev,
            i = this.em,
            o = this.containerSel,
            a = this.itemSel;
          if (this.matches(n, "".concat(a, ", ").concat(o)) || (n = this.closest(n, a)), this.draggable instanceof Array && (n = this.closest(n, this.draggable.join(","))), r && r != n && (this.targetPrev = ""), !this.targetPrev) {
            e = this.closest(n, o);
            var s = this.validTarget(n);
            if (i && i.trigger("sorter:drag:validation", s), !s.valid && e) return this.getTargetFromEl(e);
            this.targetPrev = n;
          }
          return this.nearElBorders(n) && (e = this.closest(n, o)) && this.validTarget(e).valid && (n = e), n;
        },
        nearElBorders: function nearElBorders(t) {
          var e = t.getBoundingClientRect(),
            n = t.ownerDocument.body,
            r = this.getCurrentPos(),
            i = r.x,
            o = r.y,
            a = e.top + n.scrollTop,
            s = e.left + n.scrollLeft,
            l = e.width,
            c = e.height;
          if (o < a + 10 || o > a + c - 10 || i < s + 10 || i > s + l - 10) return 1;
        },
        getCurrentPos: function getCurrentPos() {
          var t = this.eventMove;
          return {
            x: t.pageX || 0,
            y: t.pageY || 0
          };
        },
        getDim: function getDim(t) {
          var e,
            n,
            r,
            i,
            o = this.em;
          if (this.canvasRelative && o) {
            var a = o.get("Canvas"),
              s = a.getElementPos(t, {
                noScroll: 1
              }),
              l = a.getElementOffsets(t);
            e = s.top - l.marginTop, n = s.left - l.marginLeft, r = s.height + l.marginTop + l.marginBottom, i = s.width + l.marginLeft + l.marginRight;
          } else {
            var c = this.offset(t);
            e = this.relative ? t.offsetTop : c.top - (this.wmargin ? -1 : 1) * this.elT, n = this.relative ? t.offsetLeft : c.left - (this.wmargin ? -1 : 1) * this.elL, r = t.offsetHeight, i = t.offsetWidth;
          }
          return [e, n, r, i];
        },
        getChildrenDim: function getChildrenDim(t) {
          var e = this,
            n = [];
          if (!t) return n;
          var r = this.getTargetModel(t);
          if (r && r.view && !this.ignoreViewChildren) {
            var i = r.getCurrentView ? r.getCurrentView() : r.view;
            t = i.getChildrenContainer();
          }
          return Object(l.each)(t.children, function (r, i) {
            var o = Object(c.g)(r, h),
              a = o && o.index ? o.index() : i;
            if (Object(c.q)(r) || e.matches(r, e.itemSel)) {
              var s = e.getDim(r),
                l = e.direction;
              l = "v" == l || "h" != l && e.isInFlow(r, t), s.push(l, r, a), n.push(s);
            }
          }), n;
        },
        nearBorders: function nearBorders(t, e, n) {
          var r = 0,
            i = this.borderOffset,
            o = e || 0,
            a = n || 0,
            s = t[0],
            l = t[1],
            c = t[2],
            u = t[3];
          return (s + i > a || a > s + c - i || l + i > o || o > l + u - i) && (r = 1), !!r;
        },
        findPosition: function findPosition(t, e, n) {
          for (var r = {
              index: 0,
              indexEl: 0,
              method: "before"
            }, i = 0, o = 0, a = 0, s = 0, l = 0, c = 0, u = 0, d = 0, h = 0, f = t.length; h < f; h++) if (a = (d = t[h])[1] + d[3], u = d[0] + d[2], l = d[1] + d[3] / 2, c = d[0] + d[2] / 2, !(o && d[1] > o || s && c >= s || i && a < i)) if (r.index = h, r.indexEl = d[6], d[4]) {
            if (n < c) {
              r.method = "before";
              break;
            }
            r.method = "after";
          } else n < u && (s = u), e < l ? (o = l, r.method = "before") : (i = l, r.method = "after");
          return r;
        },
        movePlaceholder: function movePlaceholder(t, e, n, r) {
          var i = 0,
            o = 0,
            a = 0,
            s = 0,
            l = "px",
            c = n.method,
            u = e[n.index];
          if (t.classList.remove("vertical"), t.classList.add("horizontal"), u) u[4] ? (a = u[3] + l, s = "auto", i = "before" == c ? u[0] - 0 : u[0] + u[2] - 0, o = u[1]) : (a = "auto", s = u[2] - 0 + l, i = u[0] + 0, o = "before" == c ? u[1] - 0 : u[1] + u[3] - 0, t.classList.remove("horizontal"), t.classList.add("vertical"));else {
            if (!this.nested) return void (t.style.display = "none");
            r && (i = r[0] + 5, o = r[1] + 5, a = parseInt(r[3]) - 10 + l, s = "auto");
          }
          t.style.top = i + l, t.style.left = o + l, a && (t.style.width = a), s && (t.style.height = s);
        },
        endMove: function endMove(t) {
          var e,
            n = this,
            r = this.eV,
            i = [],
            o = this.getDocuments(),
            a = this.getContainerEl(),
            s = this.onEndMove,
            u = this.target,
            h = this.lastPos;
          if (Object(c.t)(a, "mousemove dragover", this.onMove), Object(c.t)(o, "mouseup dragend touchend", this.endMove), Object(c.t)(o, "keydown", this.rollback), this.plh.style.display = "none", r && (e = this.getSourceModel(), this.selectOnEnd && e && e.set && (e.set("status", ""), e.set("status", "selected"))), this.moved) {
            var f = this.toMove;
            (Object(l.isArray)(f) ? f : f ? [f] : [r]).forEach(function (t) {
              i.push(n.move(u, t, h));
            });
          }
          this.plh && (this.plh.style.display = "none");
          var p = this.dragHelper;
          if (p && (p.parentNode.removeChild(p), this.dragHelper = null), this.disableTextable(), this.selectTargetModel(), this.toggleSortCursor(), this.toMove = null, this.eventMove = 0, this.dropModel = null, Object(l.isFunction)(s)) {
            var g = {
              target: e,
              parent: e && e.parent(),
              index: e && e.index()
            };
            i.length ? i.forEach(function (t) {
              return s(t, n, g);
            }) : s(null, this, d(d({}, g), {}, {
              cancelled: 1
            }));
          }
        },
        move: function move(t, e, n) {
          var r = this.em,
            i = this.activeTextModel,
            o = this.dropContent,
            a = Object(c.e)(e);
          r && r.trigger("component:dragEnd:before", t, a, n);
          var l,
            u,
            f,
            p = [],
            g = n.indexEl,
            v = this.validTarget(t, a),
            m = h(t).data("collection"),
            b = v.srcModel,
            y = v.droppable,
            w = v.draggable,
            x = v.dropInfo,
            O = v.dragInfo,
            C = v.trgModel;
          y = C instanceof s.a.Collection ? 1 : y;
          var S = this.isTextableActive(b, C);
          if (m && y && w) {
            var k = {
              at: g = "after" === n.method ? g + 1 : g,
              noIncrement: 1
            };
            if (o ? (l = o, k.silent = !1, k.avoidUpdateStyle = 1) : (k.temporary = 1, u = m.add({}, d({}, k)), b.collection && (l = b.collection.remove(b, {
              temporary: 1
            }))), S) {
              var j = i.getView();
              i.trigger("active");
              var T = j.activeRte,
                P = b.getEl();
              delete b.opt.temporary, b.getView().render(), P.setAttribute("data-gjs-textable", "true");
              var E = P.outerHTML;
              T.insertHTML && T.insertHTML(E);
            } else f = m.add(l, k);
            o ? this.dropContent = null : m.remove(u), this.prevTarget = null;
          } else m || p.push("Target collection not found"), y || p.push("Target is not droppable, accepts [".concat(x, "]")), w || p.push("Component not draggable, acceptable by [".concat(O, "]")), console.warn("Invalid target position: " + p.join(", "));
          return r && r.trigger("component:dragEnd", m, l, p), r && r.trigger("sorter:drag:end", {
            targetCollection: m,
            modelToDrop: l,
            warns: p,
            validResult: v,
            dst: t,
            srcEl: a
          }), f;
        },
        rollback: function rollback(t) {
          Object(c.t)(this.getDocuments(), "keydown", this.rollback), 27 == (t.which || t.keyCode) && (this.moved = 0, this.endMove());
        }
      }),
      p = n(15),
      g = n.n(p),
      v = n(16),
      m = n.n(v);
    function b(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function y(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? b(Object(n), !0).forEach(function (e) {
          o()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var w = {
        mousePosFetcher: null,
        updateTarget: null,
        ratioDefault: 0,
        posFetcher: null,
        onStart: null,
        onMove: null,
        onEnd: null,
        onUpdateContainer: function onUpdateContainer() {},
        step: 1,
        minDim: 32,
        maxDim: "",
        unitHeight: "px",
        unitWidth: "px",
        keyHeight: "height",
        keyWidth: "width",
        currentUnit: 1,
        silentFrames: 0,
        avoidContainerUpdate: 0,
        keepAutoHeight: !1,
        keepAutoWidth: !1,
        autoHeight: !1,
        autoWidth: !1,
        tl: 1,
        tc: 1,
        tr: 1,
        cl: 1,
        cr: 1,
        bl: 1,
        bc: 1,
        br: 1
      },
      x = function x(t, e) {
        var n = e || window,
          r = t.getBoundingClientRect();
        return {
          left: r.left + n.pageXOffset,
          top: r.top + n.pageYOffset,
          width: r.width,
          height: r.height
        };
      },
      O = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return g()(this, t), this.setOptions(e), Object(l.bindAll)(this, "handleKeyDown", "handleMouseDown", "move", "stop"), this;
        }
        return m()(t, [{
          key: "getConfig",
          value: function value() {
            return this.opts;
          }
        }, {
          key: "setOptions",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.opts = Object(l.defaults)(t, w), this.setup();
          }
        }, {
          key: "setup",
          value: function value() {
            var t = this.opts,
              e = t.prefix || "",
              n = t.appendTo || document.body,
              r = this.container;
            for (r || ((r = document.createElement("div")).className = "".concat(e, "resizer-c"), n.appendChild(r), this.container = r); r.firstChild;) r.removeChild(r.firstChild);
            var i = {};
            for (var o in ["tl", "tc", "tr", "cl", "cr", "bl", "bc", "br"].forEach(function (e) {
              return i[e] = t[e] ? function (t, e) {
                var n = e.prefix || "",
                  r = document.createElement("i");
                return r.className = n + "resizer-h " + n + "resizer-h-" + t, r.setAttribute("data-" + n + "handler", t), r;
              }(e, t) : "";
            }), i) {
              var a = i[o];
              a && r.appendChild(a);
            }
            this.handlers = i, this.mousePosFetcher = t.mousePosFetcher, this.updateTarget = t.updateTarget, this.posFetcher = t.posFetcher, this.onStart = t.onStart, this.onMove = t.onMove, this.onEnd = t.onEnd, this.onUpdateContainer = t.onUpdateContainer;
          }
        }, {
          key: "toggleFrames",
          value: function value(t) {
            if (this.opts.silentFrames) {
              var e = document.querySelectorAll("iframe");
              Object(l.each)(e, function (e) {
                return e.style.pointerEvents = t ? "none" : "";
              });
            }
          }
        }, {
          key: "isHandler",
          value: function value(t) {
            var e = this.handlers;
            for (var n in e) if (e[n] === t) return !0;
            return !1;
          }
        }, {
          key: "getFocusedEl",
          value: function value() {
            return this.el;
          }
        }, {
          key: "getDocumentEl",
          value: function value() {
            return [this.el.ownerDocument, document];
          }
        }, {
          key: "getElementPos",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.posFetcher || "";
            return n ? n(t, e) : x(t);
          }
        }, {
          key: "focus",
          value: function value(t) {
            t && t === this.el || (this.el = t, this.updateContainer({
              forceShow: 1
            }), Object(c.u)(this.getDocumentEl(), "mousedown", this.handleMouseDown));
          }
        }, {
          key: "blur",
          value: function value() {
            this.container.style.display = "none", this.el && (Object(c.t)(this.getDocumentEl(), "mousedown", this.handleMouseDown), this.el = null);
          }
        }, {
          key: "start",
          value: function value(t) {
            if (0 === t.button) {
              t.preventDefault(), t.stopPropagation();
              var e = this.el,
                n = this.opts || {},
                r = "data-" + n.prefix + "handler",
                i = this.getElementPos(e, {
                  target: "el"
                });
              this.handlerAttr = t.target.getAttribute(r), this.clickedHandler = t.target, this.startDim = {
                t: i.top,
                l: i.left,
                w: i.width,
                h: i.height
              }, this.rectDim = {
                t: i.top,
                l: i.left,
                w: i.width,
                h: i.height
              }, this.startPos = {
                x: t.clientX,
                y: t.clientY
              };
              var o = this.getDocumentEl();
              Object(c.u)(o, "mousemove", this.move), Object(c.u)(o, "keydown", this.handleKeyDown), Object(c.u)(o, "mouseup", this.stop), Object(l.isFunction)(this.onStart) && this.onStart(t, {
                docs: o,
                config: n,
                el: e,
                resizer: this
              }), this.toggleFrames(1), this.move(t);
            }
          }
        }, {
          key: "move",
          value: function value(t) {
            var e = this.onMove,
              n = this.mousePosFetcher,
              r = n ? n(t) : {
                x: t.clientX,
                y: t.clientY
              };
            this.currentPos = r, this.delta = {
              x: r.x - this.startPos.x,
              y: r.y - this.startPos.y
            }, this.keys = {
              shift: t.shiftKey,
              ctrl: t.ctrlKey,
              alt: t.altKey
            }, this.rectDim = this.calc(this), this.updateRect(0), e && e(t), 0 === t.which && this.stop(t);
          }
        }, {
          key: "stop",
          value: function value(t) {
            var e = this.opts,
              n = this.getDocumentEl();
            Object(c.t)(n, "mousemove", this.move), Object(c.t)(n, "keydown", this.handleKeyDown), Object(c.t)(n, "mouseup", this.stop), this.updateRect(1), this.toggleFrames(), Object(l.isFunction)(this.onEnd) && this.onEnd(t, {
              docs: n,
              config: e
            });
          }
        }, {
          key: "updateRect",
          value: function value(t) {
            var e = this.el,
              n = this.opts,
              r = this.rectDim,
              i = this.updateTarget,
              o = this.getSelectedHandler(),
              a = n.unitHeight,
              s = n.unitWidth,
              c = n.keyWidth,
              u = n.keyHeight;
            if (Object(l.isFunction)(i)) i(e, r, {
              store: t,
              selectedHandler: o,
              resizer: this,
              config: n
            });else {
              var d = e.style;
              d[c] = r.w + s, d[u] = r.h + a;
            }
            this.updateContainer();
          }
        }, {
          key: "updateContainer",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.opts,
              n = this.container,
              r = this.el,
              i = n.style;
            !e.avoidContainerUpdate && r && t.forceShow && (i.display = "block"), this.onUpdateContainer({
              el: n,
              resizer: this,
              opts: y(y({}, e), t)
            });
          }
        }, {
          key: "getSelectedHandler",
          value: function value() {
            var t = this.handlers;
            if (this.selectedHandler) for (var e in t) if (t[e] === this.selectedHandler) return e;
          }
        }, {
          key: "handleKeyDown",
          value: function value(t) {
            27 === t.keyCode && (this.rectDim = this.startDim, this.stop(t));
          }
        }, {
          key: "handleMouseDown",
          value: function value(t) {
            var e = t.target;
            this.isHandler(e) ? (this.selectedHandler = e, this.start(t)) : e !== this.el && (this.selectedHandler = "", this.blur());
          }
        }, {
          key: "calc",
          value: function value(t) {
            var e,
              n = this.opts || {},
              r = n.step,
              i = this.startDim,
              o = n.minDim,
              a = n.maxDim,
              s = t.delta.x,
              l = t.delta.y,
              u = i.w,
              d = i.h,
              h = {
                t: 0,
                l: 0,
                w: u,
                h: d
              };
            if (t) {
              var f = t.handlerAttr;
              ~f.indexOf("r") && (e = Object(c.s)(u + s * r, r), e = Math.max(o, e), a && (e = Math.min(a, e)), h.w = e), ~f.indexOf("b") && (e = Object(c.s)(d + l * r, r), e = Math.max(o, e), a && (e = Math.min(a, e)), h.h = e), ~f.indexOf("l") && (e = Object(c.s)(u - s * r, r), e = Math.max(o, e), a && (e = Math.min(a, e)), h.w = e), ~f.indexOf("t") && (e = Object(c.s)(d - l * r, r), e = Math.max(o, e), a && (e = Math.min(a, e)), h.h = e);
              var p = n.ratioDefault ? !t.keys.shift : t.keys.shift;
              if (f.indexOf("c") < 0 && p) {
                var g = i.w / i.h;
                h.w / h.h > g ? h.h = Math.round(h.w / g) : h.w = Math.round(h.h * g);
              }
              return ~f.indexOf("l") && (h.l = i.w - h.w), ~f.indexOf("t") && (h.t = i.h - h.h), h;
            }
          }
        }]), t;
      }(),
      C = {
        init: function init(t) {
          return new O(t);
        }
      };
    e.default = function () {
      return {
        name: "Utils",
        init: function init() {
          return this;
        },
        Sorter: f,
        Resizer: C,
        Dragger: r.a
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(8),
      a = n.n(o),
      s = n(0),
      l = {
        placeholder: "eg. Text here"
      },
      c = {
        locale: "en",
        localeFallback: "en",
        detectLocale: 1,
        debug: 0,
        messages: {
          en: {
            assetManager: {
              addButton: "Add image",
              inputPlh: "http://path/to/the/image.jpg",
              modalTitle: "Select Image",
              uploadTitle: "Drop files here or click to upload"
            },
            blockManager: {
              labels: {},
              categories: {}
            },
            domComponents: {
              names: {
                "": "Box",
                wrapper: "Body",
                text: "Text",
                comment: "Comment",
                image: "Image",
                video: "Video",
                audio: "Audio",
                label: "Label",
                link: "Link",
                map: "Map",
                tfoot: "Table foot",
                tbody: "Table body",
                thead: "Table head",
                table: "Table",
                row: "Table row",
                cell: "Table cell"
              }
            },
            deviceManager: {
              device: "Device",
              devices: {
                desktop: "Desktop",
                tablet: "Tablet",
                mobileLandscape: "Mobile Landscape",
                mobilePortrait: "Mobile Portrait"
              }
            },
            panels: {
              buttons: {
                titles: {
                  preview: "Preview",
                  fullscreen: "Fullscreen",
                  "sw-visibility": "View components",
                  "export-template": "View code",
                  "open-sm": "Open Style Manager",
                  "open-tm": "Settings",
                  "open-layers": "Open Layer Manager",
                  "open-blocks": "Open Blocks"
                }
              }
            },
            selectorManager: {
              label: "Classes",
              selected: "Selected",
              emptyState: "- State -",
              states: {
                hover: "Hover",
                active: "Click",
                "nth-of-type(2n)": "Even/Odd"
              }
            },
            styleManager: {
              empty: "Select an element before using Style Manager",
              layer: "Layer",
              fileButton: "Images",
              sectors: {
                general: "General",
                layout: "Layout",
                typography: "Typography",
                decorations: "Decorations",
                extra: "Extra",
                flex: "Flex",
                dimension: "Dimension"
              },
              properties: {}
            },
            traitManager: {
              empty: "Select an element before using Trait Manager",
              label: "Component settings",
              traits: {
                labels: {},
                attributes: {
                  id: l,
                  alt: l,
                  title: l,
                  href: {
                    placeholder: "eg. https://google.com"
                  }
                },
                options: {
                  target: {
                    false: "This window",
                    _blank: "New window"
                  }
                }
              }
            }
          }
        }
      };
    function u(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function d(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? u(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var h = function h(t) {
      return !Array.isArray(t) && null !== t && "object" === a()(t);
    };
    e.default = function () {
      return {
        name: "I18n",
        config: c,
        init: function init() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.config = d(d(d({}, c), t), {}, {
            messages: d(d({}, c.messages), t.messages || {})
          }), this.config.detectLocale && (this.config.locale = this._localLang()), this.em = t.em, this;
        },
        getConfig: function getConfig() {
          return this.config;
        },
        setLocale: function setLocale(t) {
          var e = this.em,
            n = this.config,
            r = {
              value: t,
              valuePrev: n.locale
            };
          return e && e.trigger("i18n:locale", r), n.locale = t, this;
        },
        getLocale: function getLocale() {
          return this.config.locale;
        },
        getMessages: function getMessages(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.config.messages;
          return t && !n[t] && this._debug("'".concat(t, "' i18n lang not found"), e), t ? n[t] : n;
        },
        setMessages: function setMessages(t) {
          var e = this.em;
          return this.config.messages = t, e && e.trigger("i18n:update", t), this;
        },
        addMessages: function addMessages(t) {
          var e = this.em,
            n = this.config.messages;
          return e && e.trigger("i18n:add", t), this.setMessages(function t() {
            for (var e = d({}, arguments.length <= 0 ? void 0 : arguments[0]), n = 1; n < arguments.length; n++) {
              var r = d({}, n < 0 || arguments.length <= n ? void 0 : arguments[n]);
              for (var i in r) {
                var o = e[i],
                  a = r[i];
                h(o) && h(a) ? e[i] = t(o, a) : e[i] = a;
              }
            }
            return e;
          }(n, t)), this;
        },
        t: function t(_t2) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.config,
            r = e.params || {},
            i = e.l || this.getLocale(),
            o = e.lFlb || n.localeFallback,
            a = this._getMsg(_t2, i, e);
          return a || (a = this._getMsg(_t2, o, e)), !a && this._debug("'".concat(_t2, "' i18n key not found in '").concat(i, "' lang"), e), a = a && Object(s.isString)(a) ? this._addParams(a, r) : a;
        },
        _localLang: function _localLang() {
          var t = window.navigator || {},
            e = t.language || t.userLanguage;
          return e ? e.split("-")[0] : "en";
        },
        _addParams: function _addParams(t, e) {
          var n = new RegExp("{([\\w\\d-]*)}", "g");
          return t.replace(n, function (t, n) {
            return e[n] || "";
          }).trim();
        },
        _getMsg: function _getMsg(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.getMessages(e, n);
          if (r) {
            var i = r[t];
            return !i && t.indexOf(".") > 0 && (i = t.split(".").reduce(function (t, e) {
              if (!Object(s.isUndefined)(t)) return t[e];
            }, r)), i;
          }
        },
        _debug: function _debug(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.em,
            r = this.config;
          (e.debug || r.debug) && n && n.logWarning(t);
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(9),
      i = n.n(r),
      o = n(2),
      a = n.n(o),
      s = n(15),
      l = n.n(s),
      c = n(16),
      u = n.n(c),
      d = n(3);
    function h(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function f(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? h(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    var p = 1,
      g = 0,
      v = -1,
      m = function m(t) {
        var e = t.selection().anchorNode,
          n = e && e.parentNode,
          r = e && e.nextSibling;
        return n && "A" == n.nodeName || r && "A" == r.nodeName;
      },
      b = {
        bold: {
          name: "bold",
          icon: "<b>B</b>",
          attributes: {
            title: "Bold"
          },
          result: function result(t) {
            return t.exec("bold");
          }
        },
        italic: {
          name: "italic",
          icon: "<i>I</i>",
          attributes: {
            title: "Italic"
          },
          result: function result(t) {
            return t.exec("italic");
          }
        },
        underline: {
          name: "underline",
          icon: "<u>U</u>",
          attributes: {
            title: "Underline"
          },
          result: function result(t) {
            return t.exec("underline");
          }
        },
        strikethrough: {
          name: "strikethrough",
          icon: "<s>S</s>",
          attributes: {
            title: "Strike-through"
          },
          result: function result(t) {
            return t.insertHTML("<s>".concat(t.selection(), "</s>"));
          }
        },
        link: {
          icon: '<span style="transform:rotate(45deg)">&supdsub;</span>',
          name: "link",
          attributes: {
            style: "font-size:1.4rem;padding:0 4px 2px;",
            title: "Link"
          },
          state: function state(t, e) {
            return t && t.selection() && m(t) ? p : g;
          },
          result: function result(t) {
            m(t) ? t.exec("unlink") : t.insertHTML('<a class="link" href="">'.concat(t.selection(), "</a>"));
          }
        }
      },
      y = function () {
        function t() {
          var e = this,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          l()(this, t);
          var r = n.el;
          if (r._rte) return r._rte;
          r._rte = this, this.setEl(r), this.updateActiveActions = this.updateActiveActions.bind(this);
          var i = n.actions || [];
          i.forEach(function (t, e) {
            "string" == typeof t ? t = b[t] : b[t.name] && (t = f(f({}, b[t.name]), t)), i[e] = t;
          });
          var o = i.length ? i : Object.keys(b).map(function (t) {
            return b[t];
          });
          n.classes = f(f({}, {
            actionbar: "actionbar",
            button: "action",
            active: "active",
            disabled: "disabled",
            inactive: "inactive"
          }), n.classes);
          var a = n.classes,
            s = n.actionbar;
          if (this.actionbar = s, this.settings = n, this.classes = a, this.actions = o, !s) {
            var c = n.actionbarContainer;
            (s = document.createElement("div")).className = a.actionbar, c.appendChild(s), this.actionbar = s, o.forEach(function (t) {
              return e.addAction(t);
            });
          }
          return n.styleWithCSS && this.exec("styleWithCSS"), this.syncActions(), this;
        }
        return u()(t, [{
          key: "destroy",
          value: function value() {
            this.el = 0, this.doc = 0, this.actionbar = 0, this.settings = {}, this.classes = {}, this.actions = [];
          }
        }, {
          key: "setEl",
          value: function value(t) {
            this.el = t, this.doc = t.ownerDocument;
          }
        }, {
          key: "updateActiveActions",
          value: function value() {
            var t = this;
            this.getActions().forEach(function (e) {
              var n = e.btn,
                r = e.update,
                i = f({}, t.classes),
                o = i.active,
                a = i.inactive,
                s = i.disabled,
                l = e.state,
                c = e.name,
                u = t.doc;
              if (n.className = n.className.replace(o, "").trim(), n.className = n.className.replace(a, "").trim(), n.className = n.className.replace(s, "").trim(), l) switch (l(t, u)) {
                case p:
                  n.className += " ".concat(o);
                  break;
                case g:
                  n.className += " ".concat(a);
                  break;
                case v:
                  n.className += " ".concat(s);
              } else u.queryCommandSupported(c) && u.queryCommandState(c) && (n.className += " ".concat(o));
              r && r(t, e);
            });
          }
        }, {
          key: "enable",
          value: function value() {
            return this.enabled || (this.actionbarEl().style.display = "", this.el.contentEditable = !0, Object(d.u)(this.el, "mouseup keyup", this.updateActiveActions), this.syncActions(), this.updateActiveActions(), this.el.focus(), this.enabled = 1), this;
          }
        }, {
          key: "disable",
          value: function value() {
            return this.actionbarEl().style.display = "none", this.el.contentEditable = !1, Object(d.t)(this.el, "mouseup keyup", this.updateActiveActions), this.enabled = 0, this;
          }
        }, {
          key: "syncActions",
          value: function value() {
            var t = this;
            this.getActions().forEach(function (e) {
              if (t.settings.actionbar && (!e.state || e.state && e.state(t, t.doc) >= 0)) {
                var n = e.event || "click";
                e.btn["on".concat(n)] = function (n) {
                  e.result(t, e), t.updateActiveActions();
                };
              }
            });
          }
        }, {
          key: "addAction",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.sync,
              r = document.createElement("span"),
              i = t.icon,
              o = t.attributes || {};
            for (var a in r.className = this.classes.button, t.btn = r, o) r.setAttribute(a, o[a]);
            "string" == typeof i ? r.innerHTML = i : r.appendChild(i), this.actionbarEl().appendChild(r), n && (this.actions.push(t), this.syncActions());
          }
        }, {
          key: "getActions",
          value: function value() {
            return this.actions;
          }
        }, {
          key: "selection",
          value: function value() {
            return this.doc.getSelection();
          }
        }, {
          key: "exec",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            this.doc.execCommand(t, !1, e);
          }
        }, {
          key: "actionbarEl",
          value: function value() {
            return this.actionbar;
          }
        }, {
          key: "insertHTML",
          value: function value(t) {
            var e = this.doc,
              n = e.getSelection();
            if (n && n.rangeCount) {
              var r = e.createElement("div"),
                i = n.getRangeAt(0);
              i.deleteContents(), r.innerHTML = t, Array.prototype.slice.call(r.childNodes).forEach(function (t) {
                i.insertNode(t), t;
              }), n.removeAllRanges(), n.addRange(i), this.el.focus();
            }
          }
        }]), t;
      }(),
      w = {
        stylePrefix: "rte-",
        adjustToolbar: 1,
        actions: ["bold", "italic", "underline", "strikethrough", "link"]
      };
    function x(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function O(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? x(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n,
        r = {},
        o = function o() {
          var e = t.style;
          e.top = "-1000px", e.left = "-1000px", e.display = "none";
        };
      return {
        customRte: null,
        name: "RichTextEditor",
        getConfig: function getConfig() {
          return r;
        },
        init: function init() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            i = (r = O(O({}, w), e)).pStylePrefix;
          return i && (r.stylePrefix = i + r.stylePrefix), this.pfx = r.stylePrefix, r.actions || [], (t = document.createElement("div")).className = "".concat(i, "rte-toolbar ").concat(i, "one-bg"), n = this.initRte(document.createElement("div")), Object(d.u)(t, "mousedown", function (t) {
            return t.stopPropagation();
          }), this;
        },
        destroy: function destroy() {
          var e = this.customRte;
          n && n.destroy(), e && e.destroy && e.destroy(), t = 0, n = 0, this.actionbar = 0, this.actions = 0;
        },
        postRender: function postRender(e) {
          var n = e.model.get("Canvas");
          t.style.pointerEvents = "all", o(), n.getToolsEl().appendChild(t);
        },
        initRte: function initRte(e) {
          var o = this.pfx,
            a = t,
            s = this.actionbar,
            l = this.actions || i()(r.actions),
            c = {
              actionbar: "".concat(o, "actionbar"),
              button: "".concat(o, "action"),
              active: "".concat(o, "active"),
              inactive: "".concat(o, "inactive"),
              disabled: "".concat(o, "disabled")
            },
            u = new y({
              el: e,
              classes: c,
              actions: l,
              actionbar: s,
              actionbarContainer: a
            });
          return n && n.setEl(e), u.actionbar && (this.actionbar = u.actionbar), u.actions && (this.actions = u.actions), u;
        },
        add: function add(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          e.name = t, n.addAction(e, {
            sync: 1
          });
        },
        get: function get(t) {
          var e;
          return n.getActions().forEach(function (n) {
            n.name == t && (e = n);
          }), e;
        },
        getAll: function getAll() {
          return n.getActions();
        },
        remove: function remove(t) {
          var e = this.getAll(),
            n = this.get(t);
          if (n) {
            var r = n.btn,
              i = e.indexOf(n);
            r.parentNode.removeChild(r), e.splice(i, 1);
          }
          return n;
        },
        getToolbarEl: function getToolbarEl() {
          return t;
        },
        updatePosition: function updatePosition() {
          var n = r.em.get("Canvas"),
            i = t.style,
            o = n.getTargetToElementFixed(e, t, {
              event: "rteToolbarPosUpdate"
            });
          i.top = o.top + "px", i.left = "0px";
        },
        enable: function enable(n, i) {
          e = n.el;
          var o = r.em.get("Canvas"),
            a = r.em,
            s = n.getChildrenContainer(),
            l = this.customRte;
          if (o.getElementPos(e), t.style.display = "", i = l ? l.enable(s, i) : this.initRte(s).enable(), a) {
            setTimeout(this.updatePosition.bind(this), 0);
            var c = "change:canvasOffset canvasScroll frame:scroll component:update";
            a.off(c, this.updatePosition, this), a.on(c, this.updatePosition, this), a.trigger("rte:enable", n, i);
          }
          return i;
        },
        disable: function disable(t, e) {
          var n = r.em,
            i = this.customRte,
            a = t.getChildrenContainer();
          i ? i.disable(a, e) : e && e.disable(), o(), n && n.trigger("rte:disable", t, e);
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(2),
      i = n.n(r),
      o = n(0),
      a = {
        stylePrefix: "css-",
        staticRules: "",
        rules: []
      },
      s = n(34),
      l = n(33),
      c = n(37),
      u = n(12),
      d = n(10);
    function h(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function f(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? h(Object(n), !0).forEach(function (e) {
          i()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e,
        n,
        r = {};
      return {
        Selectors: u.a,
        name: "CssComposer",
        getConfig: function getConfig() {
          return r;
        },
        storageKey: function storageKey() {
          var t = [],
            e = r.stm && r.stm.getConfig() || {};
          return e.storeCss && t.push("css"), e.storeStyles && t.push("styles"), t;
        },
        init: function init(i) {
          for (var o in r = i || {}, a) o in r || (r[o] = a[o]);
          var s = r.pStylePrefix;
          s && (r.stylePrefix = s + r.stylePrefix);
          var u = r.em && r.em.config.style || "";
          return r.rules = u || r.rules, t = r.em, e = new l.a([], r), n = new c.a({
            collection: e,
            config: r
          }), this;
        },
        onLoad: function onLoad() {
          e.add(r.rules);
        },
        postLoad: function postLoad(t) {
          var e = this,
            n = "add remove",
            r = this.getAll(),
            i = t.get("UndoManager");
          i && i.add(r), t.stopListening(r, n, this.handleChange), t.listenTo(r, n, this.handleChange), r.each(function (t) {
            return e.handleChange(t, {
              avoidStore: 1
            });
          });
        },
        handleChange: function handleChange(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = "change:style",
            i = t.get("UndoManager");
          i && i.add(e);
          var o = t.handleUpdates.bind(t);
          t.stopListening(e, r, o), t.listenTo(e, r, o), !n.avoidStore && o("", "", n);
        },
        load: function load(t) {
          var n = t || "";
          !n && r.stm && (n = r.em.getCacheLoad());
          var i = n.styles || "";
          if (n.styles) try {
            i = JSON.parse(n.styles);
          } catch (t) {} else n.css && (i = r.em.get("Parser").parseCss(n.css));
          return Object(o.isArray)(i) ? i.length && e.reset(i) : i && e.reset(i), i;
        },
        store: function store(t) {
          if (r.stm) {
            var n = {},
              i = this.storageKey();
            return i.indexOf("css") >= 0 && (n.css = r.em.getCss()), i.indexOf("styles") >= 0 && (n.styles = JSON.stringify(e)), t || r.stm.store(n), n;
          }
        },
        add: function add(t, n, i) {
          var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            a = n || "",
            l = i || "",
            c = f({}, o),
            u = this.get(t, a, l, c);
          return u && u.config && !u.config.singleAtRule || (c.state = a, c.mediaText = l, c.selectors = [], (u = new s.a(c, r)).get("selectors").add(t), e.add(u)), u;
        },
        get: function get(t, n, r, i) {
          var o = null;
          return e.each(function (e) {
            o || e.compare(t, n, r, i) && (o = e);
          }), o;
        },
        getAll: function getAll() {
          return e;
        },
        clear: function clear() {
          return this.getAll().reset(), this;
        },
        addCollection: function addCollection(t) {
          for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = [], i = t instanceof Array ? t : [t], o = 0, a = i.length; o < a; o++) {
            var s = i[o] || {};
            if (s.selectors) {
              var l = r.em && r.em.get("SelectorManager");
              l || console.warn("Selector Manager not found");
              for (var c = s.selectors, u = c instanceof Array ? c : [c], d = [], h = 0, p = u.length; h < p; h++) {
                var g = l.add(u[h]);
                d.push(g);
              }
              var v = this.get(d, s.state, s.mediaText, s),
                m = this.add(d, s.state, s.mediaText, s),
                b = !v || !e.avoidUpdateStyle,
                y = s.style || {};
              if (b) {
                var w = e.extend ? f(f({}, m.get("style")), y) : y;
                m.set("style", w);
              }
              n.push(m);
            }
          }
          return n;
        },
        setRule: function setRule(e, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = r.atRuleType,
            o = r.atRuleParams,
            a = t.get("Parser").parserCss.checkNode({
              selectors: e,
              style: n
            })[0],
            s = a.state,
            l = a.selectorsAdd,
            c = t.get("SelectorManager"),
            u = c.add(a.selectors),
            d = this.add(u, s, o, {
              selectorsAdd: l,
              atRule: i
            });
          return d.setStyle(n, r), d;
        },
        getRule: function getRule(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = t.get("SelectorManager"),
            i = t.get("Parser").parserCss.checkNode({
              selectors: e
            })[0],
            o = r.get(i.selectors),
            a = i.state,
            s = i.selectorsAdd,
            l = n.atRuleType,
            c = n.atRuleParams;
          return o && this.get(o, a, c, {
            selectorsAdd: s,
            atRule: l
          });
        },
        setIdRule: function setIdRule(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = r.state || "",
            o = r.mediaText || t.getCurrentMedia(),
            a = t.get("SelectorManager"),
            s = a.add({
              name: e,
              type: d.a.TYPE_ID
            }),
            l = this.add(s, i, o);
          return l.setStyle(n, r), l;
        },
        getIdRule: function getIdRule(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = n.state || "",
            i = n.mediaText || t.getCurrentMedia(),
            o = t.get("SelectorManager").get(e, d.a.TYPE_ID);
          return o && this.get(o, r, i);
        },
        setClassRule: function setClassRule(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = r.state || "",
            o = r.mediaText || t.getCurrentMedia(),
            a = t.get("SelectorManager"),
            s = a.add({
              name: e,
              type: d.a.TYPE_CLASS
            }),
            l = this.add(s, i, o);
          return l.setStyle(n, r), l;
        },
        getClassRule: function getClassRule(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = n.state || "",
            i = n.mediaText || t.getCurrentMedia(),
            o = t.get("SelectorManager").get(e, d.a.TYPE_CLASS);
          return o && this.get(o, r, i);
        },
        render: function render() {
          return n.render().el;
        }
      };
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(9),
      i = n.n(r),
      o = n(2),
      a = n.n(o),
      s = n(0),
      l = n(22),
      c = {
        stylePrefix: "com-",
        defaults: [],
        strict: 1
      },
      u = n(5);
    function d(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function h(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? d(Object(n), !0).forEach(function (e) {
          a()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    e.default = function () {
      var t,
        e = {},
        r = {},
        o = {},
        a = {},
        d = [["preview", "Preview", "preview"], ["resize", "Resize", "resize"], ["fullscreen", "Fullscreen", "fullscreen"], ["copy", "CopyComponent"], ["paste", "PasteComponent"], ["canvas-move", "CanvasMove"], ["canvas-clear", "CanvasClear"], ["open-code", "ExportTemplate", "export-template"], ["open-layers", "OpenLayers", "open-layers"], ["open-styles", "OpenStyleManager", "open-sm"], ["open-traits", "OpenTraitManager", "open-tm"], ["open-blocks", "OpenBlocks", "open-blocks"], ["open-assets", "OpenAssets", "open-assets"], ["save-db", "SaveDb", "save-db"], ["cmd-clear", "CanvasClear", "cmd-clear"], ["component-select", "SelectComponent", "select-comp"], ["component-outline", "SwitchVisibility", "sw-visibility"], ["component-offset", "ShowOffset", "show-offset"], ["component-move", "MoveComponent", "move-comp"], ["component-next", "ComponentNext"], ["component-prev", "ComponentPrev"], ["component-enter", "ComponentEnter"], ["component-exit", "ComponentExit", "select-parent"], ["component-delete", "ComponentDelete"], ["component-style-clear", "ComponentStyleClear"], ["component-drag", "ComponentDrag"], ["set-device-desktop", "DeviceDesktop", "set-device-desktop"], ["set-device-tablet", "DeviceTablet", "set-device-tablet"], ["set-device-mobile", "DeviceMobile", "set-device-mobile"], ["set-device-mobile-ptr", "DeviceMobilePtr", "set-device-mobile-ptr"]];
      return {
        CommandAbstract: l.default,
        name: "Commands",
        init: function init() {
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e = h(h({}, c), r), t = e.em;
          var a = e.pStylePrefix;
          for (var l in a && (e.stylePrefix = a + e.stylePrefix), e.defaults) {
            var f = e.defaults[l];
            f.id && this.add(f.id, f);
          }
          return o["tlb-delete"] = {
            run: function run(t) {
              return t.runCommand("core:component-delete");
            }
          }, o["tlb-clone"] = {
            run: function run(t) {
              t.runCommand("core:copy"), t.runCommand("core:paste");
            }
          }, o["tlb-trait-setting"] = {
            run: function run(t, e) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                r = n && n.event,
                i = n.target,
                o = (i || t.getSelected(), r.clientX, r.clientY, t.TraitManager),
                a = o.getTraitsViewer();
              t.Popover.open({
                title: "Settings",
                content: a.render().el
              }).getModel().once("change:open");
            }
          }, o["tlb-move"] = {
            run: function run(t, e) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                r = t.getModel(),
                o = n && n.event,
                a = n.target,
                l = a || t.getSelected(),
                c = a ? [a] : i()(t.getSelectedAll()),
                d = o && "dragstart" == o.type,
                h = {
                  preserveSelected: 1
                },
                f = ["absolute", "translate"],
                p = l.get("dmode") || r.get("dmode"),
                g = function g() {
                  return r.stopDefault(h);
                },
                v = Object(s.includes)(f, p);
              if (c.forEach(function (t) {
                return t.trigger("disable");
              }), !l || !l.get("draggable")) return r.logWarning("The element is not draggable");
              d ? setTimeout(g, 0) : g();
              var m = function m(t) {
                  r.trigger("".concat(u.eventDrag, ":start"), t);
                },
                b = function b(t) {
                  r.trigger(u.eventDrag, t);
                },
                y = function y(e, n, i) {
                  r.runDefault(h), c.forEach(function (t) {
                    return t.set("status", "selected");
                  }), t.select(c), l.emitUpdate(), r.trigger("".concat(u.eventDrag, ":end"), i), (v || i.cancelled) && r.set("_cmpDrag", 1);
                };
              if (v) t.runCommand("core:component-drag", {
                guidesInfo: 1,
                mode: p,
                target: l,
                onStart: m,
                onDrag: b,
                onEnd: y,
                event: o
              });else {
                d && o.dataTransfer.setDragImage(l.view.el, 0, 0);
                var w = t.Commands.get("move-comp");
                w.onStart = m, w.onDrag = b, w.onEndMoveFromModel = y, w.initSorterFromModels(c);
              }
              c.forEach(function (t) {
                return t.set("status", "freezed-selected");
              });
            }
          }, o["core:undo"] = function (t) {
            return t.UndoManager.undo();
          }, o["core:redo"] = function (t) {
            return t.UndoManager.redo();
          }, d.forEach(function (e) {
            var r = e[2],
              i = n(99)("./".concat(e[1])).default,
              a = "core:".concat(e[0]);
            o[a] = i, r && (o[r] = i, ["run", "stop"].forEach(function (e) {
              t.on("".concat(e, ":").concat(r), function () {
                for (var n, r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
                return (n = t).trigger.apply(n, ["".concat(e, ":").concat(a)].concat(i));
              });
            }));
          }), e.em && (e.model = e.em.get("Canvas")), this.loadDefaultCommands(), this;
        },
        add: function add(t, e) {
          return Object(s.isFunction)(e) && (e = {
            run: e
          }), e.stop || (e.noStop = 1), delete e.initialize, e.id = t, r[t] = l.default.extend(e), this;
        },
        get: function get(n) {
          var i = r[n];
          return Object(s.isFunction)(i) ? (i = new i(e), r[n] = i) : i || t.logWarning("'".concat(n, "' command not found")), i;
        },
        extend: function extend(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.get(t);
          if (n) {
            var r = h(h({}, n.constructor.prototype), e);
            this.add(t, r);
            var i = d.filter(function (e) {
              return "core:".concat(e[0]) === t && e[2];
            })[0];
            i && this.add(i[2], r);
          }
          return this;
        },
        has: function has(t) {
          return !!r[t];
        },
        getAll: function getAll() {
          return r;
        },
        run: function run(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return this.runCommand(this.get(t), e);
        },
        stop: function stop(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return this.stopCommand(this.get(t), e);
        },
        isActive: function isActive(t) {
          return this.getActive().hasOwnProperty(t);
        },
        getActive: function getActive() {
          return a;
        },
        loadDefaultCommands: function loadDefaultCommands() {
          for (var t in o) this.add(t, o[t]);
          return this;
        },
        runCommand: function runCommand(n) {
          var r,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (n && n.run) {
            var o = n.id,
              s = t.get("Editor");
            this.isActive(o) && !i.force && e.strict || (r = n.callRun(s, i), o && n.stop && !n.noStop && !i.abort && (a[o] = r));
          }
          return r;
        },
        stopCommand: function stopCommand(n) {
          var r,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (n && n.run) {
            var o = n.id,
              s = t.get("Editor");
            (this.isActive(o) || i.force || !e.strict) && (o && delete a[o], r = n.callStop(s, i));
          }
          return r;
        },
        create: function create(t) {
          return t.stop || (t.noStop = 1), new (l.default.extend(t))(e);
        }
      };
    };
  }]).default;
});